import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.main');
import { OnInit, HostListener, ElementRef, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import * as pdfjsLib from 'pdfjs-dist/build/pdf.mjs';

interface PdfTextIndex {
    fileId: string;
    processingStatus: string;
    integrityStatus: string;
    sha256?: string;
    pageCount: number;
    extractedPageCount: number;
    textPageCount: number;
    searchablePageCount: number;
    normalPageCount: number;
    partialPageCount: number;
    reviewRequiredPageCount: number;
    noTextPageCount: number;
    ocrRequiredPageCount: number;
    emptyPageCount: number;
    chunkCount: number;
    citationCount: number;
    embeddingCount: number;
    classification: string;
    textExtractionStatus: string;
    ocrStatus: string;
    ocrEngineStatus: string;
    qualityStatus: string;
    qualityCode: string;
    qualityPolicyVersion?: string;
    extractorVersion?: string;
    searchIndexStatus: string;
    embeddingStatus: string;
    processedAt?: string;
    error?: string;
}

interface PdfAsset {
    filename: string;
    url: string;
    path?: string;
    size?: number;
    sizeLabel?: string;
    originalFilename?: string;
    resourceId?: string;
    downloadUrl?: string;
    downloadStatus?: string;
    fileId?: string;
    pageCount?: number;
    processingStatus?: string;
    textIndex?: PdfTextIndex;
}

interface TagItem {
    name: string;
    axis: string;
    status: string;
    evidence?: string;
    reviewStatus?: string;
    publicStatus?: string;
    canonicalName?: string;
    matchedAlias?: string;
    sourceField?: string;
}

interface TagAliasItem {
    tagName: string;
    axis: string;
    alias: string;
    usage: string;
    status: string;
}

interface TagReviewSummary {
    recommendedCount: number;
    pendingCount: number;
    approvedCount: number;
    rejectedCount: number;
    publicReadyCount: number;
    internalOnlyCount: number;
    workflow: string[];
    label: string;
}

interface TocItem {
    label: string;
    page?: string;
    source?: string;
    depth: number;
}

interface BodySearchHit {
    id?: string;
    chunkId?: string;
    bookId?: string;
    bookTitle?: string;
    title: string;
    context: string;
    source: string;
    pageLabel: string;
    status: string;
    page?: number;
    paragraph?: number;
    fileId?: string;
    pdfFilename?: string;
    pdfIndex?: number;
    pdfUrl?: string;
    quote?: string;
    qualityScore?: number;
}

interface SearchMatchItem {
    type: string;
    label: string;
    field: string;
    value: string;
    snippet: string;
    score: number;
    priority: number;
    page?: number;
    paragraph?: number;
    pageLabel?: string;
    fileId?: string;
    pdfFilename?: string;
    pdfIndex?: number;
    pdfUrl?: string;
    chunkId?: string;
    collectionId?: string;
    relatedTopic?: string;
    nodeLabel?: string;
    nodeType?: string;
    relationLabel?: string;
    status?: string;
}

interface SearchBookMeta {
    bookId: string;
    hflibId: string;
    title: string;
    score: number;
    priority: number;
    matches: SearchMatchItem[];
    bodyHits: SearchMatchItem[];
    relatedTopics: string[];
}

interface SearchAliasExpansion {
    canonicalTag: string;
    axis: string;
    matchedAlias: string;
    aliases: string[];
    message: string;
    usage: string;
}

interface AiEvidenceItem {
    id: string;
    chunkId: string;
    bookId: string;
    hflibId?: string;
    bookTitle: string;
    title: string;
    pdfFilename: string;
    fileId: string;
    page: number;
    paragraph: number;
    pageLabel: string;
    printedPage?: string;
    printedPageStatus?: string;
    pageMappingStatus?: string;
    evidenceParagraph: string;
    quote: string;
    context: string;
    source: string;
    status: string;
    qualityScore?: number;
    qualityEligibility?: any;
    pdfUrl?: string;
}

interface AppliedAiScope {
    type: string;
    label: string;
    identifier: string;
    materialIds: string[];
    materialCount: number;
    totalFileCount: number;
    searchableFileCount: number;
    coverageLabel: string;
    accessScope: string;
    autoExpanded: boolean;
    contractVersion: string;
    qualityPolicyVersion: string;
    qualitySignature: string;
    requestContextId: string;
}

interface AiCitationSource {
    materialId: string;
    fileId: string;
    chunkId: string;
    bookTitle: string;
    pdfFilename: string;
    page: number;
    printedPage?: string;
    paragraph: number;
    qualityEligibility?: any;
}

interface AiMaterialItem {
    id: string;
    hflibId?: string;
    title: string;
    author: string;
    publisher: string;
    publishedDate: string;
    publishedYear?: number;
    pdfCount: number;
    bodyChunkCount: number;
    citationCandidateCount: number;
    reviewStatus: string;
    publicStatus: string;
    evidenceCount: number;
    reason: string;
}

interface AiAnswerPayload {
    question: string;
    searchScope: string;
    scopeType: string;
    appliedScope: AppliedAiScope;
    citationSources: AiCitationSource[];
    requestContextId: string;
    shortConclusion: string;
    featureName: string;
    resultMode: string;
    generationAvailable: boolean;
    capabilityNotice: string;
    coreEvidence: AiEvidenceItem[];
    relatedMaterials: AiMaterialItem[];
    uncertainties: string[];
    additionalMaterials: AiMaterialItem[];
    additionalMaterialTitles: string[];
    answer: string;
    insufficient: boolean;
    reviewStatus: string;
    publicStatus: string;
    model: string;
}

interface CitationCandidateItem {
    id: string;
    citationId: string;
    chunkId: string;
    bookId: string;
    bookTitle: string;
    pdfFilename: string;
    page: number;
    paragraph: number;
    sentence: string;
    status: string;
}

interface BibliographyItem {
    bookId: string;
    title: string;
    citation: string;
    reviewStatus: string;
    publicStatus: string;
}

interface IssueEvidenceGroup {
    issue: string;
    evidence: AiEvidenceItem[];
}

interface ReportAssistantPayload {
    searchScope: string;
    scopeType: string;
    appliedScope?: AppliedAiScope;
    citationSources?: AiCitationSource[];
    requestContextId?: string;
    warning: string;
    evidenceParagraphs: AiEvidenceItem[];
    materialBundle: AiMaterialItem[];
    citationCandidates: CitationCandidateItem[];
    bibliography: BibliographyItem[];
    outline: string[];
    issueEvidence: IssueEvidenceGroup[];
    graphExport: {
        status: string;
        formats: string[];
        basis: string;
    };
    reviewStatus: string;
    publicStatus: string;
    insufficient: boolean;
}

interface ReaderTocItem {
    label: string;
    page: string;
    source: string;
    depth: number;
    targetPage: number;
}

interface ReaderPagePreview {
    page: number;
    imageUrl: string;
    loading: boolean;
    error: string;
}

interface ReaderSearchHit {
    page: number;
    snippet: string;
    count: number;
    source: string;
}

interface EvidenceItem {
    id: string;
    bookId: string;
    bookTitle: string;
    page: number;
    scope: string;
    quote: string;
    source: string;
    fileId?: string;
    materialId?: string;
    pdfPageNumber?: number;
    textEvidence?: boolean;
    savedAt: string;
}

interface KnowledgeGraphNode {
    id: string;
    nodeId?: string;
    name?: string;
    type: string;
    nodeType?: string;
    label: string;
    displayLabel?: string;
    detail?: string;
    evidenceCount: number;
    connectionCount?: number;
    evidenceStatus?: string;
    reviewStatus: string;
    publicStatus: string;
    materialId?: string;
    relatedMaterialId?: string;
    relatedMaterialCount?: number;
    materialIds?: string[];
    relatedTags?: string[];
    sourceField?: string;
    fileId?: string;
    page?: number;
    chunkId?: string;
    sentence?: string;
    pdfFilename?: string;
    pdfUrl?: string;
    pdfIndex?: number;
    priorityRank?: number;
    priorityBasis?: string;
    importanceScore?: number;
    importanceBasis?: string;
    sourceCount?: number;
    displayMetricLabel?: string;
    displayShape?: GraphNodeShape;
    sizeTier?: GraphNodeSizeTier;
    sizeRule?: string;
}

interface KnowledgeGraphRelation {
    id: string;
    relationId?: string;
    source: string;
    target: string;
    sourceNode?: string;
    targetNode?: string;
    sourceNodeId?: string;
    targetNodeId?: string;
    sourceNodeType?: string;
    targetNodeType?: string;
    sourceNodeLabel?: string;
    targetNodeLabel?: string;
    sourceLabel: string;
    targetLabel: string;
    type: string;
    rawType?: string;
    relationStatus?: string;
    status?: string;
    materialId: string;
    fileId: string;
    page: number;
    paragraph: number;
    chunkId: string;
    sentence: string;
    extractionMethod: string;
    generationMethod?: string;
    confidence: number;
    confidenceLabel: string;
    evidenceCount?: number;
    reviewStatus: string;
    publicStatus: string;
    pdfFilename: string;
    pdfUrl: string;
    pdfIndex: number;
    matchedAlias?: string;
    evidenceNodeId?: string;
    evidenceStatus?: string;
    bodyEvidenceLinked?: boolean;
    bodyEvidenceStatus?: string;
    reviewNote?: string;
    sourceField?: string;
    evidenceField?: string;
    importanceScore?: number;
    importanceBasis?: string;
    relationRule?: {
        sourceType?: string;
        targetType?: string;
        type?: string;
        basis?: string;
    };
    semanticRole?: string;
    relationMeaning?: string;
    pdfPage?: number;
    printedPage?: string;
    printedPageStatus?: string;
    evidenceVerificationStatus?: string;
    extractionReviewClass?: string;
    structuralValidationStatus?: string;
    qualityEligible?: boolean;
    qualityStatus?: string;
}

interface GraphDataSourceItem {
    source: string;
    role: string;
    active: boolean;
    detail?: string;
}

interface GraphQualityCheckItem {
    key: string;
    label: string;
    status: string;
    message: string;
    metric?: any;
}

interface GraphQualityReport {
    status: string;
    label: string;
    checks: GraphQualityCheckItem[];
    failedCount: number;
    warningCount: number;
    passedCount: number;
    defaultDisplayNodeCount: number;
    relatedMaterialDisplayCount: number;
    relatedMaterialActualCount: number;
    nodeTypeCount: number;
    metadataOnly: boolean;
    notices: string[];
    inspectionType?: string;
    historicalAccuracyConfirmed?: boolean;
    humanContentReviewStatus?: string;
    humanReviewedRelationCount?: number;
}

interface RelatedRecommendation {
    materialId: string;
    title: string;
    reason: string;
    score: number;
    strength: string;
    signals?: any;
}

interface KnowledgeGraphData {
    collectionId?: string;
    materialId: string;
    bookTitle: string;
    graphType?: string;
    generatedAt: string;
    extractionBasis: string;
    dataSources?: GraphDataSourceItem[];
    dataSourcePolicy?: GraphDataSourceItem[];
    nodeTypes?: string[];
    relationStates?: string[];
    relationCreationRules?: KnowledgeGraphRelation["relationRule"][];
    generationMethods?: string[];
    storageStatus: string;
    storagePath: string;
    generationRelationLimit?: number;
    generationMaterialLimit?: number;
    countDefinition?: {
        unit?: string;
        include?: string;
        exclude?: string;
        dedupe?: string;
        filter?: string;
        refresh?: string;
        unknownDisplay?: string;
    };
    summary: {
        nodeCount: number;
        relationCount: number;
        evidenceNodeCount: number;
        autoExtractedCount: number;
        reviewedCount: number;
        materialCount?: number;
        displayMaterialCount?: number;
        commonEntityCount?: number;
        bodyRelationCount?: number;
        bodyChunkCount?: number;
        metadataCandidateCount?: number;
        pendingEvidenceCount?: number;
        metadataOnly?: boolean;
        qualityStatus?: string;
        relationLimitReached?: boolean;
        materialLimitReached?: boolean;
    };
    quality?: GraphQualityReport;
    nodes: KnowledgeGraphNode[];
    relations: KnowledgeGraphRelation[];
    evidenceNodes: KnowledgeGraphNode[];
    materials?: CollectionMaterial[];
}

interface GraphLinkSegment {
    id: string;
    relation: KnowledgeGraphRelation;
    sourceNode?: KnowledgeGraphNode | null;
    targetNode?: KnowledgeGraphNode | null;
    x1: number;
    y1: number;
    x2: number;
    y2: number;
    curveOffset?: number;
}

interface GraphLinkRenderPoints {
    x1: number;
    y1: number;
    x2: number;
    y2: number;
    cx: number;
    cy: number;
    curved: boolean;
}

interface GraphMaterialReference {
    id: string;
    title: string;
    publisher: string;
    year: string;
    materialType: string;
    meta: string;
    book: BookItem | null;
}

type GraphSemanticGroup = "source" | "topic" | "place" | "event" | "actor" | "concept" | "support";
type GraphNodeShape = "central-topic" | "material-card" | "small-card" | "circle" | "capsule" | "compact" | "dot";
type GraphNodeSizeTier = "large" | "medium" | "small";
type BookGraphRing = "inner" | "middle" | "outer";
type CollectionGraphRing = "resource" | "tag" | "entity" | "outer";

interface GraphLayoutPoint {
    x: number;
    y: number;
}

interface BookGraphSector {
    start: number;
    end: number;
    center: number;
}

interface CollectionMaterial {
    id: string;
    hflibId: string;
    title: string;
    author: string;
    publisher: string;
    publishedDate: string;
    publishedYear?: number;
    coverImage?: string;
    coverAvailable: boolean;
    pdfCount: number;
    bodySearchAvailable: boolean;
    reviewStatus: string;
    publicStatus: string;
    score: number;
    evidence: string[];
}

interface CollectionSummary {
    id: string;
    title: string;
    description: string;
    reviewStatus: string;
    publicStatus: string;
    materialCount: number;
    pdfCount: number;
    bodyIndexedCount: number;
    topMaterialTitles: string[];
}

interface SearchCollectionCard {
    id: string;
    title: string;
    description: string;
    materialCount: number;
    pdfCount: number;
    bodyIndexedCount: number;
    matchCount: number;
}

interface SearchResultGroup {
    id: string;
    label: string;
    category: string;
    description: string;
    count: number;
    bookIds: string[];
    collectionId?: string;
    query?: string;
}

interface SearchResultTab {
    id: string;
    label: string;
    description: string;
}

interface HighlightSegment {
    text: string;
    active: boolean;
}

interface SearchBodyEvidenceResult {
    id: string;
    book: BookItem;
    match: SearchMatchItem;
}

interface SearchTagResultCard {
    id: string;
    name: string;
    axis: string;
    description: string;
    count: number;
    reasons: string[];
    bookIds: string[];
    representativeBook: BookItem | null;
}

interface SearchGraphResultCard {
    id: string;
    book: BookItem;
    match: SearchMatchItem;
    title: string;
    meta: string;
}

interface ActiveFilterChip {
    key: string;
    label: string;
    value: string;
}

type MaterialViewMode = "image" | "text";
type MaterialTextSortColumn = "title" | "publisher" | "year" | "type" | "original" | "body" | "graph";

interface BibliographicRow {
    label: string;
    value: string;
}

interface VerificationState {
    code: string;
    label: string;
    value: number;
    detail: string;
    status: string;
}

interface VerificationStatus {
    originalLink?: VerificationState;
    fileAccess?: VerificationState;
    pdfPages?: VerificationState;
    textPages?: VerificationState;
    searchablePages?: VerificationState;
    textQuality?: VerificationState;
    bodySearch?: VerificationState;
    questionEvidence?: VerificationState;
    reviewStatus?: VerificationState;
    publicStatus?: VerificationState;
    fileCounts?: any;
}

interface BookItem {
    id: string;
    hflibId: string;
    title: string;
    titleStatement?: string;
    author: string;
    compiler?: string;
    editor?: string;
    publisher: string;
    publishedDate: string;
    publishedYear?: number;
    publicationStatement?: string;
    isbn: string;
    issn?: string;
    kdc?: string;
    callNo?: string;
    classification?: string;
    physicalDescription?: string;
    seriesTitle?: string;
    volume?: string;
    category: string;
    bibliographicType?: string;
    materialType?: string;
    marcSubject?: string;
    subjectName?: string;
    generalNote?: string;
    bibliographyNote?: string;
    coverImage: string;
    coverThumbnailImage: string;
    listCoverImage: string;
    coverAvailable: boolean;
    coverStatus: string;
    coverOriginalUrl?: string;
    coverLoadedPaths: { [src: string]: boolean };
    coverFailedPaths: { [src: string]: number };
    description: string;
    descriptionBasis: string;
    sourceUrl: string;
    requestUrl?: string;
    collectedAt?: string;
    folderName?: string;
    metadataPath?: string;
    height?: string;
    page?: string;
    corporateName?: string;
    personalName?: string;
    pdfs: PdfAsset[];
    pdfCount: number;
    pdfAvailable: boolean;
    accessStatus: string;
    tags: TagItem[];
    tagAliases: TagAliasItem[];
    publicTags: TagItem[];
    tagReviewSummary: TagReviewSummary;
    statusTags: TagItem[];
    graphStatus: string;
    relationshipStatus: string;
    reviewStatus: string;
    ocrStatus: string;
    textIndexStatus: string;
    bodySearchStatus: string;
    bodySearchAvailable: boolean;
    processedPdfCount: number;
    pendingPdfProcessCount: number;
    pdfPageCount: number;
    extractedPageCount: number;
    textPageCount: number;
    searchablePageCount: number;
    ocrRequiredPageCount: number;
    bodyChunkCount: number;
    citationCandidateCount: number;
    embeddingCount: number;
    pdfTextIndexGeneratedAt?: string;
    llmStatus: string;
    graphDbStatus: string;
    graphAvailable: boolean;
    aiAnswerAvailable: boolean;
    publicStatus: string;
    publicEvidenceAllowed?: boolean;
    publicExposure?: {
        approved: boolean;
        reviewStatus: string;
        publicStatus: string;
        reason: string;
    };
    verificationStatus?: VerificationStatus;
    toc: TocItem[];
    tocCount: number;
    tocStatus: string;
    aiSummary: string;
    summaryBasis: string;
    summaryGrounded: boolean;
    summaryCoverage: string;
    metadataBasis: string;
    sourceResourceCount: number;
    crawlIndex: number;
    sourceType?: string;
    detailLoaded?: boolean;
    relatedRecommendations?: RelatedRecommendation[];
    recommendationPolicy?: any;
}

const TAG_AXES = {
    business: "공식 사업 축",
    issue: "역사현안 축",
    era: "시대 축",
    region: "지역·공간 축",
    relation: "관계사·국제질서 축",
    material: "자료 성격 축",
    creator: "발행·저술 주체 축",
    perspective: "출처·관점 축",
    purpose: "업무 목적 축",
    state: "공개·검수 상태 축",
};

const TAG_AXIS_DISPLAY_LABELS: any = {
    "공식 사업 축": "공식 사업",
    "역사현안 축": "역사현안",
    "시대 축": "시대",
    "지역·공간 축": "지역·공간",
    "관계사·국제질서 축": "관계사·국제질서",
    "자료 성격 축": "자료 성격",
    "발행·저술 주체 축": "발행·저술 주체",
    "출처·관점 축": "출처·관점",
    "업무 목적 축": "자료 활용",
    "공개·검수 상태 축": "검수·공개 상태",
    "검수·공개 상태 축": "검수·공개 상태",
};

const STATE_TAG_NAMES = [
    "원본수집완료",
    "PDF확보완료",
    "PDF 확보 완료",
    "외부 원본 링크 확인",
    "원문 확보 필요",
    "표지확보완료",
    "표지 확보 완료",
    "기본 표지 사용",
    "텍스트추출완료",
    "텍스트추출대기",
    "본문 추출 완료",
    "본문 추출 대기",
    "OCR필요",
    "OCR품질주의",
    "태그자동추천",
    "태그검수대기",
    "태그추천대기",
    "태그검수완료",
    "본문청크생성",
    "검색색인생성",
    "임베딩생성",
    "그래프자동생성",
    "그래프검수완료",
    "내부전용",
    "공개가능",
    "공개보류",
    "공개검토",
];

const FEATURED_GRAPH_COLLECTIONS = [
    {
        id: "dokdo",
        label: "독도 자료 관계도 보기",
        eyebrow: "독도·동해",
        description: "독도 영유권, 울릉도, 동해 표기, 국제법 근거 자료가 어떻게 이어지는지 봅니다.",
    },
    {
        id: "japanese-intrusion",
        label: "일제침탈 자료 관계도 보기",
        eyebrow: "한일 역사문제",
        description: "일제침탈, 식민지 정책, 조선총독부, 강제동원 자료의 연결 구조를 봅니다.",
    },
    {
        id: "korea-japan-talks",
        label: "한일회담 자료 관계도 보기",
        eyebrow: "외교문서",
        description: "한일회담, 청구권 교섭, 한일협정 관련 자료와 근거 문단을 연결합니다.",
    },
    {
        id: "goguryeo",
        label: "고구려 자료 관계도 보기",
        eyebrow: "한국 고중세사",
        description: "고구려, 유적·비문, 중국 역사서술 쟁점 자료의 연결을 봅니다.",
    },
    {
        id: "balhae",
        label: "발해 자료 관계도 보기",
        eyebrow: "한국 고중세사",
        description: "발해, 크라스키노, 연해주 고고자료의 연결을 봅니다.",
    },
    {
        id: "comfort-women",
        label: "위안부 자료 관계도 보기",
        eyebrow: "쟁점 대응",
        description: "위안부, 위안소, 전시 성폭력, 전쟁책임 자료의 근거 자료 연결을 봅니다.",
    },
];

const GRAPH_REQUIRED_NODE_TYPES = [
    "자료",
    "주제",
    "인물",
    "기관",
    "장소",
    "사건",
    "시대",
    "개념",
    "문헌·법령",
    "쟁점·반박",
    "관련 자료",
    "근거 후보",
];
const GRAPH_NODE_TYPE_LABELS: any = {
    "자료": "자료",
    "주제": "주제",
    "인물": "인물",
    "기관": "기관",
    "장소": "장소",
    "사건": "사건",
    "시대": "시대",
    "개념": "개념",
    "문헌·법령": "문헌·법령",
    "쟁점·반박": "쟁점·반박",
    "관련 자료": "관련 자료",
    "근거 후보": "근거 문단",
};
const GRAPH_TYPE_OPTIONS = [
    { value: "book", label: "개별 자료 관계도" },
    { value: "collection", label: "주제별 자료 관계도" },
    { value: "related", label: "관련 자료 관계도" },
    { value: "issue", label: "쟁점 대응 자료 관계도" },
];
const GRAPH_NODE_TYPE_FILTERS = [
    "자료",
    "주제",
    "인물",
    "기관",
    "장소",
    "사건",
    "시대",
    "개념",
    "문헌·법령",
    "쟁점·반박",
    "관련 자료",
    "근거",
];
const GRAPH_RELATION_TYPES = [
    "주제로다룬다",
    "관련장소",
    "관련사건",
    "관련시대",
    "저술했다",
    "편찬했다",
    "발행했다",
    "공표했다",
    "본문에서언급한다",
    "인용한다",
    "서지기관후보이다",
    "서지인물후보이다",
    "관련개념",
    "관련자료",
    "별칭이다",
    "발생·관련장소",
    "발생시기",
    "같은컬렉션",
    "근거를제공한다",
];
const GRAPH_DEFAULT_RELATION_LABEL_MIN = 3;
const GRAPH_DEFAULT_RELATION_LABEL_MAX = 5;
const GRAPH_RELATION_TYPE_ALIASES: any = {
    "저자·편찬": "서지인물후보이다",
    "저자·편찬 후보": "서지인물후보이다",
    "저술·발행 주체 후보이다": "서지인물후보이다",
    "발행·편찬기관": "서지기관후보이다",
    "발행기관": "발행했다",
    "기관 후보": "서지기관후보이다",
    "발행기관 후보": "발행했다",
    "발행기관이다": "발행했다",
    "발행연도이다": "관련시대",
    "시대를 다룬다": "관련시대",
    "발생했다": "발생시기",
    "장소를 다룬다": "관련장소",
    "사업축으로 분류된다": "주제로다룬다",
    "주요 현안이다": "주제로다룬다",
    "MARC 주제어이다": "주제로다룬다",
    "컬렉션 태그이다": "주제로다룬다",
    "자료유형이다": "관련개념",
    "관계사 맥락이다": "관련개념",
    "자료 성격이다": "관련개념",
    "출처 관점이다": "관련개념",
    "활용 목적이다": "관련개념",
    "청구기호이다": "관련개념",
    "PDF 파일이다": "관련자료",
    "유사 자료이다": "관련자료",
    "포함한다": "같은컬렉션",
    "언급한다": "본문에서언급한다",
    "관련된다": "관련개념",
    "근거를제공한다": "근거를제공한다",
    "반박한다": "관련자료",
    "인용한다": "인용한다",
    "발생 장소이다": "발생·관련장소",
    "발생시기이다": "발생시기",
};
const GRAPH_RELATION_STATUS_FILTERS = [
    "전체",
    "검수 완료",
    "검수 대기",
    "본문 근거 연결 완료",
    "본문 근거 연결 대기",
    "메타데이터 기반 추천",
];
const GRAPH_BODY_EVIDENCE_COMPLETE_STATUS = "본문 근거 연결 완료";
const GRAPH_BODY_EVIDENCE_PENDING_STATUS = "본문 근거 연결 대기";
const GRAPH_METADATA_RECOMMENDATION_STATUS = "메타데이터 기반 추천";
const GRAPH_METADATA_CANDIDATE_GRAPH_LABEL = "자료 정보로 만든 관계도";
const DOKDO_INNER_RING_LABELS = [
    "울릉도",
    "동해",
    "동해 표기",
    "영유권",
    "영토·영유권",
    "국제법",
    "해양법·국제법",
    "한일관계",
    "한일관계사",
    "1905년 독도 침탈",
    "시마네현 고시 제40호",
    "대한제국",
    "일본 외무성",
    "동북아역사재단",
    "독도·동해 표기 연구",
    "반박 근거 자료",
    "사료집",
    "자료총서",
    "고지도·지도자료",
];
const GRAPH_STATUS_ONLY_NODE_LABELS = new Set([
    "본문근거연결완료",
    "본문근거연결대기",
    "검수완료",
    "검수대기",
    "검수필요",
    "자동추천",
    "자동추출",
    "메타데이터기반추천",
    "내부전용",
    "공개가능",
    "공개보류",
]);
const DESIGN_EXPORT_COLORS = Object.freeze({
    background: "#F4F2EC",
    card: "#FFFFFF",
    text: "#25261F",
    textMuted: "#777462",
    border: "rgba(69, 70, 42, 0.34)",
    accent: "#45462A",
    accentStrong: "#34351F",
    selected: "rgba(96, 108, 56, 0.13)",
    accentWash: "rgba(69, 70, 42, 0.08)",
    sourceNode: "#FFFFFF",
    entityNode: "#FEFAE0",
    pendingStrong: "#5E412F",
    pendingText: "#5E412F",
    pendingBg: "#EFD6AC",
    materialBg: "#FFFFFF",
    materialBorder: "#45462A",
    materialText: "#25261F",
    centralTopicBg: "#45462A",
    centralTopicText: "#FFFFFF",
    topicBg: "#FEFAE0",
    topicBorder: "#606C38",
    topicText: "#45462A",
    placeBg: "rgba(96, 108, 56, 0.1)",
    placeBorder: "#606C38",
    placeText: "#45462A",
    relatedMaterialBg: "rgba(254, 250, 224, 0.76)",
    relatedMaterialBorder: "rgba(69, 70, 42, 0.34)",
    relatedMaterialText: "#25261F",
    actorBg: "rgba(239, 214, 172, 0.52)",
    actorBorder: "#5E412F",
    actorText: "#5E412F",
    eventBg: "rgba(212, 163, 115, 0.22)",
    eventBorder: "#D4A373",
    eventText: "#5E412F",
    conceptBg: "rgba(69, 70, 42, 0.08)",
    conceptBorder: "rgba(69, 70, 42, 0.28)",
    conceptText: "#45462A",
    issueBg: "rgba(142, 38, 48, 0.08)",
    issueBorder: "#8E2630",
    issueText: "#8E2630",
    evidenceBg: "#FFFFFF",
    evidenceBorder: "rgba(69, 70, 42, 0.28)",
    evidenceText: "#5E5E4D",
    relation: "rgba(69, 70, 42, 0.52)",
});
const LIST_PRIORITY_COVER_COUNT = 8;
const SEARCH_PRIORITY_COVER_COUNT = 3;
const HOME_ROUTE = "/";

@Component({
    selector: 'wiz-page-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.main/view.scss */
@charset "UTF-8";
:host {
  --page-bg: var(--design-bg);
  --card-bg: var(--design-card-bg);
  --muted-bg: var(--design-bg-muted);
  --border: var(--design-border);
  --border-soft: var(--design-border-soft);
  --text: var(--design-text);
  --muted: var(--design-text-secondary);
  --faint: var(--design-text-disabled);
  --accent: var(--design-accent);
  --accent-hover: var(--design-accent-strong);
  --accent-soft: var(--design-selected-bg);
  --accent-wash: var(--design-accent-wash);
  --blue-muted: var(--design-border-soft);
  --blue-soft: var(--design-info);
  --pending: var(--design-pending);
  --pending-strong: var(--design-pending-strong);
  --pending-bg: var(--design-pending-bg);
  --pending-text: var(--design-pending-text);
  --issue: var(--design-issue);
  --issue-bg: var(--design-issue-bg);
  --issue-soft: var(--design-issue-soft);
  --on-accent: var(--design-on-accent);
  --card-radius: var(--design-radius-card);
  --button-radius: var(--design-radius-button);
  --surface-shadow: var(--design-shadow);
  --surface-shadow-strong: var(--design-shadow-strong);
  --focus-ring-color: var(--design-focus-ring-color);
  --focus-ring: var(--design-focus-ring);
  --section-gap: var(--design-section-gap);
  --card-gap: var(--design-card-gap);
  --graph-accent: var(--accent);
  --graph-accent-strong: var(--accent-hover);
  --graph-source: var(--design-source);
  --graph-text: var(--text);
  --graph-muted: var(--muted);
  --graph-border: var(--border);
  --graph-line: var(--blue-muted);
  --graph-surface: var(--card-bg);
  --graph-surface-muted: var(--page-bg);
  --graph-pending: var(--pending-strong);
  --graph-pending-bg: var(--pending-bg);
  --graph-pending-text: var(--pending-text);
  display: block;
  min-height: 100vh;
  background: var(--page-bg);
  color: var(--text);
  font-family: "Pretendard", "Noto Sans KR", system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
}

.library-page {
  width: min(1440px, 100%);
  margin: 0 auto;
  padding: 30px 28px 58px;
}

.library-hero {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  padding: 8px 0 18px;
}

.library-brand-link {
  display: block;
  flex: 1 1 520px;
  min-width: 0;
  border-radius: 6px;
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  transition: color 160ms ease, opacity 160ms ease;
}

.library-brand-link:hover .eyebrow,
.library-brand-link:focus-visible .eyebrow {
  color: var(--accent);
  opacity: 0.86;
}

.library-brand-link:focus-visible {
  outline: 3px solid var(--focus-ring-color);
  outline-offset: 4px;
}

.eyebrow {
  margin: 0 0 8px;
  color: var(--accent-hover);
  font-size: 13px;
  font-weight: 800;
}

h1 {
  margin: 0;
  color: var(--text);
  font-size: 40px;
  line-height: 1.14;
  font-weight: 850;
  word-break: keep-all;
  overflow-wrap: break-word;
}

.library-subtitle {
  margin: 10px 0 0;
  color: var(--muted);
  font-size: 15px;
}

.library-count {
  border: 1px solid var(--border);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.82);
  box-shadow: 0 12px 28px rgba(37, 50, 47, 0.08);
}

.library-count {
  min-width: 132px;
  padding: 14px 16px;
  text-align: right;
}

.library-count strong {
  display: block;
  color: var(--text);
  font-size: 28px;
  line-height: 1;
}

.library-count span {
  color: var(--muted);
  font-size: 13px;
}

.auth-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 220px;
}

.auth-profile {
  display: grid;
  gap: 3px;
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.84);
  text-align: right;
}

.auth-profile strong {
  color: var(--text);
  font-size: 13px;
  font-weight: 850;
}

.auth-profile span {
  color: var(--muted);
  font-size: 12px;
  font-weight: 700;
}

.auth-link {
  min-height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  padding: 0 12px;
  background: var(--card-bg);
  color: var(--accent-hover);
  font-size: 13px;
  font-weight: 850;
  text-decoration: none;
}

.auth-link:hover,
.auth-link:focus-visible {
  border-color: var(--focus-ring-color);
  background: var(--accent-soft);
  box-shadow: 0 0 0 3px var(--focus-ring-color);
}

.topic-quickbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 0 14px;
  padding: 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
  box-shadow: 0 12px 26px rgba(37, 50, 47, 0.07);
}

.topic-quickbar > div {
  display: grid;
  min-width: 148px;
  gap: 3px;
  margin-right: 4px;
}

.topic-quickbar strong,
.detail-demo-actions strong {
  color: var(--text);
  font-size: 13px;
  font-weight: 850;
}

.topic-quickbar span,
.detail-demo-actions span {
  color: var(--muted);
  font-size: 12px;
}

.topic-quickbar button,
.detail-demo-actions button,
.reader-term-buttons button {
  min-height: 34px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: var(--page-bg);
  color: var(--accent-hover);
  cursor: pointer;
  font-size: 13px;
  font-weight: 800;
}

.topic-quickbar button {
  padding: 0 10px;
}

.topic-quickbar button:hover,
.topic-quickbar button.is-active,
.detail-demo-actions button:hover,
.reader-term-buttons button:hover,
.reader-term-buttons button.is-active {
  border-color: var(--focus-ring-color);
  background: var(--accent-soft);
  color: var(--accent-hover);
}

.topic-target-button {
  max-width: min(420px, 100%);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.top-tabbar {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(132px, 1fr));
  gap: 8px;
  margin: 0 0 14px;
  padding: 8px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
  box-shadow: 0 12px 26px rgba(37, 50, 47, 0.07);
}

.admin-access-message {
  margin: 0 0 14px;
  padding: 12px 14px;
  border: 1px solid var(--pending);
  border-radius: 8px;
  background: var(--pending-bg);
  color: var(--pending-text);
  font-size: 13px;
  font-weight: 800;
}

.top-tabbar button,
.graph-scope-tabs button {
  min-width: 0;
  min-height: 42px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: var(--page-bg);
  color: var(--accent-hover);
  cursor: pointer;
  font-size: 14px;
  font-weight: 850;
}

.top-tabbar button:hover,
.top-tabbar button:focus-visible,
.top-tabbar button.is-active,
.graph-scope-tabs button:hover,
.graph-scope-tabs button:focus-visible,
.graph-scope-tabs button.is-active {
  border-color: var(--focus-ring-color);
  background: var(--accent-soft);
  color: var(--accent-hover);
  box-shadow: 0 0 0 3px var(--focus-ring-color);
}

.topic-graph-entry-section {
  margin: 0 0 16px;
  padding: 16px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--page-bg);
  box-shadow: 0 16px 34px rgba(37, 50, 47, 0.08);
}

.collection-overview-section,
.graph-hub-section,
.graph-book-tab-section,
.research-ai-section,
.admin-review-section {
  margin-bottom: 16px;
  padding: 16px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 8px 22px rgba(37, 50, 47, 0.05);
}

.collection-meta-grid,
.admin-status-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin-top: 14px;
}

.collection-meta-grid article,
.admin-status-grid article {
  min-width: 0;
  padding: 13px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--page-bg);
}

.collection-meta-grid strong,
.collection-meta-grid span,
.admin-status-grid span,
.admin-status-grid strong,
.admin-status-grid em {
  display: block;
  min-width: 0;
}

.collection-meta-grid strong,
.admin-status-grid span {
  color: var(--accent-hover);
  font-size: 12px;
  font-weight: 850;
}

.collection-meta-grid span,
.admin-status-grid em {
  margin-top: 6px;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.45;
  font-style: normal;
}

.admin-status-grid strong {
  margin-top: 6px;
  color: var(--text);
  font-size: 24px;
  line-height: 1.1;
}

.graph-scope-tabs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 14px;
}

.graph-target-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 160px;
  gap: 10px;
  align-items: end;
  margin-top: 14px;
}

.admin-table {
  display: grid;
  gap: 8px;
  margin-top: 14px;
}

.admin-table-head,
.admin-row {
  display: grid;
  grid-template-columns: minmax(260px, 2.1fr) repeat(5, minmax(120px, 1fr));
  gap: 10px;
  align-items: center;
}

.admin-table-head {
  padding: 0 12px;
  color: var(--muted);
  font-size: 12px;
  font-weight: 850;
}

.admin-row {
  width: 100%;
  min-width: 0;
  padding: 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--text);
  cursor: pointer;
  text-align: left;
}

.admin-row:hover,
.admin-row:focus-visible {
  border-color: var(--focus-ring-color);
  background: var(--accent-wash);
}

.admin-row span {
  min-width: 0;
  overflow-wrap: anywhere;
  font-size: 13px;
  line-height: 1.4;
}

.admin-row strong,
.admin-row em {
  display: block;
  min-width: 0;
}

.admin-row strong {
  color: var(--text);
  font-size: 13px;
  font-weight: 850;
}

.admin-row em {
  margin-top: 4px;
  color: var(--muted);
  font-size: 12px;
  font-style: normal;
}

.topic-graph-entry-section .section-heading h2 {
  margin: 0;
  color: var(--text);
  font-size: 22px;
  line-height: 1.25;
}

.topic-graph-card-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
  margin-top: 14px;
}

.topic-graph-card {
  display: grid;
  min-width: 0;
  min-height: 148px;
  align-content: start;
  gap: 7px;
  padding: 13px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--text);
  cursor: pointer;
  text-align: left;
  box-shadow: 0 12px 26px rgba(37, 50, 47, 0.07);
}

.topic-graph-card:hover,
.topic-graph-card.is-active {
  border-color: var(--focus-ring-color);
  background: var(--accent-wash);
  box-shadow: 0 0 0 3px var(--focus-ring-color);
}

.topic-graph-card span,
.topic-graph-card strong,
.topic-graph-card p,
.topic-graph-card em {
  display: block;
  min-width: 0;
}

.topic-graph-card span {
  color: var(--accent-hover);
  font-size: 11px;
  font-weight: 850;
}

.topic-graph-card strong {
  color: var(--text);
  font-size: 15px;
  line-height: 1.3;
}

.topic-graph-card p {
  margin: 0;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.45;
}

.topic-graph-card em {
  margin-top: auto;
  color: var(--muted);
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
}

.collection-graph-section {
  margin-bottom: 16px;
  padding: 16px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 8px 22px rgba(37, 50, 47, 0.05);
}

.collection-heading {
  align-items: flex-start;
}

.collection-heading h2 {
  margin: 0;
  color: var(--text);
  font-size: 24px;
  line-height: 1.25;
}

.collection-heading p {
  margin: 6px 0 0;
  color: var(--muted);
  font-size: 14px;
  line-height: 1.5;
}

.collection-tabs {
  display: grid;
  grid-template-columns: repeat(8, minmax(0, 1fr));
  gap: 8px;
  margin-top: 14px;
}

.collection-tabs button,
.collection-material-grid button {
  min-width: 0;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--text);
  cursor: pointer;
  text-align: left;
}

.collection-tabs button {
  min-height: 58px;
  padding: 10px 11px;
}

.collection-tabs button.is-active,
.collection-tabs button:hover,
.collection-material-grid button:hover {
  border-color: var(--focus-ring-color);
  background: var(--accent-wash);
  box-shadow: 0 0 0 3px var(--focus-ring-color);
}

.collection-tabs strong,
.collection-tabs span,
.collection-material-grid strong,
.collection-material-grid span,
.collection-material-grid em {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.collection-tabs strong {
  font-size: 13px;
}

.collection-tabs span,
.collection-material-grid span,
.collection-material-grid em {
  margin-top: 4px;
  color: var(--muted);
  font-size: 11px;
  font-style: normal;
}

.control-panel {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
  align-items: end;
  padding: 14px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 16px 34px rgba(37, 50, 47, 0.08);
}

.search-control {
  grid-column: span 2;
}

.control {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 6px;
}

.control span {
  color: var(--muted);
  font-size: 12px;
  font-weight: 800;
}

.control input,
.control select,
.control textarea,
.reset-button,
.source-action-button,
.reader-toolbar button,
.pdf-tabs button {
  width: 100%;
  min-height: 42px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--text);
  font-size: 14px;
  outline: none;
}

.control input,
.control select,
.control textarea {
  padding: 0 12px;
}

.control textarea {
  min-height: 92px;
  padding-top: 10px;
  padding-bottom: 10px;
  line-height: 1.5;
  resize: vertical;
}

.control input:focus,
.control select:focus,
.control textarea:focus,
.author-clear:focus-visible,
.autocomplete-option:focus-visible,
.topic-graph-card:focus-visible,
.result-collection-grid button:focus-visible,
.result-group-grid button:focus-visible,
.inline-text-button:focus-visible,
.detail-primary-tags button:focus-visible,
.graph-entry-buttons button:focus-visible,
.reset-button:focus-visible,
.source-action-button:focus-visible,
.back-button:focus-visible,
.book-card:focus-visible,
.modal-close:focus-visible,
.source-link:focus-visible,
.related-card:focus-visible,
.reader-toolbar button:focus-visible,
.pdf-tabs button:focus-visible {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--focus-ring-color);
}

.autocomplete {
  position: relative;
}

.autocomplete input {
  padding-right: 40px;
}

.author-clear {
  position: absolute;
  top: 50%;
  right: 8px;
  display: grid;
  width: 26px;
  height: 26px;
  transform: translateY(-50%);
  place-items: center;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--muted);
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}

.author-clear:hover {
  background: var(--focus-ring-color);
  color: var(--text);
}

.autocomplete-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  left: 0;
  z-index: 30;
  max-height: 228px;
  overflow: auto;
  padding: 6px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
  box-shadow: 0 18px 36px rgba(37, 50, 47, 0.16);
}

.autocomplete-option {
  width: 100%;
  min-height: 34px;
  overflow: hidden;
  padding: 7px 9px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--text);
  cursor: pointer;
  font-size: 13px;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.autocomplete-option:hover,
.autocomplete-option.is-active {
  background: var(--focus-ring-color);
  color: var(--text);
}

.reset-button,
.source-link,
.source-action-button,
.back-button {
  background: var(--accent-hover);
  color: var(--card-bg);
  font-weight: 800;
  cursor: pointer;
}

.reset-button,
.back-button {
  padding: 0 16px;
}

.reset-button:hover,
.source-link:hover,
.source-action-button:hover,
.back-button:hover {
  background: var(--accent-hover);
}

.status-row {
  min-height: 36px;
  padding: 12px 2px 0;
  color: var(--muted);
  font-size: 13px;
}

.error-text {
  color: var(--issue);
  font-weight: 800;
}

.result-collection-panel {
  margin-top: 14px;
  padding: 16px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--page-bg);
  box-shadow: 0 14px 30px rgba(37, 50, 47, 0.07);
}

.active-filter-panel,
.search-next-panel {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-top: 12px;
  padding: 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #FFFFFF;
}

.search-expansion-notice {
  margin-top: 10px;
  padding: 12px 14px;
  border: 1px solid #CFE2F4;
  border-radius: 8px;
  background: #FAFAFA;
}

.search-expansion-notice > div {
  display: grid;
  gap: 4px;
}

.search-expansion-notice strong {
  color: var(--accent-hover);
  font-size: 13px;
  font-weight: 900;
}

.search-expansion-notice span {
  color: var(--muted);
  font-size: 12px;
  line-height: 1.45;
}

.search-result-tabs {
  display: grid;
  grid-template-columns: minmax(180px, 1.25fr) repeat(6, minmax(112px, 1fr));
  gap: 8px;
  margin-top: 12px;
  padding: 10px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #FFFFFF;
}

.search-result-tabs-heading,
.search-result-tabs button {
  min-width: 0;
  border-radius: 8px;
}

.search-result-tabs-heading {
  display: grid;
  align-content: center;
  gap: 3px;
  padding: 9px 10px;
  background: #FAFAFA;
}

.search-result-tabs-heading strong {
  color: var(--text);
  font-size: 13px;
  font-weight: 900;
}

.search-result-tabs-heading span {
  color: var(--muted);
  font-size: 12px;
  line-height: 1.35;
}

.search-result-tabs button {
  display: grid;
  align-content: center;
  gap: 3px;
  min-height: 70px;
  padding: 9px;
  border: 1px solid var(--border-soft);
  background: var(--page-bg);
  color: var(--text);
  cursor: pointer;
  text-align: left;
}

.search-result-tabs button:hover,
.search-result-tabs button.is-active {
  border-color: var(--focus-ring-color);
  background: var(--accent-wash);
  box-shadow: 0 0 0 3px var(--focus-ring-color);
}

.search-result-tabs button span {
  color: var(--accent-hover);
  font-size: 12px;
  font-weight: 900;
}

.search-result-tabs button strong {
  color: var(--text);
  font-size: 21px;
  line-height: 1;
  font-weight: 900;
}

.search-result-tabs button small {
  display: -webkit-box;
  overflow: hidden;
  color: var(--muted);
  font-size: 11px;
  line-height: 1.3;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.typed-result-list {
  display: grid;
  gap: 12px;
  margin-top: 14px;
}

.body-evidence-list,
.graph-result-list {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.tag-result-list {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.typed-result-card {
  display: grid;
  min-width: 0;
  gap: 10px;
  padding: 14px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 8px 20px rgba(37, 50, 47, 0.05);
}

.typed-result-kicker {
  display: flex;
  min-width: 0;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
}

.typed-result-kicker span {
  color: var(--accent-hover);
  font-size: 12px;
  font-weight: 900;
}

.typed-result-kicker em {
  min-width: 0;
  overflow: hidden;
  color: var(--muted);
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.typed-result-card h3 {
  margin: 0;
  color: var(--text);
  font-size: 17px;
  line-height: 1.35;
  font-weight: 900;
}

.typed-result-card p {
  margin: 0;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.55;
}

.typed-result-meta {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin: 0;
}

.typed-result-meta div,
.search-material-meta div {
  min-width: 0;
  padding: 8px;
  border: 1px solid #E7EDF3;
  border-radius: 7px;
  background: #F9FBFD;
}

.typed-result-meta dt,
.search-material-meta dt {
  margin: 0 0 3px;
  color: var(--muted);
  font-size: 11px;
  font-weight: 850;
}

.typed-result-meta dd,
.search-material-meta dd {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  color: var(--text);
  font-size: 12px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.evidence-snippet {
  padding: 10px 11px;
  border-left: 3px solid #9CC2E5;
  border-radius: 6px;
  background: #FAFAFA;
}

.evidence-snippet mark {
  border-radius: 4px;
  padding: 0 2px;
  background: #E9EEF6;
  color: #263544;
  font-weight: 900;
}

.typed-evidence-list {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 6px;
}

.typed-evidence-list span {
  max-width: 100%;
  overflow: hidden;
  padding: 5px 7px;
  border: 1px solid var(--border);
  border-radius: 999px;
  background: #FAFAFA;
  color: #536270;
  font-size: 11px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.typed-result-actions {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 7px;
}

.typed-result-actions .source-action-button {
  min-height: 34px;
}

.typed-empty-state {
  margin-top: 14px;
}

.active-filter-panel > div,
.search-next-panel > div,
.result-panel-heading > div {
  display: grid;
  min-width: 180px;
  gap: 3px;
  margin-right: auto;
}

.active-filter-panel strong,
.search-next-panel strong,
.result-panel-heading strong {
  color: var(--text);
  font-size: 13px;
  font-weight: 900;
}

.active-filter-panel span,
.search-next-panel span,
.result-panel-heading span {
  color: var(--muted);
  font-size: 12px;
}

.filter-chip,
.search-next-panel button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 34px;
  max-width: 240px;
  padding: 0 10px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: #FAFAFA;
  color: var(--text);
  cursor: pointer;
  font-size: 12px;
  font-weight: 800;
}

.filter-chip {
  gap: 6px;
  justify-content: flex-start;
}

.filter-chip span {
  flex: 0 0 auto;
  color: var(--muted);
  font-size: 11px;
}

.filter-chip strong {
  min-width: 0;
  overflow: hidden;
  color: var(--accent-hover);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.filter-chip i {
  color: var(--muted);
  font-style: normal;
  font-weight: 900;
}

.filter-chip:hover,
.search-next-panel button:hover {
  border-color: var(--focus-ring-color);
  background: var(--accent-wash);
}

.search-next-panel {
  border-color: #BFD5EA;
  background: #FAFAFA;
}

.search-next-panel button {
  background: #FFFFFF;
}

.search-next-panel button:disabled,
.book-result-actions button:disabled {
  cursor: not-allowed;
  opacity: 0.52;
}

.result-panel-heading {
  display: flex;
  min-width: 0;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
}

.compact-heading {
  margin-top: 16px;
}

.inline-text-button {
  min-height: 32px;
  padding: 0 10px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--accent-hover);
  cursor: pointer;
  font-size: 12px;
  font-weight: 850;
}

.inline-text-button:hover {
  background: var(--accent-soft);
  color: var(--accent-hover);
}

.result-collection-grid,
.result-group-grid {
  display: grid;
  gap: 10px;
  margin-top: 12px;
}

.result-collection-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.result-group-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.result-collection-grid button,
.result-group-grid button {
  display: grid;
  min-width: 0;
  align-content: start;
  gap: 6px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--text);
  cursor: pointer;
  text-align: left;
}

.result-collection-grid button {
  min-height: 132px;
  padding: 13px;
}

.result-group-grid button {
  min-height: 116px;
  padding: 11px;
}

.result-collection-grid button:hover,
.result-collection-grid button.is-active,
.result-group-grid button:hover,
.result-group-grid button.is-active {
  border-color: var(--focus-ring-color);
  background: var(--accent-wash);
  box-shadow: 0 0 0 3px var(--focus-ring-color);
}

.result-group-grid button:disabled {
  cursor: default;
  opacity: 0.48;
}

.result-collection-grid button span,
.result-group-grid button span {
  color: var(--accent-hover);
  font-size: 11px;
  font-weight: 850;
}

.result-collection-grid button strong,
.result-group-grid button strong {
  overflow: hidden;
  color: var(--text);
  font-size: 15px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.result-collection-grid button p,
.result-group-grid button small {
  display: -webkit-box;
  overflow: hidden;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.45;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.result-collection-grid button p {
  margin: 0;
}

.result-collection-grid button em,
.result-group-grid button em {
  color: var(--blue-soft);
  font-size: 12px;
  font-style: normal;
  font-weight: 850;
}

.shelf {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(176px, 1fr));
  gap: 22px 20px;
  align-items: stretch;
  margin-top: 12px;
  padding: 16px 0 0;
}

.search-result-shelf {
  grid-template-columns: 1fr;
  gap: 12px;
}

.book-card {
  display: flex;
  min-width: 0;
  height: 100%;
  flex-direction: column;
  gap: 11px;
  padding: 12px;
  border: 1px solid #E2E2E2;
  border-radius: 8px;
  background: #FFFFFF;
  color: inherit;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
  box-shadow: none;
  transition: transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease;
}

.book-card.search-result-card {
  display: grid;
  grid-template-columns: minmax(96px, 132px) minmax(0, 1fr);
  align-items: start;
  gap: 12px 14px;
  padding: 14px;
  cursor: default;
}

.book-card:hover {
  transform: translateY(-1px);
  border-color: #C9D8EA;
  box-shadow: 0 4px 12px rgba(31, 41, 51, 0.06);
}

.book-card-skeleton {
  cursor: default;
  pointer-events: none;
}

.skeleton-cover,
.skeleton-line {
  display: block;
  overflow: hidden;
  position: relative;
  border-radius: 6px;
  background: linear-gradient(90deg, #F1F3F2 0%, #E6ECE9 48%, #F1F3F2 100%);
  background-size: 220% 100%;
  animation: skeleton-pulse 1.1s ease-in-out infinite;
}

.skeleton-cover {
  aspect-ratio: 0.72;
  width: 100%;
}

.skeleton-line {
  height: 13px;
}

.skeleton-line.short {
  width: 62%;
}

.skeleton-title {
  height: 18px;
  width: 88%;
}

@keyframes skeleton-pulse {
  0% {
    background-position: 120% 0;
  }
  100% {
    background-position: -120% 0;
  }
}
.book-card-main {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 11px;
  color: inherit;
  text-decoration: none;
}

.search-result-card .book-card-main {
  display: grid;
  grid-column: 1/-1;
  grid-template-columns: minmax(96px, 132px) minmax(0, 1fr);
  gap: 14px;
}

.search-result-card .cover-frame {
  align-self: start;
}

.search-result-card .book-title {
  min-height: 0;
  font-size: 17px;
  line-height: 1.35;
  -webkit-line-clamp: 3;
}

.cover-frame,
.modal-cover {
  overflow: hidden;
  border-radius: 6px;
  background: var(--muted-bg);
  box-shadow: inset 10px 0 18px rgba(28, 48, 42, 0.16), 0 10px 18px rgba(37, 50, 47, 0.14);
}

.cover-frame {
  display: block;
  width: 100%;
  aspect-ratio: 3/4.15;
  border: 1px solid #E7E7E7;
  box-shadow: none;
}

.cover-frame.is-placeholder,
.modal-cover.is-placeholder {
  background: var(--muted-bg);
  box-shadow: inset 0 0 0 1px var(--border);
}

.cover-frame img,
.modal-cover img,
.related-card img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.book-meta {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
}

.book-category,
.review-state,
.section-heading span,
.tag-chip {
  border-radius: 6px;
  font-size: 11px;
  font-weight: 800;
}

.book-category {
  align-self: flex-start;
  max-width: 100%;
  overflow: hidden;
  padding: 4px 7px;
  background: var(--focus-ring-color);
  color: var(--accent-hover);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.book-title {
  display: -webkit-box;
  min-height: 39px;
  margin-top: 0;
  overflow: hidden;
  color: var(--text);
  font-size: 14px;
  font-weight: 800;
  line-height: 1.38;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.book-author {
  margin-top: 6px;
  overflow: hidden;
  color: #4F5F6F;
  font-size: 12px;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.book-publisher {
  margin-top: 7px;
  overflow: hidden;
  color: #4F5F6F;
  font-size: 12px;
  font-weight: 750;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.book-detail {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 7px;
  overflow: hidden;
  color: var(--muted);
  font-size: 11px;
}

.book-detail span {
  max-width: 100%;
  overflow: hidden;
  padding: 2px 6px;
  border: 1px solid #E6EAF0;
  border-radius: 999px;
  background: #FAFAFA;
  color: var(--muted);
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.search-material-meta {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 7px;
  margin: 10px 0 0;
}

.original-state {
  display: inline-flex;
  max-width: 100%;
  overflow: hidden;
  padding: 2px 6px;
  border-radius: 999px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.original-state.is-available {
  background: #EAF7EE;
  color: #23633A;
}

.original-state.is-limited {
  background: var(--pending-bg);
  color: var(--pending-text);
}

.original-state.is-unavailable {
  background: var(--issue-soft);
  color: var(--issue);
}

.tag-strip,
.source-actions {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 6px;
}

.section-heading span.is-missing {
  background: var(--issue-soft);
  color: var(--issue);
}

.book-card-footer {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 16px;
  margin-top: auto;
  padding-top: 14px;
}

.tag-strip {
  max-height: 56px;
  margin-top: 10px;
  overflow: hidden;
  flex-wrap: wrap;
}

.book-card-footer .tag-strip {
  margin-top: 0;
}

.tag-strip span {
  max-width: 100%;
  flex: 0 1 auto;
  overflow: hidden;
  padding: 4px 7px;
  border: 1px solid #D8E7F6;
  border-radius: 999px;
  background: #FAFAFA;
  color: #35617E;
  font-size: 11px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tag-strip span:nth-child(even) {
  border-color: #E5E7EA;
  background: #F6F7F9;
  color: #536270;
}

.tag-strip span[role=button] {
  cursor: pointer;
}

.tag-strip span[role=button]:hover,
.tag-strip span[role=button].is-active {
  background: var(--accent-soft);
  color: var(--accent-hover);
}

.detail-cta {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  min-height: 27px;
  margin-top: auto;
  padding: 0 9px;
  border-radius: 6px;
  background: var(--accent-hover);
  color: var(--card-bg);
  font-size: 12px;
  font-weight: 850;
}

.book-card-footer .detail-cta {
  margin-top: 0;
}

.search-match-panel {
  display: grid;
  grid-column: 2;
  gap: 7px;
  margin-top: 2px;
  padding: 10px;
  border: 1px solid #DCE8F3;
  border-radius: 8px;
  background: #FAFAFA;
}

.search-match-heading {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 6px;
}

.search-match-heading span {
  flex: 0 0 auto;
  color: var(--muted);
  font-size: 11px;
  font-weight: 850;
}

.search-match-heading strong {
  min-width: 0;
  overflow: hidden;
  color: var(--accent-hover);
  font-size: 12px;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.search-match-badges {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 5px;
}

.search-match-badges span {
  max-width: 100%;
  overflow: hidden;
  padding: 3px 7px;
  border: 1px solid #D4E3F2;
  border-radius: 999px;
  background: #FFFFFF;
  color: #294860;
  font-size: 11px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.search-match-panel p {
  display: -webkit-box;
  margin: 0;
  overflow: hidden;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.45;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.search-match-panel p.search-match-reason {
  color: var(--text);
  font-weight: 850;
  -webkit-line-clamp: 2;
}

.search-match-panel p.search-match-summary {
  color: var(--muted);
  -webkit-line-clamp: 2;
}

.search-match-panel button {
  justify-self: start;
  min-height: 30px;
  padding: 0 9px;
  border: 1px solid #BFD5EA;
  border-radius: 7px;
  background: #FFFFFF;
  color: var(--accent-hover);
  cursor: pointer;
  font-size: 11px;
  font-weight: 850;
}

.search-match-panel button:hover {
  border-color: #92B4D7;
  background: var(--accent-wash);
}

.book-result-actions {
  display: grid;
  grid-column: 2;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
  margin-top: auto;
  padding-top: 10px;
  border-top: 1px solid #EEF2F6;
}

.book-result-actions button {
  min-width: 0;
  min-height: 32px;
  overflow: hidden;
  padding: 0 7px;
  border: 1px solid #D9E4EF;
  border-radius: 7px;
  background: #FAFAFA;
  color: #294860;
  cursor: pointer;
  font-size: 11px;
  font-weight: 850;
  line-height: 1.2;
  white-space: normal;
}

.book-result-actions button:first-child {
  grid-column: span 2;
  background: var(--accent-hover);
  color: #FFFFFF;
}

.book-result-actions button:hover {
  border-color: #AFC8E3;
  background: var(--accent-wash);
  color: var(--accent-hover);
}

.book-result-actions button:first-child:hover {
  background: var(--accent-hover);
  color: #FFFFFF;
}

.empty-state,
.reader-empty {
  border: 1px dashed var(--border);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.65);
  color: var(--muted);
  text-align: center;
}

.empty-state {
  grid-column: 1/-1;
  padding: 54px 20px;
}

.search-empty-state {
  display: grid;
  gap: 14px;
  justify-items: center;
  padding: 34px 20px;
}

.search-empty-state strong {
  color: var(--text);
  font-size: 18px;
}

.search-empty-state p {
  max-width: 680px;
  margin: 0;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.55;
}

.empty-suggestion-block,
.empty-action-row {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: center;
}

.empty-suggestion-block span {
  color: var(--muted);
  font-size: 12px;
  font-weight: 900;
}

.empty-suggestion-block button {
  min-height: 32px;
  padding: 0 10px;
  border: 1px solid #D6E3F1;
  border-radius: 8px;
  background: #FFFFFF;
  color: var(--accent-hover);
  cursor: pointer;
  font-size: 12px;
  font-weight: 850;
}

.empty-suggestion-block button:hover {
  background: var(--accent-wash);
}

.empty-action-row .source-action-button {
  width: auto;
  min-width: 124px;
  padding: 0 14px;
}

.modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(22, 31, 28, 0.58);
}

.book-modal {
  position: relative;
  width: min(1180px, 100%);
  max-height: min(860px, 100vh - 48px);
  overflow: auto;
  padding: 28px 28px 40px;
  border-radius: 8px;
  background: var(--page-bg);
  box-shadow: 0 28px 70px rgba(0, 0, 0, 0.32);
  outline: none;
}

.modal-close {
  position: sticky;
  top: 0;
  z-index: 5;
  float: right;
  display: grid;
  width: 38px;
  height: 38px;
  margin: -8px -8px 4px 12px;
  place-items: center;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--text);
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
}

.modal-layout,
.detail-layout {
  display: grid;
  grid-template-columns: minmax(220px, 300px) 1fr;
  gap: 26px;
  clear: both;
}

.detail-layout {
  grid-template-columns: minmax(238px, 304px) minmax(0, 1fr);
  gap: 32px;
  align-items: start;
}

.modal-cover {
  aspect-ratio: 3/4.15;
}

.detail-page .modal-cover {
  width: 100%;
  max-width: 304px;
}

.modal-content,
.detail-content {
  min-width: 0;
  padding-right: 24px;
}

.modal-title-row,
.section-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.detail-title-row {
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 16px;
}

.section-heading-actions {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
}

.review-state,
.section-heading span {
  padding: 5px 8px;
  background: var(--pending-bg);
  color: var(--pending-text);
  white-space: nowrap;
}

.review-state {
  max-width: min(260px, 45%);
  overflow: hidden;
  text-overflow: ellipsis;
}

.detail-id-badge {
  flex: 0 0 auto;
  margin-left: auto;
  max-width: min(320px, 48%);
  overflow: hidden;
  padding: 7px 10px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--muted-bg);
  color: var(--muted);
  font-size: 14px;
  font-weight: 850;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.detail-title-row .book-category {
  padding: 6px 10px;
  font-size: 14px;
  line-height: 1.25;
}

.section-mini-button {
  min-height: 30px;
  padding: 0 10px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--accent-hover);
  cursor: pointer;
  font-size: 12px;
  font-weight: 850;
}

.section-mini-button:hover,
.section-mini-button:focus-visible {
  border-color: var(--focus-ring-color);
  background: var(--accent-soft);
  color: var(--accent-hover);
}

.modal-content h2,
.detail-content h2 {
  margin: 10px 0 16px;
  color: var(--text);
  font-size: 28px;
  line-height: 1.25;
}

.detail-content h2 {
  margin: 12px 0 14px;
  font-size: 32px;
  line-height: 1.22;
  font-weight: 850;
}

.detail-list,
.status-list {
  display: grid;
  margin: 0;
}

.detail-list {
  grid-template-columns: 1fr;
  gap: 0;
  margin-top: 4px;
  padding-top: 2px;
  border-top: 1px solid var(--border-soft);
}

.detail-list div,
.status-list div {
  min-width: 0;
}

.detail-list div {
  display: grid;
  grid-template-columns: 128px minmax(0, 1fr);
  gap: 18px;
  align-items: start;
  padding: 10px 0;
  border-bottom: 1px solid var(--border-soft);
}

.detail-list dt {
  color: var(--muted);
  font-size: 14px;
  font-weight: 800;
}

.status-list dt {
  color: var(--muted);
  font-size: 12px;
  font-weight: 800;
}

.detail-list dd {
  margin: 0;
  color: var(--text);
  font-size: 15.5px;
  font-weight: 700;
  line-height: 1.55;
  overflow-wrap: anywhere;
}

.status-list dd {
  margin: 4px 0 0;
  color: var(--text);
  font-size: 14px;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.modal-description {
  margin: 18px 0 0;
  color: var(--muted);
  font-size: 16px;
  line-height: 1.65;
}

.detail-primary-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 14px 0 18px;
}

.detail-primary-tags button {
  max-width: 100%;
  overflow: hidden;
  padding: 5px 8px;
  border: 0;
  border-radius: 6px;
  background: var(--muted-bg);
  color: var(--blue-soft);
  cursor: pointer;
  font-size: 12px;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.detail-primary-tags button:hover,
.detail-primary-tags button.has-graph {
  background: var(--accent-soft);
  color: var(--accent-hover);
}

.source-actions {
  margin-top: 18px;
}

.source-link,
.source-action-button,
.source-missing {
  display: inline-flex;
  align-items: center;
  min-height: 38px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 800;
}

.source-link,
.source-action-button {
  padding: 0 14px;
  text-decoration: none;
}

.source-action-button {
  width: auto;
  border: 1px solid var(--border-soft);
}

.source-link.primary-source {
  background: var(--accent-hover);
}

.source-link.secondary {
  border: 1px solid var(--border-soft);
  background: var(--card-bg);
  color: var(--accent-hover);
}

.source-link.secondary:hover {
  background: var(--accent-wash);
}

.graph-entry-action {
  border-color: var(--focus-ring-color);
  background: var(--accent-soft);
  color: var(--accent-hover);
}

.graph-entry-action:hover {
  background: var(--accent-soft);
}

.source-missing {
  color: var(--accent-hover);
}

.detail-page .source-link,
.detail-page .source-action-button,
.detail-page .source-missing {
  font-size: 15px;
}

.graph-entry-panel {
  display: grid;
  grid-template-columns: minmax(220px, 1.2fr) minmax(260px, 1fr);
  gap: 14px;
  align-items: center;
  margin-top: 16px;
  padding: 14px;
  border: 1px solid var(--focus-ring-color);
  border-radius: 8px;
  background: var(--accent-wash);
}

.graph-entry-copy {
  display: grid;
  gap: 5px;
}

.graph-entry-copy strong {
  color: var(--text);
  font-size: 16px;
  font-weight: 850;
}

.graph-entry-copy span {
  color: var(--muted);
  font-size: 12px;
  line-height: 1.45;
}

.graph-entry-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin: 0;
}

.graph-entry-metrics div {
  min-width: 0;
  padding: 9px 10px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.78);
}

.graph-entry-metrics dt {
  color: var(--muted);
  font-size: 11px;
  font-weight: 850;
}

.graph-entry-metrics dd {
  margin: 4px 0 0;
  color: var(--text);
  font-size: 14px;
  font-weight: 850;
}

.graph-entry-buttons {
  grid-column: 1/-1;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.graph-entry-buttons button {
  min-height: 34px;
  padding: 0 11px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--accent-hover);
  cursor: pointer;
  font-size: 12px;
  font-weight: 850;
}

.graph-entry-buttons button:hover {
  background: var(--accent-soft);
  color: var(--accent-hover);
}

.detail-demo-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
  padding: 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--pending-bg);
}

.detail-demo-actions > div {
  display: grid;
  min-width: min(320px, 100%);
  gap: 3px;
  margin-right: auto;
}

.detail-demo-actions button {
  padding: 0 11px;
}

.detail-demo-actions .primary-demo-action {
  border-color: var(--border-soft);
  background: var(--accent-hover);
  color: var(--card-bg);
}

.detail-demo-actions .primary-demo-action:hover {
  background: var(--accent-hover);
}

.reader-section,
.knowledge-section,
.toc-summary-grid,
.related-section,
.detail-section {
  margin-top: 28px;
  padding-top: 22px;
  border-top: 1px solid var(--border);
}

.toc-summary-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 22px;
}

.section-heading h3 {
  margin: 0;
  color: var(--text);
  font-size: 18px;
}

.toc-list {
  display: grid;
  gap: 8px;
  margin: 14px 0 0;
  padding: 0;
  list-style: none;
}

.toc-list li {
  display: flex;
  min-width: 0;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 10px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
}

.toc-list span {
  min-width: 0;
  overflow: hidden;
  color: var(--text);
  font-size: 13px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.toc-list small {
  flex: 0 0 auto;
  color: var(--muted);
  font-size: 12px;
}

.ai-summary {
  margin: 14px 0 0;
  color: var(--muted);
  font-size: 14px;
  line-height: 1.65;
}

.pdf-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
}

.pdf-tabs button {
  width: auto;
  min-width: 62px;
  padding: 0 12px;
  cursor: pointer;
}

.pdf-tabs button.is-active {
  border-color: var(--accent);
  background: var(--accent-wash);
  color: var(--accent-hover);
  font-weight: 800;
}

.ebook-reader-grid {
  display: grid;
  grid-template-columns: 238px minmax(560px, 1fr) 340px;
  gap: 16px;
  align-items: start;
  margin-top: 16px;
}

.reader-nav-panel,
.reader-text-panel {
  position: sticky;
  top: 16px;
  max-height: calc(100vh - 32px);
  overflow: auto;
  padding: 14px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
  box-shadow: 0 12px 24px rgba(37, 50, 47, 0.08);
}

.reader-panel-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.reader-panel-heading strong {
  min-width: 0;
  overflow: hidden;
  color: var(--text);
  font-size: 14px;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.reader-panel-heading span {
  flex: 0 0 auto;
  color: var(--muted);
  font-size: 12px;
  font-weight: 800;
}

.reader-toc-list {
  display: grid;
  gap: 6px;
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
}

.reader-toc-list button {
  display: grid;
  width: 100%;
  min-height: 38px;
  min-width: 0;
  padding: 7px 8px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  color: var(--text);
  cursor: pointer;
  text-align: left;
}

.reader-toc-list button:hover,
.reader-toc-list button.is-active {
  border-color: var(--focus-ring-color);
  background: var(--accent-wash);
}

.reader-toc-list span,
.reader-toc-list small {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.reader-toc-list span {
  font-size: 13px;
  font-weight: 800;
}

.reader-toc-list small {
  margin-top: 3px;
  color: var(--muted);
  font-size: 11px;
}

.evidence-box {
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid var(--border);
}

.evidence-save {
  justify-content: center;
  width: 100%;
  margin-top: 10px;
  gap: 7px;
}

.evidence-list {
  display: grid;
  gap: 8px;
  margin-top: 10px;
}

.evidence-list article {
  position: relative;
  min-width: 0;
  padding: 10px 34px 10px 10px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--page-bg);
}

.evidence-list strong,
.evidence-list span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.evidence-list strong {
  color: var(--text);
  font-size: 12px;
}

.evidence-list p {
  display: -webkit-box;
  margin: 6px 0 0;
  overflow: hidden;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.45;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.evidence-list span {
  margin-top: 6px;
  color: var(--muted);
  font-size: 11px;
}

.evidence-list article > button {
  position: absolute;
  top: 8px;
  right: 8px;
  display: grid;
  width: 24px;
  height: 24px;
  place-items: center;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--muted);
  cursor: pointer;
}

.evidence-list article > button:hover {
  background: var(--issue-soft);
  color: var(--issue);
}

.reader-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
  box-shadow: 0 10px 22px rgba(37, 50, 47, 0.08);
}

.reader-toolbar button {
  width: auto;
  min-width: 42px;
  padding: 0 12px;
  gap: 7px;
  cursor: pointer;
}

.reader-toolbar button:disabled {
  cursor: default;
  opacity: 0.48;
}

.reader-toolbar span {
  color: var(--muted);
  font-size: 13px;
  font-weight: 800;
}

.toolbar-divider {
  width: 1px;
  height: 26px;
  background: var(--border);
}

.zoom-label {
  min-width: 44px;
  text-align: center;
}

.page-jump {
  display: inline-flex;
  align-items: center;
  min-height: 42px;
  gap: 6px;
  padding: 0 10px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
}

.page-jump span,
.page-jump small {
  color: var(--muted);
  font-size: 12px;
  font-weight: 800;
}

.page-jump input {
  width: 64px;
  height: 30px;
  border: 0;
  border-bottom: 1px solid var(--border);
  color: var(--text);
  font-size: 15px;
  font-weight: 850;
  text-align: center;
  outline: none;
}

.reader-file-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 10px;
  color: var(--muted);
  font-size: 12px;
}

.reader-file-row > span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.reader-file-row > div {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: flex-end;
}

.reader-file-row .source-link {
  min-height: 32px;
  padding: 0 10px;
  gap: 6px;
  font-size: 12px;
}

.reader-index-state {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  padding: 0 10px;
  border-radius: 8px;
  background: var(--accent-wash);
  color: var(--accent-hover);
  font-size: 12px;
  font-weight: 800;
}

.reader-toolbar .pdf-file {
  min-width: 0;
  overflow: hidden;
  color: var(--muted);
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ebook-page-shell {
  overflow: auto;
  width: 100%;
  margin-top: 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: linear-gradient(90deg, var(--muted-bg) 0, var(--muted-bg) 42%, var(--muted-bg) 58%, var(--muted-bg) 100%);
}

.ebook-page-spread {
  position: relative;
  display: flex;
  min-height: min(760px, 72vh);
  align-items: center;
  justify-content: center;
  padding: 34px 28px;
}

.ebook-page-spread::before {
  position: absolute;
  top: 28px;
  bottom: 28px;
  left: 50%;
  width: 1px;
  background: rgba(37, 50, 47, 0.1);
  content: "";
}

.pdf-canvas {
  position: relative;
  z-index: 1;
  display: block;
  max-width: 100%;
  height: auto !important;
  background: var(--card-bg);
  box-shadow: 0 22px 44px rgba(37, 50, 47, 0.22), inset 18px 0 28px rgba(37, 50, 47, 0.08);
}

.pdf-canvas.is-hidden {
  display: none;
}

.page-loading {
  position: absolute;
  inset: 0;
  z-index: 3;
  display: grid;
  place-items: center;
  background: rgba(250, 250, 250, 0.68);
}

.page-loading span {
  padding: 9px 12px;
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--muted);
  font-size: 13px;
  font-weight: 800;
  box-shadow: 0 12px 24px rgba(37, 50, 47, 0.12);
}

.reader-empty {
  display: flex;
  min-height: 116px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 14px;
  padding: 22px;
}

.reader-empty strong {
  color: var(--issue);
  font-size: 16px;
}

.compact-empty {
  min-height: 96px;
  align-items: flex-start;
  text-align: left;
}

.compact-empty span {
  color: var(--muted);
  font-size: 13px;
  line-height: 1.5;
}

.reader-search {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 42px 42px;
  gap: 6px;
  margin-top: 12px;
}

.reader-search input,
.reader-text-panel textarea {
  width: 100%;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--text);
  font-size: 13px;
  outline: none;
}

.reader-search input {
  min-height: 40px;
  padding: 0 10px;
}

.reader-search button {
  display: grid;
  min-height: 40px;
  place-items: center;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--accent-hover);
  cursor: pointer;
}

.reader-search button:disabled {
  cursor: default;
  opacity: 0.48;
}

.reader-search-message {
  margin: 8px 0 0;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.45;
}

.reader-term-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.reader-term-buttons button {
  padding: 0 9px;
  font-size: 12px;
}

.reader-search-results {
  display: grid;
  gap: 7px;
  margin-top: 10px;
}

.reader-search-results button {
  min-width: 0;
  padding: 9px 10px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--page-bg);
  color: var(--text);
  cursor: pointer;
  text-align: left;
}

.reader-search-results strong,
.reader-search-results span {
  display: block;
}

.reader-search-results strong {
  font-size: 12px;
}

.reader-search-results span {
  display: -webkit-box;
  margin-top: 5px;
  overflow: hidden;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.45;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.text-heading {
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid var(--border);
}

.page-text-list {
  display: grid;
  gap: 9px;
  margin-top: 10px;
}

.page-text-list article {
  padding: 11px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--pending-bg);
}

.page-text-list p {
  margin: 0;
  color: var(--text);
  font-size: 13px;
  line-height: 1.72;
}

.page-text-list button {
  display: inline-flex;
  align-items: center;
  min-height: 30px;
  gap: 6px;
  margin-top: 9px;
  padding: 0 9px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--accent-hover);
  cursor: pointer;
  font-size: 12px;
  font-weight: 800;
}

.reader-text-panel textarea {
  min-height: 94px;
  margin-top: 10px;
  padding: 10px;
  line-height: 1.5;
  resize: vertical;
}

.reader-ai-answer {
  font-size: 13px;
}

.reader-text-panel mark,
.reader-search-results mark {
  padding: 0 2px;
  border-radius: 3px;
  background: var(--pending);
  color: var(--text);
}

.knowledge-section {
  display: grid;
  grid-template-columns: 1.08fr 0.92fr;
  gap: 22px;
}

.knowledge-block {
  min-width: 0;
}

.tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
}

.tag-chip {
  display: inline-flex;
  max-width: 100%;
  flex-direction: column;
  gap: 3px;
  padding: 7px 9px;
  background: var(--muted-bg);
  color: var(--blue-soft);
}

.tag-chip small {
  overflow: hidden;
  color: var(--muted);
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tag-chip em {
  overflow: hidden;
  color: var(--pending-text);
  font-size: 10px;
  font-style: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.public-chip {
  background: var(--accent-wash);
  color: var(--accent-hover);
}

.axis-tag-groups {
  display: grid;
  gap: 10px;
  margin-top: 14px;
}

.axis-tag-group {
  min-width: 0;
  padding: 10px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
}

.axis-tag-group.is-empty {
  background: rgba(255, 255, 255, 0.52);
}

.axis-tag-group header,
.alias-panel div {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.axis-tag-group header strong,
.public-tag-box strong,
.alias-panel strong {
  color: var(--text);
  font-size: 13px;
  font-weight: 850;
}

.axis-tag-group header span {
  color: var(--muted);
  font-size: 12px;
  font-weight: 800;
}

.review-flow {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 14px;
}

.review-flow span {
  padding: 6px 8px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--muted-bg);
  color: var(--muted);
  font-size: 12px;
  font-weight: 850;
}

.review-flow span.is-active {
  border-color: var(--focus-ring-color);
  background: var(--accent-wash);
  color: var(--accent-hover);
}

.public-tag-box,
.alias-panel {
  margin-top: 16px;
  padding: 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
}

.alias-panel {
  display: grid;
  gap: 8px;
}

.alias-panel div span {
  min-width: 0;
  overflow: hidden;
  color: var(--muted);
  font-size: 12px;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.alias-panel div em {
  min-width: 0;
  overflow: hidden;
  color: var(--accent-hover);
  font-size: 12px;
  font-style: normal;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status-list {
  gap: 12px;
  margin-top: 14px;
}

.related-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 12px;
  margin-top: 14px;
}

.related-card {
  min-width: 0;
  padding: 11px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--text);
  cursor: pointer;
  text-align: left;
}

.related-card img {
  aspect-ratio: 3/4.15;
  border-radius: 6px;
  background: var(--muted-bg);
}

.related-card span,
.related-card small,
.related-card em {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
}

.related-card span {
  margin-top: 10px;
  color: var(--text);
  font-size: 12px;
  font-weight: 800;
  line-height: 1.35;
  -webkit-line-clamp: 2;
}

.related-card small {
  margin-top: 7px;
  color: var(--muted);
  font-size: 11px;
  font-style: normal;
  line-height: 1.35;
  -webkit-line-clamp: 2;
}

.related-card em {
  margin-top: 7px;
  color: var(--blue-soft);
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
  -webkit-line-clamp: 1;
}

.no-related {
  color: var(--muted);
  font-size: 14px;
}

.detail-page {
  padding-top: 22px;
}

.detail-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  color: var(--muted);
  font-size: 13px;
  font-weight: 800;
}

.back-button {
  min-height: 40px;
  border: 1px solid var(--border);
  border-radius: 8px;
  cursor: pointer;
}

.detail-panel {
  padding: 24px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
  box-shadow: 0 16px 34px rgba(37, 50, 47, 0.08);
}

.detail-management-section {
  margin-top: 18px;
}

.management-heading {
  margin-bottom: 10px;
}

.management-heading h3 {
  margin: 0;
  color: var(--text);
  font-size: 18px;
  line-height: 1.35;
}

.detail-status-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.detail-status-grid div {
  min-width: 0;
  padding: 14px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
}

.detail-status-grid .status-label,
.detail-status-grid strong,
.detail-status-grid small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}

.detail-status-grid .status-label {
  color: var(--muted);
  font-size: 12px;
  font-weight: 850;
  line-height: 1.35;
}

.detail-status-grid strong {
  margin-top: 6px;
  color: var(--text);
  font-size: 14px;
  line-height: 1.35;
}

.detail-status-grid small {
  margin-top: 6px;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.4;
  overflow-wrap: anywhere;
  white-space: normal;
}

.detail-status-grid small a {
  color: var(--blue-soft);
  font-weight: 800;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.search-graph-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 22px;
}

.graph-detail-section {
  grid-column: 1/-1;
}

.body-search-control {
  margin-top: 14px;
}

.body-search-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 10px;
  align-items: end;
}

.inline-reset {
  width: auto;
  min-width: 74px;
}

.search-results {
  display: grid;
  gap: 9px;
  margin-top: 14px;
}

.search-results article {
  min-width: 0;
  padding: 11px 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
}

.search-result-action {
  min-height: 30px;
  margin-top: 9px;
  padding: 0 10px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: var(--accent-wash);
  color: var(--accent-hover);
  cursor: pointer;
  font-size: 12px;
  font-weight: 800;
}

.search-result-action:hover {
  background: var(--accent-soft);
}

.search-results strong,
.search-results span {
  display: block;
}

.search-results strong {
  color: var(--text);
  font-size: 13px;
}

.search-results p {
  margin: 6px 0 0;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.5;
}

.search-results span {
  margin-top: 7px;
  color: var(--blue-soft);
  font-size: 11px;
  font-weight: 800;
}

.status-list.compact {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px 18px;
}

.graph-toolbar {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  align-items: end;
  margin-top: 14px;
}

.graph-type-toolbar {
  grid-template-columns: minmax(220px, 360px);
}

.graph-tool-actions {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
  min-width: 0;
}

.graph-tool-actions button {
  min-width: 0;
  min-height: 42px;
  padding: 0 8px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--graph-accent-strong);
  cursor: pointer;
  font-size: 12px;
  font-weight: 850;
}

.graph-tool-actions button:hover,
.graph-tool-actions button:focus-visible {
  border-color: var(--focus-ring-color);
  background: var(--accent-soft);
  color: var(--accent-hover);
}

.graph-tool-actions button:disabled {
  border-color: var(--border);
  background: var(--muted-bg);
  color: var(--faint);
  cursor: default;
  opacity: 0.62;
  box-shadow: none;
}

.graph-view-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
  padding: 9px 10px;
  border: 1px solid var(--graph-border);
  border-radius: 8px;
  background: var(--graph-surface-muted);
}

.graph-view-actions span {
  margin-right: auto;
  color: var(--graph-muted);
  font-size: 12px;
  font-weight: 850;
}

.graph-view-actions em {
  min-width: 54px;
  color: var(--graph-accent-strong);
  font-size: 12px;
  font-style: normal;
  font-weight: 900;
  text-align: center;
}

.graph-view-actions button {
  min-height: 32px;
  padding: 0 10px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--graph-accent-strong);
  cursor: pointer;
  font-size: 12px;
  font-weight: 850;
}

.graph-view-actions button:hover,
.graph-view-actions button:focus-visible {
  border-color: var(--focus-ring-color);
  background: var(--accent-soft);
  color: var(--accent-hover);
}

.graph-view-actions button:disabled {
  border-color: var(--border);
  background: var(--muted-bg);
  color: var(--faint);
  cursor: default;
  opacity: 0.62;
  box-shadow: none;
}

.book-graph-summary-panel {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin-top: 10px;
  padding: 10px;
  border: 1px solid var(--graph-border);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.76);
}

.book-graph-summary-panel div {
  display: grid;
  min-width: 0;
  align-content: start;
  gap: 4px;
  min-height: 52px;
  padding: 8px 9px;
  border: 1px solid var(--border-soft);
  border-radius: 6px;
  background: var(--graph-surface-muted);
}

.book-graph-summary-panel div.is-wide {
  grid-column: span 2;
}

.book-graph-summary-panel span,
.book-graph-summary-panel strong {
  display: block;
  min-width: 0;
  overflow-wrap: anywhere;
}

.book-graph-summary-panel span {
  color: var(--graph-muted);
  font-size: 10.5px;
  font-weight: 850;
  line-height: 1.2;
}

.book-graph-summary-panel strong {
  color: var(--graph-text);
  font-size: 12.5px;
  font-weight: 900;
  line-height: 1.28;
}

.collection-toolbar {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.collection-export-button {
  justify-content: center;
  width: 100%;
}

.graph-confidence-control input {
  padding: 0;
  accent-color: var(--accent);
}

.graph-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 42px;
  gap: 8px;
  padding: 0 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--muted);
  font-size: 13px;
  font-weight: 850;
}

.graph-toggle input {
  width: 16px;
  height: 16px;
  accent-color: var(--accent);
}

.book-graph-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(312px, 340px);
  gap: 14px;
  align-items: start;
  margin-top: 14px;
}

.collection-graph-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 340px;
  gap: 14px;
  align-items: start;
  margin-top: 14px;
}

.graph-canvas {
  position: relative;
  min-height: 760px;
  overflow: hidden;
  border: 1px solid var(--graph-border);
  border-radius: 8px;
  background: var(--graph-surface);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.64);
}

.graph-canvas.is-metadata-only {
  min-height: 640px;
}

.graph-canvas.is-low-density {
  min-height: 560px;
}

.graph-canvas.is-dense {
  min-height: 960px;
}

.graph-canvas.is-filtered {
  min-height: 800px;
}

.collection-graph-canvas {
  position: relative;
  min-height: 900px;
  overflow: hidden;
  border: 1px solid var(--graph-border);
  border-radius: 8px;
  background: var(--graph-surface);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.64);
}

.graph-canvas::before,
.graph-canvas::after {
  position: absolute;
  z-index: 0;
  pointer-events: none;
  content: "";
}

.graph-canvas::before {
  display: none;
}

.graph-canvas::after {
  display: none;
}

.collection-graph-canvas::before,
.collection-graph-canvas::after {
  position: absolute;
  z-index: 0;
  pointer-events: none;
  content: "";
}

.collection-graph-canvas::before {
  display: none;
}

.collection-graph-canvas::after {
  display: none;
}

.graph-metadata-notice {
  position: absolute;
  top: 10px;
  left: 12px;
  z-index: 5;
  display: inline-flex;
  max-width: min(360px, 100% - 24px);
  min-height: 26px;
  align-items: center;
  padding: 4px 9px;
  border: 1px solid rgba(31, 31, 31, 0.14);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.9);
  color: var(--pending-text);
  font-size: 11px;
  font-weight: 850;
  line-height: 1.25;
  pointer-events: none;
}

.graph-quality-panel {
  display: grid;
  gap: 10px;
  margin-top: 12px;
  padding: 13px 14px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card-bg);
  box-shadow: 0 10px 22px rgba(37, 50, 47, 0.05);
}

.graph-quality-panel.is-pass {
  border-color: rgba(31, 132, 95, 0.22);
}

.graph-quality-panel.is-warning {
  border-color: rgba(102, 102, 102, 0.28);
  background: rgba(250, 250, 250, 0.94);
}

.graph-quality-panel.is-fail {
  border-color: rgba(179, 66, 56, 0.28);
  background: rgba(255, 248, 247, 0.94);
}

.graph-quality-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.graph-quality-heading span,
.graph-quality-panel li strong {
  color: var(--text);
  font-size: 13px;
  font-weight: 850;
}

.graph-quality-heading strong {
  color: var(--accent-hover);
  font-size: 13px;
  font-weight: 900;
}

.graph-quality-panel p {
  margin: 0;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.45;
}

.graph-quality-panel .graph-quality-notice {
  color: var(--pending-text);
  font-weight: 800;
}

.graph-quality-panel ul {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.graph-quality-panel li {
  display: grid;
  gap: 3px;
  min-width: 0;
  padding: 9px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: var(--page-bg);
}

.graph-quality-panel li.is-fail {
  border-color: rgba(179, 66, 56, 0.26);
}

.graph-quality-panel li.is-warning {
  border-color: rgba(102, 102, 102, 0.26);
}

.graph-quality-panel li span {
  color: var(--muted);
  font-size: 12px;
  line-height: 1.36;
}

.graph-node {
  --node-accent: var(--graph-accent);
  --node-border: var(--border-soft);
  --node-bg: var(--card-bg);
  position: absolute;
  z-index: 4;
  display: flex;
  width: 178px;
  min-height: 88px;
  min-width: 0;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  overflow: visible;
  padding: 10px 12px;
  border: 1px solid var(--node-border);
  border-left: 4px solid var(--node-accent);
  border-radius: 8px;
  background: var(--node-bg);
  color: var(--graph-text);
  cursor: pointer;
  font-size: 12px;
  font-weight: 850;
  text-align: left;
  box-shadow: 0 4px 12px rgba(37, 50, 47, 0.08);
  transition: border-color 140ms ease, box-shadow 140ms ease, opacity 140ms ease, filter 140ms ease, translate 140ms ease;
}

.graph-node:hover:not(.is-dimmed) {
  translate: 0 -3px;
  border-color: var(--node-accent, var(--focus-ring-color));
  box-shadow: 0 8px 18px rgba(37, 50, 47, 0.14);
}

.graph-node.is-selected {
  z-index: 7;
  border-color: var(--accent);
  border-left-color: var(--accent);
  background: var(--node-bg);
  opacity: 1;
  filter: none;
  box-shadow: 0 0 0 2px rgba(30, 30, 30, 0.24), 0 14px 28px rgba(31, 31, 31, 0.16), 0 8px 18px rgba(37, 50, 47, 0.08);
}

.graph-node.is-selected::after {
  position: absolute;
  top: 10px;
  bottom: 10px;
  left: 0;
  width: 4px;
  border-radius: 4px;
  background: var(--accent);
  content: "";
  pointer-events: none;
}

.graph-node.is-related {
  z-index: 6;
  border-color: var(--node-border);
  background: var(--node-bg);
  opacity: 1;
  filter: none;
  box-shadow: 0 7px 16px rgba(37, 50, 47, 0.1);
}

.graph-node.is-dimmed,
.graph-edge-button.is-dimmed {
  opacity: 0.34;
  filter: saturate(0.78);
}

.graph-node small,
.graph-node em,
.graph-edge-button small {
  max-width: 100%;
  overflow: hidden;
  color: var(--graph-muted);
  font-size: 10px;
  font-style: normal;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.graph-node small {
  display: inline-flex;
  width: fit-content;
  max-width: 100%;
  align-items: center;
  gap: 4px;
  padding: 2px 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.68);
  color: var(--muted);
  font-weight: 800;
}

.graph-node small::before {
  display: none;
  content: none;
}

.graph-node-icon {
  display: inline-flex;
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: var(--node-icon-bg, var(--node-accent));
  color: var(--node-icon-color, #FFFFFF);
  font-size: 8px;
  font-weight: 900;
  line-height: 1;
}

.graph-node em {
  color: var(--muted);
  font-weight: 700;
}

.graph-node-title,
.graph-edge-button span {
  display: block;
  min-width: 0;
  overflow: visible;
  color: var(--graph-text);
  font-size: 13px;
  font-weight: 900;
  line-height: 1.28;
  overflow-wrap: anywhere;
  text-overflow: clip;
  white-space: normal;
}

.graph-central-node {
  top: 50%;
  left: 50%;
  z-index: 5;
  width: 214px;
  min-height: 112px;
  transform: translate(-50%, -50%);
  --node-accent: var(--graph-source);
  --node-border: rgba(47, 80, 106, 0.25);
  --node-bg: var(--accent-wash);
  color: var(--blue-soft);
}

.graph-central-node span {
  font-size: 13.5px;
  line-height: 1.32;
}

.collection-central-node {
  width: 188px;
  min-height: 98px;
  --node-accent: var(--graph-accent);
  --node-border: var(--border-soft);
  --node-bg: var(--accent-wash);
}

.collection-resource-node {
  width: 138px;
  min-height: 66px;
  --node-accent: var(--graph-source);
  --node-border: rgba(47, 80, 106, 0.2);
  --node-bg: var(--accent-wash);
}

.collection-tag-node {
  width: 146px;
  min-height: 68px;
  --node-accent: var(--graph-accent);
  --node-border: var(--border-soft);
  --node-bg: var(--accent-wash);
}

.collection-entity-node {
  width: 146px;
  min-height: 68px;
}

.collection-outer-node {
  width: 124px;
  min-height: 52px;
  --node-accent: var(--faint);
  --node-border: rgba(83, 99, 114, 0.16);
  --node-bg: var(--page-bg);
}

.graph-node.is-compact-node {
  width: 148px;
  min-height: 62px;
  gap: 3px;
  padding: 8px 9px;
  border-left-width: 3px;
  box-shadow: 0 2px 7px rgba(37, 50, 47, 0.06);
}

.collection-resource-node.is-compact-node {
  width: 138px;
  min-height: 62px;
}

.graph-node.is-compact-node span {
  font-size: 11.5px;
  line-height: 1.28;
}

.graph-node.is-compact-node small {
  padding: 1px 5px;
  font-size: 9.5px;
}

.graph-node.is-compact-node em {
  font-size: 9.5px;
}

.graph-cluster-label {
  position: absolute;
  z-index: 2;
  display: inline-flex;
  min-height: 22px;
  align-items: center;
  padding: 0 7px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.62);
  color: var(--muted);
  font-size: 10px;
  font-weight: 850;
  letter-spacing: 0;
  line-height: 1;
  pointer-events: none;
  white-space: nowrap;
}

.graph-label-source {
  top: 37%;
  left: 48%;
}

.graph-label-topic {
  top: 18%;
  left: 56%;
}

.graph-label-place {
  top: 48%;
  left: 76%;
}

.graph-label-event {
  top: 86%;
  left: 12%;
}

.graph-label-actor {
  top: 56%;
  left: 25%;
}

.graph-label-concept {
  top: 71%;
  left: 25%;
}

.graph-label-support {
  top: 86%;
  left: 25%;
}

.collection-graph-canvas .graph-label-source {
  top: 38%;
  left: 46%;
}

.collection-label-resource {
  top: 82%;
  left: 16%;
}

.collection-label-topic {
  top: 19%;
  left: 48%;
}

.collection-label-place {
  top: 26%;
  left: 74%;
}

.collection-label-event {
  top: 42%;
  left: 78%;
}

.collection-label-actor {
  top: 66%;
  left: 72%;
}

.collection-label-concept {
  top: 23%;
  left: 18%;
}

.collection-label-support {
  top: 88%;
  left: 76%;
}

.graph-node.type-자료 {
  --node-accent: var(--graph-source);
  --node-border: rgba(47, 80, 106, 0.24);
  --node-bg: var(--accent-wash);
}

.graph-node.type-기관 {
  --node-accent: var(--blue-soft);
  --node-border: rgba(82, 103, 130, 0.2);
  --node-bg: var(--accent-wash);
}

.graph-node.type-관련-자료 {
  --node-accent: var(--graph-source);
  --node-border: rgba(47, 80, 106, 0.2);
  --node-bg: var(--accent-wash);
}

.graph-node.type-주제 {
  --node-accent: var(--graph-accent);
  --node-border: var(--border-soft);
  --node-bg: var(--accent-wash);
}

.graph-node.type-인물 {
  --node-accent: var(--blue-soft);
  --node-border: rgba(82, 103, 130, 0.2);
  --node-bg: var(--accent-wash);
}

.graph-node.type-장소 {
  --node-accent: var(--graph-accent);
  --node-border: var(--border-soft);
  --node-bg: var(--accent-wash);
}

.graph-node.type-사건,
.graph-node.type-시대 {
  --node-accent: var(--blue-soft);
  --node-border: rgba(82, 103, 130, 0.22);
  --node-bg: var(--accent-wash);
}

.graph-node.type-문헌-법령 {
  --node-accent: var(--graph-accent);
  --node-border: var(--border-soft);
  --node-bg: var(--accent-wash);
}

.graph-node.type-개념 {
  --node-accent: var(--graph-accent);
  --node-border: var(--border-soft);
  --node-bg: var(--accent-wash);
}

.graph-node.type-근거-후보 {
  --node-accent: var(--faint);
  --node-border: rgba(83, 99, 114, 0.16);
  --node-bg: var(--page-bg);
}

.graph-link-layer {
  position: absolute;
  inset: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  pointer-events: auto;
}

.graph-link-group {
  cursor: pointer;
}

.graph-link-hitline {
  stroke: transparent;
  stroke-width: 9;
  fill: none;
  vector-effect: non-scaling-stroke;
  pointer-events: stroke;
}

.graph-link {
  stroke: #B8C5D3;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.25px;
  fill: none;
  opacity: 0.64;
  shape-rendering: geometricPrecision;
  vector-effect: non-scaling-stroke;
  pointer-events: none;
}

.graph-link.is-reviewed,
.graph-link.is-evidence-complete {
  stroke: #B8C5D3;
  stroke-dasharray: none;
  opacity: 0.64;
}

.graph-link.is-pending-review.is-evidence-complete {
  stroke: var(--border-soft);
  stroke-dasharray: 4 5;
  stroke-width: 1.2px;
  opacity: 0.5;
}

.graph-link.is-evidence-strong {
  stroke-width: 1.35px;
}

.graph-link.is-metadata-recommendation,
.graph-link.is-pending-review,
.graph-link.is-pending-evidence {
  stroke: #AFC1D8;
  stroke-dasharray: 4 5;
  stroke-width: 1.2px;
  opacity: 0.58;
}

.graph-link.is-direct,
.graph-link.is-hovered {
  stroke: #6F93B8;
  stroke-dasharray: none;
  stroke-width: 1.55px;
  opacity: 0.86;
}

.graph-link.is-direct.is-metadata-recommendation,
.graph-link.is-direct.is-pending-review,
.graph-link.is-direct.is-pending-evidence,
.graph-link.is-hovered.is-metadata-recommendation,
.graph-link.is-hovered.is-pending-review,
.graph-link.is-hovered.is-pending-evidence {
  stroke: var(--design-info-muted);
  stroke-dasharray: 4 5;
  stroke-width: 1.45px;
  opacity: 0.72;
}

.graph-link.is-selected {
  stroke: var(--accent);
  stroke-dasharray: none;
  stroke-width: 2.2px;
  opacity: 1;
}

.graph-link.is-pending-evidence.is-selected {
  stroke: var(--accent);
  stroke-dasharray: none;
  stroke-width: 2.2px;
  opacity: 1;
}

.graph-link.is-dimmed {
  stroke: #E5E7EB;
  stroke-width: 1px;
  opacity: 0.18;
}

.graph-link-label {
  position: absolute;
  z-index: 5;
  display: inline-flex;
  min-height: 18px;
  align-items: center;
  max-width: 118px;
  overflow: hidden;
  padding: 1px 6px;
  border: 1px solid rgba(87, 105, 98, 0.1);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.82);
  color: var(--accent-hover);
  cursor: pointer;
  font-size: 9.5px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1.1;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-shadow: none;
}

.graph-link-hotspot {
  position: absolute;
  z-index: 3;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
}

.graph-link-hotspot:hover,
.graph-link-hotspot:focus-visible {
  background: var(--border-soft);
  box-shadow: 0 0 0 3px var(--border-soft);
}

.graph-link-label.is-metadata-recommendation,
.graph-link-label.is-pending-evidence {
  border-color: rgba(31, 31, 31, 0.13);
  background: rgba(255, 253, 248, 0.68);
  color: var(--pending-text);
}

.graph-link-label.is-evidence-complete {
  border-color: rgba(83, 118, 106, 0.13);
  background: rgba(250, 253, 251, 0.72);
  color: var(--muted);
}

.graph-link-label.is-selected {
  z-index: 6;
  border-color: var(--accent);
  background: rgba(255, 255, 255, 0.94);
  color: var(--accent);
  box-shadow: 0 0 0 3px rgba(31, 31, 31, 0.16);
}

.graph-link-label.is-direct,
.graph-link-label.is-hovered {
  border-color: rgba(122, 162, 205, 0.42);
  color: #3E6D99;
}

.graph-link-label.is-dimmed {
  opacity: 0.34;
  filter: saturate(0.78);
}

.graph-evidence-strip {
  position: absolute;
  bottom: 12px;
  left: 12px;
  z-index: 4;
  display: grid;
  width: min(248px, 100% - 24px);
  grid-template-columns: 1fr;
  gap: 7px;
  max-height: 176px;
  overflow: auto;
}

.graph-evidence-strip button {
  min-width: 0;
  padding: 8px 9px;
  border: 1px solid #E2E2E2;
  border-left: 3px solid #E2E2E2;
  border-radius: 8px;
  background: #FFFFFF;
  color: var(--design-text-muted);
  cursor: pointer;
  text-align: left;
  transition: border-color 140ms ease, box-shadow 140ms ease, opacity 140ms ease, filter 140ms ease, translate 140ms ease;
}

.graph-evidence-strip button:hover:not(.is-dimmed) {
  translate: 0 -1px;
  border-color: rgba(30, 30, 30, 0.28);
  box-shadow: 0 7px 14px rgba(37, 50, 47, 0.1);
}

.graph-evidence-strip button.is-selected {
  border-color: var(--accent);
  border-left: 4px solid var(--accent);
  background: rgba(248, 251, 255, 0.98);
  color: var(--accent-hover);
  opacity: 1;
  filter: none;
  box-shadow: 0 0 0 2px rgba(30, 30, 30, 0.18), 0 10px 20px rgba(30, 30, 30, 0.1);
}

.graph-evidence-strip button.is-related {
  border-color: rgba(30, 30, 30, 0.24);
  border-left-color: var(--accent);
  background: var(--accent-wash);
  opacity: 1;
  filter: none;
}

.graph-evidence-strip button.is-dimmed {
  opacity: 0.34;
  filter: saturate(0.78);
}

.graph-evidence-strip strong,
.graph-evidence-strip span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.graph-evidence-strip strong {
  color: var(--design-text-muted);
  font-size: 12px;
}

.graph-evidence-strip span {
  margin-top: 3px;
  color: var(--design-text-muted);
  font-size: 10px;
}

.graph-evidence-strip button.is-selected strong,
.graph-evidence-strip button.is-selected span,
.graph-evidence-strip button.is-related strong,
.graph-evidence-strip button.is-related span {
  color: var(--accent-hover);
}

.graph-inspector {
  position: sticky;
  top: 14px;
  min-width: 0;
  max-height: calc(100vh - 28px);
  overflow: auto;
  padding: 14px;
  border: 1px solid var(--graph-border);
  border-radius: 8px;
  background: var(--card-bg);
  box-shadow: 0 4px 12px rgba(37, 50, 47, 0.05);
}

.graph-inspector-kind {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  padding: 0 8px;
  border: 1px solid var(--border-soft);
  border-radius: 6px;
  background: var(--page-bg);
  color: var(--graph-accent);
  font-size: 11px;
  font-weight: 900;
}

.graph-inspector-title {
  margin: 12px 0 0;
  color: var(--graph-text);
  font-size: 15px;
  font-weight: 850;
  line-height: 1.45;
}

.graph-inspector-summary {
  margin: 12px 0 0;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.55;
}

.graph-inspector-meta,
.graph-inspector-metrics {
  display: grid;
  gap: 0;
  margin: 12px 0 0;
  border-top: 1px solid var(--border);
}

.graph-inspector-meta div,
.graph-inspector-metrics div {
  display: grid;
  grid-template-columns: 94px minmax(0, 1fr);
  gap: 10px;
  align-items: start;
  padding: 8px 0;
  border-bottom: 1px solid var(--border);
}

.graph-inspector-meta dt,
.graph-inspector-meta dd,
.graph-inspector-metrics dt,
.graph-inspector-metrics dd {
  min-width: 0;
  margin: 0;
  overflow-wrap: anywhere;
  font-size: 12px;
  line-height: 1.45;
}

.graph-inspector-meta dt,
.graph-inspector-metrics dt {
  color: var(--muted);
  font-weight: 850;
}

.graph-inspector-meta dd,
.graph-inspector-metrics dd {
  color: var(--graph-text);
  font-weight: 750;
}

.graph-inspector-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
}

.graph-inspector-tags span {
  min-height: 24px;
  padding: 4px 7px;
  border: 1px solid var(--border-soft);
  border-radius: 6px;
  background: var(--page-bg);
  color: var(--accent-hover);
  font-size: 11px;
  font-weight: 850;
}

.graph-inspector-material-list {
  margin-top: 12px;
  padding-top: 11px;
  border-top: 1px solid var(--border);
}

.graph-inspector-material-list > strong {
  color: var(--text);
  font-size: 13px;
  font-weight: 900;
}

.graph-inspector-material-list ul {
  display: grid;
  gap: 8px;
  margin: 9px 0 0;
  padding: 0;
  list-style: none;
}

.graph-inspector-material-list li {
  min-width: 0;
  padding-left: 9px;
  border-left: 3px solid var(--border-soft);
}

.graph-inspector-material-list span,
.graph-inspector-material-list small {
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.graph-inspector-material-list span {
  color: var(--text);
  font-size: 12px;
  font-weight: 850;
  white-space: nowrap;
}

.graph-inspector-material-list small {
  margin-top: 3px;
  color: var(--muted);
  font-size: 11px;
  line-height: 1.35;
}

.graph-inspector-disclosure {
  margin-top: 12px;
  border-top: 1px solid var(--border);
}

.graph-inspector-disclosure summary {
  min-height: 34px;
  padding: 9px 0 0;
  color: var(--accent-hover);
  cursor: pointer;
  font-size: 12px;
  font-weight: 900;
}

.graph-inspector-disclosure p {
  margin: 6px 0 0;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.55;
}

.graph-inspector-actions {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin-top: 12px;
}

.graph-inspector-actions .source-action-button:disabled {
  cursor: default;
  opacity: 0.42;
}

.graph-node-detail,
.graph-inspector blockquote {
  margin: 12px 0 0;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.6;
}

.graph-inspector blockquote {
  padding: 11px 12px;
  border-left: 3px solid var(--accent);
  background: var(--page-bg);
}

.graph-evidence-meta {
  grid-template-columns: 1fr;
  gap: 0;
  margin-top: 12px;
  border-top: 1px solid var(--border);
}

.graph-evidence-meta div {
  display: grid;
  grid-template-columns: 92px minmax(0, 1fr);
  gap: 10px;
  align-items: start;
  padding: 8px 0;
  border-bottom: 1px solid var(--border);
}

.graph-evidence-meta dt,
.graph-evidence-meta dd {
  margin: 0;
  font-size: 12px;
  line-height: 1.45;
}

.graph-page-button {
  justify-content: center;
  width: 100%;
  margin-top: 14px;
}

.graph-page-button:disabled {
  cursor: default;
  opacity: 0.52;
}

.node-evidence-list {
  display: grid;
  gap: 0;
  margin-top: 14px;
  border-top: 1px solid var(--border);
}

.node-evidence-list > strong {
  color: var(--text);
  font-size: 13px;
  font-weight: 850;
}

.node-evidence-list button {
  min-width: 0;
  padding: 9px 0;
  border: 0;
  border-bottom: 1px solid var(--border);
  border-radius: 0;
  background: transparent;
  color: var(--text);
  cursor: pointer;
  text-align: left;
}

.node-evidence-list button:hover {
  background: var(--page-bg);
}

.node-evidence-list span,
.node-evidence-list p {
  display: block;
  margin: 0;
}

.node-evidence-list span {
  color: var(--accent-hover);
  font-size: 12px;
  font-weight: 850;
}

.node-evidence-list p {
  display: -webkit-box;
  margin-top: 5px;
  overflow: hidden;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.5;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.graph-inspector-evidence-list {
  display: grid;
  gap: 8px;
  margin-top: 12px;
  padding-top: 11px;
  border-top: 1px solid var(--border);
}

.graph-inspector-evidence-list > strong {
  color: var(--text);
  font-size: 13px;
  font-weight: 900;
}

.graph-inspector-evidence-list article {
  display: grid;
  min-width: 0;
  gap: 5px;
  padding: 10px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: var(--page-bg);
}

.graph-inspector-evidence-list span,
.graph-inspector-evidence-list p,
.graph-inspector-evidence-list small {
  min-width: 0;
}

.graph-inspector-evidence-list span {
  color: var(--accent-hover);
  font-size: 12px;
  font-weight: 900;
  line-height: 1.35;
}

.graph-inspector-evidence-list p {
  display: -webkit-box;
  margin: 0;
  overflow: hidden;
  color: var(--text);
  font-size: 12px;
  line-height: 1.5;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.graph-inspector-evidence-list small {
  color: var(--muted);
  font-size: 11px;
  font-weight: 760;
  line-height: 1.35;
}

.graph-inspector-evidence-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 2px;
}

.graph-inspector-evidence-actions button {
  min-height: 28px;
  padding: 5px 8px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: #FFFFFF;
  color: var(--accent-hover);
  cursor: pointer;
  font-size: 11px;
  font-weight: 850;
}

.graph-inspector-evidence-actions button:hover:not(:disabled),
.graph-inspector-evidence-actions button:focus-visible:not(:disabled) {
  border-color: var(--focus-ring-color);
  box-shadow: var(--focus-ring);
}

.graph-inspector-evidence-actions button:disabled {
  cursor: default;
  opacity: 0.46;
}

.graph-edge-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 12px;
}

.graph-edge-button {
  min-width: 0;
  padding: 9px 10px;
  border: 1px solid var(--border);
  border-left: 3px solid rgba(127, 145, 140, 0.26);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--graph-text);
  cursor: pointer;
  text-align: left;
  transition: border-color 140ms ease, box-shadow 140ms ease, opacity 140ms ease, filter 140ms ease, translate 140ms ease;
}

.graph-edge-button:hover:not(.is-dimmed) {
  translate: 0 -1px;
  border-color: rgba(30, 30, 30, 0.32);
  box-shadow: 0 8px 16px rgba(37, 50, 47, 0.1);
}

.graph-edge-button.is-metadata-recommendation,
.graph-edge-button.is-pending-evidence {
  border-left-color: rgba(31, 31, 31, 0.34);
  background: var(--pending-bg);
}

.graph-edge-button.is-evidence-complete {
  border-left-color: rgba(83, 118, 106, 0.38);
}

.graph-edge-button.is-selected {
  border-color: var(--accent);
  border-left: 4px solid var(--accent);
  background: rgba(248, 251, 255, 0.98);
  opacity: 1;
  filter: none;
  box-shadow: 0 0 0 2px rgba(30, 30, 30, 0.18), 0 10px 20px rgba(30, 30, 30, 0.12);
}

.graph-edge-button.is-related {
  border-color: rgba(30, 30, 30, 0.24);
  border-left-color: var(--accent);
  background: var(--accent-wash);
  opacity: 1;
  filter: none;
}

.graph-edge-button strong,
.graph-edge-button span,
.graph-edge-button small {
  display: block;
}

.graph-edge-button strong {
  color: var(--accent-hover);
  font-size: 12px;
}

.graph-edge-button span {
  margin-top: 4px;
  color: var(--text);
  font-size: 12px;
  font-weight: 850;
}

.graph-edge-button small {
  margin-top: 4px;
}

.graph-summary-list {
  margin-top: 12px;
}

.collection-inspector {
  align-self: stretch;
}

.collection-inspector-actions {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin-top: 12px;
}

.collection-inspector-actions .source-action-button:disabled {
  cursor: default;
  opacity: 0.52;
}

.collection-ai-box {
  display: grid;
  gap: 9px;
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid var(--border);
}

.collection-edge-list {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.collection-material-list {
  margin-top: 14px;
}

.collection-material-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin-top: 10px;
}

.collection-material-grid button {
  display: grid;
  grid-template-columns: 54px minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  min-height: 78px;
  padding: 10px 11px;
}

.collection-material-copy {
  display: block;
  min-width: 0;
  overflow: visible;
  margin-top: 0;
  color: inherit;
  font-size: inherit;
  text-overflow: clip;
  white-space: normal;
}

.collection-material-grid strong {
  font-size: 13px;
  line-height: 1.35;
  white-space: normal;
}

.graph-empty-state {
  display: flex;
  min-height: 92px;
  align-items: center;
  justify-content: center;
  margin-top: 14px;
  padding: 18px;
  border: 1px dashed var(--border);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.68);
  color: var(--muted);
  font-size: 13px;
  font-weight: 800;
  text-align: center;
}

.graph-canvas > .compact-empty,
.collection-graph-canvas > .compact-empty {
  position: absolute;
  right: 14px;
  bottom: 14px;
  z-index: 5;
  display: grid;
  width: min(320px, 100% - 28px);
  min-height: 0;
  justify-content: stretch;
  margin-top: 0;
  padding: 12px;
  border-style: solid;
  background: rgba(255, 255, 255, 0.9);
  text-align: left;
}

.graph-canvas > .compact-empty strong,
.graph-canvas > .compact-empty span,
.collection-graph-canvas > .compact-empty strong,
.collection-graph-canvas > .compact-empty span {
  display: block;
  min-width: 0;
}

.graph-canvas > .compact-empty strong,
.collection-graph-canvas > .compact-empty strong {
  color: var(--graph-text);
  font-size: 13px;
}

.graph-canvas > .compact-empty span,
.collection-graph-canvas > .compact-empty span {
  margin-top: 4px;
  color: var(--graph-muted);
  font-size: 12px;
  font-weight: 750;
}

.graph-empty-state.is-error {
  color: var(--issue);
}

.ai-question-box {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 10px;
  align-items: end;
  margin-top: 14px;
}

.primary-action {
  min-width: 96px;
  min-height: 42px;
  justify-content: center;
}

.ai-answer {
  margin-top: 12px;
  padding: 13px 14px;
  border: 1px solid rgba(47, 80, 106, 0.18);
  border-radius: 8px;
  background: var(--accent-wash);
  color: var(--blue-soft);
  font-size: 14px;
  line-height: 1.55;
}

.ai-workbench-section .ai-question-box {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.ai-workbench-section .ai-question-box label:last-of-type {
  grid-column: 1/-1;
}

.ai-action-row {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
  grid-column: 1/-1;
  flex-wrap: wrap;
}

.structured-ai-answer {
  display: grid;
  gap: 14px;
  background: var(--page-bg);
  color: var(--text);
}

.question-result-focus:focus {
  outline: 3px solid rgba(42, 78, 101, 0.34);
  outline-offset: 3px;
}

.question-capability-notice {
  padding: 10px 12px;
  border: 1px solid rgba(47, 80, 106, 0.16);
  border-radius: 8px;
  background: rgba(47, 80, 106, 0.06);
  color: var(--muted);
  font-size: 13px;
  line-height: 1.55;
}

.ai-answer-header,
.report-section-title,
.report-export-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.ai-answer-header strong {
  font-size: 15px;
  color: var(--text);
}

.ai-answer-header span,
.report-warning,
.report-export-row span {
  color: var(--muted);
  font-size: 13px;
  font-weight: 800;
}

.structured-ai-answer section {
  display: grid;
  gap: 8px;
}

.structured-ai-answer h4,
.report-tool-grid h4 {
  margin: 0;
  color: var(--text);
  font-size: 14px;
}

.structured-ai-answer p,
.structured-ai-answer ul,
.report-tool-grid p,
.bibliography-list {
  margin: 0;
}

.structured-ai-answer ul {
  padding-left: 18px;
}

.ai-evidence-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.ai-evidence-grid article,
.report-evidence-row,
.report-citation-row,
.issue-evidence-group {
  display: grid;
  gap: 7px;
  padding: 12px;
  border: 1px solid rgba(85, 115, 108, 0.18);
  border-radius: 8px;
  background: var(--card-bg);
}

.ai-evidence-grid article strong,
.report-evidence-row strong,
.report-citation-row strong,
.issue-evidence-group strong {
  color: var(--text);
  font-size: 14px;
}

.ai-evidence-grid article span,
.report-evidence-row span,
.report-citation-row span,
.report-material-row span {
  color: var(--muted);
  font-size: 12px;
  font-weight: 800;
}

.ai-evidence-grid article p,
.report-evidence-row p,
.report-citation-row p,
.issue-evidence-group p {
  color: var(--muted);
  font-size: 13px;
  line-height: 1.5;
}

.ai-evidence-grid article .evidence-source-meta {
  color: var(--text);
}

.ai-evidence-grid article details {
  border-top: 1px solid rgba(85, 115, 108, 0.16);
  padding-top: 7px;
}

.ai-evidence-grid article details summary {
  width: fit-content;
  cursor: pointer;
  color: var(--blue-soft);
  font-size: 12px;
  font-weight: 850;
}

.ai-evidence-grid article details p {
  margin-top: 8px;
}

.ai-evidence-grid article div {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.ai-evidence-grid article button,
.report-evidence-row button,
.report-section-title button {
  border: 1px solid rgba(85, 115, 108, 0.24);
  border-radius: 8px;
  background: var(--accent-wash);
  color: var(--text);
  font-size: 12px;
  font-weight: 900;
  padding: 7px 10px;
}

.ai-related-materials {
  display: grid;
  gap: 8px;
}

.ai-related-materials button,
.report-material-row {
  display: grid;
  gap: 4px;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid rgba(47, 80, 106, 0.16);
  border-radius: 8px;
  background: var(--pending-bg);
  color: var(--text);
  text-align: left;
}

.assistant-empty {
  color: var(--issue);
  font-weight: 800;
}

.report-assist-section {
  display: grid;
  gap: 14px;
}

.report-tool-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.report-tool-grid > section {
  display: grid;
  gap: 9px;
  align-content: start;
  min-width: 0;
}

.bibliography-list,
.report-tool-grid ol {
  display: grid;
  gap: 7px;
  padding-left: 20px;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.5;
}

.report-export-row {
  padding: 12px;
  border: 1px solid rgba(85, 115, 108, 0.18);
  border-radius: 8px;
  background: var(--page-bg);
  flex-wrap: wrap;
}

@media (max-width: 1280px) {
  .control-panel {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .topic-graph-card-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .collection-meta-grid,
  .admin-status-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .admin-table {
    overflow-x: auto;
  }
  .collection-tabs,
  .result-collection-grid,
  .result-group-grid,
  .collection-material-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .search-control {
    grid-column: 1/-1;
  }
  .reset-button {
    min-height: 42px;
  }
  .related-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .detail-status-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .ebook-reader-grid {
    grid-template-columns: 220px minmax(0, 1fr);
  }
  .reader-text-panel {
    grid-column: 1/-1;
    position: static;
    max-height: none;
  }
  .graph-toolbar {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .graph-type-toolbar {
    grid-template-columns: minmax(220px, 360px);
  }
  .graph-tool-actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .book-graph-summary-panel {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .collection-toolbar {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .graph-legend-body {
    grid-template-columns: 1fr;
  }
  .book-graph-layout {
    grid-template-columns: 1fr;
  }
  .collection-graph-layout {
    grid-template-columns: 1fr;
  }
  .graph-inspector {
    position: static;
    max-height: none;
  }
}
@media (max-width: 900px) {
  .modal-layout,
  .detail-layout,
  .graph-entry-panel,
  .knowledge-section,
  .toc-summary-grid,
  .search-graph-grid {
    grid-template-columns: 1fr;
  }
  .book-graph-summary-panel {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .modal-cover {
    width: min(220px, 64vw);
    margin: 0 auto;
  }
  .detail-page .modal-cover {
    width: min(240px, 70vw);
    max-width: 240px;
    margin: 0 auto;
  }
  .modal-content,
  .detail-content {
    padding-right: 0;
  }
  .section-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .section-heading-actions {
    width: 100%;
    justify-content: flex-start;
  }
  .detail-status-grid,
  .status-list.compact {
    grid-template-columns: 1fr;
  }
  .ebook-reader-grid {
    grid-template-columns: 1fr;
  }
  .reader-nav-panel {
    position: static;
    max-height: none;
  }
  .graph-toolbar,
  .graph-edge-list,
  .collection-toolbar,
  .collection-edge-list,
  .result-collection-grid,
  .result-group-grid,
  .collection-material-grid,
  .collection-meta-grid,
  .admin-status-grid,
  .graph-target-row,
  .ai-workbench-section .ai-question-box,
  .ai-evidence-grid,
  .report-tool-grid {
    grid-template-columns: 1fr;
  }
  .graph-tool-actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .ai-workbench-section .ai-question-box label:last-of-type,
  .ai-action-row {
    grid-column: auto;
  }
  .collection-tabs {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .result-collection-grid,
  .result-group-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .topic-graph-card-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .top-tabbar {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .graph-canvas {
    min-height: 760px;
  }
  .collection-graph-canvas {
    min-height: 860px;
  }
  .graph-node {
    width: 144px;
  }
  .graph-node.is-compact-node {
    width: 124px;
  }
  .collection-resource-node,
  .collection-tag-node,
  .collection-entity-node,
  .collection-outer-node {
    width: 136px;
  }
}
@media (max-width: 760px) {
  .library-page {
    padding: 22px 14px 38px;
  }
  .library-hero {
    align-items: stretch;
    flex-direction: column;
    gap: 14px;
  }
  h1 {
    font-size: 31px;
  }
  .library-count {
    width: 100%;
    text-align: left;
  }
  .collection-graph-section {
    padding: 12px;
  }
  .collection-tabs {
    grid-template-columns: 1fr;
  }
  .topic-graph-card-grid,
  .result-collection-grid,
  .result-group-grid,
  .top-tabbar,
  .graph-scope-tabs,
  .graph-entry-metrics {
    grid-template-columns: 1fr;
  }
  .control-panel {
    grid-template-columns: 1fr;
  }
  .search-control {
    grid-column: auto;
  }
  .control-panel {
    padding: 12px;
  }
  .shelf {
    grid-template-columns: repeat(auto-fill, minmax(142px, 1fr));
    gap: 16px;
  }
  .book-card {
    gap: 12px;
    padding: 12px;
  }
  .book-title {
    font-size: 14px;
  }
  .book-card-footer {
    gap: 16px;
    padding-top: 14px;
  }
  .modal-backdrop {
    align-items: stretch;
    padding: 12px;
  }
  .book-modal {
    max-height: calc(100vh - 24px);
    padding: 20px 20px 34px;
  }
  .detail-panel {
    padding: 18px;
  }
  .modal-content h2 {
    font-size: 24px;
  }
  .detail-content h2 {
    font-size: 28px;
  }
  .detail-list {
    grid-template-columns: 1fr;
  }
  .detail-list div {
    grid-template-columns: 108px minmax(0, 1fr);
    gap: 12px;
  }
  .reader-toolbar {
    align-items: stretch;
    flex-wrap: wrap;
  }
  .body-search-row,
  .ai-question-box {
    grid-template-columns: 1fr;
  }
  .inline-reset,
  .primary-action {
    width: 100%;
  }
  .reader-toolbar .pdf-file {
    width: 100%;
    white-space: normal;
  }
  .ebook-page-spread {
    min-height: 520px;
    padding: 18px 12px;
  }
  .related-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .graph-node {
    width: 128px;
    min-height: 68px;
    padding: 8px 9px;
  }
  .graph-node.is-compact-node {
    width: 116px;
    min-height: 50px;
  }
  .graph-central-node,
  .collection-central-node {
    width: 146px;
    min-height: 84px;
  }
  .collection-resource-node,
  .collection-tag-node,
  .collection-entity-node,
  .collection-outer-node {
    width: 116px;
  }
}
/* Step 50: final regression polish for detail readability and graph labels. */
.detail-page .detail-panel {
  padding: 28px;
}

.detail-page .detail-layout {
  grid-template-columns: minmax(280px, 332px) minmax(0, 1fr);
  gap: 42px;
}

.detail-page .modal-cover {
  position: sticky;
  top: 18px;
  align-self: start;
  max-width: 332px;
  border: 1px solid var(--border);
  background: #FFFFFF;
  box-shadow: inset 8px 0 14px rgba(30, 30, 30, 0.08), 0 14px 30px rgba(31, 41, 51, 0.12);
}

.detail-page .modal-cover img {
  background: #FFFFFF;
  object-fit: contain;
}

.detail-page .detail-content h2 {
  font-size: 35px;
}

.detail-page .bibliographic-list {
  margin-top: 32px;
}

.detail-page .bibliographic-list div {
  grid-template-columns: 180px minmax(0, 1fr);
  min-height: 52px;
  padding: 14px 0;
}

.detail-page .bibliographic-list dt {
  font-size: 15px;
}

.detail-page .bibliographic-list dd {
  font-size: 16.5px;
  font-weight: 720;
}

.detail-management-section {
  margin-top: 18px;
  padding-top: 16px;
}

.detail-management-section .management-heading h3 {
  font-size: 17px;
}

.detail-status-grid {
  gap: 10px;
}

.detail-status-grid .detail-status-card {
  min-height: 84px;
  padding: 12px 14px;
}

.detail-status-grid .status-label {
  font-size: 12px;
}

.detail-status-grid strong {
  font-size: 15px;
}

.detail-status-grid small {
  font-size: 12px;
}

.detail-page .detail-action-group {
  gap: 10px;
}

.detail-page .detail-action-group .source-link,
.detail-page .detail-action-group .source-action-button {
  min-height: 48px;
  min-width: 164px;
  font-size: 15.5px;
}

.detail-page .detail-action-group .detail-action-primary {
  min-width: 188px;
}

.detail-page .detail-action-group .primary-graph-action {
  min-width: 230px;
}

.graph-node,
.graph-node-title,
.graph-node .graph-node-type,
.graph-node .graph-node-status,
.graph-node em {
  overflow-wrap: anywhere;
  text-overflow: clip;
  word-break: keep-all;
}

.graph-node-title,
.graph-node .graph-node-type,
.graph-node .graph-node-status,
.graph-node em {
  overflow: visible;
  white-space: normal;
}

.graph-node.shape-circle .graph-node-title,
.graph-node.shape-capsule .graph-node-title,
.graph-node.shape-compact .graph-node-title,
.graph-central-node.shape-material-card .graph-node-title,
.collection-central-node .graph-node-title,
.graph-node.shape-central-topic .graph-node-title {
  display: block;
  height: auto;
  max-height: none;
  -webkit-box-orient: initial;
  -webkit-line-clamp: unset;
}

.graph-central-node.shape-material-card {
  width: 264px;
  min-height: 148px;
}

.collection-central-node,
.graph-node.shape-central-topic {
  width: 198px;
  height: 198px;
}

.graph-node.shape-circle.is-long-label {
  width: 136px;
  height: 136px;
  padding: 16px 13px;
}

.graph-node.shape-circle.is-very-long-label {
  width: 148px;
  height: 148px;
  padding: 17px 14px;
}

.graph-node.shape-capsule.is-long-label {
  width: 174px;
  height: 84px;
  border-radius: 999px;
}

.graph-node.shape-capsule.is-very-long-label {
  width: 190px;
  height: 92px;
}

.graph-node.shape-small-card.is-long-label,
.collection-resource-node.shape-small-card.is-long-label {
  width: 184px;
  min-height: 92px;
}

.graph-node.shape-compact.is-long-label {
  width: 118px;
  height: 58px;
}

.graph-node.shape-circle.is-long-label .graph-node-title,
.graph-node.shape-capsule.is-long-label .graph-node-title {
  font-size: 14.5px;
}

.graph-node.shape-circle.is-very-long-label .graph-node-title,
.graph-node.shape-capsule.is-very-long-label .graph-node-title {
  font-size: 13.5px;
}

.graph-node.shape-circle.is-long-label .graph-node-type,
.graph-node.shape-circle.is-long-label .graph-node-status,
.graph-node.shape-circle.is-long-label em,
.graph-node.shape-capsule.is-long-label .graph-node-type,
.graph-node.shape-capsule.is-long-label .graph-node-status,
.graph-node.shape-capsule.is-long-label em {
  font-size: 11.2px;
}

.graph-link {
  stroke-width: 1.75px;
  opacity: 0.84;
}

.graph-link.is-reviewed,
.graph-link.is-evidence-complete {
  stroke-width: 1.85px;
  opacity: 0.88;
}

.graph-link.is-metadata-recommendation,
.graph-link.is-pending-review,
.graph-link.is-pending-evidence {
  stroke-width: 1.55px;
  opacity: 0.72;
}

.graph-link.is-dimmed {
  opacity: 0.2;
}

@media (max-width: 900px) {
  .detail-page .detail-layout {
    grid-template-columns: 1fr;
    gap: 26px;
  }
  .detail-page .modal-cover {
    position: static;
    max-width: 280px;
  }
  .detail-page .bibliographic-list div {
    grid-template-columns: 150px minmax(0, 1fr);
  }
  .graph-central-node.shape-material-card {
    width: 220px;
    min-height: 134px;
  }
  .collection-central-node,
  .graph-node.shape-central-topic {
    width: 168px;
    height: 168px;
  }
  .graph-node.shape-circle.is-long-label {
    width: 118px;
    height: 118px;
  }
  .graph-node.shape-circle.is-very-long-label {
    width: 128px;
    height: 128px;
  }
  .graph-node.shape-capsule.is-long-label {
    width: 150px;
    height: 74px;
  }
}
@media (max-width: 560px) {
  .book-graph-summary-panel,
  .book-graph-summary-panel div.is-wide {
    grid-template-columns: 1fr;
    grid-column: auto;
  }
  .detail-page .detail-panel {
    padding: 20px;
  }
  .detail-page .detail-content h2 {
    font-size: 28px;
  }
  .detail-page .bibliographic-list div {
    grid-template-columns: 118px minmax(0, 1fr);
  }
  .detail-page .bibliographic-list dt {
    font-size: 13.5px;
  }
  .detail-page .bibliographic-list dd {
    font-size: 15px;
  }
}
.graph-link.is-evidence-strong,
.graph-link.is-pending-review.is-evidence-complete,
.graph-link.is-reviewed.is-evidence-strong,
.graph-link.is-evidence-complete.is-evidence-strong {
  stroke-width: 1.85px;
  opacity: 0.82;
}

.graph-link.is-metadata-recommendation.is-evidence-strong,
.graph-link.is-pending-review.is-evidence-strong,
.graph-link.is-pending-evidence.is-evidence-strong {
  stroke-width: 1.65px;
  opacity: 0.74;
}

/* Step 32: global design token consolidation. */
.library-page {
  padding-top: 32px;
}

.eyebrow {
  color: var(--accent);
}

h1,
.library-count strong,
.topic-quickbar strong,
.detail-demo-actions strong,
.collection-heading h2,
.topic-graph-entry-section .section-heading h2,
.topic-graph-card strong,
.result-collection-grid button strong,
.result-group-grid button strong,
.book-title,
.modal-content h2,
.detail-content h2,
.section-heading h3,
.reader-panel-heading strong,
.management-heading h3,
.detail-status-grid strong,
.graph-entry-copy strong,
.admin-status-grid strong,
.graph-inspector-material-list > strong,
.node-evidence-list > strong,
.ai-answer-header strong,
.structured-ai-answer h4,
.report-tool-grid h4 {
  color: var(--text);
  word-break: keep-all;
  overflow-wrap: break-word;
}

.library-subtitle,
.library-count span,
.topic-quickbar span,
.detail-demo-actions span,
.collection-heading p,
.topic-graph-card p,
.topic-graph-card em,
.collection-tabs span,
.collection-material-grid span,
.collection-material-grid em,
.control span,
.status-row,
.book-detail,
.detail-list dt,
.status-list dt,
.detail-toolbar,
.reader-panel-heading span,
.reader-toolbar span,
.reader-file-row,
.reader-toolbar .pdf-file,
.reader-search-message,
.no-related,
.graph-view-actions span,
.graph-empty-state,
.ai-answer-header span,
.report-warning,
.report-export-row span {
  color: var(--muted);
}

.library-count,
.topic-quickbar,
.top-tabbar,
.topic-graph-entry-section,
.collection-overview-section,
.graph-hub-section,
.graph-book-tab-section,
.research-ai-section,
.admin-review-section,
.collection-graph-section,
.control-panel,
.result-collection-panel,
.book-card,
.book-modal,
.reader-nav-panel,
.reader-text-panel,
.reader-toolbar,
.detail-panel,
.admin-row,
.topic-graph-card,
.collection-tabs button,
.collection-material-grid button,
.result-collection-grid button,
.result-group-grid button,
.axis-tag-group,
.public-tag-box,
.alias-panel,
.related-card,
.detail-status-grid div,
.search-results article,
.ai-evidence-grid article,
.report-evidence-row,
.report-citation-row,
.issue-evidence-group,
.graph-inspector,
.graph-edge-button {
  border-color: var(--border);
  background: var(--card-bg);
  border-radius: var(--card-radius);
  box-shadow: var(--surface-shadow);
}

.collection-meta-grid article,
.admin-status-grid article,
.evidence-list article,
.reader-search-results button,
.review-flow span,
.graph-view-actions,
.report-export-row {
  border-color: var(--border);
  background: var(--page-bg);
  border-radius: var(--card-radius);
}

.book-card {
  box-shadow: var(--surface-shadow);
}

.book-card:hover,
.topic-graph-card:hover,
.topic-graph-card.is-active,
.collection-tabs button.is-active,
.collection-tabs button:hover,
.collection-material-grid button:hover,
.result-collection-grid button:hover,
.result-collection-grid button.is-active,
.result-group-grid button:hover,
.result-group-grid button.is-active,
.admin-row:hover,
.admin-row:focus-visible {
  border-color: var(--accent);
  background: var(--accent-wash);
  box-shadow: var(--focus-ring), var(--surface-shadow-strong);
}

.top-tabbar button,
.graph-scope-tabs button,
.topic-quickbar button,
.detail-demo-actions button,
.reader-term-buttons button,
.graph-entry-buttons button,
.section-mini-button,
.inline-text-button,
.graph-tool-actions button,
.graph-view-actions button,
.reader-search button,
.page-text-list button,
.search-result-action,
.ai-evidence-grid article button,
.report-evidence-row button,
.report-section-title button {
  border-color: var(--border);
  background: var(--page-bg);
  color: var(--text);
  border-radius: var(--button-radius);
}

.top-tabbar button:hover,
.top-tabbar button:focus-visible,
.top-tabbar button.is-active,
.graph-scope-tabs button:hover,
.graph-scope-tabs button:focus-visible,
.graph-scope-tabs button.is-active,
.topic-quickbar button:hover,
.topic-quickbar button.is-active,
.detail-demo-actions button:hover,
.reader-term-buttons button:hover,
.reader-term-buttons button.is-active,
.graph-entry-buttons button:hover,
.section-mini-button:hover,
.section-mini-button:focus-visible,
.inline-text-button:hover,
.graph-tool-actions button:hover,
.graph-tool-actions button:focus-visible,
.graph-view-actions button:hover,
.graph-view-actions button:focus-visible,
.reader-search button:hover,
.page-text-list button:hover,
.search-result-action:hover,
.ai-evidence-grid article button:hover,
.report-evidence-row button:hover,
.report-section-title button:hover {
  border-color: var(--accent);
  background: var(--accent-soft);
  color: var(--accent-hover);
  box-shadow: var(--focus-ring);
}

.control input,
.control select,
.control textarea,
.reader-search input,
.reader-text-panel textarea,
.page-jump,
.page-jump input,
.reset-button,
.source-action-button,
.reader-toolbar button,
.pdf-tabs button,
.back-button,
.modal-close,
.autocomplete-menu,
.autocomplete-option {
  border-color: var(--border);
  background: var(--card-bg);
  color: var(--text);
}

.control input:focus,
.control select:focus,
.control textarea:focus,
.author-clear:focus-visible,
.autocomplete-option:focus-visible,
.topic-graph-card:focus-visible,
.result-collection-grid button:focus-visible,
.result-group-grid button:focus-visible,
.inline-text-button:focus-visible,
.detail-primary-tags button:focus-visible,
.graph-entry-buttons button:focus-visible,
.reset-button:focus-visible,
.source-action-button:focus-visible,
.back-button:focus-visible,
.book-card:focus-visible,
.modal-close:focus-visible,
.source-link:focus-visible,
.related-card:focus-visible,
.reader-toolbar button:focus-visible,
.pdf-tabs button:focus-visible {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(31, 31, 31, 0.16);
}

.reset-button,
.source-link,
.source-action-button,
.back-button,
.detail-cta,
.detail-demo-actions .primary-demo-action,
.source-link.primary-source {
  border-color: var(--accent);
  background: var(--accent);
  color: var(--on-accent);
}

.reset-button:hover,
.source-link:hover,
.source-action-button:hover,
.back-button:hover,
.detail-demo-actions .primary-demo-action:hover {
  border-color: var(--accent-hover);
  background: var(--accent-hover);
}

.source-link.secondary,
.graph-entry-action {
  border-color: var(--blue-muted);
  background: var(--accent-wash);
  color: var(--accent-hover);
}

.source-link.secondary:hover,
.graph-entry-action:hover {
  background: var(--accent-soft);
}

.book-category,
.tag-strip span,
.detail-primary-tags button,
.tag-chip,
.public-chip,
.reader-index-state,
.pdf-tabs button.is-active,
.review-flow span.is-active {
  background: var(--accent-wash);
  color: var(--accent-hover);
}

.tag-strip span[role=button]:hover,
.tag-strip span[role=button].is-active,
.detail-primary-tags button:hover,
.detail-primary-tags button.has-graph {
  background: var(--accent-soft);
  color: var(--accent-hover);
}

.review-state,
.section-heading span,
.collection-meta-grid strong,
.admin-status-grid span,
.topic-graph-card span,
.result-collection-grid button span,
.result-group-grid button span {
  background: var(--muted-bg);
  color: var(--muted);
}

.section-heading span.is-missing,
.error-text,
.assistant-empty,
.reader-empty strong,
.graph-empty-state.is-error {
  color: var(--issue);
}

.section-heading span.is-missing,
.reader-empty,
.evidence-list article > button:hover {
  background: var(--issue-soft);
}

.detail-demo-actions,
.page-text-list article,
.ai-related-materials button,
.report-material-row {
  border-color: var(--pending);
  background: var(--pending-bg);
}

.reader-text-panel mark,
.reader-search-results mark {
  background: var(--pending);
  color: var(--text);
}

.cover-frame,
.modal-cover,
.related-card img {
  background: var(--muted-bg);
  box-shadow: inset 6px 0 12px rgba(31, 41, 51, 0.06), var(--surface-shadow);
}

.cover-frame.is-placeholder,
.modal-cover.is-placeholder {
  background: var(--muted-bg);
  box-shadow: inset 0 0 0 1px var(--border);
}

.modal-backdrop {
  background: rgba(31, 41, 51, 0.44);
}

.ebook-page-shell {
  border-color: var(--border);
  background: linear-gradient(90deg, var(--muted-bg) 0, var(--page-bg) 44%, var(--page-bg) 56%, var(--muted-bg) 100%);
}

.ebook-page-spread::before,
.toolbar-divider {
  background: var(--border-soft);
}

.pdf-canvas {
  box-shadow: var(--surface-shadow-strong), inset 14px 0 22px rgba(31, 41, 51, 0.04);
}

.page-loading {
  background: rgba(247, 248, 250, 0.76);
}

.structured-ai-answer,
.ai-answer {
  border-color: var(--border-soft);
  background: var(--accent-wash);
  color: var(--text);
}

.graph-canvas,
.collection-graph-canvas {
  border-color: var(--border);
  background-color: var(--card-bg);
  background-image: linear-gradient(var(--border-soft) 1px, transparent 1px), linear-gradient(90deg, var(--border-soft) 1px, transparent 1px);
  background-size: 48px 48px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.82), var(--surface-shadow);
}

.collection-graph-canvas {
  background-image: radial-gradient(ellipse at 50% 50%, transparent 0 24%, rgba(30, 30, 30, 0.13) 24.15%, rgba(30, 30, 30, 0.13) 24.45%, transparent 24.75%), radial-gradient(ellipse at 50% 50%, transparent 0 37%, rgba(31, 41, 51, 0.1) 37.15%, rgba(31, 41, 51, 0.1) 37.45%, transparent 37.75%), radial-gradient(ellipse at 50% 50%, transparent 0 47%, rgba(31, 41, 51, 0.08) 47.15%, rgba(31, 41, 51, 0.08) 47.45%, transparent 47.75%);
  background-size: 100% 100%;
}

.graph-metadata-notice {
  border-color: var(--pending);
  background: var(--pending-bg);
  color: var(--pending-text);
}

.graph-node {
  --node-accent: var(--accent);
  --node-border: var(--border-soft);
  --node-bg: var(--page-bg);
  --node-text: #4B6075;
  --node-muted: var(--design-text-muted);
  --node-icon-bg: var(--node-accent);
  --node-icon-color: #FFFFFF;
  --node-type-bg: rgba(255, 255, 255, 0.86);
  border-color: var(--node-border);
  border-left-color: var(--node-accent);
  background: var(--node-bg);
  color: var(--node-text);
  box-shadow: var(--surface-shadow);
}

.graph-node:hover:not(.is-dimmed) {
  translate: 0 -3px;
  border-color: var(--node-accent, var(--accent));
  box-shadow: 0 8px 18px rgba(37, 50, 47, 0.14);
}

.graph-node.is-selected {
  border-color: var(--accent);
  border-left-color: var(--accent);
  background: var(--node-bg);
  opacity: 1;
  filter: none;
  box-shadow: 0 0 0 2px rgba(30, 30, 30, 0.24), 0 14px 28px rgba(31, 31, 31, 0.16), 0 8px 18px rgba(37, 50, 47, 0.08);
}

.graph-node.is-related {
  background: var(--node-bg);
  opacity: 1;
  filter: none;
  box-shadow: 0 7px 16px rgba(37, 50, 47, 0.1);
}

.graph-node.is-dimmed,
.graph-edge-button.is-dimmed {
  opacity: 0.34;
  filter: saturate(0.78);
}

.graph-node small {
  background: var(--node-type-bg);
  color: var(--node-muted);
}

.graph-node em,
.graph-edge-button small {
  color: var(--node-muted);
}

.graph-node-title {
  color: var(--node-text);
}

.graph-node-type span:not(.graph-node-icon) {
  color: var(--node-muted);
  font-size: 10px;
  font-weight: 850;
}

.graph-central-node,
.graph-node.type-자료,
.graph-node.type-관련-자료,
.collection-resource-node {
  --node-accent: var(--text);
  --node-border: var(--text);
  --node-bg: #FFFFFF;
  --node-text: var(--text);
  --node-muted: var(--text);
}

.graph-node.type-주제,
.collection-tag-node {
  --node-accent: var(--accent);
  --node-border: var(--accent);
  --node-bg: var(--accent-soft);
  --node-text: var(--accent-hover);
  --node-muted: var(--accent-hover);
}

.collection-central-node {
  --node-accent: var(--accent-hover);
  --node-border: var(--accent);
  --node-bg: var(--accent);
  --node-text: #FFFFFF;
  --node-muted: rgba(255, 255, 255, 0.84);
  --node-icon-bg: #FFFFFF;
  --node-icon-color: var(--accent-hover);
  --node-type-bg: rgba(255, 255, 255, 0.16);
}

.graph-node.type-장소 {
  --node-accent: #7AA2CD;
  --node-border: #7AA2CD;
  --node-bg: #EAF4FF;
  --node-text: #3E6D99;
  --node-muted: #3E6D99;
}

.graph-node.type-기관,
.graph-node.type-인물 {
  --node-accent: var(--design-info-muted);
  --node-border: var(--design-info-muted);
  --node-bg: #F2F6FB;
  --node-text: #40566D;
  --node-muted: #40566D;
}

.graph-node.type-사건,
.graph-node.type-시대 {
  --node-accent: #5E6676;
  --node-border: #CED7E6;
  --node-bg: #F2F5FA;
  --node-text: #5E6676;
  --node-muted: #5E6676;
}

.graph-node.type-문헌-법령,
.graph-node.type-개념 {
  --node-accent: var(--border-soft);
  --node-border: var(--border-soft);
  --node-bg: var(--page-bg);
  --node-text: #4B6075;
  --node-muted: #4B6075;
}

.graph-node.type-주장,
.graph-node.type-쟁점,
.graph-node.type-반박,
.graph-node.type-쟁점-반박 {
  --node-accent: #953E40;
  --node-border: #953E40;
  --node-bg: #FFF1F1;
  --node-text: #953E40;
  --node-muted: #953E40;
}

.graph-node.type-근거-후보,
.collection-outer-node {
  --node-accent: #E2E2E2;
  --node-border: #E2E2E2;
  --node-bg: #FFFFFF;
  --node-text: var(--design-text-muted);
  --node-muted: var(--design-text-muted);
  --node-icon-color: var(--design-text-muted);
}

.graph-cluster-label {
  border-color: var(--border-soft);
  background: rgba(255, 255, 255, 0.82);
  color: var(--muted);
}

.graph-link {
  stroke: #B8C5D3;
  stroke-width: 1.25px;
  opacity: 0.64;
}

.graph-link.is-reviewed,
.graph-link.is-evidence-complete {
  stroke: #B8C5D3;
  opacity: 0.64;
}

.graph-link.is-pending-review.is-evidence-complete,
.graph-link.is-evidence-strong {
  stroke-width: 1.35px;
}

.graph-link.is-metadata-recommendation,
.graph-link.is-pending-review,
.graph-link.is-pending-evidence {
  stroke: #AFC1D8;
  stroke-dasharray: 4 5;
  stroke-width: 1.2px;
  opacity: 0.58;
}

.graph-link.is-direct,
.graph-link.is-hovered {
  stroke: #6F93B8;
  stroke-dasharray: none;
  stroke-width: 1.55px;
  opacity: 0.86;
}

.graph-link.is-direct.is-metadata-recommendation,
.graph-link.is-direct.is-pending-review,
.graph-link.is-direct.is-pending-evidence,
.graph-link.is-hovered.is-metadata-recommendation,
.graph-link.is-hovered.is-pending-review,
.graph-link.is-hovered.is-pending-evidence {
  stroke: var(--design-info-muted);
  stroke-dasharray: 4 5;
  stroke-width: 1.45px;
  opacity: 0.72;
}

.graph-link.is-selected {
  stroke: var(--accent);
  stroke-dasharray: none;
  stroke-width: 2.2px;
  opacity: 1;
}

.graph-link.is-pending-evidence.is-selected {
  stroke: var(--accent);
  stroke-dasharray: none;
  stroke-width: 2.2px;
  opacity: 1;
}

.graph-link.is-dimmed {
  stroke: #E5E7EB;
  stroke-width: 1px;
  opacity: 0.18;
}

.graph-link-label {
  border-color: var(--border-soft);
  background: rgba(255, 255, 255, 0.92);
  color: var(--accent-hover);
}

.graph-link-label.is-metadata-recommendation,
.graph-link-label.is-pending-evidence {
  border-color: var(--pending);
  background: rgba(250, 250, 250, 0.94);
  color: var(--pending-text);
}

.graph-link-label.is-evidence-complete {
  border-color: var(--border-soft);
  background: rgba(248, 251, 255, 0.94);
  color: var(--accent-hover);
}

.graph-link-label.is-selected {
  border-color: var(--accent);
  color: var(--accent);
  box-shadow: 0 0 0 3px rgba(31, 31, 31, 0.16);
}

.graph-link-label.is-direct,
.graph-link-label.is-hovered {
  border-color: rgba(122, 162, 205, 0.42);
  color: #3E6D99;
}

.graph-link-hotspot:hover,
.graph-link-hotspot:focus-visible {
  background: rgba(30, 30, 30, 0.08);
  box-shadow: var(--focus-ring);
}

.graph-inspector-kind,
.graph-inspector-tags span,
.node-evidence-list span,
.graph-inspector-disclosure summary,
.graph-edge-button strong {
  border-color: var(--border-soft);
  background: var(--accent-wash);
  color: var(--accent-hover);
}

.graph-inspector-meta,
.graph-inspector-metrics,
.graph-inspector-material-list,
.graph-inspector-disclosure,
.graph-evidence-meta,
.node-evidence-list {
  border-color: var(--border);
}

.graph-inspector-meta div,
.graph-inspector-metrics div,
.graph-evidence-meta div,
.node-evidence-list button {
  border-color: var(--border);
}

.graph-inspector blockquote {
  border-left-color: var(--accent);
  background: var(--accent-wash);
}

.graph-edge-button {
  border-left-color: var(--blue-muted);
}

.graph-edge-button.is-metadata-recommendation,
.graph-edge-button.is-pending-evidence {
  border-left-color: var(--pending-strong);
  background: var(--pending-bg);
}

.graph-edge-button.is-evidence-complete {
  border-left-color: var(--blue-soft);
}

.graph-edge-button.is-selected,
.graph-edge-button.is-related {
  border-left-color: var(--accent);
  background: var(--accent-wash);
}

.graph-edge-button.is-selected {
  border-color: var(--accent);
  border-left: 4px solid var(--accent);
  background: rgba(248, 251, 255, 0.98);
  box-shadow: 0 0 0 2px rgba(30, 30, 30, 0.18), 0 10px 20px rgba(30, 30, 30, 0.12);
}

.graph-edge-button.is-related {
  border-color: rgba(30, 30, 30, 0.24);
  opacity: 1;
  filter: none;
}

.graph-evidence-strip button,
.graph-empty-state,
.graph-canvas > .compact-empty,
.collection-graph-canvas > .compact-empty {
  border-color: var(--border);
  background: rgba(255, 255, 255, 0.94);
  color: var(--text);
}

.graph-evidence-strip button.is-selected {
  border-color: var(--accent);
  border-left: 4px solid var(--accent);
  background: rgba(248, 251, 255, 0.98);
  color: var(--accent-hover);
  opacity: 1;
  filter: none;
  box-shadow: 0 0 0 2px rgba(30, 30, 30, 0.18), 0 10px 20px rgba(30, 30, 30, 0.1);
}

.graph-evidence-strip button.is-related {
  border-color: rgba(30, 30, 30, 0.24);
  border-left-color: var(--accent);
  background: var(--accent-wash);
  opacity: 1;
  filter: none;
}

.collection-meta-grid,
.admin-status-grid,
.topic-graph-card-grid,
.result-collection-grid,
.result-group-grid,
.book-grid,
.related-grid,
.search-graph-grid,
.graph-edge-list,
.ai-evidence-grid,
.report-tool-grid {
  gap: var(--card-gap);
}

.topic-quickbar,
.top-tabbar,
.topic-graph-entry-section,
.collection-overview-section,
.graph-hub-section,
.graph-book-tab-section,
.research-ai-section,
.admin-review-section,
.collection-graph-section,
.reader-section,
.knowledge-section,
.related-section,
.detail-section,
.detail-management-section {
  margin-bottom: var(--section-gap);
}

/* Step 33: keep the main entry as a light library-style material search portal. */
:host {
  --main-tab-bg: #FFFFFF;
  --main-tab-border: var(--border);
  --main-tab-active-bg: var(--accent-wash);
  --main-tab-active-text: var(--accent);
  --main-tab-active-border: var(--border-soft);
  background: var(--page-bg);
}

.library-page {
  padding-top: 20px;
}

.library-hero {
  align-items: center;
  padding: 0 0 10px;
}

.eyebrow {
  margin-bottom: 6px;
  color: var(--muted);
  font-size: 12px;
  font-weight: 750;
}

h1 {
  color: var(--text);
  font-size: 34px;
  line-height: 1.16;
}

.library-subtitle {
  max-width: 560px;
  margin-top: 7px;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.45;
}

.library-count {
  display: inline-flex;
  min-width: 0;
  align-items: baseline;
  gap: 5px;
  padding: 8px 10px;
  border-color: var(--main-tab-border);
  background: #FFFFFF;
  box-shadow: none;
  color: var(--muted);
  text-align: left;
}

.library-count strong {
  display: inline;
  color: var(--text);
  font-size: 16px;
  line-height: 1;
}

.library-count span {
  color: var(--muted);
  font-size: 12px;
  line-height: 1.2;
}

.auth-toolbar {
  min-width: 0;
}

.auth-profile {
  box-shadow: none;
}

.auth-link {
  min-height: 34px;
  border-color: var(--main-tab-border);
  background: #FFFFFF;
  font-size: 12px;
}

.top-tabbar {
  gap: 6px;
  margin-bottom: 10px;
  padding: 6px;
  border-color: var(--main-tab-border);
  background: var(--main-tab-bg);
  box-shadow: none;
}

.top-tabbar button {
  min-height: 38px;
  border-color: var(--main-tab-border);
  background: var(--main-tab-bg);
  color: #425466;
  font-size: 13px;
  font-weight: 750;
  box-shadow: none;
}

.top-tabbar button:not(.is-active):hover,
.top-tabbar button:not(.is-active):focus-visible {
  border-color: #D6DDE8;
  background: #FAFAFA;
  color: var(--text);
  box-shadow: none;
}

.top-tabbar button.is-active,
.top-tabbar button.is-active:hover,
.top-tabbar button.is-active:focus-visible {
  border-color: var(--main-tab-active-border);
  background: var(--main-tab-active-bg);
  color: var(--main-tab-active-text);
  box-shadow: none;
}

.top-tabbar button:focus-visible {
  box-shadow: 0 0 0 2px rgba(31, 31, 31, 0.14);
}

.shelf {
  margin-top: 6px;
  padding-top: 10px;
}

.control-panel,
.topic-graph-entry-section,
.collection-overview-section,
.graph-hub-section,
.graph-book-tab-section,
.research-ai-section,
.admin-review-section,
.collection-graph-section {
  box-shadow: none;
}

.collection-meta-grid article,
.admin-status-grid article {
  background: #FAFAFA;
  box-shadow: none;
}

.admin-status-grid strong {
  font-size: 18px;
}

@media (max-width: 760px) {
  .library-page {
    padding-top: 18px;
  }
  .library-hero {
    gap: 10px;
    padding-bottom: 8px;
  }
  h1 {
    font-size: 28px;
  }
  .library-count {
    width: auto;
    align-self: flex-start;
  }
  .auth-toolbar {
    width: 100%;
    justify-content: flex-start;
  }
  .auth-profile {
    text-align: left;
  }
  .top-tabbar {
    gap: 6px;
    margin-bottom: 8px;
  }
}
/* Step 34: keep book cards light and focused on bibliographic essentials. */
.shelf {
  grid-template-columns: repeat(auto-fill, minmax(176px, 1fr));
  gap: 22px 20px;
  margin-top: 8px;
  padding-top: 12px;
}

.book-card {
  gap: 11px;
  padding: 12px;
  border: 1px solid #E2E2E2;
  background: #FFFFFF;
  box-shadow: none;
  transform: none;
}

.book-card:hover {
  border-color: #C9D8EA;
  background: #FFFFFF;
  box-shadow: 0 4px 12px rgba(31, 41, 51, 0.06);
  transform: translateY(-1px);
}

.cover-frame {
  border: 1px solid #E7E7E7;
  background: #F3F6FA;
  box-shadow: none;
}

.cover-frame.is-placeholder {
  border-color: #E2E2E2;
  background: var(--page-bg);
  box-shadow: inset 0 0 0 1px #E2E2E2;
}

.book-title {
  min-height: 39px;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.38;
}

.book-author {
  margin-top: 6px;
  color: #4F5F6F;
  font-size: 12px;
  font-weight: 650;
}

.book-detail {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 7px;
  color: var(--muted);
  font-size: 11px;
}

.book-detail span {
  max-width: 100%;
  overflow: hidden;
  padding: 2px 6px;
  border: 1px solid #E6EAF0;
  border-radius: 999px;
  background: #FAFAFA;
  color: var(--muted);
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tag-strip {
  max-height: 56px;
  margin-top: 10px;
  gap: 6px;
}

.tag-strip span {
  padding: 4px 7px;
  border: 1px solid #D8E7F6;
  border-radius: 999px;
  background: #FAFAFA;
  color: #35617E;
  font-size: 11px;
  font-weight: 700;
}

.tag-strip span:nth-child(even) {
  border-color: #E5E7EA;
  background: #F6F7F9;
  color: #536270;
}

.tag-strip span[role=button]:hover,
.tag-strip span[role=button].is-active {
  border-color: var(--border-soft);
  background: var(--accent-wash);
  color: var(--accent);
}

.graph-node {
  box-sizing: border-box;
  align-items: center;
  border-left-width: 1px;
  text-align: center;
}

.graph-node.shape-material-card,
.graph-node.shape-small-card {
  align-items: flex-start;
  border-left-width: 4px;
  text-align: left;
}

.graph-node.shape-material-card {
  width: 182px;
  min-height: 86px;
  padding: 10px 12px;
  border-radius: 8px;
}

.graph-node.shape-small-card {
  width: 132px;
  min-height: 58px;
  padding: 8px 9px;
  border-radius: 8px;
}

.graph-node.shape-circle {
  width: 100px;
  height: 100px;
  min-height: 0;
  padding: 14px 12px;
  border-radius: 50%;
  gap: 4px;
  overflow: hidden;
}

.graph-node.shape-capsule {
  width: 126px;
  height: 58px;
  min-height: 0;
  padding: 9px 13px;
  border-radius: 999px;
  gap: 3px;
  overflow: hidden;
}

.graph-node.shape-compact {
  width: 84px;
  height: 42px;
  min-height: 0;
  padding: 5px 8px;
  border-radius: 999px;
  gap: 2px;
  overflow: hidden;
  box-shadow: 0 2px 7px rgba(37, 50, 47, 0.06);
}

.graph-node.shape-compact::before {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--node-accent);
  content: "";
}

.graph-central-node.shape-material-card {
  width: 206px;
  min-height: 116px;
  border-width: 1px;
  border-left-width: 5px;
  box-shadow: 0 18px 34px rgba(31, 41, 51, 0.14);
}

.graph-central-node.shape-circle,
.graph-node.shape-central-topic,
.collection-central-node {
  width: 166px;
  height: 166px;
  min-height: 0;
  padding: 20px 18px;
  border-width: 2px;
  border-radius: 50%;
  border-left-width: 2px;
  align-items: center;
  text-align: center;
  box-shadow: 0 20px 40px rgba(36, 79, 224, 0.22);
}

.collection-resource-node.shape-material-card,
.collection-resource-node.shape-small-card {
  width: 144px;
  min-height: 70px;
  padding: 9px 10px;
}

.collection-tag-node.shape-circle {
  width: 112px;
  height: 112px;
}

.collection-entity-node.shape-circle {
  width: 104px;
  height: 104px;
}

.collection-entity-node.shape-capsule {
  width: 126px;
  height: 58px;
  min-height: 0;
}

.collection-outer-node.shape-compact {
  width: 76px;
  height: 38px;
}

.graph-node-title {
  max-width: 100%;
}

.graph-node.shape-circle .graph-node-title,
.graph-node.shape-capsule .graph-node-title,
.graph-node.shape-compact .graph-node-title,
.collection-central-node .graph-node-title {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: clip;
  -webkit-box-orient: vertical;
  white-space: normal;
}

.graph-node.shape-circle .graph-node-title {
  -webkit-line-clamp: 3;
  font-size: 12px;
  line-height: 1.18;
}

.graph-node.shape-capsule .graph-node-title {
  -webkit-line-clamp: 2;
  font-size: 11.5px;
  line-height: 1.18;
}

.graph-node.shape-compact .graph-node-title {
  -webkit-line-clamp: 1;
  font-size: 10px;
  line-height: 1.1;
}

.graph-central-node.shape-material-card .graph-node-title {
  font-size: 14px;
  line-height: 1.25;
}

.collection-resource-node.shape-material-card .graph-node-title,
.collection-resource-node.shape-small-card .graph-node-title {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  font-size: 11.5px;
  line-height: 1.18;
  white-space: normal;
}

.collection-central-node .graph-node-title {
  -webkit-line-clamp: 4;
  font-size: 15px;
  line-height: 1.18;
}

.graph-node small {
  order: -1;
  max-width: 100%;
}

.graph-node.shape-circle small,
.graph-node.shape-capsule small,
.graph-node.shape-compact small,
.collection-central-node small {
  justify-content: center;
}

.graph-node.shape-circle small,
.graph-node.shape-capsule small {
  padding: 1px 6px;
  font-size: 9px;
  line-height: 1.1;
}

.graph-node.shape-compact small {
  padding: 0;
  background: transparent;
  font-size: 8px;
  line-height: 1;
}

.graph-node.shape-compact .graph-node-icon {
  display: none;
}

.graph-node em {
  font-size: 9.5px;
}

.graph-node.shape-circle em,
.graph-node.shape-capsule em,
.collection-central-node em {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: normal;
}

.graph-node.shape-compact em {
  display: none;
}

.graph-node.type-자료,
.graph-node.type-관련-자료,
.collection-resource-node {
  --node-accent: var(--text);
  --node-border: var(--text);
  --node-bg: #FFFFFF;
  --node-text: var(--text);
  --node-muted: #59636E;
}

.graph-node.type-주제,
.collection-tag-node {
  --node-accent: var(--accent);
  --node-border: var(--accent);
  --node-bg: #DDEFFF;
  --node-text: var(--accent-hover);
  --node-muted: var(--accent-hover);
}

.collection-central-node,
.graph-node.shape-central-topic {
  --node-accent: var(--accent-hover);
  --node-border: var(--accent-hover);
  --node-bg: var(--accent);
  --node-text: #FFFFFF;
  --node-muted: rgba(255, 255, 255, 0.86);
  --node-icon-bg: #FFFFFF;
  --node-icon-color: var(--accent-hover);
  --node-type-bg: rgba(255, 255, 255, 0.16);
}

.graph-node.type-장소 {
  --node-accent: var(--design-olive);
  --node-border: rgba(94, 102, 118, 0.34);
  --node-bg: rgba(94, 102, 118, 0.1);
  --node-text: var(--design-source);
  --node-muted: var(--design-source);
}

.graph-node.type-기관,
.graph-node.type-인물 {
  --node-accent: var(--muted);
  --node-border: #9DB2C7;
  --node-bg: #F1F5F8;
  --node-text: #34485E;
  --node-muted: #34485E;
}

.graph-node.type-사건,
.graph-node.type-시대 {
  --node-accent: #A96716;
  --node-border: #D8D8D8;
  --node-bg: #F2F5FA;
  --node-text: #8C5110;
  --node-muted: #8C5110;
}

.graph-node.type-문헌-법령,
.graph-node.type-개념 {
  --node-accent: var(--design-source);
  --node-border: #AFC1D8;
  --node-bg: #F1F5FB;
  --node-text: #3E587F;
  --node-muted: #3E587F;
}

.graph-node.type-주장,
.graph-node.type-쟁점,
.graph-node.type-반박,
.graph-node.type-쟁점-반박 {
  --node-accent: #953E40;
  --node-border: #D69A9C;
  --node-bg: #FFF1F1;
  --node-text: #953E40;
  --node-muted: #953E40;
}

.graph-node.type-근거-후보,
.collection-outer-node {
  --node-accent: #8D99A6;
  --node-border: #D5DDE5;
  --node-bg: #FFFFFF;
  --node-text: #5B6673;
  --node-muted: var(--design-text-muted);
  --node-icon-color: var(--design-text-muted);
}

.graph-legend {
  margin-top: 8px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.76);
  color: var(--muted);
}

.graph-legend summary {
  display: flex;
  min-height: 30px;
  align-items: center;
  gap: 8px;
  padding: 0 10px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0;
  list-style: none;
}

.graph-legend summary::-webkit-details-marker {
  display: none;
}

.graph-legend summary::before {
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-left: 5px solid var(--faint);
  content: "";
  transition: transform 140ms ease;
}

.graph-legend[open] summary::before {
  transform: rotate(90deg);
}

.graph-legend summary span {
  color: var(--graph-text);
}

.graph-legend summary em {
  margin-left: auto;
  color: var(--faint);
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
}

.graph-legend-body {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(250px, 0.9fr);
  gap: 8px 14px;
  padding: 0 10px 10px;
}

.graph-legend-group {
  display: flex;
  min-width: 0;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 10px;
}

.graph-legend-group strong {
  color: var(--graph-text);
  font-size: 10px;
  font-weight: 900;
}

.graph-legend-item {
  display: inline-flex;
  min-height: 18px;
  align-items: center;
  gap: 5px;
  color: var(--muted);
  font-size: 10px;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
}

.graph-legend-dot {
  width: 8px;
  height: 8px;
  flex: 0 0 auto;
  border: 1px solid currentColor;
  border-radius: 50%;
  background: currentColor;
}

.graph-legend-dot.type-material {
  color: var(--text);
}

.graph-legend-dot.type-central-topic,
.graph-legend-dot.type-topic {
  color: var(--accent);
}

.graph-legend-dot.type-place {
  color: var(--design-olive);
}

.graph-legend-dot.type-event {
  color: #A96716;
}

.graph-legend-dot.type-actor {
  color: var(--muted);
}

.graph-legend-dot.type-concept {
  color: var(--design-source);
}

.graph-legend-dot.type-issue {
  color: #953E40;
}

.graph-legend-dot.type-evidence {
  color: #8D99A6;
}

.graph-legend-line {
  width: 24px;
  height: 0;
  flex: 0 0 auto;
  border-top: 2px solid #B8C5D3;
}

.graph-legend-line.status-reviewed {
  border-color: #B8C5D3;
}

.graph-legend-line.status-metadata,
.graph-legend-line.status-pending {
  border-color: #AFC1D8;
  border-top-style: dashed;
}

.graph-legend-line.status-complete {
  border-color: #B8C5D3;
}

.graph-legend-line.status-selected {
  border-color: var(--accent);
  border-top-width: 3px;
}

@media (max-width: 900px) {
  .graph-legend-body {
    grid-template-columns: 1fr;
  }
}
.graph-evidence-strip {
  width: min(178px, 100% - 24px);
  gap: 6px;
}

.graph-evidence-strip button {
  position: relative;
  min-height: 34px;
  padding: 6px 8px 6px 20px;
  border-left-width: 1px;
  border-radius: 999px;
  box-shadow: 0 2px 7px rgba(37, 50, 47, 0.05);
}

.graph-evidence-strip button::before {
  position: absolute;
  top: 50%;
  left: 9px;
  width: 6px;
  height: 6px;
  transform: translateY(-50%);
  border-radius: 50%;
  background: #8D99A6;
  content: "";
}

.graph-evidence-strip strong {
  font-size: 10px;
  line-height: 1.1;
}

.graph-evidence-strip span {
  margin-top: 1px;
  font-size: 8.5px;
}

@media (max-width: 900px) {
  .graph-node.shape-circle {
    width: 104px;
    height: 104px;
    padding: 12px 10px;
  }
  .graph-node.shape-capsule {
    width: 118px;
    min-height: 52px;
  }
  .graph-node.shape-material-card {
    width: 150px;
  }
  .graph-node.shape-small-card {
    width: 120px;
  }
  .graph-central-node.shape-material-card {
    width: 166px;
    min-height: 102px;
  }
  .collection-central-node,
  .graph-node.shape-central-topic {
    width: 140px;
    height: 140px;
    min-height: 0;
  }
}
@media (max-width: 760px) {
  .book-graph-layout,
  .collection-graph-layout {
    overflow-x: auto;
    padding-bottom: 8px;
    overscroll-behavior-x: contain;
  }
  .graph-canvas {
    min-width: 760px;
  }
  .collection-graph-canvas {
    min-width: 820px;
  }
  .graph-node.shape-circle {
    width: 94px;
    height: 94px;
    padding: 10px 8px;
  }
  .graph-node.shape-circle .graph-node-title {
    -webkit-line-clamp: 2;
    font-size: 10.5px;
  }
  .graph-node.shape-capsule {
    width: 108px;
    min-height: 48px;
    padding: 7px 10px;
  }
  .collection-entity-node.shape-capsule {
    width: 96px;
  }
  .graph-node.shape-compact {
    width: 68px;
    height: 34px;
  }
  .graph-node.shape-small-card {
    width: 104px;
    min-height: 50px;
  }
  .graph-central-node.shape-material-card {
    width: 142px;
    min-height: 88px;
  }
  .collection-central-node,
  .graph-node.shape-central-topic {
    width: 118px;
    height: 118px;
    min-height: 0;
    padding: 14px 12px;
  }
  .collection-central-node .graph-node-title {
    -webkit-line-clamp: 3;
    font-size: 12px;
  }
}
@media (max-width: 760px) {
  .shelf {
    grid-template-columns: repeat(auto-fill, minmax(148px, 1fr));
    gap: 16px;
  }
  .book-card {
    padding: 10px;
  }
  .book-title {
    font-size: 13px;
  }
  .tag-strip {
    max-height: 50px;
  }
}
/* Step 42: browser review polish for the library UI and stronger knowledge graph. */
:host {
  --graph-place-accent: var(--design-olive);
  --graph-place-border: rgba(94, 102, 118, 0.34);
  --graph-place-bg: rgba(94, 102, 118, 0.1);
  --graph-place-text: var(--accent);
  --graph-line-default: rgba(30, 30, 30, 0.26);
  --graph-line-muted: rgba(31, 31, 31, 0.16);
  --graph-line-selected: var(--accent);
  --graph-panel-bg: rgba(255, 255, 255, 0.92);
  --graph-panel-border: var(--border);
}

.library-page {
  background: transparent;
}

.book-card {
  border-color: #E0E7EF;
}

.book-card:hover,
.book-card:focus-visible {
  border-color: #B7CCE4;
  box-shadow: 0 8px 18px rgba(31, 41, 51, 0.07);
}

.tag-strip span {
  border-color: #DCEAF8;
  background: #F3F8FE;
  color: #365F84;
}

.graph-canvas,
.collection-graph-canvas {
  border-color: var(--border);
  background-color: #FFFFFF;
  background-image: none;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.9), 0 10px 24px rgba(31, 41, 51, 0.06);
}

.graph-canvas {
  min-height: 800px;
  background-image: radial-gradient(ellipse at 50% 50%, transparent 0 28%, rgba(30, 30, 30, 0.15) 28.1%, rgba(30, 30, 30, 0.15) 28.45%, transparent 28.7%), radial-gradient(ellipse at 50% 50%, transparent 0 40%, rgba(127, 157, 187, 0.19) 40.1%, rgba(127, 157, 187, 0.19) 40.45%, transparent 40.75%), radial-gradient(ellipse at 50% 50%, transparent 0 50%, rgba(127, 157, 187, 0.13) 50.1%, rgba(127, 157, 187, 0.13) 50.45%, transparent 50.75%), linear-gradient(rgba(196, 211, 228, 0.26) 1px, transparent 1px), linear-gradient(90deg, rgba(196, 211, 228, 0.26) 1px, transparent 1px);
  background-size: 100% 100%, 100% 100%, 100% 100%, 28px 28px, 28px 28px;
}

.graph-canvas.is-low-density {
  min-height: 620px;
}

.collection-graph-canvas {
  min-height: 980px;
  background-image: radial-gradient(ellipse at 50% 50%, transparent 0 28%, rgba(31, 31, 31, 0.16) 28.1%, rgba(31, 31, 31, 0.16) 28.45%, transparent 28.7%), radial-gradient(ellipse at 50% 50%, transparent 0 40%, rgba(127, 157, 187, 0.2) 40.1%, rgba(127, 157, 187, 0.2) 40.45%, transparent 40.75%), radial-gradient(ellipse at 50% 50%, transparent 0 50%, rgba(127, 157, 187, 0.14) 50.1%, rgba(127, 157, 187, 0.14) 50.45%, transparent 50.75%);
  background-size: 100% 100%;
}

.graph-node {
  border-color: var(--node-border);
  background: var(--node-bg);
  color: var(--node-text);
  box-shadow: 0 7px 18px rgba(31, 41, 51, 0.08);
}

.graph-node:hover:not(.is-dimmed) {
  box-shadow: 0 12px 24px rgba(31, 41, 51, 0.12);
}

.graph-node.is-selected {
  border-color: var(--graph-line-selected);
  border-left-color: var(--graph-line-selected);
  box-shadow: 0 0 0 3px rgba(30, 30, 30, 0.18), 0 16px 30px rgba(31, 31, 31, 0.14);
}

.graph-node.is-related {
  border-color: var(--graph-line-selected);
  box-shadow: 0 0 0 2px rgba(30, 30, 30, 0.11), 0 10px 22px rgba(31, 41, 51, 0.1);
}

.graph-node.is-dimmed,
.graph-edge-button.is-dimmed {
  opacity: 0.28;
  filter: saturate(0.72);
}

.graph-node.type-장소 {
  --node-accent: var(--graph-place-accent);
  --node-border: var(--graph-place-border);
  --node-bg: var(--graph-place-bg);
  --node-text: var(--graph-place-text);
  --node-muted: var(--graph-place-text);
}

.graph-node.type-주제,
.collection-tag-node {
  --node-bg: #E4F2FF;
}

.collection-central-node,
.graph-node.shape-central-topic {
  width: 170px;
  height: 170px;
  --node-accent: var(--accent);
  --node-border: var(--accent);
  --node-bg: var(--accent);
  box-shadow: 0 22px 44px rgba(30, 30, 30, 0.2);
}

.collection-central-node .graph-node-title {
  font-size: 16px;
  line-height: 1.18;
}

.graph-node.shape-circle {
  width: 88px;
  height: 88px;
  padding: 12px 10px;
}

.graph-node.shape-capsule {
  width: 116px;
  height: 54px;
  padding: 8px 11px;
}

.collection-tag-node.shape-circle {
  width: 96px;
  height: 96px;
}

.collection-entity-node.shape-circle {
  width: 88px;
  height: 88px;
}

.graph-link {
  stroke: var(--graph-line-default);
  stroke-width: 1.55px;
  opacity: 0.78;
}

.graph-link.is-reviewed,
.graph-link.is-evidence-complete {
  stroke: #6F93B8;
  stroke-width: 1.6px;
  opacity: 0.82;
}

.graph-link.is-metadata-recommendation,
.graph-link.is-pending-review,
.graph-link.is-pending-evidence {
  stroke: var(--graph-line-muted);
  stroke-dasharray: 4 5;
  stroke-width: 1.45px;
  opacity: 0.68;
}

.graph-link.is-direct,
.graph-link.is-hovered {
  stroke: var(--graph-line-selected);
  stroke-dasharray: none;
  stroke-width: 2.15px;
  opacity: 0.95;
}

.graph-link.is-direct.is-metadata-recommendation,
.graph-link.is-direct.is-pending-review,
.graph-link.is-direct.is-pending-evidence,
.graph-link.is-hovered.is-metadata-recommendation,
.graph-link.is-hovered.is-pending-review,
.graph-link.is-hovered.is-pending-evidence {
  stroke: var(--graph-line-selected);
  stroke-dasharray: 4 5;
  stroke-width: 1.9px;
  opacity: 0.88;
}

.graph-link.is-selected,
.graph-link.is-pending-evidence.is-selected {
  stroke: var(--graph-line-selected);
  stroke-dasharray: none;
  stroke-width: 2.8px;
  opacity: 1;
}

.graph-link.is-dimmed {
  stroke: #DDE6F0;
  stroke-width: 1px;
  opacity: 0.16;
}

.graph-link-label {
  border-color: #C9D8EA;
  background: rgba(255, 255, 255, 0.96);
  color: var(--accent);
}

.graph-link-label.is-selected,
.graph-link-label.is-direct,
.graph-link-label.is-hovered {
  border-color: var(--border-soft);
  color: var(--accent);
}

.graph-inspector {
  border-color: var(--graph-panel-border);
  background: var(--graph-panel-bg);
  box-shadow: none;
}

.graph-inspector-kind,
.graph-inspector-tags span,
.node-evidence-list span,
.graph-inspector-disclosure summary,
.graph-edge-button strong {
  border-color: #D8E7F6;
  background: var(--accent-wash);
  color: var(--accent-hover);
}

.graph-inspector-meta,
.graph-inspector-metrics {
  border-top-color: var(--border);
}

.graph-inspector-meta div,
.graph-inspector-metrics div,
.graph-evidence-meta div {
  border-bottom-color: var(--border);
}

.graph-edge-button {
  border-color: var(--border);
  border-left-color: var(--graph-line-default);
  background: #FFFFFF;
}

.graph-edge-button.is-selected,
.graph-edge-button.is-related {
  border-color: var(--border-soft);
  border-left-color: var(--graph-line-selected);
  background: var(--accent-wash);
}

.graph-legend {
  border-color: var(--border);
  background: #FFFFFF;
}

.graph-legend-dot.type-place {
  color: var(--graph-place-accent);
}

.graph-legend-line.status-reviewed,
.graph-legend-line.status-complete {
  border-color: #6F93B8;
}

.graph-legend-line.status-metadata,
.graph-legend-line.status-pending {
  border-color: var(--graph-line-muted);
}

.graph-legend-line.status-selected {
  border-color: var(--graph-line-selected);
}

@media (max-width: 900px) {
  .collection-central-node,
  .graph-node.shape-central-topic {
    width: 148px;
    height: 148px;
  }
  .collection-tag-node.shape-circle {
    width: 106px;
    height: 106px;
  }
}
@media (max-width: 760px) {
  .graph-canvas {
    min-width: 780px;
    min-height: 720px;
  }
  .collection-graph-canvas {
    min-width: 860px;
    min-height: 860px;
  }
  .collection-central-node,
  .graph-node.shape-central-topic {
    width: 126px;
    height: 126px;
  }
}
/* Step 44: keep material processing status compact and secondary to bibliography. */
.detail-management-section {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid #E6EAF0;
}

.detail-management-section .management-heading {
  align-items: baseline;
  margin-bottom: 8px;
}

.detail-management-section .management-heading h3 {
  color: #34485E;
  font-size: 16px;
  font-weight: 850;
  line-height: 1.35;
}

.detail-status-grid {
  gap: 8px;
}

.detail-status-grid-primary {
  max-width: 960px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.internal-management-group {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #DDE6F0;
}

.internal-management-label {
  margin: 0 0 8px;
  color: var(--muted);
  font-size: 12px;
  font-weight: 900;
  line-height: 1.3;
}

.internal-management-grid {
  max-width: 820px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.detail-status-grid .detail-status-card {
  min-height: 72px;
  padding: 10px 12px;
  border-color: #E1E7EF;
  border-radius: 7px;
  background: #FFFFFF;
  box-shadow: none;
}

.internal-management-grid .detail-status-card {
  background: #FAFBFD;
}

.detail-status-grid .status-label {
  color: #6B7785;
  font-size: 11px;
  font-weight: 850;
}

.detail-status-grid strong {
  margin-top: 4px;
  color: #25323D;
  font-size: 13.5px;
  font-weight: 900;
}

.detail-status-grid small {
  margin-top: 4px;
  color: #8895A3;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.35;
}

.detail-status-grid small a {
  color: var(--muted);
  font-weight: 800;
}

@media (max-width: 1180px) {
  .detail-status-grid-primary,
  .internal-management-grid {
    max-width: none;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 900px) {
  .detail-status-grid-primary,
  .internal-management-grid {
    grid-template-columns: 1fr;
  }
}
/* Step 45: place detail actions directly below bibliography with clear primary actions. */
.detail-page .detail-action-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 20px;
  padding-top: 2px;
}

.detail-page .detail-action-group .source-link,
.detail-page .detail-action-group .source-action-button {
  justify-content: center;
  min-height: 46px;
  min-width: 154px;
  padding: 0 18px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: #FFFFFF;
  color: #334256;
  box-shadow: none;
  font-size: 15px;
  font-weight: 760;
  line-height: 1.22;
}

.detail-page .detail-action-group .detail-action-primary {
  min-height: 48px;
  min-width: 176px;
  padding: 0 20px;
  border-color: var(--accent);
  background: var(--accent);
  color: #FFFFFF;
  box-shadow: 0 8px 18px rgba(31, 31, 31, 0.16);
  font-weight: 850;
}

.detail-page .detail-action-group .primary-graph-action {
  min-width: 220px;
}

.detail-page .detail-action-group .detail-action-default:hover,
.detail-page .detail-action-group .detail-action-default:focus-visible {
  border-color: var(--accent);
  background: var(--accent-wash);
  color: var(--accent);
}

.detail-page .detail-action-group .detail-action-primary:hover,
.detail-page .detail-action-group .detail-action-primary:focus-visible {
  border-color: var(--accent-hover);
  background: var(--accent-hover);
  color: #FFFFFF;
  box-shadow: 0 9px 20px rgba(30, 30, 30, 0.18);
}

.detail-page .detail-action-group .secondary {
  color: var(--muted);
}

.detail-page .detail-action-group .detail-action-missing {
  min-height: 40px;
  padding: 0 12px;
  border: 1px dashed var(--border-soft);
  background: #FAFAFA;
  color: #718096;
  font-size: 13px;
  font-weight: 700;
}

.detail-page .graph-entry-panel {
  margin-top: 14px;
  border-color: #DDE8F5;
  background: #FAFAFA;
}

@media (max-width: 900px) {
  .detail-page .detail-action-group {
    gap: 10px;
  }
  .detail-page .detail-action-group .source-link,
  .detail-page .detail-action-group .source-action-button {
    flex: 1 1 220px;
    min-width: 0;
  }
}
@media (max-width: 560px) {
  .detail-page .detail-action-group .source-link,
  .detail-page .detail-action-group .source-action-button,
  .detail-page .detail-action-group .detail-action-missing {
    width: 100%;
  }
}
/* Step 49: align the detail bibliography as a cover-left, title-and-fields-right block. */
.detail-page .detail-layout {
  grid-template-columns: minmax(260px, 320px) minmax(0, 1fr);
  gap: 38px;
}

.detail-page .modal-cover {
  max-width: 320px;
}

.detail-page .detail-content {
  padding-right: 0;
}

.detail-page .detail-content h2 {
  max-width: 940px;
  margin: 14px 0 0;
  font-size: 34px;
  line-height: 1.2;
  letter-spacing: 0;
}

.detail-page .bibliographic-list {
  margin-top: 30px;
  padding-top: 0;
  border-top: 1px solid var(--border);
}

.detail-page .bibliographic-list div {
  grid-template-columns: 172px minmax(0, 1fr);
  gap: 26px;
  min-height: 48px;
  padding: 13px 0;
  border-bottom: 1px solid #E4EAF2;
}

.detail-page .bibliographic-list dt {
  color: var(--muted);
  font-size: 14px;
  font-weight: 850;
  line-height: 1.45;
}

.detail-page .bibliographic-list dd {
  color: #25323D;
  font-size: 16px;
  font-weight: 680;
  line-height: 1.58;
}

.detail-summary-strip {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px dashed #DDE6F0;
}

.detail-summary-strip .modal-description {
  margin: 0;
  max-width: 900px;
  font-size: 15px;
  line-height: 1.6;
}

.detail-summary-strip .detail-primary-tags {
  margin: 12px 0 0;
}

@media (max-width: 900px) {
  .detail-page .detail-layout {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  .detail-page .modal-cover {
    max-width: 260px;
  }
  .detail-page .bibliographic-list div {
    grid-template-columns: 150px minmax(0, 1fr);
    gap: 18px;
  }
}
@media (max-width: 560px) {
  .detail-page .detail-content h2 {
    font-size: 28px;
  }
  .detail-page .bibliographic-list {
    margin-top: 24px;
  }
  .detail-page .bibliographic-list div {
    grid-template-columns: 118px minmax(0, 1fr);
    gap: 12px;
    padding: 11px 0;
  }
  .detail-page .bibliographic-list dt {
    font-size: 13px;
  }
  .detail-page .bibliographic-list dd {
    font-size: 14.5px;
  }
}
/* Step 47: make knowledge graph node types distinguishable by label, color, border, and shape. */
.graph-node {
  border-width: 2px;
  border-left-width: 2px;
  border-color: var(--node-border);
  background: var(--node-bg);
  color: var(--node-text);
}

.graph-node.shape-material-card,
.graph-node.shape-small-card {
  border-left-width: 6px;
}

.graph-node.shape-material-card {
  width: 190px;
  min-height: 92px;
  padding: 12px 13px;
  border-radius: 8px;
}

.graph-node.shape-small-card {
  width: 150px;
  min-height: 68px;
  padding: 10px 11px;
  border-radius: 8px;
}

.graph-central-node.shape-material-card {
  width: 222px;
  min-height: 124px;
  border-width: 2px;
  border-left-width: 7px;
  border-radius: 8px;
}

.graph-node.shape-circle {
  width: 106px;
  height: 106px;
  padding: 14px 12px;
  border-radius: 50%;
}

.graph-node.shape-capsule {
  width: 136px;
  height: 64px;
  padding: 10px 14px;
  border-radius: 999px;
}

.graph-node.shape-compact {
  width: 78px;
  height: 42px;
  padding: 5px 7px;
  border-width: 1px;
  border-radius: 999px;
  box-shadow: 0 2px 8px rgba(31, 41, 51, 0.08);
}

.graph-node.shape-compact::before {
  width: 8px;
  height: 8px;
  background: var(--node-accent);
}

.collection-central-node,
.graph-node.shape-central-topic {
  width: 176px;
  height: 176px;
  padding: 22px 18px;
  border-width: 3px;
  border-left-width: 3px;
  border-radius: 50%;
}

.collection-resource-node.shape-material-card,
.collection-resource-node.shape-small-card {
  width: 156px;
  min-height: 74px;
}

.collection-tag-node.shape-circle {
  width: 112px;
  height: 112px;
}

.collection-entity-node.shape-circle {
  width: 106px;
  height: 106px;
}

.collection-entity-node.shape-capsule {
  width: 138px;
  height: 64px;
}

.collection-outer-node.shape-compact {
  width: 78px;
  height: 42px;
}

.graph-node-title {
  color: var(--node-text);
  font-size: 14.5px;
  font-weight: 920;
  line-height: 1.24;
}

.graph-node.shape-circle .graph-node-title {
  -webkit-line-clamp: 3;
  font-size: 13.2px;
  line-height: 1.18;
}

.graph-node.shape-capsule .graph-node-title {
  -webkit-line-clamp: 2;
  font-size: 12.8px;
  line-height: 1.18;
}

.graph-node.shape-compact .graph-node-title {
  font-size: 10.5px;
}

.graph-central-node.shape-material-card .graph-node-title {
  font-size: 15.5px;
  line-height: 1.24;
}

.collection-central-node .graph-node-title,
.graph-node.shape-central-topic .graph-node-title {
  font-size: 16.5px;
  line-height: 1.16;
}

.collection-resource-node.shape-material-card .graph-node-title,
.collection-resource-node.shape-small-card .graph-node-title {
  font-size: 12.5px;
  line-height: 1.18;
}

.graph-node .graph-node-type {
  padding: 2px 7px;
  border: 1px solid var(--node-type-border, var(--node-border));
  background: var(--node-type-bg, rgba(255, 255, 255, 0.84));
  color: var(--node-muted);
  font-size: 10.5px;
  font-weight: 920;
  letter-spacing: 0;
}

.graph-node.shape-circle .graph-node-type,
.graph-node.shape-capsule .graph-node-type {
  font-size: 9.8px;
}

.graph-node.shape-compact .graph-node-type {
  padding: 1px 5px;
  border-color: var(--node-type-border, var(--node-border));
  background: var(--node-type-bg, #FFFFFF);
  font-size: 8.8px;
}

.graph-node-icon {
  display: none;
}

.graph-node em {
  color: var(--node-muted);
  font-size: 10px;
  font-weight: 760;
}

.graph-node.type-자료 {
  --node-accent: var(--design-source);
  --node-border: var(--design-source);
  --node-bg: #FFFFFF;
  --node-text: var(--text);
  --node-muted: var(--design-source);
  --node-type-bg: var(--accent-wash);
  --node-type-border: #A9C6F5;
}

.graph-central-node.type-자료 {
  --node-accent: var(--design-source);
  --node-border: var(--design-source);
  --node-bg: #FFFFFF;
  --node-text: var(--text);
  --node-muted: var(--design-source);
  box-shadow: 0 18px 36px rgba(30, 30, 30, 0.18);
}

.graph-node.type-관련-자료,
.collection-resource-node {
  --node-accent: var(--design-text-muted);
  --node-border: #9AAABD;
  --node-bg: #FFFFFF;
  --node-text: #263544;
  --node-muted: #5B6674;
  --node-type-bg: #F4F7FA;
  --node-type-border: #D3DCE6;
}

.graph-node.type-주제,
.collection-tag-node {
  --node-accent: var(--accent);
  --node-border: var(--accent);
  --node-bg: rgba(94, 102, 118, 0.1);
  --node-text: var(--accent-hover);
  --node-muted: var(--accent-hover);
  --node-type-bg: #FFFFFF;
  --node-type-border: #A9C9FF;
}

.collection-central-node,
.graph-node.shape-central-topic {
  --node-accent: var(--design-source);
  --node-border: var(--design-source);
  --node-bg: var(--accent);
  --node-text: #FFFFFF;
  --node-muted: rgba(255, 255, 255, 0.9);
  --node-type-bg: rgba(255, 255, 255, 0.16);
  --node-type-border: rgba(255, 255, 255, 0.34);
  box-shadow: 0 22px 44px rgba(30, 30, 30, 0.2);
}

.graph-node.type-장소 {
  --node-accent: var(--design-olive);
  --node-border: var(--design-olive);
  --node-bg: rgba(94, 102, 118, 0.1);
  --node-text: var(--design-olive);
  --node-muted: var(--design-olive);
  --node-type-bg: #FFFFFF;
  --node-type-border: #A9DCF0;
}

.graph-node.type-사건,
.graph-node.type-시대 {
  --node-accent: #5E6676;
  --node-border: #BDBDBD;
  --node-bg: #EFF3F7;
  --node-text: #4F5662;
  --node-muted: #4F5662;
  --node-type-bg: #FFFFFF;
  --node-type-border: #D8D8D8;
}

.graph-node.type-인물,
.graph-node.type-기관 {
  --node-accent: var(--muted);
  --node-border: #61778F;
  --node-bg: #E8EEF5;
  --node-text: #2E4258;
  --node-muted: #2E4258;
  --node-type-bg: #FFFFFF;
  --node-type-border: #BCC9D8;
}

.graph-node.type-개념,
.graph-node.type-문헌-법령 {
  --node-accent: var(--design-text-muted);
  --node-border: #B8C2CE;
  --node-bg: #F5F7FA;
  --node-text: #455365;
  --node-muted: #455365;
  --node-type-bg: #FFFFFF;
  --node-type-border: #D8DEE7;
}

.graph-node.type-주장,
.graph-node.type-쟁점,
.graph-node.type-반박,
.graph-node.type-쟁점-반박 {
  --node-accent: #B33D45;
  --node-border: #C95159;
  --node-bg: #FFE6E8;
  --node-text: #8E2630;
  --node-muted: #8E2630;
  --node-type-bg: #FFFFFF;
  --node-type-border: #E7A6AB;
}

.graph-node.type-근거-후보,
.collection-outer-node {
  --node-accent: var(--design-text-muted);
  --node-border: #C9D2DC;
  --node-bg: #FFFFFF;
  --node-text: #525A66;
  --node-muted: #626B78;
  --node-type-bg: #F6F8FA;
  --node-type-border: #DDE3EA;
}

.graph-legend-dot.type-material {
  width: 14px;
  height: 9px;
  border-radius: 3px;
  background: #FFFFFF;
  color: var(--design-source);
}

.graph-legend-dot.type-related-material {
  width: 14px;
  height: 9px;
  border-radius: 3px;
  background: #FFFFFF;
  color: var(--design-text-muted);
}

.graph-legend-dot.type-central-topic {
  width: 11px;
  height: 11px;
  background: var(--accent);
  color: var(--design-source);
}

.graph-legend-dot.type-topic {
  background: rgba(94, 102, 118, 0.1);
  color: var(--accent);
}

.graph-legend-dot.type-place {
  background: rgba(94, 102, 118, 0.1);
  color: var(--design-olive);
}

.graph-legend-dot.type-event {
  background: #EFF3F7;
  color: #5E6676;
}

.graph-legend-dot.type-actor {
  width: 13px;
  height: 8px;
  border-radius: 999px;
  background: #E8EEF5;
  color: var(--muted);
}

.graph-legend-dot.type-concept {
  background: #F5F7FA;
  color: var(--design-text-muted);
}

.graph-legend-dot.type-issue {
  background: #FFE6E8;
  color: #B33D45;
}

.graph-legend-dot.type-evidence {
  width: 6px;
  height: 6px;
  background: var(--design-text-muted);
  color: var(--design-text-muted);
}

@media (max-width: 900px) {
  .graph-node.shape-circle {
    width: 98px;
    height: 98px;
    padding: 12px 10px;
  }
  .graph-node.shape-capsule {
    width: 124px;
    height: 58px;
  }
  .graph-node.shape-material-card {
    width: 166px;
  }
  .graph-node.shape-small-card {
    width: 132px;
  }
  .collection-central-node,
  .graph-node.shape-central-topic {
    width: 150px;
    height: 150px;
  }
}
@media (max-width: 760px) {
  .graph-node.shape-circle {
    width: 92px;
    height: 92px;
    padding: 10px 8px;
  }
  .graph-node.shape-circle .graph-node-title {
    font-size: 11.2px;
  }
  .graph-node.shape-capsule {
    width: 112px;
    height: 52px;
  }
  .graph-node.shape-material-card {
    width: 146px;
    min-height: 84px;
  }
  .graph-node.shape-small-card {
    width: 116px;
    min-height: 56px;
  }
  .graph-central-node.shape-material-card {
    width: 154px;
    min-height: 96px;
  }
  .collection-central-node,
  .graph-node.shape-central-topic {
    width: 126px;
    height: 126px;
    padding: 14px 12px;
  }
  .collection-central-node .graph-node-title,
  .graph-node.shape-central-topic .graph-node-title {
    font-size: 12.8px;
  }
}
/* Step 48: strengthen knowledge graph text hierarchy. */
.graph-node {
  gap: 6px;
}

.graph-node-title {
  order: 0;
  color: var(--node-text);
  font-size: 16px;
  font-weight: 940;
  line-height: 1.22;
}

.graph-node .graph-node-type {
  order: 1;
  padding: 2px 7px;
  color: var(--node-muted);
  font-size: 12.2px;
  font-weight: 860;
  line-height: 1.1;
}

.graph-node .graph-node-status,
.graph-node em {
  order: 2;
  color: var(--node-muted);
  font-size: 12px;
  font-weight: 650;
  line-height: 1.2;
  opacity: 0.84;
}

.graph-node.shape-material-card {
  width: 210px;
  min-height: 104px;
  padding: 13px 15px;
}

.graph-node.shape-small-card {
  width: 164px;
  min-height: 78px;
  padding: 11px 12px;
}

.graph-central-node.shape-material-card {
  width: 256px;
  min-height: 146px;
  padding: 18px 20px;
}

.graph-central-node.shape-material-card .graph-node-title {
  font-size: 21px;
  line-height: 1.18;
}

.collection-central-node,
.graph-node.shape-central-topic {
  width: 198px;
  height: 198px;
  padding: 24px 20px;
}

.collection-central-node .graph-node-title,
.graph-node.shape-central-topic .graph-node-title {
  font-size: 21px;
  line-height: 1.14;
}

.graph-node.shape-circle {
  width: 122px;
  height: 122px;
  padding: 16px 13px;
}

.graph-node.shape-circle .graph-node-title {
  font-size: 16px;
  line-height: 1.16;
}

.graph-node.shape-capsule {
  width: 152px;
  height: 74px;
  padding: 11px 16px;
}

.graph-node.shape-capsule .graph-node-title {
  font-size: 15px;
  line-height: 1.16;
}

.graph-node.shape-compact {
  width: 98px;
  height: 52px;
  padding: 6px 9px;
}

.graph-node.shape-compact .graph-node-title {
  font-size: 13px;
  line-height: 1.1;
}

.graph-node.shape-compact .graph-node-type {
  font-size: 12px;
}

.collection-resource-node.shape-material-card,
.collection-resource-node.shape-small-card {
  width: 172px;
  min-height: 84px;
}

.collection-resource-node.shape-material-card .graph-node-title,
.collection-resource-node.shape-small-card .graph-node-title {
  font-size: 14.5px;
  line-height: 1.18;
}

.collection-tag-node.shape-circle {
  width: 124px;
  height: 124px;
}

.collection-entity-node.shape-circle {
  width: 120px;
  height: 120px;
}

.collection-entity-node.shape-capsule {
  width: 152px;
  height: 74px;
}

.collection-outer-node.shape-compact {
  width: 96px;
  height: 50px;
}

.graph-link-label {
  min-height: 20px;
  max-width: 150px;
  padding: 2px 7px;
  font-size: 11.5px;
  font-weight: 760;
  line-height: 1.12;
}

.graph-evidence-strip strong {
  font-size: 13px;
}

.graph-evidence-strip span {
  font-size: 12px;
}

@media (max-width: 900px) {
  .graph-node.shape-circle {
    width: 108px;
    height: 108px;
    padding: 13px 10px;
  }
  .graph-node.shape-circle .graph-node-title {
    font-size: 14.5px;
  }
  .graph-node.shape-capsule {
    width: 132px;
    height: 64px;
  }
  .graph-node.shape-material-card {
    width: 176px;
  }
  .graph-node.shape-small-card {
    width: 140px;
  }
  .graph-central-node.shape-material-card {
    width: 202px;
    min-height: 124px;
  }
  .graph-central-node.shape-material-card .graph-node-title,
  .collection-central-node .graph-node-title,
  .graph-node.shape-central-topic .graph-node-title {
    font-size: 18px;
  }
  .collection-central-node,
  .graph-node.shape-central-topic {
    width: 160px;
    height: 160px;
  }
}
@media (max-width: 760px) {
  .graph-node-title {
    font-size: 14.5px;
  }
  .graph-node .graph-node-type,
  .graph-node .graph-node-status,
  .graph-node em {
    font-size: 12px;
  }
  .graph-node.shape-circle {
    width: 100px;
    height: 100px;
    padding: 11px 8px;
  }
  .graph-node.shape-circle .graph-node-title {
    font-size: 13.5px;
  }
  .graph-node.shape-capsule {
    width: 120px;
    height: 58px;
    padding: 8px 10px;
  }
  .graph-node.shape-capsule .graph-node-title {
    font-size: 13.5px;
  }
  .graph-node.shape-material-card {
    width: 154px;
    min-height: 88px;
  }
  .graph-node.shape-small-card {
    width: 124px;
    min-height: 60px;
  }
  .graph-central-node.shape-material-card {
    width: 166px;
    min-height: 104px;
  }
  .collection-central-node,
  .graph-node.shape-central-topic {
    width: 134px;
    height: 134px;
    padding: 15px 12px;
  }
  .graph-central-node.shape-material-card .graph-node-title,
  .collection-central-node .graph-node-title,
  .graph-node.shape-central-topic .graph-node-title {
    font-size: 15.5px;
  }
}
/* Step 50 final cascade guard. */
.detail-page .detail-panel {
  padding: 28px;
}

.detail-page .detail-layout {
  grid-template-columns: minmax(280px, 332px) minmax(0, 1fr);
  gap: 42px;
}

.detail-page .modal-cover {
  position: sticky;
  top: 18px;
  align-self: start;
  max-width: 332px;
  border: 1px solid var(--border);
  background: #FFFFFF;
  box-shadow: inset 8px 0 14px rgba(30, 30, 30, 0.08), 0 14px 30px rgba(31, 41, 51, 0.12);
}

.detail-page .modal-cover img {
  background: #FFFFFF;
  object-fit: contain;
}

.detail-page .detail-content h2 {
  font-size: 35px;
}

.detail-page .bibliographic-list {
  margin-top: 32px;
}

.detail-page .bibliographic-list div {
  grid-template-columns: 180px minmax(0, 1fr);
  min-height: 52px;
  padding: 14px 0;
}

.detail-page .bibliographic-list dt {
  font-size: 15px;
}

.detail-page .bibliographic-list dd {
  font-size: 16.5px;
  font-weight: 720;
}

.detail-status-grid {
  gap: 10px;
}

.detail-status-grid .detail-status-card {
  min-height: 84px;
  padding: 12px 14px;
}

.detail-status-grid .status-label {
  font-size: 12px;
}

.detail-status-grid strong {
  font-size: 15px;
}

.detail-status-grid small {
  font-size: 12px;
}

.detail-page .detail-action-group .source-link,
.detail-page .detail-action-group .source-action-button {
  min-height: 48px;
  min-width: 164px;
  font-size: 15.5px;
}

.detail-page .detail-action-group .detail-action-primary {
  min-width: 188px;
}

.detail-page .detail-action-group .primary-graph-action {
  min-width: 230px;
}

.graph-node,
.graph-node-title,
.graph-node .graph-node-type,
.graph-node .graph-node-status,
.graph-node em {
  overflow-wrap: anywhere;
  text-overflow: clip;
  word-break: keep-all;
}

.graph-node-title,
.graph-node .graph-node-type,
.graph-node .graph-node-status,
.graph-node em {
  overflow: visible;
  white-space: normal;
}

.graph-node.shape-circle .graph-node-title,
.graph-node.shape-capsule .graph-node-title,
.graph-node.shape-compact .graph-node-title,
.graph-central-node.shape-material-card .graph-node-title,
.collection-central-node .graph-node-title,
.graph-node.shape-central-topic .graph-node-title {
  display: block !important;
  height: auto !important;
  max-height: none !important;
  overflow: visible !important;
  -webkit-box-orient: initial !important;
  -webkit-line-clamp: initial !important;
}

.graph-central-node.shape-material-card {
  width: 264px;
  min-height: 148px;
}

.collection-central-node,
.graph-node.shape-central-topic {
  width: 198px;
  height: 198px;
}

.graph-node.shape-circle.is-long-label {
  width: 128px;
  height: 128px;
  padding: 15px 12px;
}

.graph-node.shape-circle.is-very-long-label {
  width: 138px;
  height: 138px;
  padding: 16px 13px;
}

.graph-node.shape-capsule.is-long-label {
  width: 164px;
  height: 80px;
}

.graph-node.shape-capsule.is-very-long-label {
  width: 178px;
  height: 88px;
}

.graph-node.shape-small-card.is-long-label,
.collection-resource-node.shape-small-card.is-long-label {
  width: 184px;
  min-height: 92px;
}

.graph-node.shape-compact.is-long-label {
  width: 118px;
  height: 58px;
}

.graph-node.shape-circle.is-long-label .graph-node-title,
.graph-node.shape-capsule.is-long-label .graph-node-title {
  font-size: 14px;
}

.graph-node.shape-circle.is-very-long-label .graph-node-title,
.graph-node.shape-capsule.is-very-long-label .graph-node-title {
  font-size: 13px;
}

.graph-node.shape-circle.is-long-label .graph-node-type,
.graph-node.shape-circle.is-long-label .graph-node-status,
.graph-node.shape-circle.is-long-label em,
.graph-node.shape-capsule.is-long-label .graph-node-type,
.graph-node.shape-capsule.is-long-label .graph-node-status,
.graph-node.shape-capsule.is-long-label em {
  font-size: 11.2px;
}

.graph-link {
  stroke-width: 1.75px;
  opacity: 0.84;
}

.graph-link.is-reviewed,
.graph-link.is-evidence-complete {
  stroke-width: 1.85px;
  opacity: 0.88;
}

.graph-link.is-metadata-recommendation,
.graph-link.is-pending-review,
.graph-link.is-pending-evidence {
  stroke-width: 1.55px;
  opacity: 0.72;
}

.graph-link.is-dimmed {
  opacity: 0.2;
}

@media (max-width: 900px) {
  .detail-page .detail-layout {
    grid-template-columns: 1fr;
    gap: 26px;
  }
  .detail-page .modal-cover {
    position: static;
    max-width: 280px;
  }
  .detail-page .bibliographic-list div {
    grid-template-columns: 150px minmax(0, 1fr);
  }
  .graph-central-node.shape-material-card {
    width: 220px;
    min-height: 134px;
  }
  .collection-central-node,
  .graph-node.shape-central-topic {
    width: 168px;
    height: 168px;
  }
  .graph-node.shape-circle.is-long-label {
    width: 118px;
    height: 118px;
  }
  .graph-node.shape-circle.is-very-long-label {
    width: 128px;
    height: 128px;
  }
  .graph-node.shape-capsule.is-long-label {
    width: 150px;
    height: 74px;
  }
}
@media (max-width: 560px) {
  .detail-page .detail-panel {
    padding: 20px;
  }
  .detail-page .detail-content h2 {
    font-size: 28px;
  }
  .detail-page .bibliographic-list div {
    grid-template-columns: 118px minmax(0, 1fr);
  }
  .detail-page .bibliographic-list dt {
    font-size: 13.5px;
  }
  .detail-page .bibliographic-list dd {
    font-size: 15px;
  }
}
/* Step 52 final cascade guard: selected single-material node stays centered and dominant. */
.graph-canvas .graph-central-node.shape-material-card {
  width: 292px;
  min-height: 166px;
  padding: 20px 22px;
  border-width: 3px;
  border-left-width: 9px;
  border-color: var(--design-source);
  background: #FFFFFF;
  box-shadow: 0 0 0 6px rgba(30, 30, 30, 0.08), 0 24px 44px rgba(30, 30, 30, 0.2);
}

.graph-canvas .graph-central-node.shape-material-card .graph-node-title {
  font-size: 23px;
  line-height: 1.16;
}

.graph-canvas .graph-central-node.shape-material-card .graph-node-type {
  border-color: #8DB4EE;
  background: var(--accent-wash);
  color: var(--design-source);
}

@media (max-width: 900px) {
  .graph-canvas .graph-central-node.shape-material-card {
    width: 224px;
    min-height: 140px;
    padding: 16px 18px;
    border-left-width: 7px;
  }
  .graph-canvas .graph-central-node.shape-material-card .graph-node-title {
    font-size: 19px;
  }
}
@media (max-width: 560px) {
  .graph-canvas .graph-central-node.shape-material-card {
    width: 174px;
    min-height: 112px;
    padding: 13px 14px;
    border-left-width: 6px;
  }
  .graph-canvas .graph-central-node.shape-material-card .graph-node-title {
    font-size: 16px;
  }
}
/* Step 55: single-material graph lines fan from node edges, with restrained evidence-state contrast. */
:host {
  --graph-line-default: rgba(30, 30, 30, 0.26);
  --graph-line-muted: rgba(31, 31, 31, 0.16);
  --graph-line-direct: rgba(56, 80, 107, 0.46);
  --graph-line-selected: var(--accent);
}

.graph-link {
  stroke: var(--graph-line-default);
  stroke-width: 1.35px;
  opacity: 0.58;
}

.graph-link.is-reviewed,
.graph-link.is-evidence-complete {
  stroke: #93A9BE;
  stroke-width: 1.45px;
  opacity: 0.66;
}

.graph-link.is-metadata-recommendation,
.graph-link.is-pending-review,
.graph-link.is-pending-evidence {
  stroke: var(--graph-line-muted);
  stroke-dasharray: 3 6;
  stroke-width: 1.18px;
  opacity: 0.44;
}

.graph-link.is-central-direct,
.graph-link.is-direct,
.graph-link.is-hovered {
  stroke: var(--graph-line-direct);
  stroke-dasharray: none;
  stroke-width: 1.7px;
  opacity: 0.78;
}

.graph-link.is-central-direct.is-metadata-recommendation,
.graph-link.is-central-direct.is-pending-review,
.graph-link.is-central-direct.is-pending-evidence,
.graph-link.is-direct.is-metadata-recommendation,
.graph-link.is-direct.is-pending-review,
.graph-link.is-direct.is-pending-evidence,
.graph-link.is-hovered.is-metadata-recommendation,
.graph-link.is-hovered.is-pending-review,
.graph-link.is-hovered.is-pending-evidence {
  stroke: #91A7BB;
  stroke-dasharray: 3 6;
  stroke-width: 1.35px;
  opacity: 0.58;
}

.graph-link.is-selected,
.graph-link.is-reviewed.is-selected,
.graph-link.is-evidence-complete.is-selected,
.graph-link.is-metadata-recommendation.is-selected,
.graph-link.is-pending-review.is-selected,
.graph-link.is-pending-evidence.is-selected,
.graph-link.is-central-direct.is-selected,
.graph-link.is-central-direct.is-metadata-recommendation.is-selected,
.graph-link.is-central-direct.is-pending-review.is-selected,
.graph-link.is-central-direct.is-pending-evidence.is-selected,
.graph-link.is-direct.is-selected,
.graph-link.is-direct.is-metadata-recommendation.is-selected,
.graph-link.is-direct.is-pending-review.is-selected,
.graph-link.is-direct.is-pending-evidence.is-selected,
.graph-link.is-hovered.is-selected,
.graph-link.is-hovered.is-metadata-recommendation.is-selected,
.graph-link.is-hovered.is-pending-review.is-selected,
.graph-link.is-hovered.is-pending-evidence.is-selected {
  stroke: var(--graph-line-selected);
  stroke-dasharray: none;
  stroke-width: 2.65px;
  opacity: 1;
}

.graph-link.is-dimmed {
  stroke: #DDE6F0;
  stroke-width: 1px;
  opacity: 0.14;
}

.graph-link.is-central-direct.is-dimmed,
.graph-link.is-central-direct.is-metadata-recommendation.is-dimmed,
.graph-link.is-central-direct.is-pending-review.is-dimmed,
.graph-link.is-central-direct.is-pending-evidence.is-dimmed,
.graph-link.is-direct.is-dimmed,
.graph-link.is-direct.is-metadata-recommendation.is-dimmed,
.graph-link.is-direct.is-pending-review.is-dimmed,
.graph-link.is-direct.is-pending-evidence.is-dimmed,
.graph-link.is-hovered.is-dimmed,
.graph-link.is-hovered.is-metadata-recommendation.is-dimmed,
.graph-link.is-hovered.is-pending-review.is-dimmed,
.graph-link.is-hovered.is-pending-evidence.is-dimmed {
  stroke: #DDE6F0;
  stroke-dasharray: none;
  stroke-width: 1px;
  opacity: 0.14;
}

.graph-link-label.is-direct,
.graph-link-label.is-hovered {
  border-color: #C5D5E4;
  color: #466D91;
}

.graph-link-label.is-metadata-recommendation,
.graph-link-label.is-pending-evidence {
  color: #6F849A;
}

.graph-link-label.is-selected {
  border-color: var(--border-soft);
  color: var(--graph-line-selected);
}

.graph-link.is-reviewed:not(.is-selected):not(.is-dimmed) {
  stroke: #7E95AA;
  stroke-dasharray: none;
  stroke-width: 1.55px;
  opacity: 0.76;
}

.graph-link.is-metadata-recommendation:not(.is-selected):not(.is-dimmed) {
  stroke: #C5D3DF;
  stroke-dasharray: 1.5 6;
  stroke-width: 1.08px;
  opacity: 0.36;
}

.graph-link.is-pending-evidence:not(.is-metadata-recommendation):not(.is-selected):not(.is-dimmed) {
  stroke: #AABDD0;
  stroke-dasharray: 3.5 5.5;
  stroke-width: 1.22px;
  opacity: 0.58;
}

.graph-link.is-selected,
.graph-link.is-reviewed.is-selected,
.graph-link.is-evidence-complete.is-selected,
.graph-link.is-metadata-recommendation.is-selected,
.graph-link.is-pending-review.is-selected,
.graph-link.is-pending-evidence.is-selected {
  stroke: var(--graph-line-selected);
  stroke-dasharray: none;
  stroke-width: 2.65px;
  opacity: 1;
}

.graph-link-status {
  position: absolute;
  z-index: 5;
  min-width: 24px;
  height: 17px;
  padding: 0 5px;
  border: 1px solid rgba(31, 31, 31, 0.24);
  border-radius: 999px;
  background: rgba(250, 250, 250, 0.92);
  color: #666666;
  cursor: pointer;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 15px;
  text-align: center;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(45, 55, 72, 0.08);
}

.graph-link-status.is-direct,
.graph-link-status.is-hovered {
  border-color: rgba(111, 143, 174, 0.42);
  color: #466D91;
}

.graph-link-status.is-selected {
  z-index: 6;
  border-color: var(--border-soft);
  background: rgba(255, 255, 255, 0.96);
  color: var(--graph-line-selected);
  box-shadow: 0 0 0 3px rgba(31, 31, 31, 0.14);
}

.graph-link-status.is-dimmed {
  opacity: 0.28;
}

/* Step 56: single-material graph node text hierarchy and truncation. */
.graph-canvas .graph-central-node.shape-material-card {
  width: 328px;
  min-height: 188px;
  padding: 22px 24px;
}

.graph-canvas .graph-central-node.shape-material-card .graph-node-title {
  display: block;
  max-height: none;
  overflow: visible;
  color: var(--text);
  font-size: 25px;
  font-weight: 950;
  line-height: 1.15;
  text-overflow: clip;
  white-space: normal;
}

.graph-canvas .graph-central-node.shape-material-card .graph-node-type {
  max-width: 100%;
  min-height: 20px;
  padding: 2px 8px;
  overflow: hidden;
  font-size: 10.5px;
  font-weight: 820;
  line-height: 1.1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.graph-canvas .graph-central-node.shape-material-card .graph-node-status,
.graph-canvas .graph-central-node.shape-material-card em {
  max-width: 100%;
  overflow: hidden;
  color: #4B6280;
  font-size: 11.5px;
  font-weight: 700;
  line-height: 1.12;
  opacity: 0.72;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.graph-canvas .graph-cluster-node .graph-node-title {
  display: -webkit-box !important;
  max-height: 2.5em !important;
  overflow: hidden !important;
  color: var(--node-text);
  font-size: 14.8px;
  font-weight: 930;
  line-height: 1.24;
  text-overflow: ellipsis !important;
  white-space: normal !important;
  word-break: keep-all;
  overflow-wrap: anywhere;
  -webkit-box-orient: vertical !important;
  -webkit-line-clamp: 2 !important;
}

.graph-canvas .graph-cluster-node.shape-capsule {
  height: auto;
  min-height: 84px;
}

.graph-canvas .graph-cluster-node.shape-compact {
  height: auto;
  min-height: 60px;
}

.graph-canvas .graph-cluster-node.shape-circle .graph-node-title,
.graph-canvas .graph-cluster-node.shape-capsule .graph-node-title {
  font-size: 14.2px;
  line-height: 1.2;
}

.graph-canvas .graph-cluster-node.shape-compact .graph-node-title {
  max-height: 1.2em !important;
  font-size: 11.4px;
  line-height: 1.12;
  -webkit-line-clamp: 1 !important;
}

.graph-canvas .graph-cluster-node .graph-node-type {
  max-width: 100%;
  min-height: 18px;
  padding: 2px 6px;
  overflow: hidden;
  font-size: 9.6px;
  font-weight: 800;
  line-height: 1.08;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.graph-canvas .graph-cluster-node .graph-node-status,
.graph-canvas .graph-cluster-node em {
  display: block;
  max-width: 100%;
  overflow: hidden;
  color: var(--node-muted);
  font-size: 9.8px;
  font-weight: 620;
  line-height: 1.12;
  opacity: 0.68;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.graph-canvas .graph-cluster-node.shape-circle.is-long-label .graph-node-title,
.graph-canvas .graph-cluster-node.shape-circle.is-very-long-label .graph-node-title,
.graph-canvas .graph-cluster-node.shape-capsule.is-long-label .graph-node-title,
.graph-canvas .graph-cluster-node.shape-capsule.is-very-long-label .graph-node-title {
  font-size: 13.4px;
}

@media (max-width: 900px) {
  .graph-canvas .graph-central-node.shape-material-card {
    width: 248px;
    min-height: 154px;
    padding: 17px 18px;
  }
  .graph-canvas .graph-central-node.shape-material-card .graph-node-title {
    font-size: 20px;
    line-height: 1.15;
  }
  .graph-canvas .graph-cluster-node .graph-node-title {
    font-size: 13.4px;
  }
}
@media (max-width: 560px) {
  .graph-canvas .graph-central-node.shape-material-card {
    width: 198px;
    min-height: 128px;
    padding: 14px 15px;
  }
  .graph-canvas .graph-central-node.shape-material-card .graph-node-title {
    font-size: 17px;
  }
  .graph-canvas .graph-central-node.shape-material-card .graph-node-type {
    font-size: 9.8px;
  }
  .graph-canvas .graph-central-node.shape-material-card .graph-node-status,
  .graph-canvas .graph-central-node.shape-material-card em,
  .graph-canvas .graph-cluster-node .graph-node-status,
  .graph-canvas .graph-cluster-node em {
    font-size: 9.4px;
  }
}
/* Step 57: keep single-material graph cards readable inside the radial ring. */
.graph-canvas .graph-cluster-label {
  display: none;
}

.graph-canvas .graph-cluster-node.shape-small-card.is-long-label {
  width: 204px;
  min-height: 118px;
  padding: 12px 14px;
}

.graph-canvas .graph-cluster-node.shape-small-card.is-long-label .graph-node-title,
.graph-canvas .graph-cluster-node.shape-small-card.is-very-long-label .graph-node-title {
  max-height: 3.72em !important;
  font-size: 13.2px;
  line-height: 1.24;
  -webkit-line-clamp: 3 !important;
}

.graph-canvas .graph-cluster-node.shape-small-card .graph-node-type {
  min-height: 18px;
}

.graph-canvas .graph-cluster-node.shape-small-card .graph-node-status,
.graph-canvas .graph-cluster-node.shape-small-card em {
  font-size: 9.5px;
}

@media (max-width: 900px) {
  .graph-canvas .graph-cluster-node.shape-small-card.is-long-label {
    width: 168px;
    min-height: 104px;
    padding: 11px 12px;
  }
  .graph-canvas .graph-cluster-node.shape-small-card.is-long-label .graph-node-title,
  .graph-canvas .graph-cluster-node.shape-small-card.is-very-long-label .graph-node-title {
    font-size: 12.4px;
    line-height: 1.2;
  }
}
@media (max-width: 560px) {
  .graph-canvas .graph-cluster-node.shape-small-card.is-long-label {
    width: 142px;
    min-height: 92px;
    padding: 10px 10px;
  }
  .graph-canvas .graph-cluster-node.shape-small-card.is-long-label .graph-node-title,
  .graph-canvas .graph-cluster-node.shape-small-card.is-very-long-label .graph-node-title {
    font-size: 11.5px;
    line-height: 1.16;
  }
}
/* Step 58: make the single-material graph dense enough for research exploration. */
.graph-canvas.is-dense {
  min-height: 900px;
}

.graph-canvas .graph-central-node.shape-material-card {
  width: 272px;
  min-height: 144px;
  padding: 17px 19px;
  border-width: 2px;
  border-left-width: 7px;
  box-shadow: 0 0 0 4px rgba(30, 30, 30, 0.06), 0 16px 30px rgba(31, 31, 31, 0.14);
}

.graph-canvas .graph-central-node.shape-material-card .graph-node-title {
  font-size: 20.5px;
  line-height: 1.15;
}

.graph-canvas .graph-central-node.shape-material-card .graph-node-type {
  min-height: 18px;
  padding: 2px 7px;
  font-size: 10px;
}

.graph-canvas .graph-central-node.shape-material-card .graph-node-status,
.graph-canvas .graph-central-node.shape-material-card em {
  font-size: 10.5px;
}

.graph-canvas .graph-cluster-node.shape-circle {
  width: 94px;
  height: 94px;
  padding: 11px 9px;
}

.graph-canvas .graph-cluster-node.shape-capsule {
  width: 122px;
  min-height: 58px;
  padding: 8px 11px;
}

.graph-canvas .graph-cluster-node.shape-small-card {
  width: 136px;
  min-height: 76px;
  padding: 9px 10px;
}

.graph-canvas .graph-cluster-node.shape-small-card.is-long-label {
  width: 160px;
  min-height: 90px;
  padding: 10px 11px;
}

.graph-canvas .graph-cluster-node.shape-compact {
  width: 70px;
  min-height: 38px;
  padding: 5px 6px;
}

.graph-canvas .graph-cluster-node .graph-node-title {
  font-size: 12.4px;
  line-height: 1.18;
}

.graph-canvas .graph-cluster-node.shape-circle .graph-node-title,
.graph-canvas .graph-cluster-node.shape-capsule .graph-node-title {
  font-size: 12px;
  line-height: 1.15;
}

.graph-canvas .graph-cluster-node.shape-small-card .graph-node-title,
.graph-canvas .graph-cluster-node.shape-small-card.is-long-label .graph-node-title,
.graph-canvas .graph-cluster-node.shape-small-card.is-very-long-label .graph-node-title {
  font-size: 11.8px;
  line-height: 1.18;
}

.graph-canvas .graph-cluster-node .graph-node-type {
  min-height: 16px;
  padding: 1px 5px;
  font-size: 8.8px;
}

.graph-canvas .graph-cluster-node .graph-node-status,
.graph-canvas .graph-cluster-node em {
  font-size: 8.9px;
}

.graph-canvas .graph-link-label {
  max-width: 154px;
  min-height: 17px;
  padding: 1px 5px;
  background: rgba(255, 255, 255, 0.76);
  color: #435F7A;
  font-size: 9.2px;
  font-weight: 820;
  opacity: 0.9;
}

.graph-canvas .graph-link-label.is-metadata-recommendation,
.graph-canvas .graph-link-label.is-pending-evidence {
  background: rgba(255, 255, 255, 0.68);
  color: #6F7F90;
}

.graph-canvas .graph-link-label.is-evidence-complete {
  color: #395F7B;
}

@media (max-width: 900px) {
  .graph-canvas .graph-central-node.shape-material-card {
    width: 218px;
    min-height: 124px;
    padding: 14px 15px;
  }
  .graph-canvas .graph-central-node.shape-material-card .graph-node-title {
    font-size: 17.5px;
  }
  .graph-canvas .graph-cluster-node.shape-circle {
    width: 84px;
    height: 84px;
  }
  .graph-canvas .graph-cluster-node.shape-small-card.is-long-label {
    width: 138px;
    min-height: 82px;
  }
}
@media (max-width: 560px) {
  .graph-canvas .graph-central-node.shape-material-card {
    width: 174px;
    min-height: 106px;
    padding: 12px 13px;
    border-left-width: 6px;
  }
  .graph-canvas .graph-central-node.shape-material-card .graph-node-title {
    font-size: 15.5px;
  }
  .graph-canvas .graph-cluster-node.shape-circle {
    width: 74px;
    height: 74px;
    padding: 9px 7px;
  }
  .graph-canvas .graph-cluster-node.shape-capsule {
    width: 104px;
    min-height: 50px;
  }
  .graph-canvas .graph-cluster-node.shape-small-card,
  .graph-canvas .graph-cluster-node.shape-small-card.is-long-label {
    width: 118px;
    min-height: 72px;
  }
  .graph-canvas .graph-cluster-node .graph-node-title {
    font-size: 10.6px;
  }
  .graph-canvas .graph-link-label {
    max-width: 118px;
    font-size: 8.3px;
  }
}
/* Step 59: keep the single-material center node important without dominating the graph. */
.graph-canvas .graph-central-node.shape-material-card {
  width: 196px;
  min-height: 104px;
  justify-content: center;
  gap: 5px;
  padding: 11px 13px 12px;
  border-width: 1px;
  border-left-width: 5px;
  border-color: var(--accent);
  background: #FFFFFF;
  box-shadow: 0 0 0 3px rgba(30, 30, 30, 0.045), 0 12px 22px rgba(30, 30, 30, 0.12);
}

.graph-canvas .graph-central-node.shape-material-card .graph-node-type {
  order: -1;
  min-height: 16px;
  padding: 1px 6px;
  border-color: #BBD4FF;
  background: var(--accent-wash);
  color: var(--accent);
  font-size: 9px;
  font-weight: 850;
  line-height: 1.1;
}

.graph-canvas .graph-central-node.shape-material-card .graph-node-title {
  display: -webkit-box;
  max-height: 3.54em;
  overflow: hidden;
  color: var(--text);
  font-size: 15.5px;
  font-weight: 920;
  line-height: 1.18;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: anywhere;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.graph-canvas .graph-central-node.shape-material-card .graph-node-status,
.graph-canvas .graph-central-node.shape-material-card em {
  max-width: 100%;
  overflow: hidden;
  color: #44617F;
  font-size: 9.6px;
  font-weight: 720;
  line-height: 1.15;
  opacity: 0.8;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 900px) {
  .graph-canvas .graph-central-node.shape-material-card {
    width: 160px;
    min-height: 92px;
    padding: 9px 10px 10px;
    border-left-width: 4px;
  }
  .graph-canvas .graph-central-node.shape-material-card .graph-node-title {
    font-size: 13.6px;
    line-height: 1.16;
  }
  .graph-canvas .graph-central-node.shape-material-card .graph-node-type {
    font-size: 8.5px;
  }
  .graph-canvas .graph-central-node.shape-material-card .graph-node-status,
  .graph-canvas .graph-central-node.shape-material-card em {
    font-size: 8.7px;
  }
}
@media (max-width: 560px) {
  .graph-canvas .graph-central-node.shape-material-card {
    width: 136px;
    min-height: 82px;
    gap: 4px;
    padding: 8px 9px;
    border-left-width: 4px;
  }
  .graph-canvas .graph-central-node.shape-material-card .graph-node-title {
    max-height: 3.45em;
    font-size: 12.3px;
    line-height: 1.15;
  }
  .graph-canvas .graph-central-node.shape-material-card .graph-node-type {
    max-width: 100%;
    padding: 1px 5px;
    font-size: 8px;
  }
  .graph-canvas .graph-central-node.shape-material-card .graph-node-status,
  .graph-canvas .graph-central-node.shape-material-card em {
    font-size: 8px;
  }
}
/* Step 61: node priority and display-size rules. */
.graph-node.shape-circle.size-large {
  width: 142px;
  height: 142px;
  padding: 18px 15px;
  border-width: 3px;
}

.graph-node.shape-circle.size-medium {
  width: 116px;
  height: 116px;
  padding: 15px 12px;
}

.graph-node.shape-circle.size-small {
  width: 92px;
  height: 92px;
  padding: 11px 9px;
}

.graph-node.shape-circle.size-large .graph-node-title {
  font-size: 17px;
  line-height: 1.14;
  -webkit-line-clamp: 3;
}

.graph-node.shape-circle.size-medium .graph-node-title {
  font-size: 14.5px;
  line-height: 1.15;
  -webkit-line-clamp: 3;
}

.graph-node.shape-circle.size-small .graph-node-title {
  font-size: 12px;
  line-height: 1.12;
  -webkit-line-clamp: 2;
}

.graph-node.shape-circle.size-small .graph-node-type,
.graph-node.shape-circle.size-small .graph-node-status,
.graph-node.shape-circle.size-small em {
  font-size: 9px;
}

.graph-node.shape-small-card.size-small {
  width: 152px;
  min-height: 72px;
}

.collection-resource-node.shape-small-card.size-small {
  width: 160px;
  min-height: 76px;
}

.graph-node.shape-circle.priority-1,
.graph-node.shape-circle.priority-2,
.graph-node.shape-circle.priority-3 {
  box-shadow: 0 14px 28px rgba(30, 30, 30, 0.13);
}

.graph-node.shape-circle.priority-7,
.graph-node.shape-circle.priority-8,
.graph-node.shape-circle.priority-9 {
  border-style: dashed;
  background: color-mix(in srgb, var(--node-bg) 82%, #FFFFFF);
}

.graph-legend-dot.type-actor {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

@media (max-width: 900px) {
  .graph-node.shape-circle.size-large {
    width: 124px;
    height: 124px;
  }
  .graph-node.shape-circle.size-medium {
    width: 104px;
    height: 104px;
  }
  .graph-node.shape-circle.size-small {
    width: 84px;
    height: 84px;
  }
}
@media (max-width: 560px) {
  .graph-node.shape-circle.size-large {
    width: 102px;
    height: 102px;
    padding: 11px 8px;
  }
  .graph-node.shape-circle.size-medium {
    width: 86px;
    height: 86px;
    padding: 10px 7px;
  }
  .graph-node.shape-circle.size-small {
    width: 72px;
    height: 72px;
    padding: 8px 6px;
  }
  .graph-node.shape-circle.size-large .graph-node-title,
  .graph-node.shape-circle.size-medium .graph-node-title,
  .graph-node.shape-circle.size-small .graph-node-title {
    font-size: 10.4px;
  }
}
/* Step 63: compact single-material graph rings around the centered material card. */
.graph-canvas {
  min-height: 720px;
  background-image: radial-gradient(ellipse at 50% 50%, transparent 0 25.8%, rgba(30, 30, 30, 0.09) 25.95%, rgba(30, 30, 30, 0.09) 26.25%, transparent 26.55%), radial-gradient(ellipse at 50% 50%, transparent 0 35.4%, rgba(127, 157, 187, 0.09) 35.55%, rgba(127, 157, 187, 0.09) 35.85%, transparent 36.15%), radial-gradient(ellipse at 50% 50%, transparent 0 43.6%, rgba(127, 157, 187, 0.07) 43.75%, rgba(127, 157, 187, 0.07) 44.05%, transparent 44.35%);
  background-size: 100% 100%;
}

.graph-canvas.is-low-density {
  min-height: 560px;
}

.graph-canvas.is-dense {
  min-height: 960px;
}

.graph-canvas.is-filtered {
  min-height: 720px;
}

@media (max-width: 900px) {
  .graph-canvas {
    min-height: 660px;
  }
  .graph-canvas.is-dense,
  .graph-canvas.is-filtered {
    min-height: 820px;
  }
}
@media (max-width: 560px) {
  .graph-canvas {
    min-height: 580px;
  }
  .graph-canvas.is-dense,
  .graph-canvas.is-filtered {
    min-height: 720px;
  }
}
.graph-canvas.is-dense .graph-cluster-node.shape-circle {
  width: 76px;
  height: 76px;
  padding: 8px 7px;
}

.graph-canvas.is-dense .graph-cluster-node.shape-capsule {
  width: 104px;
  min-height: 44px;
  padding: 5px 8px;
}

.graph-canvas.is-dense .graph-cluster-node.shape-small-card {
  width: 120px;
  min-height: 64px;
  padding: 8px 9px;
}

.graph-canvas.is-dense .graph-cluster-node.shape-small-card.is-long-label {
  width: 140px;
  min-height: 74px;
  padding: 9px 10px;
}

.graph-canvas.is-dense .graph-cluster-node .graph-node-title {
  font-size: 11.2px;
  line-height: 1.13;
}

.graph-canvas.is-dense .graph-cluster-node.shape-small-card .graph-node-title,
.graph-canvas.is-dense .graph-cluster-node.shape-small-card.is-long-label .graph-node-title,
.graph-canvas.is-dense .graph-cluster-node.shape-small-card.is-very-long-label .graph-node-title {
  font-size: 10.8px;
}

.graph-canvas.is-dense .graph-cluster-node .graph-node-type {
  font-size: 8.2px;
}

.graph-canvas.is-dense .graph-cluster-node .graph-node-status,
.graph-canvas.is-dense .graph-cluster-node em {
  font-size: 8.3px;
}

/* Step 64: lock node-type visuals to distinct color, shape, and label cues. */
.graph-node {
  border-width: 2px;
  border-left-width: 2px;
  border-color: var(--node-border);
  background: var(--node-bg);
  color: var(--node-text);
  box-shadow: 0 8px 18px rgba(31, 41, 51, 0.09);
}

.graph-node.shape-material-card,
.graph-node.shape-small-card {
  align-items: flex-start;
  border-left-width: 6px;
  border-radius: 8px;
  background: #FFFFFF;
  text-align: left;
}

.graph-node.shape-material-card {
  width: 204px;
  min-height: 98px;
  padding: 12px 14px;
}

.graph-node.shape-small-card {
  width: 148px;
  min-height: 68px;
  padding: 9px 11px;
}

.graph-canvas .graph-central-node.shape-material-card {
  width: 206px;
  min-height: 112px;
  border-width: 2px;
  border-left-width: 7px;
  border-color: var(--design-source);
  background: #FFFFFF;
  box-shadow: 0 0 0 4px rgba(30, 30, 30, 0.07), 0 16px 30px rgba(30, 30, 30, 0.15);
}

.graph-node.shape-circle {
  width: 108px;
  height: 108px;
  min-height: 0;
  align-items: center;
  padding: 13px 10px;
  border-left-width: 2px;
  border-radius: 50%;
  overflow: hidden;
  text-align: center;
}

.graph-node.shape-circle.size-large {
  width: 132px;
  height: 132px;
  padding: 17px 13px;
  border-width: 3px;
}

.graph-node.shape-circle.size-medium {
  width: 112px;
  height: 112px;
}

.graph-node.shape-circle.size-small {
  width: 92px;
  height: 92px;
  padding: 10px 8px;
}

.graph-node.shape-capsule {
  width: 148px;
  height: 68px;
  min-height: 0;
  align-items: center;
  padding: 9px 14px;
  border-left-width: 2px;
  border-radius: 999px;
  overflow: hidden;
  text-align: center;
}

.graph-node.shape-dot {
  width: 86px;
  height: 36px;
  min-height: 0;
  align-items: flex-start;
  gap: 0;
  padding: 5px 8px 5px 23px;
  border-width: 1px;
  border-radius: 999px;
  overflow: hidden;
  text-align: left;
  box-shadow: 0 2px 7px rgba(31, 41, 51, 0.08);
}

.graph-node.shape-dot::before {
  position: absolute;
  top: 50%;
  left: 10px;
  width: 8px;
  height: 8px;
  transform: translateY(-50%);
  border-radius: 50%;
  background: var(--node-accent);
  content: "";
}

.collection-central-node,
.graph-node.shape-central-topic {
  width: 188px;
  height: 188px;
  min-height: 0;
  align-items: center;
  padding: 22px 18px;
  border-width: 3px;
  border-left-width: 3px;
  border-radius: 50%;
  text-align: center;
}

.collection-central-node,
.graph-node.shape-central-topic,
.graph-node.type-자료.shape-central-topic {
  --node-accent: var(--design-source);
  --node-border: var(--design-source);
  --node-bg: var(--accent);
  --node-text: #FFFFFF;
  --node-muted: rgba(255, 255, 255, 0.9);
  --node-type-bg: rgba(255, 255, 255, 0.18);
  --node-type-border: rgba(255, 255, 255, 0.38);
  box-shadow: 0 22px 44px rgba(30, 30, 30, 0.2);
}

.graph-node.type-자료 {
  --node-accent: var(--design-source);
  --node-border: var(--design-source);
  --node-bg: #FFFFFF;
  --node-text: var(--text);
  --node-muted: var(--design-source);
  --node-type-bg: var(--accent-wash);
  --node-type-border: #A9C6F5;
}

.graph-node.type-관련-자료,
.collection-resource-node {
  --node-accent: var(--design-text-muted);
  --node-border: #9AAABD;
  --node-bg: #FFFFFF;
  --node-text: #263544;
  --node-muted: #5B6674;
  --node-type-bg: #F4F7FA;
  --node-type-border: #D3DCE6;
}

.graph-node.type-주제,
.collection-tag-node {
  --node-accent: var(--accent);
  --node-border: var(--accent);
  --node-bg: rgba(94, 102, 118, 0.1);
  --node-text: var(--accent-hover);
  --node-muted: var(--accent-hover);
  --node-type-bg: #FFFFFF;
  --node-type-border: #A9C9FF;
}

.graph-node.type-장소 {
  --node-accent: var(--design-olive);
  --node-border: var(--design-olive);
  --node-bg: rgba(94, 102, 118, 0.1);
  --node-text: var(--design-olive);
  --node-muted: var(--design-olive);
  --node-type-bg: #FFFFFF;
  --node-type-border: #A9DCF0;
}

.graph-node.type-사건,
.graph-node.type-시대 {
  --node-accent: #5E6676;
  --node-border: #BDBDBD;
  --node-bg: #EFF3F7;
  --node-text: #4F5662;
  --node-muted: #4F5662;
  --node-type-bg: #FFFFFF;
  --node-type-border: #D8D8D8;
}

.graph-node.type-인물,
.graph-node.type-기관 {
  --node-accent: var(--muted);
  --node-border: #61778F;
  --node-bg: #E7EEF6;
  --node-text: #2D425A;
  --node-muted: #2D425A;
  --node-type-bg: #FFFFFF;
  --node-type-border: #BCC9D8;
}

.graph-node.type-개념,
.graph-node.type-문헌-법령 {
  --node-accent: var(--design-text-muted);
  --node-border: #C9D2DC;
  --node-bg: #F5F7FA;
  --node-text: #435064;
  --node-muted: #435064;
  --node-type-bg: #FFFFFF;
  --node-type-border: #D8DEE7;
}

.graph-node.type-주장,
.graph-node.type-쟁점,
.graph-node.type-반박,
.graph-node.type-쟁점-반박 {
  --node-accent: #B33D45;
  --node-border: #C95159;
  --node-bg: #FFE6E8;
  --node-text: #8E2630;
  --node-muted: #8E2630;
  --node-type-bg: #FFFFFF;
  --node-type-border: #E7A6AB;
}

.graph-node.type-근거-후보,
.collection-outer-node {
  --node-accent: var(--design-text-muted);
  --node-border: #C9D2DC;
  --node-bg: #FFFFFF;
  --node-text: #525A66;
  --node-muted: #626B78;
  --node-type-bg: #F6F8FA;
  --node-type-border: #DDE3EA;
}

.collection-central-node,
.graph-node.shape-central-topic,
.graph-node.type-자료.shape-central-topic,
.graph-node.type-주제.shape-central-topic {
  --node-accent: var(--design-source);
  --node-border: var(--design-source);
  --node-bg: var(--accent);
  --node-text: #FFFFFF;
  --node-muted: rgba(255, 255, 255, 0.9);
  --node-type-bg: rgba(255, 255, 255, 0.18);
  --node-type-border: rgba(255, 255, 255, 0.38);
  box-shadow: 0 22px 44px rgba(30, 30, 30, 0.2);
}

.graph-node-title {
  color: var(--node-text);
  font-size: 14.5px;
  font-weight: 930;
  line-height: 1.18;
}

.graph-canvas .graph-central-node.shape-material-card .graph-node-title {
  font-size: 16.5px;
  line-height: 1.16;
}

.collection-central-node .graph-node-title,
.graph-node.shape-central-topic .graph-node-title {
  font-size: 19px;
  line-height: 1.14;
}

.graph-node.shape-circle .graph-node-title {
  font-size: 13.5px;
  line-height: 1.14;
}

.graph-node.shape-circle.size-large .graph-node-title {
  font-size: 15.5px;
}

.graph-node.shape-circle.size-small .graph-node-title {
  font-size: 11.2px;
}

.graph-node.shape-capsule .graph-node-title {
  font-size: 12.8px;
  line-height: 1.14;
}

.graph-node.shape-dot .graph-node-title {
  display: block !important;
  max-height: 1.15em !important;
  overflow: hidden !important;
  color: var(--node-text);
  font-size: 10.5px;
  font-weight: 830;
  line-height: 1.12;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  -webkit-line-clamp: 1 !important;
}

.graph-node .graph-node-type {
  border-color: var(--node-type-border, var(--node-border));
  background: var(--node-type-bg, rgba(255, 255, 255, 0.88));
  color: var(--node-muted);
  font-size: 9.6px;
  font-weight: 860;
  line-height: 1.08;
}

.graph-node.shape-dot .graph-node-type,
.graph-node.shape-dot .graph-node-status,
.graph-node.shape-dot em {
  display: none;
}

.graph-node.shape-circle.is-selected::after,
.graph-node.shape-capsule.is-selected::after,
.graph-node.shape-central-topic.is-selected::after,
.graph-node.shape-dot.is-selected::after {
  display: none;
}

.graph-evidence-strip button {
  min-height: 32px;
  padding: 6px 8px 6px 22px;
  border-left-width: 1px;
  border-radius: 999px;
}

.graph-evidence-strip button::before {
  left: 10px;
  width: 7px;
  height: 7px;
  background: var(--design-text-muted);
}

.graph-legend-dot.type-material,
.graph-legend-dot.type-related-material {
  width: 14px;
  height: 9px;
  border-radius: 3px;
  background: #FFFFFF;
}

.graph-legend-dot.type-material {
  color: var(--design-source);
}

.graph-legend-dot.type-related-material {
  color: var(--design-text-muted);
}

.graph-legend-dot.type-central-topic {
  width: 12px;
  height: 12px;
  background: var(--accent);
  color: var(--design-source);
}

.graph-legend-dot.type-topic {
  background: rgba(94, 102, 118, 0.1);
  color: var(--accent);
}

.graph-legend-dot.type-place {
  background: rgba(94, 102, 118, 0.1);
  color: var(--design-olive);
}

.graph-legend-dot.type-event {
  background: #EFF3F7;
  color: #5E6676;
}

.graph-legend-dot.type-actor {
  width: 14px;
  height: 8px;
  border-radius: 999px;
  background: #E7EEF6;
  color: var(--muted);
}

.graph-legend-dot.type-concept {
  background: #F5F7FA;
  color: var(--design-text-muted);
}

.graph-legend-dot.type-issue {
  background: #FFE6E8;
  color: #B33D45;
}

.graph-legend-dot.type-evidence {
  width: 6px;
  height: 6px;
  background: var(--design-text-muted);
  color: var(--design-text-muted);
}

@media (max-width: 900px) {
  .graph-node.shape-material-card {
    width: 170px;
    min-height: 88px;
  }
  .graph-node.shape-small-card {
    width: 126px;
    min-height: 60px;
  }
  .graph-canvas .graph-central-node.shape-material-card {
    width: 164px;
    min-height: 94px;
  }
  .collection-central-node,
  .graph-node.shape-central-topic {
    width: 148px;
    height: 148px;
  }
  .graph-node.shape-circle.size-large {
    width: 116px;
    height: 116px;
  }
  .graph-node.shape-circle,
  .graph-node.shape-circle.size-medium {
    width: 96px;
    height: 96px;
  }
  .graph-node.shape-circle.size-small {
    width: 82px;
    height: 82px;
  }
  .graph-node.shape-capsule {
    width: 126px;
    height: 60px;
  }
}
@media (max-width: 560px) {
  .graph-node.shape-material-card {
    width: 144px;
    min-height: 78px;
  }
  .graph-node.shape-small-card {
    width: 112px;
    min-height: 54px;
  }
  .graph-canvas .graph-central-node.shape-material-card {
    width: 136px;
    min-height: 82px;
  }
  .collection-central-node,
  .graph-node.shape-central-topic {
    width: 122px;
    height: 122px;
    padding: 14px 10px;
  }
  .graph-node.shape-circle.size-large,
  .graph-node.shape-circle,
  .graph-node.shape-circle.size-medium {
    width: 82px;
    height: 82px;
  }
  .graph-node.shape-circle.size-small {
    width: 70px;
    height: 70px;
  }
  .graph-node.shape-capsule {
    width: 108px;
    height: 52px;
  }
  .graph-node.shape-dot {
    width: 72px;
    height: 32px;
    padding-left: 20px;
  }
}
/* Step 84: refine the first-screen tone into a clean, evidence-first library workspace. */
:host {
  --page-bg: var(--design-bg);
  --card-bg: #FFFFFF;
  --muted-bg: var(--design-bg-muted);
  --border: var(--design-border);
  --border-soft: var(--design-border-soft);
  --text: var(--design-text);
  --muted: var(--design-text-secondary);
  --faint: var(--design-text-disabled);
  --accent: var(--design-accent);
  --accent-hover: var(--design-accent-strong);
  --accent-soft: var(--design-selected-bg);
  --accent-wash: var(--design-accent-wash);
  --focus-ring-color: var(--design-focus-ring-color);
  --focus-ring: var(--design-focus-ring);
  --surface-shadow: var(--design-shadow);
  --surface-shadow-strong: var(--design-shadow-strong);
  background: var(--page-bg);
}

.library-page {
  width: min(1360px, 100%);
  padding: 34px 32px 64px;
}

.library-hero {
  align-items: flex-start;
  gap: 18px;
  padding: 0 0 18px;
}

.library-brand-link,
.library-hero > div:first-child {
  flex: 1 1 520px;
  min-width: 0;
}

.eyebrow {
  margin-bottom: 8px;
  color: #496A90;
  font-size: 13px;
  font-weight: 800;
}

h1 {
  color: var(--text);
  font-size: 38px;
  line-height: 1.16;
  letter-spacing: 0;
}

.library-subtitle {
  max-width: 720px;
  margin-top: 10px;
  color: var(--muted);
  font-size: 15px;
  line-height: 1.58;
}

.library-count,
.auth-profile,
.auth-link {
  border-color: var(--border);
  background: rgba(255, 255, 255, 0.92);
  box-shadow: var(--surface-shadow);
}

.library-count {
  min-height: 42px;
  padding: 10px 12px;
}

.library-count strong {
  color: var(--text);
  font-size: 18px;
}

.auth-toolbar {
  gap: 10px;
}

.auth-profile {
  min-height: 42px;
  padding: 9px 12px;
}

.auth-link {
  min-height: 42px;
  padding: 0 14px;
  color: #335E8D;
  font-size: 13px;
}

.top-tabbar {
  gap: 8px;
  margin-bottom: 16px;
  padding: 8px;
  border-color: var(--border);
  background: rgba(255, 255, 255, 0.94);
  box-shadow: var(--surface-shadow);
}

.top-tabbar button {
  min-height: 42px;
  border-color: transparent;
  background: transparent;
  color: #4B5F73;
  font-size: 14px;
  font-weight: 800;
}

.top-tabbar button:not(.is-active):hover,
.top-tabbar button:not(.is-active):focus-visible {
  border-color: var(--border);
  background: #F7FAFD;
  color: var(--text);
}

.top-tabbar button.is-active,
.top-tabbar button.is-active:hover,
.top-tabbar button.is-active:focus-visible {
  border-color: #BFD4F4;
  background: var(--accent-soft);
  color: var(--accent-hover);
  box-shadow: none;
}

.home-search-panel {
  display: grid;
  gap: 14px;
  margin: 0 0 20px;
  padding: 20px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: var(--surface-shadow-strong);
}

.home-search-main {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 112px;
  gap: 12px;
  align-items: end;
}

.home-search-control {
  display: grid;
  min-width: 0;
  gap: 8px;
}

.home-search-control span,
.home-topic-row > span {
  color: var(--muted);
  font-size: 13px;
  font-weight: 850;
}

.home-search-control input {
  width: 100%;
  min-height: 54px;
  padding: 0 17px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.88);
  color: var(--text);
  font-size: 16px;
  font-weight: 650;
  outline: none;
}

.home-search-control input::placeholder {
  color: var(--faint);
  font-weight: 600;
}

.home-search-control input:focus {
  border-color: var(--accent);
  background: #FFFFFF;
  box-shadow: var(--focus-ring);
}

.home-search-button {
  min-height: 54px;
  border: 1px solid var(--accent-hover);
  border-radius: 8px;
  background: var(--accent-hover);
  color: #FFFFFF;
  cursor: pointer;
  font-size: 15px;
  font-weight: 900;
}

.home-search-button:hover,
.home-search-button:focus-visible {
  border-color: var(--accent);
  background: var(--accent);
  box-shadow: 0 10px 22px rgba(31, 31, 31, 0.16);
  outline: none;
}

.home-topic-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
}

.home-topic-row button {
  min-height: 34px;
  padding: 0 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--design-card-tinted);
  color: var(--design-source);
  cursor: pointer;
  font-size: 13px;
  font-weight: 800;
}

.home-topic-row button:hover,
.home-topic-row button:focus-visible,
.home-topic-row button.is-active {
  border-color: var(--accent);
  background: var(--accent-soft);
  color: var(--accent-hover);
  outline: none;
}

.control-panel {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 18px;
  padding: 20px;
  border-color: var(--border);
  background: #FFFFFF;
  box-shadow: var(--surface-shadow-strong);
}

.search-control {
  grid-column: span 2;
}

.control span {
  color: var(--muted);
  font-size: 13px;
}

.control input,
.control select,
.control textarea {
  min-height: 44px;
  border-color: var(--border-soft);
  background: rgba(255, 255, 255, 0.88);
  font-size: 14.5px;
}

.search-control input {
  min-height: 50px;
  font-size: 15.5px;
}

.reset-button {
  min-height: 44px;
  border-color: var(--border-soft);
  background: var(--accent-wash);
  color: var(--design-source);
  font-weight: 850;
}

.shelf {
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 24px 22px;
  margin-top: 4px;
  padding-top: 12px;
}

.book-card {
  gap: 13px;
  padding: 14px;
  border-color: var(--border);
  background: #FFFFFF;
  box-shadow: 0 1px 2px rgba(30, 30, 30, 0.08);
}

.book-card:hover,
.book-card:focus-visible {
  transform: translateY(-2px);
  border-color: var(--accent);
  box-shadow: 0 12px 26px rgba(30, 30, 30, 0.12);
}

.cover-frame {
  border-color: var(--border);
  background: var(--design-card-tinted);
}

.book-title {
  min-height: 43px;
  color: var(--text);
  font-size: 15px;
  font-weight: 850;
  line-height: 1.42;
}

.book-author {
  margin-top: 8px;
  color: var(--muted);
  font-size: 13px;
  font-weight: 650;
}

.book-detail {
  gap: 6px;
  margin-top: 9px;
  font-size: 12px;
}

.book-detail span {
  border-color: var(--border);
  background: rgba(255, 255, 255, 0.88);
  color: var(--muted);
}

.tag-strip {
  gap: 6px;
  max-height: 60px;
  margin-top: 12px;
}

.tag-strip span,
.tag-strip span:nth-child(even) {
  border-color: var(--border);
  background: var(--design-card-tinted);
  color: var(--design-source);
  font-size: 12px;
  font-weight: 760;
}

.tag-strip span[role=button]:hover,
.tag-strip span[role=button].is-active {
  border-color: var(--accent);
  background: var(--accent-soft);
  color: var(--accent-hover);
}

@media (max-width: 900px) {
  .library-page {
    padding: 24px 20px 52px;
  }
  .library-brand-link,
  .library-hero > div:first-child {
    flex: 1 1 100%;
  }
  .library-hero {
    flex-wrap: wrap;
  }
  .home-search-main,
  .control-panel {
    grid-template-columns: 1fr;
  }
  .search-control {
    grid-column: auto;
  }
}
@media (max-width: 560px) {
  .library-page {
    padding: 20px 14px 42px;
  }
  .library-hero {
    align-items: flex-start;
    gap: 12px;
  }
  h1 {
    font-size: 30px;
  }
  .library-subtitle {
    font-size: 14px;
  }
  .home-search-panel {
    padding: 16px;
  }
  .home-search-button {
    width: 100%;
  }
  .shelf {
    grid-template-columns: repeat(auto-fill, minmax(154px, 1fr));
    gap: 16px;
  }
  .book-card {
    padding: 11px;
  }
}
/* Step 91: typed search results with evidence-first cards. */
.search-result-tabs {
  display: grid;
  grid-template-columns: minmax(180px, 1.25fr) repeat(6, minmax(112px, 1fr));
  gap: 8px;
  margin-top: 12px;
  padding: 10px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: var(--surface-shadow);
}

.search-result-tabs-heading {
  display: grid;
  min-width: 0;
  align-content: center;
  gap: 3px;
  padding: 9px 10px;
  border-radius: 8px;
  background: #FAFAFA;
}

.search-result-tabs-heading strong,
.search-result-tabs button span {
  color: var(--accent-hover);
  font-size: 12px;
  font-weight: 900;
}

.search-result-tabs-heading span,
.search-result-tabs button small {
  color: var(--muted);
  font-size: 11px;
  line-height: 1.35;
}

.search-result-tabs button {
  display: grid;
  min-width: 0;
  min-height: 70px;
  align-content: center;
  gap: 3px;
  padding: 9px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: var(--page-bg);
  color: var(--text);
  cursor: pointer;
  text-align: left;
}

.search-result-tabs button:hover,
.search-result-tabs button.is-active {
  border-color: var(--focus-ring-color);
  background: var(--accent-wash);
  box-shadow: var(--focus-ring);
}

.search-result-tabs button strong {
  color: var(--text);
  font-size: 21px;
  line-height: 1;
  font-weight: 900;
}

.search-result-tabs button small {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.typed-result-list {
  display: grid;
  gap: 12px;
  margin-top: 14px;
}

.body-evidence-list,
.graph-result-list {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.tag-result-list {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.typed-result-card {
  display: grid;
  min-width: 0;
  gap: 10px;
  padding: 14px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: var(--surface-shadow);
}

.typed-result-kicker {
  display: flex;
  min-width: 0;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
}

.typed-result-kicker span {
  color: var(--accent-hover);
  font-size: 12px;
  font-weight: 900;
}

.typed-result-kicker em {
  min-width: 0;
  overflow: hidden;
  color: var(--muted);
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.typed-result-card h3 {
  margin: 0;
  color: var(--text);
  font-size: 17px;
  line-height: 1.35;
  font-weight: 900;
}

.typed-result-card p {
  margin: 0;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.55;
}

.typed-result-meta,
.search-material-meta {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 7px;
  margin: 10px 0 0;
}

.typed-result-meta {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin: 0;
}

.typed-result-meta div,
.search-material-meta div {
  min-width: 0;
  padding: 8px;
  border: 1px solid #E7EDF3;
  border-radius: 7px;
  background: #F9FBFD;
}

.typed-result-meta dt,
.search-material-meta dt {
  margin: 0 0 3px;
  color: var(--muted);
  font-size: 11px;
  font-weight: 850;
}

.typed-result-meta dd,
.search-material-meta dd {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  color: var(--text);
  font-size: 12px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.evidence-snippet {
  padding: 10px 11px;
  border-left: 3px solid #9CC2E5;
  border-radius: 6px;
  background: #FAFAFA;
}

.evidence-snippet mark {
  border-radius: 4px;
  padding: 0 2px;
  background: #E9EEF6;
  color: #263544;
  font-weight: 900;
}

.typed-evidence-list,
.typed-result-actions {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 7px;
}

.typed-evidence-list span {
  max-width: 100%;
  overflow: hidden;
  padding: 5px 7px;
  border: 1px solid var(--border);
  border-radius: 999px;
  background: #FAFAFA;
  color: #536270;
  font-size: 11px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.typed-result-actions .source-action-button {
  min-height: 34px;
}

.typed-empty-state {
  margin-top: 14px;
}

.shelf.search-result-shelf {
  grid-template-columns: 1fr;
  gap: 12px;
}

.book-card.search-result-card {
  display: grid;
  grid-template-columns: minmax(96px, 132px) minmax(0, 1fr);
  align-items: start;
  gap: 12px 14px;
  padding: 14px;
  cursor: default;
}

.search-result-card .book-card-main {
  display: grid;
  grid-column: 1/-1;
  grid-template-columns: minmax(96px, 132px) minmax(0, 1fr);
  gap: 14px;
}

.search-result-card .book-title {
  min-height: 0;
  font-size: 17px;
  line-height: 1.35;
  -webkit-line-clamp: 3;
}

.book-publisher {
  margin-top: 7px;
  overflow: hidden;
  color: #4F5F6F;
  font-size: 12px;
  font-weight: 750;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.original-state {
  display: inline-flex;
  max-width: 100%;
  overflow: hidden;
  padding: 2px 6px;
  border-radius: 999px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.original-state.is-available {
  background: #EAF7EE;
  color: #23633A;
}

.original-state.is-limited {
  background: var(--pending-bg);
  color: var(--pending-text);
}

.original-state.is-unavailable {
  background: var(--issue-soft);
  color: var(--issue);
}

.search-result-card .search-match-panel,
.search-result-card .book-result-actions {
  grid-column: 2;
}

.search-match-panel p.search-match-reason {
  color: var(--text);
  font-weight: 850;
  -webkit-line-clamp: 2;
}

.search-match-panel p.search-match-summary {
  color: var(--muted);
  -webkit-line-clamp: 2;
}

@media (max-width: 1120px) {
  .search-result-tabs {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .search-result-tabs-heading {
    grid-column: 1/-1;
  }
  .tag-result-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .search-result-tabs,
  .body-evidence-list,
  .graph-result-list,
  .tag-result-list,
  .typed-result-meta,
  .search-material-meta {
    grid-template-columns: 1fr;
  }
  .book-card.search-result-card,
  .search-result-card .book-card-main {
    grid-template-columns: 88px minmax(0, 1fr);
  }
  .search-result-card .search-match-panel,
  .search-result-card .book-result-actions {
    grid-column: 1/-1;
  }
}
/* Step 93 final override: readable collection knowledge graph with non-overlapping nodes. */
.collection-graph-canvas {
  min-height: 1040px;
}

.collection-central-node,
.collection-central-node.shape-central-topic {
  width: 164px;
  height: 164px;
  padding: 18px 15px;
}

.collection-resource-node.shape-material-card,
.collection-resource-node.shape-small-card {
  width: 136px;
  min-height: 64px;
  padding: 8px 9px;
}

.collection-tag-node.shape-circle {
  width: 104px;
  height: 104px;
  padding: 12px 10px;
}

.collection-entity-node.shape-circle {
  width: 96px;
  height: 96px;
  padding: 11px 9px;
}

.collection-entity-node.shape-capsule {
  width: 118px;
  height: 54px;
  padding: 8px 10px;
}

.collection-outer-node.shape-compact {
  width: 78px;
  height: 38px;
}

.collection-central-node .graph-node-title {
  font-size: 15.5px;
  line-height: 1.12;
}

.collection-resource-node.shape-material-card .graph-node-title,
.collection-resource-node.shape-small-card .graph-node-title {
  font-size: 11.7px;
  line-height: 1.13;
}

.collection-tag-node.shape-circle .graph-node-title,
.collection-entity-node.shape-circle .graph-node-title,
.collection-entity-node.shape-capsule .graph-node-title {
  font-size: 11.4px;
  line-height: 1.12;
}

/* Step 94: final public knowledge-platform polish. */
:host {
  --page-bg: var(--design-bg);
  --card-bg: #FFFFFF;
  --muted-bg: var(--design-bg-muted);
  --border: var(--design-border);
  --border-soft: var(--design-border-soft);
  --text: var(--design-text);
  --muted: var(--design-text-secondary);
  --faint: var(--design-text-disabled);
  --accent: var(--design-accent);
  --accent-hover: var(--design-accent-strong);
  --accent-soft: var(--design-selected-bg);
  --accent-wash: var(--design-accent-wash);
  --blue-soft: var(--design-info);
  --pending-bg: var(--design-pending-bg);
  --pending-text: var(--design-pending-text);
  --issue-soft: var(--design-issue-soft);
  --issue: var(--design-issue);
  --surface-shadow: var(--design-shadow);
  --surface-shadow-strong: var(--design-shadow-strong);
  --focus-ring-color: var(--design-focus-ring-color);
  --focus-ring: var(--design-focus-ring);
  --graph-accent: var(--accent);
  --graph-accent-strong: var(--accent-hover);
  --graph-source: var(--design-source);
  --graph-text: var(--text);
  --graph-muted: var(--muted);
  --graph-border: var(--border);
  --graph-surface: #FFFFFF;
  --graph-surface-muted: var(--design-card-tinted);
}

.library-page {
  width: min(1320px, 100%);
  padding: 30px 28px 64px;
}

.library-hero {
  align-items: flex-start;
  padding-bottom: 16px;
}

h1 {
  font-size: 36px;
  line-height: 1.18;
  letter-spacing: 0;
}

.library-subtitle {
  max-width: 760px;
  font-size: 15.5px;
}

.top-tabbar,
.home-search-panel,
.control-panel,
.topic-graph-entry-section,
.collection-overview-section,
.graph-hub-section,
.graph-book-tab-section,
.research-ai-section,
.admin-review-section,
.collection-graph-section,
.search-result-tabs,
.typed-result-card,
.book-card,
.detail-panel,
.reader-nav-panel,
.reader-text-panel,
.reader-toolbar,
.graph-inspector {
  border-color: var(--border);
  background: var(--card-bg);
  box-shadow: var(--surface-shadow);
}

.home-search-panel,
.control-panel,
.detail-panel {
  box-shadow: var(--surface-shadow-strong);
}

.top-tabbar button,
.home-topic-row button,
.reset-button,
.section-mini-button,
.source-action-button,
.source-link.secondary,
.graph-tool-actions button,
.graph-view-actions button,
.auth-link {
  border-color: var(--border-soft);
  background: #FFFFFF;
  color: var(--accent-hover);
}

.top-tabbar button.is-active,
.home-topic-row button.is-active,
.home-topic-row button:hover,
.source-action-button:hover,
.source-link.secondary:hover,
.section-mini-button:hover,
.graph-tool-actions button:hover,
.graph-view-actions button:hover {
  border-color: var(--border-soft);
  background: var(--accent-soft);
  color: var(--accent-hover);
}

.home-search-button,
.source-link.primary-source,
.primary-action,
.primary-graph-action,
.detail-demo-actions .primary-demo-action {
  border-color: var(--accent-hover);
  background: var(--accent-hover);
  color: #FFFFFF;
}

.home-search-button:hover,
.source-link.primary-source:hover,
.primary-action:hover,
.primary-graph-action:hover,
.detail-demo-actions .primary-demo-action:hover {
  border-color: var(--accent);
  background: var(--accent);
  color: #FFFFFF;
}

.shelf {
  grid-template-columns: repeat(auto-fill, minmax(204px, 1fr));
  gap: 22px;
}

.book-card {
  border-color: #E0E8F1;
  background: #FFFFFF;
}

.book-title {
  min-height: 0;
  font-size: 15.5px;
  line-height: 1.42;
}

.book-card:hover,
.book-card:focus-visible,
.typed-result-card:hover,
.related-card:hover,
.collection-card:hover {
  border-color: var(--border-soft);
  box-shadow: 0 12px 26px rgba(23, 34, 53, 0.08);
}

.tag-strip span,
.detail-primary-tags button,
.graph-inspector-tags span,
.typed-evidence-list span {
  border-color: #D8E7F5;
  background: var(--accent-wash);
  color: var(--design-source);
}

.search-result-tabs {
  grid-template-columns: minmax(180px, 1.2fr) repeat(6, minmax(118px, 1fr));
}

.search-result-tabs button {
  min-height: 72px;
  background: #F8FBFE;
}

.typed-result-card {
  padding: 16px;
}

.book-card.search-result-card {
  grid-template-columns: minmax(104px, 136px) minmax(0, 1fr);
  gap: 14px;
}

.search-result-card .book-card-main {
  grid-template-columns: minmax(104px, 136px) minmax(0, 1fr);
}

.detail-page {
  padding-top: 24px;
}

.detail-toolbar {
  margin-bottom: 16px;
}

.detail-panel {
  padding: 30px;
}

.detail-page .detail-layout {
  grid-template-columns: minmax(260px, 318px) minmax(0, 1fr);
  gap: 38px;
}

.detail-page .modal-cover {
  max-width: 318px;
  border-color: var(--border);
  background: #FFFFFF;
  box-shadow: 0 16px 32px rgba(30, 30, 30, 0.12);
}

.detail-page .modal-cover img {
  object-fit: contain;
}

.detail-page .detail-content h2 {
  margin-top: 12px;
  font-size: 31px;
  line-height: 1.24;
}

.detail-page .bibliographic-list {
  margin-top: 22px;
  padding: 2px 16px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.88);
}

.detail-page .bibliographic-list div {
  grid-template-columns: 156px minmax(0, 1fr);
  min-height: 48px;
  padding: 12px 0;
  border-color: var(--border);
}

.detail-page .bibliographic-list div:last-child {
  border-bottom: 0;
}

.detail-page .bibliographic-list dt {
  color: #5D6E82;
  font-size: 14px;
  font-weight: 900;
}

.detail-page .bibliographic-list dd {
  color: var(--text);
  font-size: 15.5px;
  font-weight: 720;
  line-height: 1.55;
}

.modal-description {
  color: var(--muted);
  font-size: 15px;
}

.detail-action-group {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 18px;
}

.detail-action-group > * {
  justify-content: center;
  min-width: 0;
  min-height: 46px;
  text-align: center;
}

.detail-action-primary {
  font-size: 15px;
  font-weight: 900;
}

.detail-action-default {
  font-size: 14px;
  font-weight: 850;
}

.detail-action-missing {
  border: 1px solid var(--border);
  background: #FAFAFA;
  color: var(--muted);
}

.graph-entry-panel {
  border-color: #D6E5F5;
  background: #FAFAFA;
}

.graph-entry-copy strong {
  font-size: 16px;
}

.graph-entry-metrics div {
  border: 1px solid #E3ECF5;
  background: #FFFFFF;
}

.detail-management-section {
  margin-top: 18px;
}

.detail-status-grid-primary {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.detail-status-grid .detail-status-card {
  background: #FFFFFF;
}

.internal-management-group {
  margin-top: 14px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: var(--surface-shadow);
  overflow: hidden;
}

.internal-management-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 48px;
  margin: 0;
  padding: 0 16px;
  color: var(--text);
  cursor: pointer;
  font-size: 14px;
  font-weight: 900;
  list-style: none;
}

.internal-management-label::-webkit-details-marker {
  display: none;
}

.internal-management-label::after {
  content: "펼치기";
  min-height: 28px;
  padding: 5px 9px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: #F8FBFE;
  color: var(--accent-hover);
  font-size: 12px;
  font-weight: 850;
}

.internal-management-group[open] .internal-management-label::after {
  content: "접기";
}

.internal-management-grid {
  padding: 0 16px 16px;
}

.reader-section,
.knowledge-section,
.toc-summary-grid,
.related-section,
.detail-section {
  border-top-color: var(--border);
}

.ebook-reader-grid {
  grid-template-columns: 240px minmax(520px, 1fr) 330px;
}

.ebook-reader-grid.is-text-panel-closed {
  grid-template-columns: 240px minmax(520px, 1fr);
}

.reader-file-row {
  align-items: flex-start;
}

.graph-canvas,
.collection-graph-canvas {
  border-color: var(--graph-border);
  background: #FBFCFE;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.72);
}

.graph-node {
  border-color: #D6E1EE;
  background: #FFFFFF;
  color: var(--graph-text);
  box-shadow: 0 6px 16px rgba(23, 34, 53, 0.08);
}

.graph-node.type-자료,
.graph-node.type-관련-자료 {
  --node-accent: #2E6E7E;
  --node-border: #BFD5DE;
  --node-bg: #F8FCFD;
}

.graph-node.type-주제,
.graph-node.type-장소,
.graph-node.type-개념,
.graph-node.type-문헌-법령 {
  --node-accent: var(--accent);
  --node-border: #C4D7F0;
  --node-bg: var(--accent-wash);
}

.graph-node.type-인물,
.graph-node.type-기관,
.graph-node.type-사건,
.graph-node.type-시대 {
  --node-accent: #597896;
  --node-border: #CFDAE6;
  --node-bg: #FAFCFE;
}

.graph-node.type-주장,
.graph-node.type-쟁점,
.graph-node.type-반박,
.graph-node.type-쟁점-반박 {
  --node-accent: #666666;
  --node-border: #E5E5E5;
  --node-bg: #FAFAFA;
}

.graph-node.type-근거-후보 {
  --node-accent: #8A98A8;
  --node-border: #DCE3EA;
  --node-bg: #FFFFFF;
}

.graph-node.is-dimmed,
.graph-edge-button.is-dimmed {
  opacity: 0.38;
  filter: saturate(0.82);
}

.graph-link {
  stroke: #A9B8C8;
  opacity: 0.56;
}

.graph-link.is-reviewed,
.graph-link.is-evidence-complete {
  stroke: #829BB3;
  opacity: 0.7;
}

.graph-link.is-metadata-recommendation:not(.is-selected):not(.is-dimmed),
.graph-link.is-pending-review:not(.is-selected):not(.is-dimmed),
.graph-link.is-pending-evidence:not(.is-selected):not(.is-dimmed) {
  stroke: #BECBDC;
  stroke-dasharray: 2 7;
  opacity: 0.36;
}

.graph-link.is-selected {
  stroke: var(--accent-hover);
}

.graph-link-label {
  border-color: rgba(200, 214, 230, 0.85);
  background: rgba(255, 255, 255, 0.88);
  color: #355F87;
}

.graph-link-label.is-metadata-recommendation,
.graph-link-label.is-pending-evidence {
  color: #687C91;
}

.graph-inspector {
  background: #FFFFFF;
}

.book-graph-layout,
.collection-graph-layout {
  grid-template-columns: minmax(0, 1fr) minmax(300px, 336px);
}

.graph-edge-button {
  border-color: var(--border);
  background: #FFFFFF;
}

.graph-edge-list {
  gap: 12px;
  margin-top: 18px;
}

.graph-edge-button {
  align-items: flex-start;
  min-height: 96px;
  padding: 14px 16px;
  border-left: 3px solid #D4DFEA;
  border-radius: 8px;
  background: #FFFFFF;
  color: var(--ink);
  text-align: left;
  box-shadow: 0 8px 22px rgba(23, 34, 53, 0.05);
}

.graph-edge-button strong,
.graph-edge-button span,
.graph-edge-button small {
  display: block;
}

.graph-edge-button strong {
  color: var(--accent);
  font-size: 13px;
  font-weight: 850;
}

.graph-edge-button span {
  margin-top: 5px;
  color: var(--ink);
  font-size: 14px;
  font-weight: 800;
  line-height: 1.42;
}

.graph-edge-button small {
  margin-top: 6px;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.45;
}

.graph-edge-button.is-metadata-recommendation,
.graph-edge-button.is-pending-evidence,
.graph-edge-button.is-pending-review {
  border-left-color: #CBD7E5;
  background: rgba(255, 255, 255, 0.88);
}

.graph-edge-button.is-reviewed,
.graph-edge-button.is-evidence-complete {
  border-left-color: var(--accent-calm);
  background: #F8FCFD;
}

.graph-edge-button.is-selected,
.graph-edge-button:hover,
.graph-edge-button:focus-visible {
  border-color: #B6C8E5;
  border-left-color: var(--accent-hover);
  background: var(--accent-wash);
  box-shadow: 0 12px 28px rgba(32, 83, 172, 0.12);
  outline: none;
}

@media (max-width: 1120px) {
  .search-result-tabs {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .detail-page .detail-layout,
  .book-graph-layout,
  .collection-graph-layout {
    grid-template-columns: 1fr;
  }
  .detail-page .modal-cover {
    position: relative;
    top: auto;
    width: min(240px, 100%);
    max-width: 240px;
  }
  .ebook-reader-grid {
    grid-template-columns: 1fr;
  }
  .reader-nav-panel,
  .reader-text-panel,
  .graph-inspector {
    position: relative;
    top: auto;
    max-height: none;
  }
  .detail-status-grid-primary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .library-page {
    padding: 22px 14px 48px;
  }
  h1 {
    font-size: 30px;
  }
  .detail-panel {
    padding: 18px;
  }
  .detail-page .detail-content h2 {
    font-size: 25px;
  }
  .detail-page .bibliographic-list {
    padding: 0 12px;
  }
  .detail-page .bibliographic-list div {
    grid-template-columns: 1fr;
    gap: 4px;
    min-height: 0;
  }
  .detail-action-group,
  .detail-status-grid-primary,
  .detail-status-grid,
  .graph-edge-list {
    grid-template-columns: 1fr;
  }
  .book-card.search-result-card,
  .search-result-card .book-card-main {
    grid-template-columns: 92px minmax(0, 1fr);
  }
  .graph-canvas {
    min-height: 620px;
  }
}
/* Review 97: keep the main page self-contained because WIZ serves component styles separately from global tokens. */
:host {
  --design-bg: #FFFFFF;
  --design-card-bg: #FFFFFF;
  --design-bg-muted: rgba(30, 30, 30, 0.32);
  --design-card-tinted: rgba(255, 255, 255, 0.72);
  --design-card-tinted-strong: rgba(30, 30, 30, 0.48);
  --design-card-olive: rgba(94, 102, 118, 0.1);
  --design-card-clay: rgba(104, 112, 134, 0.14);
  --design-text: #1F1F1F;
  --design-text-secondary: #666666;
  --design-text-muted: #8A8A8A;
  --design-text-disabled: #A0A0A0;
  --design-border: rgba(30, 30, 30, 0.18);
  --design-border-soft: rgba(30, 30, 30, 0.28);
  --design-accent: #1F1F1F;
  --design-accent-strong: #111111;
  --design-accent-wash: rgba(30, 30, 30, 0.08);
  --design-selected-bg: rgba(94, 102, 118, 0.13);
  --design-source: #38506B;
  --design-info: #5E6676;
  --design-info-muted: #666666;
  --design-brown: #666666;
  --design-olive: #5E6676;
  --design-clay: #687086;
  --design-cream: #FFFFFF;
  --design-beige: #F5F5F5;
  --design-pending: #F5F5F5;
  --design-pending-strong: #666666;
  --design-pending-bg: rgba(30, 30, 30, 0.48);
  --design-pending-text: #666666;
  --design-issue: #8E2630;
  --design-issue-bg: rgba(142, 38, 48, 0.08);
  --design-issue-soft: rgba(142, 38, 48, 0.08);
  --design-on-accent: #FFFFFF;
  --design-radius-card: 8px;
  --design-radius-button: 8px;
  --design-shadow: 0 1px 2px rgba(30, 30, 30, 0.08);
  --design-shadow-strong: 0 10px 26px rgba(30, 30, 30, 0.12);
  --design-hover-shadow: 0 14px 30px rgba(31, 31, 31, 0.14);
  --design-focus-ring-color: rgba(31, 31, 31, 0.16);
  --design-focus-ring: 0 0 0 3px rgba(31, 31, 31, 0.16);
  --design-section-gap: 16px;
  --design-card-gap: 10px;
}

/* Review 97: final shared token layer for charcoal CTA, warm cards, and restrained graph colors. */
.topic-quickbar,
.top-tabbar,
.search-next-panel,
.search-result-tabs,
.typed-result-card,
.book-card,
.detail-panel,
.detail-section,
.detail-management-section,
.knowledge-block,
.ai-workbench-section,
.graph-book-tab-section,
.collection-graph-section,
.reader-section,
.related-card,
.detail-status-card,
.graph-inspector,
.graph-summary-card {
  border-color: var(--border);
  background: rgba(255, 255, 255, 0.92);
  box-shadow: var(--surface-shadow);
}

.topic-graph-card,
.search-expansion-notice,
.search-match-panel,
.public-tag-box,
.graph-metadata-notice,
.reader-search-results,
.graph-edge-list {
  border-color: var(--border);
  background: var(--design-card-tinted);
}

.control-panel {
  border-color: var(--border);
  background: rgba(255, 255, 255, 0.92);
  box-shadow: var(--surface-shadow-strong);
}

.control span,
.home-search-control span,
.home-topic-row > span {
  color: var(--muted);
}

.control input,
.control select,
.control textarea,
.home-search-control input,
.search-control input,
.reader-search input,
.page-jump input {
  border-color: var(--border-soft);
  background: rgba(255, 255, 255, 0.88);
  color: var(--text);
}

.control input::placeholder,
.control textarea::placeholder,
.home-search-control input::placeholder,
.search-control input::placeholder,
.reader-search input::placeholder {
  color: var(--faint);
}

.control input:focus,
.control select:focus,
.control textarea:focus,
.home-search-control input:focus,
.search-control input:focus,
.reader-search input:focus,
.page-jump input:focus {
  border-color: var(--accent);
  background: #FFFFFF;
  box-shadow: var(--focus-ring);
}

.home-topic-row button {
  border-color: var(--border);
  background: var(--design-card-tinted);
  color: var(--accent);
}

.home-topic-row button:hover,
.home-topic-row button:focus-visible,
.home-topic-row button.is-active {
  border-color: var(--accent);
  background: var(--accent-wash);
  color: var(--accent-hover);
  box-shadow: var(--focus-ring);
}

.source-link.primary-source,
.source-action-button.primary-action,
.primary-graph-action,
.primary-demo-action,
.home-search-button,
.book-result-actions button:first-child,
.search-box button,
.graph-action {
  border-color: var(--accent);
  background: var(--accent);
  color: var(--on-accent);
}

.home-search-button:hover,
.home-search-button:focus-visible {
  border-color: var(--accent-hover);
  background: var(--accent-hover);
  box-shadow: 0 10px 22px rgba(31, 31, 31, 0.16);
}

.source-action-button,
.source-link.secondary,
.reset-button,
.back-button,
.section-mini-button,
.inline-text-button,
.detail-primary-tags button,
.graph-entry-buttons button,
.reader-term-buttons button,
.search-next-panel button,
.book-result-actions button {
  border-color: var(--border-soft);
  background: #FFFFFF;
  color: var(--accent);
}

.source-action-button:hover,
.source-action-button:focus-visible,
.source-link.secondary:hover,
.source-link.secondary:focus-visible,
.reset-button:hover,
.reset-button:focus-visible,
.back-button:hover,
.back-button:focus-visible,
.section-mini-button:hover,
.section-mini-button:focus-visible,
.inline-text-button:hover,
.inline-text-button:focus-visible,
.detail-primary-tags button:hover,
.detail-primary-tags button:focus-visible,
.graph-entry-buttons button:hover,
.graph-entry-buttons button:focus-visible,
.reader-term-buttons button:hover,
.reader-term-buttons button:focus-visible,
.search-next-panel button:hover,
.search-next-panel button:focus-visible,
.book-result-actions button:hover,
.book-result-actions button:focus-visible {
  border-color: var(--accent);
  background: var(--accent-wash);
  color: var(--accent-hover);
  box-shadow: var(--focus-ring);
}

.tag-chip,
.tag-strip span,
.filter-chip,
.search-match-badges span,
.detail-id-badge,
.graph-status-pill,
.graph-edge-button small,
.graph-legend-chip,
.result-evidence-badge {
  border-color: var(--border);
  background: var(--design-card-tinted);
  color: var(--muted);
}

.graph-node.type-자료,
.graph-node.type-관련-자료,
.collection-resource-node {
  --node-accent: var(--accent);
  --node-border: var(--border-soft);
  --node-bg: #FFFFFF;
  --node-text: var(--text);
  --node-muted: var(--muted);
  --node-type-bg: var(--accent-wash);
  --node-type-border: var(--border);
}

.graph-node.type-주제,
.collection-tag-node {
  --node-accent: var(--accent);
  --node-border: var(--accent);
  --node-bg: rgba(94, 102, 118, 0.1);
  --node-text: var(--accent-hover);
  --node-muted: var(--accent-hover);
  --node-type-bg: #FFFFFF;
  --node-type-border: var(--border);
}

.graph-node.type-장소,
.graph-node.type-기관,
.graph-node.type-인물 {
  --node-accent: var(--design-olive);
  --node-border: rgba(94, 102, 118, 0.34);
  --node-bg: rgba(94, 102, 118, 0.1);
  --node-text: var(--design-olive);
  --node-muted: var(--design-olive);
  --node-type-bg: #FFFFFF;
  --node-type-border: var(--border);
}

.graph-node.type-사건,
.graph-node.type-시대 {
  --node-accent: var(--design-clay);
  --node-border: rgba(104, 112, 134, 0.46);
  --node-bg: rgba(104, 112, 134, 0.18);
  --node-text: var(--design-brown);
  --node-muted: var(--design-brown);
  --node-type-bg: #FFFFFF;
  --node-type-border: var(--border);
}

.graph-node.type-개념,
.graph-node.type-문헌-법령,
.graph-node.type-근거-후보,
.collection-outer-node {
  --node-accent: var(--muted);
  --node-border: var(--border);
  --node-bg: var(--accent-wash);
  --node-text: var(--text);
  --node-muted: var(--muted);
  --node-type-bg: #FFFFFF;
  --node-type-border: var(--border);
}

.graph-node.type-주장,
.graph-node.type-쟁점,
.graph-node.type-반박,
.graph-node.type-쟁점-반박 {
  --node-accent: var(--issue);
  --node-border: rgba(142, 38, 48, 0.3);
  --node-bg: var(--issue-soft);
  --node-text: var(--issue);
  --node-muted: var(--issue);
  --node-type-bg: #FFFFFF;
  --node-type-border: rgba(142, 38, 48, 0.18);
}

.collection-central-node,
.graph-node.shape-central-topic,
.graph-node.type-자료.shape-central-topic,
.graph-node.type-주제.shape-central-topic {
  --node-accent: var(--accent-hover);
  --node-border: var(--accent-hover);
  --node-bg: var(--accent);
  --node-text: #FFFFFF;
  --node-muted: rgba(255, 255, 255, 0.88);
  --node-icon-bg: #FFFFFF;
  --node-icon-color: var(--accent-hover);
  box-shadow: 0 18px 34px rgba(30, 30, 30, 0.2);
}

.library-page {
  --page-bg: var(--design-bg);
  --card-bg: var(--design-card-bg);
  --muted-bg: var(--design-bg-muted);
  --border: var(--design-border);
  --border-soft: var(--design-border-soft);
  --text: var(--design-text);
  --muted: var(--design-text-secondary);
  --faint: var(--design-text-disabled);
  --accent: var(--design-accent);
  --accent-hover: var(--design-accent-strong);
  --accent-soft: var(--design-selected-bg);
  --accent-wash: var(--design-accent-wash);
  --blue-muted: var(--design-border-soft);
  --blue-soft: var(--design-info);
  --pending: var(--design-pending);
  --pending-strong: var(--design-pending-strong);
  --pending-bg: var(--design-pending-bg);
  --pending-text: var(--design-pending-text);
  --issue: var(--design-issue);
  --issue-bg: var(--design-issue-bg);
  --issue-soft: var(--design-issue-soft);
  --on-accent: var(--design-on-accent);
  --card-radius: var(--design-radius-card);
  --button-radius: var(--design-radius-button);
  --surface-shadow: var(--design-shadow);
  --surface-shadow-strong: var(--design-shadow-strong);
  --focus-ring-color: var(--design-focus-ring-color);
  --focus-ring: var(--design-focus-ring);
  --section-gap: var(--design-section-gap);
  --card-gap: var(--design-card-gap);
  --graph-accent: var(--accent);
  --graph-accent-strong: var(--accent-hover);
  --graph-source: var(--design-source);
  --graph-text: var(--text);
  --graph-muted: var(--muted);
  --graph-border: var(--border);
  --graph-line: var(--blue-muted);
  --graph-surface: var(--card-bg);
  --graph-surface-muted: var(--design-card-tinted);
  --graph-pending: var(--pending-strong);
  --graph-pending-bg: var(--pending-bg);
  --graph-pending-text: var(--pending-text);
  min-height: 100vh;
  background: var(--page-bg);
  color: var(--text);
}

/* Review 102: align material lists and search results with the charcoal/warm token system from review 97. */
.control-panel,
.active-filter-panel,
.search-result-tabs,
.search-next-panel,
.result-collection-panel,
.typed-result-card,
.shelf .book-card,
.search-empty-state {
  border-color: var(--design-border);
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.94), rgba(255, 255, 255, 0.66));
  box-shadow: var(--design-shadow);
}

.control-panel {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.96), rgba(30, 30, 30, 0.22)), var(--design-card-bg);
}

.control input,
.control select,
.search-control input {
  border-color: var(--design-border);
  background: rgba(255, 255, 255, 0.88);
  color: var(--design-text);
}

.control span,
.search-result-tabs-heading span,
.book-author,
.book-publisher,
.search-match-heading span {
  color: var(--design-text-secondary);
}

.reset-button,
.inline-text-button,
.filter-chip,
.search-result-tabs button,
.search-next-panel button,
.result-collection-grid button,
.result-group-grid button,
.book-result-actions button,
.source-action-button.secondary,
.empty-suggestion-block button {
  border-color: var(--design-border-soft);
  background: rgba(255, 255, 255, 0.86);
  color: var(--design-accent);
  box-shadow: none;
}

.filter-chip,
.tag-strip span,
.typed-evidence-list span,
.search-match-badges span,
.book-detail span,
.original-state {
  border-color: var(--design-border);
  background: var(--design-card-tinted);
  color: var(--design-text-secondary);
}

.filter-chip strong,
.search-match-heading strong,
.book-title {
  color: var(--design-text);
}

.search-result-tabs button.is-active,
.search-result-tabs button:hover,
.search-result-tabs button:focus-visible,
.filter-chip:hover,
.filter-chip:focus-visible,
.tag-strip span[role=button]:hover,
.tag-strip span[role=button]:focus-visible,
.tag-strip span[role=button].is-active,
.empty-suggestion-block button:hover,
.empty-suggestion-block button:focus-visible {
  border-color: var(--design-accent);
  background: var(--design-accent-wash);
  color: var(--design-accent-strong);
  box-shadow: var(--design-focus-ring);
}

.search-result-tabs button.is-active {
  background: rgba(30, 30, 30, 0.1);
}

.shelf .book-card {
  border-color: var(--design-border);
  background: linear-gradient(160deg, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.58) 74%, rgba(30, 30, 30, 0.22));
}

.shelf .book-card:hover,
.shelf .book-card:focus-visible,
.typed-result-card:hover,
.typed-result-card:focus-visible {
  border-color: var(--design-border-soft);
  box-shadow: var(--design-hover-shadow);
}

.shelf.search-result-shelf .book-card.search-result-card {
  border-color: var(--design-border);
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.96), rgba(255, 255, 255, 0.72) 68%, rgba(94, 102, 118, 0.08));
}

.search-result-card .book-card-main {
  border-radius: var(--design-radius-card);
}

.search-material-meta div,
.typed-result-meta div {
  border-color: var(--design-border);
  background: rgba(255, 255, 255, 0.62);
}

.search-match-panel {
  border-color: var(--design-border);
  background: rgba(255, 255, 255, 0.58);
}

.search-match-panel p.search-match-reason {
  color: var(--design-text);
}

.search-match-panel p.search-match-summary,
.typed-result-card p,
.search-empty-state p {
  color: var(--design-text-secondary);
}

.search-match-badges span.match-badge-title {
  border-color: rgba(30, 30, 30, 0.26);
  background: rgba(30, 30, 30, 0.08);
  color: var(--design-accent-strong);
}

.search-match-badges span.match-badge-tag {
  border-color: rgba(94, 102, 118, 0.28);
  background: rgba(94, 102, 118, 0.11);
  color: var(--design-olive);
}

.search-match-badges span.match-badge-body {
  border-color: rgba(104, 112, 134, 0.42);
  background: rgba(104, 112, 134, 0.15);
  color: var(--design-brown);
}

.search-match-badges span.match-badge-graph {
  border-color: rgba(56, 80, 107, 0.24);
  background: rgba(56, 80, 107, 0.09);
  color: var(--design-source);
}

.search-match-badges span.match-badge-biblio,
.search-match-badges span.match-badge-default {
  border-color: var(--design-border);
  background: rgba(255, 255, 255, 0.78);
  color: var(--design-text-secondary);
}

.evidence-snippet {
  border-left-color: var(--design-olive);
  background: rgba(94, 102, 118, 0.08);
}

.evidence-snippet mark {
  background: rgba(30, 30, 30, 0.72);
  color: var(--design-text);
}

.original-state.is-available {
  background: rgba(94, 102, 118, 0.12);
  color: var(--design-olive);
}

.original-state.is-limited {
  background: var(--design-pending-bg);
  color: var(--design-pending-text);
}

.original-state.is-unavailable {
  background: var(--design-issue-soft);
  color: var(--design-issue);
}

.source-action-button:not(.secondary),
.search-match-panel button,
.book-result-actions button:first-child,
.search-next-panel button:first-of-type,
.empty-action-row .source-action-button:first-child {
  border-color: var(--design-accent);
  background: var(--design-accent);
  color: var(--design-on-accent);
}

.source-action-button:not(.secondary):hover,
.source-action-button:not(.secondary):focus-visible,
.search-match-panel button:hover,
.search-match-panel button:focus-visible,
.book-result-actions button:first-child:hover,
.book-result-actions button:first-child:focus-visible,
.search-next-panel button:first-of-type:hover,
.search-next-panel button:first-of-type:focus-visible,
.empty-action-row .source-action-button:first-child:hover,
.empty-action-row .source-action-button:first-child:focus-visible {
  border-color: var(--design-accent-strong);
  background: var(--design-accent-strong);
  color: var(--design-on-accent);
  box-shadow: var(--design-focus-ring);
}

.book-result-actions button:not(:first-child),
.search-next-panel button:not(:first-of-type),
.empty-action-row .source-action-button.secondary {
  border-color: var(--design-border-soft);
  background: rgba(255, 255, 255, 0.86);
  color: var(--design-accent);
}

.book-result-actions button:disabled,
.search-next-panel button:disabled,
.source-action-button:disabled {
  border-color: var(--design-border);
  background: rgba(255, 255, 255, 0.52);
  color: var(--design-text-disabled);
  box-shadow: none;
}

.search-empty-state {
  border-style: solid;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.82), rgba(255, 255, 255, 0.82) 62%, rgba(94, 102, 118, 0.08));
}

.search-empty-state strong,
.empty-suggestion-block span {
  color: var(--design-text);
}

.typed-empty-state {
  margin-top: 14px;
}

@media (max-width: 760px) {
  .search-result-card .book-card-main {
    gap: 12px;
  }
  .book-result-actions button,
  .search-next-panel button,
  .typed-result-actions .source-action-button {
    min-width: 0;
    white-space: normal;
  }
}
/* Review 103: material detail page tone and CTA hierarchy. */
.detail-page {
  --detail-card-gradient: linear-gradient(145deg, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.68) 68%, rgba(30, 30, 30, 0.22));
  --detail-card-soft: rgba(255, 255, 255, 0.62);
  --detail-card-glass: rgba(255, 255, 255, 0.72);
  --detail-cover-paper: #F6F6F6;
  --detail-cover-line: rgba(30, 30, 30, 0.22);
  --detail-card-border: rgba(30, 30, 30, 0.2);
  --detail-card-shadow: 0 10px 24px rgba(31, 31, 31, 0.1);
}

.detail-page .detail-panel {
  border-color: var(--detail-card-border);
  background: var(--detail-card-gradient);
  box-shadow: var(--design-shadow-strong);
}

.detail-page .detail-layout {
  grid-template-columns: minmax(250px, 312px) minmax(0, 1fr);
  gap: 34px;
  align-items: start;
}

.detail-page .detail-content {
  padding-right: 0;
}

.cover-frame,
.modal-cover,
.related-cover,
.collection-material-cover,
.tag-result-cover {
  display: block;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(30, 30, 30, 0.22);
  border-radius: 8px;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.96), rgba(30, 30, 30, 0.26));
  box-shadow: 0 10px 18px rgba(31, 31, 31, 0.12);
}

.cover-frame.is-placeholder,
.modal-cover.is-placeholder,
.related-cover.is-placeholder,
.collection-material-cover.is-placeholder,
.tag-result-cover.is-placeholder {
  background: linear-gradient(90deg, rgba(31, 31, 31, 0.16) 0 8px, transparent 8px), linear-gradient(145deg, var(--detail-cover-paper, #F6F6F6), #FFFFFF 58%, rgba(30, 30, 30, 0.42));
  box-shadow: 0 10px 18px rgba(31, 31, 31, 0.1);
}

.cover-frame.is-placeholder::before,
.modal-cover.is-placeholder::before,
.related-cover.is-placeholder::before,
.collection-material-cover.is-placeholder::before,
.tag-result-cover.is-placeholder::before {
  content: "";
  position: absolute;
  inset: 12px 11px;
  border: 1px solid var(--detail-cover-line, rgba(30, 30, 30, 0.22));
  border-radius: 6px;
  pointer-events: none;
}

.cover-frame .cover-placeholder,
.modal-cover .cover-placeholder,
.related-cover .cover-placeholder,
.collection-material-cover .cover-placeholder,
.tag-result-cover .cover-placeholder {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr auto;
  gap: 8px;
  padding: 16px 13px 14px 18px;
  color: var(--design-accent-strong);
}

.cover-placeholder .placeholder-type {
  justify-self: start;
  max-width: 100%;
  overflow: hidden;
  border: 1px solid rgba(30, 30, 30, 0.2);
  border-radius: 999px;
  padding: 3px 7px;
  background: rgba(255, 255, 255, 0.68);
  color: var(--design-accent);
  font-size: 10px;
  font-weight: 900;
  line-height: 1.1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cover-placeholder strong {
  align-self: center;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  color: var(--design-accent-strong);
  font-size: 12.5px;
  font-weight: 920;
  line-height: 1.34;
  overflow-wrap: anywhere;
}

.cover-placeholder em {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: var(--design-text-secondary);
  font-size: 10.5px;
  font-style: normal;
  font-weight: 820;
  line-height: 1.3;
}

.collection-material-cover,
.tag-result-cover {
  width: 54px;
  aspect-ratio: 3/4;
  align-self: center;
  margin-top: 0;
  color: inherit;
  font-size: inherit;
  text-overflow: clip;
  white-space: normal;
}

.collection-material-cover img,
.tag-result-cover img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.collection-material-cover .cover-placeholder,
.tag-result-cover .cover-placeholder {
  gap: 3px;
  padding: 7px 6px 7px 9px;
}

.collection-material-cover .cover-placeholder .placeholder-type,
.tag-result-cover .cover-placeholder .placeholder-type {
  margin-top: 0;
  padding: 2px 5px;
  font-size: 8px;
}

.collection-material-cover .cover-placeholder strong,
.tag-result-cover .cover-placeholder strong {
  margin-top: 0;
  -webkit-line-clamp: 3;
  font-size: 8.5px;
  line-height: 1.2;
}

.collection-material-cover .cover-placeholder em,
.tag-result-cover .cover-placeholder em {
  margin-top: 0;
  -webkit-line-clamp: 1;
  font-size: 7.5px;
  line-height: 1.2;
}

.tag-representative-material {
  display: grid;
  grid-template-columns: 54px minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  margin: 10px 0;
  padding: 9px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--page-bg);
}

.tag-representative-material > span:not(.tag-result-cover) {
  min-width: 0;
}

.tag-representative-material strong,
.tag-representative-material em {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tag-representative-material strong {
  color: var(--text);
  font-size: 13px;
  line-height: 1.35;
}

.tag-representative-material em {
  margin-top: 4px;
  color: var(--muted);
  font-size: 11px;
  font-style: normal;
  white-space: nowrap;
}

.detail-page .modal-cover {
  max-width: 312px;
  border-color: rgba(30, 30, 30, 0.24);
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.95), rgba(30, 30, 30, 0.22));
  box-shadow: 0 16px 30px rgba(31, 31, 31, 0.14);
}

.detail-page .modal-cover img {
  object-fit: cover;
}

.detail-page .modal-cover .cover-placeholder {
  padding: 24px 22px 22px 28px;
}

.detail-page .modal-cover .cover-placeholder .placeholder-type {
  font-size: 12px;
}

.detail-page .modal-cover .cover-placeholder strong {
  font-size: 20px;
  line-height: 1.34;
  -webkit-line-clamp: 6;
}

.detail-page .modal-cover .cover-placeholder em {
  font-size: 13px;
}

.detail-page .detail-title-row {
  align-items: center;
  gap: 10px;
}

.detail-page .detail-title-row .book-category,
.detail-page .detail-id-badge {
  border-color: var(--detail-card-border);
  background: rgba(255, 255, 255, 0.64);
  color: var(--design-text-secondary);
}

.detail-page .detail-content h2 {
  margin: 13px 0 18px;
  color: var(--design-text);
  font-size: 32px;
  line-height: 1.25;
  font-weight: 920;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.detail-page .bibliographic-list {
  margin-top: 0;
  padding: 0 18px;
  border: 1px solid var(--detail-card-border);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.74);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.64);
}

.detail-page .bibliographic-list div {
  grid-template-columns: minmax(128px, 164px) minmax(0, 1fr);
  gap: 20px;
  min-height: 46px;
  padding: 12px 0;
  border-bottom-color: rgba(31, 31, 31, 0.14);
}

.detail-page .bibliographic-list dt {
  color: var(--design-text-muted);
  font-size: 13.5px;
  font-weight: 900;
}

.detail-page .bibliographic-list dd {
  color: var(--design-text);
  font-size: 15.5px;
  font-weight: 760;
  line-height: 1.55;
}

.detail-summary-strip {
  margin-top: 14px;
  padding: 14px 16px;
  border: 1px solid rgba(31, 31, 31, 0.14);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.42);
}

.detail-summary-strip .modal-description {
  margin: 0;
  color: var(--design-text-secondary);
}

.detail-page .detail-primary-tags {
  margin: 12px 0 0;
}

.detail-page .detail-primary-tags button {
  border: 1px solid rgba(30, 30, 30, 0.18);
  background: rgba(255, 255, 255, 0.64);
  color: var(--design-accent);
}

.detail-page .detail-primary-tags button.has-graph,
.detail-page .detail-primary-tags button:hover,
.detail-page .detail-primary-tags button:focus-visible {
  border-color: var(--design-accent);
  background: var(--design-accent-wash);
  color: var(--design-accent-strong);
  box-shadow: var(--design-focus-ring);
}

.detail-page .detail-action-group {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 9px;
  margin-top: 16px;
}

.detail-page .detail-action-group .source-link,
.detail-page .detail-action-group .source-action-button,
.detail-page .detail-action-group .source-missing {
  justify-content: center;
  min-width: 0;
  min-height: 46px;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 13.5px;
  line-height: 1.25;
  white-space: normal;
}

.detail-page .detail-action-group .detail-action-primary {
  border-color: var(--design-accent);
  background: var(--design-accent);
  color: var(--design-on-accent);
  font-weight: 920;
}

.detail-page .detail-action-group .detail-action-primary:hover,
.detail-page .detail-action-group .detail-action-primary:focus-visible {
  border-color: var(--design-accent-strong);
  background: var(--design-accent-strong);
  color: var(--design-on-accent);
  box-shadow: var(--design-focus-ring);
}

.detail-page .detail-action-group .detail-action-default.secondary,
.detail-page .detail-action-group .source-link.secondary {
  border-color: var(--design-border-soft);
  background: rgba(255, 255, 255, 0.76);
  color: var(--design-accent);
  box-shadow: none;
}

.detail-page .detail-action-group .detail-action-default.secondary:hover,
.detail-page .detail-action-group .detail-action-default.secondary:focus-visible,
.detail-page .detail-action-group .source-link.secondary:hover,
.detail-page .detail-action-group .source-link.secondary:focus-visible {
  border-color: var(--design-accent);
  background: var(--design-accent-wash);
  color: var(--design-accent-strong);
  box-shadow: var(--design-focus-ring);
}

.detail-page .detail-action-group .detail-action-missing {
  border: 1px solid rgba(31, 31, 31, 0.14);
  background: rgba(255, 255, 255, 0.48);
  color: var(--design-text-muted);
  font-size: 12.5px;
  font-weight: 780;
}

.detail-page .graph-entry-panel {
  margin-top: 14px;
  border-color: rgba(30, 30, 30, 0.18);
  background: rgba(255, 255, 255, 0.5);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.58);
}

.detail-page .graph-entry-metrics div {
  border-color: rgba(31, 31, 31, 0.14);
  background: rgba(255, 255, 255, 0.66);
}

.detail-page .detail-management-section {
  margin-top: 16px;
  padding: 16px;
  border: 1px solid rgba(31, 31, 31, 0.14);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.54);
  box-shadow: none;
}

.detail-page .detail-status-grid-primary {
  gap: 10px;
}

.detail-page .detail-status-card {
  border-color: rgba(31, 31, 31, 0.14);
  background: rgba(255, 255, 255, 0.58);
  box-shadow: none;
}

.detail-page .detail-status-card .status-label {
  color: var(--design-text-muted);
}

.detail-page .detail-status-card strong {
  color: var(--design-text);
}

.detail-page .detail-status-card small {
  color: var(--design-text-secondary);
}

.detail-page .internal-management-group {
  margin-top: 12px;
  border-color: rgba(30, 30, 30, 0.12);
  background: rgba(255, 255, 255, 0.36);
  box-shadow: none;
}

.detail-page .internal-management-label {
  min-height: 42px;
  color: var(--design-text-muted);
  font-size: 13px;
}

.detail-page .internal-management-label::after {
  border-color: rgba(31, 31, 31, 0.16);
  background: rgba(255, 255, 255, 0.56);
  color: var(--design-text-muted);
}

.detail-page .internal-management-grid .detail-status-card {
  background: rgba(255, 255, 255, 0.46);
}

.detail-page .detail-demo-actions {
  border-color: rgba(102, 102, 102, 0.14);
  background: rgba(30, 30, 30, 0.22);
  box-shadow: none;
}

.detail-page .knowledge-section,
.detail-page .toc-summary-grid,
.detail-page .search-graph-grid {
  margin-top: 18px;
  padding-top: 0;
  border-top: 0;
  background: transparent;
  box-shadow: none;
}

.detail-page .knowledge-block,
.detail-page .toc-summary-grid > .detail-section,
.detail-page .search-graph-grid > .detail-section,
.detail-page .ai-workbench-section,
.detail-page .report-assist-section,
.detail-page .reader-section,
.detail-page .related-section {
  margin-top: 0;
  padding: 18px;
  border: 1px solid var(--detail-card-border);
  border-radius: 8px;
  background: var(--detail-card-gradient);
  box-shadow: var(--design-shadow);
}

.detail-page .reader-section,
.detail-page .related-section,
.detail-page .ai-workbench-section,
.detail-page .report-assist-section {
  margin-top: 18px;
}

.detail-page .section-heading h3 {
  color: var(--design-text);
  font-weight: 900;
}

.detail-page .section-heading span {
  border: 1px solid rgba(31, 31, 31, 0.14);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.58);
  color: var(--design-text-secondary);
  font-weight: 850;
}

.detail-page .axis-tag-group,
.detail-page .public-tag-box,
.detail-page .alias-panel,
.detail-page .ai-evidence-grid article,
.detail-page .report-evidence-row,
.detail-page .report-citation-row,
.detail-page .issue-evidence-group,
.detail-page .report-tool-grid > section,
.detail-page .search-results article,
.detail-page .reader-search-results,
.detail-page .graph-edge-list {
  border-color: rgba(31, 31, 31, 0.16);
  background: rgba(255, 255, 255, 0.62);
  box-shadow: none;
}

.detail-page .tag-chip,
.detail-page .review-flow span,
.detail-page .typed-evidence-list span,
.detail-page .graph-status-pill {
  border: 1px solid rgba(31, 31, 31, 0.16);
  background: rgba(255, 255, 255, 0.62);
  color: var(--design-text-secondary);
}

.detail-page .tag-chip.public-chip,
.detail-page .review-flow span.is-active {
  border-color: rgba(30, 30, 30, 0.24);
  background: rgba(30, 30, 30, 0.08);
  color: var(--design-accent);
}

.detail-page .body-search-row,
.detail-page .ai-question-box {
  padding: 12px;
  border: 1px solid rgba(31, 31, 31, 0.14);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.54);
}

.detail-page .ai-answer,
.detail-page .structured-ai-answer {
  border-color: rgba(31, 31, 31, 0.16);
  background: rgba(255, 255, 255, 0.56);
  color: var(--design-text);
}

.detail-page .evidence-snippet,
.detail-page .report-warning {
  border-color: rgba(94, 102, 118, 0.2);
  background: rgba(94, 102, 118, 0.08);
  color: var(--design-text);
}

.detail-page .detail-section .source-action-button:not(.primary-action),
.detail-page .reader-section .source-action-button:not(.primary-action),
.detail-page .report-assist-section .source-action-button:not(.primary-action),
.detail-page .graph-tool-actions button,
.detail-page .graph-view-actions button,
.detail-page .ai-evidence-grid article button,
.detail-page .report-evidence-row button,
.detail-page .report-section-title button {
  border-color: var(--design-border-soft);
  background: rgba(255, 255, 255, 0.76);
  color: var(--design-accent);
  box-shadow: none;
}

.detail-page .detail-section .source-action-button:not(.primary-action):hover,
.detail-page .detail-section .source-action-button:not(.primary-action):focus-visible,
.detail-page .reader-section .source-action-button:not(.primary-action):hover,
.detail-page .reader-section .source-action-button:not(.primary-action):focus-visible,
.detail-page .report-assist-section .source-action-button:not(.primary-action):hover,
.detail-page .report-assist-section .source-action-button:not(.primary-action):focus-visible,
.detail-page .graph-tool-actions button:hover,
.detail-page .graph-tool-actions button:focus-visible,
.detail-page .graph-view-actions button:hover,
.detail-page .graph-view-actions button:focus-visible,
.detail-page .ai-evidence-grid article button:hover,
.detail-page .ai-evidence-grid article button:focus-visible,
.detail-page .report-evidence-row button:hover,
.detail-page .report-evidence-row button:focus-visible,
.detail-page .report-section-title button:hover,
.detail-page .report-section-title button:focus-visible {
  border-color: var(--design-accent);
  background: var(--design-accent-wash);
  color: var(--design-accent-strong);
  box-shadow: var(--design-focus-ring);
}

.detail-page .ai-action-row .source-action-button.primary-action {
  border-color: var(--design-accent);
  background: var(--design-accent);
  color: var(--design-on-accent);
}

.detail-page .related-grid {
  grid-template-columns: repeat(auto-fill, minmax(154px, 1fr));
  gap: 12px;
}

.detail-page .related-card {
  display: grid;
  align-content: start;
  gap: 8px;
  padding: 12px;
  border-color: rgba(30, 30, 30, 0.18);
  background: rgba(255, 255, 255, 0.68);
  color: var(--design-text);
  text-decoration: none;
  box-shadow: 0 1px 2px rgba(31, 31, 31, 0.08);
  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.detail-page .related-card:hover,
.detail-page .related-card:focus-visible {
  transform: translateY(-2px);
  border-color: var(--design-accent);
  background: rgba(255, 255, 255, 0.82);
  box-shadow: var(--design-hover-shadow);
  outline: none;
}

.detail-page .related-cover {
  display: block;
  width: 100%;
  aspect-ratio: 3/4.15;
}

.detail-page .related-cover img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.detail-page .related-card .related-cover,
.detail-page .related-card .cover-placeholder,
.detail-page .related-card .cover-placeholder span,
.detail-page .related-card .cover-placeholder strong,
.detail-page .related-card .cover-placeholder em {
  -webkit-box-orient: initial;
}

.detail-page .related-card .cover-placeholder {
  display: grid;
  margin: 0;
}

.detail-page .related-card .cover-placeholder .placeholder-type {
  display: block;
}

.detail-page .related-card .cover-placeholder strong {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}

.detail-page .related-card > span:not(.related-cover) {
  margin-top: 0;
  color: var(--design-text);
  font-size: 13px;
  font-weight: 880;
  line-height: 1.35;
}

.detail-page .related-card small {
  margin-top: 0;
  color: var(--design-text-secondary);
}

.detail-page .related-card em {
  margin-top: 0;
  color: var(--design-accent);
}

@media (max-width: 1120px) {
  .detail-page .detail-layout,
  .detail-page .knowledge-section,
  .detail-page .toc-summary-grid,
  .detail-page .search-graph-grid {
    grid-template-columns: 1fr;
  }
  .detail-page .detail-action-group,
  .detail-page .detail-status-grid-primary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .detail-page .detail-panel,
  .detail-page .knowledge-block,
  .detail-page .toc-summary-grid > .detail-section,
  .detail-page .search-graph-grid > .detail-section,
  .detail-page .ai-workbench-section,
  .detail-page .report-assist-section,
  .detail-page .reader-section,
  .detail-page .related-section,
  .detail-page .detail-management-section {
    padding: 15px;
  }
  .detail-page .modal-cover {
    width: min(200px, 100%);
    max-width: 200px;
  }
  .detail-page .detail-content h2 {
    font-size: 25px;
  }
  .detail-page .bibliographic-list {
    padding: 0 12px;
  }
  .detail-page .bibliographic-list div,
  .detail-page .detail-action-group,
  .detail-page .detail-status-grid-primary {
    grid-template-columns: 1fr;
  }
  .detail-page .body-search-row,
  .detail-page .ai-question-box,
  .detail-page .report-tool-grid,
  .detail-page .ai-evidence-grid {
    grid-template-columns: 1fr;
  }
}
/* Review 104: knowledge graph charcoal/warm tone and default clarity. */
.library-page {
  --graph-line-default: rgba(30, 30, 30, 0.48);
  --graph-line-strong: rgba(31, 31, 31, 0.7);
  --graph-line-muted: rgba(102, 102, 102, 0.4);
  --graph-line-selected: var(--design-accent-strong);
  --graph-node-shadow: 0 9px 18px rgba(31, 31, 31, 0.11);
  --graph-node-shadow-strong: 0 16px 30px rgba(31, 31, 31, 0.16);
}

.graph-book-tab-section,
.collection-graph-section {
  border-color: var(--design-border);
  background: rgba(255, 255, 255, 0.9);
  box-shadow: var(--design-shadow);
}

.graph-toolbar,
.graph-view-actions,
.book-graph-summary-panel,
.graph-legend,
.graph-inspector,
.graph-edge-list {
  border-color: var(--design-border);
  background: var(--design-card-tinted);
  color: var(--design-text);
}

.graph-toolbar .control select,
.graph-toolbar .control input {
  border-color: var(--design-border-soft);
  background: rgba(255, 255, 255, 0.88);
  color: var(--design-text);
}

.graph-toolbar .control select:focus,
.graph-toolbar .control input:focus {
  border-color: var(--design-accent);
  box-shadow: var(--design-focus-ring);
}

.graph-target-row .source-action-button,
.graph-tool-actions button,
.graph-view-actions button {
  border-color: var(--design-border-soft);
  background: rgba(255, 255, 255, 0.82);
  color: var(--design-accent);
  box-shadow: none;
}

.graph-target-row .source-action-button,
.graph-view-actions button:last-child {
  border-color: var(--design-accent);
  background: var(--design-accent);
  color: var(--design-on-accent);
}

.graph-target-row .source-action-button:hover,
.graph-target-row .source-action-button:focus-visible,
.graph-tool-actions button:hover,
.graph-tool-actions button:focus-visible,
.graph-view-actions button:hover,
.graph-view-actions button:focus-visible {
  border-color: var(--design-accent-strong);
  background: var(--design-accent-wash);
  color: var(--design-accent-strong);
  box-shadow: var(--design-focus-ring);
}

.graph-target-row .source-action-button:hover,
.graph-target-row .source-action-button:focus-visible,
.graph-view-actions button:last-child:hover,
.graph-view-actions button:last-child:focus-visible {
  background: var(--design-accent-strong);
  color: var(--design-on-accent);
}

.graph-tool-actions button:disabled,
.graph-view-actions button:disabled,
.graph-target-row .source-action-button:disabled {
  border-color: var(--design-border);
  background: rgba(255, 255, 255, 0.48);
  color: var(--design-text-disabled);
  box-shadow: none;
}

.graph-canvas,
.collection-graph-canvas {
  min-height: 670px;
  border-color: rgba(30, 30, 30, 0.22);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.92), rgba(255, 255, 255, 0.62)), var(--design-card-bg);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.72), var(--design-shadow);
}

.graph-canvas::before,
.graph-canvas::after,
.collection-graph-canvas::before,
.collection-graph-canvas::after {
  border-color: rgba(30, 30, 30, 0.13);
}

.graph-node {
  border-color: var(--node-border);
  background: var(--node-bg);
  color: var(--node-text);
  box-shadow: var(--graph-node-shadow);
  opacity: 1;
  filter: none;
}

.graph-node.type-자료 {
  --node-accent: var(--design-accent);
  --node-border: rgba(30, 30, 30, 0.54);
  --node-bg: #FFFFFF;
  --node-text: var(--design-text);
  --node-muted: var(--design-text-secondary);
  --node-type-bg: var(--design-accent-wash);
  --node-type-border: var(--design-border);
}

.graph-node.type-관련-자료,
.collection-resource-node {
  --node-accent: var(--design-text-secondary);
  --node-border: rgba(30, 30, 30, 0.34);
  --node-bg: rgba(255, 255, 255, 0.76);
  --node-text: var(--design-text);
  --node-muted: var(--design-text-secondary);
  --node-type-bg: rgba(255, 255, 255, 0.84);
  --node-type-border: var(--design-border);
}

.graph-node.type-주제,
.collection-tag-node {
  --node-accent: var(--design-accent);
  --node-border: rgba(30, 30, 30, 0.5);
  --node-bg: rgba(255, 255, 255, 0.84);
  --node-text: var(--design-accent-strong);
  --node-muted: var(--design-accent);
  --node-type-bg: rgba(255, 255, 255, 0.86);
  --node-type-border: var(--design-border);
}

.graph-node.type-장소 {
  --node-accent: var(--design-olive);
  --node-border: rgba(94, 102, 118, 0.54);
  --node-bg: rgba(94, 102, 118, 0.12);
  --node-text: #4F5662;
  --node-muted: #636B76;
  --node-type-bg: rgba(255, 255, 255, 0.88);
  --node-type-border: rgba(94, 102, 118, 0.28);
}

.graph-node.type-인물,
.graph-node.type-기관 {
  --node-accent: var(--design-brown);
  --node-border: rgba(102, 102, 102, 0.42);
  --node-bg: rgba(30, 30, 30, 0.4);
  --node-text: var(--design-brown);
  --node-muted: var(--design-brown);
  --node-type-bg: rgba(255, 255, 255, 0.86);
  --node-type-border: rgba(102, 102, 102, 0.22);
}

.graph-node.type-사건,
.graph-node.type-시대 {
  --node-accent: #9C6D45;
  --node-border: rgba(156, 109, 69, 0.46);
  --node-bg: rgba(104, 112, 134, 0.22);
  --node-text: var(--design-brown);
  --node-muted: var(--design-brown);
  --node-type-bg: rgba(255, 255, 255, 0.86);
  --node-type-border: rgba(156, 109, 69, 0.24);
}

.graph-node.type-개념,
.graph-node.type-문헌-법령 {
  --node-accent: var(--design-text-secondary);
  --node-border: rgba(30, 30, 30, 0.28);
  --node-bg: rgba(30, 30, 30, 0.08);
  --node-text: var(--design-text);
  --node-muted: var(--design-text-secondary);
  --node-type-bg: rgba(255, 255, 255, 0.86);
  --node-type-border: var(--design-border);
}

.graph-node.type-주장,
.graph-node.type-쟁점,
.graph-node.type-반박,
.graph-node.type-쟁점-반박 {
  --node-accent: #6F4A38;
  --node-border: rgba(111, 74, 56, 0.45);
  --node-bg: rgba(104, 112, 134, 0.2);
  --node-text: #666666;
  --node-muted: #666666;
  --node-type-bg: rgba(255, 255, 255, 0.86);
  --node-type-border: rgba(111, 74, 56, 0.22);
}

.graph-node.type-근거-후보,
.collection-outer-node {
  --node-accent: var(--design-text-muted);
  --node-border: rgba(30, 30, 30, 0.24);
  --node-bg: rgba(255, 255, 255, 0.9);
  --node-text: var(--design-text-secondary);
  --node-muted: var(--design-text-muted);
  --node-type-bg: rgba(255, 255, 255, 0.64);
  --node-type-border: var(--design-border);
}

.collection-central-node,
.graph-node.shape-central-topic,
.graph-node.type-자료.shape-central-topic,
.graph-node.type-주제.shape-central-topic,
.graph-canvas .graph-central-node.shape-material-card {
  --node-accent: var(--design-accent-strong);
  --node-border: var(--design-accent-strong);
  --node-bg: var(--design-accent);
  --node-text: #FFFFFF;
  --node-muted: rgba(255, 255, 255, 0.9);
  --node-type-bg: rgba(255, 255, 255, 0.16);
  --node-type-border: rgba(255, 255, 255, 0.34);
  box-shadow: var(--graph-node-shadow-strong);
}

.graph-canvas .graph-central-node.shape-material-card .graph-node-title,
.collection-central-node .graph-node-title,
.graph-node.shape-central-topic .graph-node-title,
.graph-canvas .graph-central-node.shape-material-card .graph-node-type,
.graph-canvas .graph-central-node.shape-material-card .graph-node-status,
.graph-canvas .graph-central-node.shape-material-card em {
  color: var(--node-text);
}

.graph-node.is-selected,
.graph-node.is-related {
  opacity: 1;
  filter: none;
  box-shadow: 0 0 0 3px rgba(31, 31, 31, 0.16), var(--graph-node-shadow-strong);
}

.graph-node.is-related {
  border-color: var(--node-accent);
}

.graph-node.is-dimmed,
.graph-edge-button.is-dimmed {
  opacity: 0.32;
  filter: saturate(0.62);
}

.graph-link {
  stroke: var(--graph-line-default);
  stroke-width: 1.6px;
  opacity: 0.72;
}

.graph-link.is-reviewed,
.graph-link.is-evidence-complete {
  stroke: var(--graph-line-strong);
  stroke-width: 1.75px;
  opacity: 0.84;
}

.graph-link.is-metadata-recommendation:not(.is-selected):not(.is-dimmed),
.graph-link.is-pending-review:not(.is-selected):not(.is-dimmed),
.graph-link.is-pending-evidence:not(.is-selected):not(.is-dimmed) {
  stroke: var(--graph-line-muted);
  stroke-dasharray: 3 6;
  stroke-width: 1.35px;
  opacity: 0.52;
}

.graph-link.is-central-direct,
.graph-link.is-direct,
.graph-link.is-hovered {
  stroke: var(--graph-line-strong);
  stroke-dasharray: none;
  stroke-width: 2px;
  opacity: 0.92;
}

.graph-link.is-selected,
.graph-link.is-reviewed.is-selected,
.graph-link.is-evidence-complete.is-selected,
.graph-link.is-metadata-recommendation.is-selected,
.graph-link.is-pending-review.is-selected,
.graph-link.is-pending-evidence.is-selected,
.graph-link.is-direct.is-selected,
.graph-link.is-hovered.is-selected {
  stroke: var(--graph-line-selected);
  stroke-dasharray: none;
  stroke-width: 2.8px;
  opacity: 1;
}

.graph-link.is-dimmed,
.graph-link.is-central-direct.is-dimmed,
.graph-link.is-direct.is-dimmed,
.graph-link.is-hovered.is-dimmed {
  stroke: rgba(30, 30, 30, 0.2);
  stroke-width: 1.05px;
  opacity: 0.22;
}

.graph-link-label,
.graph-link-status {
  border-color: var(--design-border);
  background: rgba(255, 255, 255, 0.9);
  color: var(--design-accent);
  box-shadow: 0 2px 6px rgba(31, 31, 31, 0.08);
}

.graph-link-label.is-selected,
.graph-link-label.is-direct,
.graph-link-label.is-hovered,
.graph-link-status.is-selected,
.graph-link-status.is-direct,
.graph-link-status.is-hovered {
  border-color: var(--design-accent);
  color: var(--design-accent-strong);
}

.graph-link-label.is-dimmed,
.graph-link-status.is-dimmed {
  opacity: 0.36;
}

.graph-edge-button {
  border-color: var(--design-border);
  border-left-color: var(--design-accent);
  background: rgba(255, 255, 255, 0.88);
  color: var(--design-text);
  box-shadow: var(--design-shadow);
}

.graph-edge-button.is-metadata-recommendation,
.graph-edge-button.is-pending-evidence,
.graph-edge-button.is-pending-review {
  border-left-color: var(--design-brown);
  background: rgba(255, 255, 255, 0.72);
}

.graph-edge-button.is-reviewed,
.graph-edge-button.is-evidence-complete {
  border-left-color: var(--design-olive);
  background: rgba(94, 102, 118, 0.08);
}

.graph-edge-button.is-selected,
.graph-edge-button.is-related,
.graph-edge-button:hover:not(.is-dimmed),
.graph-edge-button:focus-visible:not(.is-dimmed) {
  border-color: var(--design-accent);
  border-left-color: var(--design-accent-strong);
  background: var(--design-accent-wash);
  box-shadow: var(--design-focus-ring), var(--design-shadow);
}

.graph-inspector-kind,
.graph-inspector-title,
.graph-edge-button strong,
.graph-legend-group strong,
.book-graph-summary-panel strong {
  color: var(--design-accent-strong);
}

.graph-inspector-meta div,
.graph-inspector-metrics div,
.graph-inspector-material-list,
.graph-inspector-evidence-list article,
.graph-inspector-disclosure,
.graph-summary-card,
.book-graph-summary-panel div {
  border-color: var(--design-border);
  background: rgba(255, 255, 255, 0.68);
}

.graph-inspector-actions .source-action-button:not(:disabled),
.graph-inspector-evidence-actions button:not(:disabled) {
  border-color: var(--design-border-soft);
  background: rgba(255, 255, 255, 0.82);
  color: var(--design-accent);
}

.graph-inspector-actions .source-action-button:not(:disabled):hover,
.graph-inspector-actions .source-action-button:not(:disabled):focus-visible,
.graph-inspector-evidence-actions button:not(:disabled):hover,
.graph-inspector-evidence-actions button:not(:disabled):focus-visible {
  border-color: var(--design-accent);
  background: var(--design-accent-wash);
  color: var(--design-accent-strong);
  box-shadow: var(--design-focus-ring);
}

.graph-legend-dot.type-material,
.graph-legend-dot.type-related-material {
  background: #FFFFFF;
  color: var(--design-accent);
}

.graph-legend-dot.type-central-topic {
  background: var(--design-accent);
  color: var(--design-accent);
}

.graph-legend-dot.type-topic {
  background: rgba(255, 255, 255, 0.86);
  color: var(--design-accent);
}

.graph-legend-dot.type-place {
  background: rgba(94, 102, 118, 0.14);
  color: var(--design-olive);
}

.graph-legend-dot.type-event {
  background: rgba(104, 112, 134, 0.26);
  color: #9C6D45;
}

.graph-legend-dot.type-actor {
  background: rgba(30, 30, 30, 0.48);
  color: var(--design-brown);
}

.graph-legend-dot.type-concept,
.graph-legend-dot.type-evidence {
  background: rgba(30, 30, 30, 0.1);
  color: var(--design-text-secondary);
}

.graph-legend-dot.type-issue {
  background: rgba(104, 112, 134, 0.22);
  color: #6F4A38;
}

.graph-legend-line.status-reviewed,
.graph-legend-line.status-complete {
  background: var(--graph-line-strong);
}

.graph-legend-line.status-metadata,
.graph-legend-line.status-pending {
  background: repeating-linear-gradient(90deg, var(--graph-line-muted), var(--graph-line-muted) 5px, transparent 5px, transparent 10px);
}

.graph-legend-line.status-selected {
  background: var(--graph-line-selected);
}

@media (max-width: 1120px) {
  .graph-canvas,
  .collection-graph-canvas {
    min-height: 620px;
  }
}
@media (max-width: 760px) {
  .graph-canvas,
  .collection-graph-canvas {
    min-height: 560px;
  }
  .graph-toolbar,
  .graph-view-actions {
    background: rgba(255, 255, 255, 0.72);
  }
}
/* Review 105: restrained autumn mute tone across search, detail, and graph surfaces. */
:host {
  --design-bg: #FFFFFF;
  --design-card-bg: #FFFFFF;
  --design-bg-muted: #FAFAFA;
  --design-card-tinted: #FAFAFA;
  --design-card-tinted-strong: rgba(30, 30, 30, 0.3);
  --design-card-olive: rgba(94, 102, 118, 0.08);
  --design-card-clay: rgba(102, 102, 102, 0.1);
  --design-text: #1F1F1F;
  --design-text-secondary: #666666;
  --design-text-muted: #8A8A8A;
  --design-text-disabled: #A0A0A0;
  --design-border: #E5E5E5;
  --design-border-soft: #D8D8D8;
  --design-accent: #1F1F1F;
  --design-accent-strong: #2B2B2B;
  --design-accent-wash: rgba(94, 102, 118, 0.08);
  --design-selected-bg: rgba(94, 102, 118, 0.1);
  --design-info: #5E6676;
  --design-info-muted: #666666;
  --design-brown: #666666;
  --design-olive: #5E6676;
  --design-clay: #666666;
  --design-cream: #FAFAFA;
  --design-beige: #F5F5F5;
  --design-pending: #F5F5F5;
  --design-pending-bg: rgba(30, 30, 30, 0.34);
  --design-shadow: 0 10px 30px rgba(30, 30, 30, 0.07);
  --design-shadow-strong: 0 14px 36px rgba(30, 30, 30, 0.09);
  --design-hover-shadow: 0 14px 34px rgba(30, 30, 30, 0.1);
  --design-focus-ring-color: rgba(94, 102, 118, 0.18);
  --design-focus-ring: 0 0 0 3px rgba(94, 102, 118, 0.18);
}

.library-page {
  --page-bg: var(--design-bg);
  --card-bg: var(--design-card-bg);
  --muted-bg: var(--design-bg-muted);
  --border: var(--design-border);
  --border-soft: var(--design-border-soft);
  --text: var(--design-text);
  --muted: var(--design-text-secondary);
  --faint: var(--design-text-disabled);
  --accent: var(--design-accent);
  --accent-hover: var(--design-accent-strong);
  --accent-soft: var(--design-selected-bg);
  --accent-wash: var(--design-accent-wash);
  --blue-muted: var(--design-border-soft);
  --blue-soft: var(--design-info);
  --pending: var(--design-pending);
  --pending-bg: var(--design-pending-bg);
  --pending-text: var(--design-pending-text);
  --surface-shadow: var(--design-shadow);
  --surface-shadow-strong: var(--design-shadow-strong);
  --focus-ring: var(--design-focus-ring);
  --graph-line-default: rgba(94, 102, 118, 0.42);
  --graph-line-strong: rgba(31, 31, 31, 0.68);
  --graph-line-muted: rgba(102, 102, 102, 0.34);
  --graph-line-selected: var(--design-accent-strong);
  --graph-node-shadow: 0 8px 22px rgba(30, 30, 30, 0.08);
  --graph-node-shadow-strong: 0 14px 34px rgba(30, 30, 30, 0.12);
  background: var(--page-bg);
}

.topic-quickbar,
.top-tabbar,
.search-next-panel,
.search-result-tabs,
.result-collection-panel,
.typed-result-card,
.book-card,
.detail-panel,
.detail-section,
.detail-management-section,
.knowledge-block,
.ai-workbench-section,
.report-assist-section,
.graph-book-tab-section,
.collection-graph-section,
.reader-section,
.related-card,
.detail-status-card,
.graph-inspector,
.graph-summary-card,
.control-panel,
.active-filter-panel,
.search-empty-state {
  border-color: var(--design-border);
  background: #FFFFFF;
  box-shadow: 0 10px 30px rgba(30, 30, 30, 0.055);
}

.topic-graph-card,
.search-expansion-notice,
.search-match-panel,
.public-tag-box,
.graph-metadata-notice,
.reader-search-results,
.graph-edge-list,
.book-graph-summary-panel,
.graph-toolbar,
.graph-view-actions,
.graph-legend {
  border-color: var(--design-border);
  background: #FAFAFA;
  box-shadow: none;
}

.control input,
.control select,
.control textarea,
.home-search-control input,
.search-control input,
.reader-search input,
.page-jump input,
.graph-toolbar .control select,
.graph-toolbar .control input {
  border-color: var(--design-border);
  background: #FFFFFF;
  color: var(--design-text);
}

.control input:focus,
.control select:focus,
.control textarea:focus,
.home-search-control input:focus,
.search-control input:focus,
.reader-search input:focus,
.page-jump input:focus,
.graph-toolbar .control select:focus,
.graph-toolbar .control input:focus {
  border-color: var(--design-olive);
  background: #FFFFFF;
  box-shadow: var(--design-focus-ring);
}

.source-link.primary-source,
.source-action-button.primary-action,
.primary-graph-action,
.primary-demo-action,
.home-search-button,
.book-result-actions button:first-child,
.search-box button,
.graph-action,
.source-action-button:not(.secondary),
.search-match-panel button,
.search-next-panel button:first-of-type,
.empty-action-row .source-action-button:first-child,
.graph-target-row .source-action-button,
.graph-view-actions button:last-child {
  border-color: var(--design-accent);
  background: var(--design-accent);
  color: var(--design-on-accent);
  box-shadow: none;
}

.source-link.primary-source:hover,
.source-link.primary-source:focus-visible,
.source-action-button.primary-action:hover,
.source-action-button.primary-action:focus-visible,
.primary-graph-action:hover,
.primary-graph-action:focus-visible,
.primary-demo-action:hover,
.primary-demo-action:focus-visible,
.home-search-button:hover,
.home-search-button:focus-visible,
.book-result-actions button:first-child:hover,
.book-result-actions button:first-child:focus-visible,
.source-action-button:not(.secondary):hover,
.source-action-button:not(.secondary):focus-visible,
.search-match-panel button:hover,
.search-match-panel button:focus-visible,
.search-next-panel button:first-of-type:hover,
.search-next-panel button:first-of-type:focus-visible,
.empty-action-row .source-action-button:first-child:hover,
.empty-action-row .source-action-button:first-child:focus-visible,
.graph-target-row .source-action-button:hover,
.graph-target-row .source-action-button:focus-visible,
.graph-view-actions button:last-child:hover,
.graph-view-actions button:last-child:focus-visible {
  border-color: var(--design-accent-strong);
  background: var(--design-accent-strong);
  color: var(--design-on-accent);
  box-shadow: none;
}

.source-action-button,
.source-link.secondary,
.reset-button,
.back-button,
.section-mini-button,
.inline-text-button,
.detail-primary-tags button,
.graph-entry-buttons button,
.reader-term-buttons button,
.search-next-panel button,
.book-result-actions button,
.graph-tool-actions button,
.graph-view-actions button,
.result-collection-grid button,
.result-group-grid button,
.empty-suggestion-block button {
  border-color: var(--design-border);
  background: #FFFFFF;
  color: var(--design-accent);
  box-shadow: none;
}

.source-action-button:hover,
.source-action-button:focus-visible,
.source-link.secondary:hover,
.source-link.secondary:focus-visible,
.reset-button:hover,
.reset-button:focus-visible,
.back-button:hover,
.back-button:focus-visible,
.section-mini-button:hover,
.section-mini-button:focus-visible,
.inline-text-button:hover,
.inline-text-button:focus-visible,
.detail-primary-tags button:hover,
.detail-primary-tags button:focus-visible,
.graph-entry-buttons button:hover,
.graph-entry-buttons button:focus-visible,
.reader-term-buttons button:hover,
.reader-term-buttons button:focus-visible,
.search-next-panel button:hover,
.search-next-panel button:focus-visible,
.book-result-actions button:hover,
.book-result-actions button:focus-visible,
.graph-tool-actions button:hover,
.graph-tool-actions button:focus-visible,
.graph-view-actions button:hover,
.graph-view-actions button:focus-visible,
.result-collection-grid button:hover,
.result-collection-grid button:focus-visible,
.result-group-grid button:hover,
.result-group-grid button:focus-visible,
.empty-suggestion-block button:hover,
.empty-suggestion-block button:focus-visible {
  border-color: var(--design-olive);
  background: rgba(94, 102, 118, 0.09);
  color: var(--design-accent-strong);
  box-shadow: none;
}

.tag-chip,
.tag-strip span,
.filter-chip,
.search-match-badges span,
.detail-id-badge,
.graph-status-pill,
.graph-edge-button small,
.graph-legend-chip,
.result-evidence-badge,
.typed-evidence-list span,
.original-state,
.detail-page .tag-chip,
.detail-page .review-flow span,
.detail-page .typed-evidence-list span,
.detail-page .graph-status-pill {
  border-color: rgba(221, 210, 196, 0.9);
  background: #FAFAFA;
  color: var(--design-text-secondary);
}

.search-result-tabs button.is-active,
.filter-chip:hover,
.filter-chip:focus-visible,
.tag-strip span[role=button]:hover,
.tag-strip span[role=button]:focus-visible,
.tag-strip span[role=button].is-active,
.detail-page .tag-chip.public-chip,
.detail-page .review-flow span.is-active {
  border-color: rgba(94, 102, 118, 0.24);
  background: rgba(94, 102, 118, 0.1);
  color: var(--design-accent);
}

.control-panel,
.active-filter-panel,
.search-result-tabs,
.search-next-panel,
.result-collection-panel,
.typed-result-card,
.shelf .book-card,
.shelf.search-result-shelf .book-card.search-result-card,
.search-empty-state,
.detail-page .detail-panel,
.detail-page .detail-section,
.detail-page .knowledge-block,
.detail-page .ai-workbench-section,
.detail-page .reader-section,
.detail-page .related-card {
  background: #FFFFFF;
}

.typed-result-card:hover,
.typed-result-card:focus-visible,
.shelf .book-card:hover,
.shelf .book-card:focus-visible,
.detail-page .related-card:hover,
.detail-page .related-card:focus-visible {
  transform: none;
  border-color: #D8D8D8;
  box-shadow: 0 12px 32px rgba(30, 30, 30, 0.08);
}

.search-match-panel,
.detail-page .ai-answer,
.detail-page .structured-ai-answer,
.detail-page .body-search-row,
.detail-page .ai-question-box,
.detail-page .detail-status-card,
.detail-page .detail-summary-strip,
.detail-page .graph-entry-panel,
.detail-page .reader-search-results,
.detail-page .graph-edge-list,
.search-material-meta div,
.typed-result-meta div {
  border-color: var(--design-border);
  background: #FAFAFA;
}

.search-match-badges span.match-badge-title,
.search-match-badges span.match-badge-biblio,
.search-match-badges span.match-badge-default {
  border-color: rgba(94, 102, 118, 0.18);
  background: rgba(94, 102, 118, 0.08);
  color: var(--design-accent);
}

.search-match-badges span.match-badge-tag,
.original-state.is-available {
  border-color: rgba(94, 102, 118, 0.2);
  background: rgba(94, 102, 118, 0.09);
  color: var(--design-olive);
}

.search-match-badges span.match-badge-body,
.original-state.is-limited {
  border-color: rgba(102, 102, 102, 0.2);
  background: rgba(102, 102, 102, 0.1);
  color: #8C5B36;
}

.evidence-snippet,
.detail-page .evidence-snippet,
.detail-page .report-warning {
  border-left-color: var(--design-olive);
  background: rgba(94, 102, 118, 0.08);
}

.evidence-snippet mark {
  background: rgba(30, 30, 30, 0.62);
  color: var(--design-text);
}

.detail-page {
  --detail-card-gradient: #FFFFFF;
  --detail-card-soft: #FAFAFA;
  --detail-card-glass: rgba(255, 255, 255, 0.82);
  --detail-cover-paper: #FAFAFA;
  --detail-cover-line: #E5E5E5;
  --detail-card-border: var(--design-border);
  --detail-card-shadow: 0 10px 30px rgba(30, 30, 30, 0.07);
}

.detail-page .detail-panel {
  background: #FFFFFF;
  box-shadow: 0 10px 30px rgba(30, 30, 30, 0.06);
}

.cover-frame,
.modal-cover,
.related-cover,
.collection-material-cover,
.tag-result-cover,
.cover-frame.is-placeholder,
.modal-cover.is-placeholder,
.related-cover.is-placeholder,
.collection-material-cover.is-placeholder,
.tag-result-cover.is-placeholder {
  border-color: rgba(221, 210, 196, 0.95);
  background: linear-gradient(90deg, rgba(94, 102, 118, 0.11) 0 7px, transparent 7px), linear-gradient(145deg, #FAFAFA, #FFFFFF 62%, rgba(30, 30, 30, 0.22));
  box-shadow: 0 10px 24px rgba(30, 30, 30, 0.07);
}

.cover-placeholder .placeholder-type {
  border-color: rgba(221, 210, 196, 0.9);
  background: rgba(255, 255, 255, 0.76);
  color: var(--design-olive);
}

.graph-book-tab-section,
.collection-graph-section {
  background: #FFFFFF;
}

.graph-canvas,
.collection-graph-canvas {
  border-color: var(--design-border);
  background: linear-gradient(rgba(221, 210, 196, 0.22) 1px, transparent 1px), linear-gradient(90deg, rgba(221, 210, 196, 0.22) 1px, transparent 1px), #FFFFFF;
  background-size: 28px 28px, 28px 28px, auto;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.72), 0 10px 30px rgba(30, 30, 30, 0.055);
}

.graph-toolbar,
.graph-view-actions,
.book-graph-summary-panel,
.graph-legend,
.graph-inspector,
.graph-edge-list {
  border-color: var(--design-border);
  background: #FAFAFA;
}

.graph-node,
.graph-node.type-자료,
.graph-node.type-관련-자료,
.collection-resource-node {
  --node-accent: var(--design-accent);
  --node-border: var(--design-border);
  --node-bg: #FFFFFF;
  --node-text: var(--design-text);
  --node-muted: var(--design-text-secondary);
  --node-type-bg: #FAFAFA;
  --node-type-border: var(--design-border);
  box-shadow: var(--graph-node-shadow);
}

.graph-node.type-주제,
.collection-tag-node {
  --node-accent: var(--design-olive);
  --node-border: rgba(94, 102, 118, 0.24);
  --node-bg: rgba(94, 102, 118, 0.09);
  --node-text: var(--design-accent);
  --node-muted: var(--design-text-secondary);
  --node-type-bg: rgba(255, 255, 255, 0.82);
  --node-type-border: rgba(94, 102, 118, 0.16);
}

.graph-node.type-장소,
.graph-node.type-기관,
.graph-node.type-인물 {
  --node-accent: #666A72;
  --node-border: rgba(102, 106, 114, 0.22);
  --node-bg: rgba(30, 30, 30, 0.22);
  --node-text: var(--design-text);
  --node-muted: var(--design-text-secondary);
  --node-type-bg: rgba(255, 255, 255, 0.82);
  --node-type-border: rgba(102, 106, 114, 0.16);
}

.graph-node.type-사건,
.graph-node.type-시대,
.graph-node.type-주장,
.graph-node.type-쟁점,
.graph-node.type-반박,
.graph-node.type-쟁점-반박 {
  --node-accent: #9C6D45;
  --node-border: rgba(102, 102, 102, 0.24);
  --node-bg: rgba(102, 102, 102, 0.11);
  --node-text: var(--design-text);
  --node-muted: var(--design-text-secondary);
  --node-type-bg: rgba(255, 255, 255, 0.82);
  --node-type-border: rgba(102, 102, 102, 0.18);
}

.graph-node.type-개념,
.graph-node.type-문헌-법령,
.graph-node.type-근거-후보,
.collection-outer-node {
  --node-accent: var(--design-text-secondary);
  --node-border: var(--design-border);
  --node-bg: #FAFAFA;
  --node-text: var(--design-text);
  --node-muted: var(--design-text-secondary);
  --node-type-bg: #FFFFFF;
  --node-type-border: var(--design-border);
}

.collection-central-node,
.graph-node.shape-central-topic,
.graph-node.type-자료.shape-central-topic,
.graph-node.type-주제.shape-central-topic,
.graph-canvas .graph-central-node.shape-material-card {
  --node-accent: var(--design-accent-strong);
  --node-border: var(--design-accent);
  --node-bg: var(--design-accent);
  --node-text: #FFFFFF;
  --node-muted: rgba(255, 255, 255, 0.86);
  --node-type-bg: rgba(255, 255, 255, 0.14);
  --node-type-border: rgba(255, 255, 255, 0.32);
  box-shadow: var(--graph-node-shadow-strong);
}

.graph-node.is-selected,
.graph-node.is-related {
  box-shadow: 0 0 0 3px rgba(94, 102, 118, 0.16), var(--graph-node-shadow-strong);
}

.graph-edge-button {
  border-color: var(--design-border);
  border-left-color: var(--design-olive);
  background: #FFFFFF;
  box-shadow: 0 8px 22px rgba(30, 30, 30, 0.05);
}

.graph-edge-button.is-metadata-recommendation,
.graph-edge-button.is-pending-evidence,
.graph-edge-button.is-pending-review {
  border-left-color: #666666;
  background: #FAFAFA;
}

.graph-link-label,
.graph-link-status {
  border-color: var(--design-border);
  background: rgba(255, 255, 255, 0.92);
  color: var(--design-accent);
  box-shadow: 0 2px 6px rgba(30, 30, 30, 0.06);
}

.graph-legend-dot.type-topic {
  background: rgba(94, 102, 118, 0.12);
  color: var(--design-olive);
}

.graph-legend-dot.type-event,
.graph-legend-dot.type-issue {
  background: rgba(102, 102, 102, 0.14);
  color: #9C6D45;
}

.graph-legend-dot.type-actor {
  background: rgba(30, 30, 30, 0.34);
  color: #666A72;
}

.graph-legend-dot.type-concept,
.graph-legend-dot.type-evidence {
  background: #FAFAFA;
  color: var(--design-text-secondary);
}

@media (max-width: 760px) {
  .graph-toolbar,
  .graph-view-actions {
    background: #FAFAFA;
  }
}
/* Review 113: NAHF logo fallback cover for materials without real cover images. */
.cover-frame.is-placeholder,
.modal-cover.is-placeholder,
.related-cover.is-placeholder,
.collection-material-cover.is-placeholder,
.tag-result-cover.is-placeholder {
  background: linear-gradient(90deg, rgba(94, 102, 118, 0.11) 0 7px, transparent 7px), linear-gradient(145deg, #FAFAFA 0%, #FFFFFF 58%, rgba(30, 30, 30, 0.26) 100%);
}

.cover-frame.is-loading,
.modal-cover.is-loading,
.related-cover.is-loading,
.collection-material-cover.is-loading,
.tag-result-cover.is-loading {
  background: #FAFAFA;
}

.cover-frame.is-loading::after,
.modal-cover.is-loading::after,
.related-cover.is-loading::after,
.collection-material-cover.is-loading::after,
.tag-result-cover.is-loading::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 2;
  background: linear-gradient(90deg, #FAFAFA 0%, rgba(30, 30, 30, 0.46) 46%, #FAFAFA 100%);
  background-size: 220% 100%;
  animation: skeleton-pulse 1.1s ease-in-out infinite;
  pointer-events: none;
}

.cover-frame.is-loading img,
.modal-cover.is-loading img,
.related-cover.is-loading img,
.collection-material-cover.is-loading img,
.tag-result-cover.is-loading img {
  opacity: 0;
}

.cover-frame img,
.modal-cover img,
.related-cover img,
.collection-material-cover img,
.tag-result-cover img {
  transition: opacity 120ms ease;
}

.cover-frame .cover-placeholder,
.modal-cover .cover-placeholder,
.related-cover .cover-placeholder,
.collection-material-cover .cover-placeholder,
.tag-result-cover .cover-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 16px 12px 14px 18px;
  text-align: center;
}

.cover-fallback-brand {
  width: min(72%, 132px);
  min-height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 2px;
}

.cover-fallback-logo {
  display: block;
  width: 100%;
  max-width: 132px;
  max-height: 58px;
  object-fit: contain !important;
}

.cover-placeholder .placeholder-type {
  justify-self: auto;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cover-placeholder strong,
.cover-placeholder em {
  text-align: center;
}

.detail-page .modal-cover .cover-fallback-brand {
  width: min(66%, 190px);
  min-height: 68px;
  margin-bottom: 8px;
}

.detail-page .modal-cover .cover-fallback-logo {
  max-width: 190px;
  max-height: 84px;
}

.collection-material-cover .cover-placeholder,
.tag-result-cover .cover-placeholder,
.related-cover-placeholder {
  gap: 4px;
  padding: 8px 6px 7px 10px;
}

.collection-material-cover .cover-fallback-brand,
.tag-result-cover .cover-fallback-brand,
.related-cover-placeholder .cover-fallback-brand {
  width: 76%;
  min-height: 24px;
  margin-bottom: 0;
}

.collection-material-cover .cover-fallback-logo,
.tag-result-cover .cover-fallback-logo,
.related-cover-placeholder .cover-fallback-logo {
  max-height: 28px;
}

.collection-material-cover .cover-placeholder strong,
.tag-result-cover .cover-placeholder strong,
.related-cover-placeholder strong {
  display: none;
}

/* Review 118: charcoal-centered role tokens across search, detail, and graph. */
:host {
  --design-bg: var(--color-page-background);
  --design-card-bg: var(--color-card-background);
  --design-bg-muted: var(--color-surface-muted);
  --design-card-tinted: var(--color-surface-muted);
  --design-card-tinted-strong: var(--color-surface-muted-strong);
  --design-card-olive: rgba(94, 102, 118, 0.08);
  --design-card-clay: rgba(102, 102, 102, 0.08);
  --design-text: var(--color-text-heading);
  --design-text-secondary: var(--color-text-secondary);
  --design-text-muted: var(--color-text-placeholder);
  --design-text-disabled: rgba(30, 30, 30, 0.38);
  --design-border: var(--color-border-default);
  --design-border-soft: var(--color-cta-secondary-border);
  --design-border-strong: var(--color-border-emphasis);
  --design-accent: var(--color-cta-primary-bg);
  --design-accent-strong: var(--color-cta-primary-hover);
  --design-accent-wash: var(--color-surface-selected);
  --design-selected-bg: var(--color-surface-selected);
  --design-info: var(--color-support-green);
  --design-info-muted: rgba(94, 102, 118, 0.72);
  --design-brown: var(--color-support-taupe);
  --design-olive: var(--color-support-green);
  --design-clay: var(--color-support-clay);
  --design-cream: var(--color-surface-muted);
  --design-beige: var(--color-surface-muted-strong);
  --design-pending: var(--color-border-emphasis);
  --design-pending-bg: var(--color-status-warning-bg);
  --design-pending-text: var(--color-status-warning-text);
  --design-shadow: 0 10px 30px rgba(30, 30, 30, 0.055);
  --design-shadow-strong: 0 14px 36px rgba(30, 30, 30, 0.08);
  --design-hover-shadow: 0 14px 34px rgba(30, 30, 30, 0.1);
  --design-focus-ring-color: var(--color-focus-ring);
  --design-focus-ring: 0 0 0 3px var(--color-focus-ring);
  background: var(--color-page-background);
  color: var(--color-text-body);
}

.library-page {
  --page-bg: var(--color-page-background);
  --card-bg: var(--color-card-background);
  --muted-bg: var(--color-surface-muted);
  --border: var(--color-border-default);
  --border-soft: var(--color-cta-secondary-border);
  --text: var(--color-text-heading);
  --muted: var(--color-text-secondary);
  --faint: var(--color-text-placeholder);
  --accent: var(--color-cta-primary-bg);
  --accent-hover: var(--color-cta-primary-hover);
  --accent-soft: var(--color-surface-selected);
  --accent-wash: var(--color-surface-selected);
  --blue-muted: var(--color-cta-secondary-border);
  --blue-soft: var(--color-support-green);
  --pending: var(--color-border-emphasis);
  --pending-bg: var(--color-status-warning-bg);
  --pending-text: var(--color-status-warning-text);
  --surface-shadow: 0 10px 30px rgba(30, 30, 30, 0.055);
  --surface-shadow-strong: 0 14px 36px rgba(30, 30, 30, 0.08);
  --focus-ring: var(--design-focus-ring);
  --graph-line-default: rgba(30, 30, 30, 0.28);
  --graph-line-strong: rgba(30, 30, 30, 0.48);
  --graph-line-muted: rgba(30, 30, 30, 0.18);
  --graph-line-selected: var(--color-cta-primary-bg);
  --graph-node-shadow: 0 8px 22px rgba(30, 30, 30, 0.06);
  --graph-node-shadow-strong: 0 14px 34px rgba(30, 30, 30, 0.1);
  background: var(--color-page-background);
  color: var(--color-text-body);
}

.topic-quickbar,
.top-tabbar,
.search-next-panel,
.search-result-tabs,
.result-collection-panel,
.typed-result-card,
.book-card,
.detail-panel,
.detail-section,
.detail-management-section,
.knowledge-block,
.ai-workbench-section,
.report-assist-section,
.graph-book-tab-section,
.collection-graph-section,
.reader-section,
.related-card,
.detail-status-card,
.graph-inspector,
.graph-summary-card,
.control-panel,
.active-filter-panel,
.search-empty-state {
  border-color: var(--color-border-default);
  background: var(--color-card-background);
  box-shadow: 0 10px 30px rgba(30, 30, 30, 0.045);
}

.topic-graph-card,
.search-expansion-notice,
.search-match-panel,
.public-tag-box,
.graph-metadata-notice,
.reader-search-results,
.graph-edge-list,
.book-graph-summary-panel,
.graph-toolbar,
.graph-view-actions,
.graph-legend {
  border-color: var(--color-border-default);
  background: var(--color-surface-muted);
  box-shadow: none;
}

.control input,
.control select,
.control textarea,
.home-search-control input,
.search-control input,
.reader-search input,
.page-jump input,
.graph-toolbar .control select,
.graph-toolbar .control input {
  border-color: var(--color-border-default);
  background: var(--color-card-background);
  color: var(--color-text-body);
}

.home-search-control input::placeholder,
.search-control input::placeholder,
.reader-search input::placeholder {
  color: var(--color-text-placeholder);
}

.control input:focus,
.control select:focus,
.control textarea:focus,
.home-search-control input:focus,
.search-control input:focus,
.reader-search input:focus,
.page-jump input:focus,
.graph-toolbar .control select:focus,
.graph-toolbar .control input:focus {
  border-color: var(--color-border-emphasis);
  background: var(--color-card-background);
  box-shadow: var(--design-focus-ring);
}

.home-search-button,
.source-action-button.primary-action,
.detail-page .ai-action-row .source-action-button.primary-action,
.primary-demo-action {
  border-color: var(--color-cta-primary-bg);
  background: var(--color-cta-primary-bg);
  color: var(--color-cta-primary-text);
  box-shadow: none;
}

.home-search-button:hover,
.home-search-button:focus-visible,
.source-action-button.primary-action:hover,
.source-action-button.primary-action:focus-visible,
.detail-page .ai-action-row .source-action-button.primary-action:hover,
.detail-page .ai-action-row .source-action-button.primary-action:focus-visible,
.primary-demo-action:hover,
.primary-demo-action:focus-visible {
  border-color: var(--color-cta-primary-hover);
  background: var(--color-cta-primary-hover);
  color: var(--color-cta-primary-text);
  box-shadow: var(--design-focus-ring);
}

.source-action-button,
.source-action-button:not(.secondary),
.source-link.secondary,
.reset-button,
.back-button,
.section-mini-button,
.inline-text-button,
.detail-primary-tags button,
.graph-entry-buttons button,
.reader-term-buttons button,
.search-next-panel button,
.book-result-actions button,
.book-result-actions button:first-child,
.graph-tool-actions button,
.graph-view-actions button,
.graph-view-actions button:last-child,
.result-collection-grid button,
.result-group-grid button,
.empty-suggestion-block button,
.search-match-panel button,
.empty-action-row .source-action-button:first-child,
.graph-target-row .source-action-button,
.primary-graph-action,
.detail-page .detail-action-group .primary-graph-action,
.detail-page .detail-action-group .source-action-button {
  border-color: var(--color-cta-secondary-border);
  background: var(--color-cta-secondary-bg);
  color: var(--color-cta-secondary-text);
  box-shadow: none;
}

.source-action-button:hover,
.source-action-button:focus-visible,
.source-action-button:not(.secondary):hover,
.source-action-button:not(.secondary):focus-visible,
.source-link.secondary:hover,
.source-link.secondary:focus-visible,
.reset-button:hover,
.reset-button:focus-visible,
.back-button:hover,
.back-button:focus-visible,
.section-mini-button:hover,
.section-mini-button:focus-visible,
.inline-text-button:hover,
.inline-text-button:focus-visible,
.detail-primary-tags button:hover,
.detail-primary-tags button:focus-visible,
.graph-entry-buttons button:hover,
.graph-entry-buttons button:focus-visible,
.reader-term-buttons button:hover,
.reader-term-buttons button:focus-visible,
.search-next-panel button:hover,
.search-next-panel button:focus-visible,
.book-result-actions button:hover,
.book-result-actions button:focus-visible,
.book-result-actions button:first-child:hover,
.book-result-actions button:first-child:focus-visible,
.graph-tool-actions button:hover,
.graph-tool-actions button:focus-visible,
.graph-view-actions button:hover,
.graph-view-actions button:focus-visible,
.graph-view-actions button:last-child:hover,
.graph-view-actions button:last-child:focus-visible,
.result-collection-grid button:hover,
.result-collection-grid button:focus-visible,
.result-group-grid button:hover,
.result-group-grid button:focus-visible,
.empty-suggestion-block button:hover,
.empty-suggestion-block button:focus-visible,
.search-match-panel button:hover,
.search-match-panel button:focus-visible,
.empty-action-row .source-action-button:first-child:hover,
.empty-action-row .source-action-button:first-child:focus-visible,
.graph-target-row .source-action-button:hover,
.graph-target-row .source-action-button:focus-visible,
.primary-graph-action:hover,
.primary-graph-action:focus-visible,
.detail-page .detail-action-group .primary-graph-action:hover,
.detail-page .detail-action-group .primary-graph-action:focus-visible,
.detail-page .detail-action-group .source-action-button:hover,
.detail-page .detail-action-group .source-action-button:focus-visible {
  border-color: var(--color-border-emphasis);
  background: var(--color-cta-secondary-bg);
  color: var(--color-cta-secondary-text);
  box-shadow: var(--design-focus-ring);
}

.home-search-button,
.source-action-button.primary-action,
.detail-page .ai-action-row .source-action-button.primary-action,
.primary-demo-action {
  border-color: var(--color-cta-primary-bg);
  background: var(--color-cta-primary-bg);
  color: var(--color-cta-primary-text);
  box-shadow: none;
}

.home-search-button:hover,
.home-search-button:focus-visible,
.source-action-button.primary-action:hover,
.source-action-button.primary-action:focus-visible,
.detail-page .ai-action-row .source-action-button.primary-action:hover,
.detail-page .ai-action-row .source-action-button.primary-action:focus-visible,
.primary-demo-action:hover,
.primary-demo-action:focus-visible {
  border-color: var(--color-cta-primary-hover);
  background: var(--color-cta-primary-hover);
  color: var(--color-cta-primary-text);
  box-shadow: var(--design-focus-ring);
}

.tag-chip,
.tag-strip span,
.filter-chip,
.search-match-badges span,
.detail-id-badge,
.graph-status-pill,
.graph-edge-button small,
.graph-legend-chip,
.result-evidence-badge,
.typed-evidence-list span,
.original-state,
.detail-page .tag-chip,
.detail-page .review-flow span,
.detail-page .typed-evidence-list span,
.detail-page .graph-status-pill {
  border-color: var(--color-border-default);
  background: var(--color-surface-muted);
  color: var(--color-text-secondary);
}

.search-result-tabs button.is-active,
.filter-chip:hover,
.filter-chip:focus-visible,
.tag-strip span[role=button]:hover,
.tag-strip span[role=button]:focus-visible,
.tag-strip span[role=button].is-active,
.detail-page .tag-chip.public-chip,
.detail-page .review-flow span.is-active {
  border-color: var(--color-cta-secondary-border);
  background: var(--color-surface-selected);
  color: var(--color-text-heading);
}

.evidence-snippet,
.detail-page .evidence-snippet,
.detail-page .report-warning {
  border-left-color: var(--color-border-emphasis);
  background: var(--color-surface-muted);
}

.evidence-snippet mark {
  background: var(--color-surface-muted-strong);
  color: var(--color-text-heading);
}

.detail-page {
  --detail-card-gradient: var(--color-card-background);
  --detail-card-soft: var(--color-surface-muted);
  --detail-card-glass: rgba(255, 255, 255, 0.82);
  --detail-cover-paper: var(--color-surface-muted);
  --detail-cover-line: var(--color-border-default);
  --detail-card-border: var(--color-border-default);
  --detail-card-shadow: 0 10px 30px rgba(30, 30, 30, 0.055);
}

.cover-frame,
.modal-cover,
.related-cover,
.collection-material-cover,
.tag-result-cover,
.cover-frame.is-placeholder,
.modal-cover.is-placeholder,
.related-cover.is-placeholder,
.collection-material-cover.is-placeholder,
.tag-result-cover.is-placeholder {
  border-color: var(--color-border-default);
  background: linear-gradient(90deg, var(--color-border-default) 0 7px, transparent 7px), linear-gradient(145deg, var(--color-surface-muted), #FFFFFF 62%, rgba(30, 30, 30, 0.04));
  box-shadow: 0 10px 24px rgba(30, 30, 30, 0.055);
}

.cover-frame.is-loading,
.modal-cover.is-loading,
.related-cover.is-loading,
.collection-material-cover.is-loading,
.tag-result-cover.is-loading {
  background: var(--color-surface-muted);
}

.cover-frame.is-loading::after,
.modal-cover.is-loading::after,
.related-cover.is-loading::after,
.collection-material-cover.is-loading::after,
.tag-result-cover.is-loading::after {
  background: linear-gradient(90deg, rgba(30, 30, 30, 0.035) 0%, rgba(30, 30, 30, 0.07) 46%, rgba(30, 30, 30, 0.035) 100%);
}

.graph-canvas,
.collection-graph-canvas {
  border-color: var(--color-border-default);
  background: linear-gradient(rgba(30, 30, 30, 0.07) 1px, transparent 1px), linear-gradient(90deg, rgba(30, 30, 30, 0.07) 1px, transparent 1px), #FFFFFF;
  background-size: 28px 28px, 28px 28px, auto;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.72), 0 10px 30px rgba(30, 30, 30, 0.045);
}

.graph-node,
.graph-node.type-자료,
.graph-node.type-관련-자료,
.collection-resource-node {
  --node-accent: var(--color-text-heading);
  --node-border: var(--color-border-default);
  --node-bg: #FFFFFF;
  --node-text: var(--color-text-heading);
  --node-muted: var(--color-text-secondary);
  --node-type-bg: var(--color-surface-muted);
  --node-type-border: var(--color-border-default);
}

.graph-node.type-주제,
.collection-tag-node {
  --node-accent: var(--color-support-green);
  --node-border: rgba(94, 102, 118, 0.22);
  --node-bg: rgba(94, 102, 118, 0.08);
  --node-text: var(--color-text-heading);
  --node-muted: var(--color-text-secondary);
  --node-type-bg: #FFFFFF;
  --node-type-border: rgba(94, 102, 118, 0.16);
}

.graph-node.type-장소,
.graph-node.type-기관,
.graph-node.type-인물,
.graph-node.type-사건,
.graph-node.type-시대,
.graph-node.type-주장,
.graph-node.type-쟁점,
.graph-node.type-반박,
.graph-node.type-쟁점-반박,
.graph-node.type-개념,
.graph-node.type-문헌-법령,
.graph-node.type-근거-후보,
.collection-outer-node {
  --node-accent: var(--color-support-taupe);
  --node-border: rgba(102, 102, 102, 0.2);
  --node-bg: rgba(102, 102, 102, 0.08);
  --node-text: var(--color-text-heading);
  --node-muted: var(--color-text-secondary);
  --node-type-bg: #FFFFFF;
  --node-type-border: rgba(102, 102, 102, 0.14);
}

.collection-central-node,
.graph-node.shape-central-topic,
.graph-node.type-자료.shape-central-topic,
.graph-node.type-주제.shape-central-topic,
.graph-canvas .graph-central-node.shape-material-card {
  --node-accent: var(--color-cta-primary-hover);
  --node-border: var(--color-cta-primary-bg);
  --node-bg: var(--color-cta-primary-bg);
  --node-text: var(--color-cta-primary-text);
  --node-muted: rgba(255, 255, 255, 0.84);
  --node-type-bg: rgba(255, 255, 255, 0.14);
  --node-type-border: rgba(255, 255, 255, 0.32);
}

.graph-node.is-selected,
.graph-node.is-related {
  box-shadow: var(--design-focus-ring), var(--graph-node-shadow-strong);
}

.graph-edge-button {
  border-color: var(--color-border-default);
  border-left-color: var(--color-border-emphasis);
  background: #FFFFFF;
  box-shadow: 0 8px 22px rgba(30, 30, 30, 0.045);
}

.graph-edge-button.is-metadata-recommendation,
.graph-edge-button.is-pending-evidence,
.graph-edge-button.is-pending-review {
  border-left-color: var(--color-support-taupe);
  background: var(--color-surface-muted);
}

.graph-link-label,
.graph-link-status {
  border-color: var(--color-border-default);
  background: rgba(255, 255, 255, 0.94);
  color: var(--color-text-heading);
  box-shadow: 0 2px 6px rgba(30, 30, 30, 0.045);
}

.graph-legend-dot.type-topic,
.graph-legend-dot.type-event,
.graph-legend-dot.type-issue,
.graph-legend-dot.type-actor,
.graph-legend-dot.type-concept,
.graph-legend-dot.type-evidence {
  background: var(--color-surface-muted);
  color: var(--color-text-secondary);
}

@media (max-width: 760px) {
  .graph-toolbar,
  .graph-view-actions {
    background: var(--color-surface-muted);
  }
}
/* Review 120: calm card surfaces and material action hierarchy. */
:host {
  --review120-card-border: rgba(30, 30, 30, 0.12);
  --review120-card-border-hover: rgba(31, 31, 31, 0.14);
  --review120-card-shadow: 0 6px 18px rgba(30, 30, 30, 0.035);
  --review120-card-shadow-hover: 0 8px 22px rgba(30, 30, 30, 0.055);
  --review120-charcoal: #1F1F1F;
  --review120-charcoal-hover: #111111;
  --review120-muted-text: #4F4F4F;
  --review120-badge-bg: rgba(30, 30, 30, 0.035);
  --review120-selected-bg: rgba(30, 30, 30, 0.06);
  --review120-bluegrey: rgba(93, 119, 139, 0.09);
  --review120-sage: rgba(120, 146, 124, 0.09);
  --review120-neutralgrey: rgba(102, 102, 102, 0.09);
  --review120-softgrey: rgba(102, 102, 102, 0.09);
  --review120-greygreen: rgba(105, 130, 117, 0.085);
  --review120-warmgrey: rgba(102, 102, 102, 0.09);
}

.topic-graph-card,
.typed-result-card,
.book-card,
.shelf .book-card,
.shelf.search-result-shelf .book-card.search-result-card,
.collection-material-grid button,
.related-card,
.detail-page .detail-panel,
.detail-page .detail-section,
.detail-page .knowledge-block,
.detail-page .reader-section,
.detail-page .report-assist-section,
.detail-page .ai-workbench-section {
  border-color: var(--review120-card-border);
  background: #FFFFFF;
  box-shadow: var(--review120-card-shadow);
}

.topic-graph-card:hover,
.topic-graph-card.is-active,
.typed-result-card:hover,
.typed-result-card:focus-visible,
.shelf .book-card:hover,
.shelf .book-card:focus-visible,
.collection-material-grid button:hover,
.collection-material-grid button:focus-visible,
.detail-page .related-card:hover,
.detail-page .related-card:focus-visible {
  border-color: var(--review120-card-border-hover);
  background: #FFFFFF;
  box-shadow: var(--review120-card-shadow-hover);
  transform: none;
}

.topic-graph-card {
  --topic-card-tint: var(--review120-bluegrey);
}

.topic-graph-card:nth-child(6n+1) {
  --topic-card-tint: var(--review120-bluegrey);
}

.topic-graph-card:nth-child(6n+2) {
  --topic-card-tint: var(--review120-sage);
}

.topic-graph-card:nth-child(6n+3) {
  --topic-card-tint: var(--review120-neutralgrey);
}

.topic-graph-card:nth-child(6n+4) {
  --topic-card-tint: var(--review120-softgrey);
}

.topic-graph-card:nth-child(6n+5) {
  --topic-card-tint: var(--review120-greygreen);
}

.topic-graph-card:nth-child(6n) {
  --topic-card-tint: var(--review120-warmgrey);
}

.topic-graph-card span,
.collection-meta-grid strong,
.admin-status-grid span {
  border-color: rgba(30, 30, 30, 0.1);
  background: var(--topic-card-tint, var(--review120-badge-bg));
  color: var(--review120-charcoal);
}

.tag-chip,
.tag-strip span,
.filter-chip,
.search-match-badges span,
.detail-id-badge,
.graph-status-pill,
.graph-edge-button small,
.graph-legend-chip,
.result-evidence-badge,
.typed-evidence-list span,
.original-state,
.detail-page .tag-chip,
.detail-page .review-flow span,
.detail-page .typed-evidence-list span,
.detail-page .graph-status-pill,
.public-tag-box,
.search-material-meta div,
.typed-result-meta div {
  border-color: rgba(30, 30, 30, 0.1);
  background: var(--review120-badge-bg);
  color: var(--review120-muted-text);
}

.search-result-tabs button.is-active,
.filter-chip:hover,
.filter-chip:focus-visible,
.tag-strip span[role=button]:hover,
.tag-strip span[role=button]:focus-visible,
.tag-strip span[role=button].is-active,
.detail-page .tag-chip.public-chip,
.detail-page .review-flow span.is-active {
  border-color: rgba(31, 31, 31, 0.14);
  background: var(--review120-selected-bg);
  color: var(--review120-charcoal);
}

.source-action-button,
.source-action-button:not(.secondary),
.source-link.secondary,
.reset-button,
.back-button,
.section-mini-button,
.inline-text-button,
.detail-primary-tags button,
.graph-entry-buttons button,
.reader-term-buttons button,
.search-next-panel button,
.book-result-actions button,
.book-result-actions button:first-child,
.graph-tool-actions button,
.graph-view-actions button,
.graph-view-actions button:last-child,
.result-collection-grid button,
.result-group-grid button,
.empty-suggestion-block button,
.search-match-panel button,
.empty-action-row .source-action-button:first-child,
.graph-target-row .source-action-button,
.primary-graph-action,
.detail-page .detail-action-group .primary-graph-action,
.detail-page .detail-action-group .source-action-button {
  border-color: rgba(31, 31, 31, 0.14);
  background: #FFFFFF;
  color: var(--review120-charcoal);
  box-shadow: none;
}

.source-link.primary-source,
.source-action-button.primary-action,
.detail-page .ai-action-row .source-action-button.primary-action,
.book-result-actions button:nth-child(2):not(:disabled),
.detail-page .detail-action-group .source-link.primary-source {
  border-color: var(--review120-charcoal);
  background: var(--review120-charcoal);
  color: #FFFFFF;
  box-shadow: none;
}

.source-action-button:hover,
.source-action-button:focus-visible,
.source-action-button:not(.secondary):hover,
.source-action-button:not(.secondary):focus-visible,
.source-link.secondary:hover,
.source-link.secondary:focus-visible,
.reset-button:hover,
.reset-button:focus-visible,
.back-button:hover,
.back-button:focus-visible,
.section-mini-button:hover,
.section-mini-button:focus-visible,
.inline-text-button:hover,
.inline-text-button:focus-visible,
.detail-primary-tags button:hover,
.detail-primary-tags button:focus-visible,
.graph-entry-buttons button:hover,
.graph-entry-buttons button:focus-visible,
.reader-term-buttons button:hover,
.reader-term-buttons button:focus-visible,
.search-next-panel button:hover,
.search-next-panel button:focus-visible,
.book-result-actions button:hover,
.book-result-actions button:focus-visible,
.book-result-actions button:first-child:hover,
.book-result-actions button:first-child:focus-visible,
.graph-tool-actions button:hover,
.graph-tool-actions button:focus-visible,
.graph-view-actions button:hover,
.graph-view-actions button:focus-visible,
.graph-view-actions button:last-child:hover,
.graph-view-actions button:last-child:focus-visible,
.result-collection-grid button:hover,
.result-collection-grid button:focus-visible,
.result-group-grid button:hover,
.result-group-grid button:focus-visible,
.empty-suggestion-block button:hover,
.empty-suggestion-block button:focus-visible,
.search-match-panel button:hover,
.search-match-panel button:focus-visible,
.empty-action-row .source-action-button:first-child:hover,
.empty-action-row .source-action-button:first-child:focus-visible,
.graph-target-row .source-action-button:hover,
.graph-target-row .source-action-button:focus-visible,
.primary-graph-action:hover,
.primary-graph-action:focus-visible,
.detail-page .detail-action-group .primary-graph-action:hover,
.detail-page .detail-action-group .primary-graph-action:focus-visible,
.detail-page .detail-action-group .source-action-button:hover,
.detail-page .detail-action-group .source-action-button:focus-visible {
  border-color: rgba(30, 30, 30, 0.22);
  background: var(--review120-selected-bg);
  color: var(--review120-charcoal);
  box-shadow: var(--design-focus-ring);
}

.source-link.primary-source:hover,
.source-link.primary-source:focus-visible,
.source-action-button.primary-action:hover,
.source-action-button.primary-action:focus-visible,
.detail-page .ai-action-row .source-action-button.primary-action:hover,
.detail-page .ai-action-row .source-action-button.primary-action:focus-visible,
.book-result-actions button:nth-child(2):not(:disabled):hover,
.book-result-actions button:nth-child(2):not(:disabled):focus-visible,
.detail-page .detail-action-group .source-link.primary-source:hover,
.detail-page .detail-action-group .source-link.primary-source:focus-visible {
  border-color: var(--review120-charcoal-hover);
  background: var(--review120-charcoal-hover);
  color: #FFFFFF;
  box-shadow: var(--design-focus-ring);
}

.source-action-button:disabled,
.book-result-actions button:disabled {
  border-color: rgba(30, 30, 30, 0.1);
  background: rgba(30, 30, 30, 0.025);
  color: rgba(30, 30, 30, 0.42);
}

/* Review 121: charcoal token continuity for search, detail, graph, loading, and disabled states. */
:host {
  --review121-page-bg: #FFFFFF;
  --review121-card-bg: #FFFFFF;
  --review121-muted-bg: rgba(30, 30, 30, 0.035);
  --review121-muted-bg-strong: rgba(30, 30, 30, 0.065);
  --review121-border: rgba(30, 30, 30, 0.12);
  --review121-border-strong: rgba(30, 30, 30, 0.22);
  --review121-text: #1F1F1F;
  --review121-body: #252525;
  --review121-secondary: #555555;
  --review121-muted-text: #8A8A8A;
  --review121-disabled-bg: #F5F5F5;
  --review121-disabled-border: #E5E5E5;
  --review121-disabled-text: #A0A0A0;
  --review121-charcoal: #1F1F1F;
  --review121-charcoal-hover: #111111;
  --review121-focus: 0 0 0 3px rgba(31, 31, 31, 0.14);
  --review121-card-shadow: 0 8px 22px rgba(30, 30, 30, 0.04);
  --review121-card-shadow-hover: 0 10px 26px rgba(30, 30, 30, 0.06);
  --review121-graph-topic: #536C7A;
  --review121-graph-topic-bg: rgba(83, 108, 122, 0.11);
  --review121-graph-place: #5E6676;
  --review121-graph-place-bg: rgba(94, 102, 118, 0.11);
  --review121-graph-actor: #646B78;
  --review121-graph-actor-bg: rgba(100, 107, 120, 0.11);
  --review121-graph-event: #666666;
  --review121-graph-event-bg: rgba(102, 102, 102, 0.11);
  --review121-graph-concept: #687086;
  --review121-graph-concept-bg: rgba(104, 112, 134, 0.10);
  --review121-graph-evidence: #666666;
  --review121-graph-evidence-bg: rgba(100, 107, 120, 0.10);
  --review121-graph-pending: #7A6570;
  --review121-graph-pending-bg: rgba(122, 101, 112, 0.10);
  --design-bg: var(--review121-page-bg);
  --design-card-bg: var(--review121-card-bg);
  --design-bg-muted: var(--review121-muted-bg);
  --design-card-tinted: var(--review121-muted-bg);
  --design-card-tinted-strong: var(--review121-muted-bg-strong);
  --design-text: var(--review121-text);
  --design-text-secondary: var(--review121-secondary);
  --design-text-muted: var(--review121-muted-text);
  --design-text-disabled: var(--review121-disabled-text);
  --design-border: var(--review121-border);
  --design-border-soft: var(--review121-border);
  --design-border-strong: var(--review121-border-strong);
  --design-accent: var(--review121-charcoal);
  --design-accent-strong: var(--review121-charcoal-hover);
  --design-accent-wash: var(--review121-muted-bg-strong);
  --design-selected-bg: var(--review121-muted-bg-strong);
  --design-pending: var(--review121-disabled-border);
  --design-pending-bg: var(--review121-disabled-bg);
  --design-pending-text: var(--review121-disabled-text);
  --design-shadow: var(--review121-card-shadow);
  --design-shadow-strong: var(--review121-card-shadow-hover);
  --design-hover-shadow: var(--review121-card-shadow-hover);
  --design-focus-ring-color: rgba(31, 31, 31, 0.14);
  --design-focus-ring: var(--review121-focus);
  background: var(--review121-page-bg);
  color: var(--review121-body);
}

.library-page {
  --page-bg: var(--review121-page-bg);
  --card-bg: var(--review121-card-bg);
  --muted-bg: var(--review121-muted-bg);
  --border: var(--review121-border);
  --border-soft: var(--review121-border);
  --text: var(--review121-text);
  --muted: var(--review121-secondary);
  --faint: var(--review121-muted-text);
  --accent: var(--review121-charcoal);
  --accent-hover: var(--review121-charcoal-hover);
  --accent-soft: var(--review121-muted-bg-strong);
  --accent-wash: var(--review121-muted-bg-strong);
  --pending: var(--review121-disabled-border);
  --pending-bg: var(--review121-disabled-bg);
  --pending-text: var(--review121-disabled-text);
  --surface-shadow: var(--review121-card-shadow);
  --surface-shadow-strong: var(--review121-card-shadow-hover);
  --focus-ring: var(--review121-focus);
  --graph-line-default: rgba(30, 30, 30, 0.32);
  --graph-line-strong: rgba(30, 30, 30, 0.55);
  --graph-line-muted: rgba(104, 112, 134, 0.34);
  --graph-line-selected: var(--review121-charcoal);
  --graph-node-shadow: 0 8px 20px rgba(30, 30, 30, 0.07);
  --graph-node-shadow-strong: 0 12px 30px rgba(30, 30, 30, 0.12);
  background: var(--review121-page-bg);
  color: var(--review121-body);
}

.topic-quickbar,
.top-tabbar,
.control-panel,
.active-filter-panel,
.search-result-tabs,
.search-next-panel,
.result-collection-panel,
.typed-result-card,
.book-card,
.shelf .book-card,
.shelf.search-result-shelf .book-card.search-result-card,
.detail-page .detail-panel,
.detail-page .detail-section,
.detail-page .detail-management-section,
.detail-page .knowledge-block,
.detail-page .ai-workbench-section,
.detail-page .report-assist-section,
.detail-page .reader-section,
.detail-page .related-section,
.detail-page .related-card,
.graph-book-tab-section,
.collection-graph-section,
.graph-inspector,
.graph-summary-card,
.book-graph-summary-panel,
.graph-edge-list,
.graph-legend,
.search-empty-state,
.empty-state,
.reader-empty {
  border-color: var(--review121-border);
  background: var(--review121-card-bg);
  color: var(--review121-body);
  box-shadow: var(--review121-card-shadow);
}

.topic-graph-card,
.search-expansion-notice,
.search-match-panel,
.public-tag-box,
.graph-metadata-notice,
.reader-search-results,
.graph-toolbar,
.graph-view-actions,
.detail-page .ai-answer,
.detail-page .structured-ai-answer,
.detail-page .body-search-row,
.detail-page .ai-question-box,
.detail-page .detail-summary-strip,
.detail-page .graph-entry-panel,
.detail-page .axis-tag-group,
.detail-page .alias-panel,
.detail-page .ai-evidence-grid article,
.detail-page .report-evidence-row,
.detail-page .report-citation-row,
.detail-page .issue-evidence-group,
.detail-page .report-tool-grid > section,
.detail-page .search-results article,
.graph-inspector-meta div,
.graph-inspector-metrics div,
.graph-inspector-material-list,
.graph-inspector-evidence-list article,
.graph-inspector-disclosure,
.book-graph-summary-panel div {
  border-color: var(--review121-border);
  background: var(--review121-card-bg);
  color: var(--review121-body);
  box-shadow: none;
}

.topic-graph-card:hover,
.typed-result-card:hover,
.typed-result-card:focus-visible,
.book-card:hover,
.book-card:focus-visible,
.shelf .book-card:hover,
.shelf .book-card:focus-visible,
.detail-page .related-card:hover,
.detail-page .related-card:focus-visible {
  border-color: var(--review121-border-strong);
  background: var(--review121-card-bg);
  box-shadow: var(--review121-card-shadow-hover);
  transform: none;
}

.control input,
.control select,
.control textarea,
.home-search-control input,
.search-control input,
.reader-search input,
.reader-text-panel textarea,
.page-jump input,
.graph-toolbar .control select,
.graph-toolbar .control input {
  border-color: var(--review121-border);
  background: var(--review121-card-bg);
  color: var(--review121-body);
}

.control input::placeholder,
.control textarea::placeholder,
.home-search-control input::placeholder,
.search-control input::placeholder,
.reader-search input::placeholder,
.reader-text-panel textarea::placeholder {
  color: rgba(30, 30, 30, 0.55);
}

.control input:focus,
.control select:focus,
.control textarea:focus,
.home-search-control input:focus,
.search-control input:focus,
.reader-search input:focus,
.reader-text-panel textarea:focus,
.page-jump input:focus,
.graph-toolbar .control select:focus,
.graph-toolbar .control input:focus {
  border-color: var(--review121-border-strong);
  background: var(--review121-card-bg);
  box-shadow: var(--review121-focus);
}

.tag-chip,
.tag-strip span,
.filter-chip,
.search-match-badges span,
.detail-id-badge,
.graph-status-pill,
.graph-edge-button small,
.graph-legend-chip,
.result-evidence-badge,
.typed-evidence-list span,
.original-state,
.detail-page .tag-chip,
.detail-page .review-flow span,
.detail-page .typed-evidence-list span,
.detail-page .graph-status-pill,
.public-tag-box,
.search-material-meta div,
.typed-result-meta div,
.detail-page .section-heading span,
.detail-page .detail-status-card,
.detail-page .graph-entry-metrics div,
.reader-index-state {
  border-color: rgba(30, 30, 30, 0.1);
  background: var(--review121-muted-bg);
  color: var(--review121-secondary);
  box-shadow: none;
}

.search-result-tabs button.is-active,
.filter-chip:hover,
.filter-chip:focus-visible,
.tag-strip span[role=button]:hover,
.tag-strip span[role=button]:focus-visible,
.tag-strip span[role=button].is-active,
.detail-page .tag-chip.public-chip,
.detail-page .review-flow span.is-active,
.reader-term-buttons button.is-active {
  border-color: var(--review121-border-strong);
  background: var(--review121-muted-bg-strong);
  color: var(--review121-text);
}

.source-action-button,
.source-action-button:not(.secondary),
.source-link.secondary,
.reset-button,
.back-button,
.section-mini-button,
.inline-text-button,
.detail-primary-tags button,
.graph-entry-buttons button,
.reader-term-buttons button,
.search-next-panel button,
.book-result-actions button,
.book-result-actions button:first-child,
.graph-tool-actions button,
.graph-view-actions button,
.graph-view-actions button:last-child,
.result-collection-grid button,
.result-group-grid button,
.empty-suggestion-block button,
.search-match-panel button,
.empty-action-row .source-action-button:first-child,
.graph-target-row .source-action-button,
.primary-graph-action,
.detail-page .detail-action-group .primary-graph-action,
.detail-page .detail-action-group .source-action-button,
.detail-page .detail-action-group .source-link.secondary,
.detail-page .detail-section .source-action-button:not(.primary-action),
.detail-page .reader-section .source-action-button:not(.primary-action),
.detail-page .report-assist-section .source-action-button:not(.primary-action),
.detail-page .ai-evidence-grid article button,
.detail-page .report-evidence-row button,
.detail-page .report-section-title button,
.graph-inspector-actions .source-action-button,
.graph-inspector-evidence-actions button,
.reader-toolbar button,
.reader-search button {
  border-color: var(--review121-border);
  background: var(--review121-card-bg);
  color: var(--review121-text);
  box-shadow: none;
}

.home-search-button,
.source-link.primary-source,
.source-action-button.primary-action,
.detail-page .ai-action-row .source-action-button.primary-action,
.detail-page .detail-action-group .source-link.primary-source,
.detail-page .detail-action-group .source-action-button.detail-action-primary:not(.primary-graph-action):not(.graph-context-action),
.book-result-actions button:nth-child(2):not(:disabled),
.search-next-panel button:nth-of-type(2):not(:disabled),
.graph-inspector-actions .source-action-button:first-child:not(:disabled) {
  border-color: var(--review121-charcoal);
  background: var(--review121-charcoal);
  color: #FFFFFF;
  box-shadow: none;
}

.source-action-button:hover,
.source-action-button:focus-visible,
.source-action-button:not(.secondary):hover,
.source-action-button:not(.secondary):focus-visible,
.source-link.secondary:hover,
.source-link.secondary:focus-visible,
.reset-button:hover,
.reset-button:focus-visible,
.back-button:hover,
.back-button:focus-visible,
.section-mini-button:hover,
.section-mini-button:focus-visible,
.inline-text-button:hover,
.inline-text-button:focus-visible,
.detail-primary-tags button:hover,
.detail-primary-tags button:focus-visible,
.graph-entry-buttons button:hover,
.graph-entry-buttons button:focus-visible,
.reader-term-buttons button:hover,
.reader-term-buttons button:focus-visible,
.search-next-panel button:hover,
.search-next-panel button:focus-visible,
.book-result-actions button:hover,
.book-result-actions button:focus-visible,
.book-result-actions button:first-child:hover,
.book-result-actions button:first-child:focus-visible,
.graph-tool-actions button:hover,
.graph-tool-actions button:focus-visible,
.graph-view-actions button:hover,
.graph-view-actions button:focus-visible,
.graph-view-actions button:last-child:hover,
.graph-view-actions button:last-child:focus-visible,
.result-collection-grid button:hover,
.result-collection-grid button:focus-visible,
.result-group-grid button:hover,
.result-group-grid button:focus-visible,
.empty-suggestion-block button:hover,
.empty-suggestion-block button:focus-visible,
.search-match-panel button:hover,
.search-match-panel button:focus-visible,
.empty-action-row .source-action-button:first-child:hover,
.empty-action-row .source-action-button:first-child:focus-visible,
.graph-target-row .source-action-button:hover,
.graph-target-row .source-action-button:focus-visible,
.primary-graph-action:hover,
.primary-graph-action:focus-visible,
.detail-page .detail-action-group .primary-graph-action:hover,
.detail-page .detail-action-group .primary-graph-action:focus-visible,
.detail-page .detail-action-group .source-action-button:hover,
.detail-page .detail-action-group .source-action-button:focus-visible,
.detail-page .detail-action-group .source-link.secondary:hover,
.detail-page .detail-action-group .source-link.secondary:focus-visible,
.detail-page .detail-section .source-action-button:not(.primary-action):hover,
.detail-page .detail-section .source-action-button:not(.primary-action):focus-visible,
.detail-page .reader-section .source-action-button:not(.primary-action):hover,
.detail-page .reader-section .source-action-button:not(.primary-action):focus-visible,
.detail-page .report-assist-section .source-action-button:not(.primary-action):hover,
.detail-page .report-assist-section .source-action-button:not(.primary-action):focus-visible,
.detail-page .ai-evidence-grid article button:hover,
.detail-page .ai-evidence-grid article button:focus-visible,
.detail-page .report-evidence-row button:hover,
.detail-page .report-evidence-row button:focus-visible,
.detail-page .report-section-title button:hover,
.detail-page .report-section-title button:focus-visible,
.graph-inspector-actions .source-action-button:hover,
.graph-inspector-actions .source-action-button:focus-visible,
.graph-inspector-evidence-actions button:hover,
.graph-inspector-evidence-actions button:focus-visible,
.reader-toolbar button:hover,
.reader-toolbar button:focus-visible,
.reader-search button:hover,
.reader-search button:focus-visible {
  border-color: var(--review121-border-strong);
  background: var(--review121-muted-bg-strong);
  color: var(--review121-text);
  box-shadow: var(--review121-focus);
  transform: none;
}

.home-search-button:hover,
.home-search-button:focus-visible,
.source-link.primary-source:hover,
.source-link.primary-source:focus-visible,
.source-action-button.primary-action:hover,
.source-action-button.primary-action:focus-visible,
.detail-page .ai-action-row .source-action-button.primary-action:hover,
.detail-page .ai-action-row .source-action-button.primary-action:focus-visible,
.detail-page .detail-action-group .source-link.primary-source:hover,
.detail-page .detail-action-group .source-link.primary-source:focus-visible,
.detail-page .detail-action-group .source-action-button.detail-action-primary:not(.primary-graph-action):not(.graph-context-action):hover,
.detail-page .detail-action-group .source-action-button.detail-action-primary:not(.primary-graph-action):not(.graph-context-action):focus-visible,
.book-result-actions button:nth-child(2):not(:disabled):hover,
.book-result-actions button:nth-child(2):not(:disabled):focus-visible,
.search-next-panel button:nth-of-type(2):not(:disabled):hover,
.search-next-panel button:nth-of-type(2):not(:disabled):focus-visible,
.graph-inspector-actions .source-action-button:first-child:not(:disabled):hover,
.graph-inspector-actions .source-action-button:first-child:not(:disabled):focus-visible {
  border-color: var(--review121-charcoal-hover);
  background: var(--review121-charcoal-hover);
  color: #FFFFFF;
  box-shadow: var(--review121-focus);
}

.detail-page .detail-action-group .primary-graph-action,
.detail-page .detail-action-group .graph-context-action,
.book-result-actions button:nth-child(3),
.search-next-panel button:nth-of-type(3) {
  border-color: var(--review121-border);
  background: var(--review121-card-bg);
  color: var(--review121-text);
}

.status-row,
.detail-loading-row,
.graph-empty-state,
.page-loading,
.reader-search-message,
.typed-empty-state,
.compact-empty {
  border: 1px solid var(--review121-border);
  border-radius: 8px;
  background: var(--review121-card-bg);
  color: var(--review121-secondary);
  box-shadow: var(--review121-card-shadow);
}

.graph-empty-state.is-error,
.compact-empty.is-error,
.status-row .error-text {
  border-color: rgba(154, 42, 42, 0.22);
  background: rgba(154, 42, 42, 0.055);
  color: #8A2424;
}

.cover-frame.is-loading,
.modal-cover.is-loading,
.related-cover.is-loading,
.collection-material-cover.is-loading,
.tag-result-cover.is-loading,
.book-card-skeleton,
.skeleton-cover,
.skeleton-line {
  background: var(--review121-muted-bg);
}

.cover-frame.is-loading::after,
.modal-cover.is-loading::after,
.related-cover.is-loading::after,
.collection-material-cover.is-loading::after,
.tag-result-cover.is-loading::after,
.skeleton-cover,
.skeleton-line {
  background: linear-gradient(90deg, rgba(30, 30, 30, 0.025) 0%, rgba(30, 30, 30, 0.07) 46%, rgba(30, 30, 30, 0.025) 100%);
}

.graph-canvas,
.collection-graph-canvas {
  border-color: var(--review121-border);
  background: linear-gradient(rgba(30, 30, 30, 0.075) 1px, transparent 1px), linear-gradient(90deg, rgba(30, 30, 30, 0.075) 1px, transparent 1px), var(--review121-card-bg);
  background-size: 28px 28px, 28px 28px, auto;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.78), var(--review121-card-shadow);
}

.graph-canvas::before,
.graph-canvas::after,
.collection-graph-canvas::before,
.collection-graph-canvas::after {
  border-color: rgba(30, 30, 30, 0.12);
}

.graph-link {
  stroke: var(--graph-line-default);
  stroke-width: 1.65px;
  opacity: 0.78;
}

.graph-link.is-reviewed,
.graph-link.is-evidence-complete,
.graph-link.is-central-direct,
.graph-link.is-direct,
.graph-link.is-hovered {
  stroke: var(--graph-line-strong);
  stroke-width: 2px;
  opacity: 0.92;
}

.graph-link.is-metadata-recommendation:not(.is-selected):not(.is-dimmed),
.graph-link.is-pending-review:not(.is-selected):not(.is-dimmed),
.graph-link.is-pending-evidence:not(.is-selected):not(.is-dimmed) {
  stroke: var(--graph-line-muted);
  stroke-dasharray: 4 6;
  stroke-width: 1.4px;
  opacity: 0.62;
}

.graph-link.is-selected,
.graph-link.is-reviewed.is-selected,
.graph-link.is-evidence-complete.is-selected,
.graph-link.is-metadata-recommendation.is-selected,
.graph-link.is-pending-review.is-selected,
.graph-link.is-pending-evidence.is-selected,
.graph-link.is-direct.is-selected,
.graph-link.is-hovered.is-selected {
  stroke: var(--graph-line-selected);
  stroke-dasharray: none;
  stroke-width: 3px;
  opacity: 1;
}

.graph-link.is-dimmed,
.graph-link.is-central-direct.is-dimmed,
.graph-link.is-direct.is-dimmed,
.graph-link.is-hovered.is-dimmed {
  stroke: rgba(30, 30, 30, 0.18);
  stroke-width: 1.1px;
  opacity: 0.26;
}

.graph-link-label,
.graph-link-status {
  border-color: var(--review121-border);
  background: rgba(255, 255, 255, 0.96);
  color: var(--review121-text);
  box-shadow: 0 2px 6px rgba(30, 30, 30, 0.045);
}

.graph-link-label.is-selected,
.graph-link-label.is-direct,
.graph-link-label.is-hovered,
.graph-link-status.is-selected,
.graph-link-status.is-direct,
.graph-link-status.is-hovered {
  border-color: var(--review121-border-strong);
  background: var(--review121-card-bg);
  color: var(--review121-text);
}

.graph-node,
.graph-node.type-자료,
.graph-node.type-관련-자료,
.collection-resource-node {
  --node-accent: var(--review121-charcoal);
  --node-border: rgba(30, 30, 30, 0.18);
  --node-bg: #FFFFFF;
  --node-text: var(--review121-text);
  --node-muted: var(--review121-secondary);
  --node-type-bg: var(--review121-muted-bg);
  --node-type-border: var(--review121-border);
  border-color: var(--node-border);
  background: var(--node-bg);
  color: var(--node-text);
  box-shadow: var(--graph-node-shadow);
  opacity: 1;
  filter: none;
}

.graph-node.type-주제,
.collection-tag-node {
  --node-accent: var(--review121-graph-topic);
  --node-border: rgba(83, 108, 122, 0.34);
  --node-bg: var(--review121-graph-topic-bg);
  --node-text: #314A58;
  --node-muted: #4D6572;
  --node-type-bg: #FFFFFF;
  --node-type-border: rgba(83, 108, 122, 0.20);
}

.graph-node.type-장소 {
  --node-accent: var(--review121-graph-place);
  --node-border: rgba(94, 102, 118, 0.34);
  --node-bg: var(--review121-graph-place-bg);
  --node-text: #2F5053;
  --node-muted: #48676A;
  --node-type-bg: #FFFFFF;
  --node-type-border: rgba(94, 102, 118, 0.20);
}

.graph-node.type-인물,
.graph-node.type-기관 {
  --node-accent: var(--review121-graph-actor);
  --node-border: rgba(100, 107, 120, 0.32);
  --node-bg: var(--review121-graph-actor-bg);
  --node-text: #41584A;
  --node-muted: #566D60;
  --node-type-bg: #FFFFFF;
  --node-type-border: rgba(100, 107, 120, 0.20);
}

.graph-node.type-사건,
.graph-node.type-시대,
.graph-node.type-주장,
.graph-node.type-쟁점,
.graph-node.type-반박,
.graph-node.type-쟁점-반박 {
  --node-accent: var(--review121-graph-event);
  --node-border: rgba(102, 102, 102, 0.34);
  --node-bg: var(--review121-graph-event-bg);
  --node-text: #5A4056;
  --node-muted: #715B6E;
  --node-type-bg: #FFFFFF;
  --node-type-border: rgba(102, 102, 102, 0.20);
}

.graph-node.type-개념,
.graph-node.type-문헌-법령 {
  --node-accent: var(--review121-graph-concept);
  --node-border: rgba(104, 112, 134, 0.32);
  --node-bg: var(--review121-graph-concept-bg);
  --node-text: #4D556C;
  --node-muted: #626A80;
  --node-type-bg: #FFFFFF;
  --node-type-border: rgba(104, 112, 134, 0.20);
}

.graph-node.type-근거-후보,
.collection-outer-node {
  --node-accent: var(--review121-graph-evidence);
  --node-border: rgba(100, 107, 120, 0.28);
  --node-bg: var(--review121-graph-evidence-bg);
  --node-text: #4F5662;
  --node-muted: #636B76;
  --node-type-bg: #FFFFFF;
  --node-type-border: rgba(100, 107, 120, 0.18);
}

.collection-central-node,
.graph-node.shape-central-topic,
.graph-node.type-자료.shape-central-topic,
.graph-node.type-주제.shape-central-topic,
.graph-canvas .graph-central-node.shape-material-card {
  --node-accent: var(--review121-charcoal-hover);
  --node-border: var(--review121-charcoal);
  --node-bg: var(--review121-charcoal);
  --node-text: #FFFFFF;
  --node-muted: rgba(255, 255, 255, 0.86);
  --node-type-bg: rgba(255, 255, 255, 0.15);
  --node-type-border: rgba(255, 255, 255, 0.34);
  box-shadow: var(--graph-node-shadow-strong);
}

.graph-node.is-related {
  border-color: var(--node-accent);
  box-shadow: 0 0 0 3px rgba(83, 108, 122, 0.18), var(--graph-node-shadow-strong);
}

.graph-node.is-selected {
  border-color: var(--review121-charcoal);
  box-shadow: 0 0 0 3px rgba(30, 30, 30, 0.18), var(--graph-node-shadow-strong);
}

.graph-node.is-dimmed,
.graph-edge-button.is-dimmed {
  opacity: 0.38;
  filter: saturate(0.72);
}

.graph-edge-button {
  border-color: var(--review121-border);
  border-left-color: var(--review121-graph-concept);
  background: var(--review121-card-bg);
  color: var(--review121-body);
  box-shadow: var(--review121-card-shadow);
}

.graph-edge-button.is-reviewed,
.graph-edge-button.is-evidence-complete {
  border-left-color: var(--review121-graph-topic);
  background: rgba(83, 108, 122, 0.06);
}

.graph-edge-button.is-metadata-recommendation,
.graph-edge-button.is-pending-evidence,
.graph-edge-button.is-pending-review {
  border-left-color: var(--review121-graph-pending);
  background: var(--review121-graph-pending-bg);
}

.graph-edge-button.is-selected,
.graph-edge-button.is-related,
.graph-edge-button:hover:not(.is-dimmed),
.graph-edge-button:focus-visible:not(.is-dimmed) {
  border-color: var(--review121-border-strong);
  border-left-color: var(--review121-charcoal);
  background: var(--review121-card-bg);
  box-shadow: var(--review121-focus), var(--review121-card-shadow);
}

.graph-inspector-kind,
.graph-inspector-title,
.graph-edge-button strong,
.graph-legend-group strong,
.book-graph-summary-panel strong {
  color: var(--review121-text);
}

.graph-legend-dot.type-material,
.graph-legend-dot.type-related-material {
  background: #FFFFFF;
  color: var(--review121-charcoal);
}

.graph-legend-dot.type-central-topic {
  background: var(--review121-charcoal);
  color: var(--review121-charcoal);
}

.graph-legend-dot.type-topic {
  background: var(--review121-graph-topic-bg);
  color: var(--review121-graph-topic);
}

.graph-legend-dot.type-place {
  background: var(--review121-graph-place-bg);
  color: var(--review121-graph-place);
}

.graph-legend-dot.type-actor {
  background: var(--review121-graph-actor-bg);
  color: var(--review121-graph-actor);
}

.graph-legend-dot.type-event,
.graph-legend-dot.type-issue {
  background: var(--review121-graph-event-bg);
  color: var(--review121-graph-event);
}

.graph-legend-dot.type-concept {
  background: var(--review121-graph-concept-bg);
  color: var(--review121-graph-concept);
}

.graph-legend-dot.type-evidence {
  background: var(--review121-graph-evidence-bg);
  color: var(--review121-graph-evidence);
}

.cover-frame,
.modal-cover,
.related-cover,
.collection-material-cover,
.tag-result-cover,
.cover-frame.is-placeholder,
.modal-cover.is-placeholder,
.related-cover.is-placeholder,
.collection-material-cover.is-placeholder,
.tag-result-cover.is-placeholder {
  border-color: var(--review121-border);
  background: linear-gradient(90deg, rgba(30, 30, 30, 0.06) 0 7px, transparent 7px), linear-gradient(145deg, var(--review121-muted-bg), #FFFFFF 62%, rgba(30, 30, 30, 0.04));
  box-shadow: 0 8px 20px rgba(30, 30, 30, 0.045);
}

.cover-placeholder .placeholder-type {
  border-color: var(--review121-border);
  background: var(--review121-card-bg);
  color: var(--review121-secondary);
}

.evidence-snippet,
.detail-page .evidence-snippet,
.detail-page .report-warning {
  border-left-color: var(--review121-border-strong);
  background: var(--review121-muted-bg);
  color: var(--review121-body);
}

.evidence-snippet mark,
.reader-text-panel mark,
.reader-search-results mark {
  background: rgba(83, 108, 122, 0.14);
  color: var(--review121-text);
}

.source-action-button:disabled,
.source-action-button:disabled:hover,
.source-action-button:disabled:focus-visible,
.book-result-actions button:disabled,
.book-result-actions button:disabled:hover,
.book-result-actions button:disabled:focus-visible,
.search-next-panel button:disabled,
.search-next-panel button:disabled:hover,
.search-next-panel button:disabled:focus-visible,
.graph-tool-actions button:disabled,
.graph-tool-actions button:disabled:hover,
.graph-tool-actions button:disabled:focus-visible,
.graph-view-actions button:disabled,
.graph-view-actions button:disabled:hover,
.graph-view-actions button:disabled:focus-visible,
.graph-target-row .source-action-button:disabled,
.graph-target-row .source-action-button:disabled:hover,
.graph-target-row .source-action-button:disabled:focus-visible,
.graph-inspector-actions .source-action-button:disabled,
.graph-inspector-actions .source-action-button:disabled:hover,
.graph-inspector-actions .source-action-button:disabled:focus-visible,
.graph-inspector-evidence-actions button:disabled,
.graph-inspector-evidence-actions button:disabled:hover,
.graph-inspector-evidence-actions button:disabled:focus-visible,
.reader-toolbar button:disabled,
.reader-toolbar button:disabled:hover,
.reader-toolbar button:disabled:focus-visible,
.reader-search button:disabled,
.reader-search button:disabled:hover,
.reader-search button:disabled:focus-visible,
.result-group-grid button:disabled,
.result-group-grid button:disabled:hover,
.result-group-grid button:disabled:focus-visible {
  border-color: var(--review121-disabled-border);
  background: var(--review121-disabled-bg);
  color: var(--review121-disabled-text);
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
  transform: none;
}

/* Review 122: neutral page background, lighter cards, and cooler graph meaning colors. */
:host {
  --review122-page-bg: #FFFFFF;
  --review122-card-bg: #FFFFFF;
  --review122-muted-bg: #FAFAFA;
  --review122-muted-bg-strong: #F7F7F7;
  --review122-border: #E5E5E5;
  --review122-border-strong: #D8D8D8;
  --review122-text: #1F1F1F;
  --review122-body: #2B2B2B;
  --review122-secondary: #666666;
  --review122-muted-text: #8A8A8A;
  --review122-disabled-bg: #F5F5F5;
  --review122-disabled-border: #E5E5E5;
  --review122-disabled-text: #A0A0A0;
  --review122-focus: 0 0 0 3px rgba(31, 31, 31, 0.14);
  --review122-card-shadow: 0 6px 18px rgba(30, 30, 30, 0.032);
  --review122-card-shadow-hover: 0 8px 22px rgba(30, 30, 30, 0.05);
  --review122-graph-topic: #536C7A;
  --review122-graph-topic-bg: rgba(83, 108, 122, 0.10);
  --review122-graph-place: #5E6676;
  --review122-graph-place-bg: rgba(94, 102, 118, 0.10);
  --review122-graph-actor: #646B78;
  --review122-graph-actor-bg: rgba(100, 107, 120, 0.10);
  --review122-graph-event: #666666;
  --review122-graph-event-bg: rgba(102, 102, 102, 0.10);
  --review122-graph-concept: #687086;
  --review122-graph-concept-bg: rgba(104, 112, 134, 0.095);
  --review122-graph-evidence: #646B78;
  --review122-graph-evidence-bg: rgba(100, 107, 120, 0.095);
  --review122-graph-pending: #666666;
  --review122-graph-pending-bg: rgba(102, 102, 102, 0.095);
  --review121-page-bg: var(--review122-page-bg);
  --review121-card-bg: var(--review122-card-bg);
  --review121-muted-bg: var(--review122-muted-bg);
  --review121-muted-bg-strong: var(--review122-muted-bg-strong);
  --review121-border: var(--review122-border);
  --review121-border-strong: var(--review122-border-strong);
  --review121-text: var(--review122-text);
  --review121-body: var(--review122-body);
  --review121-secondary: var(--review122-secondary);
  --review121-muted-text: var(--review122-muted-text);
  --review121-disabled-bg: var(--review122-disabled-bg);
  --review121-disabled-border: var(--review122-disabled-border);
  --review121-disabled-text: var(--review122-disabled-text);
  --review121-focus: var(--review122-focus);
  --review121-card-shadow: var(--review122-card-shadow);
  --review121-card-shadow-hover: var(--review122-card-shadow-hover);
  --review121-graph-topic: var(--review122-graph-topic);
  --review121-graph-topic-bg: var(--review122-graph-topic-bg);
  --review121-graph-place: var(--review122-graph-place);
  --review121-graph-place-bg: var(--review122-graph-place-bg);
  --review121-graph-actor: var(--review122-graph-actor);
  --review121-graph-actor-bg: var(--review122-graph-actor-bg);
  --review121-graph-event: var(--review122-graph-event);
  --review121-graph-event-bg: var(--review122-graph-event-bg);
  --review121-graph-concept: var(--review122-graph-concept);
  --review121-graph-concept-bg: var(--review122-graph-concept-bg);
  --review121-graph-evidence: var(--review122-graph-evidence);
  --review121-graph-evidence-bg: var(--review122-graph-evidence-bg);
  --review121-graph-pending: var(--review122-graph-pending);
  --review121-graph-pending-bg: var(--review122-graph-pending-bg);
  background: var(--review122-page-bg);
  color: var(--review122-body);
}

:host,
.library-page {
  background: var(--review122-page-bg);
  color: var(--review122-body);
}

.library-count,
.auth-profile,
.auth-link,
.topic-quickbar,
.top-tabbar,
.control-panel,
.active-filter-panel,
.search-result-tabs,
.search-next-panel,
.result-collection-panel,
.typed-result-card,
.book-card,
.shelf .book-card,
.shelf.search-result-shelf .book-card.search-result-card,
.detail-page .detail-panel,
.detail-page .detail-section,
.detail-page .detail-management-section,
.detail-page .knowledge-block,
.detail-page .ai-workbench-section,
.detail-page .report-assist-section,
.detail-page .reader-section,
.detail-page .related-section,
.detail-page .related-card,
.graph-book-tab-section,
.collection-graph-section,
.graph-inspector,
.graph-summary-card,
.book-graph-summary-panel,
.graph-edge-list,
.graph-legend,
.search-empty-state,
.empty-state,
.reader-empty {
  border-color: var(--review122-border);
  background: var(--review122-card-bg);
  color: var(--review122-body);
  box-shadow: var(--review122-card-shadow);
}

.topic-graph-card,
.search-expansion-notice,
.search-match-panel,
.public-tag-box,
.graph-metadata-notice,
.reader-search-results,
.graph-toolbar,
.graph-view-actions,
.detail-page .ai-answer,
.detail-page .structured-ai-answer,
.detail-page .body-search-row,
.detail-page .ai-question-box,
.detail-page .detail-summary-strip,
.detail-page .graph-entry-panel,
.detail-page .axis-tag-group,
.detail-page .alias-panel,
.detail-page .ai-evidence-grid article,
.detail-page .report-evidence-row,
.detail-page .report-citation-row,
.detail-page .issue-evidence-group,
.detail-page .report-tool-grid > section,
.detail-page .search-results article,
.graph-inspector-meta div,
.graph-inspector-metrics div,
.graph-inspector-material-list,
.graph-inspector-evidence-list article,
.graph-inspector-disclosure,
.book-graph-summary-panel div {
  border-color: var(--review122-border);
  background: var(--review122-card-bg);
  color: var(--review122-body);
  box-shadow: none;
}

.typed-result-card:hover,
.typed-result-card:focus-visible,
.book-card:hover,
.book-card:focus-visible,
.shelf .book-card:hover,
.shelf .book-card:focus-visible,
.detail-page .related-card:hover,
.detail-page .related-card:focus-visible {
  border-color: var(--review122-border-strong);
  background: var(--review122-card-bg);
  box-shadow: var(--review122-card-shadow-hover);
  transform: none;
}

.home-search-button,
.source-link.primary-source,
.source-action-button.primary-action,
.detail-page .ai-action-row .source-action-button.primary-action,
.detail-page .detail-action-group .source-link.primary-source,
.detail-page .detail-action-group .source-action-button.detail-action-primary:not(.primary-graph-action):not(.graph-context-action),
.book-result-actions button:nth-child(2):not(:disabled),
.search-next-panel button:nth-of-type(2):not(:disabled),
.graph-inspector-actions .source-action-button:first-child:not(:disabled) {
  border-color: var(--review122-text);
  background: var(--review122-text);
  color: #FFFFFF;
  box-shadow: none;
}

.source-action-button,
.source-action-button:not(.secondary),
.source-link.secondary,
.reset-button,
.back-button,
.section-mini-button,
.inline-text-button,
.auth-link,
.detail-primary-tags button,
.graph-entry-buttons button,
.reader-term-buttons button,
.search-next-panel button,
.book-result-actions button,
.graph-tool-actions button,
.graph-view-actions button,
.result-collection-grid button,
.result-group-grid button,
.empty-suggestion-block button,
.search-match-panel button,
.graph-target-row .source-action-button,
.primary-graph-action,
.detail-page .detail-action-group .primary-graph-action,
.detail-page .detail-action-group .graph-context-action,
.detail-page .detail-action-group .source-action-button,
.detail-page .detail-action-group .source-link.secondary,
.detail-page .detail-section .source-action-button:not(.primary-action),
.detail-page .reader-section .source-action-button:not(.primary-action),
.detail-page .report-assist-section .source-action-button:not(.primary-action),
.graph-inspector-actions .source-action-button,
.graph-inspector-evidence-actions button,
.reader-toolbar button,
.reader-search button {
  border-color: var(--review122-border);
  background: var(--review122-card-bg);
  color: var(--review122-text);
  box-shadow: none;
}

.source-action-button:hover,
.source-action-button:focus-visible,
.source-link.secondary:hover,
.source-link.secondary:focus-visible,
.reset-button:hover,
.reset-button:focus-visible,
.back-button:hover,
.back-button:focus-visible,
.section-mini-button:hover,
.section-mini-button:focus-visible,
.inline-text-button:hover,
.inline-text-button:focus-visible,
.auth-link:hover,
.auth-link:focus-visible,
.detail-primary-tags button:hover,
.detail-primary-tags button:focus-visible,
.graph-entry-buttons button:hover,
.graph-entry-buttons button:focus-visible,
.reader-term-buttons button:hover,
.reader-term-buttons button:focus-visible,
.search-next-panel button:hover,
.search-next-panel button:focus-visible,
.book-result-actions button:hover,
.book-result-actions button:focus-visible,
.graph-tool-actions button:hover,
.graph-tool-actions button:focus-visible,
.graph-view-actions button:hover,
.graph-view-actions button:focus-visible,
.result-collection-grid button:hover,
.result-collection-grid button:focus-visible,
.result-group-grid button:hover,
.result-group-grid button:focus-visible,
.empty-suggestion-block button:hover,
.empty-suggestion-block button:focus-visible,
.search-match-panel button:hover,
.search-match-panel button:focus-visible,
.graph-target-row .source-action-button:hover,
.graph-target-row .source-action-button:focus-visible,
.primary-graph-action:hover,
.primary-graph-action:focus-visible,
.detail-page .detail-action-group .primary-graph-action:hover,
.detail-page .detail-action-group .primary-graph-action:focus-visible,
.detail-page .detail-action-group .graph-context-action:hover,
.detail-page .detail-action-group .graph-context-action:focus-visible,
.detail-page .detail-action-group .source-action-button:hover,
.detail-page .detail-action-group .source-action-button:focus-visible,
.graph-inspector-actions .source-action-button:hover,
.graph-inspector-actions .source-action-button:focus-visible,
.graph-inspector-evidence-actions button:hover,
.graph-inspector-evidence-actions button:focus-visible,
.reader-toolbar button:hover,
.reader-toolbar button:focus-visible,
.reader-search button:hover,
.reader-search button:focus-visible {
  border-color: var(--review122-border-strong);
  background: var(--review122-muted-bg-strong);
  color: var(--review122-text);
  box-shadow: var(--review122-focus);
  transform: none;
}

.home-search-button:hover,
.home-search-button:focus-visible,
.source-link.primary-source:hover,
.source-link.primary-source:focus-visible,
.source-action-button.primary-action:hover,
.source-action-button.primary-action:focus-visible,
.detail-page .ai-action-row .source-action-button.primary-action:hover,
.detail-page .ai-action-row .source-action-button.primary-action:focus-visible,
.detail-page .detail-action-group .source-link.primary-source:hover,
.detail-page .detail-action-group .source-link.primary-source:focus-visible,
.detail-page .detail-action-group .source-action-button.detail-action-primary:not(.primary-graph-action):not(.graph-context-action):hover,
.detail-page .detail-action-group .source-action-button.detail-action-primary:not(.primary-graph-action):not(.graph-context-action):focus-visible,
.book-result-actions button:nth-child(2):not(:disabled):hover,
.book-result-actions button:nth-child(2):not(:disabled):focus-visible,
.search-next-panel button:nth-of-type(2):not(:disabled):hover,
.search-next-panel button:nth-of-type(2):not(:disabled):focus-visible,
.graph-inspector-actions .source-action-button:first-child:not(:disabled):hover,
.graph-inspector-actions .source-action-button:first-child:not(:disabled):focus-visible {
  border-color: #111111;
  background: #111111;
  color: #FFFFFF;
  box-shadow: var(--review122-focus);
}

.tag-chip,
.tag-strip span,
.filter-chip,
.search-match-badges span,
.detail-id-badge,
.graph-status-pill,
.graph-edge-button small,
.graph-legend-chip,
.result-evidence-badge,
.typed-evidence-list span,
.original-state,
.detail-page .tag-chip,
.detail-page .review-flow span,
.detail-page .typed-evidence-list span,
.detail-page .graph-status-pill,
.public-tag-box,
.search-material-meta div,
.typed-result-meta div,
.detail-page .section-heading span,
.detail-page .detail-status-card,
.detail-page .graph-entry-metrics div,
.reader-index-state {
  border-color: rgba(30, 30, 30, 0.1);
  background: var(--review122-muted-bg);
  color: var(--review122-secondary);
  box-shadow: none;
}

.graph-canvas,
.collection-graph-canvas {
  border-color: var(--review122-border);
  background: linear-gradient(rgba(30, 30, 30, 0.065) 1px, transparent 1px), linear-gradient(90deg, rgba(30, 30, 30, 0.065) 1px, transparent 1px), var(--review122-card-bg);
  background-size: 28px 28px, 28px 28px, auto;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.76), var(--review122-card-shadow);
}

.graph-link {
  stroke: rgba(30, 30, 30, 0.3);
  opacity: 0.76;
}

.graph-link.is-metadata-recommendation:not(.is-selected):not(.is-dimmed),
.graph-link.is-pending-review:not(.is-selected):not(.is-dimmed),
.graph-link.is-pending-evidence:not(.is-selected):not(.is-dimmed) {
  stroke: rgba(104, 112, 134, 0.34);
  opacity: 0.58;
}

.graph-node.type-근거-후보,
.collection-outer-node {
  --node-accent: var(--review122-graph-evidence);
  --node-border: rgba(100, 107, 120, 0.28);
  --node-bg: var(--review122-graph-evidence-bg);
  --node-text: #4F5662;
  --node-muted: #636B76;
}

.evidence-snippet mark,
.reader-text-panel mark,
.reader-search-results mark {
  background: rgba(83, 108, 122, 0.13);
  color: var(--review122-text);
}

.source-action-button:disabled,
.source-action-button:disabled:hover,
.source-action-button:disabled:focus-visible,
.book-result-actions button:disabled,
.book-result-actions button:disabled:hover,
.book-result-actions button:disabled:focus-visible,
.search-next-panel button:disabled,
.search-next-panel button:disabled:hover,
.search-next-panel button:disabled:focus-visible,
.graph-tool-actions button:disabled,
.graph-tool-actions button:disabled:hover,
.graph-tool-actions button:disabled:focus-visible,
.graph-view-actions button:disabled,
.graph-view-actions button:disabled:hover,
.graph-view-actions button:disabled:focus-visible,
.graph-target-row .source-action-button:disabled,
.graph-target-row .source-action-button:disabled:hover,
.graph-target-row .source-action-button:disabled:focus-visible,
.graph-inspector-actions .source-action-button:disabled,
.graph-inspector-actions .source-action-button:disabled:hover,
.graph-inspector-actions .source-action-button:disabled:focus-visible,
.graph-inspector-evidence-actions button:disabled,
.graph-inspector-evidence-actions button:disabled:hover,
.graph-inspector-evidence-actions button:disabled:focus-visible,
.reader-toolbar button:disabled,
.reader-toolbar button:disabled:hover,
.reader-toolbar button:disabled:focus-visible,
.reader-search button:disabled,
.reader-search button:disabled:hover,
.reader-search button:disabled:focus-visible,
.result-group-grid button:disabled,
.result-group-grid button:disabled:hover,
.result-group-grid button:disabled:focus-visible {
  border-color: var(--review122-disabled-border);
  background: var(--review122-disabled-bg);
  color: var(--review122-disabled-text);
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
  transform: none;
}

/* Review 124: CTA and button hierarchy cleanup. */
:host {
  --review124-primary: #1F1F1F;
  --review124-primary-hover: #343434;
  --review124-primary-text: #FFFFFF;
  --review124-secondary-bg: #FFFFFF;
  --review124-secondary-border: #E5E5E5;
  --review124-secondary-hover: #F7F7F7;
  --review124-chip-bg: #F6F6F6;
  --review124-chip-text: #2B2B2B;
  --review124-chip-border: #EEEEEE;
  --review124-disabled-bg: #F5F5F5;
  --review124-disabled-border: #E5E5E5;
  --review124-disabled-text: #A0A0A0;
  --accent: var(--review124-primary);
  --accent-hover: var(--review124-primary-hover);
}

.auth-link,
.source-action-button,
.source-action-button:not(.secondary),
.source-link.secondary,
.source-link.primary-source,
.reset-button,
.back-button,
.section-mini-button,
.inline-text-button,
.detail-primary-tags button,
.graph-entry-buttons button,
.reader-term-buttons button,
.search-next-panel button,
.book-result-actions button,
.graph-tool-actions button,
.graph-view-actions button,
.result-collection-grid button,
.result-group-grid button,
.empty-suggestion-block button,
.search-match-panel button,
.graph-target-row .source-action-button,
.primary-graph-action,
.detail-page .detail-action-group .primary-graph-action,
.detail-page .detail-action-group .graph-context-action,
.detail-page .detail-action-group .source-action-button,
.detail-page .detail-action-group .source-link.secondary,
.detail-page .detail-section .source-action-button:not(.primary-action),
.detail-page .reader-section .source-action-button:not(.primary-action),
.detail-page .report-assist-section .source-action-button:not(.primary-action),
.graph-inspector-actions .source-action-button,
.graph-inspector-evidence-actions button,
.reader-toolbar button,
.reader-search button,
.typed-result-actions .source-action-button {
  border-color: var(--review124-secondary-border);
  background: var(--review124-secondary-bg);
  color: var(--review124-primary);
  box-shadow: none;
}

.auth-link[href="/signup"],
.home-search-button,
.source-action-button.primary-action,
.detail-page .ai-action-row .source-action-button.primary-action {
  border-color: var(--review124-primary);
  background: var(--review124-primary);
  color: var(--review124-primary-text);
  box-shadow: none;
}

.source-action-button:hover,
.source-action-button:focus-visible,
.source-link.secondary:hover,
.source-link.secondary:focus-visible,
.source-link.primary-source:hover,
.source-link.primary-source:focus-visible,
.reset-button:hover,
.reset-button:focus-visible,
.back-button:hover,
.back-button:focus-visible,
.section-mini-button:hover,
.section-mini-button:focus-visible,
.inline-text-button:hover,
.inline-text-button:focus-visible,
.auth-link:hover,
.auth-link:focus-visible,
.detail-primary-tags button:hover,
.detail-primary-tags button:focus-visible,
.graph-entry-buttons button:hover,
.graph-entry-buttons button:focus-visible,
.reader-term-buttons button:hover,
.reader-term-buttons button:focus-visible,
.search-next-panel button:hover,
.search-next-panel button:focus-visible,
.book-result-actions button:hover,
.book-result-actions button:focus-visible,
.graph-tool-actions button:hover,
.graph-tool-actions button:focus-visible,
.graph-view-actions button:hover,
.graph-view-actions button:focus-visible,
.result-collection-grid button:hover,
.result-collection-grid button:focus-visible,
.result-group-grid button:hover,
.result-group-grid button:focus-visible,
.empty-suggestion-block button:hover,
.empty-suggestion-block button:focus-visible,
.search-match-panel button:hover,
.search-match-panel button:focus-visible,
.graph-target-row .source-action-button:hover,
.graph-target-row .source-action-button:focus-visible,
.primary-graph-action:hover,
.primary-graph-action:focus-visible,
.detail-page .detail-action-group .primary-graph-action:hover,
.detail-page .detail-action-group .primary-graph-action:focus-visible,
.detail-page .detail-action-group .graph-context-action:hover,
.detail-page .detail-action-group .graph-context-action:focus-visible,
.detail-page .detail-action-group .source-action-button:hover,
.detail-page .detail-action-group .source-action-button:focus-visible,
.graph-inspector-actions .source-action-button:hover,
.graph-inspector-actions .source-action-button:focus-visible,
.graph-inspector-evidence-actions button:hover,
.graph-inspector-evidence-actions button:focus-visible,
.reader-toolbar button:hover,
.reader-toolbar button:focus-visible,
.reader-search button:hover,
.reader-search button:focus-visible,
.typed-result-actions .source-action-button:hover,
.typed-result-actions .source-action-button:focus-visible {
  border-color: var(--review124-secondary-border);
  background: var(--review124-secondary-hover);
  color: var(--review124-primary);
  box-shadow: 0 0 0 3px rgba(30, 30, 30, 0.12);
  transform: none;
}

.auth-link[href="/signup"]:hover,
.auth-link[href="/signup"]:focus-visible,
.home-search-button:hover,
.home-search-button:focus-visible,
.source-action-button.primary-action:hover,
.source-action-button.primary-action:focus-visible,
.detail-page .ai-action-row .source-action-button.primary-action:hover,
.detail-page .ai-action-row .source-action-button.primary-action:focus-visible {
  border-color: var(--review124-primary-hover);
  background: var(--review124-primary-hover);
  color: var(--review124-primary-text);
  box-shadow: 0 0 0 3px rgba(31, 31, 31, 0.14);
}

.book-result-actions {
  gap: 6px;
}

.book-result-actions button,
.search-next-panel button,
.typed-result-actions .source-action-button {
  min-height: 30px;
  padding: 0 9px;
  font-size: 12px;
  font-weight: 760;
}

.home-topic-row button,
.topic-quickbar button,
.tag-chip,
.tag-strip span,
.filter-chip,
.search-match-badges span,
.detail-id-badge,
.graph-status-pill,
.graph-edge-button small,
.graph-legend-chip,
.result-evidence-badge,
.typed-evidence-list span,
.original-state,
.detail-page .tag-chip,
.detail-page .review-flow span,
.detail-page .typed-evidence-list span,
.detail-page .graph-status-pill,
.public-tag-box,
.search-material-meta div,
.typed-result-meta div,
.detail-page .section-heading span,
.detail-page .detail-status-card,
.detail-page .graph-entry-metrics div,
.reader-index-state {
  border-color: var(--review124-chip-border);
  background: var(--review124-chip-bg);
  color: var(--review124-chip-text);
  box-shadow: none;
}

.home-topic-row button:hover,
.home-topic-row button:focus-visible,
.home-topic-row button.is-active,
.topic-quickbar button:hover,
.topic-quickbar button:focus-visible,
.topic-quickbar button.is-active,
.filter-chip:hover,
.filter-chip:focus-visible,
.tag-strip span[role=button]:hover,
.tag-strip span[role=button]:focus-visible,
.tag-strip span[role=button].is-active,
.detail-primary-tags button.has-graph,
.detail-primary-tags button:hover,
.detail-primary-tags button:focus-visible,
.reader-term-buttons button.is-active {
  border-color: var(--review124-secondary-border);
  background: var(--review124-secondary-hover);
  color: var(--review124-primary);
  box-shadow: 0 0 0 3px rgba(30, 30, 30, 0.1);
}

.source-action-button:disabled,
.source-action-button:disabled:hover,
.source-action-button:disabled:focus-visible,
.book-result-actions button:disabled,
.book-result-actions button:disabled:hover,
.book-result-actions button:disabled:focus-visible,
.search-next-panel button:disabled,
.search-next-panel button:disabled:hover,
.search-next-panel button:disabled:focus-visible,
.graph-tool-actions button:disabled,
.graph-tool-actions button:disabled:hover,
.graph-tool-actions button:disabled:focus-visible,
.graph-view-actions button:disabled,
.graph-view-actions button:disabled:hover,
.graph-view-actions button:disabled:focus-visible,
.graph-target-row .source-action-button:disabled,
.graph-target-row .source-action-button:disabled:hover,
.graph-target-row .source-action-button:disabled:focus-visible,
.graph-inspector-actions .source-action-button:disabled,
.graph-inspector-actions .source-action-button:disabled:hover,
.graph-inspector-actions .source-action-button:disabled:focus-visible,
.graph-inspector-evidence-actions button:disabled,
.graph-inspector-evidence-actions button:disabled:hover,
.graph-inspector-evidence-actions button:disabled:focus-visible,
.reader-toolbar button:disabled,
.reader-toolbar button:disabled:hover,
.reader-toolbar button:disabled:focus-visible,
.reader-search button:disabled,
.reader-search button:disabled:hover,
.reader-search button:disabled:focus-visible,
.result-group-grid button:disabled,
.result-group-grid button:disabled:hover,
.result-group-grid button:disabled:focus-visible,
.typed-result-actions .source-action-button:disabled,
.typed-result-actions .source-action-button:disabled:hover,
.typed-result-actions .source-action-button:disabled:focus-visible {
  border-color: var(--review124-disabled-border);
  background: var(--review124-disabled-bg);
  color: var(--review124-disabled-text);
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
  transform: none;
}

.detail-page .detail-action-group .source-link.primary-source,
.detail-page .detail-action-group .source-action-button.detail-action-primary:not(.primary-graph-action):not(.graph-context-action),
.book-result-actions button:nth-child(2):not(:disabled),
.search-next-panel button:nth-of-type(2):not(:disabled),
.graph-inspector-actions .source-action-button:first-child:not(:disabled) {
  border-color: var(--review124-secondary-border);
  background: var(--review124-secondary-bg);
  color: var(--review124-primary);
  box-shadow: none;
}

.detail-page .detail-action-group .source-link.primary-source:hover,
.detail-page .detail-action-group .source-link.primary-source:focus-visible,
.detail-page .detail-action-group .source-action-button.detail-action-primary:not(.primary-graph-action):not(.graph-context-action):hover,
.detail-page .detail-action-group .source-action-button.detail-action-primary:not(.primary-graph-action):not(.graph-context-action):focus-visible,
.book-result-actions button:nth-child(2):not(:disabled):hover,
.book-result-actions button:nth-child(2):not(:disabled):focus-visible,
.search-next-panel button:nth-of-type(2):not(:disabled):hover,
.search-next-panel button:nth-of-type(2):not(:disabled):focus-visible,
.graph-inspector-actions .source-action-button:first-child:not(:disabled):hover,
.graph-inspector-actions .source-action-button:first-child:not(:disabled):focus-visible {
  border-color: var(--review124-secondary-border);
  background: var(--review124-secondary-hover);
  color: var(--review124-primary);
  box-shadow: 0 0 0 3px rgba(30, 30, 30, 0.12);
}

/* Review 127: prevent default graph edge labels from stacking over nodes. */
.graph-link-label:not(.is-selected),
.graph-link-status:not(.is-selected) {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

.graph-link-label.is-selected,
.graph-link-status.is-selected {
  opacity: 1;
  visibility: visible;
}

.library-page input:focus,
.library-page textarea:focus,
.library-page select:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(30, 30, 30, 0.12);
  --tw-ring-color: transparent;
  --tw-ring-shadow: 0 0 #0000;
}

/* Review 143: material list view mode switch and dense text list. */
.material-view-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin: 14px 0 8px;
  padding: 12px 14px;
  border: 1px solid var(--design-border);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: var(--design-shadow);
}

.material-view-toolbar > div:first-child {
  display: grid;
  min-width: 0;
  gap: 3px;
}

.material-view-toolbar strong {
  color: var(--design-text);
  font-size: 15px;
  font-weight: 900;
  line-height: 1.25;
}

.material-view-toolbar span {
  color: var(--design-text-secondary);
  font-size: 12px;
  font-weight: 800;
  line-height: 1.35;
}

.view-toggle {
  display: inline-flex;
  flex: 0 0 auto;
  gap: 4px;
  padding: 4px;
  border: 1px solid var(--design-border);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.76);
}

.view-toggle button {
  display: grid;
  min-width: 82px;
  min-height: 42px;
  align-content: center;
  gap: 2px;
  padding: 6px 10px;
  border: 1px solid transparent;
  border-radius: 7px;
  background: transparent;
  color: var(--design-accent);
  cursor: pointer;
  text-align: left;
}

.view-toggle button span {
  color: inherit;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0;
}

.view-toggle button strong {
  color: inherit;
  font-size: 13px;
  font-weight: 900;
}

.view-toggle button:hover,
.view-toggle button:focus-visible,
.view-toggle button.is-active {
  border-color: var(--design-accent);
  background: var(--design-accent-wash);
  color: var(--design-accent-strong);
  outline: none;
  box-shadow: var(--design-focus-ring);
}

.material-text-list {
  margin-top: 12px;
}

.material-text-table-wrap {
  overflow-x: auto;
  border: 1px solid #EAEAEA;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: var(--design-shadow);
}

.material-text-table {
  width: 100%;
  min-width: 1180px;
  border-collapse: separate;
  border-spacing: 0;
}

.material-text-table th,
.material-text-table td {
  border-bottom: 1px solid #EAEAEA;
  padding: 11px 12px;
  color: var(--design-text);
  font-size: 14px;
  line-height: 1.45;
  text-align: left;
  vertical-align: middle;
}

.material-text-table th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #FAFAFA;
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 900;
  white-space: nowrap;
}

.material-text-row {
  cursor: pointer;
}

.material-text-row:hover td,
.material-text-row:focus-visible td {
  background: #FAFAFA;
}

.material-text-row:hover td:first-child,
.material-text-row:focus-visible td:first-child {
  box-shadow: inset 3px 0 0 var(--design-accent);
}

.material-text-row:focus-visible {
  outline: none;
}

.material-text-table tbody tr:last-child td {
  border-bottom: 0;
}

.text-sort-button {
  display: inline-flex;
  width: 100%;
  min-height: 30px;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  border: 0;
  border-radius: 6px;
  padding: 3px 5px;
  background: transparent;
  color: inherit;
  cursor: pointer;
  font: inherit;
  font-weight: 900;
  line-height: 1.2;
  text-align: left;
}

.text-sort-button span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-sort-button em {
  flex: 0 0 auto;
  border: 1px solid #E0E0E0;
  border-radius: 999px;
  padding: 2px 5px;
  background: #FFFFFF;
  color: var(--design-accent);
  font-size: 10px;
  font-style: normal;
  font-weight: 900;
  line-height: 1;
}

.text-sort-button:hover,
.text-sort-button:focus-visible,
.text-sort-button.is-active {
  background: #FFFFFF;
  color: var(--design-accent-strong);
  outline: none;
  box-shadow: inset 0 0 0 1px #DADADA;
}

.text-col-title {
  width: 27%;
}

.text-col-publisher {
  width: 12%;
}

.text-col-year {
  width: 8%;
}

.text-col-type {
  width: 10%;
}

.text-col-tags {
  width: 16%;
}

.text-col-status {
  width: 9%;
}

.text-col-actions {
  width: 10%;
}

.text-title-cell a {
  display: -webkit-box;
  overflow: hidden;
  color: var(--design-text);
  font-size: 15px;
  font-weight: 900;
  line-height: 1.35;
  text-decoration: none;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.text-title-cell a:hover,
.text-title-cell a:focus-visible {
  color: var(--design-accent-strong);
  outline: none;
  text-decoration: underline;
}

.text-title-cell > span,
.text-muted {
  display: block;
  margin-top: 5px;
  color: var(--design-text-secondary);
  font-size: 12px;
  font-weight: 750;
}

.text-list-tags,
.text-row-actions {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 5px;
}

.text-list-tags button,
.text-row-actions a,
.text-row-actions button {
  min-height: 28px;
  max-width: 100%;
  overflow: hidden;
  border: 1px solid var(--design-border);
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.84);
  color: var(--design-accent);
  cursor: pointer;
  font-size: 12px;
  font-weight: 850;
  line-height: 1.2;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-list-tags button {
  padding: 0 7px;
  color: var(--design-source);
}

.text-row-actions a,
.text-row-actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
}

.text-row-actions a:first-child {
  border-color: var(--design-accent);
  background: var(--design-accent);
  color: var(--design-on-accent);
}

.text-list-tags button:hover,
.text-list-tags button:focus-visible,
.text-list-tags button.is-active,
.text-row-actions a:hover,
.text-row-actions a:focus-visible,
.text-row-actions button:hover,
.text-row-actions button:focus-visible {
  border-color: var(--design-accent);
  background: var(--design-accent-wash);
  color: var(--design-accent-strong);
  outline: none;
  box-shadow: var(--design-focus-ring);
}

.text-row-actions a:first-child:hover,
.text-row-actions a:first-child:focus-visible {
  border-color: var(--design-accent-strong);
  background: var(--design-accent-strong);
  color: var(--design-on-accent);
}

.text-row-actions button:disabled,
.text-row-actions button:disabled:hover,
.text-row-actions button:disabled:focus-visible {
  border-color: var(--design-border);
  background: rgba(255, 255, 255, 0.5);
  color: var(--design-text-disabled);
  cursor: not-allowed;
  box-shadow: none;
}

.list-state-pill {
  display: inline-flex;
  max-width: 100%;
  overflow: hidden;
  padding: 4px 8px;
  border: 1px solid var(--design-border);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 850;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.state-stack {
  display: grid;
  min-width: 0;
  gap: 4px;
}

.state-kind {
  width: fit-content;
  border: 1px solid #EAEAEA;
  border-radius: 999px;
  padding: 2px 6px;
  background: #FAFAFA;
  color: var(--design-text-secondary);
  font-size: 10px;
  font-weight: 900;
  line-height: 1;
}

.list-state-pill.is-available {
  border-color: rgba(94, 102, 118, 0.24);
  background: rgba(94, 102, 118, 0.12);
  color: var(--design-olive);
}

.list-state-pill.is-limited {
  border-color: var(--design-border);
  background: var(--design-pending-bg);
  color: var(--design-pending-text);
}

.list-state-pill.is-unavailable {
  border-color: var(--design-border);
  background: var(--design-issue-soft);
  color: var(--design-issue);
}

.text-empty-cell {
  padding: 26px 14px;
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 800;
  text-align: center;
}

.text-empty-cell strong,
.text-empty-cell span {
  display: block;
}

.text-empty-cell strong {
  margin-bottom: 5px;
  color: var(--design-text);
  font-size: 15px;
}

.text-list-empty-actions {
  margin-top: 10px;
}

@media (max-width: 900px) {
  .material-view-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .view-toggle {
    width: 100%;
  }
  .view-toggle button {
    flex: 1 1 0;
    min-width: 0;
  }
}
@media (max-width: 760px) {
  .material-view-toolbar {
    margin-top: 12px;
    padding: 11px;
  }
  .material-text-table {
    min-width: 920px;
  }
  .material-text-table th,
  .material-text-table td {
    padding: 9px;
  }
}
/* Review 145: cover-first image material cards. */
.shelf:not(.search-result-shelf) {
  grid-template-columns: repeat(auto-fill, minmax(198px, 1fr));
  grid-auto-rows: 1fr;
  align-items: stretch;
  gap: 18px;
  margin-top: 12px;
  padding-top: 10px;
}

.shelf:not(.search-result-shelf) .book-card {
  min-height: 536px;
  gap: 0;
  padding: 12px;
  border: 1px solid #E5E5E5;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: none;
  transform: none;
}

.shelf:not(.search-result-shelf) .book-card:hover,
.shelf:not(.search-result-shelf) .book-card:focus-visible {
  border-color: #D0D0D0;
  background: #FFFFFF;
  box-shadow: 0 8px 18px rgba(30, 30, 30, 0.06);
  transform: none;
}

.shelf:not(.search-result-shelf) .book-card-main {
  flex: 1 1 auto;
  gap: 0;
}

.shelf:not(.search-result-shelf) .cover-frame,
.shelf:not(.search-result-shelf) .skeleton-cover {
  position: relative;
  width: 100%;
  aspect-ratio: 3/4.25;
  border: 1px solid #E5E5E5;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: none;
}

.shelf:not(.search-result-shelf) .cover-frame:not(.is-placeholder) img {
  object-fit: contain;
  background: #FFFFFF;
}

.shelf:not(.search-result-shelf) .cover-frame.is-placeholder {
  border-color: #E5E5E5;
  background: linear-gradient(90deg, rgba(30, 30, 30, 0.08) 0 7px, transparent 7px), linear-gradient(145deg, #FAFAFA 0%, #FFFFFF 60%, #EDEDED 100%);
  box-shadow: inset 0 0 0 1px rgba(30, 30, 30, 0.03);
}

.shelf:not(.search-result-shelf) .cover-frame .cover-placeholder {
  min-height: 100%;
  padding: 18px 13px 16px 19px;
}

.shelf:not(.search-result-shelf) .cover-fallback-brand {
  width: min(76%, 138px);
  min-height: 42px;
}

.shelf:not(.search-result-shelf) .cover-fallback-logo {
  max-width: 138px;
  max-height: 62px;
}

.shelf:not(.search-result-shelf) .book-meta {
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  padding-top: 12px;
}

.shelf:not(.search-result-shelf) .book-title {
  min-height: 4.08em;
  margin: 0;
  color: #1E1E1E;
  font-size: 15px;
  font-weight: 900;
  line-height: 1.36;
  -webkit-line-clamp: 3;
}

.shelf:not(.search-result-shelf) .book-publisher {
  display: block;
  min-height: 17px;
  margin-top: 8px;
  overflow: hidden;
  color: #4A4A4A;
  font-size: 12px;
  font-weight: 750;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.shelf:not(.search-result-shelf) .book-detail {
  gap: 5px;
  min-height: 24px;
  margin-top: 7px;
  font-size: 11px;
}

.shelf:not(.search-result-shelf) .book-detail span {
  border-color: #E5E5E5;
  background: #FAFAFA;
  color: #666666;
}

.shelf:not(.search-result-shelf) .tag-strip {
  min-height: 54px;
  max-height: 54px;
  margin-top: 10px;
  align-content: flex-start;
  overflow: hidden;
}

.shelf:not(.search-result-shelf) .tag-strip span {
  border-color: #E5E5E5;
  background: #FFFFFF;
  color: #4A4A4A;
  font-size: 11px;
  font-weight: 750;
}

.shelf:not(.search-result-shelf) .tag-strip .tag-placeholder {
  color: #888888;
}

.book-result-actions {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid #EEEEEE;
}

.book-result-actions button,
.book-result-actions button:first-child,
.book-result-actions button:nth-child(2):not(:disabled) {
  min-height: 30px;
  overflow: hidden;
  padding: 0 8px;
  border: 1px solid #DADADA;
  border-radius: 6px;
  background: #FFFFFF;
  color: #333333;
  box-shadow: none;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.15;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.book-result-actions button:first-child {
  grid-column: auto;
}

.book-result-actions button:hover:not(:disabled),
.book-result-actions button:focus-visible:not(:disabled),
.book-result-actions button:first-child:hover,
.book-result-actions button:first-child:focus-visible {
  border-color: #9A9A9A;
  background: #F6F6F6;
  color: #1E1E1E;
  box-shadow: none;
  outline: none;
}

.book-result-actions button:nth-child(2):not(:disabled):hover,
.book-result-actions button:nth-child(2):not(:disabled):focus-visible {
  border-color: #1E1E1E;
  background: #1E1E1E;
  color: #FFFFFF;
}

.book-result-actions button:disabled,
.book-result-actions button:disabled:hover,
.book-result-actions button:disabled:focus-visible {
  border-color: #E5E5E5;
  background: #FAFAFA;
  color: #A0A0A0;
  cursor: not-allowed;
  box-shadow: none;
}

@media (max-width: 760px) {
  .shelf:not(.search-result-shelf) {
    grid-template-columns: repeat(auto-fill, minmax(154px, 1fr));
    gap: 14px;
  }
  .shelf:not(.search-result-shelf) .book-card {
    min-height: 474px;
    padding: 10px;
  }
  .shelf:not(.search-result-shelf) .book-title {
    font-size: 14px;
  }
  .shelf:not(.search-result-shelf) .tag-strip {
    min-height: 48px;
    max-height: 48px;
  }
}
/* Review 154: paged material lists and staged search state */
.search-area-status {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin: 12px 0;
}

.search-area-status article {
  min-width: 0;
  display: grid;
  gap: 3px;
  padding: 10px 12px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  background: #f5f5f5;
}

.search-area-status strong,
.search-area-status em {
  color: #2b2b2b;
  font-style: normal;
}

.search-area-status span {
  color: #666;
  font-size: 12px;
}

.search-evidence-error,
.search-result-pending {
  margin: 10px 0;
  padding: 12px 14px;
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  background: #f5f5f5;
  color: #444;
}

.material-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 22px 0 8px;
  padding: 14px;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  background: #fff;
}

.material-pagination button,
.material-pagination select {
  min-height: 38px;
  border: 1px solid #cfcfcf;
  border-radius: 6px;
  background: #fff;
  color: #2b2b2b;
}

.material-pagination button {
  padding: 0 13px;
  cursor: pointer;
}

.material-pagination button:disabled {
  color: #aaa;
  cursor: not-allowed;
  background: #f5f5f5;
}

.material-pagination button:focus-visible,
.material-pagination select:focus-visible {
  outline: 2px solid #2b2b2b;
  outline-offset: 2px;
}

.material-pagination > span {
  min-width: 270px;
  text-align: center;
  color: #444;
  font-size: 13px;
}

.material-pagination label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #555;
  font-size: 12px;
}

.material-pagination select {
  padding: 0 28px 0 9px;
}

@media (max-width: 760px) {
  .search-area-status {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .material-pagination > span {
    order: -1;
    flex-basis: 100%;
    min-width: 0;
  }
}
@media (max-width: 420px) {
  .search-area-status {
    grid-template-columns: 1fr;
  }
  .material-pagination {
    gap: 6px;
    padding-inline: 8px;
  }
  .material-pagination button {
    padding-inline: 10px;
  }
}
/* Review 157 common UI */
:host {
  --page-bg: #FFFFFF;
  --card-bg: #FFFFFF;
  --muted-bg: #F5F5F5;
  --accent: #2B2B2B;
  --accent-hover: #171717;
  --accent-soft: #F5F5F5;
  --accent-wash: #F5F5F5;
  background: #FFFFFF;
  color: #333333;
  font-family: SUIT, "Noto Sans KR", system-ui, sans-serif;
  font-size: 16px;
  line-height: 1.6;
}

.library-page {
  max-width: 100%;
  overflow-x: clip;
  background: #FFFFFF;
}

:host h1,
:host h2,
:host h3,
:host strong {
  font-weight: 700;
}

:host p,
:host li,
:host dd,
:host dt,
:host label,
:host input,
:host select,
:host textarea {
  font-size: max(15px, 1em);
}

:host p,
:host li,
:host dd {
  font-weight: 400;
}

:host button,
:host label,
:host th {
  font-weight: 600;
}

.library-count,
.home-search-panel,
.graph-entry-panel,
.control-panel,
.search-results,
.detail-content,
.detail-section,
.reader-section,
.collection-overview-section,
.collection-graph-section,
.admin-review-section,
.typed-result-card,
.book-card,
.graph-inspector,
.ai-question-box,
.ai-answer {
  background: #FFFFFF;
  background-image: none;
  box-shadow: 0 1px 2px rgba(30, 30, 30, 0.06);
}

.search-area-status,
.active-filter-panel,
.detail-summary-strip,
.detail-status-card,
.graph-quality-panel,
.graph-metadata-notice,
.empty-state,
.reader-empty,
.graph-empty-state,
.search-result-pending,
.page-loading {
  background: #F5F5F5;
  background-image: none;
}

.home-search-button,
.source-action-button.primary-action,
.source-action-button.detail-action-primary,
.source-link.primary-source,
.primary-demo-action,
.search-result-tabs button.active,
.collection-tabs button.active,
.pdf-tabs button.active {
  border-color: #2B2B2B;
  background: #2B2B2B;
  background-image: none;
  color: #FFFFFF;
}

.source-action-button.secondary,
.source-link.secondary,
.reset-button,
.section-mini-button,
.back-button,
.text-sort-button {
  border-color: #BDBDBD;
  background: #FFFFFF;
  background-image: none;
  color: #2B2B2B;
}

:host button:disabled,
:host input:disabled,
:host select:disabled,
:host textarea:disabled,
:host [aria-disabled=true] {
  cursor: not-allowed;
  opacity: 0.5;
}

:host input:focus,
:host select:focus,
:host textarea:focus {
  border-color: #2B2B2B;
  box-shadow: 0 0 0 3px rgba(43, 43, 43, 0.16);
  outline: none;
}

.material-text-table-wrap {
  max-width: 100%;
  overflow-x: auto;
  overscroll-behavior-inline: contain;
}

.material-text-table {
  min-width: 1080px;
}

.material-text-table th:first-child,
.material-text-table td:first-child {
  min-width: 260px;
}

.material-text-table th:last-child,
.material-text-table td:last-child,
.admin-table-head > :last-child,
.admin-table > * > :last-child {
  min-width: 104px;
  white-space: nowrap;
}

.book-meta,
.detail-list dd,
.material-text-table td {
  word-break: normal;
  overflow-wrap: break-word;
}

@media (max-width: 768px) {
  .library-page {
    padding-inline: 18px;
  }
}
@media (max-width: 420px) {
  .library-page {
    padding-inline: 14px;
  }
}
/* Review 162: researcher-first search, comparison list, and detail hierarchy. */
.primary-search-panel {
  display: grid;
  grid-template-columns: minmax(340px, 2fr) repeat(4, minmax(132px, 0.8fr)) auto;
  align-items: end;
  gap: 12px;
}

.primary-search-panel .search-control {
  min-width: 0;
}

.primary-search-panel .search-control small {
  display: block;
  margin-top: 6px;
  color: #666666;
  font-size: 12px;
  line-height: 1.45;
}

.advanced-search-panel {
  margin-top: 10px;
  border: 1px solid #DADADA;
  border-radius: 8px;
  background: #FFFFFF;
}

.advanced-search-panel > summary {
  display: flex;
  min-height: 48px;
  align-items: center;
  gap: 12px;
  padding: 0 16px;
  color: #2B2B2B;
  cursor: pointer;
}

.advanced-search-panel > summary span {
  color: #666666;
  font-size: 13px;
}

.advanced-search-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin: 0;
  border: 0;
  border-top: 1px solid #E5E5E5;
  border-radius: 0 0 8px 8px;
  box-shadow: none;
}

.book-author-year {
  display: block;
  color: #444444;
  font-size: 13px;
  font-weight: 650;
  line-height: 1.45;
}

.book-detail .original-state {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.book-result-actions > a,
.book-result-actions > .result-source-note {
  display: inline-flex;
  min-height: 30px;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border: 1px solid #DADADA;
  border-radius: 6px;
  color: #2B2B2B;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.2;
  text-align: center;
  text-decoration: none;
}

.book-result-actions > .result-source-note {
  border-color: transparent;
  background: #F5F5F5;
  color: #666666;
}

.material-text-table {
  min-width: 880px;
  table-layout: fixed;
}

.text-col-title {
  width: 44%;
}

.text-col-publisher {
  width: 15%;
}

.text-col-year {
  width: 8%;
}

.text-col-type {
  width: 10%;
}

.text-col-availability {
  width: 15%;
}

.text-col-actions {
  width: 8%;
}

.text-title-cell a {
  display: block;
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: anywhere;
  -webkit-box-orient: initial;
  -webkit-line-clamp: initial;
}

.text-title-cell > span {
  display: block;
  margin-top: 4px;
  color: #666666;
  font-size: 12px;
}

.state-stack {
  gap: 5px;
}

.text-row-actions {
  display: grid;
  gap: 6px;
}

.text-row-actions a,
.text-row-actions button {
  width: 100%;
  min-height: 32px;
  white-space: normal;
}

.detail-core-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
}

.detail-primary-tags {
  align-items: center;
}

.detail-primary-tags-label {
  margin-right: 4px;
  color: #555555;
  font-size: 13px;
  font-weight: 800;
}

.detail-discovery-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid #E5E5E5;
}

.detail-discovery-nav button {
  min-height: 36px;
  padding: 0 12px;
  border: 1px solid #BDBDBD;
  border-radius: 6px;
  background: #FFFFFF;
  color: #2B2B2B;
}

.detail-overview-section {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-top: 18px;
}

.detail-overview-card,
.bibliographic-details {
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  padding: 18px;
  background: #FFFFFF;
}

.detail-overview-card p {
  margin: 12px 0 0;
  color: #333333;
  line-height: 1.7;
}

.detail-overview-card > small {
  display: block;
  margin-top: 10px;
  color: #666666;
  line-height: 1.5;
}

.bibliographic-details {
  grid-column: 1/-1;
  padding: 0;
}

.bibliographic-details > summary {
  padding: 16px 18px;
  cursor: pointer;
  font-weight: 800;
}

.bibliographic-details .bibliographic-list {
  margin: 0;
  padding: 0 18px 18px;
}

.toc-only-grid {
  grid-template-columns: minmax(0, 1fr);
}

@media (max-width: 1280px) {
  .primary-search-panel {
    grid-template-columns: minmax(300px, 2fr) repeat(3, minmax(128px, 1fr));
  }
  .primary-search-panel .reset-button {
    min-height: 42px;
  }
  .advanced-search-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .primary-search-panel,
  .advanced-search-grid,
  .detail-overview-section,
  .detail-core-list {
    grid-template-columns: minmax(0, 1fr);
  }
  .primary-search-panel .search-control,
  .bibliographic-details {
    grid-column: auto;
  }
  .advanced-search-panel > summary {
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    gap: 3px;
    padding-block: 10px;
  }
  .material-text-table {
    min-width: 760px;
  }
  .detail-action-group,
  .detail-discovery-nav {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
  }
  .detail-action-group > *,
  .detail-discovery-nav button {
    width: 100%;
  }
}
/* Review 163: the PDF page is the primary reading surface. */
.ebook-reader-grid {
  grid-template-areas: "stage";
  grid-template-columns: minmax(0, 1fr);
  width: 100%;
  gap: 12px;
}

.ebook-reader-grid.is-nav-panel-open {
  grid-template-areas: "nav stage";
  grid-template-columns: minmax(220px, 260px) minmax(0, 1fr);
}

.ebook-reader-grid.is-text-panel-open {
  grid-template-areas: "stage text";
  grid-template-columns: minmax(0, 1fr) minmax(300px, 360px);
}

.ebook-reader-grid.is-nav-panel-open.is-text-panel-open {
  grid-template-areas: "nav stage text";
  grid-template-columns: minmax(210px, 238px) minmax(0, 1fr) minmax(300px, 340px);
}

.reader-stage {
  grid-area: stage;
  min-width: 0;
}

.reader-nav-panel {
  grid-area: nav;
}

.reader-text-panel {
  grid-area: text;
}

.reader-panel-title {
  min-height: 34px;
}

.reader-panel-title > div {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.reader-panel-title > button {
  display: grid;
  width: 34px;
  min-width: 34px;
  height: 34px;
  padding: 0;
  place-items: center;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--card-bg);
  color: var(--text);
  cursor: pointer;
}

.reader-disclosure + .reader-disclosure {
  margin-top: 10px;
}

.reader-disclosure-toggle {
  display: flex;
  width: 100%;
  min-height: 42px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 10px;
  border: 1px solid var(--border);
  border-radius: 7px;
  background: var(--card-bg);
  color: var(--text);
  cursor: pointer;
  font-weight: 800;
  text-align: left;
}

.reader-disclosure-toggle small {
  color: var(--muted);
  font-size: 11px;
}

.reader-page-previews {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  margin-top: 8px;
}

.reader-page-previews button {
  display: grid;
  min-width: 0;
  min-height: 92px;
  align-content: center;
  gap: 5px;
  padding: 5px;
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--card-bg);
  color: var(--muted);
  cursor: pointer;
  font-size: 10px;
}

.reader-page-previews button.is-active {
  border-color: var(--accent);
  box-shadow: 0 0 0 1px var(--accent);
}

.reader-page-previews img {
  display: block;
  width: 100%;
  max-height: 112px;
  object-fit: contain;
}

.evidence-item-actions {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 7px;
}

.evidence-item-actions button {
  min-height: 30px;
  padding: 0 9px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--card-bg);
  color: var(--text);
  cursor: pointer;
}

.evidence-item-actions button:disabled {
  cursor: default;
  opacity: 0.48;
}

.evidence-list article {
  padding: 10px;
}

.reader-toolbar {
  position: sticky;
  top: 0;
  z-index: 5;
}

.reader-toolbar button.is-active {
  border-color: var(--accent);
  background: var(--accent-wash);
  color: var(--accent-hover);
}

.reader-action-message {
  margin: 8px 0 0;
  padding: 8px 10px;
  border-radius: 6px;
  background: var(--accent-wash);
  color: var(--accent-hover);
  font-size: 12px;
  font-weight: 700;
}

.reader-action-message.is-error {
  background: var(--issue-soft);
  color: var(--issue);
}

.reader-file-row {
  width: 100%;
}

.reader-index-state {
  white-space: nowrap;
}

.ebook-page-shell {
  width: 100%;
  max-width: none;
  min-width: 0;
  background: #F1F3F5;
}

.ebook-page-spread {
  min-width: min-content;
  min-height: min(820px, 78vh);
}

.ebook-page-spread::before {
  content: none;
}

.pdf-canvas {
  max-width: none;
  box-shadow: 0 18px 38px rgba(37, 50, 47, 0.2);
}

.reader-recovery-actions,
.reader-text-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.reader-recovery-actions {
  margin-top: 4px;
}

.reader-text-actions {
  margin: 10px 0;
}

.reader-text-actions button {
  min-height: 36px;
  padding: 0 10px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--card-bg);
  color: var(--text);
  cursor: pointer;
}

.reader-toolbar button:focus-visible,
.reader-panel-title > button:focus-visible,
.reader-disclosure-toggle:focus-visible,
.reader-page-previews button:focus-visible,
.reader-text-actions button:focus-visible,
.evidence-item-actions button:focus-visible {
  outline: 3px solid var(--focus-ring-color);
  outline-offset: 2px;
}

.ebook-reader-grid:fullscreen {
  width: 100vw;
  height: 100vh;
  padding: 12px;
  overflow: auto;
  background: var(--page-bg);
}

.ebook-reader-grid:fullscreen .reader-stage {
  align-self: stretch;
}

.ebook-reader-grid:fullscreen .ebook-page-spread {
  min-height: calc(100vh - 180px);
}

@media (max-width: 1100px) {
  .ebook-reader-grid.is-nav-panel-open,
  .ebook-reader-grid.is-text-panel-open,
  .ebook-reader-grid.is-nav-panel-open.is-text-panel-open {
    grid-template-areas: "stage" "nav" "text";
    grid-template-columns: minmax(0, 1fr);
  }
  .reader-nav-panel,
  .reader-text-panel {
    position: static;
    max-height: none;
  }
}
@media (max-width: 760px) {
  .reader-toolbar {
    gap: 6px;
    padding: 8px;
  }
  .reader-toolbar button {
    min-height: 40px;
    padding-inline: 9px;
    font-size: 12px;
  }
  .toolbar-divider {
    display: none;
  }
  .page-jump {
    order: 2;
    width: 100%;
    justify-content: center;
  }
  .page-jump input {
    width: 56px;
  }
  .reader-file-row,
  .reader-file-row > div {
    display: grid;
    width: 100%;
    justify-content: stretch;
  }
  .reader-file-row .source-link,
  .reader-index-state {
    width: 100%;
    justify-content: center;
    white-space: normal;
    text-align: center;
  }
  .ebook-page-spread {
    min-height: 62vh;
    padding: 10px;
  }
}
/* Stage 165: graph-first relationship exploration */
.graph-primary-view {
  display: flex;
  min-width: 0;
  flex-direction: column;
}

.graph-primary-view > .section-heading,
.graph-primary-view > .collection-heading {
  order: 0;
}

.graph-primary-view > .graph-target-row,
.graph-primary-view > .collection-tabs {
  order: 1;
}

.graph-primary-view > .graph-toolbar {
  order: 2;
}

.graph-primary-view > .graph-view-actions {
  order: 3;
}

.graph-primary-view > .graph-empty-state {
  order: 4;
}

.graph-primary-view > .book-graph-layout,
.graph-primary-view > .collection-graph-layout {
  order: 5;
}

.graph-primary-view > .graph-list-heading {
  order: 6;
}

.graph-primary-view > .graph-list-alternative {
  order: 7;
}

.graph-primary-view > .graph-support-details,
.graph-primary-view > .collection-material-list {
  order: 8;
}

.graph-primary-view > .book-graph-summary-panel,
.graph-primary-view > .graph-summary-list {
  order: 20;
}

.graph-primary-view > .graph-quality-panel {
  order: 21;
}

.graph-primary-view > .graph-legend {
  order: 22;
}

.graph-primary-view .book-graph-layout,
.graph-primary-view .collection-graph-layout {
  grid-template-columns: minmax(0, 1fr) minmax(300px, 340px);
  gap: 14px;
  min-width: 0;
  margin-top: 12px;
}

.graph-primary-view .graph-canvas,
.graph-primary-view .collection-graph-canvas {
  width: 100%;
  min-width: 0;
  min-height: clamp(540px, 100vh - 300px, 760px);
  overflow: hidden;
}

.graph-primary-view .graph-inspector {
  position: sticky;
  top: 12px;
  max-height: clamp(540px, 100vh - 300px, 760px);
  overflow: auto;
}

.graph-list-heading {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin: 18px 0 8px;
}

.graph-list-heading strong {
  color: var(--text);
  font-size: 15px;
}

.graph-list-heading span {
  color: var(--text-muted);
  font-size: 12px;
  text-align: right;
}

.graph-list-alternative {
  margin-top: 0;
}

.graph-support-details {
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--secondary-bg, #F5F5F5);
}

.graph-support-details summary {
  color: var(--text);
  font-weight: 700;
  cursor: pointer;
}

.graph-support-details button {
  min-height: 36px;
  margin-top: 10px;
  padding: 0 12px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: #FFFFFF;
  color: var(--text);
  cursor: pointer;
}

.graph-empty-state.is-partial {
  border-color: #C99735;
  background: #FFF8E8;
  color: #6A4A12;
}

.graph-list-alternative button:focus-visible,
.graph-support-details summary:focus-visible,
.graph-support-details button:focus-visible {
  outline: 3px solid var(--focus-ring-color);
  outline-offset: 2px;
}

@media (max-width: 1050px) {
  .graph-primary-view .book-graph-layout,
  .graph-primary-view .collection-graph-layout {
    grid-template-columns: minmax(0, 1fr);
  }
  .graph-primary-view .graph-inspector {
    position: static;
    max-height: none;
  }
}
@media (max-width: 760px) {
  .graph-hub-section,
  .graph-primary-view,
  .graph-primary-view > *,
  .graph-primary-view .book-graph-layout,
  .graph-primary-view .collection-graph-layout {
    max-width: 100%;
    min-width: 0;
  }
  .graph-primary-view .graph-toolbar {
    grid-template-columns: minmax(0, 1fr);
  }
  .graph-primary-view .graph-tool-actions,
  .graph-primary-view .graph-view-actions {
    width: 100%;
    overflow-x: auto;
  }
  .graph-primary-view .graph-canvas,
  .graph-primary-view .collection-graph-canvas {
    min-height: 520px;
  }
  .graph-list-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .graph-list-heading span {
    text-align: left;
  }
}`],
})
export class PageMainComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @ViewChild('modalPanel') modalPanel?: ElementRef;
    @ViewChild('pdfCanvas') pdfCanvas?: ElementRef<HTMLCanvasElement>;
    @ViewChild('readerWorkspace') readerWorkspace?: ElementRef<HTMLElement>;
    @ViewChild('readerViewport') readerViewport?: ElementRef<HTMLElement>;

    public books: BookItem[] = [];
    public filteredBooks: BookItem[] = [];
    public visibleBooks: BookItem[] = [];
    public relatedBooks: BookItem[] = [];
    public selectedBook: BookItem | null = null;
    public bodySearchQuery: string = "";
    public bodySearchResults: BodySearchHit[] = [];
    public searchMetaByBookKey: { [key: string]: SearchBookMeta } = {};
    public integratedSearchSuggestions: string[] = [];
    public integratedNearbyTopics: string[] = [];
    public searchAliasExpansions: SearchAliasExpansion[] = [];
    public searchEvidenceLoading: boolean = false;
    public searchEvidenceState: "initial" | "debouncing" | "loading" | "complete" | "error" = "initial";
    public searchEvidenceErrorMessage: string = "";
    public searchEvidenceQuery: string = "";
    public detailLoading: boolean = false;
    public detailErrorMessage: string = "";
    public aiQuestion: string = "";
    public aiDraftAnswer: string = "";
    public aiAnswer: AiAnswerPayload | null = null;
    public aiRequestState: "idle" | "loading" | "success" | "empty" | "error" = "idle";
    public aiScopeType: string = "selected";
    public aiScopeTag: string = "";
    public aiScopeCollectionId: string = "";
    public aiScopeOptions: Array<{ value: string, label: string }> = [
        { value: "all", label: "전체 접근 가능 자료" },
        { value: "selected", label: "선택한 자료" },
        { value: "tag", label: "선택한 주제" },
        { value: "collection", label: "선택한 모음" },
        { value: "reviewed", label: "접근 가능한 자료 확인 완료 자료" },
        { value: "public", label: "접근 가능한 공개 자료" },
    ];
    public reportAssistant: ReportAssistantPayload | null = null;
    public reportLoading: boolean = false;
    public reportErrorMessage: string = "";
    public loading: boolean = true;
    public errorMessage: string = "";
    public listSkeletonRows: number[] = [1, 2, 3, 4, 5, 6, 7, 8];
    public categoryOptions: string[] = [];
    public authorOptions: string[] = [];
    public authorSuggestions: string[] = [];
    public authorDropdownOpen: boolean = false;
    public authorActiveIndex: number = -1;
    public yearOptions: string[] = [];
    public tagOptions: string[] = [];
    public tagAxisOptions: string[] = [];
    public accessOptions: string[] = [];
    public reviewOptions: string[] = [];
    public businessAxisOptions: string[] = [];
    public issueAxisOptions: string[] = [];
    public eraAxisOptions: string[] = [];
    public regionAxisOptions: string[] = [];
    public relationshipAxisOptions: string[] = [];
    public materialNatureOptions: string[] = [];
    public creatorAxisOptions: string[] = [];
    public perspectiveAxisOptions: string[] = [];
    public workPurposeOptions: string[] = [];
    public reviewStateAxisOptions: string[] = [];
    public bodyExtractionOptions: string[] = [];
    public tagReviewOptions: string[] = [];
    public publicStatusOptions: string[] = [];
    public tagAxes: any = TAG_AXES;
    public tagAxisDisplayOrder: string[] = [
        TAG_AXES.business,
        TAG_AXES.issue,
        TAG_AXES.era,
        TAG_AXES.region,
        TAG_AXES.relation,
        TAG_AXES.material,
        TAG_AXES.creator,
        TAG_AXES.perspective,
        TAG_AXES.state,
    ];
    public landingSearchTags: string[] = ["독도", "발해", "고구려", "한일회담", "일제침탈", "위안부", "동북공정"];
    public demoTopicTags: string[] = ["독도", "영토·영유권", "시마네현", "시마네현 고시 제40호", "1905년 독도 침탈"];
    public demoReaderSearchTerms: string[] = ["1905년", "시마네현 고시", "영유권"];
    public demoGraphNodeLabel: string = "시마네현 고시 제40호";
    public demoAiQuestion: string = "독도 1905년 침탈과 관련된 핵심 근거를 정리해줘";
    public activePdfIndex: number = 0;
    public activePdfPage: number = 1;
    public readerPageInput: string = "1";
    public readerZoom: number = 1;
    public readerZoomMode: "fit-width" | "custom" = "fit-width";
    public pdfTotalPages: number = 0;
    public pdfLoading: boolean = false;
    public pdfRenderError: string = "";
    public currentPageText: string = "";
    public currentPageParagraphs: string[] = [];
    public currentPageQualityStatus: string = "미검증";
    public currentPageQualityReason: string = "품질 검증 산출물이 없습니다.";
    public currentPageTextAvailable: boolean = false;
    public currentPageSearchAvailable: boolean = false;
    public currentPageParagraphSaveAvailable: boolean = false;
    public currentPrintedPageNumber: number | null = null;
    public readerNavPanelOpen: boolean = false;
    public readerTextPanelOpen: boolean = false;
    public readerTocOpen: boolean = false;
    public readerPreviewOpen: boolean = false;
    public readerSavedPagesOpen: boolean = false;
    public readerFullscreen: boolean = false;
    public readerPageError: string = "";
    public readerActionMessage: string = "";
    public readerPagePreviews: ReaderPagePreview[] = [];
    public currentPageMatchCount: number = 0;
    public readerSearchQuery: string = "";
    public readerSearchResults: ReaderSearchHit[] = [];
    public readerSearchRunning: boolean = false;
    public readerSearchMessage: string = "";
    public readerAiQuestion: string = "";
    public readerAiAnswer: string = "";
    public readerAiLoading: boolean = false;
    public readerAiAnswerContext: string = "";
    public evidenceBox: EvidenceItem[] = [];
    public knowledgeGraph: KnowledgeGraphData | null = null;
    public collections: CollectionSummary[] = [];
    public selectedCollectionId: string = "";
    public searchRelatedCollections: SearchCollectionCard[] = [];
    public searchResultGroups: SearchResultGroup[] = [];
    public activeResultGroupId: string = "";
    public collectionGraph: KnowledgeGraphData | null = null;
    public collectionGraphLoading: boolean = false;
    public collectionGraphErrorMessage: string = "";
    public collectionGraphPartialMessage: string = "";
    public collectionSelectedNode: KnowledgeGraphNode | null = null;
    public collectionSelectedRelation: KnowledgeGraphRelation | null = null;
    public collectionHoveredNode: KnowledgeGraphNode | null = null;
    public collectionHoveredRelation: KnowledgeGraphRelation | null = null;
    public collectionNodeTypeFilter: string = "";
    public collectionReviewStatusFilter: string = "";
    public collectionMinConfidence: number = 0;
    public collectionShowEvidence: boolean = false;
    public collectionGraphExpanded: boolean = false;
    public collectionGraphZoom: number = 1;
    public collectionAiQuestion: string = "";
    public collectionAiAnswer: string = "";
    public collectionAiLoading: boolean = false;
    public graphLoading: boolean = false;
    public graphErrorMessage: string = "";
    public graphPartialMessage: string = "";
    public graphSelectedNode: KnowledgeGraphNode | null = null;
    public graphSelectedRelation: KnowledgeGraphRelation | null = null;
    public graphHoveredNode: KnowledgeGraphNode | null = null;
    public graphHoveredRelation: KnowledgeGraphRelation | null = null;
    public graphNodeTypeFilter: string = "";
    public graphRelationTypeFilter: string = "";
    public graphRelationStatusFilter: string = "전체";
    public graphSearchQuery: string = "";
    public graphMinConfidence: number = 0;
    public graphShowEvidence: boolean = false;
    public graphExpanded: boolean = false;
    public graphZoom: number = 1;
    public activeTopTab: string = "books";
    public activeSearchResultTab: string = "all";
    public searchResultTabs: SearchResultTab[] = [
        { id: "all", label: "전체", description: "자료와 근거를 함께 본 통합 결과" },
        { id: "materials", label: "자료", description: "표지, 자료 기본정보, 원문 상태를 비교" },
        { id: "body", label: "본문 근거", description: "페이지·문단 단위 근거" },
        { id: "tags", label: "주제어", description: "대표 주제어와 별칭 기반 결과" },
        { id: "graph", label: "자료 관계도", description: "항목·관계 연관 결과" },
        { id: "collections", label: "관련 자료 묶음", description: "주제 묶음과 자료 관계 결과" },
    ];
    public adminReviewLoading: boolean = false;
    public adminReviewAllowed: boolean = false;
    public adminReviewErrorMessage: string = "";
    public routeStateMessage: string = "";
    public activeGraphScope: string = "collection";
    public graphTargetBookId: string = "";
    public graphRouteSelectedNodeId: string = "";
    public graphRouteSelectedRelationId: string = "";
    public collectionRouteSelectedNodeId: string = "";
    public collectionRouteSelectedRelationId: string = "";
    public aiTargetBookId: string = "";
    public topTabs: Array<{ id: string, label: string }> = [
        { id: "books", label: "자료 목록" },
        { id: "search", label: "자료검색" },
        { id: "collections", label: "주제 탐색" },
        { id: "graph", label: "자료 관계도" },
        { id: "ai", label: "질문 근거 찾기" },
        { id: "admin", label: "자료 관리·확인" },
        { id: "users", label: "사용자 관리" },
    ];
    public stats: any = {
        rawCount: 0,
        count: 0,
        duplicateRemoved: 0,
        sourceFiles: [],
        assetStats: {
            metadataFiles: 0,
            pdfFiles: 0,
            coverFiles: 0,
            booksWithPdf: 0,
            booksWithoutPdf: 0,
            booksWithCover: 0,
            booksWithoutCover: 0
        }
    };
    public fallbackCoverLogoSrc: string = "/assets/brand/logo_nahf.png";
    private coverFailureCounts: { [src: string]: number } = {};
    public filters: any = {
        search: "",
        author: "",
        businessAxis: "",
        issueAxis: "",
        eraAxis: "",
        regionAxis: "",
        relationshipAxis: "",
        materialNature: "",
        creatorAxis: "",
        perspectiveAxis: "",
        workPurpose: "",
        reviewStateAxis: "",
        collectionId: "",
        year: "",
        pdfState: "",
        bodyExtractionStatus: "",
        tagReviewStatus: "",
        publicStatus: "",
        sort: "title"
    };
    private previousFocus: HTMLElement | null = null;
    private previousBodyOverflow: string = "";
    private pdfDocument: any = null;
    private activePdfUrl: string = "";
    private pageTextCache: any = {};
    private serverPageTextCache: any = {};
    private pdfRenderToken: number = 0;
    private pdfPageRenderTask: any = null;
    private readerSearchToken: number = 0;
    private knowledgeGraphToken: number = 0;
    private collectionGraphToken: number = 0;
    private knowledgeGraphAbortController: AbortController | null = null;
    private collectionGraphAbortController: AbortController | null = null;
    private knowledgeGraphRequestKey: string = "";
    private collectionGraphRequestKey: string = "";
    private aiRequestToken: number = 0;
    private readerAiRequestToken: number = 0;
    private reportRequestToken: number = 0;
    private collectionAiRequestToken: number = 0;
    private integratedSearchToken: number = 0;
    private integratedSearchAbortController: AbortController | null = null;
    private integratedSearchDebounceTimer: any = null;
    private integratedSearchCache: { [query: string]: { byBook: { [key: string]: SearchBookMeta }, suggestions: string[], nearbyTopics: string[], aliasExpansions: SearchAliasExpansion[] } } = {};
    private integratedSearchInFlight: { [query: string]: boolean } = {};
    private bookDetailCache: { [bookId: string]: BookItem } = {};
    private libraryCacheTtlMs: number = 5 * 60 * 1000;
    private pdfjs: any = null;
    private requestedReaderPage: number = 1;
    private readerResizeTimer: any = null;
    private readerPreviewToken: number = 0;
    private readerPreviewCache: { [key: string]: string } = {};
    private evidenceStorageKey: string = "nah-reader-evidence-v1";
    private materialViewStorageKey: string = "nah-material-list-view-mode-v1";
    private entryRouteApplied: boolean = false;
    private restoringRouteState: boolean = false;
    private selectedFileId: string = "";
    public materialViewMode: MaterialViewMode = "image";
    public materialListPage: number = 1;
    public materialListPageSize: number = 50;
    public materialListPageSizeOptions: number[] = [20, 50, 100];
    private materialListScrollY: number = 0;

    public async ngOnInit() {
        await this.service.init();
        if (this.service.auth.status && this.service.auth.session?.status !== "active") {
            this.service.href("/pending");
            return;
        }
        this.restoreMaterialViewMode();
        this.loadEvidenceBox();
        await this.loadServerBooks();
        await this.service.render();
    }

    private normalizeMaterialViewMode(value: any): MaterialViewMode | "" {
        let mode = this.text(value).toLocaleLowerCase();
        if (["text", "list", "table", "dense", "목록", "목록형"].includes(mode)) return "text";
        if (["image", "cover", "grid", "card", "표지", "표지형"].includes(mode)) return "image";
        return "";
    }

    private restoreMaterialViewMode() {
        let urlMode: MaterialViewMode | "" = "";
        try {
            let params = new URLSearchParams(window.location.search || "");
            urlMode = this.normalizeMaterialViewMode(params.get("view") || params.get("viewMode") || params.get("listView"));
        } catch (e) {
            urlMode = "";
        }

        if (urlMode) {
            this.materialViewMode = urlMode;
            this.persistMaterialViewMode(false);
            return;
        }

        let storedMode: MaterialViewMode | "" = "";
        try {
            storedMode = this.normalizeMaterialViewMode(window.localStorage.getItem(this.materialViewStorageKey));
        } catch (e) {
            storedMode = "";
        }
        if (storedMode) {
            this.materialViewMode = storedMode;
            this.persistMaterialViewMode(false);
        }
    }

    private persistMaterialViewMode(syncUrl: boolean = true) {
        try {
            window.localStorage.setItem(this.materialViewStorageKey, this.materialViewMode);
        } catch (e) { }
        if (syncUrl) this.syncMaterialViewModeUrl();
    }

    private syncMaterialViewModeUrl() {
        this.syncMainUrl("replace");
    }

    public isMaterialViewMode(mode: MaterialViewMode): boolean {
        return this.materialViewMode === mode;
    }

    public async setMaterialViewMode(mode: MaterialViewMode, event?: Event) {
        this.stopEvent(event);
        let nextMode = this.normalizeMaterialViewMode(mode);
        if (!nextMode || nextMode === this.materialViewMode) return;
        this.materialViewMode = nextMode;
        this.persistMaterialViewMode(true);
        await this.service.render();
    }

    public async loadServerBooks() {
        this.loading = true;
        this.errorMessage = "";
        await this.service.render();

        let usedCachedPayload = false;
        let cachedPayload = this.readCachedLibraryPayload();
        if (cachedPayload) {
            usedCachedPayload = true;
            await this.applyServerBooksPayload(cachedPayload);
            this.loading = false;
            await this.service.render();
        }

        try {
            let payload = await this.fetchServerBooksPayload();
            this.writeCachedLibraryPayload(payload);
            await this.applyServerBooksPayload(payload);
            this.loading = false;
            await this.service.render();
            await this.loadInitialDeferredData();
        } catch (e) {
            if (!usedCachedPayload) {
                this.errorMessage = "수집 자료 데이터를 불러오지 못했습니다.";
                this.books = [];
                this.filteredBooks = [];
                this.visibleBooks = [];
            } else {
                this.errorMessage = "최신 자료 목록 갱신에 실패해 저장된 목록을 표시합니다.";
            }
            this.loading = false;
            await this.service.render();
            if (usedCachedPayload) await this.loadInitialDeferredData();
        }
    }

    private async fetchServerBooksPayload(): Promise<any> {
        let endpoint = "/wiz/api/page.main/books?projection=list";
        let raw = await fetch(endpoint, { cache: "no-cache" });
        let response: any = await raw.json();
        if (!raw.ok || response?.code !== 200) {
            throw new Error(response?.data?.message || response?.message || "books failed");
        }
        return response?.data?.data || response?.data || {};
    }

    private readCachedLibraryPayload(): any | null {
        try {
            let raw = window.sessionStorage.getItem(this.libraryCacheKey());
            if (!raw) return null;
            let cached = JSON.parse(raw);
            if (!cached || !cached.payload || !Array.isArray(cached.payload.books)) return null;
            if (Date.now() - Number(cached.savedAt || 0) > this.libraryCacheTtlMs) return null;
            return cached.payload;
        } catch (e) {
            return null;
        }
    }

    private writeCachedLibraryPayload(payload: any) {
        try {
            if (!payload || !Array.isArray(payload.books)) return;
            window.sessionStorage.setItem(this.libraryCacheKey(), JSON.stringify({
                savedAt: Date.now(),
                payload
            }));
        } catch (e) { }
    }

    private libraryCacheKey(): string {
        let session = this.service.auth.session || {};
        let permissions = this.materialPermissions().slice().sort().join(",");
        let identity = [session.id || session.username || "anonymous", session.role || "guest", session.status || "", permissions].join("|");
        let hash = 2166136261;
        for (let i = 0; i < identity.length; i++) {
            hash ^= identity.charCodeAt(i);
            hash = Math.imul(hash, 16777619);
        }
        return `nah-library-list-v3-${(hash >>> 0).toString(16)}`;
    }

    private async applyServerBooksPayload(payload: any) {
        this.stats = {
            rawCount: payload.rawCount || 0,
            count: payload.count || 0,
            duplicateRemoved: payload.duplicateRemoved || 0,
            sourceFiles: payload.sourceFiles || [],
            assetStats: payload.assetStats || this.stats.assetStats,
            manifestStatus: payload.manifestStatus || []
        };
        this.collections = this.cleanCollections(payload.collections || []);
        if (!this.selectedCollectionId && this.collections.length) {
            let preferredCollection = this.collections.find((collection) => collection.id === "dokdo") || this.collections[0];
            this.selectedCollectionId = preferredCollection.id;
        }
        if (!this.aiScopeCollectionId && this.selectedCollectionId) {
            this.aiScopeCollectionId = this.selectedCollectionId;
        }
        this.restoringRouteState = true;
        this.setBooks(payload.books || []);
        this.applyEntryRouteParams();
        await this.applyFilters(false);
        this.syncSelectedBookFromUrl();
        this.restoringRouteState = false;
        this.syncMainUrl("replace");
        this.restoreDetailAnchor();
        this.ensureGraphTargetBook();
        this.ensureAiTargetBook();
    }

    private async loadInitialDeferredData() {
        if (this.selectedBook) {
            let detail = await this.loadBookDetail(this.selectedBook, false);
            this.applySelectedFileId(detail);
            let tasks: Promise<any>[] = [];
            if (this.canAccessBookOriginals(detail)) tasks.push(this.prepareActiveReader());
            if (this.canUseBookKnowledgeGraph(detail)) tasks.push(this.loadKnowledgeGraph(detail));
            await Promise.all(tasks);
            this.restoreDetailAnchor();
        } else if (this.activeTopTab === "graph" && this.canAccessKnowledgeGraph()) {
            if (this.activeGraphScope === "book") await this.ensureGraphTargetBookLoaded();
            else if (this.isCollectionGraphMode() && this.selectedCollectionId) await this.loadCollectionGraph();
        }
    }

    private bookDetailCacheKey(book: BookItem): string {
        return this.text(book.id || book.hflibId || book.title);
    }

    private bookMatches(left: BookItem, right: BookItem): boolean {
        if (!left || !right) return false;
        let leftIds = [left.id, left.hflibId].map((value) => this.text(value)).filter((value) => value);
        let rightIds = [right.id, right.hflibId].map((value) => this.text(value)).filter((value) => value);
        return leftIds.some((value) => rightIds.includes(value));
    }

    private replaceBookWithDetail(detail: BookItem) {
        let replace = (book: BookItem) => this.bookMatches(book, detail) ? detail : book;
        this.books = this.books.map(replace);
        this.filteredBooks = this.filteredBooks.map(replace);
        this.visibleBooks = this.visibleBooks.map(replace);
        this.relatedBooks = this.relatedBooks.map(replace);
        if (this.selectedBook && this.bookMatches(this.selectedBook, detail)) {
            this.selectedBook = detail;
            this.relatedBooks = this.findRelatedBooks(detail);
        }
        if (detail.id) this.bookDetailCache[detail.id] = detail;
        if (detail.hflibId) this.bookDetailCache[detail.hflibId] = detail;
    }

    private async loadBookDetail(book: BookItem, showLoading: boolean = true): Promise<BookItem> {
        let cacheKey = this.bookDetailCacheKey(book);
        let cached = this.bookDetailCache[cacheKey] || this.bookDetailCache[book.id] || this.bookDetailCache[book.hflibId];
        if (cached) {
            this.replaceBookWithDetail(cached);
            return cached;
        }
        if (book.detailLoaded) return book;

        this.detailLoading = showLoading;
        this.detailErrorMessage = "";
        if (showLoading) await this.service.render();

        try {
            let endpoint = `/wiz/api/page.main/book_detail?bookId=${encodeURIComponent(book.id || book.hflibId)}`;
            let raw = await fetch(endpoint, { cache: "no-cache" });
            let response: any = await raw.json();
            if (!raw.ok || response?.code !== 200) throw new Error(response?.data?.message || response?.message || "book_detail failed");
            let payload = response?.data?.data || response?.data || {};
            let detail = this.cleanBooks([payload.book || payload]).find((item) => item.id || item.title) || book;
            detail.detailLoaded = true;
            this.replaceBookWithDetail(detail);
            return detail;
        } catch (e) {
            this.detailErrorMessage = "상세 자료를 불러오지 못했습니다. 목록 정보로 표시합니다.";
            return book;
        } finally {
            this.detailLoading = false;
            if (showLoading) await this.service.render();
        }
    }

    public async setActiveTopTab(tabId: string, event?: Event) {
        this.stopEvent(event);
        if (tabId === "materials") tabId = "admin";
        if (!this.topTabs.some((tab) => tab.id === tabId)) return;
        if (!this.canAccessTopTab(tabId)) {
            this.adminReviewErrorMessage = this.accessDeniedMessage(tabId);
            this.activeTopTab = "books";
            await this.service.render();
            return;
        }
        if (tabId === "users") {
            window.location.href = "/admin/users";
            return;
        }
        if (tabId === "admin") {
            if (!this.canAccessMaterials()) {
                this.activeTopTab = "books";
                this.adminReviewErrorMessage = this.accessDeniedMessage("admin");
                await this.service.render();
                return;
            }
            window.location.href = "/admin/materials";
            return;
        }
        this.adminReviewErrorMessage = "";
        this.routeStateMessage = "";
        this.activeTopTab = tabId;

        if (tabId === "graph") {
            if (this.activeGraphScope === "book") {
                await this.ensureGraphTargetBookLoaded();
            } else if (this.isCollectionGraphMode()
                && this.selectedCollectionId
                && (!this.collectionGraph || this.collectionGraph.collectionId !== this.selectedCollectionId)
                && !this.collectionGraphLoading) {
                await this.loadCollectionGraph();
            }
        }

        if (tabId === "ai") this.ensureAiTargetBook();
        if (tabId === "search" && this.text(this.filters.search)) {
            this.prefetchIntegratedSearchMeta(this.filters.search);
        }
        this.syncMainUrl("push");
        await this.service.render();
    }

    public navigateToHome(event?: MouseEvent) {
        if (event && (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.service.href(HOME_ROUTE);
    }

    public visibleTopTabs(): Array<{ id: string, label: string }> {
        return this.topTabs.filter((tab) => this.canAccessTopTab(tab.id));
    }

    public isActiveTopTab(tabId: string): boolean {
        return this.activeTopTab === tabId;
    }

    public isAuthenticated(): boolean {
        return !!this.service.auth.status;
    }

    public isActiveUser(): boolean {
        return this.service.auth.session?.status === "active";
    }

    public currentUserRole(): string {
        return this.service.auth.session?.role || "";
    }

    public hasAnyRole(roles: string[]): boolean {
        return this.isActiveUser() && roles.includes(this.currentUserRole());
    }

    public materialPermissions(): string[] {
        let value = this.service.auth.session?.materialsPermissions || this.service.auth.session?.materials_permissions || [];
        if (Array.isArray(value)) return value;
        if (typeof value === "string" && value.trim()) {
            try {
                let parsed = JSON.parse(value);
                if (Array.isArray(parsed)) return parsed;
            } catch (e) {
                return value.split(",").map((item) => item.trim()).filter((item) => !!item);
            }
        }
        return [];
    }

    public currentUserName(): string {
        return this.service.auth.session?.name || this.service.auth.session?.username || "";
    }

    public currentUserRoleLabel(): string {
        let role = this.service.auth.session?.role || "";
        let labels: any = {
            user: "일반 사용자",
            researcher: "연구자",
            materials: "자료관리 담당자",
            reviewer: "검수자",
            admin: "관리자",
        };
        return labels[role] || role;
    }

    public currentUserStatusLabel(): string {
        let status = this.service.auth.session?.status || "";
        let labels: any = {
            pending: "승인대기",
            active: "활성",
            rejected: "반려",
            inactive: "비활성",
        };
        return labels[status] || status;
    }

    public isAdmin(): boolean {
        return this.hasAnyRole(["admin"]);
    }

    public canAccessCollections(): boolean {
        return true;
    }

    public canAccessKnowledgeGraph(): boolean {
        return true;
    }

    public canAccessResearchAi(): boolean {
        return this.hasAnyRole(["admin", "reviewer", "researcher"]);
    }

    public canAccessOriginals(): boolean {
        if (this.hasAnyRole(["admin", "reviewer", "researcher", "materials"])) return true;
        return this.isActiveUser() && this.materialPermissions().some((permission) => ["materials_admin", "materials_read_internal"].includes(permission));
    }

    public isReviewCompleted(book: BookItem | null): boolean {
        return this.text(book?.reviewStatus) === "검수 완료";
    }

    public isPublicApprovedBook(book: BookItem | null): boolean {
        if (!book) return false;
        if (book.publicEvidenceAllowed === false) return false;
        return this.text(book.publicStatus) === "공개" && this.isReviewCompleted(book);
    }

    public canAccessBookOriginals(book: BookItem | null): boolean {
        return this.canAccessOriginals() || this.isPublicApprovedBook(book);
    }

    public originalAccessDeniedLabel(book: BookItem | null): string {
        if (book?.publicEvidenceAllowed === false) return book.publicExposure?.reason || "공개 승인 전 원문은 공개되지 않습니다.";
        return "원문 열람은 연구자 이상 권한 또는 공개 승인 자료에만 제공됩니다.";
    }

    public canAccessAdminReview(): boolean {
        return this.hasAnyRole(["admin", "reviewer"]);
    }

    public canAccessMaterials(): boolean {
        return this.hasAnyRole(["admin", "materials"]) || (this.isActiveUser() && this.materialPermissions().length > 0);
    }

    public canAccessUserManagement(): boolean {
        return this.isAdmin();
    }

    public canAccessTopTab(tabId: string): boolean {
        if (["books", "search"].includes(tabId)) return true;
        if (["collections", "graph"].includes(tabId)) return this.canAccessKnowledgeGraph();
        if (tabId === "ai") return this.canAccessResearchAi();
        if (["materials", "admin"].includes(tabId)) return this.canAccessMaterials();
        if (tabId === "users") return this.canAccessUserManagement();
        return false;
    }

    public accessDeniedMessage(tabId: string): string {
        if (!this.isAuthenticated()) return "로그인 후 접근할 수 있습니다.";
        if (!this.isActiveUser()) return "활성 계정만 접근할 수 있습니다.";
        if (tabId === "ai") return "질문과 관련된 근거 찾기는 연구자 이상 권한이 필요합니다.";
        if (["materials", "admin"].includes(tabId)) return "자료 관리·검수는 자료관리 권한이 있는 계정만 접근할 수 있습니다.";
        if (tabId === "users") return "회원 관리는 관리자만 접근할 수 있습니다.";
        return "해당 기능에 접근할 권한이 없습니다.";
    }

    public async verifyAdminReviewAccess() {
        this.adminReviewLoading = true;
        this.adminReviewErrorMessage = "";
        await this.service.render();
        let response: any = await wiz.call("admin_review_summary");
        this.adminReviewLoading = false;
        this.adminReviewAllowed = response.code === 200;
        if (!this.adminReviewAllowed) {
            this.adminReviewErrorMessage = response.data?.message || response.data || "관리·검수 권한을 확인하지 못했습니다.";
        }
        await this.service.render();
    }


    public async selectGraphScope(scope: string, event?: Event) {
        this.stopEvent(event);
        if (!this.canAccessKnowledgeGraph()) {
            this.adminReviewErrorMessage = this.accessDeniedMessage("graph");
            await this.service.render();
            return;
        }
        if (!GRAPH_TYPE_OPTIONS.some((option) => option.value === scope)) return;
        if (scope === "book") {
            this.collectionGraphAbortController?.abort();
            this.collectionGraphToken++;
            this.collectionGraphLoading = false;
        } else {
            this.knowledgeGraphAbortController?.abort();
            this.knowledgeGraphToken++;
            this.graphLoading = false;
        }
        this.activeGraphScope = scope;
        this.activeTopTab = "graph";
        this.syncMainUrl("push");
        if (scope === "book") await this.ensureGraphTargetBookLoaded();
        if (scope === "related") this.prepareRelatedGraphCollection();
        if (scope === "issue") this.prepareIssueGraphCollection();
        if (this.isCollectionGraphMode()
            && this.selectedCollectionId
            && (!this.collectionGraph || this.collectionGraph.collectionId !== this.selectedCollectionId)
            && !this.collectionGraphLoading) {
            await this.loadCollectionGraph();
        }
        await this.service.render();
    }

    public graphTypeOptions(): Array<{ value: string, label: string }> {
        return GRAPH_TYPE_OPTIONS;
    }

    public activeGraphTypeLabel(): string {
        let option = GRAPH_TYPE_OPTIONS.find((item) => item.value === this.activeGraphScope);
        return option ? option.label : "주제별 관계도";
    }

    public isCollectionGraphMode(): boolean {
        return ["collection", "related", "issue"].includes(this.activeGraphScope);
    }

    public graphModeDescription(collection: CollectionSummary | null): string {
        if (this.activeGraphScope === "related") {
            return "선택 자료와 같은 현안·태그로 묶인 관련 자료의 관계와 근거 상태를 확인합니다.";
        }
        if (this.activeGraphScope === "issue") {
            return "역사현안 대응에 필요한 자료, 쟁점, 근거 후보의 연결 상태를 확인합니다.";
        }
        return collection?.description || "컬렉션 단위 자료 관계와 본문 근거 연결 상태를 확인합니다.";
    }

    private prepareRelatedGraphCollection() {
        this.ensureGraphTargetBook();
        let book = this.graphTargetBook();
        let collectionId = book ? this.collectionIdForBook(book) : "";
        if (collectionId) this.selectedCollectionId = collectionId;
    }

    private prepareIssueGraphCollection() {
        if (this.selectedCollectionId) return;
        let issueCollection = this.collections.find((collection) => {
            let value = `${collection.id} ${collection.title} ${collection.description}`.toLocaleLowerCase();
            return /dokdo|intrusion|talks|comfort|goguryeo|balhae|project|gando|독도|일제|한일|위안부|고구려|발해|동북공정|간도/.test(value);
        }) || this.collections[0] || null;
        if (issueCollection) this.selectedCollectionId = issueCollection.id;
    }

    public graphTargetBook(): BookItem | null {
        return this.findBookByMaterialId(this.graphTargetBookId) || this.books.find((book) => book.graphAvailable) || this.books[0] || null;
    }

    public graphCandidateBooks(): BookItem[] {
        let rows = this.books
            .filter((book) => book.graphAvailable || book.bodySearchAvailable || book.tags.length > 0)
            .sort((a, b) => Number(b.graphAvailable) - Number(a.graphAvailable) || b.bodyChunkCount - a.bodyChunkCount || a.title.localeCompare(b.title, "ko"));
        return rows.slice(0, 80);
    }

    public ensureGraphTargetBook() {
        if (this.graphTargetBookId && this.findBookByMaterialId(this.graphTargetBookId)) return;
        let target = this.books.find((book) => book.graphAvailable)
            || this.books.find((book) => book.bodySearchAvailable)
            || this.books[0]
            || null;
        this.graphTargetBookId = target?.id || "";
    }

    public async ensureGraphTargetBookLoaded() {
        this.ensureGraphTargetBook();
        let book = this.graphTargetBook();
        if (!book) return;
        if (!this.knowledgeGraph || this.knowledgeGraph.materialId !== (book.id || book.hflibId)) {
            await this.loadKnowledgeGraph(book);
        }
    }

    public async selectGraphBook(bookId: string) {
        this.graphTargetBookId = this.text(bookId);
        this.activeGraphScope = "book";
        this.activeTopTab = "graph";
        this.graphNodeTypeFilter = "";
        this.graphRelationTypeFilter = "";
        this.graphRelationStatusFilter = "전체";
        this.graphSearchQuery = "";
        this.graphMinConfidence = 0;
        this.graphShowEvidence = false;
        this.graphExpanded = false;
        this.graphZoom = 1;
        this.graphRouteSelectedNodeId = "";
        this.graphRouteSelectedRelationId = "";
        this.syncMainUrl("push");
        let book = this.graphTargetBook();
        if (book) await this.loadKnowledgeGraph(book);
        await this.service.render();
    }

    public selectedAiTargetBook(): BookItem | null {
        return this.findBookByMaterialId(this.aiTargetBookId) || this.graphTargetBook() || this.books[0] || null;
    }

    public ensureAiTargetBook() {
        if (this.aiTargetBookId && this.findBookByMaterialId(this.aiTargetBookId)) return;
        this.aiTargetBookId = this.graphTargetBook()?.id || this.books[0]?.id || "";
    }

    private aiScopeIdentifier(book: BookItem | null): string {
        if (this.aiScopeType === "selected") return this.text(book?.id || book?.hflibId || this.aiTargetBookId);
        if (this.aiScopeType === "tag") return this.text(this.aiScopeTag);
        if (this.aiScopeType === "collection") return this.text(this.aiScopeCollectionId);
        return "";
    }

    private aiScopeValidationMessage(book: BookItem | null): string {
        if (this.aiScopeType === "selected" && !this.aiScopeIdentifier(book)) return "선택 자료 범위에는 자료를 먼저 선택해야 합니다.";
        if (this.aiScopeType === "tag" && !this.aiScopeTag) return "선택 주제 범위에는 주제를 먼저 선택해야 합니다.";
        if (this.aiScopeType === "collection" && !this.aiScopeCollectionId) return "선택 모음 범위에는 모음을 먼저 선택해야 합니다.";
        return "";
    }

    private aiScopeRequestKey(book: BookItem | null): string {
        let session = this.service.auth.session || {};
        let liveIdentifier = this.aiScopeType === "selected" && !this.selectedBook
            ? this.text(this.aiTargetBookId || book?.id || book?.hflibId)
            : this.aiScopeIdentifier(book);
        return [
            session.id || session.username || "anonymous",
            session.role || "guest",
            session.status || "",
            this.aiScopeType,
            liveIdentifier,
            this.text(this.aiQuestion),
        ].map((value) => this.text(value)).join("|");
    }

    private focusQuestionResult(selector: string = ".question-result-focus") {
        setTimeout(() => {
            let target = document.querySelector(selector) as HTMLElement | null;
            if (target?.focus) target.focus({ preventScroll: false });
        }, 0);
    }

    public async onAiScopeChange() {
        this.aiRequestToken++;
        this.reportRequestToken++;
        this.aiAnswer = null;
        this.aiDraftAnswer = "";
        this.aiRequestState = "idle";
        this.reportAssistant = null;
        this.reportErrorMessage = "";
        if (!this.restoringRouteState && this.activeTopTab === "ai") this.syncMainUrl("replace");
        await this.service.render();
    }

    public async onAiQuestionChange() {
        this.aiRequestToken++;
        this.reportRequestToken++;
        this.aiAnswer = null;
        this.aiDraftAnswer = "";
        this.aiRequestState = "idle";
        this.reportAssistant = null;
        this.reportErrorMessage = "";
        await this.service.render();
    }

    public async askResearchAi() {
        if (!this.canAccessResearchAi()) {
            this.aiAnswer = null;
            this.aiDraftAnswer = this.accessDeniedMessage("ai");
            this.aiRequestState = "error";
            await this.service.render();
            this.focusQuestionResult();
            return;
        }
        this.ensureAiTargetBook();
        let book = this.selectedAiTargetBook();
        if (!book) return;
        let validationMessage = this.aiScopeValidationMessage(book);
        if (validationMessage) {
            this.aiAnswer = null;
            this.aiDraftAnswer = validationMessage;
            this.aiRequestState = "error";
            await this.service.render();
            this.focusQuestionResult();
            return;
        }
        await this.askAi(book);
    }

    public collectionPreviewBooks(collection: CollectionSummary | null = null, limit: number = 12): BookItem[] {
        collection = collection || this.selectedCollection();
        if (!collection) return [];
        let rows = this.books.filter((book) => this.collectionIdForBook(book) === collection?.id);
        if (!rows.length && collection.topMaterialTitles.length) {
            rows = collection.topMaterialTitles
                .map((title) => this.books.find((book) => book.title === title || book.title.includes(title) || title.includes(book.title)))
                .filter((book): book is BookItem => !!book);
        }
        rows.sort((a, b) => Number(b.bodySearchAvailable) - Number(a.bodySearchAvailable) || b.pdfCount - a.pdfCount || a.title.localeCompare(b.title, "ko"));
        return rows.slice(0, limit);
    }

    public collectionAxisPreview(collection: CollectionSummary | null, axis: string, limit: number = 5): string[] {
        let counts: any = {};
        this.collectionPreviewBooks(collection, 40).forEach((book) => {
            this.axisTagNames(book, axis).forEach((name) => counts[name] = (counts[name] || 0) + 1);
        });
        return Object.keys(counts)
            .sort((a, b) => counts[b] - counts[a] || a.localeCompare(b, "ko"))
            .slice(0, limit);
    }

    public collectionRepresentativeTags(collection: CollectionSummary | null): string[] {
        let axes = [TAG_AXES.issue, TAG_AXES.business, TAG_AXES.material, TAG_AXES.region, TAG_AXES.era, TAG_AXES.relation];
        let tags: string[] = [];
        axes.forEach((axis) => {
            this.collectionAxisPreview(collection, axis, 4).forEach((name) => {
                if (!tags.includes(name)) tags.push(name);
            });
        });
        return tags.slice(0, 8);
    }

    public collectionPublicMeta(collection: CollectionSummary | null): string {
        if (!collection) return "주제별 자료";
        let parts = [`자료 ${collection.materialCount || 0}건`];
        if (collection.pdfCount > 0) parts.push(`원문 ${collection.pdfCount}개`);
        if (collection.bodyIndexedCount > 0) parts.push(`본문 검색 ${collection.bodyIndexedCount}건`);
        return parts.join(" · ");
    }

    public collectionAxisFallback(label: string): string {
        return `${label} 준비 중`;
    }

    public publicOriginalGuide(book: BookItem): string {
        if (book.pdfAvailable && book.pdfCount > 1) return `원문 ${book.pdfCount}개가 있습니다`;
        if (book.pdfAvailable) return "원문을 볼 수 있습니다";
        if (book.sourceUrl) return "외부 출처 링크만 있습니다";
        return "연결된 원문이 없습니다";
    }

    public publicOriginalGuideDetail(book: BookItem): string {
        if (book.pdfAvailable) return `${book.pdfCount || 1}개 원문 파일이 연결되어 있습니다.`;
        if (book.sourceUrl) return "내부 원문은 없으며 외부 출처 사이트에서 확인합니다.";
        return "원문이 없어 출처 정보와 관련 자료를 함께 확인할 수 있습니다.";
    }

    public publicBodyGuide(book: BookItem): string {
        if (book.bodySearchAvailable) return this.isPartialBodySearch(book) ? "일부 본문을 검색할 수 있습니다" : "본문까지 검색할 수 있습니다";
        if (book.pdfAvailable) return "원문을 열어 내용을 확인할 수 있습니다";
        return "제목과 주제어로 찾을 수 있습니다";
    }

    public publicBodyGuideDetail(book: BookItem): string {
        if (book.bodySearchAvailable) return this.isPartialBodySearch(book)
            ? `검색 가능한 ${book.searchablePageCount || book.extractedPageCount}쪽에서 페이지·문단 단위로 찾습니다.`
            : "페이지와 문단 단위로 검색 결과를 확인합니다.";
        if (book.pdfAvailable) return "본문 검색은 준비 중이며 원문 열람은 가능합니다.";
        return "본문 검색은 원문 연결 후 제공됩니다.";
    }

    public publicGraphGuide(book: BookItem): string {
        if (book.graphAvailable) return "자료 관계도를 볼 수 있습니다";
        if (book.tags.length > 0) return "주제어로 관련 자료를 찾을 수 있습니다";
        return "연결 정보 준비 중";
    }

    public publicGraphGuideDetail(book: BookItem): string {
        if (book.graphAvailable) return "인물·장소·사건이 어떻게 이어지는지 확인합니다.";
        if (book.tags.length > 0) return "같은 주제어를 가진 자료를 함께 살펴봅니다.";
        return "자료가 정리되면 자료 관계도가 제공됩니다.";
    }

    public publicQuestionGuide(book: BookItem): string {
        return this.canAccessResearchAi() ? "질문과 관련된 근거를 찾을 수 있습니다" : "근거 찾기는 권한이 필요합니다";
    }

    public publicQuestionGuideDetail(book: BookItem): string {
        if (this.canAccessResearchAi()) return "답변 문장을 생성하지 않고 자료명·원문 파일·PDF 쪽·근거 문단을 찾습니다.";
        return "로그인한 연구자·검수자에게 제공되는 기능입니다.";
    }

    public evidenceFileLabel(item: AiEvidenceItem): string {
        let book = this.findBookByMaterialId(item.bookId || item.hflibId || "");
        let volume = this.text(book?.volume);
        let filename = this.text(item.pdfFilename) || "파일명 미확인";
        return volume ? `${volume} · ${filename}` : filename;
    }

    public evidenceLocationLabel(item: AiEvidenceItem): string {
        let printed = this.text(item.printedPage);
        return `PDF ${item.page || "미확인"}쪽 · 인쇄쪽수 ${printed || "미확인"} · 문단 ${item.paragraph || "미확인"}`;
    }

    public bodySummaryCoverage(book: BookItem): string {
        if (!book.summaryGrounded) return "";
        return this.text(book.summaryCoverage) || `자료ID ${book.id || book.hflibId} · 사용 파일·본문 범위 미기록`;
    }

    private readerQuestionRequestKey(book: BookItem): string {
        let session = this.service.auth.session || {};
        let pdf = this.activePdf(book);
        return [
            session.id || session.username || "anonymous",
            session.role || "guest",
            session.status || "",
            book.id || book.hflibId,
            pdf?.fileId || pdf?.textIndex?.fileId,
            this.activePdfPage,
            this.text(this.readerAiQuestion),
        ].map((value) => this.text(value)).join("|");
    }

    public showReaderQuestionResult(book: BookItem): boolean {
        return Boolean(this.readerAiAnswer && this.readerAiAnswerContext === this.readerQuestionRequestKey(book));
    }

    public showReaderQuestionLoading(book: BookItem): boolean {
        return this.readerAiLoading && this.readerAiAnswerContext === this.readerQuestionRequestKey(book);
    }

    public async selectCollectionOverview(collection: CollectionSummary, event?: Event) {
        this.stopEvent(event);
        if (!this.canAccessCollections()) {
            this.adminReviewErrorMessage = this.accessDeniedMessage("collections");
            await this.service.render();
            return;
        }
        if (!collection) return;
        let changed = this.selectedCollectionId !== collection.id;
        this.selectedCollectionId = collection.id;
        this.aiScopeCollectionId = collection.id;
        this.activeTopTab = "collections";
        if (changed) {
            this.collectionGraph = null;
            this.collectionSelectedNode = null;
            this.collectionSelectedRelation = null;
            this.collectionHoveredNode = null;
            this.collectionHoveredRelation = null;
        }
        this.syncMainUrl("push");
        await this.service.render();
    }

    public async openCollectionOverviewGraph(collection: CollectionSummary, event?: Event) {
        await this.openCollectionGraphById(collection?.id, event);
    }

    public async showCollectionMaterials(collection: CollectionSummary, event?: Event) {
        this.stopEvent(event);
        if (!this.canAccessCollections()) {
            this.adminReviewErrorMessage = this.accessDeniedMessage("collections");
            await this.service.render();
            return;
        }
        if (!collection) return;
        this.selectedCollectionId = collection.id;
        this.filters = this.emptyFilterState();
        this.filters.collectionId = collection.id;
        this.filters.sort = "newest";
        this.activeResultGroupId = "";
        this.activeTopTab = "search";
        this.syncMainUrl("push");
        await this.applyFilters();
        this.scrollToList();
        await this.service.render();
    }

    public async applyCollectionFilterSelection() {
        let collectionId = this.text(this.filters.collectionId);
        this.activeResultGroupId = "";
        if (collectionId && this.collections.some((collection) => collection.id === collectionId)) {
            this.selectedCollectionId = collectionId;
            this.aiScopeCollectionId = collectionId;
        }
        await this.applyFilters();
    }

    public adminStatusRows(): Array<{ label: string, value: string, note: string }> {
        let pdfReady = this.books.filter((book) => book.pdfAvailable).length;
        let bodyReady = this.books.filter((book) => book.verificationStatus?.bodySearch?.code === "available").length;
        let evidenceReady = this.books.filter((book) => book.verificationStatus?.questionEvidence?.code === "available").length;
        let pageCount = this.books.reduce((sum, book) => sum + Number(book.verificationStatus?.pdfPages?.value || 0), 0);
        let textPageCount = this.books.reduce((sum, book) => sum + Number(book.verificationStatus?.textPages?.value || 0), 0);
        let searchablePageCount = this.books.reduce((sum, book) => sum + Number(book.verificationStatus?.searchablePages?.value || 0), 0);
        let publicReady = this.books.filter((book) => this.publicAvailabilityLabel(book) === "공개 가능").length;
        return [
            { label: "원문 링크/파일", value: `${pdfReady}/${this.books.length}건`, note: `${this.stats.assetStats?.pdfFiles || 0}개 파일(자료 건수와 별도)` },
            { label: "PDF 원문 쪽수", value: `${pageCount.toLocaleString()}쪽`, note: "쪽수 확인 파일만 합산" },
            { label: "텍스트 추출 쪽수", value: `${textPageCount.toLocaleString()}쪽`, note: "PDF 원문 쪽수와 별도" },
            { label: "검색 가능 쪽수", value: `${searchablePageCount.toLocaleString()}쪽`, note: "실제 오류 신호 검사 통과 쪽" },
            { label: "본문 검색", value: `${bodyReady}/${this.books.length}건`, note: "검색 색인과 본문 구간 모두 확인" },
            { label: "질문 근거", value: `${evidenceReady}/${this.books.length}건`, note: "현재 권한에서 근거 사용 가능한 자료" },
            { label: "공개 범위", value: `${publicReady}/${this.books.length}건`, note: "자료 확인 상태와 별도" },
        ];
    }

    public adminReviewBooks(): BookItem[] {
        return this.books
            .slice()
            .sort((a, b) => Number(!a.pdfAvailable) - Number(!b.pdfAvailable)
                || Number(!a.bodySearchAvailable) - Number(!b.bodySearchAvailable)
                || b.tagReviewSummary.pendingCount - a.tagReviewSummary.pendingCount
                || a.title.localeCompare(b.title, "ko"))
            .slice(0, 18);
    }

    public setBooks(items: BookItem[]) {
        this.books = this.cleanBooks(items);
        this.categoryOptions = this.uniqueOptions(this.books.map((book) => book.category));
        this.authorOptions = this.uniqueOptions(this.books.map((book) => book.author));
        this.accessOptions = this.uniqueOptions(this.books.map((book) => book.accessStatus));
        this.tagOptions = this.uniqueOptions(this.books.flatMap((book) => book.tags.map((tag) => tag.name)));
        this.tagAxisOptions = this.uniqueOptions(this.books.flatMap((book) => book.tags.map((tag) => tag.axis)));
        this.reviewOptions = this.uniqueOptions(this.books.map((book) => book.reviewStatus));
        this.businessAxisOptions = this.axisOptions(TAG_AXES.business);
        this.issueAxisOptions = this.axisOptions(TAG_AXES.issue);
        this.eraAxisOptions = this.axisOptions(TAG_AXES.era);
        this.regionAxisOptions = this.axisOptions(TAG_AXES.region);
        this.relationshipAxisOptions = this.axisOptions(TAG_AXES.relation);
        this.materialNatureOptions = this.uniqueOptions(
            this.books.flatMap((book) => this.axisTagNames(book, TAG_AXES.material).concat([this.materialNature(book)]))
        );
        this.creatorAxisOptions = this.axisOptions(TAG_AXES.creator);
        this.perspectiveAxisOptions = this.axisOptions(TAG_AXES.perspective);
        this.workPurposeOptions = this.axisOptions(TAG_AXES.purpose);
        this.reviewStateAxisOptions = this.axisOptions(TAG_AXES.state);
        this.bodyExtractionOptions = this.uniqueOptions(this.books.map((book) => this.bodyExtractionStatus(book)));
        this.tagReviewOptions = this.uniqueOptions(this.books.map((book) => this.tagReviewLabel(book)));
        this.publicStatusOptions = this.uniqueOptions(this.books.map((book) => this.publicStatusLabel(book)));
        this.updateAuthorSuggestions();
        this.yearOptions = this.uniqueOptions(
            this.books
                .map((book) => this.yearOf(book))
                .filter((year) => year)
        ).sort((a: string, b: string) => Number(b) - Number(a));
        this.syncSelectedBookFromUrl();
    }

    public cleanCollections(items: any[]): CollectionSummary[] {
        if (!Array.isArray(items)) return [];
        let seen: any = {};
        return items
            .map((item) => ({
                id: this.text(item.id),
                title: this.text(item.title),
                description: this.text(item.description),
                reviewStatus: this.text(item.reviewStatus || "검수대기"),
                publicStatus: this.text(item.publicStatus || "내부전용"),
                materialCount: Number(item.materialCount || 0),
                pdfCount: Number(item.pdfCount || 0),
                bodyIndexedCount: Number(item.bodyIndexedCount || 0),
                topMaterialTitles: Array.isArray(item.topMaterialTitles)
                    ? item.topMaterialTitles.map((value: any) => this.text(value)).filter((value: string) => value)
                    : []
            }))
            .filter((item) => {
                if (!item.id || !item.title || seen[item.id]) return false;
                seen[item.id] = true;
                return true;
            });
    }

    private valueAtPath(item: any, path: string): string {
        let current = item;
        for (let part of this.text(path).split(".")) {
            if (!current || typeof current !== "object" || Array.isArray(current)) return "";
            current = current[part];
        }
        return this.text(current);
    }

    private firstCoverField(item: any): string {
        if (!item || typeof item !== "object") return "";
        let fields = [
            "cover",
            "coverImage",
            "cover_url",
            "coverUrl",
            "coverPath",
            "localCoverPath",
            "thumbnail",
            "image",
            "coverImageUrl",
            "cover_image",
            "thumbnail_url",
            "thumbnailUrl"
        ];
        for (let field of fields) {
            let value = this.text(item[field]);
            if (value) return value;
        }
        return "";
    }

    private firstThumbnailField(item: any): string {
        if (!item || typeof item !== "object") return "";
        let fields = [
            "listCoverImage",
            "coverThumbnailImage",
            "coverThumbnail",
            "cover_thumbnail",
            "coverThumb",
            "cover_thumb",
            "thumbnailImage",
            "thumbnail_image",
            "thumbnail",
            "thumbnail_url",
            "thumbnailUrl",
            "thumb",
            "thumb_url",
            "thumbUrl",
            "썸네일",
            "표지 썸네일",
            "표지 썸네일 URL"
        ];
        for (let field of fields) {
            let value = this.text(item[field]);
            if (value) return value;
        }
        return "";
    }

    private coverFieldFromContainer(value: any, thumbnailOnly: boolean = false): string {
        if (!value) return "";
        if (Array.isArray(value)) {
            for (let row of value) {
                if (!row || typeof row !== "object") continue;
                let role = this.normalizeStatusText(this.text(row.role || row.type || row.kind || row.name || row.label)).toLowerCase();
                let isThumbnail = role.includes("thumbnail") || role.includes("thumb") || role.includes("썸네일");
                if (thumbnailOnly && !isThumbnail) continue;
                if (!thumbnailOnly && !role.includes("cover") && !role.includes("thumbnail") && !role.includes("thumb") && !role.includes("표지")) continue;
                let direct = this.coverFieldFromContainer(row, thumbnailOnly);
                if (direct) return direct;
            }
            return "";
        }
        if (typeof value !== "object") return this.text(value);
        return (thumbnailOnly ? this.firstThumbnailField(value) : this.firstCoverField(value))
            || this.text(value.url || value.path || value.href || value.file || value.filename);
    }

    private encodeCoverPath(value: string): string {
        value = this.text(value).replace(/\\/g, "/");
        if (!value) return "";
        if (/^(https?:|data:|\/wiz\/)/i.test(value)) return value;

        let normalizePublic = (prefix: string, browserPrefix: string): string => {
            if (!value.startsWith(prefix)) return "";
            let rest = value.slice(prefix.length).replace(/^\/+/, "");
            return browserPrefix + rest.split("/").map((part) => encodeURIComponent(decodeURIComponent(part))).join("/");
        };

        return normalizePublic("/assets/", "/assets/")
            || normalizePublic("assets/", "/assets/")
            || normalizePublic("/static/", "/static/")
            || normalizePublic("static/", "/static/")
            || normalizePublic("public/assets/", "/assets/")
            || normalizePublic("public/static/", "/static/")
            || value;
    }

    public normalizedCoverImage(item: any): string {
        let direct = this.firstCoverField(item);
        if (direct) return this.encodeCoverPath(direct);

        for (let path of [
            "assets.cover",
            "assets.coverImage",
            "assets.cover_url",
            "assets.coverPath",
            "assets.localCoverPath",
            "assets.thumbnail",
            "assets.image",
            "files.cover",
            "files.coverImage",
            "files.cover_url",
            "files.coverPath",
            "files.localCoverPath",
            "files.thumbnail",
            "files.image"
        ]) {
            let value = this.valueAtPath(item, path);
            if (value) return this.encodeCoverPath(value);
        }

        let nested = this.coverFieldFromContainer(item?.assets) || this.coverFieldFromContainer(item?.files);
        return this.encodeCoverPath(nested);
    }

    public normalizedListCoverImage(item: any): string {
        let direct = this.firstThumbnailField(item);
        if (direct) return this.encodeCoverPath(direct);

        for (let path of [
            "assets.listCoverImage",
            "assets.coverThumbnailImage",
            "assets.coverThumbnail",
            "assets.cover_thumb",
            "assets.thumbnailImage",
            "assets.thumbnail",
            "assets.thumbnail_url",
            "assets.thumb",
            "files.listCoverImage",
            "files.coverThumbnailImage",
            "files.coverThumbnail",
            "files.cover_thumb",
            "files.thumbnailImage",
            "files.thumbnail",
            "files.thumbnail_url",
            "files.thumb"
        ]) {
            let value = this.valueAtPath(item, path);
            if (value) return this.encodeCoverPath(value);
        }

        let nested = this.coverFieldFromContainer(item?.assets, true) || this.coverFieldFromContainer(item?.files, true);
        return this.encodeCoverPath(nested);
    }

    public cleanBooks(items: any[]): BookItem[] {
        let result: BookItem[] = [];
        let seenIds: any = {};
        let seenTitleAuthor: any = {};

        for (let i = 0; i < items.length; i++) {
            let item = items[i] || {};
            let title = this.text(item.title);
            if (!title) continue;

            let pdfs = this.cleanPdfs(item.pdfs);
            let tags = this.cleanSubjectTags(item.tags);
            let publicTags = this.cleanSubjectTags(item.publicTags);
            let tagAliases = this.cleanTagAliases(item.tagAliases);
            let tagReviewSummary = this.cleanTagReviewSummary(item.tagReviewSummary, tags, publicTags);
            let statusTags = this.cleanStatusTags(item.statusTags, item.tags);
            let coverImage = this.normalizedCoverImage(item);
            let coverThumbnailImage = this.normalizedListCoverImage(item);
            let listCoverImage = coverThumbnailImage || coverImage;
            let id = this.text(item.id) || this.text(item.hflibId) || `book-${i}`;
            let author = this.text(item.author) || "저자 정보 없음";
            let declaredPdfCount = Math.max(pdfs.length, Number(item.pdfCount || 0));
            let pdfAvailable = pdfs.length > 0 || Boolean(item.pdfAvailable) || declaredPdfCount > 0;
            let aiSummary = this.text(item.aiSummary);

            let book: BookItem = {
                id: id,
                hflibId: this.text(item.hflibId) || id,
                title: title,
                titleStatement: this.text(item.titleStatement),
                author: author,
                compiler: this.text(item.compiler),
                editor: this.text(item.editor),
                publisher: this.text(item.publisher) || "출판사 정보 없음",
                publishedDate: this.text(item.publishedDate) || "출간일 정보 없음",
                publishedYear: item.publishedYear || this.numberYear(item.publishedDate),
                publicationStatement: this.text(item.publicationStatement),
                isbn: this.normalizeIsbn(item.isbn),
                issn: this.text(item.issn),
                kdc: this.text(item.kdc),
                callNo: this.text(item.callNo),
                classification: this.text(item.classification),
                physicalDescription: this.text(item.physicalDescription),
                seriesTitle: this.text(item.seriesTitle),
                volume: this.text(item.volume),
                category: this.text(item.category) || "분류 정보 없음",
                bibliographicType: this.text(item.bibliographicType),
                materialType: this.text(item.materialType),
                marcSubject: this.text(item.marcSubject),
                subjectName: this.text(item.subjectName),
                generalNote: this.text(item.generalNote),
                bibliographyNote: this.text(item.bibliographyNote),
                coverImage: coverImage,
                coverThumbnailImage: coverThumbnailImage,
                listCoverImage: listCoverImage,
                coverAvailable: Boolean(coverImage || listCoverImage),
                coverStatus: this.text(item.coverStatus) || (coverImage || listCoverImage ? "표지 확보 완료" : "기본 표지 사용"),
                coverOriginalUrl: this.text(item.coverOriginalUrl),
                coverLoadedPaths: {},
                coverFailedPaths: {},
                description: this.text(item.description),
                descriptionBasis: this.text(item.descriptionBasis) || (this.text(item.description) ? "수집 원본의 자료 소개 필드" : "자료 소개 미제공"),
                sourceUrl: this.text(item.sourceUrl),
                requestUrl: this.text(item.requestUrl),
                collectedAt: this.text(item.collectedAt),
                folderName: this.text(item.folderName),
                metadataPath: this.text(item.metadataPath),
                height: this.text(item.height),
                page: this.text(item.page),
                corporateName: this.text(item.corporateName),
                personalName: this.text(item.personalName),
                pdfs: pdfs,
                pdfCount: declaredPdfCount,
                pdfAvailable: pdfAvailable,
                accessStatus: pdfAvailable ? "PDF 확보 완료" : (this.text(item.sourceUrl) ? "외부 원본 링크 확인" : "원문 확보 필요"),
                tags: tags,
                tagAliases: tagAliases,
                publicTags: publicTags,
                tagReviewSummary: tagReviewSummary,
                statusTags: statusTags,
                graphStatus: this.text(item.graphStatus) || "본문 근거 연결 대기",
                relationshipStatus: this.text(item.relationshipStatus) || "메타데이터 기반 추천",
                reviewStatus: this.text(item.reviewStatus) || "검수 대기",
                ocrStatus: this.text(item.ocrStatus) || "OCR 상태 미검증",
                textIndexStatus: this.text(item.textIndexStatus) || "본문 품질 미검증",
                bodySearchStatus: this.text(item.bodySearchStatus) || "본문 검색 미검증",
                bodySearchAvailable: Boolean(item.bodySearchAvailable),
                processedPdfCount: Number(item.processedPdfCount || 0),
                pendingPdfProcessCount: Number(item.pendingPdfProcessCount || 0),
                pdfPageCount: Number(item.pdfPageCount || 0),
                extractedPageCount: Number(item.extractedPageCount || item.textPageCount || 0),
                textPageCount: Number(item.textPageCount || 0),
                searchablePageCount: Number(item.searchablePageCount || 0),
                ocrRequiredPageCount: Number(item.ocrRequiredPageCount || 0),
                bodyChunkCount: Number(item.bodyChunkCount || 0),
                citationCandidateCount: Number(item.citationCandidateCount || 0),
                embeddingCount: Number(item.embeddingCount || 0),
                pdfTextIndexGeneratedAt: this.text(item.pdfTextIndexGeneratedAt),
                llmStatus: this.text(item.llmStatus) || "질문과 관련된 근거 찾기 미검증",
                graphDbStatus: this.text(item.graphDbStatus) || "Graph DB 연동 준비 상태",
                graphAvailable: Boolean(item.graphAvailable),
                aiAnswerAvailable: Boolean(item.aiAnswerAvailable),
                publicStatus: this.text(item.publicStatus) || "내부전용",
                publicEvidenceAllowed: item.publicEvidenceAllowed !== false,
                publicExposure: item.publicExposure || undefined,
                verificationStatus: item.verificationStatus || undefined,
                toc: this.cleanToc(item.toc),
                tocCount: Number(item.tocCount || (Array.isArray(item.toc) ? item.toc.length : 0)),
                tocStatus: this.text(item.tocStatus) || "목차 데이터 미수집",
                aiSummary: aiSummary,
                summaryBasis: this.text(item.summaryBasis) || (Boolean(item.summaryGrounded) && aiSummary ? "근거가 확인된 본문 요약" : "근거가 확인된 본문 요약 미제공"),
                summaryGrounded: Boolean(item.summaryGrounded),
                summaryCoverage: this.text(item.summaryCoverage) || (Boolean(item.summaryGrounded) && aiSummary ? `자료ID ${id} · 사용 파일·본문 범위 미기록` : ""),
                metadataBasis: this.text(item.metadataBasis) || "자료 정보 및 원문·표지 파일",
                sourceResourceCount: Number(item.sourceResourceCount || declaredPdfCount || 0),
                crawlIndex: Number(item.crawlIndex ?? i),
                sourceType: this.text(item.sourceType),
                detailLoaded: Boolean(item.detailLoaded),
                relatedRecommendations: Array.isArray(item.relatedRecommendations)
                    ? item.relatedRecommendations.map((row: any) => ({
                        materialId: this.text(row.materialId),
                        title: this.text(row.title),
                        reason: this.text(row.reason),
                        score: Number(row.score || 0),
                        strength: this.text(row.strength),
                        signals: row.signals || {},
                    })).filter((row: RelatedRecommendation) => !!row.materialId && !!row.reason)
                    : [],
                recommendationPolicy: item.recommendationPolicy || undefined,
            };

            if (seenIds[book.id]) continue;
            if (!book.id) {
                let key = `${book.title.toLocaleLowerCase()}|${book.author.toLocaleLowerCase()}`;
                if (seenTitleAuthor[key]) continue;
                seenTitleAuthor[key] = true;
            }
            seenIds[book.id] = true;
            result.push(book);
        }

        return result;
    }

    public cleanPdfs(items: any[]): PdfAsset[] {
        if (!Array.isArray(items)) return [];
        return items
            .map((item) => ({
                filename: this.text(item.filename),
                url: this.text(item.url),
                path: this.text(item.path),
                size: Number(item.size || 0),
                sizeLabel: this.text(item.sizeLabel),
                originalFilename: this.text(item.originalFilename),
                resourceId: this.text(item.resourceId),
                downloadUrl: this.text(item.downloadUrl),
                downloadStatus: this.text(item.downloadStatus),
                fileId: this.text(item.fileId || item.textIndex?.fileId),
                pageCount: Number(item.pageCount || item.textIndex?.pageCount || 0),
                processingStatus: this.text(item.processingStatus || item.textIndex?.processingStatus),
                textIndex: item.textIndex ? {
                    fileId: this.text(item.textIndex.fileId),
                    processingStatus: this.text(item.textIndex.processingStatus),
                    integrityStatus: this.text(item.textIndex.integrityStatus),
                    sha256: this.text(item.textIndex.sha256),
                    pageCount: Number(item.textIndex.pageCount || 0),
                    extractedPageCount: Number(item.textIndex.extractedPageCount || item.textIndex.textPageCount || 0),
                    textPageCount: Number(item.textIndex.extractedPageCount || item.textIndex.textPageCount || 0),
                    searchablePageCount: Number(item.textIndex.searchablePageCount || 0),
                    normalPageCount: Number(item.textIndex.normalPageCount || 0),
                    partialPageCount: Number(item.textIndex.partialPageCount || 0),
                    reviewRequiredPageCount: Number(item.textIndex.reviewRequiredPageCount || 0),
                    noTextPageCount: Number(item.textIndex.noTextPageCount || 0),
                    ocrRequiredPageCount: Number(item.textIndex.ocrRequiredPageCount || 0),
                    emptyPageCount: Number(item.textIndex.emptyPageCount || 0),
                    chunkCount: Number(item.textIndex.chunkCount || 0),
                    citationCount: Number(item.textIndex.citationCount || 0),
                    embeddingCount: Number(item.textIndex.embeddingCount || 0),
                    classification: this.text(item.textIndex.classification),
                    textExtractionStatus: this.text(item.textIndex.textExtractionStatus),
                    ocrStatus: this.text(item.textIndex.ocrStatus),
                    ocrEngineStatus: this.text(item.textIndex.ocrEngineStatus),
                    qualityStatus: this.text(item.textIndex.qualityStatus) || "미검증",
                    qualityCode: this.text(item.textIndex.qualityCode) || "unverified",
                    qualityPolicyVersion: this.text(item.textIndex.qualityPolicyVersion),
                    extractorVersion: this.text(item.textIndex.extractorVersion),
                    searchIndexStatus: this.text(item.textIndex.searchIndexStatus),
                    embeddingStatus: this.text(item.textIndex.embeddingStatus),
                    processedAt: this.text(item.textIndex.processedAt),
                    error: this.text(item.textIndex.error)
                } : undefined
            }))
            .filter((item) => item.filename && item.url);
    }

    public cleanToc(items: any[]): TocItem[] {
        if (!Array.isArray(items)) return [];
        return items
            .map((item) => {
                if (typeof item === "string") {
                    return { label: this.text(item), page: "", source: "metadata.md", depth: 1 };
                }
                let depth = Number(item?.depth || 1);
                if (!depth || depth < 1) depth = 1;
                if (depth > 4) depth = 4;
                return {
                    label: this.text(item?.label || item?.title || item?.name || item?.text),
                    page: this.text(item?.page || item?.pageLabel),
                    source: this.text(item?.source || "metadata.md"),
                    depth: depth
                };
            })
            .filter((item) => item.label)
            .slice(0, 80);
    }

    public cleanTags(items: any[]): TagItem[] {
        if (!Array.isArray(items)) return [];
        let seen: any = {};
        return items
            .map((item) => ({
                name: this.text(item.name),
                axis: this.text(item.axis),
                status: this.text(item.status),
                evidence: this.text(item.evidence),
                reviewStatus: this.text(item.reviewStatus),
                publicStatus: this.text(item.publicStatus),
                canonicalName: this.text(item.canonicalName),
                matchedAlias: this.text(item.matchedAlias),
                sourceField: this.text(item.sourceField)
            }))
            .filter((item) => {
                let key = `${item.axis}|${item.name}`;
                if (!item.name || seen[key]) return false;
                seen[key] = true;
                return true;
            });
    }

    public cleanTagAliases(items: any[]): TagAliasItem[] {
        if (!Array.isArray(items)) return [];
        let seen: any = {};
        return items
            .map((item) => ({
                tagName: this.text(item.tagName),
                axis: this.text(item.axis),
                alias: this.text(item.alias),
                usage: this.text(item.usage) || "검색 확장·전거 정규화",
                status: this.text(item.status) || "전거 후보"
            }))
            .filter((item) => {
                let key = `${item.axis}|${item.tagName}|${item.alias}`;
                if (!item.tagName || !item.alias || seen[key]) return false;
                seen[key] = true;
                return true;
            });
    }

    public cleanTagReviewSummary(item: any, tags: TagItem[], publicTags: TagItem[]): TagReviewSummary {
        let workflow = Array.isArray(item?.workflow) && item.workflow.length
            ? item.workflow.map((value: any) => this.text(value)).filter((value: string) => value)
            : ["자동추천", "검수대기", "검수완료", "반려", "공개가능", "내부전용"];
        let pendingCount = Number(item?.pendingCount ?? tags.filter((tag) => this.reviewStatusOfTag(tag) === "검수대기").length);
        let recommendedCount = Number(item?.recommendedCount ?? tags.filter((tag) => tag.status === "자동추천").length);
        return {
            recommendedCount: recommendedCount,
            pendingCount: pendingCount,
            approvedCount: Number(item?.approvedCount ?? tags.filter((tag) => this.reviewStatusOfTag(tag) === "검수완료").length),
            rejectedCount: Number(item?.rejectedCount ?? tags.filter((tag) => this.reviewStatusOfTag(tag) === "반려").length),
            publicReadyCount: Number(item?.publicReadyCount ?? publicTags.length),
            internalOnlyCount: Number(item?.internalOnlyCount ?? tags.filter((tag) => this.publicStatusOfTag(tag) === "내부전용").length),
            workflow: workflow,
            label: this.text(item?.label) || (pendingCount || recommendedCount ? "검수대기" : "태그추천대기")
        };
    }

    public cleanSubjectTags(items: any[]): TagItem[] {
        return this.cleanTags(items).filter((item) => !this.isStateTag(item));
    }

    public cleanStatusTags(statusItems: any[], tagItems: any[] = []): TagItem[] {
        let statusTags = this.cleanTags(statusItems);
        let misplacedStatusTags = this.cleanTags(tagItems).filter((item) => this.isStateTag(item));
        return this.dedupeTags(statusTags.concat(misplacedStatusTags));
    }

    public isStateTag(tag: TagItem): boolean {
        if (!tag) return false;
        if (tag.axis === "공개·검수 상태 축" || tag.axis === "검수·공개 상태 축") return true;
        return STATE_TAG_NAMES.includes(tag.name);
    }

    private cleanSearchMatch(item: any): SearchMatchItem {
        return {
            type: this.text(item?.type),
            label: this.text(item?.label || "검색 근거"),
            field: this.text(item?.field),
            value: this.text(item?.value),
            snippet: this.text(item?.snippet),
            score: Number(item?.score || 0),
            priority: Number(item?.priority || 99),
            page: Number(item?.page || 0),
            paragraph: Number(item?.paragraph || 0),
            pageLabel: this.text(item?.pageLabel),
            fileId: this.text(item?.fileId),
            pdfFilename: this.text(item?.pdfFilename),
            pdfIndex: Number(item?.pdfIndex || 0),
            pdfUrl: this.text(item?.pdfUrl),
            chunkId: this.text(item?.chunkId),
            collectionId: this.text(item?.collectionId),
            relatedTopic: this.text(item?.relatedTopic),
            nodeLabel: this.text(item?.nodeLabel),
            nodeType: this.text(item?.nodeType),
            relationLabel: this.text(item?.relationLabel),
            status: this.text(item?.status),
        };
    }

    private cleanSearchBookMeta(item: any): SearchBookMeta {
        let matches = Array.isArray(item?.matches) ? item.matches.map((row: any) => this.cleanSearchMatch(row)) : [];
        let bodyHits = Array.isArray(item?.bodyHits) ? item.bodyHits.map((row: any) => this.cleanSearchMatch(row)) : [];
        return {
            bookId: this.text(item?.bookId),
            hflibId: this.text(item?.hflibId),
            title: this.text(item?.title),
            score: Number(item?.score || 0),
            priority: Number(item?.priority || 99),
            matches: matches.filter((row: SearchMatchItem) => row.label || row.snippet),
            bodyHits: bodyHits.filter((row: SearchMatchItem) => row.snippet || row.page),
            relatedTopics: Array.isArray(item?.relatedTopics)
                ? item.relatedTopics.map((value: any) => this.text(value)).filter((value: string) => value)
                : [],
        };
    }

    private cleanSearchAliasExpansion(item: any): SearchAliasExpansion {
        return {
            canonicalTag: this.text(item?.canonicalTag),
            axis: this.text(item?.axis),
            matchedAlias: this.text(item?.matchedAlias),
            aliases: Array.isArray(item?.aliases)
                ? item.aliases.map((value: any) => this.text(value)).filter((value: string) => value)
                : [],
            message: this.text(item?.message),
            usage: this.text(item?.usage || "검색 확장·전거 정규화"),
        };
    }

    private clearIntegratedSearchPresentation() {
        this.searchMetaByBookKey = {};
        this.integratedSearchSuggestions = [];
        this.integratedNearbyTopics = [];
        this.searchAliasExpansions = [];
    }

    private cancelIntegratedSearch(clearDebounce: boolean = true) {
        if (clearDebounce && this.integratedSearchDebounceTimer) {
            clearTimeout(this.integratedSearchDebounceTimer);
            this.integratedSearchDebounceTimer = null;
        }
        if (this.integratedSearchAbortController) {
            this.integratedSearchAbortController.abort();
            this.integratedSearchAbortController = null;
        }
        this.integratedSearchToken++;
    }

    private cachedIntegratedSearchMeta(query: string): { [key: string]: SearchBookMeta } {
        query = this.text(query).trim();
        if (!query) {
            this.cancelIntegratedSearch();
            this.clearIntegratedSearchPresentation();
            this.searchEvidenceQuery = "";
            this.searchEvidenceState = "initial";
            this.searchEvidenceErrorMessage = "";
            this.searchEvidenceLoading = false;
            return {};
        }

        let cacheKey = query.toLocaleLowerCase();
        let cached = this.integratedSearchCache[cacheKey];
        if (cached) {
            this.searchMetaByBookKey = cached.byBook;
            this.integratedSearchSuggestions = cached.suggestions;
            this.integratedNearbyTopics = cached.nearbyTopics;
            this.searchAliasExpansions = cached.aliasExpansions;
            this.searchEvidenceQuery = query;
            this.searchEvidenceState = "complete";
            this.searchEvidenceErrorMessage = "";
            this.searchEvidenceLoading = false;
            return cached.byBook;
        }

        if (this.searchEvidenceQuery.toLocaleLowerCase() !== cacheKey) {
            this.cancelIntegratedSearch();
            this.clearIntegratedSearchPresentation();
            this.searchEvidenceQuery = query;
            this.searchEvidenceState = "initial";
            this.searchEvidenceErrorMessage = "";
            this.searchEvidenceLoading = false;
        }
        return {};
    }

    private prefetchIntegratedSearchMeta(query: string) {
        query = this.text(query).trim();
        if (!query || this.activeTopTab !== "search") return;
        let cacheKey = query.toLocaleLowerCase();
        if (this.integratedSearchCache[cacheKey]) {
            this.cachedIntegratedSearchMeta(query);
            return;
        }
        if (this.integratedSearchInFlight[cacheKey]) return;
        if (this.integratedSearchDebounceTimer && this.searchEvidenceQuery.toLocaleLowerCase() === cacheKey) return;

        if (this.integratedSearchDebounceTimer) clearTimeout(this.integratedSearchDebounceTimer);
        if (this.searchEvidenceQuery.toLocaleLowerCase() !== cacheKey) {
            this.cancelIntegratedSearch(false);
            this.clearIntegratedSearchPresentation();
        }
        this.searchEvidenceQuery = query;
        this.searchEvidenceState = "debouncing";
        this.searchEvidenceErrorMessage = "";
        this.searchEvidenceLoading = true;

        this.integratedSearchDebounceTimer = setTimeout(() => {
            this.integratedSearchDebounceTimer = null;
            let activeKey = this.text(this.filters.search).trim().toLocaleLowerCase();
            if (activeKey !== cacheKey || this.activeTopTab !== "search") return;
            this.integratedSearchInFlight[cacheKey] = true;
            this.loadIntegratedSearchMeta(query)
                .then(async () => {
                    let latestKey = this.text(this.filters.search).trim().toLocaleLowerCase();
                    if (latestKey === cacheKey) await this.applyFilters(false);
                    else await this.service.render();
                })
                .finally(() => {
                    delete this.integratedSearchInFlight[cacheKey];
                });
        }, 260);
    }

    private shouldPrefetchIntegratedSearchMeta(): boolean {
        return this.activeTopTab === "search" && !!this.text(this.filters.search).trim();
    }

    private async loadIntegratedSearchMeta(query: string): Promise<{ [key: string]: SearchBookMeta }> {
        query = this.text(query).trim();
        if (!query) return {};

        let cacheKey = query.toLocaleLowerCase();
        if (this.integratedSearchCache[cacheKey]) {
            return this.cachedIntegratedSearchMeta(query);
        }

        if (this.integratedSearchAbortController) this.integratedSearchAbortController.abort();
        let controller = new AbortController();
        this.integratedSearchAbortController = controller;
        let token = ++this.integratedSearchToken;
        this.searchEvidenceQuery = query;
        this.searchEvidenceState = "loading";
        this.searchEvidenceErrorMessage = "";
        this.searchEvidenceLoading = true;
        await this.service.render();

        try {
            let endpoint = `/wiz/api/page.main/integrated_search?q=${encodeURIComponent(query)}&limit=180`;
            let raw = await fetch(endpoint, { signal: controller.signal, cache: "no-cache" });
            let response: any = await raw.json();
            if (!raw.ok || response?.code !== 200) throw new Error(response?.data?.message || response?.message || "integrated_search failed");
            let activeKey = this.text(this.filters.search).trim().toLocaleLowerCase();
            if (token !== this.integratedSearchToken || activeKey !== cacheKey) return {};

            let payload = response?.data?.data || response?.data || {};
            let rows = Array.isArray(payload.results) ? payload.results : [];
            let byBook: { [key: string]: SearchBookMeta } = {};
            rows.forEach((row: any) => {
                let meta = this.cleanSearchBookMeta(row);
                if (!meta.bookId && !meta.hflibId) return;
                if (meta.bookId) byBook[meta.bookId] = meta;
                if (meta.hflibId) byBook[meta.hflibId] = meta;
            });
            let suggestions = Array.isArray(payload.suggestions)
                ? payload.suggestions.map((value: any) => this.text(value)).filter((value: string) => value)
                : [];
            let nearbyTopics = Array.isArray(payload.nearbyTopics)
                ? payload.nearbyTopics.map((value: any) => this.text(value)).filter((value: string) => value)
                : [];
            let aliasExpansions = Array.isArray(payload.aliasExpansions)
                ? payload.aliasExpansions.map((row: any) => this.cleanSearchAliasExpansion(row)).filter((row: SearchAliasExpansion) => row.canonicalTag)
                : [];

            this.integratedSearchCache[cacheKey] = { byBook, suggestions, nearbyTopics, aliasExpansions };
            this.searchMetaByBookKey = byBook;
            this.integratedSearchSuggestions = suggestions;
            this.integratedNearbyTopics = nearbyTopics;
            this.searchAliasExpansions = aliasExpansions;
            this.searchEvidenceState = "complete";
            this.searchEvidenceErrorMessage = "";
            return byBook;
        } catch (e: any) {
            if (e?.name === "AbortError" || token !== this.integratedSearchToken) return {};
            let activeKey = this.text(this.filters.search).trim().toLocaleLowerCase();
            if (activeKey === cacheKey) {
                this.clearIntegratedSearchPresentation();
                this.searchEvidenceState = "error";
                this.searchEvidenceErrorMessage = "본문·주제어·관계 근거 조회에 실패했습니다. 기본 자료 결과는 계속 표시합니다.";
            }
            return {};
        } finally {
            if (token === this.integratedSearchToken) {
                this.searchEvidenceLoading = false;
                if (this.integratedSearchAbortController === controller) this.integratedSearchAbortController = null;
            }
        }
    }

    public async applyFilters(resetPage: boolean = true) {
        let search = this.text(this.filters.search).toLocaleLowerCase();
        let searchMeta = this.cachedIntegratedSearchMeta(search);
        if (this.shouldPrefetchIntegratedSearchMeta()) this.prefetchIntegratedSearchMeta(search);
        let author = this.normalizedAuthor(this.filters.author);
        let businessAxis = this.filters.businessAxis;
        let issueAxis = this.filters.issueAxis;
        let eraAxis = this.filters.eraAxis;
        let regionAxis = this.filters.regionAxis;
        let relationshipAxis = this.filters.relationshipAxis;
        let materialNature = this.filters.materialNature;
        let creatorAxis = this.filters.creatorAxis;
        let perspectiveAxis = this.filters.perspectiveAxis;
        let workPurpose = this.filters.workPurpose;
        let reviewStateAxis = this.filters.reviewStateAxis;
        let collectionId = this.text(this.filters.collectionId);
        let year = this.filters.year;
        let pdfState = this.filters.pdfState;
        let bodyExtractionStatus = this.filters.bodyExtractionStatus;
        let tagReviewStatus = this.filters.tagReviewStatus;
        let publicStatus = this.filters.publicStatus;

        let rows = this.books.filter((book) => {
            if (author && !this.normalizedAuthor(book.author).includes(author)) return false;
            if (businessAxis && !this.hasAxisTag(book, TAG_AXES.business, businessAxis)) return false;
            if (issueAxis && !this.hasAxisTag(book, TAG_AXES.issue, issueAxis)) return false;
            if (eraAxis && !this.hasAxisTag(book, TAG_AXES.era, eraAxis)) return false;
            if (regionAxis && !this.hasAxisTag(book, TAG_AXES.region, regionAxis)) return false;
            if (relationshipAxis && !this.hasAxisTag(book, TAG_AXES.relation, relationshipAxis)) return false;
            if (materialNature && !this.matchesMaterialNature(book, materialNature)) return false;
            if (creatorAxis && !this.hasAxisTag(book, TAG_AXES.creator, creatorAxis)) return false;
            if (perspectiveAxis && !this.hasAxisTag(book, TAG_AXES.perspective, perspectiveAxis)) return false;
            if (workPurpose && !this.hasAxisTag(book, TAG_AXES.purpose, workPurpose)) return false;
            if (reviewStateAxis && !this.hasStatusTag(book, reviewStateAxis)) return false;
            if (collectionId && this.collectionIdForBook(book) !== collectionId) return false;
            if (year && this.yearOf(book) !== year) return false;
            if (pdfState === "with-pdf" && !book.pdfAvailable) return false;
            if (pdfState === "without-pdf" && book.pdfAvailable) return false;
            if (bodyExtractionStatus && this.bodyExtractionStatus(book) !== bodyExtractionStatus) return false;
            if (tagReviewStatus && this.tagReviewLabel(book) !== tagReviewStatus) return false;
            if (publicStatus && this.publicStatusLabel(book) !== publicStatus) return false;
            if (!search) return true;
            let integratedMeta = searchMeta[this.bookKey(book)] || searchMeta[book.hflibId];
            if (integratedMeta && integratedMeta.matches.length > 0) return true;

            let haystack = [
                book.id,
                book.hflibId,
                book.title,
                book.titleStatement,
                book.author,
                book.compiler,
                book.editor,
                book.publisher,
                book.publicationStatement,
                book.isbn,
                book.issn,
                book.kdc,
                book.callNo,
                book.classification,
                book.seriesTitle,
                book.volume,
                book.marcSubject,
                book.subjectName,
                book.generalNote,
                book.bibliographyNote,
                book.category,
                book.bibliographicType,
                book.materialType,
                this.materialNature(book),
                book.description,
                book.aiSummary,
                book.accessStatus,
                this.pdfStatusLabel(book),
                this.originalAccessLabel(book),
                book.coverStatus,
                book.reviewStatus,
                book.ocrStatus,
                book.textIndexStatus,
                book.bodySearchStatus,
                this.bodyExtractionStatus(book),
                book.publicStatus,
                book.tags.map((item) => item.name).join(" "),
                book.tags.map((item) => item.axis).join(" "),
                book.tags.map((item) => item.matchedAlias || "").join(" "),
                book.tagAliases.map((item) => item.alias).join(" "),
                book.statusTags.map((item) => item.name).join(" "),
                book.toc.map((item) => item.label).join(" "),
                book.pdfs.map((item) => item.filename).join(" ")
            ].join(" ").toLocaleLowerCase();
            return haystack.includes(search);
        });

        this.searchRelatedCollections = this.buildRelatedCollectionCards(rows);
        this.searchResultGroups = this.buildSearchResultGroups(rows);
        if (this.activeResultGroupId) {
            let group = this.searchResultGroups.find((item) => item.id === this.activeResultGroupId);
            if (group && group.bookIds.length) {
                let bookIds = new Set(group.bookIds);
                rows = rows.filter((book) => bookIds.has(this.bookKey(book)));
            } else {
                this.activeResultGroupId = "";
            }
        }

        this.filteredBooks = search
            ? this.sortSearchResults(rows, this.filters.sort)
            : this.sortBooks(rows, this.filters.sort);
        this.updateMaterialPage(resetPage);
        if (!this.restoringRouteState) this.syncMainUrl("replace");
        await this.service.render();
    }

    private updateMaterialPage(resetPage: boolean = false) {
        if (resetPage) this.materialListPage = 1;
        let pageCount = this.materialListPageCount();
        this.materialListPage = Math.max(1, Math.min(pageCount, Number(this.materialListPage || 1)));
        let start = (this.materialListPage - 1) * this.materialListPageSize;
        this.visibleBooks = this.filteredBooks.slice(start, start + this.materialListPageSize);
    }

    public materialListPageCount(): number {
        return Math.max(1, Math.ceil(this.filteredBooks.length / this.materialListPageSize));
    }

    public materialListFrom(): number {
        return this.filteredBooks.length ? (this.materialListPage - 1) * this.materialListPageSize + 1 : 0;
    }

    public materialListTo(): number {
        return this.filteredBooks.length
            ? Math.min(this.filteredBooks.length, this.materialListPage * this.materialListPageSize)
            : 0;
    }

    public materialRangeLabel(): string {
        if (!this.filteredBooks.length) return "전체 0건 중 표시할 자료가 없습니다.";
        return `전체 ${this.filteredBooks.length}건 중 ${this.materialListFrom()}–${this.materialListTo()}건`;
    }

    public async goToMaterialPage(page: number) {
        let next = Math.max(1, Math.min(this.materialListPageCount(), Number(page || 1)));
        if (next === this.materialListPage) return;
        this.materialListPage = next;
        this.updateMaterialPage(false);
        this.syncMainUrl("push");
        await this.service.render();
        this.scrollToList();
    }

    public async changeMaterialPageSize() {
        let size = Number(this.materialListPageSize);
        this.materialListPageSize = this.materialListPageSizeOptions.includes(size) ? size : 50;
        this.materialListPage = 1;
        this.updateMaterialPage(false);
        this.syncMainUrl("replace");
        await this.service.render();
        this.scrollToList();
    }

    public async applyTopicTag(tagName: string, event?: Event) {
        this.stopEvent(event);
        tagName = this.text(tagName);
        if (!tagName) return;

        this.applyTopicFilterState(tagName);
        let collectionId = this.collectionIdForTag(tagName);
        if (collectionId) {
            this.selectedCollectionId = collectionId;
            if (!this.aiScopeCollectionId) this.aiScopeCollectionId = collectionId;
            this.filters.collectionId = collectionId;
            this.filters.sort = "newest";
        }
        this.activeTopTab = "search";
        this.activeSearchResultTab = "materials";
        this.searchEvidenceLoading = false;
        this.syncMainUrl("push");
        await this.applyFilters();
        this.scrollToList();
    }

    private applyTopicFilterState(tagName: string) {
        this.filters.search = "";
        this.filters.author = "";
        this.filters.businessAxis = "";
        this.filters.issueAxis = "";
        this.filters.eraAxis = "";
        this.filters.regionAxis = "";
        this.filters.relationshipAxis = "";
        this.filters.materialNature = "";
        this.filters.creatorAxis = "";
        this.filters.perspectiveAxis = "";
        this.filters.workPurpose = "";
        this.filters.reviewStateAxis = "";
        this.filters.collectionId = "";
        this.filters.year = "";
        this.filters.pdfState = "";
        this.filters.bodyExtractionStatus = "";
        this.filters.tagReviewStatus = "";
        this.filters.publicStatus = "";
        this.activeResultGroupId = "";
        this.authorDropdownOpen = false;
        this.authorActiveIndex = -1;
        this.updateAuthorSuggestions();
        if (this.businessAxisOptions.includes(tagName)) this.filters.businessAxis = tagName;
        else if (this.issueAxisOptions.includes(tagName)) this.filters.issueAxis = tagName;
        else if (this.eraAxisOptions.includes(tagName)) this.filters.eraAxis = tagName;
        else if (this.regionAxisOptions.includes(tagName)) this.filters.regionAxis = tagName;
        else if (this.relationshipAxisOptions.includes(tagName)) this.filters.relationshipAxis = tagName;
        else if (this.materialNatureOptions.includes(tagName)) this.filters.materialNature = tagName;
        else if (this.creatorAxisOptions.includes(tagName)) this.filters.creatorAxis = tagName;
        else if (this.perspectiveAxisOptions.includes(tagName)) this.filters.perspectiveAxis = tagName;
        else if (this.workPurposeOptions.includes(tagName)) this.filters.workPurpose = tagName;
        else if (this.reviewStateAxisOptions.includes(tagName)) this.filters.reviewStateAxis = tagName;
        else this.filters.search = tagName;
    }

    public isTopicTagActive(tagName: string): boolean {
        tagName = this.text(tagName);
        return this.filters.issueAxis === tagName
            || this.filters.regionAxis === tagName
            || this.filters.creatorAxis === tagName
            || this.filters.perspectiveAxis === tagName
            || this.filters.search === tagName;
    }

    public async openDokdoDemoBook(event?: Event) {
        this.stopEvent(event);
        let book = this.books.find((item) => item.hflibId === "228413")
            || this.books.find((item) => item.title.includes("한국의 독도주권과 1905년 일제의 침탈"))
            || this.visibleBooks.find((item) => item.tags.some((tag) => tag.name === "독도"))
            || null;
        if (!book) return;
        await this.openBook(book, undefined, true);
    }

    public async runReaderDemoSearch(book: BookItem, term: string, event?: Event) {
        this.stopEvent(event);
        this.readerSearchQuery = this.text(term);
        await this.runReaderSearch(book);
    }

    public async runDokdoDemoAi(book: BookItem, event?: Event) {
        this.stopEvent(event);
        this.aiScopeType = "collection";
        await this.activateCollectionById("dokdo", false);
        this.aiScopeCollectionId = "dokdo";
        this.aiQuestion = this.demoAiQuestion;
        await this.askAi(book);
        await this.scrollToDetailSection("ai-workbench");
    }

    public async selectDemoGraphNode(event?: Event) {
        this.stopEvent(event);
        if (!this.selectedBook) return;
        if (this.canUseBookKnowledgeGraph(this.selectedBook) && !this.knowledgeGraph && !this.graphLoading) {
            await this.loadKnowledgeGraph(this.selectedBook);
        }
        this.graphSearchQuery = this.demoGraphNodeLabel;
        this.graphShowEvidence = true;
        let target = this.knowledgeGraph?.nodes.find((node) => node.label === this.demoGraphNodeLabel)
            || this.knowledgeGraph?.nodes.find((node) => node.label.includes(this.demoGraphNodeLabel))
            || null;
        if (target) {
            this.graphSelectedNode = target;
            this.graphSelectedRelation = null;
        }
        await this.scrollToDetailSection("book-knowledge-graph");
        await this.service.render();
    }

    private async activateCollectionById(collectionId: string, reload: boolean = true) {
        if (!this.collections.some((item) => item.id === collectionId)) return;
        let changed = this.selectedCollectionId !== collectionId;
        this.selectedCollectionId = collectionId;
        if (!this.aiScopeCollectionId) this.aiScopeCollectionId = collectionId;
        if (changed) {
            this.collectionNodeTypeFilter = "";
            this.collectionReviewStatusFilter = "";
            this.graphRelationStatusFilter = "전체";
            this.graphSearchQuery = "";
            this.collectionMinConfidence = 0;
            this.collectionShowEvidence = false;
            this.collectionGraphExpanded = false;
            this.collectionGraphZoom = 1;
            this.collectionSelectedNode = null;
            this.collectionSelectedRelation = null;
            this.collectionHoveredNode = null;
            this.collectionHoveredRelation = null;
        }
        if (reload && changed && !this.selectedBook) {
            await this.loadCollectionGraph();
        }
    }

    public collectionIdForTag(tagName: string): string {
        let tag = this.text(tagName).toLocaleLowerCase();
        if (!tag) return "";
        let mappings = [
            { id: "dokdo", words: ["독도", "울릉", "동해", "영토", "영유권", "해양법", "국제법", "시마네", "scapin", "liancourt", "takeshima"] },
            { id: "japanese-intrusion", words: ["일제", "침탈", "식민", "조선총독부", "통감부", "강제동원", "경제침탈", "징용", "수탈", "총동원"] },
            { id: "korea-japan-talks", words: ["한일회담", "청구권", "한일협정", "외교문서", "평화선", "냉전·한일회담기"] },
            { id: "goguryeo", words: ["고구려", "광개토", "고구려 유적", "고구려비", "goguryeo", "koguryo"] },
            { id: "balhae", words: ["발해", "크라스키노", "연해주", "balhae", "parhae"] },
            { id: "comfort-women", words: ["위안부", "위안소", "성노예", "comfort women"] },
            { id: "northeast-project", words: ["동북공정", "중국 역사교과서", "중국 역사왜곡", "중국 동북지역"] },
            { id: "gando-border", words: ["간도", "국경", "백두산정계비", "압록강", "두만강"] },
        ];
        let match = mappings.find((entry) => entry.words.some((word) => tag.includes(word.toLocaleLowerCase())));
        let collectionId = match ? match.id : "";
        return collectionId && this.collections.some((item) => item.id === collectionId) ? collectionId : "";
    }

    public collectionIdForBook(book: BookItem): string {
        let candidates = book.tags.map((tag) => tag.name)
            .concat([
                book.title,
                book.description,
                book.category,
                book.materialType || "",
                book.seriesTitle || "",
            ]);
        for (let value of candidates) {
            let collectionId = this.collectionIdForTag(value);
            if (collectionId) return collectionId;
        }
        return "";
    }

    public featuredGraphCards(): any[] {
        return FEATURED_GRAPH_COLLECTIONS
            .map((preset) => {
                let collection = this.collections.find((item) => item.id === preset.id);
                if (!collection) return null;
                return {
                    ...preset,
                    title: collection.title,
                    materialCount: collection.materialCount,
                    pdfCount: collection.pdfCount,
                    bodyIndexedCount: collection.bodyIndexedCount,
                    reviewStatus: collection.reviewStatus,
                    publicStatus: collection.publicStatus,
                };
            })
            .filter((item) => item);
    }

    public trackGraphCard(index: number, card: any) {
        return card?.id || index;
    }

    public async openCollectionGraphCard(card: any, event?: Event) {
        await this.openCollectionGraphById(this.text(card?.id), event);
    }

    public async openTagGraphEntry(tagName: string, event?: Event) {
        tagName = this.text(tagName);
        let collectionId = this.collectionIdForTag(tagName);
        if (collectionId) {
            await this.openCollectionGraphById(collectionId, event, tagName);
            return;
        }
        if (this.selectedBook) {
            this.stopEvent(event);
            await this.closeDetail();
            await this.applyTopicTag(tagName);
            return;
        }
        await this.applyTopicTag(tagName, event);
    }

    public async openCollectionGraphById(collectionId: string, event?: Event, tagName: string = "") {
        this.stopEvent(event);
        if (!this.canAccessKnowledgeGraph()) {
            this.adminReviewErrorMessage = this.accessDeniedMessage("graph");
            await this.service.render();
            return;
        }
        collectionId = this.text(collectionId);
        if (!collectionId || !this.collections.some((item) => item.id === collectionId)) return;
        let cameFromDetail = !!this.selectedBook;
        this.activeTopTab = "graph";
        this.activeGraphScope = "collection";
        if (tagName) this.applyTopicFilterState(tagName);
        if (this.selectedBook) {
            this.selectedBook = null;
            this.relatedBooks = [];
            this.activePdfIndex = 0;
            this.activePdfPage = 1;
            this.readerPageInput = "1";
            this.resetPdfReaderState();
            this.resetDetailTools();
            this.pushListUrl();
            await this.service.render();
        }
        await this.activateCollectionById(collectionId, false);
        this.syncMainUrl(cameFromDetail ? "replace" : "push");
        if (tagName) await this.applyFilters();
        else await this.service.render();
        await this.loadCollectionGraph();
        this.scrollToCollectionGraph();
    }

    private scrollToCollectionGraph() {
        setTimeout(() => {
            document.querySelector(".collection-graph-section")?.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 0);
    }

    private scrollToList() {
        setTimeout(() => {
            document.querySelector(".shelf")?.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 0);
    }

    private stopEvent(event?: Event) {
        if (!event) return;
        event.preventDefault();
        event.stopPropagation();
    }

    private stableBookIdentity(book: BookItem): string {
        return this.text(book?.id || book?.hflibId || `${book?.crawlIndex || ""}|${book?.title || ""}`);
    }

    private compareStableBookIdentity(a: BookItem, b: BookItem): number {
        return this.stableBookIdentity(a).localeCompare(this.stableBookIdentity(b), "ko");
    }

    public sortBooks(rows: BookItem[], sort: string): BookItem[] {
        let list = [...rows];
        let byText = (key: keyof BookItem, descending: boolean = false) => {
            list.sort((a, b) => {
                let compared = descending
                    ? this.text(b[key]).localeCompare(this.text(a[key]), "ko")
                    : this.text(a[key]).localeCompare(this.text(b[key]), "ko");
                return compared || this.compareStableBookIdentity(a, b);
            });
        };

        if (sort === "title") byText("title");
        else if (sort === "title-desc") byText("title", true);
        else if (sort === "author") byText("author");
        else if (sort === "publisher") {
            list.sort((a, b) => this.publisherLabel(a).localeCompare(this.publisherLabel(b), "ko")
                || this.compareStableBookIdentity(a, b));
        }
        else if (sort === "publisher-desc") {
            list.sort((a, b) => this.publisherLabel(b).localeCompare(this.publisherLabel(a), "ko")
                || this.compareStableBookIdentity(a, b));
        }
        else if (sort === "category") byText("category");
        else if (sort === "material") {
            list.sort((a, b) => this.materialNature(a).localeCompare(this.materialNature(b), "ko")
                || this.compareStableBookIdentity(a, b));
        }
        else if (sort === "material-desc") {
            list.sort((a, b) => this.materialNature(b).localeCompare(this.materialNature(a), "ko")
                || this.compareStableBookIdentity(a, b));
        }
        else if (sort === "pdf") {
            list.sort((a, b) => Number(b.pdfAvailable) - Number(a.pdfAvailable)
                || b.pdfCount - a.pdfCount
                || this.compareStableBookIdentity(a, b));
        } else if (sort === "body") {
            list.sort((a, b) => Number(b.bodySearchAvailable) - Number(a.bodySearchAvailable)
                || b.bodyChunkCount - a.bodyChunkCount
                || this.compareStableBookIdentity(a, b));
        } else if (sort === "graph") {
            list.sort((a, b) => Number(b.graphAvailable) - Number(a.graphAvailable)
                || this.materialGraphStatusLabel(a).localeCompare(this.materialGraphStatusLabel(b), "ko")
                || this.compareStableBookIdentity(a, b));
        } else if (sort === "newest") {
            list.sort((a, b) => (this.yearValue(b) - this.yearValue(a))
                || this.compareStableBookIdentity(a, b));
        } else if (sort === "oldest") {
            list.sort((a, b) => (this.yearValue(a, true) - this.yearValue(b, true))
                || this.compareStableBookIdentity(a, b));
        } else {
            byText("title");
        }

        return list;
    }

    public searchMetaForBook(book: BookItem): SearchBookMeta | null {
        if (!book) return null;
        return this.searchMetaByBookKey[this.bookKey(book)] || this.searchMetaByBookKey[book.hflibId] || null;
    }

    public searchMatchesForBook(book: BookItem): SearchMatchItem[] {
        let meta = this.searchMetaForBook(book);
        if (meta?.matches?.length) {
            let sorted = meta.matches.slice().sort((a, b) => (a.priority || 99) - (b.priority || 99) || (b.score || 0) - (a.score || 0));
            let preferredTypes = ["title_exact", "title_partial", "tag", "bibliographic", "toc", "summary", "body", "graph", "semantic"];
            let selected: SearchMatchItem[] = [];
            preferredTypes.forEach((type) => {
                let match = sorted.find((item) => item.type === type);
                if (match && !selected.includes(match)) selected.push(match);
            });
            sorted.forEach((match) => {
                if (selected.length >= 7) return;
                if (!selected.includes(match)) selected.push(match);
            });
            return selected.slice(0, 7);
        }
        let query = this.text(this.filters.search);
        if (!query) return [];
        let queryLower = query.toLocaleLowerCase();
        let matches: SearchMatchItem[] = [];
        if (book.title.toLocaleLowerCase() === queryLower) {
            matches.push({ type: "title_exact", label: "제목 정확 일치", field: "제목", value: query, snippet: book.title, score: 1200, priority: 1 });
        } else if (book.title.toLocaleLowerCase().includes(queryLower)) {
            matches.push({ type: "title_partial", label: "제목 부분 일치", field: "제목", value: query, snippet: book.title, score: 900, priority: 2 });
        }
        let tag = book.tags.find((item) => `${item.name} ${item.matchedAlias || ""}`.toLocaleLowerCase().includes(queryLower));
        if (tag) matches.push({ type: "tag", label: "태그/주제어 일치", field: this.axisDisplayName(tag.axis), value: tag.name, snippet: tag.evidence || tag.name, score: 760, priority: 3 });
        return matches.slice(0, 3);
    }

    public searchMatchBadgeLabel(match: SearchMatchItem | null): string {
        let type = this.text(match?.type);
        let label = this.text(match?.label);
        let field = this.text(match?.field);
        let combined = `${type} ${label} ${field}`.toLocaleLowerCase();
        if (["title_exact", "title_partial", "title"].includes(type) || combined.includes("제목")) return "제목 일치";
        if (["tag", "semantic"].includes(type) || combined.includes("태그") || combined.includes("주제")) return "태그 일치";
        if (type === "body" || combined.includes("본문") || combined.includes("원문")) return "본문 근거 일치";
        if (type === "graph" || combined.includes("graph") || combined.includes("지식그래프")) return "자료 관계도 연관";
        if (["bibliographic", "toc", "summary"].includes(type) || combined.includes("서지") || combined.includes("목차") || combined.includes("요약")) return "서지 정보 일치";
        return label || "검색 근거";
    }

    public searchMatchBadgeClass(match: SearchMatchItem | null): string {
        let label = this.searchMatchBadgeLabel(match);
        if (label === "제목 일치") return "match-badge-title";
        if (label === "태그 일치") return "match-badge-tag";
        if (label === "본문 근거 일치") return "match-badge-body";
        if (label === "자료 관계도 연관") return "match-badge-graph";
        if (label === "서지 정보 일치") return "match-badge-biblio";
        return "match-badge-default";
    }

    public isActiveSearchResultTab(tabId: string): boolean {
        return this.activeSearchResultTab === tabId;
    }

    public async setActiveSearchResultTab(tabId: string, event?: Event) {
        this.stopEvent(event);
        if (!this.searchResultTabs.some((tab) => tab.id === tabId)) return;
        this.activeSearchResultTab = tabId;
        if (this.shouldPrefetchIntegratedSearchMeta()) this.prefetchIntegratedSearchMeta(this.filters.search);
        this.syncMainUrl("push");
        await this.service.render();
    }

    public async handleSearchResultTabKeydown(event: KeyboardEvent, index: number) {
        let targetIndex = index;
        if (event.key === "ArrowRight" || event.key === "ArrowDown") targetIndex = (index + 1) % this.searchResultTabs.length;
        else if (event.key === "ArrowLeft" || event.key === "ArrowUp") targetIndex = (index - 1 + this.searchResultTabs.length) % this.searchResultTabs.length;
        else if (event.key === "Home") targetIndex = 0;
        else if (event.key === "End") targetIndex = this.searchResultTabs.length - 1;
        else return;
        event.preventDefault();
        await this.setActiveSearchResultTab(this.searchResultTabs[targetIndex].id);
        setTimeout(() => document.getElementById(`search-result-tab-${this.searchResultTabs[targetIndex].id}`)?.focus(), 0);
    }

    public searchResultTabCount(tabId: string): number {
        if (tabId === "all") {
            return this.filteredBooks.length
                + this.searchBodyEvidenceRows().length
                + this.searchTagResultCards().length
                + this.searchGraphResultCards().length
                + this.searchRelatedCollections.length;
        }
        if (tabId === "materials") return this.filteredBooks.length;
        if (tabId === "body") return this.searchBodyEvidenceRows().length;
        if (tabId === "tags") return this.searchTagResultCards().length;
        if (tabId === "graph") return this.searchGraphResultCards().length;
        if (tabId === "collections") return this.searchRelatedCollections.length;
        return 0;
    }

    public searchResultTabCountLabel(tabId: string): string {
        let count = this.searchResultTabCount(tabId);
        if (this.isSearchEvidencePending()) return count > 0 ? `${count}+` : "확인 중";
        if (this.searchEvidenceState === "error" && ["all", "body", "tags", "graph"].includes(tabId)) {
            return count > 0 ? String(count) : "미확인";
        }
        return String(count);
    }

    public isSearchEvidencePending(): boolean {
        return ["debouncing", "loading"].includes(this.searchEvidenceState);
    }

    public canConfirmSearchAreaEmpty(): boolean {
        if (!this.text(this.filters.search)) return true;
        return !this.isSearchEvidencePending() && this.searchEvidenceState !== "error";
    }

    public searchEvidenceStatusRows(): Array<{ label: string, status: string, count: number }> {
        let evidenceStatus = "대기";
        if (this.isSearchEvidencePending()) evidenceStatus = "조회 중 · 잠정 결과";
        else if (this.searchEvidenceState === "complete") evidenceStatus = "조회 완료";
        else if (this.searchEvidenceState === "error") evidenceStatus = "조회 실패 · 기본 결과 유지";
        else if (!this.text(this.filters.search)) evidenceStatus = "검색어 없음";

        let materialStatus = this.isSearchEvidencePending() ? "잠정 결과" : "조회 완료";
        if (this.searchEvidenceState === "error") materialStatus = "기본 결과 유지";
        return [
            { label: "자료", status: materialStatus, count: this.filteredBooks.length },
            { label: "본문 근거", status: evidenceStatus, count: this.searchBodyEvidenceRows().length },
            { label: "주제어", status: evidenceStatus, count: this.searchTagResultCards().length },
            { label: "자료 관계도", status: evidenceStatus, count: this.searchGraphResultCards().length },
        ];
    }

    public isMaterialSearchResultTab(): boolean {
        return ["all", "materials"].includes(this.activeSearchResultTab);
    }

    public materialSearchReason(book: BookItem): string {
        let matches = this.searchMatchesForBook(book).slice(0, 3);
        if (!matches.length) {
            if (this.hasActiveSearchContext()) return "현재 검색어 또는 필터 조건과 일치합니다.";
            return "전체 자료 목록에 포함된 자료입니다.";
        }
        return matches
            .map((match) => {
                let value = this.text(match.value || match.relatedTopic || match.nodeLabel || match.relationLabel);
                return value ? `${match.label}: ${this.truncate(value, 34)}` : match.label;
            })
            .join(" · ");
    }

    public materialSearchSummary(book: BookItem): string {
        let snippet = this.searchMatchSnippet(book);
        if (snippet) return snippet;
        let tags = this.listCardTags(book).map((tag) => tag.name).slice(0, 4);
        if (tags.length) return `주요 태그: ${tags.join(", ")}`;
        return this.truncate(book.description || (book.summaryGrounded ? book.aiSummary : "") || "자료 기본정보와 주제어가 검색 조건과 일치합니다.", 150);
    }

    public originalAvailabilityLabel(book: BookItem): string {
        if (!book?.pdfAvailable && book?.sourceUrl) return "외부 링크만 있음";
        if (!book?.pdfAvailable) return "원문 없음";
        if (!this.canAccessBookOriginals(book)) return "원문 보유 · 공개 승인/권한 필요";
        if (book.pdfCount > 1) return `원문 ${book.pdfCount}개 · ${this.isPartialBodySearch(book) ? "일부 본문 검색" : (book.bodySearchAvailable ? "본문 검색" : "본문 미검색")}`;
        if (book.bodySearchAvailable) return this.isPartialBodySearch(book) ? "원문 열람 · 일부 본문 검색" : "원문 열람 · 본문 검색";
        return "원문 열람 가능";
    }

    public originalAvailabilityClass(book: BookItem): string {
        if (!book?.pdfAvailable) return book?.sourceUrl ? "is-limited" : "is-unavailable";
        if (!this.canAccessBookOriginals(book)) return "is-limited";
        return "is-available";
    }

    public bodySearchAvailabilityLabel(book: BookItem): string {
        if (book?.bodySearchAvailable) {
            if (this.isPartialBodySearch(book)) return `일부 검색 가능 · ${book.searchablePageCount || book.extractedPageCount}쪽`;
            if (book.bodyChunkCount > 0) return `검색 가능 · 본문 구간 ${book.bodyChunkCount}개`;
            return "검색 가능";
        }
        if (book?.pdfAvailable) return this.bodyExtractionStatus(book);
        return "원문 확보 후 색인";
    }

    public isPartialBodySearch(book: BookItem): boolean {
        if (!book?.bodySearchAvailable) return false;
        if (book.pdfPageCount > 0 && book.searchablePageCount > 0 && book.searchablePageCount < book.pdfPageCount) return true;
        if (book.pdfCount > 1 && book.processedPdfCount > 0 && book.processedPdfCount < book.pdfCount) return true;
        return book.ocrRequiredPageCount > 0;
    }

    public originalActionLabel(book: BookItem): string {
        return book?.pdfCount > 1 ? `원문 ${book.pdfCount}개 읽기` : "원문 읽기";
    }

    public materialIntroduction(book: BookItem): string {
        return this.text(book?.description) || "제공된 자료 소개가 없습니다. 제목과 서지정보만으로 본문 내용을 추측해 표시하지 않습니다.";
    }

    public groundedBodySummary(book: BookItem): string {
        if (book?.summaryGrounded && this.text(book.aiSummary)) return book.aiSummary;
        return "근거가 확인된 본문 요약이 없습니다. 원문과 검색 가능한 본문을 직접 확인해 주세요.";
    }

    public bodySearchAvailabilityClass(book: BookItem): string {
        if (book?.bodySearchAvailable) return "is-available";
        if (book?.pdfAvailable) return "is-limited";
        return "is-unavailable";
    }

    public materialGraphStatusLabel(book: BookItem): string {
        if (book?.graphAvailable) return "자료 관계도 제공";
        if (this.text(book?.graphStatus)) return this.text(book.graphStatus);
        if (book?.bodyChunkCount > 0) return "본문 근거 연결 대기";
        return "그래프 생성 대기";
    }

    public materialGraphStatusClass(book: BookItem): string {
        if (book?.graphAvailable) return "is-available";
        if (book?.bodyChunkCount > 0 || this.text(book?.graphStatus)) return "is-limited";
        return "is-unavailable";
    }

    public materialListHeading(): string {
        return this.materialViewMode === "text" ? "목록 보기 · 자료 비교" : "표지 보기 · 자료 목록";
    }

    public materialListSummaryLabel(): string {
        let scope = this.activeTopTab === "search" ? "검색·필터 결과" : "전체 자료";
        return `${scope} ${this.filteredBooks.length}건 · ${this.sortLabel(this.filters.sort)} · ${this.materialRangeLabel()}`;
    }

    public sortLabel(value: string): string {
        if (value === "pdf") return "원문 우선";
        if (value === "body") return "본문 검색 우선";
        if (value === "graph") return "자료 관계도 우선";
        if (value === "newest") return "최신순";
        if (value === "oldest") return "오래된순";
        if (value === "material") return "자료 성격순";
        if (value === "material-desc") return "자료 성격 역순";
        if (value === "publisher") return "발행기관순";
        if (value === "publisher-desc") return "발행기관 역순";
        if (value === "title-desc") return "제목 역순";
        if (value === "author") return "저자순";
        if (value === "category") return "분류순";
        return "제목순";
    }

    private materialTextSortValues(column: MaterialTextSortColumn): string[] {
        if (column === "title") return ["title", "title-desc"];
        if (column === "publisher") return ["publisher", "publisher-desc"];
        if (column === "year") return ["newest", "oldest"];
        if (column === "type") return ["material", "material-desc"];
        if (column === "original") return ["pdf"];
        if (column === "body") return ["body"];
        if (column === "graph") return ["graph"];
        return ["title"];
    }

    public async setTextListSort(column: MaterialTextSortColumn, event?: Event) {
        this.stopEvent(event);
        let values = this.materialTextSortValues(column);
        let current = this.text(this.filters.sort);
        let currentIndex = values.indexOf(current);
        this.filters.sort = currentIndex >= 0 && values.length > 1 ? values[(currentIndex + 1) % values.length] : values[0];
        await this.applyFilters();
    }

    public isTextListSortColumn(column: MaterialTextSortColumn): boolean {
        return this.materialTextSortValues(column).includes(this.text(this.filters.sort));
    }

    public textListSortHeaderClass(column: MaterialTextSortColumn): string {
        if (!this.isTextListSortColumn(column)) return "";
        let value = this.text(this.filters.sort);
        if (["title-desc", "publisher-desc", "oldest", "material-desc"].includes(value)) return "is-active is-desc";
        if (["pdf", "body", "graph"].includes(value)) return "is-active is-priority";
        return "is-active is-asc";
    }

    public textListSortAriaSort(column: MaterialTextSortColumn): string | null {
        if (!this.isTextListSortColumn(column)) return null;
        let value = this.text(this.filters.sort);
        if (["title-desc", "publisher-desc", "oldest", "material-desc"].includes(value)) return "descending";
        if (["pdf", "body", "graph"].includes(value)) return "other";
        return "ascending";
    }

    public textListSortDirectionLabel(column: MaterialTextSortColumn): string {
        if (!this.isTextListSortColumn(column)) return "";
        let value = this.text(this.filters.sort);
        if (value === "oldest") return "오름";
        if (["title-desc", "publisher-desc", "material-desc"].includes(value)) return "내림";
        if (["pdf", "body", "graph"].includes(value)) return "우선";
        return "오름";
    }

    public textListSortAriaLabel(column: MaterialTextSortColumn, label: string): string {
        let active = this.isTextListSortColumn(column) ? `현재 ${this.sortLabel(this.filters.sort)} 정렬입니다.` : "현재 정렬 기준이 아닙니다.";
        return `${label} 컬럼으로 정렬합니다. ${active}`;
    }

    public searchBodyEvidenceRows(limit: number = 80): SearchBodyEvidenceResult[] {
        let rows: SearchBodyEvidenceResult[] = [];
        let seen = new Set<string>();
        this.filteredBooks.forEach((book) => {
            let meta = this.searchMetaForBook(book);
            let bodyMatches: SearchMatchItem[] = []
                .concat(meta?.bodyHits || [])
                .concat((meta?.matches || []).filter((match) => match.type === "body"))
                .concat(this.searchMatchesForBook(book).filter((match) => match.type === "body"));
            bodyMatches.forEach((match: SearchMatchItem) => {
                if (!match || match.type !== "body") return;
                let key = [
                    this.bookKey(book),
                    match.chunkId,
                    match.fileId,
                    match.page || 0,
                    match.paragraph || 0,
                    match.snippet,
                ].join("|");
                if (seen.has(key)) return;
                seen.add(key);
                rows.push({ id: key, book, match });
            });
        });
        return rows.slice(0, limit);
    }

    public searchTagResultCards(limit: number = 48): SearchTagResultCard[] {
        let cards: { [key: string]: SearchTagResultCard } = {};
        let query = this.text(this.filters.search).toLocaleLowerCase();
        let activeTags = new Set(this.activeFilterChips().map((chip) => this.text(chip.value).toLocaleLowerCase()));

        let addCard = (book: BookItem, name: string, axis: string, reason: string) => {
            name = this.text(name);
            axis = this.text(axis) || "주제·태그";
            if (!name || this.isStateTagName(name)) return;
            let key = `${axis}|${name}`;
            if (!cards[key]) {
                cards[key] = {
                    id: key,
                    name,
                    axis,
                    description: `${this.axisDisplayName(axis)} 기준으로 연결된 자료`,
                    count: 0,
                    reasons: [],
                    bookIds: [],
                    representativeBook: book,
                };
            }
            let card = cards[key];
            let bookKey = this.bookKey(book);
            if (!card.bookIds.includes(bookKey)) {
                card.bookIds.push(bookKey);
                card.count += 1;
            }
            reason = this.text(reason);
            if (reason && !card.reasons.includes(reason)) card.reasons.push(this.truncate(reason, 120));
            if (!card.representativeBook) card.representativeBook = book;
        };

        this.filteredBooks.forEach((book) => {
            let tagMatches = this.searchMatchesForBook(book).filter((match) => match.type === "tag" || match.type === "semantic");
            tagMatches.forEach((match) => {
                addCard(book, match.value || match.relatedTopic, match.field || "주제·태그", match.snippet || match.label);
            });

            this.primaryTags(book).slice(0, 8).forEach((tag) => {
                let haystack = `${tag.name} ${tag.axis} ${tag.evidence || ""} ${tag.matchedAlias || ""}`.toLocaleLowerCase();
                let shouldShow = !query
                    || haystack.includes(query)
                    || activeTags.has(tag.name.toLocaleLowerCase())
                    || tagMatches.some((match) => this.text(match.value).toLocaleLowerCase() === tag.name.toLocaleLowerCase());
                if (shouldShow || Object.keys(cards).length < 12) {
                    addCard(book, tag.name, tag.axis, tag.evidence || `${book.title}의 주요 태그`);
                }
            });
        });

        return Object.values(cards)
            .sort((a, b) => b.count - a.count || this.tagAxisDisplayOrder.indexOf(a.axis) - this.tagAxisDisplayOrder.indexOf(b.axis) || a.name.localeCompare(b.name, "ko"))
            .slice(0, limit);
    }

    public searchGraphResultCards(limit: number = 60): SearchGraphResultCard[] {
        let rows: SearchGraphResultCard[] = [];
        let seen = new Set<string>();
        this.filteredBooks.forEach((book) => {
            this.searchMatchesForBook(book)
                .filter((match) => match.type === "graph")
                .forEach((match) => {
                    let title = this.searchGraphResultTitle(match);
                    let key = `${this.bookKey(book)}|${match.chunkId}|${match.page || 0}|${match.field}|${title}`;
                    if (seen.has(key)) return;
                    seen.add(key);
                    rows.push({
                        id: key,
                        book,
                        match,
                        title,
                        meta: this.searchGraphResultMeta(match),
                    });
                });
        });
        return rows.slice(0, limit);
    }

    public searchGraphResultTitle(match: SearchMatchItem): string {
        if (match.relationLabel) return match.relationLabel;
        if (match.nodeLabel) return `${match.nodeType || "항목"} · ${match.nodeLabel}`;
        return match.value || match.field || "자료 관계도 연관 결과";
    }

    public searchGraphResultMeta(match: SearchMatchItem): string {
        let parts = [match.field, match.relatedTopic, match.status]
            .map((item) => this.text(item))
            .filter((item) => item);
        if (match.page) parts.push(`${match.page}쪽`);
        return this.uniqueOptions(parts).slice(0, 4).join(" · ") || "자료 관계도 연관";
    }

    public bodyEvidencePageLabel(match: SearchMatchItem): string {
        if (match.pageLabel) return match.pageLabel;
        if (match.page) return `${match.page}쪽`;
        return "페이지 정보 없음";
    }

    public bodyEvidenceParagraphLabel(match: SearchMatchItem): string {
        if (match.paragraph) return `문단 ${match.paragraph}`;
        return "문단 정보 없음";
    }

    public bodyEvidenceSourceLabel(row: SearchBodyEvidenceResult): string {
        return row.match.pdfFilename || row.match.fileId || row.book.title;
    }

    public bodyEvidenceSnippet(row: SearchBodyEvidenceResult): string {
        return this.truncate(row.match.snippet || row.match.value || row.book.description || "본문 근거 문단 정보가 준비 중입니다.", 360);
    }

    public bodyEvidenceUnavailableReason(row: SearchBodyEvidenceResult): string {
        return this.searchMatchSourceUnavailableReason(row.book, row.match);
    }

    public canOpenBodyEvidence(row: SearchBodyEvidenceResult): boolean {
        return this.canOpenSearchMatchSource(row.book, row.match);
    }

    public canOpenSearchMatchSource(book: BookItem, match: SearchMatchItem | null): boolean {
        return Boolean(book?.pdfAvailable && this.canAccessBookOriginals(book) && match && (match.page || match.fileId || match.pdfFilename));
    }

    public searchMatchSourceUnavailableReason(book: BookItem, match: SearchMatchItem | null): string {
        if (!book?.pdfAvailable) return "연결된 PDF/eBook 원문이 없습니다.";
        if (!this.canAccessBookOriginals(book)) return this.originalAccessDeniedLabel(book);
        if (!match?.page && !match?.fileId && !match?.pdfFilename) return "페이지 또는 파일 위치 정보가 없습니다.";
        return "";
    }

    public highlightSegments(value: string, term: string = ""): HighlightSegment[] {
        value = this.truncate(value, 420);
        let candidates = [
            term,
            this.filters.search,
            ...this.searchAliasExpansions.flatMap((item) => [item.canonicalTag, item.matchedAlias].concat(item.aliases || [])),
        ]
            .map((item) => this.text(item))
            .filter((item) => item.length >= 2)
            .sort((a, b) => b.length - a.length);
        let lower = value.toLocaleLowerCase();
        let target = candidates.find((item) => lower.includes(item.toLocaleLowerCase()));
        if (!value || !target) return [{ text: value, active: false }];

        let escaped = this.escapeRegExp(target);
        let regex = new RegExp(escaped, "gi");
        let result: HighlightSegment[] = [];
        let lastIndex = 0;
        let match: RegExpExecArray | null;
        while ((match = regex.exec(value)) !== null) {
            if (match.index > lastIndex) result.push({ text: value.slice(lastIndex, match.index), active: false });
            result.push({ text: match[0], active: true });
            lastIndex = match.index + match[0].length;
        }
        if (lastIndex < value.length) result.push({ text: value.slice(lastIndex), active: false });
        return result.length ? result : [{ text: value, active: false }];
    }

    public primarySearchMatch(book: BookItem): SearchMatchItem | null {
        return this.searchMatchesForBook(book)[0] || null;
    }

    public searchEvidenceMatch(book: BookItem): SearchMatchItem | null {
        let matches = this.searchMatchesForBook(book);
        return matches.find((match) => Boolean(match.page || match.fileId || match.type === "body"))
            || matches.find((match) => Boolean(match.type === "graph" || match.collectionId))
            || null;
    }

    public searchMatchSnippet(book: BookItem): string {
        let evidenceMatch = this.searchEvidenceMatch(book);
        if (evidenceMatch?.snippet) return this.truncate(evidenceMatch.snippet, 150);
        let match = this.primarySearchMatch(book);
        if (match?.snippet) return this.truncate(match.snippet, 150);
        let meta = this.searchMetaForBook(book);
        if (meta?.relatedTopics?.length) return `가까운 주제: ${meta.relatedTopics.slice(0, 3).join(", ")}`;
        return "";
    }

    public hasSearchEvidenceAction(book: BookItem): boolean {
        return Boolean(this.searchEvidenceMatch(book));
    }

    public searchEvidenceActionLabel(book: BookItem): string {
        let match = this.searchEvidenceMatch(book);
        if (!match) return "자료 상세";
        if (match.page || match.fileId || match.type === "body") return "근거 문단 보기";
        if (match.type === "graph" || match.collectionId) return "자료 관계도 보기";
        return "자료 상세";
    }

    public async openSearchEvidence(book: BookItem, event?: Event) {
        this.stopEvent(event);
        let match = this.searchEvidenceMatch(book);
        await this.openSearchMatchEvidence(book, match, event);
    }

    public async openSearchMatchEvidence(book: BookItem, match: SearchMatchItem | null, event?: Event) {
        this.stopEvent(event);
        if (!match) {
            await this.openResultDetail(book);
            return;
        }
        if (match.page || match.fileId || match.type === "body") {
            await this.openBook(book, undefined, true);
            if (!this.selectedBook) return;
            if (match.fileId) {
                let index = this.selectedBook.pdfs.findIndex((pdf) => (pdf.fileId || pdf.textIndex?.fileId) === match.fileId);
                if (index >= 0) this.activePdfIndex = index;
            } else if (typeof match.pdfIndex === "number" && Number.isFinite(match.pdfIndex)) {
                this.activePdfIndex = Math.max(0, match.pdfIndex);
            }
            if (match.page && match.page > 0) {
                this.activePdfPage = match.page;
                this.readerPageInput = String(match.page);
            }
            await this.scrollToDetailSection("ebook-reader");
            await this.renderActivePdfPage();
            return;
        }
        if (match.type === "graph" || match.collectionId) {
            await this.openResultGraph(book);
            return;
        }
        await this.openResultDetail(book);
    }

    public sortSearchResults(rows: BookItem[], sort: string): BookItem[] {
        let base = this.sortBooks(rows, sort);
        if (sort && sort !== "title") return base;
        let baseIndex: any = {};
        base.forEach((book, index) => baseIndex[this.bookKey(book)] = index);
        return base.sort((a, b) => {
            let aMeta = this.searchMetaForBook(a);
            let bMeta = this.searchMetaForBook(b);
            let aPriority = aMeta?.priority || this.localSearchPriority(a);
            let bPriority = bMeta?.priority || this.localSearchPriority(b);
            let aScore = aMeta?.score || 0;
            let bScore = bMeta?.score || 0;
            return aPriority - bPriority
                || bScore - aScore
                || Number(b.bodySearchAvailable) - Number(a.bodySearchAvailable)
                || Number(b.graphAvailable) - Number(a.graphAvailable)
                || (baseIndex[this.bookKey(a)] || 0) - (baseIndex[this.bookKey(b)] || 0)
                || this.compareStableBookIdentity(a, b);
        });
    }

    private localSearchPriority(book: BookItem): number {
        let query = this.text(this.filters.search).toLocaleLowerCase();
        if (!query) return 99;
        if (book.title.toLocaleLowerCase() === query) return 1;
        if (book.title.toLocaleLowerCase().includes(query)) return 2;
        if (book.tags.some((tag) => `${tag.name} ${tag.matchedAlias || ""}`.toLocaleLowerCase().includes(query))) return 3;
        if (`${book.author} ${book.publisher} ${book.publishedYear || ""} ${book.id} ${book.hflibId}`.toLocaleLowerCase().includes(query)) return 4;
        if (book.toc.some((toc) => toc.label.toLocaleLowerCase().includes(query))) return 5;
        return 9;
    }

    public async handleAuthorInput(value: string) {
        this.filters.author = this.text(value);
        this.authorDropdownOpen = true;
        this.updateAuthorSuggestions();
        await this.applyFilters();
    }

    public async openAuthorSuggestions() {
        this.authorDropdownOpen = true;
        this.updateAuthorSuggestions();
        await this.service.render();
    }

    public closeAuthorSuggestionsSoon() {
        setTimeout(async () => {
            this.authorDropdownOpen = false;
            this.authorActiveIndex = -1;
            await this.service.render();
        }, 120);
    }

    public async handleAuthorKeydown(event: KeyboardEvent) {
        if (event.key === "ArrowDown") {
            event.preventDefault();
            this.authorDropdownOpen = true;
            this.updateAuthorSuggestions();
            if (this.authorSuggestions.length) {
                this.authorActiveIndex = (this.authorActiveIndex + 1) % this.authorSuggestions.length;
            }
            await this.service.render();
        } else if (event.key === "ArrowUp") {
            event.preventDefault();
            this.authorDropdownOpen = true;
            this.updateAuthorSuggestions();
            if (this.authorSuggestions.length) {
                this.authorActiveIndex = this.authorActiveIndex <= 0
                    ? this.authorSuggestions.length - 1
                    : this.authorActiveIndex - 1;
            }
            await this.service.render();
        } else if (event.key === "Enter") {
            if (this.authorDropdownOpen && this.authorActiveIndex >= 0 && this.authorSuggestions[this.authorActiveIndex]) {
                event.preventDefault();
                await this.selectAuthor(this.authorSuggestions[this.authorActiveIndex]);
            }
        } else if (event.key === "Escape") {
            this.authorDropdownOpen = false;
            this.authorActiveIndex = -1;
            await this.service.render();
        }
    }

    public async selectAuthor(author: string, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.filters.author = author;
        this.authorDropdownOpen = false;
        this.authorActiveIndex = -1;
        this.updateAuthorSuggestions();
        await this.applyFilters();
    }

    public async clearAuthorFilter(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.filters.author = "";
        this.authorDropdownOpen = false;
        this.authorActiveIndex = -1;
        this.updateAuthorSuggestions();
        await this.applyFilters();
    }

    public updateAuthorSuggestions() {
        let query = this.normalizedAuthor(this.filters.author);
        let options = this.authorOptions.filter((author) => this.text(author));
        let suggestions: string[] = [];

        if (query) {
            let prefixMatches = options.filter((author) => this.normalizedAuthor(author).startsWith(query));
            let partialMatches = options.filter((author) => {
                let normalized = this.normalizedAuthor(author);
                return !normalized.startsWith(query) && normalized.includes(query);
            });
            suggestions = prefixMatches.concat(partialMatches);
        } else {
            suggestions = options;
        }

        this.authorSuggestions = suggestions.slice(0, 8);
        if (this.authorActiveIndex >= this.authorSuggestions.length) {
            this.authorActiveIndex = this.authorSuggestions.length ? 0 : -1;
        }
    }

    public async resetFilters() {
        this.filters = {
            search: "",
            author: "",
            businessAxis: "",
            issueAxis: "",
            eraAxis: "",
            regionAxis: "",
            relationshipAxis: "",
            materialNature: "",
            creatorAxis: "",
            perspectiveAxis: "",
            workPurpose: "",
            reviewStateAxis: "",
            collectionId: "",
            year: "",
            pdfState: "",
            bodyExtractionStatus: "",
            tagReviewStatus: "",
            publicStatus: "",
            sort: "title"
        };
        this.activeResultGroupId = "";
        this.activeSearchResultTab = "all";
        this.authorDropdownOpen = false;
        this.authorActiveIndex = -1;
        this.updateAuthorSuggestions();
        await this.applyFilters();
    }

    public async openBook(
        book: BookItem,
        event?: Event,
        updateUrl: boolean = true,
        evidenceTarget?: { fileId?: string, page?: number, anchor?: string },
    ) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.selectedBook) {
            this.previousFocus = document.activeElement as HTMLElement;
            this.captureMaterialListScroll();
        }
        this.selectedBook = book;
        this.selectedFileId = "";
        this.relatedBooks = this.findRelatedBooks(book);
        this.activePdfIndex = 0;
        this.activePdfPage = 1;
        this.readerPageInput = "1";
        this.readerZoomMode = "fit-width";
        this.readerZoom = 1;
        this.readerNavPanelOpen = false;
        this.readerTextPanelOpen = false;
        this.readerTocOpen = false;
        this.readerPreviewOpen = false;
        this.readerSavedPagesOpen = false;
        this.resetPdfReaderState();
        this.resetDetailTools();
        if (evidenceTarget?.fileId) {
            this.selectedFileId = evidenceTarget.fileId;
            let evidencePdfIndex = book.pdfs.findIndex((pdf) => (pdf.fileId || pdf.textIndex?.fileId) === evidenceTarget.fileId);
            if (evidencePdfIndex >= 0) this.activePdfIndex = evidencePdfIndex;
        }
        if (Number(evidenceTarget?.page || 0) > 0) {
            this.activePdfPage = Number(evidenceTarget?.page);
            this.readerPageInput = String(this.activePdfPage);
        }
        this.graphLoading = this.canUseBookKnowledgeGraph(book);
        if (updateUrl) this.pushDetailUrl(book);
        if (updateUrl && evidenceTarget?.anchor) this.replaceDetailAnchor(evidenceTarget.anchor);
        window.scrollTo({ top: 0, behavior: "smooth" });
        await this.service.render();
        let detail = await this.loadBookDetail(book);
        let tasks: Promise<any>[] = [];
        if (this.canAccessBookOriginals(detail)) tasks.push(this.prepareActiveReader());
        if (this.canUseBookKnowledgeGraph(detail)) tasks.push(this.loadKnowledgeGraph(detail));
        await Promise.all(tasks);
    }

    public async closeDetail() {
        this.selectedBook = null;
        this.selectedFileId = "";
        this.relatedBooks = [];
        this.activePdfIndex = 0;
        this.activePdfPage = 1;
        this.readerPageInput = "1";
        this.readerNavPanelOpen = false;
        this.readerTextPanelOpen = false;
        this.resetPdfReaderState();
        this.resetDetailTools();
        this.pushListUrl();
        await this.service.render();
        if (this.activeTopTab === "graph" && this.canAccessKnowledgeGraph()) {
            if (this.activeGraphScope === "book") await this.ensureGraphTargetBookLoaded();
            else if (this.selectedCollectionId) await this.loadCollectionGraph();
        }
        this.restoreMaterialListScroll();
        if (this.previousFocus && this.previousFocus.focus) {
            setTimeout(() => {
                this.previousFocus?.focus({ preventScroll: true });
                window.scrollTo({ top: this.materialListScrollY, behavior: "auto" });
            }, 0);
        }
    }

    public async closeModal() {
        await this.closeDetail();
    }

    @HostListener('document:keydown.escape')
    public async handleEscape() {
        if (document.fullscreenElement) return;
        if (this.selectedBook) await this.closeDetail();
    }

    @HostListener('document:fullscreenchange')
    public async handleReaderFullscreenChange() {
        this.readerFullscreen = document.fullscreenElement === this.readerWorkspace?.nativeElement;
        await this.service.render();
        if (this.readerZoomMode === "fit-width") {
            setTimeout(() => this.renderActivePdfPage(), 0);
        }
    }

    @HostListener('window:resize')
    public handleReaderResize() {
        if (!this.selectedBook || this.readerZoomMode !== "fit-width") return;
        if (this.readerResizeTimer) clearTimeout(this.readerResizeTimer);
        this.readerResizeTimer = setTimeout(() => this.renderActivePdfPage(), 120);
    }

    @HostListener('window:popstate')
    public async handlePopState() {
        this.restoringRouteState = true;
        this.restoreMainStateFromUrl();
        this.syncSelectedBookFromUrl();
        await this.applyFilters(false);
        await this.service.render();
        this.restoreDetailAnchor();
        if (this.selectedBook) {
            let detail = await this.loadBookDetail(this.selectedBook);
            this.applySelectedFileId(detail);
            let tasks: Promise<any>[] = [];
            if (this.canAccessBookOriginals(detail)) tasks.push(this.prepareActiveReader());
            if (this.canUseBookKnowledgeGraph(detail)) tasks.push(this.loadKnowledgeGraph(detail));
            await Promise.all(tasks);
            this.restoreDetailAnchor();
        } else if (this.activeTopTab === "graph" && this.canAccessKnowledgeGraph()) {
            if (this.activeGraphScope === "book") {
                await this.ensureGraphTargetBookLoaded();
            } else if (this.selectedCollectionId
                && (!this.collectionGraph || this.collectionGraph.collectionId !== this.selectedCollectionId)) {
                await this.loadCollectionGraph();
            }
        }
        this.restoringRouteState = false;
        this.syncMainUrl("replace");
        if (!this.selectedBook) this.restoreMaterialListScroll();
    }

    public handleModalKeydown(event: KeyboardEvent) {
        if (event.key !== "Tab" || !this.modalPanel) return;

        let focusable = this.modalPanel.nativeElement.querySelectorAll(
            "a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex='-1'])"
        );
        if (!focusable.length) return;

        let first = focusable[0] as HTMLElement;
        let last = focusable[focusable.length - 1] as HTMLElement;
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    public findRelatedBooks(book: BookItem): BookItem[] {
        let recommendations = book.relatedRecommendations || [];
        return recommendations
            .map((row) => this.books.find((item) => item.id === row.materialId || item.hflibId === row.materialId) || null)
            .filter((item): item is BookItem => !!item)
            .slice(0, 6);
    }

    public sharedTags(a: BookItem, b: BookItem): string[] {
        let target = a.tags.map((tag) => tag.name);
        return b.tags.map((tag) => tag.name).filter((name) => target.includes(name));
    }

    public relatedReason(a: BookItem, b: BookItem): string {
        let recommendation = (a.relatedRecommendations || []).find((row) => row.materialId === b.id || row.materialId === b.hflibId);
        return recommendation?.reason || "구체적인 관련 근거가 확인되지 않았습니다.";
    }

    public authorOrCompiler(book: BookItem): string {
        let names = [book.author, book.personalName, book.corporateName]
            .map((item) => this.text(item).replace(/[.,]$/, ""))
            .filter((item) => item && item !== "저자 정보 없음");
        let unique = this.uniqueOptions(names);
        return unique.length ? unique.join(", ") : "저자·편찬기관 정보 없음";
    }

    public bibliographicRows(book: BookItem): BibliographicRow[] {
        let rows: BibliographicRow[] = [];
        let add = (label: string, value: string, fallback: string = "") => {
            value = this.cleanBibliographicValue(value);
            if (this.isMissingBibliographicValue(value)) {
                if (!fallback) return;
                value = fallback;
            }
            rows.push({ label, value });
        };

        add("자료유형", this.materialTypeLabel(book), "정보 없음");
        add("저자·편찬기관", this.authorOrCompiler(book), "정보 없음");
        add("서명·저자사항", this.titleStatementLabel(book), "정보 없음");
        add("발행사항", this.publicationStatementLabel(book), "정보 없음");
        add("형태사항", this.physicalDescriptionLabel(book), "정보 없음");
        add("총서사항", this.seriesStatementLabel(book));
        add("ISBN 또는 ISSN", this.identifierLabel(book), "정보 없음");
        add("일반주기", book.generalNote || "");
        add("서지주기", book.bibliographyNote || "");
        add("주제명", this.subjectLabel(book));
        add("KDC 또는 분류 정보", this.classificationLabel(book), "정보 없음");
        return rows;
    }

    public trackBibliographicRow(index: number, row: BibliographicRow) {
        return `${row.label}-${index}`;
    }

    public materialTypeLabel(book: BookItem): string {
        return this.text(book.materialType) || this.text(book.category) || this.text(book.bibliographicType);
    }

    public titleStatementLabel(book: BookItem): string {
        let statement = this.text(book.titleStatement);
        if (!this.isMissingBibliographicValue(statement)) return statement;

        let author = this.authorOrCompiler(book);
        if (this.isMissingBibliographicValue(author)) return book.title;
        return `${book.title} / ${author}`;
    }

    public publicationStatementLabel(book: BookItem): string {
        let statement = this.text(book.publicationStatement);
        if (!this.isMissingBibliographicValue(statement)) return statement;

        let values = [book.publisher, book.publishedDate]
            .map((item) => this.text(item))
            .filter((item) => !this.isMissingBibliographicValue(item));
        return values.join(", ");
    }

    public physicalDescriptionLabel(book: BookItem): string {
        let statement = this.text(book.physicalDescription);
        if (!this.isMissingBibliographicValue(statement)) return statement;

        let values = [book.page, book.height]
            .map((item) => this.text(item))
            .filter((item) => !this.isMissingBibliographicValue(item));
        return values.join(" ; ");
    }

    public seriesStatementLabel(book: BookItem): string {
        let values = [book.seriesTitle, book.volume]
            .map((item) => this.text(item))
            .filter((item) => !this.isMissingBibliographicValue(item));
        return values.join(" ");
    }

    public subjectLabel(book: BookItem): string {
        let subject = this.text(book.subjectName || book.marcSubject);
        if (!this.isMissingBibliographicValue(subject)) return subject;

        let tags = this.primaryTags(book)
            .map((tag) => this.text(tag.name))
            .filter((item) => item && !this.isStateTagName(item));
        return this.uniqueOptions(tags).slice(0, 8).join(", ");
    }

    public publisherYearLabel(book: BookItem): string {
        let year = this.publishedYearLabel(book);
        return `${book.publisher} · ${year}`;
    }

    public publisherLabel(book: BookItem): string {
        let publisher = this.text(book.publisher || book.corporateName);
        if (!publisher || this.isMissingBibliographicValue(publisher)) return "발행기관 정보 없음";
        return publisher;
    }

    public identifierLabel(book: BookItem): string {
        let values = [];
        if (book.isbn) values.push(`ISBN ${book.isbn}`);
        let issn = this.cleanIdentifierValue(book.issn || "");
        if (issn) values.push(`ISSN ${issn}`);
        return values.length ? values.join(" / ") : "ISBN·ISSN 정보 없음";
    }

    public classificationLabel(book: BookItem): string {
        if (book.kdc) return `KDC ${book.kdc}`;
        if (book.classification) return book.classification;
        if (book.callNo) return `청구기호 ${book.callNo}`;
        return book.category || "분류 정보 없음";
    }

    public originalUrlLabel(book: BookItem): string {
        return book.sourceUrl || "원본 URL 정보 없음";
    }

    private cleanIdentifierValue(value: string): string {
        value = this.text(value);
        return ["-", "없음", "N/A", "NA"].includes(value.toLocaleUpperCase()) ? "" : value;
    }

    private cleanBibliographicValue(value: string): string {
        return this.text(value)
            .replace(/\s+([,.;:])/g, "$1")
            .replace(/\s*\/\s*$/g, "")
            .trim();
    }

    private isMissingBibliographicValue(value: string): boolean {
        value = this.text(value);
        if (!value || value === "-" || value === "/" || value === "·") return true;
        return [
            "정보 없음",
            "저자 정보 없음",
            "저자·편찬기관 정보 없음",
            "출판사 정보 없음",
            "출간일 정보 없음",
            "분류 정보 없음",
            "자료 성격 미분류",
            "ISBN·ISSN 정보 없음",
            "서지유형 정보 없음",
            "총서 정보 없음",
            "쪽수 정보 없음",
            "크기 정보 없음",
            "원본 URL 정보 없음",
            "연도 미상",
        ].includes(value);
    }

    private isStateTagName(name: string): boolean {
        return STATE_TAG_NAMES.includes(this.text(name));
    }

    public ebookStatusLabel(book: BookItem): string {
        if (!book.pdfAvailable) return "원문 확보 필요";
        if (book.bodySearchAvailable) return "페이지·문단 본문 연결";
        return "내부 eBook 열람 가능";
    }

    public detailUrl(book: BookItem): string {
        let id = encodeURIComponent(book.id || book.hflibId);
        return this.mainStateUrl(`/main/${id}`);
    }

    public async scrollToDetailSection(sectionId: string) {
        let target = document.getElementById(sectionId);
        if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
        await this.service.render();
    }

    public bookGraphNodeCountLabel(book: BookItem): string {
        if (this.graphLoading) return "불러오는 중";
        if (this.knowledgeGraph) return `${this.knowledgeGraph.summary.nodeCount || this.knowledgeGraph.nodes.length}개`;
        return book.graphAvailable ? "산출 가능" : "대기";
    }

    public bookGraphRelationCountLabel(book: BookItem): string {
        if (this.graphLoading) return "불러오는 중";
        if (this.knowledgeGraph) return `${this.knowledgeGraph.summary.relationCount || this.knowledgeGraph.relations.length}개`;
        return book.graphAvailable ? "산출 가능" : "대기";
    }

    public bookGraphEvidenceCountLabel(book: BookItem): string {
        if (this.graphLoading) return "불러오는 중";
        if (this.knowledgeGraph) {
            let count = this.knowledgeGraph.summary.evidenceNodeCount || this.knowledgeGraph.evidenceNodes.length;
            return `${count}건`;
        }
        if (book.bodyChunkCount > 0) return `청크 ${book.bodyChunkCount}개`;
        return book.bodySearchStatus || "본문 근거 대기";
    }

    public async openBookKnowledgeGraph(book: BookItem) {
        if (!this.canAccessKnowledgeGraph()) {
            this.graphErrorMessage = this.accessDeniedMessage("graph");
            await this.service.render();
            return;
        }
        if (!book?.graphAvailable) {
            await this.openBookRelatedGraph(book);
            return;
        }
        let materialId = this.text(book.id || book.hflibId);
        if ((!this.knowledgeGraph || this.knowledgeGraph.materialId !== materialId) && !this.graphLoading) await this.loadKnowledgeGraph(book);
        this.graphNodeTypeFilter = "";
        this.graphRelationTypeFilter = "";
        this.graphRelationStatusFilter = "전체";
        this.graphSearchQuery = "";
        this.graphMinConfidence = 0;
        this.graphShowEvidence = false;
        this.graphExpanded = false;
        this.graphZoom = 1;
        this.graphSelectedNode = null;
        this.graphSelectedRelation = null;
        this.graphHoveredNode = null;
        this.graphHoveredRelation = null;
        await this.scrollToDetailSection("book-knowledge-graph");
        await this.service.render();
    }

    public async openBookEntityRelations(book: BookItem) {
        if (!this.canAccessKnowledgeGraph()) {
            this.graphErrorMessage = this.accessDeniedMessage("graph");
            await this.service.render();
            return;
        }
        if (!book?.graphAvailable) {
            await this.openBookRelatedGraph(book);
            return;
        }
        if (!this.knowledgeGraph && !this.graphLoading) await this.loadKnowledgeGraph(book);
        this.graphNodeTypeFilter = "";
        this.graphRelationTypeFilter = this.graphRelationTypeOptions().includes("주제로다룬다") ? "주제로다룬다" : "";
        this.graphRelationStatusFilter = "전체";
        this.graphSearchQuery = "";
        this.graphShowEvidence = true;
        this.graphExpanded = false;
        await this.scrollToDetailSection("book-knowledge-graph");
        await this.service.render();
    }

    public async openBookRelatedGraph(book: BookItem, event?: Event) {
        this.stopEvent(event);
        if (!this.canAccessKnowledgeGraph()) {
            this.graphErrorMessage = this.accessDeniedMessage("graph");
            await this.service.render();
            return;
        }
        let collectionId = this.collectionIdForBook(book);
        if (collectionId) {
            await this.openCollectionGraphById(collectionId);
            return;
        }
        if (book?.graphAvailable) {
            await this.openBookKnowledgeGraph(book);
            return;
        }
        this.graphErrorMessage = "이 자료는 아직 자료 관계도 산출 대상이 아닙니다.";
        await this.service.render();
    }

    public axisDisplayName(axis: string): string {
        axis = this.text(axis);
        return TAG_AXIS_DISPLAY_LABELS[axis] || axis.replace(/\s*축$/, "");
    }

    public categoryDisplayText(value: string): string {
        let result = this.text(value);
        Object.keys(TAG_AXIS_DISPLAY_LABELS).forEach((axis) => {
            result = result.split(axis).join(TAG_AXIS_DISPLAY_LABELS[axis]);
        });
        return result;
    }

    public nodeTypeLabel(node: KnowledgeGraphNode | null): string {
        let type = this.normalizeGraphNodeType(this.text(node?.nodeType || node?.type));
        return GRAPH_NODE_TYPE_LABELS[type] || this.axisDisplayName(type);
    }

    public graphNodeIcon(node: KnowledgeGraphNode | null): string {
        let type = this.normalizeGraphNodeType(this.text(node?.nodeType || node?.type));
        if (type === "자료" || type === "관련 자료") return "DOC";
        if (type === "주제") return "TOP";
        if (type === "장소") return "LOC";
        if (type === "인물") return "PER";
        if (type === "기관") return "ORG";
        if (type === "사건" || type === "시대") return "EVT";
        if (type === "문헌·법령") return "LAW";
        if (type === "쟁점·반박") return "!";
        if (type === "근거 후보") return "TXT";
        return "CON";
    }

    private normalizeGraphNodeType(type: string): string {
        let value = this.text(type) || "개념";
        const aliases: any = {
            "시대·국가": "시대",
            "근거문단": "근거 후보",
            "근거": "근거 후보",
            "태그": "주제",
            "별칭": "개념",
            "컬렉션": "주제",
            "주장": "쟁점·반박",
            "쟁점": "쟁점·반박",
            "반박": "쟁점·반박",
        };
        value = aliases[value] || value;
        return GRAPH_REQUIRED_NODE_TYPES.includes(value) ? value : "개념";
    }

    public graphNodeDisplayLabel(node: KnowledgeGraphNode | null): string {
        if (!node) return "";
        return this.text(node.displayLabel) || `${this.nodeTypeLabel(node)} · ${node.label}`;
    }

    public graphNodeRelatedMaterialId(node: KnowledgeGraphNode | null): string {
        if (!node) return "해당 없음";
        return this.text(node.relatedMaterialId || node.materialId) || "해당 없음";
    }

    public graphNodeRelatedTags(node: KnowledgeGraphNode | null): string {
        if (!node || !node.relatedTags?.length) return "해당 없음";
        return node.relatedTags.slice(0, 6).join(", ");
    }

    public graphNodeSourceField(node: KnowledgeGraphNode | null): string {
        if (!node) return "해당 없음";
        return this.text(node.sourceField) || "해당 없음";
    }

    private normalizeGraphReviewStatus(status: string): string {
        let value = this.text(status || "검수 대기");
        if (value === "검수완료") return "검수 완료";
        if (value === "검수대기" || value === "검수 필요" || value === "자동추출" || value === "자동추천") return "검수 대기";
        return value;
    }

    public nodeDetailLabel(node: KnowledgeGraphNode | null): string {
        let value = this.categoryDisplayText(this.text(node?.detail || node?.sentence || "상세 정보 없음"));
        return this.publicGraphText(value);
    }

    public publicGraphText(value: string): string {
        value = this.text(value);
        if (!value || this.canAccessAdminReview()) return value;
        return value
            .replace(/본문 근거 연결 전/g, "원문 근거 준비 중")
            .replace(/본문 근거 연결 대기/g, "원문 근거 준비 중")
            .replace(/메타데이터 기반 추천/g, "자료 정보 기반 연결")
            .replace(/검수대기/g, "확인 전")
            .replace(/검수 대기/g, "확인 전")
            .replace(/검수 필요/g, "확인 필요")
            .replace(/자동추출/g, "자료 분석")
            .replace(/자동추천/g, "자료 정보 기반");
    }

    public graphTotalNodeCount(graph: KnowledgeGraphData | null): number {
        if (!graph) return 0;
        return Number(graph.summary?.nodeCount || graph.nodes.length || 0);
    }

    public graphTotalRelationCount(graph: KnowledgeGraphData | null): number {
        if (!graph) return 0;
        return Number(graph.summary?.relationCount || graph.relations.length || 0);
    }

    public graphEvidenceConnectionSummary(graph: KnowledgeGraphData | null): string {
        if (!graph) return "연결 데이터 준비 중";
        let relations = graph.relations || [];
        if (!relations.length) return "연결 없음";
        let linked = relations.filter((relation) => this.relationHasSourcePage(relation)).length;
        let pending = relations.filter((relation) => !this.relationHasSourcePage(relation)).length;
        if (linked && pending) return `근거 문장 ${linked}건 · 준비 중 ${pending}건`;
        if (linked) return `근거 문장 ${linked}건`;
        if (graph.summary?.metadataOnly) return "자료 정보로 연결 · 근거 문장 준비 중";
        return "근거 문장 준비 중";
    }

    public graphRelationBasisSummary(graph: KnowledgeGraphData | null): string {
        if (!graph) return "연결 데이터 준비 중";
        let total = this.graphTotalRelationCount(graph);
        if (!total) return "연결 0건";

        let metadata = Number(graph.summary?.metadataCandidateCount || 0);
        let body = Number(graph.summary?.bodyRelationCount || 0);
        if (graph.summary?.metadataOnly || metadata >= total) return `자료 정보 연결 ${total}건`;
        if (metadata > 0 && body > 0) return `근거 문장 ${body}건 · 자료 정보 ${metadata}건`;
        if (body > 0) return `근거 문장 연결 ${body}건`;
        return `연결 ${total}건`;
    }

    public graphCoreTopicCount(graph: KnowledgeGraphData | null): number {
        if (!graph) return 0;
        let excluded = new Set(["자료", "관련 자료", "근거 후보"]);
        return graph.nodes.filter((node) => {
            let type = this.normalizeGraphNodeType(this.text(node.nodeType || node.type));
            return !excluded.has(type);
        }).length;
    }

    public graphRelatedMaterialCount(graph: KnowledgeGraphData | null, book: BookItem | null = null): number {
        if (!graph) return 0;
        let currentMaterialIds = new Set([graph.materialId, book?.id, book?.hflibId]
            .map((value) => this.text(value))
            .filter((value) => value));
        let materialIds = new Set<string>();

        graph.nodes.forEach((node) => {
            let type = this.normalizeGraphNodeType(this.text(node.nodeType || node.type));
            if (type !== "관련 자료") return;
            let materialId = this.text(node.relatedMaterialId || node.materialId || node.id.replace(/^material:/, ""));
            if (materialId && !currentMaterialIds.has(materialId)) materialIds.add(materialId);
        });
        graph.relations.forEach((relation) => {
            let materialId = this.text(relation.materialId);
            if (materialId && !currentMaterialIds.has(materialId)) materialIds.add(materialId);
        });
        (graph.materials || []).forEach((material) => {
            let materialId = this.text(material.id || material.hflibId);
            if (materialId && !currentMaterialIds.has(materialId)) materialIds.add(materialId);
        });

        if (materialIds.size > 0) return materialIds.size;
        return Number(graph.summary?.displayMaterialCount || graph.summary?.materialCount || 0);
    }

    public graphReviewStatusSummary(graph: KnowledgeGraphData | null, book: BookItem | null = null): string {
        let fallback = this.normalizeGraphReviewStatus(this.text(book?.reviewStatus || "검수 대기"));
        if (!graph) return fallback;
        let relations = graph.relations || [];
        if (!relations.length) return fallback;

        let reviewed = Number(graph.summary?.reviewedCount || 0);
        if (!reviewed) reviewed = relations.filter((relation) => this.isRelationReviewed(relation)).length;
        let pending = relations.filter((relation) => this.isRelationPendingReview(relation)).length;
        if (reviewed > 0 && pending > 0) return `검수 완료 ${reviewed}건 · 대기 ${pending}건`;
        if (reviewed > 0 && reviewed >= relations.length) return `검수 완료 ${reviewed}건`;
        if (pending > 0) return `검수 대기 ${pending}건`;
        return fallback;
    }

    public graphQualityStatusLabel(graph: KnowledgeGraphData | null): string {
        if (!graph?.quality) return "구조 검사 대기";
        let quality = graph.quality;
        if (quality.status === "fail") return `구조 검사 실패 ${quality.failedCount}건`;
        if (quality.status === "warning") return `구조 검사 주의 ${quality.warningCount}건`;
        return `구조 검사 통과 ${quality.passedCount}건`;
    }

    public graphQualityPanelClass(graph: KnowledgeGraphData | null): any {
        let status = this.text(graph?.quality?.status || "pending");
        return {
            "is-pass": status === "pass",
            "is-warning": status === "warning",
            "is-fail": status === "fail",
        };
    }

    public graphQualityMetricSummary(graph: KnowledgeGraphData | null): string {
        if (!graph?.quality) return "품질 검수 결과 없음";
        let quality = graph.quality;
        return `기본 노드 ${quality.defaultDisplayNodeCount}개 · 유형 ${quality.nodeTypeCount}종 · 관련 자료 ${quality.relatedMaterialDisplayCount}/${quality.relatedMaterialActualCount}개`;
    }

    public graphQualityCheckRows(graph: KnowledgeGraphData | null): GraphQualityCheckItem[] {
        if (!graph?.quality?.checks?.length) return [];
        let rows = graph.quality.checks.slice().sort((a, b) => {
            let weight: any = { fail: 0, warning: 1, pass: 2 };
            return Number(weight[a.status] ?? 3) - Number(weight[b.status] ?? 3);
        });
        return rows.slice(0, 6);
    }

    public graphQualityCheckClass(check: GraphQualityCheckItem | null): string {
        if (!check) return "is-pass";
        if (check.status === "fail") return "is-fail";
        if (check.status === "warning") return "is-warning";
        return "is-pass";
    }

    public graphQualityNotice(graph: KnowledgeGraphData | null): string {
        if (!graph?.quality) return "";
        if (graph.quality.notices?.length) return graph.quality.notices[0];
        if (graph.quality.metadataOnly || graph.summary?.metadataOnly) {
            return "중심 자료 외 관계가 모두 메타데이터 기반 추천 상태입니다. 본문 근거 연결 전까지 확정 관계로 보지 않습니다.";
        }
        return "자동 구조 검사는 역사적 정확성 확인을 뜻하지 않습니다.";
    }

    public graphGenerationBasisLabel(graph: KnowledgeGraphData | null): string {
        if (!graph) return "데이터 생성 기준 대기";
        if (graph.summary?.metadataOnly) return GRAPH_METADATA_CANDIDATE_GRAPH_LABEL;
        if (this.text(graph.graphType)) return this.text(graph.graphType);
        let basis = this.categoryDisplayText(this.text(graph.extractionBasis));
        return basis ? this.truncate(basis, 90) : "자료 정보·원문 문단 기준";
    }

    public graphActiveDataSourceLabel(graph: KnowledgeGraphData | null): string {
        if (!graph?.dataSources?.length) return "데이터 소스 정보 없음";
        let active = graph.dataSources
            .filter((item) => item.active)
            .map((item) => item.source);
        return active.length ? this.truncate(active.join(", "), 110) : "활성 데이터 소스 없음";
    }

    public isGraphMaterialNode(node: KnowledgeGraphNode | null): boolean {
        if (!node) return false;
        let type = this.normalizeGraphNodeType(this.text(node.nodeType || node.type));
        let id = this.text(node.id);
        return type === "자료" || type === "관련 자료" || id.startsWith("material:");
    }

    public graphNodeDetailAvailable(node: KnowledgeGraphNode | null): boolean {
        if (!node) return false;
        return this.nodeDetailLabel(node) !== "상세 정보 없음";
    }

    public graphNodeScopedEvidenceStatus(node: KnowledgeGraphNode | null, scope: string): string {
        return scope === "collection" ? this.collectionNodeEvidenceStatus(node) : this.graphNodeEvidenceStatus(node);
    }

    public graphNodeScopedConnectionCount(node: KnowledgeGraphNode | null, scope: string): number {
        return this.graphRelationsForNodeScope(node, scope).length;
    }

    public graphNodeScopedMaterialCount(node: KnowledgeGraphNode | null, scope: string): number {
        if (scope === "collection") return this.collectionNodeMaterialCount(node);
        return this.graphNodeMaterialCount(node);
    }

    public graphNodeScopedMetricLabel(node: KnowledgeGraphNode | null, scope: string): string {
        if (!node) return "출처 0건";
        if (this.text(node.displayMetricLabel)) return this.text(node.displayMetricLabel);
        let type = this.normalizeGraphNodeType(this.text(node.nodeType || node.type));
        if (type === "자료") return `연결 ${this.graphNodeScopedConnectionCount(node, scope)}건`;
        if (type === "관련 자료") return `관련 자료 ${Math.max(1, this.graphNodeScopedMaterialCount(node, scope))}건`;
        let materialCount = this.graphNodeScopedMaterialCount(node, scope);
        if (materialCount > 1) return `관련 자료 ${materialCount}건`;
        return `출처 ${Math.max(1, Number(node.sourceCount || 0) || this.graphNodeScopedConnectionCount(node, scope))}건`;
    }

    public graphNodeScopedStatusLabel(node: KnowledgeGraphNode | null, scope: string): string {
        let status = this.graphNodeScopedEvidenceStatus(node, scope);
        let shortStatus = status === GRAPH_BODY_EVIDENCE_COMPLETE_STATUS
            ? "본문 근거"
            : status === GRAPH_BODY_EVIDENCE_PENDING_STATUS
                ? "근거 대기"
                : status || "근거 상태 없음";
        return `${this.graphNodeScopedMetricLabel(node, scope)} · ${shortStatus}`;
    }

    public graphNodePublicEvidenceLabel(node: KnowledgeGraphNode | null, scope: string): string {
        let status = this.graphNodeScopedEvidenceStatus(node, scope);
        if (status === GRAPH_BODY_EVIDENCE_COMPLETE_STATUS) return "근거 문장 있음";
        if (status === GRAPH_BODY_EVIDENCE_PENDING_STATUS) return "근거 문장 준비 중";
        if (status === GRAPH_METADATA_RECOMMENDATION_STATUS) return "자료 정보로 연결";
        if (!status || status.includes("검수") || status.includes("자동") || status.includes("내부")) return "연결 정보 확인";
        return status;
    }

    public graphNodeMaterialRelatedCount(node: KnowledgeGraphNode | null, scope: string, fallbackBook: BookItem | null = null): number {
        if (!node) return 0;
        let primaryId = this.normalizeGraphMaterialId(this.graphPrimaryMaterialIdForNode(node));
        let direct = this.graphNodeDirectMaterialReferences(node, scope, fallbackBook)
            .filter((item) => this.normalizeGraphMaterialId(item.id) !== primaryId)
            .length;
        let book = this.graphNodeBook(node, scope, fallbackBook);
        if (book) direct = Math.max(direct, this.findRelatedBooks(book).length);
        return Math.max(direct, Number(node.relatedMaterialCount || 0));
    }

    public graphNodeMaterialTitle(node: KnowledgeGraphNode | null, scope: string, fallbackBook: BookItem | null = null): string {
        return this.graphNodeMaterialReference(node, scope, fallbackBook).title;
    }

    public graphNodeMaterialPublisher(node: KnowledgeGraphNode | null, scope: string, fallbackBook: BookItem | null = null): string {
        return this.graphNodeMaterialReference(node, scope, fallbackBook).publisher;
    }

    public graphNodeMaterialYear(node: KnowledgeGraphNode | null, scope: string, fallbackBook: BookItem | null = null): string {
        return this.graphNodeMaterialReference(node, scope, fallbackBook).year;
    }

    public graphNodeMaterialType(node: KnowledgeGraphNode | null, scope: string, fallbackBook: BookItem | null = null): string {
        return this.graphNodeMaterialReference(node, scope, fallbackBook).materialType;
    }

    public graphNodeTagNames(node: KnowledgeGraphNode | null, scope: string, fallbackBook: BookItem | null = null): string[] {
        if (!node) return [];
        let tags = Array.isArray(node.relatedTags) ? node.relatedTags.map((item) => this.text(item)).filter((item) => item) : [];
        if (tags.length) return this.uniqueOptions(tags).slice(0, 8);
        let book = this.graphNodeBook(node, scope, fallbackBook);
        if (book) return this.primaryTags(book).map((tag) => tag.name).slice(0, 8);
        return [];
    }

    public graphNodeRelatedTagsLabel(node: KnowledgeGraphNode | null, scope: string, fallbackBook: BookItem | null = null): string {
        let tags = this.graphNodeTagNames(node, scope, fallbackBook);
        return tags.length ? tags.join(", ") : "해당 없음";
    }

    public graphNodeSourceFieldLabel(node: KnowledgeGraphNode | null, scope: string): string {
        if (!node) return "출처 필드 없음";
        let fields = [this.text(node.sourceField)]
            .concat(this.graphRelationsForNodeScope(node, scope).map((relation) => this.text(relation.sourceField)))
            .filter((field) => field && field !== "해당 없음");
        let unique = this.uniqueOptions(fields).slice(0, 5);
        if (unique.length) return unique.join(", ");

        let graph = this.graphDataForScope(scope);
        let basis = this.categoryDisplayText(this.text(graph?.extractionBasis));
        if (basis) return this.truncate(basis, 80);
        return "출처 필드 없음";
    }

    public graphNodeRelationshipToMaterial(node: KnowledgeGraphNode | null, scope: string, fallbackBook: BookItem | null = null): string {
        if (!node) return "연결 없음";
        let relations = this.graphRelationsForNodeScope(node, scope);
        if (!relations.length) return "연결 없음";

        let graph = this.graphDataForScope(scope);
        let currentMaterialIds = new Set([
            this.text(graph?.materialId),
            this.text(fallbackBook?.id),
            this.text(fallbackBook?.hflibId),
        ].filter((value) => value).map((value) => this.normalizeGraphMaterialId(value)));

        let relation = relations.find((item) => {
            let materialId = this.normalizeGraphMaterialId(item.materialId);
            if (materialId && currentMaterialIds.has(materialId)) return true;
            let sourceNode = this.graphNodeById(graph, item.source);
            let targetNode = this.graphNodeById(graph, item.target);
            let sourceMaterialId = this.normalizeGraphMaterialId(this.graphPrimaryMaterialIdForNode(sourceNode));
            let targetMaterialId = this.normalizeGraphMaterialId(this.graphPrimaryMaterialIdForNode(targetNode));
            return currentMaterialIds.has(sourceMaterialId) || currentMaterialIds.has(targetMaterialId);
        }) || relations[0];

        return `${this.relationTypeLabel(relation)} · ${this.relationSourceTarget(relation)}`;
    }

    public graphNodeConnectedTopics(node: KnowledgeGraphNode | null, scope: string, fallbackBook: BookItem | null = null): string[] {
        if (!node) return [];
        let graph = this.graphDataForScope(scope);
        let topics: string[] = [];
        let addTopic = (label: string, candidateNode: KnowledgeGraphNode | null = null) => {
            label = this.text(label);
            if (!label || label === node.label || topics.includes(label)) return;
            let type = this.normalizeGraphNodeType(this.text(candidateNode?.nodeType || candidateNode?.type || "주제"));
            if (type === "자료" || type === "관련 자료" || type === "근거 후보") return;
            topics.push(label);
        };

        this.graphRelationsForNodeScope(node, scope).forEach((relation) => {
            let sourceNode = this.graphNodeById(graph, relation.source);
            let targetNode = this.graphNodeById(graph, relation.target);
            if (relation.source === node.id || relation.sourceLabel === node.label) addTopic(relation.targetLabel, targetNode);
            if (relation.target === node.id || relation.targetLabel === node.label) addTopic(relation.sourceLabel, sourceNode);
            if (this.isGraphMaterialNode(node)) {
                addTopic(relation.targetLabel, targetNode);
                addTopic(relation.sourceLabel, sourceNode);
            }
        });

        if (!topics.length) {
            let book = this.graphNodeBook(node, scope, fallbackBook);
            if (book) topics = this.primaryTags(book).map((tag) => tag.name).filter((name) => name);
        }
        return this.uniqueOptions(topics).slice(0, 8);
    }

    public graphNodeConnectedTopicLabel(node: KnowledgeGraphNode | null, scope: string, fallbackBook: BookItem | null = null): string {
        let topics = this.graphNodeConnectedTopics(node, scope, fallbackBook);
        return topics.length ? topics.join(", ") : "연결 주제 없음";
    }

    public graphNodeDirectMaterialReferences(node: KnowledgeGraphNode | null, scope: string, fallbackBook: BookItem | null = null): GraphMaterialReference[] {
        if (!node) return [];
        let graph = this.graphDataForScope(scope);
        let result: GraphMaterialReference[] = [];
        let seen = new Set<string>();
        let primaryId = this.normalizeGraphMaterialId(this.graphPrimaryMaterialIdForNode(node));

        let addReference = (materialId: string) => {
            materialId = this.normalizeGraphMaterialId(materialId);
            if (!materialId || seen.has(materialId)) return;
            let reference = this.materialReferenceForId(materialId, graph, fallbackBook);
            if (!reference) return;
            seen.add(materialId);
            result.push(reference);
        };

        if (node.materialId) addReference(node.materialId);
        if (node.relatedMaterialId) addReference(node.relatedMaterialId);
        (node.materialIds || []).forEach((materialId) => addReference(materialId));
        if (this.isGraphMaterialNode(node)) addReference(primaryId || node.id);

        this.graphRelationsForNodeScope(node, scope).forEach((relation) => {
            addReference(relation.materialId);
            let sourceNode = this.graphNodeById(graph, relation.source);
            let targetNode = this.graphNodeById(graph, relation.target);
            [sourceNode, targetNode].forEach((entry) => {
                if (entry && this.isGraphMaterialNode(entry)) addReference(this.graphPrimaryMaterialIdForNode(entry));
            });
        });

        if (this.isGraphMaterialNode(node) && primaryId) {
            result = result.filter((item) => this.normalizeGraphMaterialId(item.id) !== primaryId);
        }
        if (!result.length && fallbackBook && this.isGraphMaterialNode(node)) {
            let reference = this.materialReferenceForBook(fallbackBook);
            if (reference) result.push(reference);
        }
        return result.slice(0, 6);
    }

    public graphNodeEvidenceRelations(node: KnowledgeGraphNode | null, scope: string): KnowledgeGraphRelation[] {
        return this.graphRelationsForNodeScope(node, scope)
            .filter((relation) => this.relationHasSourcePage(relation) || this.text(relation.sentence))
            .sort((a, b) => this.graphRelationScore(b) - this.graphRelationScore(a)
                || this.relationTypeLabel(a).localeCompare(this.relationTypeLabel(b), "ko"))
            .slice(0, 6);
    }

    public relationOriginalLocationLabel(relation: KnowledgeGraphRelation | null): string {
        if (!relation) return "원문 위치 없음";
        if (this.relationHasSourcePage(relation)) return `${this.relationMaterialTitle(relation)} · ${relation.page}쪽 · 문단 ${relation.paragraph || 0}`;
        if (this.canAccessAdminReview() && Number(relation.page || 0) > 0) return `후보 위치 ${relation.page}쪽`;
        return "원문 위치 준비 중";
    }

    public graphNodeMaterialReference(node: KnowledgeGraphNode | null, scope: string, fallbackBook: BookItem | null = null): GraphMaterialReference {
        let graph = this.graphDataForScope(scope);
        let materialId = this.graphPrimaryMaterialIdForNode(node);
        let reference = this.materialReferenceForId(materialId, graph, fallbackBook);
        if (reference) return reference;
        if (fallbackBook && (!node || this.isGraphMaterialNode(node))) return this.materialReferenceForBook(fallbackBook);
        return {
            id: this.text(node?.id),
            title: this.text(node?.label) || "자료명 없음",
            publisher: "발행기관 정보 없음",
            year: "연도 미상",
            materialType: this.nodeTypeLabel(node),
            meta: this.nodeTypeLabel(node),
            book: null,
        };
    }

    public graphNodeOriginalAvailable(node: KnowledgeGraphNode | null, scope: string, fallbackBook: BookItem | null = null): boolean {
        let book = this.graphNodeBook(node, scope, fallbackBook);
        return Boolean(book?.pdfAvailable);
    }

    public graphNodeDetailAvailableForMaterial(node: KnowledgeGraphNode | null, scope: string, fallbackBook: BookItem | null = null): boolean {
        return Boolean(this.graphNodeBook(node, scope, fallbackBook) || this.graphNodeDirectMaterialReferences(node, scope, fallbackBook).length);
    }

    public graphNodeCollectionAvailable(node: KnowledgeGraphNode | null, scope: string, fallbackBook: BookItem | null = null): boolean {
        if (scope === "collection") return Boolean(this.collectionGraph);
        return Boolean(this.graphCollectionIdForNode(node, fallbackBook));
    }

    public async openInspectorNodeOriginal(node: KnowledgeGraphNode | null, scope: string, fallbackBook: BookItem | null = null, event?: Event) {
        this.stopEvent(event);
        let book = this.graphNodeBook(node, scope, fallbackBook);
        if (!book || !book.pdfAvailable) return;
        if (!this.selectedBook || this.selectedBook.id !== book.id) {
            await this.openBook(book);
        }
        if (!this.selectedBook) return;
        await this.scrollToDetailSection("ebook-reader");
        await this.renderActivePdfPage();
    }

    public async openInspectorNodeDetail(node: KnowledgeGraphNode | null, scope: string, fallbackBook: BookItem | null = null, event?: Event) {
        this.stopEvent(event);
        let book = this.graphNodeBook(node, scope, fallbackBook);
        if (book) {
            await this.openBook(book);
            return;
        }
        if (scope === "collection") await this.openCollectionNodeMaterial(node);
        else await this.openGraphNodeMaterial(node);
    }

    public async openInspectorNodeCollection(node: KnowledgeGraphNode | null, scope: string, fallbackBook: BookItem | null = null, event?: Event) {
        this.stopEvent(event);
        if (scope === "collection") {
            this.scrollToCollectionGraph();
            return;
        }
        let collectionId = this.graphCollectionIdForNode(node, fallbackBook);
        if (collectionId) {
            await this.openCollectionGraphById(collectionId);
        }
    }

    public async openInspectorRelationPage(relation: KnowledgeGraphRelation | null, scope: string, event?: Event) {
        this.stopEvent(event);
        if (!relation || !this.relationHasSourcePage(relation)) return;
        if (scope === "collection") await this.openCollectionRelationPage(relation);
        else await this.openGraphRelationPage(relation);
    }

    public async openInspectorRelationMaterials(relation: KnowledgeGraphRelation | null, scope: string, event?: Event) {
        this.stopEvent(event);
        if (!relation) return;
        if (scope === "collection") {
            await this.openCollectionMaterial(this.findBookByMaterialId(relation.materialId));
            return;
        }
        await this.openGraphRelationMaterial(relation);
    }

    private graphNodeBook(node: KnowledgeGraphNode | null, scope: string, fallbackBook: BookItem | null = null): BookItem | null {
        let graph = this.graphDataForScope(scope);
        let materialId = this.graphPrimaryMaterialIdForNode(node);
        if (!materialId) return fallbackBook && this.isGraphMaterialNode(node) ? fallbackBook : null;
        let reference = this.materialReferenceForId(materialId, graph, fallbackBook);
        if (reference?.book) return reference.book;
        if (fallbackBook && this.isGraphMaterialNode(node)) return fallbackBook;
        return null;
    }

    private graphDataForScope(scope: string): KnowledgeGraphData | null {
        return scope === "collection" ? this.collectionGraph : this.knowledgeGraph;
    }

    private graphRelationsForNodeScope(node: KnowledgeGraphNode | null, scope: string): KnowledgeGraphRelation[] {
        return scope === "collection" ? this.collectionAllRelationsForNode(node) : this.graphAllRelationsForNode(node);
    }

    private graphNodeById(graph: KnowledgeGraphData | null, nodeId: string): KnowledgeGraphNode | null {
        nodeId = this.text(nodeId);
        if (!graph || !nodeId) return null;
        return graph.nodes.find((node) => node.id === nodeId) || null;
    }

    private graphPrimaryMaterialIdForNode(node: KnowledgeGraphNode | null): string {
        if (!node) return "";
        let id = this.text(node.materialId || node.relatedMaterialId);
        if (!id && this.isGraphMaterialNode(node)) id = this.text(node.id);
        return this.normalizeGraphMaterialId(id);
    }

    private normalizeGraphMaterialId(materialId: string): string {
        return this.text(materialId).replace(/^material:/, "");
    }

    private materialReferenceForId(materialId: string, graph: KnowledgeGraphData | null, fallbackBook: BookItem | null = null): GraphMaterialReference | null {
        materialId = this.normalizeGraphMaterialId(materialId);
        if (!materialId) return fallbackBook ? this.materialReferenceForBook(fallbackBook) : null;

        let book = this.findBookByMaterialId(materialId);
        if (!book && fallbackBook && (materialId === fallbackBook.id || materialId === fallbackBook.hflibId)) book = fallbackBook;
        if (book) return this.materialReferenceForBook(book);

        let material = graph?.materials?.find((item) => item.id === materialId || item.hflibId === materialId);
        if (material) {
            let year = material.publishedYear ? String(material.publishedYear) : (this.numberYear(material.publishedDate) ? String(this.numberYear(material.publishedDate)) : "연도 미상");
            let publisher = this.text(material.publisher) || "발행기관 정보 없음";
            let type = "관련 자료";
            return {
                id: material.id,
                title: material.title,
                publisher: publisher,
                year: year,
                materialType: type,
                meta: `${publisher} · ${year} · ${type}`,
                book: null,
            };
        }

        return {
            id: materialId,
            title: materialId,
            publisher: "발행기관 정보 없음",
            year: "연도 미상",
            materialType: "자료",
            meta: "자료 상세 정보 없음",
            book: null,
        };
    }

    private materialReferenceForBook(book: BookItem): GraphMaterialReference {
        let publisher = this.text(book.publisher) || "발행기관 정보 없음";
        let year = this.publishedYearLabel(book);
        let type = this.materialNature(book);
        return {
            id: book.id || book.hflibId,
            title: book.title,
            publisher: publisher,
            year: year,
            materialType: type,
            meta: `${publisher} · ${year} · ${type}`,
            book: book,
        };
    }

    private graphCollectionIdForNode(node: KnowledgeGraphNode | null, fallbackBook: BookItem | null = null): string {
        if (fallbackBook) {
            let collectionId = this.collectionIdForBook(fallbackBook);
            if (collectionId) return collectionId;
        }
        let candidates = [
            this.text(node?.label),
            this.text(node?.detail),
            ...((node?.relatedTags || []).map((tag) => this.text(tag))),
        ].filter((item) => item);
        for (let candidate of candidates) {
            let collectionId = this.collectionIdForTag(candidate);
            if (collectionId) return collectionId;
        }
        return "";
    }

    public showSearchCollectionPanel(): boolean {
        if (this.activeTopTab === "search" && !["all", "collections"].includes(this.activeSearchResultTab)) return false;
        return this.hasActiveSearchContext()
            && (this.searchRelatedCollections.length > 0 || this.searchResultGroups.length > 0);
    }

    public hasActiveSearchContext(): boolean {
        let keys = [
            "search",
            "author",
            "businessAxis",
            "issueAxis",
            "eraAxis",
            "regionAxis",
            "relationshipAxis",
            "materialNature",
            "creatorAxis",
            "perspectiveAxis",
            "workPurpose",
            "reviewStateAxis",
            "collectionId",
            "year",
            "pdfState",
            "bodyExtractionStatus",
            "tagReviewStatus",
            "publicStatus",
        ];
        return Boolean(this.activeResultGroupId || keys.some((key) => this.text(this.filters[key])));
    }

    public collectionFilterLabel(): string {
        let collectionId = this.text(this.filters.collectionId);
        if (!collectionId) return "";
        let collection = this.collections.find((item) => item.id === collectionId);
        return collection?.title || collectionId;
    }

    public activeSearchContextLabel(): string {
        let values = [
            this.filters.search,
            this.filters.issueAxis,
            this.filters.regionAxis,
            this.filters.businessAxis,
            this.filters.relationshipAxis,
            this.filters.materialNature,
            this.filters.creatorAxis,
            this.filters.perspectiveAxis,
            this.filters.reviewStateAxis,
            this.collectionFilterLabel(),
            this.filters.author,
            this.filters.year,
        ].map((value) => this.text(value)).filter((value) => value);
        if (this.activeResultGroupId) {
            let group = this.searchResultGroups.find((item) => item.id === this.activeResultGroupId);
            if (group) values.unshift(group.label);
        }
        return values.length ? values[0] : "전체 자료";
    }

    public searchExpansionNotice(): string {
        if (!this.text(this.filters.search) || !this.searchAliasExpansions.length) return "";
        let tags = this.uniqueOptions(this.searchAliasExpansions.map((item) => item.canonicalTag).filter((value) => value));
        if (!tags.length) return "";
        if (tags.length === 1) return `${tags[0]} 관련 검색어도 함께 찾았습니다.`;
        return `${tags.slice(0, 3).join(", ")} 관련 검색어도 함께 찾았습니다.`;
    }

    public searchExpansionDetail(): string {
        let aliases = this.uniqueOptions(
            this.searchAliasExpansions
                .flatMap((item) => [item.matchedAlias].concat(item.aliases || []))
                .map((value) => this.text(value))
                .filter((value) => value && value.toLocaleLowerCase() !== this.text(this.filters.search).toLocaleLowerCase())
        );
        if (!aliases.length) return "대표 태그는 결과와 필터에 사용하고, 별칭은 검색 확장에만 사용합니다.";
        return `함께 확장한 별칭: ${aliases.slice(0, 6).join(", ")}`;
    }

    public activeFilterChips(): ActiveFilterChip[] {
        let chips: ActiveFilterChip[] = [];
        let add = (key: string, label: string, value: string) => {
            value = this.text(value);
            if (value) chips.push({ key, label, value });
        };

        if (this.activeResultGroupId) {
            let group = this.searchResultGroups.find((item) => item.id === this.activeResultGroupId);
            if (group) add("resultGroup", "결과 묶음", group.label);
        }
        add("search", "검색어", this.filters.search);
        add("author", "저자·기관", this.filters.author);
        add("businessAxis", "공식 사업", this.filters.businessAxis);
        add("issueAxis", "역사현안", this.filters.issueAxis);
        add("eraAxis", "시대", this.filters.eraAxis);
        add("regionAxis", "지역·공간", this.filters.regionAxis);
        add("relationshipAxis", "관계사·국제질서", this.filters.relationshipAxis);
        add("materialNature", "자료 성격", this.filters.materialNature);
        add("collectionId", "주제 컬렉션", this.collectionFilterLabel());
        add("creatorAxis", "발행·저술 주체", this.filters.creatorAxis);
        add("perspectiveAxis", "출처·관점", this.filters.perspectiveAxis);
        add("workPurpose", "업무 목적", this.filters.workPurpose);
        add("reviewStateAxis", "검수·공개 상태", this.filters.reviewStateAxis);
        add("year", "출간연도", this.filters.year);
        add("pdfState", "원문 보유", this.pdfFilterLabel(this.filters.pdfState));
        add("bodyExtractionStatus", "본문 색인", this.filters.bodyExtractionStatus);
        add("tagReviewStatus", "태그 검수", this.filters.tagReviewStatus);
        add("publicStatus", "공개 상태", this.filters.publicStatus);
        return chips;
    }

    public pdfFilterLabel(value: string): string {
        if (value === "with-pdf") return "원문 있음";
        if (value === "without-pdf") return "원문 없음";
        return "";
    }

    public async clearFilterChip(key: string, event?: Event) {
        this.stopEvent(event);
        key = this.text(key);
        if (key === "resultGroup") {
            this.activeResultGroupId = "";
        } else if (this.filters.hasOwnProperty(key)) {
            this.filters[key] = "";
            if (key === "collectionId") this.selectedCollectionId = "";
            if (key === "author") {
                this.authorDropdownOpen = false;
                this.authorActiveIndex = -1;
                this.updateAuthorSuggestions();
            }
        }
        await this.applyFilters();
    }

    public async clearSearchFilters(event?: Event) {
        this.stopEvent(event);
        await this.resetFilters();
        this.scrollToList();
    }

    public async viewAllMaterials(event?: Event) {
        this.stopEvent(event);
        this.activeTopTab = "books";
        this.syncMainUrl("push");
        await this.resetFilters();
        this.scrollToList();
    }

    public primaryResultBook(): BookItem | null {
        return this.visibleBooks[0] || null;
    }

    public resultActionContextLabel(): string {
        let book = this.primaryResultBook();
        if (!book) return "검색 결과 없음";
        return `첫 번째 결과: ${this.truncate(book.title, 44)}`;
    }

    public resultOriginalUnavailableReason(book: BookItem): string {
        if (!book?.pdfAvailable) return "연결된 원문이 없습니다.";
        if (!this.canAccessBookOriginals(book)) return this.originalAccessDeniedLabel(book);
        return "";
    }

    public resultBodySearchUnavailableReason(book: BookItem): string {
        if (!book?.bodySearchAvailable) return "본문 검색 색인이 아직 준비되지 않았습니다.";
        if (!this.canAccessBookOriginals(book)) return this.originalAccessDeniedLabel(book);
        return "";
    }

    public canUseResultOriginal(book: BookItem): boolean {
        return Boolean(book?.pdfAvailable && this.canAccessBookOriginals(book));
    }

    public canUseResultBodySearch(book: BookItem): boolean {
        return Boolean(book?.bodySearchAvailable && this.canAccessBookOriginals(book));
    }

    public canUseBookKnowledgeGraph(book: BookItem): boolean {
        return Boolean(book && this.canAccessKnowledgeGraph() && book.graphAvailable);
    }

    public canUseRelatedGraphEntry(book: BookItem): boolean {
        return Boolean(book && this.canAccessKnowledgeGraph() && (book.graphAvailable || this.collectionIdForBook(book)));
    }

    public graphEntryTitle(book: BookItem): string {
        if (book?.graphAvailable) return "이 자료 관계도 보기";
        if (this.collectionIdForBook(book)) return "연관 주제 자료 관계도 보기";
        return "자료 관계도 준비 중";
    }

    public graphEntryDescription(book: BookItem): string {
        if (book?.graphAvailable) return "자료에 나오는 인물·장소·사건·개념의 연결과 근거 상태를 확인합니다.";
        if (this.collectionIdForBook(book)) return "이 자료가 속한 역사현안 주제에서 관련 자료와 연결 상태를 확인합니다.";
        return "이 자료는 아직 단일 자료 그래프 산출 대상이 아닙니다.";
    }

    public canUseResultGraph(book: BookItem): boolean {
        return this.canUseRelatedGraphEntry(book);
    }

    public canUseResultAi(book: BookItem): boolean {
        return Boolean(book && this.canAccessResearchAi());
    }

    public async openResultDetail(book: BookItem, event?: Event) {
        await this.openBook(book, event, true);
    }

    public async openResultOriginal(book: BookItem, event?: Event) {
        this.stopEvent(event);
        await this.openBook(book, undefined, true);
        if (this.canUseResultOriginal(book)) {
            await this.scrollToDetailSection("ebook-reader");
            await this.renderActivePdfPage();
        }
    }

    public async openResultBodySearch(book: BookItem, event?: Event) {
        this.stopEvent(event);
        await this.openBook(book, undefined, true);
        if (this.canUseResultBodySearch(book)) await this.scrollToDetailSection("body-search");
    }

    public async openResultRelatedMaterials(book: BookItem, event?: Event) {
        this.stopEvent(event);
        await this.openBook(book, undefined, true);
        await this.scrollToDetailSection("related-materials");
    }

    public async openResultGraph(book: BookItem, event?: Event) {
        this.stopEvent(event);
        let collectionId = this.collectionIdForBook(book);
        if (collectionId) {
            this.graphTargetBookId = this.text(book.id || book.hflibId);
            await this.openCollectionGraphById(collectionId);
            return;
        }
        if (book?.graphAvailable) {
            await this.openBook(book, undefined, true);
            await this.openBookKnowledgeGraph(book);
            return;
        }
        await this.openBook(book, undefined, true);
        await this.openBookKnowledgeGraph(book);
    }

    public async openResultAi(book: BookItem, event?: Event) {
        this.stopEvent(event);
        if (!this.canUseResultAi(book)) return;
        await this.openBook(book, undefined, true);
        this.aiScopeType = "selected";
        this.aiTargetBookId = book.id || book.hflibId;
        if (!this.aiQuestion) {
            this.aiQuestion = `${book.title}의 핵심 내용을 확인할 수 있는 근거 쪽수를 찾아줘`;
        }
        await this.scrollToDetailSection("ai-workbench");
    }

    public suggestedSearchTerms(): string[] {
        let active = new Set(this.activeFilterChips().map((chip) => this.text(chip.value).toLocaleLowerCase()));
        if (this.integratedSearchSuggestions.length) {
            return this.integratedSearchSuggestions
                .filter((item) => item && !active.has(item.toLocaleLowerCase()))
                .slice(0, 8);
        }
        let candidates = this.uniqueOptions([
            ...this.landingSearchTags,
            ...this.issueAxisOptions,
            ...this.regionAxisOptions,
            ...this.relationshipAxisOptions,
            ...this.materialNatureOptions,
        ]);
        return candidates
            .filter((item) => item && !active.has(item.toLocaleLowerCase()))
            .slice(0, 8);
    }

    public nearbyTopicTerms(): string[] {
        if (this.integratedNearbyTopics.length) {
            let active = new Set(this.activeFilterChips().map((chip) => this.text(chip.value).toLocaleLowerCase()));
            return this.integratedNearbyTopics
                .filter((item) => item && !active.has(item.toLocaleLowerCase()))
                .slice(0, 8);
        }
        let activeValues = this.activeFilterChips().map((chip) => chip.value);
        let active = new Set(activeValues.map((value) => value.toLocaleLowerCase()));
        let query = activeValues.join(" ").toLocaleLowerCase();
        let counts: any = {};

        this.books.forEach((book) => {
            this.primaryTags(book).forEach((tag) => {
                if (!tag.name || active.has(tag.name.toLocaleLowerCase())) return;
                counts[tag.name] = (counts[tag.name] || 0) + 1;
            });
        });
        this.collections.forEach((collection) => {
            if (!collection.title || active.has(collection.title.toLocaleLowerCase())) return;
            counts[collection.title] = Math.max(counts[collection.title] || 0, collection.materialCount || 0);
        });

        return Object.keys(counts)
            .sort((a, b) => {
                let aKey = a.toLocaleLowerCase();
                let bKey = b.toLocaleLowerCase();
                let aBoost = query && (query.includes(aKey) || aKey.includes(query)) ? 1000 : 0;
                let bBoost = query && (query.includes(bKey) || bKey.includes(query)) ? 1000 : 0;
                return (counts[b] + bBoost) - (counts[a] + aBoost) || a.localeCompare(b, "ko");
            })
            .slice(0, 8);
    }

    public async applyResultGroup(group: SearchResultGroup, event?: Event) {
        this.stopEvent(event);
        if (!group) return;
        if (group.count <= 0) {
            if (!group.query) return;
            this.activeResultGroupId = "";
            this.filters.search = group.query;
            this.filters.collectionId = "";
            this.selectedCollectionId = "";
            this.activeTopTab = "search";
            await this.applyFilters();
            this.scrollToList();
            return;
        }
        this.activeResultGroupId = this.activeResultGroupId === group.id ? "" : group.id;
        await this.applyFilters();
        this.scrollToList();
    }

    public async clearResultGroup(event?: Event) {
        this.stopEvent(event);
        this.activeResultGroupId = "";
        await this.applyFilters();
    }

    public async openSearchCollection(collection: SearchCollectionCard, event?: Event) {
        await this.openCollectionGraphById(this.text(collection?.id), event);
    }

    public isResultGroupActive(group: SearchResultGroup): boolean {
        return Boolean(group && this.activeResultGroupId === group.id);
    }

    private buildRelatedCollectionCards(rows: BookItem[]): SearchCollectionCard[] {
        let counts: any = {};
        rows.forEach((book) => {
            let collectionId = this.collectionIdForBook(book);
            if (!collectionId) return;
            counts[collectionId] = (counts[collectionId] || 0) + 1;
        });

        let activeLabel = this.activeSearchContextLabel();
        let activeCollectionId = this.collectionIdForTag(activeLabel);
        if (activeCollectionId && counts[activeCollectionId] === undefined) counts[activeCollectionId] = 0;

        return this.collections
            .filter((collection) => counts[collection.id] !== undefined)
            .map((collection) => ({
                id: collection.id,
                title: collection.title,
                description: collection.description,
                materialCount: collection.materialCount,
                pdfCount: collection.pdfCount,
                bodyIndexedCount: collection.bodyIndexedCount,
                matchCount: Number(counts[collection.id] || 0),
            }))
            .sort((a, b) => b.matchCount - a.matchCount || b.materialCount - a.materialCount || a.title.localeCompare(b.title, "ko"))
            .slice(0, 6);
    }

    private buildSearchResultGroups(rows: BookItem[]): SearchResultGroup[] {
        let query = this.activeSearchContextLabel();
        let topicGroups = this.topicGroupDefinitions(query);
        if (topicGroups.length) {
            return topicGroups.map((definition) => {
                let bookIds = definition.allRows
                    ? rows.map((book) => this.bookKey(book))
                    : this.groupBookIds(rows, definition.terms || [], definition.requiredTerms || []);
                return {
                    id: definition.id,
                    label: definition.label,
                    category: definition.category,
                    description: definition.description || this.searchGroupDescription(definition.category, definition.terms || []),
                    count: bookIds.length,
                    bookIds: bookIds,
                    collectionId: definition.collectionId,
                    query: definition.query || (definition.terms || [definition.label])[0],
                };
            });
        }
        return this.categoryGroupsForRows(rows);
    }

    private topicGroupDefinitions(query: string): any[] {
        let expansionContext = this.searchAliasExpansions
            .flatMap((item) => [item.canonicalTag, item.matchedAlias].concat(item.aliases || []))
            .map((item) => this.text(item))
            .filter((item) => item)
            .join(" ");
        let value = `${this.text(query)} ${expansionContext}`.toLocaleLowerCase();
        let hasAny = (words: string[]) => words.some((word) => value.includes(word.toLocaleLowerCase()));

        if (hasAny(["독도", "동해", "울릉", "영유권", "국제법"])) {
            return [
                {
                    id: "dokdo-all",
                    label: "전체 독도 자료",
                    category: "역사현안",
                    collectionId: "dokdo",
                    allRows: true,
                    query: "독도",
                    terms: ["독도", "우산도", "석도", "Takeshima", "Liancourt Rocks"],
                    description: "독도 대표어·별칭과 관련 근거로 찾은 자료 전체",
                },
                {
                    id: "dokdo-korea",
                    label: "한국 측 독도 자료",
                    category: "출처·관점",
                    collectionId: "dokdo",
                    query: "독도연구소",
                    terms: ["한국 측 자료", "동북아역사재단", "독도연구소", "국내 기관", "국내 연구자", "한국", "대한민국"],
                    description: "한국 기관·연구자와 재단 자료를 중심으로 다시 보기",
                },
                {
                    id: "dokdo-japan-rebuttal",
                    label: "일본 측 주장/반박 관련 자료",
                    category: "출처·관점",
                    collectionId: "dokdo",
                    query: "Takeshima",
                    terms: ["일본 측 자료", "일본 연구자·기관", "일본 외무성", "일본 정부", "일본 자료", "Takeshima", "竹島", "반박 근거 자료", "쟁점 대응", "역사왜곡", "오류", "무주지", "편입"],
                    description: "일본 측 주장과 그에 대한 반박 근거를 함께 확인",
                },
                {
                    id: "dokdo-law",
                    label: "국제법 관련 자료",
                    category: "관계사·국제질서",
                    collectionId: "dokdo",
                    query: "국제법",
                    terms: ["국제법", "해양법", "해양법·국제법", "SCAPIN 677", "평화선", "EEZ", "조약·협정", "영토 분쟁"],
                    description: "국제법·해양법·조약 근거가 연결된 자료",
                },
                {
                    id: "dokdo-ulleung-east-sea",
                    label: "울릉도·동해 관련 자료",
                    category: "지역·공간",
                    collectionId: "dokdo",
                    query: "울릉도",
                    terms: ["울릉도", "울릉", "울도군", "수토제", "동해", "동해 표기", "East Sea", "Sea of Japan", "일본해"],
                    description: "울릉도 관리, 동해 표기, 주변 해역 맥락으로 보기",
                },
                {
                    id: "dokdo-shimane-1905",
                    label: "1905년 시마네현 고시 관련 자료",
                    category: "역사현안",
                    collectionId: "dokdo",
                    query: "시마네현",
                    terms: ["1905년 독도 침탈", "1905년", "시마네현 고시 제40호", "시마네현 고시", "시마네현", "Shimane", "고시 제40호", "독도 침탈", "대한제국"],
                    description: "1905년 편입 고시와 독도 침탈 쟁점을 중심으로 보기",
                },
                {
                    id: "dokdo-education-promotion",
                    label: "교육·홍보 자료",
                    category: "자료 성격",
                    collectionId: "dokdo",
                    query: "교사용",
                    terms: ["교육자료", "교육자료 제작", "역사인식 교육·홍보", "대외 홍보", "교사용", "학생용", "학습지", "바로 알기", "홍보", "체험관", "대중해설서"],
                    description: "교사용·학생용·대외 설명 자료를 중심으로 보기",
                },
            ];
        }

        if (hasAny(["발해", "balhae", "parhae", "渤海"])) {
            return [
                {
                    id: "balhae-all",
                    label: "전체 발해 자료",
                    category: "역사현안",
                    collectionId: "balhae",
                    allRows: true,
                    query: "발해",
                    terms: ["발해", "발해사", "Balhae", "Parhae", "渤海"],
                    description: "발해 대표어·별칭과 관련 근거로 찾은 자료 전체",
                },
                {
                    id: "balhae-study",
                    label: "발해사 연구",
                    category: "역사현안",
                    collectionId: "balhae",
                    query: "발해사",
                    terms: ["발해사", "발해", "연구총서", "한국 고중세사 연구", "고대사", "북방사"],
                    description: "발해 정치·사회·문화·대외관계 연구 자료",
                },
                {
                    id: "balhae-goguryeo-legacy",
                    label: "고구려 계승 관련 자료",
                    category: "역사현안",
                    collectionId: "balhae",
                    query: "고구려",
                    terms: ["고구려 계승", "고구려", "고구려사", "고구려발해", "남북국시대", "대조영", "계승"],
                    description: "고구려와 발해의 역사적 연계를 다룬 자료",
                },
                {
                    id: "balhae-northeast-project",
                    label: "중국 동북공정 관련 자료",
                    category: "역사현안",
                    collectionId: "northeast-project",
                    query: "동북공정",
                    terms: ["동북공정", "중국 동북공정", "중국 역사왜곡", "중국 역사", "중국사 인식", "한중관계사 연구", "중국 동북지역", "한중관계"],
                    description: "중국 동북공정과 발해사 서술 쟁점을 함께 확인",
                },
                {
                    id: "balhae-archaeology",
                    label: "유적·고고학 자료",
                    category: "자료 성격",
                    collectionId: "balhae",
                    query: "크라스키노",
                    terms: ["발해 유적·고고학", "크라스키노", "발해성", "발굴조사", "발굴조사보고서", "유적", "고고학", "연해주", "회령"],
                    description: "발해 유적, 발굴조사, 고고자료를 중심으로 보기",
                },
                {
                    id: "balhae-education",
                    label: "교육 자료",
                    category: "자료 성격",
                    collectionId: "balhae",
                    query: "교육자료",
                    terms: ["교육자료", "교육자료 제작", "역사인식 교육·홍보", "교사용", "학생용", "학습", "바로 알기", "대중해설서"],
                    description: "발해사를 교육·대중 설명에 활용할 수 있는 자료",
                },
            ];
        }

        if (hasAny(["한일회담", "청구권", "한일협정", "평화선"])) {
            return [
                { id: "talks-documents", label: "한일회담 외교문서", category: "자료 성격", collectionId: "korea-japan-talks", terms: ["한일회담", "외교문서", "청구권", "교섭"] },
                { id: "talks-treaty", label: "조약·협정 관련 자료", category: "관계사·국제질서", collectionId: "korea-japan-talks", terms: ["한일협정", "조약·협정", "청구권", "외교 교섭"] },
                { id: "talks-postwar", label: "전후 처리·청구권 자료", category: "관계사·국제질서", collectionId: "korea-japan-talks", terms: ["전후 처리", "청구권", "전후보상"] },
                { id: "talks-source", label: "한국·일본 측 자료 비교", category: "출처·관점", collectionId: "korea-japan-talks", terms: ["한국 측 자료", "일본 측 자료", "비교 검토 자료"] },
            ];
        }

        if (hasAny(["일제침탈", "일제", "식민지", "조선총독부", "강제동원"])) {
            return [
                { id: "intrusion-policy", label: "식민지 지배·정책 자료", category: "관계사·국제질서", collectionId: "japanese-intrusion", terms: ["식민지 지배", "식민지 정책", "조선총독부", "통감부"] },
                { id: "intrusion-mobilization", label: "강제동원·전시동원 자료", category: "역사현안", collectionId: "japanese-intrusion", terms: ["강제동원", "전시동원", "총동원", "징용"] },
                { id: "intrusion-source", label: "사료·외교문서 자료", category: "자료 성격", collectionId: "japanese-intrusion", terms: ["사료집", "자료총서", "외교문서", "원사료"] },
                { id: "intrusion-rebuttal", label: "반박 근거·역사왜곡 대응 자료", category: "출처·관점", collectionId: "japanese-intrusion", terms: ["반박 근거 자료", "역사왜곡", "오류", "대응"] },
            ];
        }

        return [];
    }

    private categoryGroupsForRows(rows: BookItem[]): SearchResultGroup[] {
        let axes = [
            TAG_AXES.business,
            TAG_AXES.issue,
            TAG_AXES.era,
            TAG_AXES.region,
            TAG_AXES.relation,
            TAG_AXES.material,
            TAG_AXES.creator,
            TAG_AXES.perspective,
            TAG_AXES.state,
        ];
        let groups: SearchResultGroup[] = [];
        axes.forEach((axis) => {
            let counts: any = {};
            let idsByName: any = {};
            rows.forEach((book) => {
                this.axisTagNames(book, axis).forEach((name) => {
                    counts[name] = (counts[name] || 0) + 1;
                    if (!idsByName[name]) idsByName[name] = [];
                    idsByName[name].push(this.bookKey(book));
                });
            });
            Object.keys(counts)
                .sort((a, b) => counts[b] - counts[a] || a.localeCompare(b, "ko"))
                .slice(0, 2)
                .forEach((name) => {
                    groups.push({
                        id: `${axis}:${name}`,
                        label: name,
                        category: this.axisDisplayName(axis),
                        description: `${this.axisDisplayName(axis)} 기준으로 묶은 검색 결과`,
                        count: counts[name],
                        bookIds: Array.from(new Set(idsByName[name] || [])),
                        collectionId: this.collectionIdForTag(name),
                        query: name,
                    });
                });
        });
        return groups.sort((a, b) => b.count - a.count || a.category.localeCompare(b.category, "ko")).slice(0, 12);
    }

    private groupBookIds(rows: BookItem[], terms: string[], requiredTerms: string[] = []): string[] {
        let result = rows.filter((book) => {
            let corpus = this.bookCorpus(book);
            let termMatch = !terms.length || terms.some((term) => corpus.includes(this.text(term).toLocaleLowerCase()));
            let requiredMatch = requiredTerms.every((term) => corpus.includes(this.text(term).toLocaleLowerCase()));
            return termMatch && requiredMatch;
        }).map((book) => this.bookKey(book));
        return Array.from(new Set(result));
    }

    private bookCorpus(book: BookItem): string {
        return [
            book.id,
            book.hflibId,
            book.title,
            book.titleStatement,
            book.author,
            book.compiler,
            book.editor,
            book.publisher,
            book.publishedDate,
            book.publishedYear,
            book.kdc,
            book.callNo,
            book.classification,
            book.category,
            book.bibliographicType,
            book.materialType,
            book.seriesTitle,
            book.marcSubject,
            book.subjectName,
            book.description,
            book.aiSummary,
            book.tags.map((tag) => `${tag.name} ${this.axisDisplayName(tag.axis)} ${tag.axis} ${tag.matchedAlias || ""}`).join(" "),
            book.tagAliases.map((item) => `${item.tagName} ${item.alias}`).join(" "),
            book.statusTags.map((tag) => tag.name).join(" "),
            book.toc.map((toc) => toc.label).join(" "),
            book.pdfs.map((pdf) => pdf.filename).join(" "),
            this.searchMatchesForBook(book).map((match) => `${match.label} ${match.field} ${match.value} ${match.snippet} ${match.relatedTopic || ""}`).join(" "),
        ].join(" ").toLocaleLowerCase();
    }

    private searchGroupDescription(category: string, terms: string[]): string {
        return terms.length
            ? `${category} 기준: ${terms.slice(0, 3).join(", ")}`
            : `${category} 기준으로 묶은 검색 결과`;
    }

    private bookKey(book: BookItem): string {
        return this.text(book.id || book.hflibId || book.title);
    }

    public axisOptions(axis: string): string[] {
        return this.uniqueOptions(this.books.flatMap((book) => this.axisTagNames(book, axis)));
    }

    public axisTagNames(book: BookItem, axis: string): string[] {
        if (axis === TAG_AXES.state) {
            return this.uniqueOptions(book.statusTags.map((tag) => tag.name));
        }
        return this.uniqueOptions(book.tags.filter((tag) => tag.axis === axis).map((tag) => tag.name));
    }

    public hasAxisTag(book: BookItem, axis: string, name: string): boolean {
        if (axis === TAG_AXES.state) return this.hasStatusTag(book, name);
        return book.tags.some((tag) => tag.axis === axis && tag.name === name);
    }

    public hasStatusTag(book: BookItem, name: string): boolean {
        return book.statusTags.some((tag) => tag.name === name);
    }

    public tagsByAxis(book: BookItem, axis: string): TagItem[] {
        if (axis === TAG_AXES.state) return book.statusTags;
        return book.tags.filter((tag) => tag.axis === axis);
    }

    public aliasesForTag(book: BookItem, tag: TagItem): TagAliasItem[] {
        return book.tagAliases.filter((item) => item.axis === tag.axis && item.tagName === tag.name).slice(0, 3);
    }

    public aliasSummary(book: BookItem, tag: TagItem): string {
        let aliases = this.aliasesForTag(book, tag).map((item) => item.alias);
        return aliases.length ? `별칭 ${aliases.join(", ")}` : "";
    }

    public tagAliasPreview(book: BookItem): TagAliasItem[] {
        return book.tagAliases.slice(0, 16);
    }

    public materialNature(book: BookItem): string {
        let tagged = this.axisTagNames(book, TAG_AXES.material)[0];
        return tagged || this.text(book.materialType) || this.text(book.category) || "자료 성격 미분류";
    }

    public matchesMaterialNature(book: BookItem, value: string): boolean {
        return this.materialNature(book) === value || this.hasAxisTag(book, TAG_AXES.material, value);
    }

    public primaryTags(book: BookItem): TagItem[] {
        let ordered = [
            ...book.tags.filter((tag) => tag.axis === TAG_AXES.issue),
            ...book.tags.filter((tag) => tag.axis === TAG_AXES.business),
            ...book.tags.filter((tag) => tag.axis === TAG_AXES.era),
            ...book.tags.filter((tag) => tag.axis === TAG_AXES.region),
            ...book.tags.filter((tag) => tag.axis === TAG_AXES.relation),
            ...book.tags.filter((tag) => tag.axis === TAG_AXES.material),
            ...book.tags.filter((tag) => tag.axis === TAG_AXES.perspective),
            ...book.tags.filter((tag) => tag.axis === TAG_AXES.creator),
            ...book.tags.filter((tag) => tag.axis === TAG_AXES.purpose),
            ...book.tags,
        ];
        return this.dedupeTags(ordered).slice(0, 4);
    }

    public listCardTags(book: BookItem): TagItem[] {
        let visible = this.dedupeTags([
            ...this.primaryTags(book),
            ...book.tags,
        ]).filter((tag) => tag.axis !== TAG_AXES.material && !this.isStateTag(tag));
        return visible.slice(0, 4);
    }

    public dedupeTags(tags: TagItem[]): TagItem[] {
        let seen: any = {};
        return tags.filter((tag) => {
            let key = `${tag?.axis || ""}|${tag?.name || ""}`;
            if (!tag || !tag.name || seen[key]) return false;
            seen[key] = true;
            return true;
        });
    }

    public reviewStatusOfTag(tag: TagItem): string {
        return this.text(tag.reviewStatus) || (tag.status === "자동추천" ? "검수대기" : this.text(tag.status) || "검수대기");
    }

    public publicStatusOfTag(tag: TagItem): string {
        return this.text(tag.publicStatus) || "내부전용";
    }

    public publicTagList(book: BookItem): TagItem[] {
        if (book.publicTags.length) return book.publicTags;
        return book.tags.filter((tag) => this.reviewStatusOfTag(tag) === "검수완료" && this.publicStatusOfTag(tag) === "공개가능").slice(0, 8);
    }

    public isReviewStepActive(book: BookItem, state: string): boolean {
        if (state === "자동추천") return book.tagReviewSummary.recommendedCount > 0;
        if (state === "검수대기") return book.tagReviewSummary.pendingCount > 0;
        if (state === "검수완료") return book.tagReviewSummary.approvedCount > 0;
        if (state === "반려") return book.tagReviewSummary.rejectedCount > 0;
        if (state === "공개가능") return book.tagReviewSummary.publicReadyCount > 0;
        if (state === "내부전용") return book.tagReviewSummary.internalOnlyCount > 0;
        return false;
    }

    public publishedYearLabel(book: BookItem): string {
        return this.yearOf(book) || "연도 미상";
    }

    public pdfStatusLabel(book: BookItem): string {
        if (!book.pdfAvailable) return "PDF 미확보";
        if (book.pdfPageCount > 0) return `PDF ${book.pdfCount}개 · ${book.pdfPageCount}쪽`;
        return `PDF ${book.pdfCount}개 확보`;
    }

    public pdfAcquisitionLabel(book: BookItem): string {
        if (book.pdfAvailable) return "PDF 확보";
        if (book.sourceUrl) return "원본 링크만 확보";
        return "PDF 미확보";
    }

    public originalAccessLabel(book: BookItem): string {
        if (book.pdfAvailable) return "원문 열람 가능";
        if (book.sourceUrl) return "외부 원본 링크 있음";
        return "원문 열람 불가";
    }

    public bodyExtractionStatus(book: BookItem): string {
        let textStatus = `${book.textIndexStatus} ${book.bodySearchStatus}`.toLocaleLowerCase();
        if (book.bodySearchAvailable || textStatus.includes("완료")) return "본문 추출 완료";
        if (book.ocrStatus.includes("OCR필요") || book.ocrStatus.includes("OCR 필요")) return "OCR 필요";
        return "본문 추출 대기";
    }

    public ocrRequirementLabel(book: BookItem): string {
        let status = this.text(book.ocrStatus);
        if (book.ocrRequiredPageCount > 0) return `OCR 필요 ${book.ocrRequiredPageCount}쪽`;
        if (status.includes("OCR필요") || status.includes("OCR 필요")) return status;
        if (status.includes("OCR불필요") || status.includes("OCR 불필요")) return "OCR 불필요";
        if (book.bodySearchAvailable || book.textPageCount > 0) return "OCR 불필요";
        if (!book.pdfAvailable) return "PDF 확보 후 판단";
        return status || "OCR 판단 대기";
    }

    public tagSuggestionStatus(book: BookItem): string {
        let recommended = Number(book.tagReviewSummary?.recommendedCount || 0);
        if (recommended > 0) return `자동추천 ${recommended}개`;
        if (book.tags.length > 0) return `태그 후보 ${book.tags.length}개`;
        return "태그 추천 대기";
    }

    public tagReviewLabel(book: BookItem): string {
        return this.text(book.tagReviewSummary?.label) || this.text(book.reviewStatus) || "검수대기";
    }

    public tagReviewStatusDetail(book: BookItem): string {
        let summary = book.tagReviewSummary;
        let counts = [];
        if (summary.pendingCount > 0) counts.push(`대기 ${summary.pendingCount}개`);
        if (summary.approvedCount > 0) counts.push(`완료 ${summary.approvedCount}개`);
        if (summary.rejectedCount > 0) counts.push(`반려 ${summary.rejectedCount}개`);
        return counts.length ? `${this.tagReviewLabel(book)} · ${counts.join(" / ")}` : this.tagReviewLabel(book);
    }

    public publicStatusLabel(book: BookItem): string {
        let status = this.text(book.publicStatus) || "내부전용";
        if (status === "공개가능") return "공개 가능";
        if (status === "공개보류") return "공개 보류";
        return status;
    }

    public publicAvailabilityLabel(book: BookItem): string {
        let status = this.publicStatusLabel(book);
        if (status === "공개 가능") return "공개 가능";
        if (status === "공개 보류") return "공개 보류";
        return "공개 미승인";
    }

    public internalOnlyStatusLabel(book: BookItem): string {
        let status = this.text(book.publicStatus);
        if (status === "내부전용") return "내부 전용";
        if (book.statusTags.some((tag) => tag.name === "내부전용")) return "내부 전용";
        if (book.tagReviewSummary.internalOnlyCount > 0) return `내부 전용 태그 ${book.tagReviewSummary.internalOnlyCount}개`;
        if (status === "공개가능") return "아니오";
        return "검토 필요";
    }

    public async loadKnowledgeGraph(book: BookItem) {
        if (!this.canAccessKnowledgeGraph()) {
            this.knowledgeGraph = null;
            this.graphLoading = false;
            this.graphErrorMessage = this.accessDeniedMessage("graph");
            await this.service.render();
            return;
        }
        let materialId = this.text(book.id || book.hflibId);
        if (this.graphLoading && this.knowledgeGraphRequestKey === materialId) return;
        this.knowledgeGraphAbortController?.abort();
        let controller = new AbortController();
        this.knowledgeGraphAbortController = controller;
        this.knowledgeGraphRequestKey = materialId;
        let token = ++this.knowledgeGraphToken;
        this.graphLoading = true;
        this.graphErrorMessage = "";
        this.graphPartialMessage = "";
        this.knowledgeGraph = null;
        this.graphSelectedNode = null;
        this.graphSelectedRelation = null;
        this.graphHoveredNode = null;
        this.graphHoveredRelation = null;
        await this.service.render();

        try {
            let endpoint = `/wiz/api/page.main/knowledge_graph?bookId=${encodeURIComponent(materialId)}`;
            let raw = await fetch(endpoint, { signal: controller.signal, cache: "no-cache" });
            let response: any = await raw.json();
            if (token !== this.knowledgeGraphToken) return;
            if (!raw.ok || response.code != 200) {
                this.graphErrorMessage = this.graphLoadErrorMessage(Number(response.code || raw.status), response, "자료");
                return;
            }
            let payload = response?.data?.data || response?.data || {};
            this.knowledgeGraph = this.cleanKnowledgeGraph(payload);
            this.graphSelectedNode = null;
            this.graphSelectedRelation = null;
            this.graphHoveredNode = null;
            this.graphHoveredRelation = null;
            this.graphZoom = this.recommendedBookGraphZoom(book);
            this.restoreGraphSelectionFromRoute("book");
        } catch (e) {
            if (token !== this.knowledgeGraphToken) return;
            if ((e as any)?.name === "AbortError") return;
            this.graphErrorMessage = "자료 관계도 요청에 실패했습니다. 잠시 후 다시 시도해 주세요.";
        } finally {
            if (token === this.knowledgeGraphToken) {
                this.graphLoading = false;
                this.knowledgeGraphRequestKey = "";
                if (this.knowledgeGraphAbortController === controller) this.knowledgeGraphAbortController = null;
                await this.service.render();
            }
        }
    }

    private graphLoadErrorMessage(status: number, response: any, scopeLabel: string): string {
        let serverMessage = this.text(response?.data?.message || response?.message);
        if (status === 401 || status === 403) return `${scopeLabel} 관계도 접근 권한이 없습니다. ${serverMessage}`.trim();
        if (status === 404) return `${scopeLabel} 관계도 대상을 찾을 수 없습니다. ${serverMessage}`.trim();
        return `${scopeLabel} 관계도를 불러오지 못했습니다. ${serverMessage || "잠시 후 다시 시도해 주세요."}`;
    }

    public cleanKnowledgeGraph(payload: any): KnowledgeGraphData {
        let nodes = Array.isArray(payload.nodes) ? payload.nodes : [];
        let relations = Array.isArray(payload.relations) ? payload.relations : [];
        let evidenceNodes = Array.isArray(payload.evidenceNodes) ? payload.evidenceNodes : [];
        let materials = Array.isArray(payload.materials) ? payload.materials : [];
        let cleanedNodes = this.dedupeGraphNodes(nodes
            .map((item: any) => this.cleanGraphNode(item))
            .filter((item: KnowledgeGraphNode) => item.id && item.label));
        let hiddenNodeIds = new Set(cleanedNodes
            .filter((node) => this.isGraphStatusOnlyNode(node))
            .map((node) => node.id));
        cleanedNodes = cleanedNodes.filter((node) => !hiddenNodeIds.has(node.id));
        let visibleNodeIds = new Set(cleanedNodes.map((node) => node.id));
        let cleanedRelations = this.dedupeGraphRelations(relations
            .map((item: any) => this.cleanGraphRelation(item))
            .filter((item: KnowledgeGraphRelation) => item.id && item.sentence)
            .filter((relation: KnowledgeGraphRelation) => {
                if (hiddenNodeIds.has(relation.source) || hiddenNodeIds.has(relation.target) || hiddenNodeIds.has(relation.evidenceNodeId || "")) return false;
                return visibleNodeIds.has(relation.source) || visibleNodeIds.has(relation.target);
            }));
        let cleanedEvidenceNodes = this.dedupeGraphNodes(evidenceNodes
            .map((item: any) => this.cleanGraphNode(item))
            .filter((item: KnowledgeGraphNode) => item.id && item.label && !hiddenNodeIds.has(item.id)));
        let bodyRelationCount = cleanedRelations.filter((relation) => this.relationEvidenceStatusLabel(relation) === GRAPH_BODY_EVIDENCE_COMPLETE_STATUS).length;
        let metadataCandidateCount = cleanedRelations.filter((relation) => this.isRelationMetadataRecommendation(relation)).length;
        let pendingEvidenceCount = cleanedRelations.filter((relation) => this.relationEvidenceStatusLabel(relation) === GRAPH_BODY_EVIDENCE_PENDING_STATUS).length;
        let graphData: KnowledgeGraphData = {
            collectionId: this.text(payload.collectionId),
            materialId: this.text(payload.materialId),
            bookTitle: this.text(payload.bookTitle),
            graphType: this.text(payload.graphType),
            generatedAt: this.text(payload.generatedAt),
            extractionBasis: this.text(payload.extractionBasis),
            dataSources: this.cleanGraphDataSources(payload.dataSources || []),
            dataSourcePolicy: this.cleanGraphDataSources(payload.dataSourcePolicy || []),
            nodeTypes: Array.isArray(payload.nodeTypes) ? payload.nodeTypes.map((item: any) => this.text(item)).filter((item: string) => item) : GRAPH_REQUIRED_NODE_TYPES,
            relationStates: Array.isArray(payload.relationStates) ? payload.relationStates.map((item: any) => this.text(item)).filter((item: string) => item) : [],
            relationCreationRules: Array.isArray(payload.relationCreationRules) ? payload.relationCreationRules : [],
            generationMethods: Array.isArray(payload.generationMethods) ? payload.generationMethods.map((item: any) => this.text(item)).filter((item: string) => item) : [],
            storageStatus: this.text(payload.storageStatus),
            storagePath: this.text(payload.storagePath),
            generationRelationLimit: Number(payload.generationRelationLimit || 0),
            generationMaterialLimit: Number(payload.generationMaterialLimit || 0),
            countDefinition: payload.countDefinition || {},
            summary: {
                nodeCount: cleanedNodes.length,
                relationCount: cleanedRelations.length,
                evidenceNodeCount: cleanedEvidenceNodes.length,
                autoExtractedCount: cleanedRelations.filter((relation) => this.isRelationPendingReview(relation)).length,
                reviewedCount: cleanedRelations.filter((relation) => this.isRelationReviewed(relation)).length,
                materialCount: Number(payload.summary?.materialCount || 0),
                displayMaterialCount: Number(payload.summary?.displayMaterialCount || 0),
                commonEntityCount: Number(payload.summary?.commonEntityCount || 0),
                bodyRelationCount: bodyRelationCount,
                bodyChunkCount: Number(payload.summary?.bodyChunkCount || 0),
                metadataCandidateCount: metadataCandidateCount,
                pendingEvidenceCount: pendingEvidenceCount,
                metadataOnly: bodyRelationCount === 0 && cleanedRelations.length > 0,
                qualityStatus: this.text(payload.summary?.qualityStatus || payload.quality?.status),
                relationLimitReached: Boolean(payload.summary?.relationLimitReached),
                materialLimitReached: Boolean(payload.summary?.materialLimitReached),
            },
            quality: this.cleanGraphQuality(payload.quality),
            nodes: cleanedNodes,
            relations: cleanedRelations,
            evidenceNodes: cleanedEvidenceNodes,
            materials: materials.map((item: any) => this.cleanCollectionMaterial(item)).filter((item: CollectionMaterial) => item.id && item.title),
        };
        if (!graphData.quality) graphData.quality = this.buildClientGraphQuality(graphData);
        if (graphData.quality) graphData.summary.qualityStatus = graphData.quality.status;
        return graphData;
    }

    private cleanGraphQuality(payload: any): GraphQualityReport | undefined {
        if (!payload || typeof payload !== "object") return undefined;
        let checks = Array.isArray(payload.checks)
            ? payload.checks.map((item: any) => ({
                key: this.text(item.key),
                label: this.text(item.label),
                status: this.text(item.status || "pass"),
                message: this.text(item.message),
                metric: item.metric || {},
            })).filter((item: GraphQualityCheckItem) => item.key || item.label || item.message)
            : [];
        let failedCount = Number(payload.failedCount ?? checks.filter((item: GraphQualityCheckItem) => item.status === "fail").length);
        let warningCount = Number(payload.warningCount ?? checks.filter((item: GraphQualityCheckItem) => item.status === "warning").length);
        return {
            status: this.text(payload.status || (failedCount ? "fail" : warningCount ? "warning" : "pass")),
            label: this.text(payload.label || (failedCount ? "실패" : warningCount ? "주의" : "통과")),
            checks: checks,
            failedCount: failedCount,
            warningCount: warningCount,
            passedCount: Number(payload.passedCount ?? checks.filter((item: GraphQualityCheckItem) => item.status === "pass").length),
            defaultDisplayNodeCount: Number(payload.defaultDisplayNodeCount || 0),
            relatedMaterialDisplayCount: Number(payload.relatedMaterialDisplayCount || 0),
            relatedMaterialActualCount: Number(payload.relatedMaterialActualCount || 0),
            nodeTypeCount: Number(payload.nodeTypeCount || 0),
            metadataOnly: Boolean(payload.metadataOnly),
            notices: Array.isArray(payload.notices) ? payload.notices.map((item: any) => this.text(item)).filter((item: string) => item) : [],
        };
    }

    private buildClientGraphQuality(graph: KnowledgeGraphData): GraphQualityReport {
        let centralId = graph.collectionId ? `collection:${graph.collectionId}` : `material:${graph.materialId}`;
        let centralType = graph.collectionId ? "주제" : "자료";
        let central = graph.nodes.find((node) => node.id === centralId)
            || graph.nodes.find((node) => this.normalizeGraphNodeType(node.type) === centralType && node.label === graph.bookTitle)
            || null;
        let displayNodes = this.clientDefaultGraphNodes(graph, centralId);
        let nodeTypes: string[] = [];
        for (let node of displayNodes) {
            let type = this.normalizeGraphNodeType(node.type);
            if (type && !nodeTypes.includes(type)) nodeTypes.push(type);
        }
        let relatedActual = this.clientRelatedMaterialIds(graph).size;
        let relatedDisplayCount = 0;
        for (let node of displayNodes) {
            let type = this.normalizeGraphNodeType(node.type);
            let materialId = this.text(node.relatedMaterialId || node.materialId || node.id.replace(/^material:/, ""));
            if (["자료", "관련 자료"].includes(type) && node.id !== centralId && materialId) relatedDisplayCount += 1;
        }
        let duplicateLabels = this.duplicateGraphDisplayLabels(displayNodes);
        let metadataOnly = graph.relations.length > 0 && graph.relations.every((relation) => this.isRelationMetadataRecommendation(relation) || this.relationEvidenceStatusLabel(relation) === GRAPH_BODY_EVIDENCE_PENDING_STATUS);

        let checks: GraphQualityCheckItem[] = [
            {
                key: "central_node",
                label: "중심 항목",
                status: central && this.normalizeGraphNodeType(central.type) === centralType ? "pass" : "fail",
                message: central ? "중심 자료 항목이 자료ID와 제목 기준으로 확인되었습니다." : "중심 자료 항목을 확인하지 못했습니다.",
            },
            {
                key: "default_node_count",
                label: "기본 표시 항목 수",
                status: displayNodes.length >= 12 && displayNodes.length <= 40 ? "pass" : "fail",
                message: `기본 표시 항목 ${displayNodes.length}개입니다.`,
                metric: { count: displayNodes.length, min: 12, max: 40 },
            },
            {
                key: "related_material_count",
                label: "관련 자료 표시 수",
                status: relatedActual < 2 || relatedDisplayCount >= 2 ? "pass" : "fail",
                message: `관련 자료 표시 ${relatedDisplayCount}개 / 실제 후보 ${relatedActual}개입니다.`,
                metric: { displayCount: relatedDisplayCount, actualCount: relatedActual },
            },
            {
                key: "node_type_diversity",
                label: "항목 유형 다양성",
                status: nodeTypes.length >= 4 ? "pass" : "fail",
                message: `기본 표시 항목 유형 ${nodeTypes.length}종입니다.`,
                metric: { count: nodeTypes.length, min: 4 },
            },
            {
                key: "single_color_repetition",
                label: "단일 색상 반복",
                status: nodeTypes.length > 1 || displayNodes.length <= 1 ? "pass" : "fail",
                message: nodeTypes.length > 1 ? "여러 항목 유형이 섞여 단일 색상 반복이 아닙니다." : "한 가지 항목 유형만 반복됩니다.",
            },
            {
                key: "duplicate_display_labels",
                label: "동일 라벨 반복",
                status: duplicateLabels.length ? "fail" : "pass",
                message: duplicateLabels.length ? "기본 표시 영역에 같은 이름의 항목이 반복됩니다." : "기본 표시 영역에 같은 이름이 반복되지 않습니다.",
                metric: { duplicates: duplicateLabels },
            },
        ];
        let failedCount = checks.filter((check) => check.status === "fail").length;
        let warningCount = 0;
        let status = failedCount ? "fail" : warningCount ? "warning" : "pass";
        return {
            status: status,
            label: status === "fail" ? "실패" : status === "warning" ? "주의" : "통과",
            checks: checks,
            failedCount: failedCount,
            warningCount: warningCount,
            passedCount: checks.filter((check) => check.status === "pass").length,
            defaultDisplayNodeCount: displayNodes.length,
            relatedMaterialDisplayCount: relatedDisplayCount,
            relatedMaterialActualCount: relatedActual,
            nodeTypeCount: nodeTypes.length,
            metadataOnly: metadataOnly,
            notices: metadataOnly ? ["중심 자료 외 관계가 모두 메타데이터 기반 추천 상태입니다. 본문 근거 연결 전까지 확정 관계로 보지 않습니다."] : [],
        };
    }

    private clientDefaultGraphNodes(graph: KnowledgeGraphData, centralId: string): KnowledgeGraphNode[] {
        let central = graph.nodes.find((node) => node.id === centralId) || null;
        let clientNodeScore = (node: KnowledgeGraphNode) => {
            return Number(node.importanceScore || 0) * 2.1
                + Math.max(0, 9 - Number(node.priorityRank || 9)) * 0.38
                + Math.min(6, Number(node.sourceCount || 0)) * 0.18
                + Number(node.evidenceCount || 0) * 0.08
                + Number(node.relatedMaterialCount || 0) * 0.16
                + Number(node.connectionCount || 0) * 0.12;
        };
        let candidates = graph.nodes
            .filter((node) => node.id !== centralId && !this.isGraphStatusOnlyNode(node) && !this.isEvidenceNodeType(node))
            .sort((a, b) => clientNodeScore(b) - clientNodeScore(a) || a.label.localeCompare(b.label, "ko"));
        if (graph.collectionId) {
            let selected: KnowledgeGraphNode[] = [];
            let seenIds = new Set<string>();
            let seenLabels = new Set<string>();
            let addNode = (node: KnowledgeGraphNode | null) => {
                if (!node) return;
                let id = this.text(node.id);
                let labelKey = this.graphLabelKey(node.label) || id;
                if (!id || seenIds.has(id) || seenLabels.has(labelKey)) return;
                seenIds.add(id);
                seenLabels.add(labelKey);
                selected.push(node);
            };
            let addRows = (rows: KnowledgeGraphNode[], limit: number) => {
                let added = 0;
                for (let node of rows) {
                    if (added >= limit) break;
                    let before = selected.length;
                    addNode(node);
                    if (selected.length > before) added += 1;
                }
            };
            addNode(central);
            addRows(candidates.filter((node) => ["자료", "관련 자료"].includes(this.normalizeGraphNodeType(node.type))), 5);
            addRows(candidates.filter((node) => this.normalizeGraphNodeType(node.type) === "주제"), 7);
            addRows(candidates.filter((node) => !["자료", "관련 자료", "주제"].includes(this.normalizeGraphNodeType(node.type))), 10);
            addRows(candidates, 28);
            return selected.slice(0, 28);
        }
        let selected: KnowledgeGraphNode[] = [];
        let seenIds = new Set<string>();
        let seenLabels = new Set<string>();
        [central].concat(candidates).forEach((node) => {
            if (!node || selected.length >= 25) return;
            let id = this.text(node.id);
            let labelKey = this.graphLabelKey(node.label) || id;
            if (!id || seenIds.has(id) || seenLabels.has(labelKey)) return;
            seenIds.add(id);
            seenLabels.add(labelKey);
            selected.push(node);
        });
        return selected;
    }

    private clientRelatedMaterialIds(graph: KnowledgeGraphData): Set<string> {
        let currentIds = new Set([graph.materialId, graph.collectionId].map((value) => this.text(value)).filter((value) => value));
        let ids = new Set<string>();
        graph.nodes.forEach((node) => {
            let type = this.normalizeGraphNodeType(node.type);
            let materialId = this.text(node.relatedMaterialId || node.materialId || node.id.replace(/^material:/, ""));
            if (materialId && !currentIds.has(materialId) && ["자료", "관련 자료"].includes(type)) ids.add(materialId);
        });
        graph.relations.forEach((relation) => {
            let materialId = this.text(relation.materialId);
            if (materialId && !currentIds.has(materialId)) ids.add(materialId);
        });
        return ids;
    }

    private duplicateGraphNodeIds(nodes: KnowledgeGraphNode[]): string[] {
        let counts: any = {};
        nodes.forEach((node) => {
            let id = this.text(node.id);
            if (id) counts[id] = Number(counts[id] || 0) + 1;
        });
        return Object.keys(counts).filter((id) => counts[id] > 1);
    }

    private duplicateGraphDisplayLabels(nodes: KnowledgeGraphNode[]): string[] {
        let counts: any = {};
        let labels: any = {};
        nodes.forEach((node) => {
            let key = this.graphLabelKey(node.label);
            if (!key) return;
            counts[key] = Number(counts[key] || 0) + 1;
            labels[key] = node.label;
        });
        return Object.keys(counts).filter((key) => counts[key] > 1).map((key) => labels[key]);
    }

    private cleanGraphNodeShape(value: any): GraphNodeShape | undefined {
        let shape = this.text(value) as GraphNodeShape;
        return ["central-topic", "material-card", "small-card", "circle", "capsule", "compact", "dot"].includes(shape) ? shape : undefined;
    }

    private cleanGraphNodeSizeTier(value: any): GraphNodeSizeTier | undefined {
        let tier = this.text(value) as GraphNodeSizeTier;
        return ["large", "medium", "small"].includes(tier) ? tier : undefined;
    }

    private cleanGraphDataSources(items: any[]): GraphDataSourceItem[] {
        if (!Array.isArray(items)) return [];
        return items.map((item: any) => ({
            source: this.text(item.source),
            role: this.text(item.role),
            active: Boolean(item.active),
            detail: this.text(item.detail),
        })).filter((item: GraphDataSourceItem) => item.source);
    }

    public cleanGraphNode(item: any): KnowledgeGraphNode {
        let nodeType = this.normalizeGraphNodeType(this.text(item.nodeType || item.type || "개념"));
        let label = this.text(item.label || item.name);
        return {
            id: this.text(item.id || item.nodeId),
            nodeId: this.text(item.nodeId || item.id),
            name: this.text(item.name || label),
            type: nodeType,
            nodeType: nodeType,
            label: label,
            displayLabel: this.text(item.displayLabel) || `${nodeType} · ${label}`,
            detail: this.text(item.detail),
            evidenceCount: Number(item.evidenceCount || 0),
            connectionCount: Number(item.connectionCount || 0),
            evidenceStatus: this.text(item.evidenceStatus || GRAPH_BODY_EVIDENCE_PENDING_STATUS),
            reviewStatus: this.normalizeGraphReviewStatus(item.reviewStatus),
            publicStatus: this.text(item.publicStatus || "내부전용"),
            materialId: this.text(item.materialId),
            relatedMaterialId: this.text(item.relatedMaterialId || item.materialId),
            relatedMaterialCount: Number(item.relatedMaterialCount || 0),
            materialIds: Array.isArray(item.materialIds)
                ? item.materialIds.map((value: any) => this.text(value)).filter((value: string) => value)
                : [],
            relatedTags: Array.isArray(item.relatedTags)
                ? item.relatedTags.map((value: any) => this.text(value)).filter((value: string) => value)
                : [],
            sourceField: this.text(item.sourceField),
            fileId: this.text(item.fileId),
            page: Number(item.page || 0),
            chunkId: this.text(item.chunkId),
            sentence: this.text(item.sentence),
            pdfFilename: this.text(item.pdfFilename),
            pdfUrl: this.text(item.pdfUrl),
            pdfIndex: Number(item.pdfIndex || 0),
            priorityRank: Number.isFinite(Number(item.priorityRank)) ? Number(item.priorityRank) : 9,
            priorityBasis: this.text(item.priorityBasis),
            importanceScore: Number(item.importanceScore || 0),
            importanceBasis: this.text(item.importanceBasis),
            sourceCount: Number(item.sourceCount || 0),
            displayMetricLabel: this.text(item.displayMetricLabel),
            displayShape: this.cleanGraphNodeShape(item.displayShape),
            sizeTier: this.cleanGraphNodeSizeTier(item.sizeTier),
            sizeRule: this.text(item.sizeRule),
        };
    }

    public cleanCollectionMaterial(item: any): CollectionMaterial {
        let coverImage = this.normalizedCoverImage(item);
        return {
            id: this.text(item.id || item.hflibId),
            hflibId: this.text(item.hflibId || item.id),
            title: this.text(item.title),
            author: this.text(item.author || "저자 정보 없음"),
            publisher: this.text(item.publisher || "출판사 정보 없음"),
            publishedDate: this.text(item.publishedDate || "출간일 정보 없음"),
            publishedYear: item.publishedYear || this.numberYear(item.publishedDate),
            coverImage: coverImage,
            coverAvailable: Boolean(coverImage),
            pdfCount: Number(item.pdfCount || 0),
            bodySearchAvailable: Boolean(item.bodySearchAvailable),
            reviewStatus: this.text(item.reviewStatus || "검수대기"),
            publicStatus: this.text(item.publicStatus || "내부전용"),
            score: Number(item.score || 0),
            evidence: Array.isArray(item.evidence)
                ? item.evidence.map((value: any) => this.text(value)).filter((value: string) => value)
                : []
        };
    }

    private canonicalGraphRelationType(value: string, item: any = {}): string {
        let type = this.text(value || item.type || "");
        let targetType = this.normalizeGraphNodeType(this.text(item.targetType || item.targetNodeType || item.nodeType));
        let sourceType = this.normalizeGraphNodeType(this.text(item.sourceType || item.sourceNodeType));
        if (sourceType === "사건" && targetType === "장소") return "발생·관련장소";
        if (sourceType === "사건" && targetType === "시대") return "발생시기";
        if (!type || ["관련된다", GRAPH_METADATA_RECOMMENDATION_STATUS, GRAPH_BODY_EVIDENCE_PENDING_STATUS].includes(type)) type = "";
        let normalized = this.normalizeStatusText(type);
        let mapped = GRAPH_RELATION_TYPE_ALIASES[type] || GRAPH_RELATION_TYPE_ALIASES[normalized];
        if (mapped) type = mapped;
        if (GRAPH_RELATION_TYPES.includes(type)) return type;
        if (targetType === "주제") return "주제로다룬다";
        if (targetType === "장소") return "관련장소";
        if (targetType === "사건") return "관련사건";
        if (targetType === "시대") return "관련시대";
        if (targetType === "기관") return sourceType === "자료" ? "본문에서언급한다" : "서지기관후보이다";
        if (targetType === "인물") return sourceType === "자료" ? "본문에서언급한다" : "서지인물후보이다";
        if (targetType === "문헌·법령" && sourceType === "자료") return "인용한다";
        if (targetType === "자료" || targetType === "관련 자료") return "관련자료";
        return "관련개념";
    }

    public cleanGraphRelation(item: any): KnowledgeGraphRelation {
        let relationStatus = this.text(item.relationStatus || item.status);
        if (!relationStatus) {
            relationStatus = this.text(item.evidenceStatus) || (this.text(item.extractionMethod).includes("메타데이터") ? GRAPH_METADATA_RECOMMENDATION_STATUS : GRAPH_BODY_EVIDENCE_PENDING_STATUS);
        }
        let rawType = this.text(item.rawType || item.type || "관련된다");
        let sourceNodeType = this.normalizeGraphNodeType(this.text(item.sourceNodeType || item.sourceType));
        let targetNodeType = this.normalizeGraphNodeType(this.text(item.targetNodeType || item.targetType || item.nodeType));
        let generationMethod = this.text(item.generationMethod || item.extractionMethod || "metadata_rule");
        let chunkId = this.text(item.chunkId);
        let bodyEvidenceLinked = Boolean(item.bodyEvidenceLinked)
            || (Number(item.page || 0) > 0 && !!chunkId && !chunkId.startsWith("metadata:") && !!this.text(item.sentence));
        if (bodyEvidenceLinked && relationStatus === GRAPH_BODY_EVIDENCE_PENDING_STATUS) {
            relationStatus = GRAPH_BODY_EVIDENCE_COMPLETE_STATUS;
        }
        return {
            id: this.text(item.id),
            relationId: this.text(item.relationId || item.id),
            source: this.text(item.source),
            target: this.text(item.target),
            sourceNode: this.text(item.sourceNode || item.source),
            targetNode: this.text(item.targetNode || item.target),
            sourceNodeId: this.text(item.sourceNodeId || item.source),
            targetNodeId: this.text(item.targetNodeId || item.target),
            sourceNodeType: sourceNodeType,
            targetNodeType: targetNodeType,
            sourceNodeLabel: this.text(item.sourceNodeLabel || item.sourceLabel),
            targetNodeLabel: this.text(item.targetNodeLabel || item.targetLabel),
            sourceLabel: this.text(item.sourceLabel),
            targetLabel: this.text(item.targetLabel),
            type: this.canonicalGraphRelationType(rawType, { ...item, sourceNodeType, targetNodeType }),
            rawType: rawType,
            relationStatus: relationStatus,
            status: relationStatus,
            materialId: this.text(item.materialId),
            fileId: this.text(item.fileId),
            page: Number(item.page || 0),
            paragraph: Number(item.paragraph || 0),
            chunkId: chunkId,
            sentence: this.text(item.sentence),
            extractionMethod: this.text(item.extractionMethod || "규칙"),
            generationMethod: generationMethod,
            confidence: Number(item.confidence || 0),
            confidenceLabel: this.text(item.confidenceLabel),
            evidenceCount: Number(item.evidenceCount || (relationStatus === GRAPH_BODY_EVIDENCE_COMPLETE_STATUS ? 1 : 0)),
            reviewStatus: this.normalizeGraphReviewStatus(item.reviewStatus),
            publicStatus: this.text(item.publicStatus || "내부전용"),
            pdfFilename: this.text(item.pdfFilename),
            pdfUrl: this.text(item.pdfUrl),
            pdfIndex: Number(item.pdfIndex || 0),
            matchedAlias: this.text(item.matchedAlias),
            evidenceNodeId: this.text(item.evidenceNodeId),
            evidenceStatus: this.text(item.evidenceStatus),
            bodyEvidenceLinked: bodyEvidenceLinked,
            bodyEvidenceStatus: this.text(item.bodyEvidenceStatus),
            reviewNote: this.text(item.reviewNote),
            sourceField: this.text(item.sourceField),
            evidenceField: this.text(item.evidenceField || item.sourceField),
            importanceScore: Number(item.importanceScore || 0),
            importanceBasis: this.text(item.importanceBasis),
            relationRule: item.relationRule || undefined,
            semanticRole: this.text(item.semanticRole),
            relationMeaning: this.text(item.relationMeaning),
            pdfPage: Number(item.pdfPage || item.page || 0),
            printedPage: this.text(item.printedPage),
            printedPageStatus: this.text(item.printedPageStatus || (item.printedPage ? "확인됨" : "미확인")),
            evidenceVerificationStatus: this.text(item.evidenceVerificationStatus),
            extractionReviewClass: this.text(item.extractionReviewClass),
            structuralValidationStatus: this.text(item.structuralValidationStatus),
            qualityEligible: item.qualityEligible !== false,
            qualityStatus: this.text(item.qualityStatus),
        };
    }

    private dedupeGraphNodes(nodes: KnowledgeGraphNode[]): KnowledgeGraphNode[] {
        let result: KnowledgeGraphNode[] = [];
        let seen = new Set<string>();
        nodes.forEach((node) => {
            let key = node.id || `${node.type}:${node.label}`;
            if (!key || seen.has(key)) return;
            seen.add(key);
            result.push(node);
        });
        return result;
    }

    private dedupeGraphRelations(relations: KnowledgeGraphRelation[]): KnowledgeGraphRelation[] {
        let result: KnowledgeGraphRelation[] = [];
        let seen = new Set<string>();
        relations.forEach((relation) => {
            let key = [
                relation.source,
                relation.target,
                relation.type,
                relation.chunkId,
                relation.sentence,
            ].join("|");
            if (!key || seen.has(key)) return;
            seen.add(key);
            result.push(relation);
        });
        return result;
    }

    private isGraphStatusOnlyNode(node: KnowledgeGraphNode | null): boolean {
        if (!node) return false;
        let type = this.text(node.type);
        let label = this.normalizeStatusText(node.label);
        let sourceField = this.normalizeStatusText(node.sourceField || "");
        if (sourceField.includes("본문근거연결상태") || sourceField.includes("검수상태") || sourceField.includes("공개상태")) return true;
        return type === "개념" && GRAPH_STATUS_ONLY_NODE_LABELS.has(label);
    }

    public graphCentralNode(): KnowledgeGraphNode | null {
        let graph = this.knowledgeGraph;
        if (!graph) return null;
        let materialId = this.text(graph.materialId);
        let materialNodeId = materialId ? `material:${materialId}` : "";
        let bookTitle = this.text(graph.bookTitle);
        return graph.nodes.find((node) => node.type === "자료" && materialNodeId && node.id === materialNodeId)
            || graph.nodes.find((node) => node.type === "자료" && materialId && (node.materialId === materialId || node.relatedMaterialId === materialId))
            || graph.nodes.find((node) => node.type === "자료" && bookTitle && node.label === bookTitle)
            || graph.nodes.find((node) => node.type === "자료")
            || graph.nodes[0]
            || null;
    }

    public graphNodeTypeOptions(): string[] {
        return GRAPH_NODE_TYPE_FILTERS;
    }

    public graphRelationTypeOptions(): string[] {
        if (!this.knowledgeGraph) return [];
        let available = new Set(this.knowledgeGraph.relations.map((relation) => this.relationTypeLabel(relation)));
        return GRAPH_RELATION_TYPES.filter((type) => available.has(type))
            .concat(this.uniqueOptions(Array.from(available).filter((type) => !GRAPH_RELATION_TYPES.includes(type))));
    }

    public graphRelationStatusOptions(): string[] {
        return GRAPH_RELATION_STATUS_FILTERS;
    }

    public graphDisplayNodes(book: BookItem): KnowledgeGraphNode[] {
        let rows = this.graphFilteredNodes(book);
        return rows.slice(0, this.graphNodeDisplayLimit(rows.length));
    }

    private graphFilteredNodes(book: BookItem): KnowledgeGraphNode[] {
        if (!this.knowledgeGraph) return [];
        let query = this.text(this.graphSearchQuery).toLocaleLowerCase();
        let visibleRelationIds = new Set<string>();
        this.graphDisplayRelations(book).forEach((relation) => {
            visibleRelationIds.add(relation.source);
            visibleRelationIds.add(relation.target);
            if (relation.evidenceNodeId) visibleRelationIds.add(relation.evidenceNodeId);
        });
        let relationStatusFiltered = this.graphRelationStatusFilter !== "전체";
        let rows = this.knowledgeGraph.nodes.filter((node) => {
            if (!this.graphEvidenceNodesVisible() && this.isEvidenceNodeType(node)) return false;
            if (this.graphNodeTypeFilter
                && !this.matchesGraphNodeTypeFilter(node, this.graphNodeTypeFilter)
                && !this.isContextMaterialNode(node, visibleRelationIds)) return false;
            if (relationStatusFiltered && !visibleRelationIds.has(node.id)) return false;
            if (query && !`${node.label} ${node.type} ${node.detail || ""}`.toLocaleLowerCase().includes(query) && !visibleRelationIds.has(node.id)) return false;
            if (visibleRelationIds.size && node.type !== "자료" && !visibleRelationIds.has(node.id)) return false;
            return true;
        });
        rows.sort((a, b) => this.graphNodeScore(b) - this.graphNodeScore(a) || a.label.localeCompare(b.label, "ko"));
        return rows;
    }

    public graphSurroundingNodes(book: BookItem): KnowledgeGraphNode[] {
        let rows = this.graphSurroundingCandidates(book);
        if (!this.isDefaultBookGraphLayout()) return rows.slice(0, 24);

        rows.sort((a, b) => this.graphNodeScore(b) - this.graphNodeScore(a) || a.label.localeCompare(b.label, "ko"));
        return this.balanceBookRadialNodes(rows, this.bookGraphDefaultNodeLimit(rows.length));
    }

    private graphSurroundingCandidates(book: BookItem): KnowledgeGraphNode[] {
        return this.graphFilteredNodes(book)
            .filter((node) => node.type !== "자료")
            .filter((node) => !this.isGraphStatusOnlyNode(node) && (this.graphShowEvidence || !this.isEvidenceNodeType(node)));
    }

    public graphHiddenNodeCount(book: BookItem): number {
        if (!this.isDefaultBookGraphLayout()) return 0;
        let candidates = this.graphSurroundingCandidates(book);
        return Math.max(0, candidates.length - this.bookGraphDefaultNodeLimit(candidates.length));
    }

    public graphCanToggleMore(book: BookItem): boolean {
        return this.graphExpanded || this.graphHiddenNodeCount(book) > 0;
    }

    public graphMoreButtonLabel(book: BookItem): string {
        if (this.graphExpanded) return "간략히";
        let count = this.graphHiddenNodeCount(book);
        return count > 0 ? `더 보기 ${count}개` : "더 보기";
    }

    public async toggleBookGraphMore(book: BookItem) {
        this.graphExpanded = !this.graphExpanded;
        this.graphZoom = this.recommendedBookGraphZoom(book);
        this.syncMainUrl("replace");
        await this.service.render();
    }

    public graphEvidenceNodes(book: BookItem): KnowledgeGraphNode[] {
        if (!this.graphShowEvidence && this.isDefaultBookGraphLayout()) return [];
        if (!this.graphEvidenceNodesVisible()) return [];
        return this.graphDisplayNodes(book)
            .filter((node) => this.isEvidenceNodeType(node))
            .slice(0, 12);
    }

    public graphDisplayRelations(book: BookItem): KnowledgeGraphRelation[] {
        let rows = this.filteredGraphRelations();
        rows.sort((a, b) => this.graphRelationScore(b) - this.graphRelationScore(a) || this.relationTypeLabel(a).localeCompare(this.relationTypeLabel(b), "ko"));
        let limit = this.graphRelationDisplayLimit(rows.length);
        if (this.isDefaultBookGraphLayout()) return this.diverseBookGraphRelations(rows, limit);
        return rows.slice(0, limit);
    }

    private diverseBookGraphRelations(rows: KnowledgeGraphRelation[], limit: number): KnowledgeGraphRelation[] {
        let selected: KnowledgeGraphRelation[] = [];
        let usedRelationIds = new Set<string>();
        let usedEndpointKeys = new Set<string>();

        let endpointKey = (relation: KnowledgeGraphRelation) => {
            return [
                this.text(relation.source || relation.sourceLabel),
                this.text(relation.target || relation.targetLabel),
                this.relationTypeLabel(relation),
            ].join("::");
        };
        let add = (relation: KnowledgeGraphRelation, requireUniqueEndpoint: boolean = false) => {
            if (!relation || selected.length >= limit) return;
            let relationId = this.text(relation.id) || endpointKey(relation);
            if (usedRelationIds.has(relationId)) return;
            let key = endpointKey(relation);
            if (requireUniqueEndpoint && usedEndpointKeys.has(key)) return;
            usedRelationIds.add(relationId);
            usedEndpointKeys.add(key);
            selected.push(relation);
        };

        rows.filter((relation) => this.relationEvidenceStatusLabel(relation) === GRAPH_BODY_EVIDENCE_COMPLETE_STATUS)
            .forEach((relation) => add(relation, true));
        rows.filter((relation) => this.relationEvidenceStatusLabel(relation) !== GRAPH_BODY_EVIDENCE_COMPLETE_STATUS)
            .forEach((relation) => add(relation, true));
        rows.forEach((relation) => add(relation, false));
        return selected.slice(0, limit);
    }

    private filteredGraphRelations(): KnowledgeGraphRelation[] {
        let graph = this.knowledgeGraph;
        if (!graph) return [];
        let query = this.text(this.graphSearchQuery).toLocaleLowerCase();
        let minConfidence = Number(this.graphMinConfidence || 0);
        return graph.relations.filter((relation) => {
            if (this.graphRelationTypeFilter && this.relationTypeLabel(relation) !== this.graphRelationTypeFilter) return false;
            if (!this.matchesGraphRelationStatusFilter(relation)) return false;
            if (this.graphNodeTypeFilter && !this.graphRelationMatchesNodeTypeFilter(relation, graph)) return false;
            if (relation.confidence < minConfidence) return false;
            if (query && !this.graphRelationMatchesSearch(relation, query)) return false;
            return true;
        });
    }

    private isDefaultBookGraphLayout(): boolean {
        return !this.graphNodeTypeFilter
            && !this.graphSearchQuery
            && this.graphRelationStatusFilter === "전체";
    }

    private graphEvidenceNodesVisible(): boolean {
        return this.graphShowEvidence || this.graphNodeTypeFilter === "근거" || this.isDefaultBookGraphLayout();
    }

    private isEvidenceNodeType(node: KnowledgeGraphNode | null): boolean {
        if (!node) return false;
        let type = this.text(node.type);
        let id = this.text(node.id);
        return type === "근거" || type === "근거 후보" || type === "근거문단" || id.startsWith("evidence:") || id.startsWith("chunk:");
    }

    private isContextMaterialNode(node: KnowledgeGraphNode | null, visibleRelationIds: Set<string>): boolean {
        if (!node || !visibleRelationIds.has(node.id)) return false;
        return node.type === "자료" || node.id.startsWith("collection:");
    }

    private matchesGraphNodeTypeFilter(node: KnowledgeGraphNode | null, filter: string): boolean {
        filter = this.text(filter);
        if (!filter || !node) return true;
        let type = this.text(node.type);
        let id = this.text(node.id);
        if (filter === "자료") return type === "자료" || type === "관련 자료" || id.startsWith("material:");
        if (filter === "근거") return this.isEvidenceNodeType(node);
        if (filter === "시대") return type === "시대" || type === "시대·국가" || type.includes("시대") || type.includes("국가");
        if (filter === "문헌·법령") return type === "문헌·법령" || type === "문헌" || type === "법령";
        return type === filter || type.includes(filter);
    }

    private graphRelationMatchesNodeTypeFilter(relation: KnowledgeGraphRelation, graph: KnowledgeGraphData | null): boolean {
        if (!this.graphNodeTypeFilter || !graph) return true;
        return this.graphNodesForRelation(relation, graph).some((node) => this.matchesGraphNodeTypeFilter(node, this.graphNodeTypeFilter));
    }

    private graphNodesForRelation(relation: KnowledgeGraphRelation, graph: KnowledgeGraphData): KnowledgeGraphNode[] {
        let ids = [relation.source, relation.target, relation.evidenceNodeId].filter((value) => this.text(value));
        let labels = [relation.sourceLabel, relation.targetLabel].filter((value) => this.text(value));
        return graph.nodes.filter((node) => ids.includes(node.id) || labels.includes(node.label));
    }

    private graphRelationMatchesSearch(relation: KnowledgeGraphRelation, query: string): boolean {
        let value = [
            relation.sourceLabel,
            relation.targetLabel,
            relation.sentence,
            this.relationTypeLabel(relation),
            relation.rawType,
            this.relationEvidenceStatusLabel(relation),
            this.relationReviewStatusLabel(relation),
            this.relationMaterialTitle(relation),
        ].join(" ").toLocaleLowerCase();
        return value.includes(query);
    }

    private matchesGraphRelationStatusFilter(relation: KnowledgeGraphRelation | null): boolean {
        let filter = this.text(this.graphRelationStatusFilter) || "전체";
        if (!relation || filter === "전체") return true;
        let review = this.normalizeStatusText(this.relationReviewStatusLabel(relation));
        let relationStatus = this.normalizeStatusText(this.relationStatusLabel(relation));
        let evidence = this.relationEvidenceStatusLabel(relation);
        if (filter === "검수 완료") return review.includes("검수완료") || relationStatus.includes("검수완료");
        if (filter === "검수 대기") return review.includes("검수대기") || relationStatus.includes("검수대기");
        if (filter === GRAPH_BODY_EVIDENCE_COMPLETE_STATUS) return evidence === GRAPH_BODY_EVIDENCE_COMPLETE_STATUS;
        if (filter === GRAPH_BODY_EVIDENCE_PENDING_STATUS) return evidence === GRAPH_BODY_EVIDENCE_PENDING_STATUS;
        if (filter === GRAPH_METADATA_RECOMMENDATION_STATUS) return this.isRelationMetadataRecommendation(relation);
        return relationStatus === this.normalizeStatusText(filter) || evidence === filter;
    }

    private normalizeStatusText(value: string): string {
        return this.text(value).replace(/\s+/g, "");
    }

    private graphImportanceKey(value: any): string {
        return this.text(value).replace(/[\sㆍ·/|:;,_\-()（）\[\]{}<>〈〉《》「」『』]+/g, "").toLocaleLowerCase();
    }

    private graphImportanceHas(values: any[], keywords: string[]): boolean {
        let context = this.graphImportanceKey(values.map((value) => this.text(value)).join(" "));
        return keywords.some((keyword) => {
            let key = this.graphImportanceKey(keyword);
            return !!key && context.includes(key);
        });
    }

    private relationImportanceParts(relation: KnowledgeGraphRelation | null): string[] {
        if (!relation) return [];
        let values = [
            relation.sourceField,
            relation.evidenceField,
            relation.extractionMethod,
            relation.generationMethod,
            relation.type,
            relation.rawType,
            relation.sentence,
            relation.chunkId,
        ];
        let parts: string[] = [];
        let add = (basis: string) => {
            if (!parts.includes(basis)) parts.push(basis);
        };
        if (this.graphImportanceHas(values, ["제목 직접 키워드", "제목 핵심 명사", "제목 속 시기", "제목 문헌·법령 키워드", "MARC 245"])) add("제목 기반 연결");
        if (this.graphImportanceHas(values, ["MARC", "MARC 653", "PERSONAL_NAME", "CORPORATE_NAME", "marc_rule"])) add("서지정보 기반 연결");
        if (this.graphImportanceHas(values, ["자료태그", "자료 태그", "태그 별칭", "컬렉션 태그"])) add("주제어 기반 연결");
        if (this.relationHasSourcePage(relation) || this.graphImportanceHas(values, ["PDF 본문 청크", "본문청크", "본문 청크", "text_chunk_rule"])) add("원문 문단 기반 연결");
        if (this.graphImportanceHas(values, ["관련 자료", "관련자료", "유사 자료", "유사자료", "같은컬렉션", "동일 태그", "catalog"])) add("관련 자료 기반 연결");
        return parts;
    }

    private relationImportanceScore(relation: KnowledgeGraphRelation | null): number {
        if (!relation) return 0;
        let explicit = Number(relation.importanceScore || 0);
        if (explicit > 0) return explicit;
        if (Object.prototype.hasOwnProperty.call(relation as any, "__importanceScore")) return Number((relation as any).__importanceScore || 0);
        let weights: any = {
            "제목 기반 연결": 5,
            "서지정보 기반 연결": 4,
            "주제어 기반 연결": 4,
            "원문 문단 기반 연결": 5,
            "관련 자료 기반 연결": 2,
        };
        let parts = this.relationImportanceParts(relation);
        let score = parts.reduce((sum, basis) => sum + Number(weights[basis] || 0), 0);
        (relation as any).__importanceScore = score;
        (relation as any).__importanceBasis = parts.length ? parts.join(" · ") : "보조 연결 후보";
        return score;
    }

    private relationImportanceBasis(relation: KnowledgeGraphRelation | null): string {
        if (!relation) return "보조 관계 후보";
        let explicit = this.text(relation.importanceBasis);
        if (explicit && Number(relation.importanceScore || 0) > 0) return explicit;
        this.relationImportanceScore(relation);
        return this.text((relation as any).__importanceBasis) || "보조 관계 후보";
    }

    private graphRelationScore(relation: KnowledgeGraphRelation): number {
        let score = Number(relation.importanceScore || 0);
        if (!score) score = Number(relation.confidence || 0);
        score += Number(relation.confidence || 0) * 0.2;
        if (this.relationEvidenceStatusLabel(relation) === GRAPH_BODY_EVIDENCE_COMPLETE_STATUS) score += 0.35;
        if (["검수완료", "검수 완료"].includes(this.text(relation.reviewStatus))) score += 0.18;
        if (this.relationTypeLabel(relation) === "같은컬렉션") score += 0.03;
        if (this.isRelationPendingEvidence(relation)) score -= 0.04;
        return score;
    }

    private graphCandidateRelationsForNode(node: KnowledgeGraphNode | null): KnowledgeGraphRelation[] {
        if (!node) return [];
        let rows: KnowledgeGraphRelation[] = [];
        let matches = (relation: KnowledgeGraphRelation) => relation.target === node.id
            || relation.source === node.id
            || relation.evidenceNodeId === node.id
            || relation.targetLabel === node.label
            || relation.sourceLabel === node.label;
        if (this.knowledgeGraph) rows = rows.concat(this.knowledgeGraph.relations.filter(matches));
        if (this.collectionGraph) rows = rows.concat(this.collectionGraph.relations.filter(matches));
        return rows;
    }

    private graphNodeImportanceParts(node: KnowledgeGraphNode | null): string[] {
        if (!node) return [];
        let values: any[] = [
            node.sourceField,
            node.detail,
            node.displayLabel,
            node.pdfFilename,
            (node.relatedTags || []).join(" "),
        ];
        let titleValues: string[] = [];
        let pdfValues: string[] = [this.text(node.pdfFilename)];
        let labelKey = this.graphImportanceKey(node.label);
        let parts: string[] = [];
        let add = (basis: string) => {
            if (!parts.includes(basis)) parts.push(basis);
        };
        if (node.type === "자료" || titleValues.some((value) => labelKey && this.graphImportanceKey(value).includes(labelKey))) add("제목에 직접 등장");
        if (this.graphImportanceHas(values, ["제목 직접 키워드", "제목 핵심 명사", "제목 속 시기", "제목 문헌·법령 키워드", "MARC 245"])) add("제목에 직접 등장");
        if (this.graphImportanceHas(values, ["MARC 주제어", "MARC 653"])) add("MARC 주제어에 등장");
        if (this.graphImportanceHas(values, ["자료태그", "자료 태그", "주요태그", "주요 태그", "태그 별칭", "컬렉션 태그"])) add("태그에 포함");
        if (pdfValues.some((value) => labelKey && this.graphImportanceKey(value).includes(labelKey)) || this.graphImportanceHas(values, ["PDF 파일명", "PDF 원본 파일명", "원문 리소스 PDF 파일명", "resources.json/PDF 파일명"])) add("PDF 파일명에 등장");
        if (this.graphImportanceHas(values, ["관련 자료 반복", "관련자료반복", "관련 자료", "유사 자료", "유사자료", "동일 태그", "같은컬렉션"])) add("관련 자료에 반복 등장");
        if (this.graphImportanceHas(values, ["PERSONAL_NAME", "CORPORATE_NAME", "저자", "편찬자", "편찬", "발행기관", "저자·편찬", "발행·편찬기관"])) add("발행기관·저자 정보");
        if (this.graphImportanceHas(values, ["KDC", "청구기호", "분류기호", "분류/청구기호", "자료유형", "서지유형", "classification"])) add("단순 분류 후보");
        return parts;
    }

    private graphNodeImportanceScore(node: KnowledgeGraphNode | null): number {
        if (!node) return 0;
        let explicit = Number(node.importanceScore || 0);
        if (explicit > 0) return explicit;
        if (Object.prototype.hasOwnProperty.call(node as any, "__importanceScore")) return Number((node as any).__importanceScore || 0);
        let weights: any = {
            "제목에 직접 등장": 5,
            "MARC 주제어에 등장": 4,
            "태그에 포함": 4,
            "PDF 파일명에 등장": 3,
            "관련 자료에 반복 등장": 3,
            "발행기관·저자 정보": 2,
            "단순 분류 후보": 1,
        };
        let parts = this.graphNodeImportanceParts(node);
        let score = parts.reduce((sum, basis) => sum + Number(weights[basis] || 0), 0);
        (node as any).__importanceScore = score;
        (node as any).__importanceBasis = parts.length ? parts.join(" · ") : (this.text(node.priorityBasis) || "보조 후보");
        return score;
    }

    private graphNodeImportanceBasis(node: KnowledgeGraphNode | null): string {
        if (!node) return "보조 후보";
        let explicit = this.text(node.importanceBasis);
        if (explicit && Number(node.importanceScore || 0) > 0) return explicit;
        this.graphNodeImportanceScore(node);
        return this.text((node as any).__importanceBasis) || this.text(node.priorityBasis) || "보조 후보";
    }

    private graphNodeScore(node: KnowledgeGraphNode): number {
        let relations = this.graphAllRelationsForNode(node);
        let relationScore = relations.reduce((sum, relation) => sum + this.graphRelationScore(relation), 0);
        let priorityRank = this.graphNodePriorityRank(node);
        let importanceScore = this.graphNodeImportanceScore(node);
        let priorityBonus = Math.max(0, 9 - priorityRank) * 0.45;
        let sourceBonus = Math.min(6, this.graphNodeSourceCount(node)) * 0.22;
        let materialBonus = Math.min(8, this.graphNodeMaterialCount(node)) * 0.16;
        return importanceScore * 2.4
            + relationScore
            + priorityBonus
            + sourceBonus
            + materialBonus
            + (node.evidenceCount || 0) * 0.16
            + (node.relatedMaterialCount || 0) * 0.14;
    }

    private graphNodePriorityRank(node: KnowledgeGraphNode | null): number {
        if (!node) return 9;
        if (Number.isFinite(Number(node.priorityRank))) return Math.max(0, Math.min(9, Number(node.priorityRank)));
        if (node.type === "자료") return 0;
        let context = this.graphNodePriorityContext(node);
        if (context.includes("제목직접키워드") || context.includes("제목키워드")) return 1;
        if (context.includes("자료태그") || context.includes("주요태그")) return 2;
        if (context.includes("marc주제어")) return 3;
        if (context.includes("personal_name") || context.includes("corporate_name") || context.includes("저자") || context.includes("편찬") || context.includes("발행기관") || context.includes("기관후보")) return 4;
        if (context.includes("pdf파일명") || context.includes("pdf파일이다")) return 5;
        if (context.includes("동일태그") || context.includes("유사자료") || context.includes("관련자료반복")) return 6;
        if (context.includes("컬렉션태그") || context.includes("관련컬렉션") || context.includes("컬렉션통제어휘")) return 7;
        if (context.includes("청구기호") || context.includes("kdc") || context.includes("분류기호") || context.includes("분류/청구기호")) return 8;
        return 9;
    }

    private graphNodePriorityContext(node: KnowledgeGraphNode): string {
        let values = [
            node.sourceField,
            node.detail,
            node.pdfFilename,
            node.type,
            node.label,
        ];
        this.graphAllRelationsForNode(node).forEach((relation) => {
            values.push(relation.sourceField);
            values.push(this.relationTypeLabel(relation));
            values.push(relation.extractionMethod);
            values.push(relation.sentence);
        });
        return values
            .map((value) => this.normalizeStatusText(this.text(value)).toLocaleLowerCase())
            .filter((value) => value)
            .join(" ");
    }

    public graphNodeSourceCount(node: KnowledgeGraphNode | null): number {
        if (!node) return 0;
        if (Number(node.sourceCount || 0) > 0) return Number(node.sourceCount || 0);
        let sources = new Set<string>();
        this.graphNodeSourceFields(node).forEach((value) => sources.add(value));
        this.graphAllRelationsForNode(node).forEach((relation) => {
            let sourceField = this.normalizeGraphSourceKey(relation.sourceField);
            if (sourceField) sources.add(sourceField);
            let chunkId = this.text(relation.chunkId);
            if (chunkId && !chunkId.startsWith("metadata:")) sources.add(`chunk:${chunkId}`);
            let materialId = this.normalizeGraphMaterialId(relation.materialId);
            if (materialId) sources.add(`material:${materialId}`);
        });
        (node.materialIds || []).forEach((materialId) => {
            materialId = this.normalizeGraphMaterialId(materialId);
            if (materialId) sources.add(`material:${materialId}`);
        });
        if (!sources.size && node.evidenceCount > 0) sources.add("evidence");
        if (!sources.size && this.graphNodeConnectionCount(node) > 0) sources.add("relation");
        return sources.size;
    }

    private graphNodeSourceFields(node: KnowledgeGraphNode | null): string[] {
        if (!node) return [];
        return this.text(node.sourceField)
            .split(" · ")
            .map((value) => this.normalizeGraphSourceKey(value))
            .filter((value) => value);
    }

    private normalizeGraphSourceKey(value: string | null | undefined): string {
        return this.normalizeStatusText(this.text(value)).toLocaleLowerCase();
    }

    private graphRelationDisplayLimit(total: number): number {
        if (this.graphExpanded && this.isDefaultBookGraphLayout()) return Math.min(96, total);
        if (this.graphNodeTypeFilter || this.graphSearchQuery || this.graphRelationStatusFilter !== "전체") return Math.min(52, total);
        if (total > 90) return 46;
        if (total > 56) return 50;
        return 52;
    }

    private graphNodeDisplayLimit(total: number): number {
        if (this.graphExpanded && this.isDefaultBookGraphLayout()) return Math.min(60, total);
        if (this.graphNodeTypeFilter || this.graphSearchQuery || this.graphRelationStatusFilter !== "전체") return Math.min(30, total);
        if (total > 44) return 36;
        if (total > 30) return 34;
        return 32;
    }

    private clampGraphZoom(value: number): number {
        value = Number(value || 1);
        if (!Number.isFinite(value)) value = 1;
        return Math.round(Math.max(0.86, Math.min(1.22, value)) * 100) / 100;
    }

    private zoomPosition(position: GraphLayoutPoint, zoom: number, minX: number, maxX: number, minY: number, maxY: number): GraphLayoutPoint {
        zoom = this.clampGraphZoom(zoom);
        return {
            x: Math.max(minX, Math.min(maxX, 50 + (position.x - 50) * zoom)),
            y: Math.max(minY, Math.min(maxY, 50 + (position.y - 50) * zoom)),
        };
    }

    private graphSemanticGroup(node: KnowledgeGraphNode | null): GraphSemanticGroup {
        if (!node) return "concept";
        let type = this.text(node.type);
        let id = this.text(node.id);
        if (id.startsWith("collection:") || type === "자료") return "source";
        if (type === "주제") return "topic";
        if (type === "관련 자료" || type === "근거 후보" || id.startsWith("material:") || id.startsWith("evidence:") || id.startsWith("chunk:") || id.startsWith("alias:")) return "support";
        if (type.includes("장소") || type.includes("지역") || type.includes("공간")) return "place";
        if (type.includes("사건") || type.includes("시대") || type.includes("국가")) return "event";
        if (type.includes("인물") || type.includes("기관") || type.includes("단체")) return "actor";
        return "concept";
    }

    private graphGroupOrder(): GraphSemanticGroup[] {
        return ["topic", "place", "event", "actor", "concept", "support"];
    }

    private balanceGraphNodes(nodes: KnowledgeGraphNode[], groups: GraphSemanticGroup[], capacity: number, maxTotal: number): KnowledgeGraphNode[] {
        let result: KnowledgeGraphNode[] = [];
        let used = new Set<string>();
        groups.forEach((group) => {
            nodes.filter((node) => this.graphSemanticGroup(node) === group)
                .slice(0, capacity)
                .forEach((node) => {
                    if (used.has(node.id) || result.length >= maxTotal) return;
                    used.add(node.id);
                    result.push(node);
                });
        });
        if (!result.length && nodes.length > 0) {
            nodes.forEach((node) => {
                if (used.has(node.id) || result.length >= maxTotal) return;
                used.add(node.id);
                result.push(node);
            });
        }
        return result;
    }

    private graphNodesForGroup(nodes: KnowledgeGraphNode[], group: GraphSemanticGroup): KnowledgeGraphNode[] {
        return nodes.filter((node) => this.graphSemanticGroup(node) === group);
    }

    private gridPosition(index: number, count: number, minX: number, maxX: number, minY: number, maxY: number, maxColumns: number): GraphLayoutPoint {
        count = Math.max(1, count || 1);
        maxColumns = Math.max(1, maxColumns || 1);
        let columns = Math.min(maxColumns, count);
        let rows = Math.ceil(count / columns);
        let column = index % columns;
        let row = Math.floor(index / columns);
        let x = columns <= 1 ? (minX + maxX) / 2 : minX + ((maxX - minX) * column / (columns - 1));
        let y = rows <= 1 ? (minY + maxY) / 2 : minY + ((maxY - minY) * row / (rows - 1));
        if (rows > 1 && Math.abs(maxY - minY) < 0.001) {
            y = minY + (row - (rows - 1) / 2) * 26;
        }
        return { x, y };
    }

    private bookFocusPosition(index: number, count: number): GraphLayoutPoint {
        let maxColumns = count <= 9 ? 3 : 4;
        return this.gridPosition(index, count, 32, 92, 14, 86, maxColumns);
    }

    private bookGraphDefaultNodeLimit(total: number): number {
        if (this.graphExpanded) return Math.min(40, total);
        if (total > 34) return 22;
        if (total > 28) return 22;
        if (total > 22) return 22;
        if (total > 16) return 22;
        return Math.min(24, total);
    }

    private balanceBookRadialNodes(nodes: KnowledgeGraphNode[], maxTotal: number): KnowledgeGraphNode[] {
        let capacities: any = {
            topic: this.graphExpanded ? 10 : 8,
            place: this.graphExpanded ? 6 : 5,
            event: this.graphExpanded ? 6 : 5,
            actor: this.graphExpanded ? 6 : 4,
            concept: this.graphExpanded ? 10 : 7,
            support: this.graphExpanded ? 8 : 6,
        };
        let result: KnowledgeGraphNode[] = [];
        let used = new Set<string>();
        this.graphGroupOrder().forEach((group) => {
            this.graphNodesForGroup(nodes, group)
                .slice(0, capacities[group] || 3)
                .forEach((node) => {
                    if (used.has(node.id) || result.length >= maxTotal) return;
                    used.add(node.id);
                    result.push(node);
                });
        });
        if (result.length < Math.min(maxTotal, nodes.length)) {
            nodes.forEach((node) => {
                if (used.has(node.id) || result.length >= maxTotal) return;
                used.add(node.id);
                result.push(node);
            });
        }
        return this.uniqueGraphNodesForDisplay(result.concat(nodes), true).slice(0, maxTotal);
    }

    private bookGraphRing(node: KnowledgeGraphNode | null): BookGraphRing {
        if (!node) return "inner";
        let type = this.normalizeGraphNodeType(this.text(node.nodeType || node.type));
        let group = this.graphSemanticGroup(node);
        let sourceField = this.normalizeStatusText(this.text(node.sourceField));
        let labelKey = this.graphLabelKey(node.label);
        if (this.isEvidenceNodeType(node) || this.isGraphStatusOnlyNode(node)) return "outer";
        if (sourceField.includes("관련컬렉션") || labelKey.includes("컬렉션")) return "outer";
        if (type === "관련 자료" || group === "support" || this.isBookMaterialCardNode(node)) return "outer";
        if (type === "문헌·법령" || group === "actor") return "middle";
        return "inner";
    }

    private bookGraphLayoutRing(node: KnowledgeGraphNode | null, nodes: KnowledgeGraphNode[]): BookGraphRing {
        if (!node) return "inner";
        let baseRing = this.bookGraphRing(node);
        if (baseRing === "outer") return "outer";
        let shape = this.graphNodeShape(node);
        let group = this.graphSemanticGroup(node);
        let groupNodes = nodes.filter((item) => this.graphSemanticGroup(item) === group);
        let groupIndex = Math.max(0, groupNodes.findIndex((item) => item.id === node.id));
        let band = Math.floor(groupIndex / this.bookGroupAngularSlots(group));
        if (shape === "material-card" || shape === "small-card" || this.isEvidenceNodeType(node)) return "outer";
        if (band >= 2) return "outer";
        if (band >= 1 || shape === "capsule" || baseRing === "middle") return "middle";
        return "inner";
    }

    private isBookMaterialCardNode(node: KnowledgeGraphNode | null): boolean {
        if (!node) return false;
        let shape = this.graphNodeShape(node);
        let type = this.normalizeGraphNodeType(this.text(node.nodeType || node.type));
        return shape === "material-card" || shape === "small-card" || type === "관련 자료";
    }

    private bookRingBounds(ring: BookGraphRing): { minX: number, maxX: number, minY: number, maxY: number } {
        if (ring === "inner") return { minX: 23, maxX: 77, minY: 20, maxY: 80 };
        if (ring === "middle") return { minX: 16, maxX: 84, minY: 12, maxY: 88 };
        return { minX: 10, maxX: 90, minY: 8, maxY: 92 };
    }

    private bookNodeSafeBounds(node: KnowledgeGraphNode, ring: BookGraphRing): { minX: number, maxX: number, minY: number, maxY: number } {
        let bounds = this.bookRingBounds(ring);
        let visual = this.graphNodeVisualBounds(node);
        let margin = this.graphNodeShape(node) === "small-card" ? 2.1 : 1.6;
        return {
            minX: Math.min(49, Math.max(bounds.minX, visual.halfX + margin)),
            maxX: Math.max(51, Math.min(bounds.maxX, 100 - visual.halfX - margin)),
            minY: Math.min(49, Math.max(bounds.minY, visual.halfY + margin)),
            maxY: Math.max(51, Math.min(bounds.maxY, 100 - visual.halfY - margin)),
        };
    }

    private bookGraphSector(group: GraphSemanticGroup): BookGraphSector {
        let sectors: any = {
            topic: { start: -128, end: -48, center: -88 },
            place: { start: -30, end: 28, center: 0 },
            event: { start: 42, end: 84, center: 63 },
            actor: { start: 92, end: 122, center: 107 },
            concept: { start: 130, end: 162, center: 146 },
            support: { start: 192, end: 304, center: 248 },
            source: { start: -90, end: -90, center: -90 },
        };
        return sectors[group] || sectors.concept;
    }

    private bookGroupAngularSlots(group: GraphSemanticGroup): number {
        let slots: any = {
            topic: 3,
            place: 3,
            event: 2,
            actor: 2,
            concept: 2,
            support: 6,
        };
        return slots[group] || 2;
    }

    private bookSectorAngle(index: number, count: number, sector: BookGraphSector): number {
        count = Math.max(1, count || 1);
        if (count <= 1) return sector.center;
        let padding = count >= 4 ? 4 : 7;
        let start = sector.start + padding;
        let end = sector.end - padding;
        if (end <= start) {
            start = sector.start;
            end = sector.end;
        }
        return start + (end - start) * index / (count - 1);
    }

    private bookNodeRadius(node: KnowledgeGraphNode, band: number, groupCount: number, ring: BookGraphRing = "inner"): { radiusX: number, radiusY: number } {
        let shape = this.graphNodeShape(node);
        let group = this.graphSemanticGroup(node);
        let size = this.graphNodeSizeTier(node);
        let labelLength = this.text(node.label).replace(/\s+/g, "").length;
        let denseBoost = groupCount > this.bookGroupAngularSlots(group) ? 0.8 : 0;
        let radiusBase: any = {
            inner: { x: 25.2, y: 24.4 },
            middle: { x: 33.4, y: 32.2 },
            outer: { x: 40.2, y: 38.6 },
        };
        let radiusX = (radiusBase[ring]?.x || radiusBase.inner.x) + denseBoost;
        let radiusY = (radiusBase[ring]?.y || radiusBase.inner.y) + denseBoost;

        if (shape === "small-card" || shape === "material-card" || group === "support") {
            radiusX = ring === "outer" ? 39.8 : 34.4;
            radiusY = ring === "outer" ? 38.2 : 32.6;
            if (labelLength >= 14) {
                radiusX += 1.1;
                radiusY += 0.9;
            }
        } else if (shape === "capsule") {
            radiusX += ring === "inner" ? 1.8 : 0.8;
            radiusY += ring === "inner" ? 1.6 : 0.6;
        } else if (shape === "compact" || shape === "dot") {
            radiusX = ring === "outer" ? 39.6 : 33.2;
            radiusY = ring === "outer" ? 37.6 : 31.8;
        } else if (labelLength >= 14) {
            radiusX += 0.8;
            radiusY += 0.8;
        }
        if (shape === "circle" && size === "large") {
            radiusX += ring === "inner" ? 1.5 : 1.9;
            radiusY += ring === "inner" ? 1.5 : 1.9;
        } else if (shape === "circle" && size === "small") {
            radiusX -= 0.8;
            radiusY -= 0.8;
        }

        radiusX += band * (shape === "circle" ? 3.2 : 2.6);
        radiusY += band * (shape === "circle" ? 3.2 : 2.6);
        return {
            radiusX: Math.min(42.4, radiusX),
            radiusY: Math.min(40.8, radiusY),
        };
    }

    private bookCenterClearance(node: KnowledgeGraphNode | null): number {
        let shape = this.graphNodeShape(node);
        if (shape === "material-card") return 23.8;
        if (shape === "small-card") return 23.4;
        if (shape === "capsule") return 21.2;
        if (shape === "compact") return 20.2;
        if (shape === "dot") return 18.8;
        if (shape === "circle") {
            let size = this.graphNodeSizeTier(node);
            if (size === "large") return 23.2;
            if (size === "small") return 20.6;
        }
        return 21.8;
    }

    private enforceBookCenterClearance(point: GraphLayoutPoint, node: KnowledgeGraphNode, nodes: KnowledgeGraphNode[]): GraphLayoutPoint {
        let bounds = this.bookNodeSafeBounds(node, this.bookGraphLayoutRing(node, nodes));
        let dx = point.x - 50;
        let dy = point.y - 50;
        let distance = Math.sqrt(dx * dx + dy * dy);
        let minimum = this.bookCenterClearance(node);
        if (distance >= minimum) return this.clampGraphPoint(point, bounds);
        let fallback = this.bookGraphSector(this.graphSemanticGroup(node)).center * Math.PI / 180;
        let ux = distance > 0.001 ? dx / distance : Math.cos(fallback);
        let uy = distance > 0.001 ? dy / distance : Math.sin(fallback);
        return this.clampGraphPoint({
            x: 50 + ux * minimum,
            y: 50 + uy * minimum,
        }, bounds);
    }

    private normalizeBookCollisionPoint(point: GraphLayoutPoint, node: KnowledgeGraphNode, nodes: KnowledgeGraphNode[]): GraphLayoutPoint {
        return this.enforceBookCenterClearance(point, node, nodes);
    }

    private bookBalancedRadialOrder(nodes: KnowledgeGraphNode[]): KnowledgeGraphNode[] {
        let buckets: any = {};
        this.graphGroupOrder().forEach((group) => buckets[group] = []);
        nodes.forEach((node) => {
            let group = this.graphSemanticGroup(node);
            if (!buckets[group]) buckets[group] = [];
            buckets[group].push(node);
        });

        Object.keys(buckets).forEach((group) => {
            buckets[group].sort((a: KnowledgeGraphNode, b: KnowledgeGraphNode) => {
                return this.graphNodeScore(b) - this.graphNodeScore(a) || a.label.localeCompare(b.label, "ko");
            });
        });

        let order: KnowledgeGraphNode[] = [];
        let groups = this.graphGroupOrder();
        let maxLength = Math.max(0, ...groups.map((group) => buckets[group].length));
        for (let index = 0; index < maxLength; index++) {
            groups.forEach((group) => {
                if (buckets[group][index]) order.push(buckets[group][index]);
            });
        }
        return order.length ? order : nodes;
    }

    private bookBalancedRadialAngle(node: KnowledgeGraphNode, nodes: KnowledgeGraphNode[]): number {
        let order = this.bookBalancedRadialOrder(nodes);
        let index = Math.max(0, order.findIndex((item) => item.id === node.id));
        let count = Math.max(1, order.length);
        if (count === 1) return -90;
        let step = 360 / count;
        let angle = -96 + index * step;
        if (count <= 5) angle -= step * 0.18;
        return angle;
    }

    private bookRadialBasePosition(node: KnowledgeGraphNode, index: number, nodes: KnowledgeGraphNode[], ring?: BookGraphRing): GraphLayoutPoint {
        let layoutRing = ring || this.bookGraphLayoutRing(node, nodes);
        let group = this.graphSemanticGroup(node);
        let groupNodes = nodes.filter((item) => this.graphSemanticGroup(item) === group);
        let groupIndex = Math.max(0, groupNodes.findIndex((item) => item.id === node.id));
        let slots = this.bookGroupAngularSlots(group);
        let band = Math.floor(groupIndex / slots);
        let bandIndex = groupIndex - band * slots;
        let bandCount = Math.min(slots, Math.max(1, groupNodes.length - band * slots));
        let angle = this.bookSectorAngle(bandIndex, bandCount, this.bookGraphSector(group));
        if (layoutRing === "middle") angle += 5;
        if (layoutRing === "outer") angle += 10;
        if (band > 0) {
            let bandOffset = group === "support" ? 16 : 11;
            angle += band % 2 === 1 ? bandOffset : -bandOffset;
        }
        let radii = this.bookNodeRadius(node, band, groupNodes.length, layoutRing);

        let radians = angle * Math.PI / 180;
        let point = {
            x: 50 + Math.cos(radians) * radii.radiusX,
            y: 50 + Math.sin(radians) * radii.radiusY,
        };
        return this.enforceBookCenterClearance(
            this.clampGraphPoint(point, this.bookNodeSafeBounds(node, layoutRing)),
            node,
            nodes
        );
    }

    private bookNodeCollisionDistance(node: KnowledgeGraphNode | null): number {
        let shape = this.graphNodeShape(node);
        if (shape === "material-card") return 23.5;
        if (shape === "small-card") return 21.8;
        if (shape === "capsule") return 17.2;
        if (shape === "compact") return 9.5;
        if (shape === "dot") return 8.8;
        if (shape === "circle") {
            let size = this.graphNodeSizeTier(node);
            if (size === "large") return 21.2;
            if (size === "small") return 14.6;
            return 16.8;
        }
        return this.text(node?.label).replace(/\s+/g, "").length >= 14 ? 18 : 16.8;
    }

    private resolveBookRadialCollisions(items: Array<{ node: KnowledgeGraphNode, point: GraphLayoutPoint }>, nodes: KnowledgeGraphNode[]): Array<{ node: KnowledgeGraphNode, point: GraphLayoutPoint }> {
        let rows = items.map((item) => {
            let ring = this.bookGraphLayoutRing(item.node, nodes);
            return {
                node: item.node,
                point: this.clampGraphPoint({ x: item.point.x, y: item.point.y }, this.bookNodeSafeBounds(item.node, ring)),
            };
        });
        for (let pass = 0; pass < 24; pass++) {
            for (let i = 0; i < rows.length; i++) {
                for (let j = i + 1; j < rows.length; j++) {
                    let a = rows[i].point;
                    let b = rows[j].point;
                    let minimum = Math.max(this.bookNodeCollisionDistance(rows[i].node), this.bookNodeCollisionDistance(rows[j].node));
                    if (this.graphSemanticGroup(rows[i].node) === this.graphSemanticGroup(rows[j].node)) minimum += 1.9;
                    let weightedDx = (a.x - b.x) * 1.18;
                    let dy = a.y - b.y;
                    let distance = Math.sqrt(weightedDx * weightedDx + dy * dy);
                    if (distance >= minimum) continue;
                    let fallbackAngle = ((i + j + pass + 1) * 137.5) * Math.PI / 180;
                    let ux = distance > 0.001 ? weightedDx / distance : Math.cos(fallbackAngle);
                    let uy = distance > 0.001 ? dy / distance : Math.sin(fallbackAngle);
                    let push = (minimum - distance) / 2 + 0.55;
                    a.x += ux * push / 1.18;
                    b.x -= ux * push / 1.18;
                    a.y += uy * push;
                    b.y -= uy * push;
                    rows[i].point = this.normalizeBookCollisionPoint(a, rows[i].node, nodes);
                    rows[j].point = this.normalizeBookCollisionPoint(b, rows[j].node, nodes);
                }
            }
        }
        return rows;
    }

    private resolveBookNodeOverlaps(items: Array<{ node: KnowledgeGraphNode, point: GraphLayoutPoint }>, nodes: KnowledgeGraphNode[]): Array<{ node: KnowledgeGraphNode, point: GraphLayoutPoint }> {
        let rows = items.map((item) => ({
            node: item.node,
            point: this.normalizeBookCollisionPoint({ x: item.point.x, y: item.point.y }, item.node, nodes),
        }));
        for (let pass = 0; pass < 24; pass++) {
            let moved = false;
            for (let i = 0; i < rows.length; i++) {
                for (let j = i + 1; j < rows.length; j++) {
                    let a = rows[i].point;
                    let b = rows[j].point;
                    let aBounds = this.graphNodeVisualBounds(rows[i].node);
                    let bBounds = this.graphNodeVisualBounds(rows[j].node);
                    let gap = this.graphSemanticGroup(rows[i].node) === this.graphSemanticGroup(rows[j].node) ? 2.1 : 1.75;
                    let minX = aBounds.halfX + bBounds.halfX + gap;
                    let minY = aBounds.halfY + bBounds.halfY + gap;
                    let dx = b.x - a.x;
                    let dy = b.y - a.y;
                    let absX = Math.abs(dx);
                    let absY = Math.abs(dy);
                    if (absX >= minX || absY >= minY) continue;

                    let overlapX = minX - absX;
                    let overlapY = minY - absY;
                    let fallbackAngle = ((i + j + pass + 1) * 137.5) * Math.PI / 180;
                    let signX = absX > 0.001 ? Math.sign(dx) : Math.sign(Math.cos(fallbackAngle) || 1);
                    let signY = absY > 0.001 ? Math.sign(dy) : Math.sign(Math.sin(fallbackAngle) || 1);
                    let separateByX = (overlapX / Math.max(minX, 0.001)) <= (overlapY / Math.max(minY, 0.001));
                    if (separateByX) {
                        let push = overlapX / 2 + 0.65;
                        a.x -= signX * push;
                        b.x += signX * push;
                        a.y -= signY * 0.08;
                        b.y += signY * 0.08;
                    } else {
                        let push = overlapY / 2 + 0.65;
                        a.y -= signY * push;
                        b.y += signY * push;
                        a.x -= signX * 0.08;
                        b.x += signX * 0.08;
                    }
                    rows[i].point = this.normalizeBookCollisionPoint(a, rows[i].node, nodes);
                    rows[j].point = this.normalizeBookCollisionPoint(b, rows[j].node, nodes);
                    moved = true;
                }
            }
            if (!moved) break;
        }
        return rows;
    }

    private bookRadialPositionMap(nodes: KnowledgeGraphNode[]): any {
        let rows = nodes.map((node, index) => ({
            node: node,
            point: this.bookRadialBasePosition(node, index, nodes, this.bookGraphLayoutRing(node, nodes)),
        }));
        let adjusted = this.resolveBookNodeOverlaps(this.resolveBookRadialCollisions(rows, nodes), nodes);
        let result: any = {};
        adjusted.forEach((item) => result[item.node.id] = item.point);
        return result;
    }

    private graphNodePositionForNode(node: KnowledgeGraphNode, nodes: KnowledgeGraphNode[]): GraphLayoutPoint {
        let index = nodes.findIndex((item) => item.id === node.id);
        if (index < 0) index = 0;
        if (this.graphNodeTypeFilter || this.graphSearchQuery || this.graphRelationStatusFilter !== "전체") {
            return this.zoomPosition(this.bookFocusPosition(index, nodes.length), this.graphZoom, 28, 94, 4, 94);
        }
        let ring = this.bookGraphLayoutRing(node, nodes);
        let positions = this.bookRadialPositionMap(nodes);
        let position = positions[node.id] || this.bookRadialBasePosition(node, index, nodes.length ? nodes : [node], ring);
        let bounds = this.bookNodeSafeBounds(node, ring);
        return this.zoomPosition(position, this.graphZoom, bounds.minX, bounds.maxX, bounds.minY, bounds.maxY);
    }

    public graphCentralNodeStyle(): any {
        return {
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
        };
    }

    public graphNodeStyle(book: BookItem, node: KnowledgeGraphNode, index: number, count: number): any {
        let position = this.graphNodePositionForNode(node, this.graphSurroundingNodes(book));
        return {
            left: `${position.x}%`,
            top: `${position.y}%`,
            transform: "translate(-50%, -50%)",
        };
    }

    public graphNodeClass(node: KnowledgeGraphNode): string {
        return this.graphNodeClassTokens(node).join(" ");
    }

    private graphNodeClassTokens(node: KnowledgeGraphNode): string[] {
        let typeClass = "type-" + this.text(node.type).replace(/[^0-9A-Za-z가-힣]/g, "-");
        let group = this.graphSemanticGroup(node);
        let shape = this.graphNodeShape(node);
        let classes = [typeClass, `group-${group}`, `shape-${shape}`, `size-${this.graphNodeSizeTier(node)}`, `priority-${this.graphNodePriorityRank(node)}`];
        let labelLength = this.text(node.label).replace(/\s+/g, "").length;
        if (labelLength >= 9) classes.push("is-long-label");
        if (labelLength >= 14) classes.push("is-very-long-label");
        classes.push(this.isCompactKnowledgeGraphNode(node) ? "is-compact-node" : "is-card-node");
        return classes;
    }

    private graphNodeShape(node: KnowledgeGraphNode | null): GraphNodeShape {
        if (!node) return "circle";
        let type = this.normalizeGraphNodeType(this.text(node.nodeType || node.type));
        let id = this.text(node.id);
        if (node.displayShape === "central-topic") return "central-topic";
        if (id.startsWith("collection:")) return "central-topic";
        if (type === "자료") return "material-card";
        if (type === "관련 자료") return "small-card";
        if (type === "인물" || type === "기관") return "capsule";
        if (type === "근거 후보" || id.startsWith("evidence:") || id.startsWith("chunk:") || id.startsWith("alias:")) return "dot";
        return "circle";
    }

    private graphNodeSizeTier(node: KnowledgeGraphNode | null): GraphNodeSizeTier {
        if (!node) return "medium";
        if (node.sizeTier) return node.sizeTier;
        let shape = this.graphNodeShape(node);
        let type = this.normalizeGraphNodeType(this.text(node.nodeType || node.type));
        if (shape === "material-card") return "medium";
        if (shape === "small-card" || shape === "compact" || shape === "dot") return "small";

        let sourceCount = this.graphNodeSourceCount(node);
        let materialCount = this.graphNodeMaterialCount(node);
        let connectionCount = this.graphNodeConnectionCount(node);
        let evidenceCount = Number(node.evidenceCount || 0);
        let priorityRank = this.graphNodePriorityRank(node);

        if (type === "주제" && (sourceCount >= 3 || connectionCount >= 6 || evidenceCount >= 4 || priorityRank <= 2 && connectionCount >= 3)) {
            return "large";
        }
        if (materialCount >= 3 || sourceCount >= 2 || connectionCount >= 3 || evidenceCount >= 2 || priorityRank <= 2) {
            return "medium";
        }
        return "small";
    }

    public graphNodeMetricLabel(node: KnowledgeGraphNode | null): string {
        if (!node) return "출처 0건";
        if (this.text(node.displayMetricLabel)) return this.text(node.displayMetricLabel);
        if (this.isGraphMaterialNode(node)) {
            let count = Math.max(1, this.graphNodeMaterialCount(node));
            return node.type === "관련 자료" ? `관련 자료 ${count}건` : `연결 ${this.graphNodeConnectionCount(node)}건`;
        }
        let materialCount = this.graphNodeMaterialCount(node);
        if (materialCount > 1) return `관련 자료 ${materialCount}건`;
        return `출처 ${Math.max(1, this.graphNodeSourceCount(node))}건`;
    }

    public graphNodeImportanceLabel(node: KnowledgeGraphNode | null): string {
        if (!node) return "0점 · 보조 후보";
        let score = this.graphNodeImportanceScore(node);
        let basis = this.graphNodeImportanceBasis(node);
        return `${score}점 · ${basis}`;
    }

    public graphNodeEvidenceStateLabel(node: KnowledgeGraphNode | null): string {
        let status = this.graphNodeEvidenceStatus(node);
        if (status === GRAPH_BODY_EVIDENCE_COMPLETE_STATUS) return "본문 근거";
        if (status === GRAPH_BODY_EVIDENCE_PENDING_STATUS) return "근거 대기";
        return status || "근거 상태 없음";
    }

    private isCompactKnowledgeGraphNode(node: KnowledgeGraphNode | null): boolean {
        if (!node) return false;
        let type = this.text(node.type);
        let id = this.text(node.id);
        if (type === "근거 후보") return true;
        if (id.startsWith("alias:") || id.startsWith("evidence:") || id.startsWith("chunk:")) return true;
        return false;
    }

    public graphLinkSegments(book: BookItem): GraphLinkSegment[] {
        if (!this.knowledgeGraph) return [];
        let central = this.graphCentralNode();
        let surrounding = this.graphSurroundingNodes(book);
        let positions: any = {};
        let nodesById: any = {};
        if (central) positions[central.id] = { x: 50, y: 50 };
        if (central) nodesById[central.id] = central;
        surrounding.forEach((node) => {
            positions[node.id] = this.graphNodePositionForNode(node, surrounding);
            nodesById[node.id] = node;
        });

        let seen: any = {};
        let segments: GraphLinkSegment[] = [];
        for (let relation of this.graphDisplayRelations(book)) {
            let source = positions[relation.source];
            let target = positions[relation.target];
            if (!source || !target) continue;
            let key = `${relation.source}:${relation.target}`;
            if (seen[key]) continue;
            seen[key] = true;
            let sourceNode = nodesById[relation.source] || null;
            let targetNode = nodesById[relation.target] || null;
            segments.push({
                id: relation.id,
                relation: relation,
                sourceNode: sourceNode,
                targetNode: targetNode,
                x1: source.x,
                y1: source.y,
                x2: target.x,
                y2: target.y,
                curveOffset: this.graphRelationCurveOffset(source, target, relation, segments.length),
            });
            if (segments.length >= 36) break;
        }
        return segments;
    }

    public graphLinkClass(relation: KnowledgeGraphRelation): string {
        let classes = ["graph-link"];
        classes = classes.concat(this.graphRelationStateClassTokens(relation));
        let isSelected = this.isGraphRelationSelected(relation);
        let isDirect = this.isGraphRelationDirect(relation);
        if (isSelected) classes.push("is-selected");
        else if (isDirect) classes.push("is-direct");
        if (this.isBookCentralRelation(relation)) classes.push("is-central-direct");
        if (this.isGraphRelationHovered(relation)) classes.push("is-hovered");
        if (this.isGraphSelectionActive() && !isSelected && !isDirect) classes.push("is-dimmed");
        return classes.join(" ");
    }

    public graphLinkPath(segment: GraphLinkSegment): string {
        let points = this.graphLinkRenderPoints(segment);
        if (points.curved) {
            return `M ${points.x1} ${points.y1} Q ${points.cx} ${points.cy} ${points.x2} ${points.y2}`;
        }
        return `M ${points.x1} ${points.y1} L ${points.x2} ${points.y2}`;
    }

    private exportGraphPath(source: { x: number, y: number, node?: KnowledgeGraphNode }, target: { x: number, y: number, node?: KnowledgeGraphNode }, relation?: KnowledgeGraphRelation, index: number = 0): string {
        let segment: GraphLinkSegment = {
            id: relation?.id || `${source.x}:${source.y}:${target.x}:${target.y}`,
            relation: relation || ({} as KnowledgeGraphRelation),
            sourceNode: source.node || null,
            targetNode: target.node || null,
            x1: source.x,
            y1: source.y,
            x2: target.x,
            y2: target.y,
            curveOffset: this.graphRelationCurveOffset(source, target, relation || null, index),
        };
        let points = this.graphLinkRenderPoints(segment);
        if (points.curved) return `M ${points.x1} ${points.y1} Q ${points.cx} ${points.cy} ${points.x2} ${points.y2}`;
        return `M ${points.x1} ${points.y1} L ${points.x2} ${points.y2}`;
    }

    private graphLinkRenderPoints(segment: GraphLinkSegment): GraphLinkRenderPoints {
        let source = this.graphNodeBoundaryPoint(
            { x: segment.x1, y: segment.y1 },
            { x: segment.x2, y: segment.y2 },
            segment.sourceNode || null,
            "source"
        );
        let target = this.graphNodeBoundaryPoint(
            { x: segment.x2, y: segment.y2 },
            { x: segment.x1, y: segment.y1 },
            segment.targetNode || null,
            "target"
        );
        let dx = target.x - source.x;
        let dy = target.y - source.y;
        let distance = Math.sqrt(dx * dx + dy * dy);
        if (!Number.isFinite(distance) || distance <= 0.001) {
            return { x1: source.x, y1: source.y, x2: target.x, y2: target.y, cx: source.x, cy: source.y, curved: false };
        }
        let offset = Number(segment.curveOffset || 0);
        let curved = Math.abs(offset) > 0.05 && distance > 18;
        let midX = (source.x + target.x) / 2;
        let midY = (source.y + target.y) / 2;
        let cx = midX + (-dy / distance) * offset;
        let cy = midY + (dx / distance) * offset;
        return {
            x1: this.roundGraphPoint(source.x),
            y1: this.roundGraphPoint(source.y),
            x2: this.roundGraphPoint(target.x),
            y2: this.roundGraphPoint(target.y),
            cx: this.roundGraphPoint(cx),
            cy: this.roundGraphPoint(cy),
            curved: curved,
        };
    }

    private graphNodeBoundaryPoint(center: GraphLayoutPoint, other: GraphLayoutPoint, node: KnowledgeGraphNode | null, role: "source" | "target"): GraphLayoutPoint {
        let dx = other.x - center.x;
        let dy = other.y - center.y;
        let distance = Math.sqrt(dx * dx + dy * dy);
        if (!Number.isFinite(distance) || distance <= 0.001) {
            return { x: center.x, y: center.y };
        }
        let ux = dx / distance;
        let uy = dy / distance;
        let bounds = this.graphNodeVisualBounds(node);
        let inset = 0;
        if (bounds.mode === "rect") {
            let tx = Math.abs(ux) > 0.001 ? bounds.halfX / Math.abs(ux) : Number.POSITIVE_INFINITY;
            let ty = Math.abs(uy) > 0.001 ? bounds.halfY / Math.abs(uy) : Number.POSITIVE_INFINITY;
            inset = Math.min(tx, ty);
        } else {
            inset = 1 / Math.sqrt((ux * ux) / (bounds.halfX * bounds.halfX) + (uy * uy) / (bounds.halfY * bounds.halfY));
        }
        if (!Number.isFinite(inset) || inset <= 0.001) {
            inset = Math.min(role === "source" ? 4.8 : 5.4, distance * (role === "source" ? 0.18 : 0.22));
        }
        let gap = role === "target" ? bounds.targetGap : bounds.sourceGap;
        let maxInset = Math.max(0, distance * 0.46);
        inset = Math.min(inset + gap, maxInset);
        return {
            x: this.roundGraphPoint(center.x + ux * inset),
            y: this.roundGraphPoint(center.y + uy * inset),
        };
    }

    private graphNodeVisualBounds(node: KnowledgeGraphNode | null): { halfX: number, halfY: number, mode: "rect" | "ellipse", sourceGap: number, targetGap: number } {
        let shape = this.graphNodeShape(node);
        let labelLength = this.text(node?.label).replace(/\s+/g, "").length;
        let isCentralMaterial = !!(node && this.graphCentralNode()?.id === node.id && shape === "material-card");
        if (isCentralMaterial) return { halfX: 10.8, halfY: 6.4, mode: "rect", sourceGap: 0.65, targetGap: 1 };
        if (shape === "material-card") return { halfX: labelLength >= 14 ? 11.2 : 10.1, halfY: labelLength >= 14 ? 6.9 : 6.1, mode: "rect", sourceGap: 0.6, targetGap: 1.05 };
        if (shape === "small-card") return { halfX: labelLength >= 9 ? 9.1 : 8.1, halfY: labelLength >= 9 ? 5.2 : 4.4, mode: "rect", sourceGap: 0.55, targetGap: 0.95 };
        if (shape === "central-topic") return { halfX: 10.2, halfY: 10.2, mode: "ellipse", sourceGap: 0.8, targetGap: 1.25 };
        if (shape === "capsule") return { halfX: labelLength >= 14 ? 8.8 : 7, halfY: labelLength >= 9 ? 4.5 : 3.5, mode: "ellipse", sourceGap: 0.5, targetGap: 0.95 };
        if (shape === "compact") return { halfX: labelLength >= 9 ? 6 : 4.8, halfY: 2.9, mode: "ellipse", sourceGap: 0.4, targetGap: 0.8 };
        if (shape === "dot") return { halfX: 4.2, halfY: 2.5, mode: "ellipse", sourceGap: 0.35, targetGap: 0.7 };
        let size = this.graphNodeSizeTier(node);
        let radius = labelLength >= 14 ? 7.4 : labelLength >= 9 ? 6.8 : 5.8;
        if (size === "large") radius = Math.max(radius, 8.6);
        if (size === "small") radius = Math.min(radius, 5.6);
        return { halfX: radius, halfY: radius, mode: "ellipse", sourceGap: 0.55, targetGap: 1.1 };
    }

    private graphRelationCurveOffset(source: GraphLayoutPoint, target: GraphLayoutPoint, relation: KnowledgeGraphRelation | null, index: number): number {
        let dx = target.x - source.x;
        let dy = target.y - source.y;
        let distance = Math.sqrt(dx * dx + dy * dy);
        if (!Number.isFinite(distance) || distance < 18) return 0;
        let seed = this.graphHashNumber(this.text(relation?.id || `${source.x}:${source.y}:${target.x}:${target.y}`));
        let angle = Math.atan2(dy, dx);
        let wave = Math.sin(angle * 2.35 + seed * 0.41 + index * 0.27);
        let strength = this.isBookCentralRelation(relation) ? 1.9 : 1.15;
        if (this.isRelationMetadataRecommendation(relation) || this.isRelationPendingEvidence(relation)) strength *= 0.72;
        return this.roundGraphPoint(Math.max(-2.6, Math.min(2.6, wave * strength)));
    }

    private graphHashNumber(value: string): number {
        let hash = 0;
        for (let index = 0; index < value.length; index++) {
            hash = (hash + value.charCodeAt(index) * (index + 1)) % 997;
        }
        return hash;
    }

    private roundGraphPoint(value: number): number {
        return Math.round(value * 100) / 100;
    }

    private graphCurveMidpoint(points: GraphLinkRenderPoints): GraphLayoutPoint {
        if (!points.curved) {
            return {
                x: (points.x1 + points.x2) / 2,
                y: (points.y1 + points.y2) / 2,
            };
        }
        return {
            x: (points.x1 + 2 * points.cx + points.x2) / 4,
            y: (points.y1 + 2 * points.cy + points.y2) / 4,
        };
    }

    private isBookCentralRelation(relation: KnowledgeGraphRelation | null): boolean {
        if (!relation) return false;
        let central = this.graphCentralNode();
        if (!central) return false;
        return relation.source === central.id || relation.target === central.id || relation.sourceLabel === central.label || relation.targetLabel === central.label;
    }

    public relationUsesArrow(relation: KnowledgeGraphRelation | null): boolean {
        if (!relation) return false;
        let type = this.relationTypeLabel(relation);
        return !["관련개념", "관련자료", "같은컬렉션", "메타데이터기반추천", "본문근거연결대기"].includes(type);
    }

    private exportGraphRelationSvg(relation: KnowledgeGraphRelation, source: { x: number, y: number, node?: KnowledgeGraphNode }, target: { x: number, y: number, node?: KnowledgeGraphNode }, index: number = 0, scope: "book" | "collection" = "book"): string {
        let isPending = this.isRelationMetadataRecommendation(relation) || this.isRelationPendingEvidence(relation);
        let stroke = isPending ? DESIGN_EXPORT_COLORS.border : DESIGN_EXPORT_COLORS.relation;
        let dash = isPending ? ' stroke-dasharray="4 5"' : "";
        let width = this.relationEvidenceCount(relation) > 1 ? 1.35 : 1.2;
        let opacity = isPending ? 0.5 : 0.55;
        let path = `<path d="${this.exportGraphPath(source, target, relation, index)}" fill="none" stroke="${stroke}" stroke-width="${width}" opacity="${opacity}" stroke-linecap="round"${dash}/>`;
        let label = this.relationVisualLabel(relation, scope);
        if (!label) return path;
        let x = Math.max(70, Math.min(source.x * 0.5 + target.x * 0.5, 1210));
        let y = Math.max(36, Math.min(source.y * 0.5 + target.y * 0.5, 830));
        let fill = isPending ? DESIGN_EXPORT_COLORS.pendingText : DESIGN_EXPORT_COLORS.accentStrong;
        return `${path}<text x="${x}" y="${y - 4}" text-anchor="middle" font-size="11.5" font-weight="760" fill="${fill}" opacity="0.82">${this.escapeHtml(label)}</text>`;
    }

    private exportGraphNodeSvg(node: KnowledgeGraphNode, x: number, y: number, palette: { bg: string, border: string, text: string, accent: string }, centralTopic: boolean = false): string {
        let shape = centralTopic ? "central-topic" : this.graphNodeShape(node);
        let size = this.graphNodeSizeTier(node);
        let labelLimit = shape === "material-card" ? 24 : shape === "small-card" ? 18 : shape === "capsule" ? 16 : shape === "dot" ? 10 : 14;
        let label = this.escapeHtml(this.truncate(node.label, labelLimit));
        let type = this.escapeHtml(this.nodeTypeLabel(node));
        let strokeWidth = shape === "central-topic" ? 2.4 : shape === "dot" ? 1.2 : 1.5;

        if (shape === "central-topic") {
            let r = 76;
            return `<g><circle cx="${x}" cy="${y}" r="${r}" fill="${palette.bg}" stroke="${palette.border}" stroke-width="${strokeWidth}"/><text x="${x}" y="${y - 6}" text-anchor="middle" font-size="18" font-weight="850" fill="${palette.text}">${label}</text><text x="${x}" y="${y + 22}" text-anchor="middle" font-size="11.5" font-weight="760" fill="${palette.text}" opacity="0.82">${type}</text></g>`;
        }
        if (shape === "material-card" || shape === "small-card") {
            let w = shape === "material-card" ? 190 : 146;
            let h = shape === "material-card" ? 78 : 58;
            return `<g><rect x="${x - w / 2}" y="${y - h / 2}" width="${w}" height="${h}" rx="8" fill="${palette.bg}" stroke="${palette.border}" stroke-width="${strokeWidth}"/><rect x="${x - w / 2}" y="${y - h / 2}" width="6" height="${h}" rx="3" fill="${palette.accent}"/><text x="${x - w / 2 + 17}" y="${y - 7}" text-anchor="start" font-size="${shape === "material-card" ? 15.5 : 13.5}" font-weight="830" fill="${palette.text}">${label}</text><text x="${x - w / 2 + 17}" y="${y + 17}" text-anchor="start" font-size="11.2" font-weight="760" fill="${palette.text}" opacity="0.74">${type}</text></g>`;
        }
        if (shape === "capsule") {
            let w = 144;
            let h = 58;
            return `<g><rect x="${x - w / 2}" y="${y - h / 2}" width="${w}" height="${h}" rx="29" fill="${palette.bg}" stroke="${palette.border}" stroke-width="${strokeWidth}"/><text x="${x}" y="${y - 3}" text-anchor="middle" font-size="13" font-weight="830" fill="${palette.text}">${label}</text><text x="${x}" y="${y + 16}" text-anchor="middle" font-size="10.5" font-weight="760" fill="${palette.text}" opacity="0.72">${type}</text></g>`;
        }
        if (shape === "dot") {
            let w = 88;
            let h = 34;
            return `<g><rect x="${x - w / 2}" y="${y - h / 2}" width="${w}" height="${h}" rx="17" fill="${palette.bg}" stroke="${palette.border}" stroke-width="${strokeWidth}"/><circle cx="${x - w / 2 + 16}" cy="${y}" r="5" fill="${palette.accent}"/><text x="${x - w / 2 + 27}" y="${y + 4}" text-anchor="start" font-size="10.5" font-weight="780" fill="${palette.text}">${label}</text></g>`;
        }

        let r = size === "large" ? 56 : size === "small" ? 38 : 46;
        return `<g><circle cx="${x}" cy="${y}" r="${r}" fill="${palette.bg}" stroke="${palette.border}" stroke-width="${strokeWidth}"/><text x="${x}" y="${y - 4}" text-anchor="middle" font-size="${size === "large" ? 15.5 : 13.5}" font-weight="830" fill="${palette.text}">${label}</text><text x="${x}" y="${y + 17}" text-anchor="middle" font-size="10.5" font-weight="760" fill="${palette.text}" opacity="0.72">${type}</text></g>`;
    }

    public graphLinkLabelStyle(segment: GraphLinkSegment): any {
        let points = this.graphLinkRenderPoints(segment);
        let midpoint = this.graphCurveMidpoint(points);
        let x = midpoint.x;
        let y = midpoint.y;
        if (Math.abs(points.y2 - points.y1) < 4) y -= 2.4;
        return {
            left: `${Math.max(7, Math.min(93, x))}%`,
            top: `${Math.max(5, Math.min(95, y))}%`,
            transform: "translate(-50%, -50%)",
        };
    }

    public graphLinkStatusStyle(segment: GraphLinkSegment): any {
        let style = this.graphLinkLabelStyle(segment);
        return {
            ...style,
            transform: "translate(-50%, 8px)",
        };
    }

    public graphLinkLabelClass(relation: KnowledgeGraphRelation, scope: "book" | "collection" = "book"): string {
        let classes = ["graph-link-label"];
        classes = classes.concat(this.graphRelationStateClassTokens(relation));
        let isSelected = scope === "collection" ? this.isCollectionRelationSelected(relation) : this.isGraphRelationSelected(relation);
        let isDirect = scope === "collection" ? this.isCollectionRelationDirect(relation) : this.isGraphRelationDirect(relation);
        let isHovered = scope === "collection" ? this.isCollectionRelationHovered(relation) : this.isGraphRelationHovered(relation);
        let isDimmed = scope === "collection"
            ? this.isCollectionSelectionActive() && !isSelected && !isDirect
            : this.isGraphSelectionActive() && !isSelected && !isDirect;
        if (isSelected) classes.push("is-selected");
        else if (isDirect) classes.push("is-direct");
        if (isHovered) classes.push("is-hovered");
        if (isDimmed) {
            classes.push("is-dimmed");
        }
        return classes.join(" ");
    }

    public graphRelationItemClass(relation: KnowledgeGraphRelation): string {
        return this.graphRelationStateClassTokens(relation).join(" ");
    }

    public graphConfidenceLabel(): string {
        let value = Number(this.graphMinConfidence || 0);
        if (value <= 0) return "전체";
        return `${Math.round(value * 100)}% 이상`;
    }

    public graphZoomLabel(): string {
        return `${Math.round(this.graphZoom * 100)}%`;
    }

    public graphFilteredRelationCount(book: BookItem): number {
        return this.filteredGraphRelations().length;
    }

    public graphDisplaySummary(book: BookItem): string {
        if (this.graphLoading) return "응답을 기다리는 중";
        if (!this.knowledgeGraph) return "응답 범위 미확인";
        let responseTotal = this.knowledgeGraph?.relations.length || 0;
        let total = this.graphFilteredRelationCount(book);
        let visible = this.graphDisplayRelations(book).length;
        let range = this.knowledgeGraph?.summary?.relationLimitReached
            ? `응답 범위 ${responseTotal}건(전체 아님)`
            : `응답 관계 ${responseTotal}건`;
        if (!total) return `${range} · 현재 표시 0건`;
        if (visible < total) return `${range} · 필터 ${total}건 중 ${visible}건 표시`;
        return `${range} · 현재 표시 ${visible}건`;
    }

    public isBookGraphMetadataOnly(): boolean {
        if (!this.knowledgeGraph) return false;
        if (this.knowledgeGraph.summary?.metadataOnly) return true;
        let bodyCount = Number(this.knowledgeGraph.summary?.bodyRelationCount || 0);
        return bodyCount <= 0 && this.knowledgeGraph.relations.length > 0;
    }

    public bookGraphCanvasClass(book: BookItem): any {
        let visibleNodes = this.graphDisplayNodes(book).length;
        return {
            "is-metadata-only": this.isBookGraphMetadataOnly(),
            "is-low-density": visibleNodes > 0 && visibleNodes <= 8,
            "is-dense": visibleNodes > 18,
            "is-filtered": Boolean(this.graphNodeTypeFilter || this.graphSearchQuery || this.graphRelationStatusFilter !== "전체"),
        };
    }

    public bookGraphMetadataNotice(): string {
        if (!this.isBookGraphMetadataOnly()) return "";
        return "자료 정보로 만든 관계도입니다. 원문 문장 근거가 준비되면 페이지 이동까지 함께 제공합니다.";
    }

    public graphCentralNodeMeta(book: BookItem): string {
        let central = this.graphCentralNode();
        if (central) return this.graphNodeScopedStatusLabel(central, "book");
        return `연결 ${this.graphDisplayRelations(book).length}건 · 근거 문장 준비 중`;
    }

    public bookGraphEmptyTitle(book: BookItem): string {
        if (!this.knowledgeGraph?.relations.length) return "실제 관계 없음";
        if (!this.filteredGraphRelations().length) return "필터 결과 없음";
        if (this.isBookGraphMetadataOnly()) return GRAPH_METADATA_CANDIDATE_GRAPH_LABEL;
        return "표시 항목 없음";
    }

    public bookGraphEmptyDescription(book: BookItem): string {
        if (!this.knowledgeGraph?.relations.length) return "현재 응답에는 이 자료와 연결된 관계가 없습니다.";
        if (!this.filteredGraphRelations().length) return "필터를 바꾸거나 초기화하면 전체 응답 범위를 다시 볼 수 있습니다.";
        if (this.isBookGraphMetadataOnly()) return "본문 페이지·청크 근거가 연결되면 원문 이동 관계가 활성화됩니다.";
        return "현재 표시 범위에 포함된 항목이 없습니다. 더 보기를 선택해 확인하세요.";
    }

    public async zoomBookGraph(delta: number) {
        this.graphZoom = this.clampGraphZoom(this.graphZoom + delta);
        this.syncMainUrl("replace");
        await this.service.render();
    }

    private recommendedBookGraphZoom(book: BookItem): number {
        let nodeCount = this.graphSurroundingNodes(book).length;
        if (nodeCount > 26) return 1.18;
        if (nodeCount > 22) return 1.15;
        if (nodeCount > 18) return 1.1;
        if (nodeCount > 14) return 1.05;
        return 1;
    }

    public async fitBookGraph(book: BookItem) {
        this.graphZoom = this.clampGraphZoom(this.recommendedBookGraphZoom(book));
        this.syncMainUrl("replace");
        await this.service.render();
    }

    public async resetBookGraphView(book: BookItem) {
        this.graphNodeTypeFilter = "";
        this.graphRelationTypeFilter = "";
        this.graphRelationStatusFilter = "전체";
        this.graphSearchQuery = "";
        this.graphMinConfidence = 0;
        this.graphShowEvidence = false;
        this.graphExpanded = false;
        this.graphZoom = this.recommendedBookGraphZoom(book);
        this.graphSelectedNode = null;
        this.graphSelectedRelation = null;
        this.graphHoveredNode = null;
        this.graphHoveredRelation = null;
        this.graphRouteSelectedNodeId = "";
        this.graphRouteSelectedRelationId = "";
        this.syncMainUrl("replace");
        await this.service.render();
    }

    public onBookGraphFilterChange(book: BookItem | null = null) {
        this.graphSelectedNode = null;
        this.graphSelectedRelation = null;
        this.graphRouteSelectedNodeId = "";
        this.graphRouteSelectedRelationId = "";
        this.graphExpanded = false;
        if (book) this.graphZoom = this.recommendedBookGraphZoom(book);
        this.syncMainUrl("replace");
    }

    public async clearGraphSelection(event?: Event) {
        if (event) event.stopPropagation();
        if (!this.graphSelectedNode && !this.graphSelectedRelation) return;
        this.graphSelectedNode = null;
        this.graphSelectedRelation = null;
        this.graphRouteSelectedNodeId = "";
        this.graphRouteSelectedRelationId = "";
        this.syncMainUrl("replace");
        await this.service.render();
    }

    public setGraphHoveredRelation(relation: KnowledgeGraphRelation | null) {
        this.graphHoveredRelation = relation;
    }

    public clearGraphHoveredRelation(relation: KnowledgeGraphRelation | null) {
        if (!relation || this.isEquivalentGraphRelation(this.graphHoveredRelation, relation)) {
            this.graphHoveredRelation = null;
        }
    }

    public setGraphHoveredNode(node: KnowledgeGraphNode | null) {
        this.graphHoveredNode = node;
    }

    public clearGraphHoveredNode(node: KnowledgeGraphNode | null) {
        if (!node || this.graphHoveredNode?.id === node.id) {
            this.graphHoveredNode = null;
        }
    }

    public async selectGraphNode(node: KnowledgeGraphNode, event?: Event) {
        if (event) event.stopPropagation();
        if (this.graphSelectedNode?.id === node.id && !this.graphSelectedRelation) {
            this.graphSelectedNode = null;
            this.graphSelectedRelation = null;
        } else {
            this.graphSelectedNode = node;
            this.graphSelectedRelation = null;
        }
        this.graphRouteSelectedNodeId = this.graphSelectedNode?.id || "";
        this.graphRouteSelectedRelationId = "";
        this.syncMainUrl("replace");
        await this.service.render();
    }

    public async selectGraphRelation(relation: KnowledgeGraphRelation, event?: Event) {
        if (event) event.stopPropagation();
        if (this.graphSelectedRelation?.id === relation.id) {
            this.graphSelectedRelation = null;
            this.graphSelectedNode = null;
            this.graphRouteSelectedNodeId = "";
            this.graphRouteSelectedRelationId = "";
            this.syncMainUrl("replace");
            await this.service.render();
            return;
        }
        this.graphSelectedRelation = relation;
        this.graphSelectedNode = this.knowledgeGraph?.nodes.find((node) => node.id === relation.target)
            || this.knowledgeGraph?.nodes.find((node) => node.id === relation.source)
            || null;
        this.graphRouteSelectedRelationId = relation.id;
        this.graphRouteSelectedNodeId = this.graphSelectedNode?.id || "";
        this.syncMainUrl("replace");
        await this.service.render();
    }

    private restoreGraphSelectionFromRoute(scope: "book" | "collection") {
        let graph = scope === "book" ? this.knowledgeGraph : this.collectionGraph;
        if (!graph) return;
        if (scope === "book") {
            this.graphSelectedRelation = graph.relations.find((item) => item.id === this.graphRouteSelectedRelationId) || null;
            this.graphSelectedNode = graph.nodes.find((item) => item.id === this.graphRouteSelectedNodeId)
                || (this.graphSelectedRelation ? graph.nodes.find((item) => item.id === this.graphSelectedRelation?.target || item.id === this.graphSelectedRelation?.source) : null)
                || null;
            if (this.graphSelectedRelation && !this.filteredGraphRelations().some((item) => item.id === this.graphSelectedRelation?.id)) {
                this.graphSelectedRelation = null;
                this.graphRouteSelectedRelationId = "";
            }
            let book = this.graphTargetBook() || this.selectedBook;
            if (book && this.graphSelectedNode && !this.graphDisplayNodes(book).some((item) => item.id === this.graphSelectedNode?.id)) {
                this.graphSelectedNode = null;
                this.graphRouteSelectedNodeId = "";
            }
            return;
        }
        this.collectionSelectedRelation = graph.relations.find((item) => item.id === this.collectionRouteSelectedRelationId) || null;
        this.collectionSelectedNode = graph.nodes.find((item) => item.id === this.collectionRouteSelectedNodeId)
            || (this.collectionSelectedRelation ? graph.nodes.find((item) => item.id === this.collectionSelectedRelation?.target || item.id === this.collectionSelectedRelation?.source) : null)
            || null;
        if (this.collectionSelectedRelation && !this.filteredCollectionRelations().some((item) => item.id === this.collectionSelectedRelation?.id)) {
            this.collectionSelectedRelation = null;
            this.collectionRouteSelectedRelationId = "";
        }
        if (this.collectionSelectedNode && !this.collectionDisplayNodes().some((item) => item.id === this.collectionSelectedNode?.id)) {
            this.collectionSelectedNode = null;
            this.collectionRouteSelectedNodeId = "";
        }
    }

    private isGraphRelationSelected(relation: KnowledgeGraphRelation | null): boolean {
        return !!(relation && this.graphSelectedRelation && this.isEquivalentGraphRelation(relation, this.graphSelectedRelation));
    }

    private isGraphRelationDirect(relation: KnowledgeGraphRelation | null): boolean {
        return !!(relation && !this.graphSelectedRelation && this.graphSelectedNode && this.isGraphRelationFocused(relation));
    }

    private isGraphRelationHovered(relation: KnowledgeGraphRelation | null): boolean {
        if (!relation) return false;
        if (this.graphHoveredRelation && this.isEquivalentGraphRelation(relation, this.graphHoveredRelation)) return true;
        return !!(this.graphHoveredNode && this.isRelationEndpointNode(this.graphHoveredNode, relation));
    }

    public isGraphSelectionActive(): boolean {
        return !!(this.graphSelectedRelation || this.graphSelectedNode);
    }

    public isGraphNodeDimmed(node: KnowledgeGraphNode): boolean {
        if (!node) return false;
        if (this.graphSelectedRelation) {
            return !this.isRelationEndpointNode(node, this.graphSelectedRelation);
        }
        if (this.graphSelectedNode) return !this.isGraphNodeFocused(node);
        return false;
    }

    public isGraphNodeRelated(node: KnowledgeGraphNode): boolean {
        if (!node || !this.isGraphSelectionActive() || this.isGraphNodeDimmed(node)) return false;
        if (this.graphSelectedRelation) return this.isRelationEndpointNode(node, this.graphSelectedRelation);
        if (!this.graphSelectedNode) return false;
        return node.id !== this.graphSelectedNode.id && this.isGraphNodeFocused(node);
    }

    private isGraphNodeFocused(node: KnowledgeGraphNode): boolean {
        if (!node || !this.graphSelectedNode) return false;
        if (node.id === this.graphSelectedNode.id) return true;
        return this.graphAllRelationsForNode(this.graphSelectedNode).some((relation) => {
            return relation.source === node.id || relation.target === node.id || relation.evidenceNodeId === node.id;
        });
    }

    public isGraphRelationFocused(relation: KnowledgeGraphRelation): boolean {
        if (!relation) return false;
        if (this.graphSelectedRelation) return this.isEquivalentGraphRelation(relation, this.graphSelectedRelation);
        if (!this.graphSelectedNode) return false;
        return relation.source === this.graphSelectedNode.id
            || relation.target === this.graphSelectedNode.id
            || relation.evidenceNodeId === this.graphSelectedNode.id
            || relation.sourceLabel === this.graphSelectedNode.label
            || relation.targetLabel === this.graphSelectedNode.label;
    }

    public isGraphRelationRelated(relation: KnowledgeGraphRelation): boolean {
        return !!this.graphSelectedNode && !this.graphSelectedRelation && this.isGraphRelationFocused(relation);
    }

    private isRelationEndpointNode(node: KnowledgeGraphNode | null, relation: KnowledgeGraphRelation | null): boolean {
        if (!node || !relation) return false;
        return relation.source === node.id
            || relation.target === node.id
            || relation.evidenceNodeId === node.id
            || relation.sourceLabel === node.label
            || relation.targetLabel === node.label;
    }

    private isEquivalentGraphRelation(a: KnowledgeGraphRelation | null, b: KnowledgeGraphRelation | null): boolean {
        if (!a || !b) return false;
        if (a.id && b.id && a.id === b.id) return true;
        return !!(a.source && a.target
            && a.source === b.source
            && a.target === b.target
            && a.type === b.type
            && a.chunkId === b.chunkId);
    }

    public relationSourceTarget(relation: KnowledgeGraphRelation): string {
        return `${relation.sourceNodeLabel || relation.sourceLabel || "자료"} → ${relation.targetNodeLabel || relation.targetLabel || "대상"}`;
    }

    public relationUserSummary(relation: KnowledgeGraphRelation | null): string {
        if (!relation) return "연결 정보 없음";
        if (this.relationHasSourcePage(relation)) return `${relation.page}쪽 원문 근거 있음`;
        if (this.isRelationMetadataRecommendation(relation)) return "자료 정보로 연결";
        if (this.isRelationPendingEvidence(relation)) return "원문 근거 준비 중";
        return this.relationEvidenceStatusLabel(relation) || "연결 정보 확인";
    }

    public relationTypeLabel(relation: KnowledgeGraphRelation | null): string {
        if (!relation) return "";
        return this.canonicalGraphRelationType(this.text(relation.type || relation.rawType), relation);
    }

    public graphEvidenceLabel(relation: KnowledgeGraphRelation): string {
        if (!this.relationHasSourcePage(relation)) {
            return `${relation.materialId} · ${this.relationStatusLabel(relation)} · ${GRAPH_BODY_EVIDENCE_PENDING_STATUS}`;
        }
        return `${relation.materialId} · ${relation.page || 0}쪽 · ${relation.chunkId || "청크 없음"}`;
    }

    public relationStatusLabel(relation: KnowledgeGraphRelation | null): string {
        if (!relation) return "";
        let status = this.text(relation.relationStatus || relation.status);
        if (status === "본문 근거 연결") return GRAPH_BODY_EVIDENCE_COMPLETE_STATUS;
        if (status === "근거 연결 전") return GRAPH_BODY_EVIDENCE_PENDING_STATUS;
        if (status) return status;
        return this.relationHasSourcePage(relation) ? GRAPH_BODY_EVIDENCE_COMPLETE_STATUS : GRAPH_METADATA_RECOMMENDATION_STATUS;
    }

    public relationEvidenceStatusLabel(relation: KnowledgeGraphRelation | null): string {
        if (!relation) return "";
        let status = this.text(relation.evidenceStatus);
        let chunkId = this.text(relation.chunkId);
        let bodyLinked = Boolean(relation.bodyEvidenceLinked)
            || (Number(relation.page || 0) > 0 && !!chunkId && !chunkId.startsWith("metadata:") && !!this.text(relation.sentence));
        if (bodyLinked) return GRAPH_BODY_EVIDENCE_COMPLETE_STATUS;
        if (status === "본문 근거 연결") return GRAPH_BODY_EVIDENCE_COMPLETE_STATUS;
        if (status === "근거 연결 전" || status === GRAPH_BODY_EVIDENCE_PENDING_STATUS) return GRAPH_BODY_EVIDENCE_PENDING_STATUS;
        if (status === GRAPH_BODY_EVIDENCE_COMPLETE_STATUS && !bodyLinked) return GRAPH_BODY_EVIDENCE_PENDING_STATUS;
        if (status) return status;
        if (!relation.page || this.text(relation.extractionMethod).includes("메타데이터")) return GRAPH_BODY_EVIDENCE_PENDING_STATUS;
        return GRAPH_BODY_EVIDENCE_COMPLETE_STATUS;
    }

    public relationReviewStatusLabel(relation: KnowledgeGraphRelation | null): string {
        if (!relation) return "";
        let review = this.normalizeGraphReviewStatus(relation.reviewStatus || "검수대기");
        let note = this.text(relation.reviewNote).replace("검수 필요", "검수 대기");
        if (this.isRelationPendingReview(relation)) {
            if (review === "검수 대기") return review;
            return `${review} · 검수 대기`;
        }
        if (note && !review.includes(note)) return `${review} · ${note}`;
        return review;
    }

    public relationPageLabel(relation: KnowledgeGraphRelation | null): string {
        if (!relation) return "";
        if (!this.relationHasSourcePage(relation)) {
            return this.canAccessAdminReview()
                ? "근거 문장 준비 중 · 원문 페이지 없음"
                : "원문 위치 준비 중";
        }
        let printed = this.text(relation.printedPage);
        return `PDF ${relation.pdfPage || relation.page}쪽 · 인쇄쪽수 ${printed || "미확인"} · 문단 ${relation.paragraph}`;
    }

    public relationMaterialTitle(relation: KnowledgeGraphRelation | null): string {
        if (!relation) return "출처 자료 없음";
        let book = this.findBookByMaterialId(relation.materialId);
        return book?.title || relation.materialId || "출처 자료 없음";
    }

    public relationBodyLinkStatus(relation: KnowledgeGraphRelation | null): string {
        if (!relation) return "본문 연결 없음";
        if (this.relationHasSourcePage(relation) && relation.chunkId) return "원문 페이지·문단 연결";
        if (this.relationHasSourcePage(relation)) return "원문 페이지 연결";
        return "근거 문장 준비 중";
    }

    public relationGenerationMethodLabel(relation: KnowledgeGraphRelation | null): string {
        if (!relation) return "생성 방식 없음";
        let method = this.text(relation.generationMethod || relation.extractionMethod);
        const labels: any = {
            metadata_rule: "metadata_rule · 메타데이터 규칙",
            marc_rule: "marc_rule · MARC/서지 규칙",
            filename_rule: "filename_rule · 파일명 규칙",
            similar_material_rule: "similar_material_rule · 관련 자료 규칙",
            text_chunk_rule: "text_chunk_rule · 원문 문단 규칙",
            manual_reviewed: "manual_reviewed · 수동 검수",
        };
        return labels[method] || method || "metadata_rule · 메타데이터 규칙";
    }

    public relationImportanceLabel(relation: KnowledgeGraphRelation | null): string {
        if (!relation) return "0점 · 보조 관계 후보";
        let score = this.relationImportanceScore(relation);
        let basis = this.relationImportanceBasis(relation);
        return `${score}점 · ${basis}`;
    }

    public relationCreationBasis(relation: KnowledgeGraphRelation | null): string {
        if (!relation) return "관계 생성 근거 없음";
        if (!this.canAccessAdminReview()) {
            if (this.relationHasSourcePage(relation)) return "원문 문장 근거";
            if (this.isRelationMetadataRecommendation(relation)) return "서지·태그 정보 기반 연결";
            return "자료 정보 기반 연결";
        }
        let method = this.relationGenerationMethodLabel(relation);
        let parts: string[] = [];
        if (method) {
            parts.push(method);
        } else if (this.relationHasSourcePage(relation)) {
            parts.push("본문 문장 근거");
        } else if (this.isRelationMetadataRecommendation(relation)) {
            parts.push("메타데이터 기반 추천");
        } else {
            parts.push("자동 관계 산출");
        }

        let sourceField = this.text(relation.sourceField);
        if (sourceField) parts.push(`출처 ${sourceField}`);
        let confidence = this.text(relation.confidenceLabel);
        if (!confidence && Number(relation.confidence || 0) > 0) {
            confidence = `신뢰도 ${Math.round(Number(relation.confidence) * 100)}%`;
        }
        if (confidence) parts.push(confidence);

        let evidenceCount = this.relationEvidenceCount(relation);
        if (evidenceCount > 1) parts.push(`근거 ${evidenceCount}건`);
        let ruleBasis = this.text(relation.relationRule?.basis || "");
        if (ruleBasis) parts.push(ruleBasis);
        let seen = new Set<string>();
        return parts.filter((part) => {
            if (seen.has(part)) return false;
            seen.add(part);
            return true;
        }).join(" · ");
    }

    public relationMetadataFieldLabel(relation: KnowledgeGraphRelation | null): string {
        if (!relation) return "메타데이터 필드 없음";
        let fields = [this.text(relation.evidenceField || relation.sourceField)];
        let chunkId = this.text(relation.chunkId);
        if (chunkId.startsWith("metadata:")) fields.push(chunkId.replace(/^metadata:/, ""));
        let seen = new Set<string>();
        let unique = fields.filter((field) => {
            field = this.text(field);
            if (!field || seen.has(field)) return false;
            seen.add(field);
            return true;
        });
        if (unique.length) return unique.join(", ");
        if (this.isRelationMetadataRecommendation(relation)) return "자료 메타데이터";
        return "해당 없음(본문 근거)";
    }

    public relationBodyEvidenceLinkLabel(relation: KnowledgeGraphRelation | null): string {
        if (!relation) return this.canAccessAdminReview() ? "본문 근거 미연결" : "원문 근거 준비 중";
        if (this.relationHasSourcePage(relation)) {
            let chunkId = this.text(relation.chunkId);
            let chunkLabel = this.canAccessAdminReview() && chunkId ? ` · ${chunkId}` : "";
            let fileLabel = this.text(relation.fileId) ? ` · 파일 ${relation.fileId}` : " · 파일 미확인";
            return `자료 ${relation.materialId || "미확인"}${fileLabel} · 연결됨 · ${this.relationPageLabel(relation)}${chunkLabel}`;
        }
        if (!this.canAccessAdminReview()) return "원문 근거 준비 중";
        if (Number(relation.page || 0) > 0) return `본문 근거 연결 대기 · 후보 페이지 ${relation.page}쪽`;
        return "본문 근거 연결 대기";
    }

    public relationEvidenceDisclosureLabel(relation: KnowledgeGraphRelation | null): string {
        if (!relation) return "근거 보기";
        if (this.relationHasSourcePage(relation)) return "본문 근거 문장 보기";
        if (!this.canAccessAdminReview()) return "연결 설명 보기";
        if (this.isRelationMetadataRecommendation(relation)) return "메타데이터 후보 설명 보기";
        return "근거 상태 설명 보기";
    }

    public relationEvidenceCount(relation: KnowledgeGraphRelation | null): number {
        if (!relation) return 0;
        let count = Number(relation.evidenceCount || 0);
        if (count > 0) return count;
        return this.relationHasSourcePage(relation) ? 1 : 0;
    }

    public relationVisualLabel(relation: KnowledgeGraphRelation | null, scope: "book" | "collection" = "book"): string {
        if (!relation) return "";
        let shouldShow = scope === "collection"
            ? this.isCollectionRelationSelected(relation) || this.isCollectionRelationHovered(relation)
            : this.isGraphRelationSelected(relation) || this.isGraphRelationHovered(relation);
        if (!shouldShow && !this.isDefaultGraphRelationLabel(relation, scope)) return "";
        return this.relationInlineLabel(relation);
    }

    private isDefaultGraphRelationLabel(relation: KnowledgeGraphRelation | null, scope: "book" | "collection"): boolean {
        if (!relation) return false;
        if (scope === "collection") {
            if (this.isCollectionSelectionActive()) return false;
            return this.defaultCollectionRelationLabelIds().has(relation.id);
        }
        if (this.isGraphSelectionActive()) return false;
        return this.defaultBookRelationLabelIds().has(relation.id);
    }

    private defaultBookRelationLabelIds(): Set<string> {
        let book = this.graphTargetBook() || this.selectedBook;
        if (!this.knowledgeGraph || !book) return new Set();
        return this.pickDefaultRelationLabelIds(this.graphDisplayRelations(book));
    }

    private defaultCollectionRelationLabelIds(): Set<string> {
        if (!this.collectionGraph) return new Set();
        return this.pickDefaultRelationLabelIds(this.collectionDisplayRelations());
    }

    private pickDefaultRelationLabelIds(relations: KnowledgeGraphRelation[]): Set<string> {
        let sorted = relations.slice().sort((a, b) => this.graphRelationScore(b) - this.graphRelationScore(a) || this.relationTypeLabel(a).localeCompare(this.relationTypeLabel(b), "ko"));
        let semanticRows = sorted.filter((relation) => !["메타데이터기반추천", "본문근거연결대기"].includes(this.relationTypeLabel(relation)));
        let groundedRows = semanticRows.filter((relation) => this.relationEvidenceStatusLabel(relation) === GRAPH_BODY_EVIDENCE_COMPLETE_STATUS || this.isRelationReviewed(relation));
        let rows: KnowledgeGraphRelation[] = [];
        groundedRows.concat(semanticRows).concat(sorted).forEach((relation) => {
            if (!rows.some((item) => item.id === relation.id)) rows.push(relation);
        });
        let desired = Math.min(GRAPH_DEFAULT_RELATION_LABEL_MAX, Math.max(GRAPH_DEFAULT_RELATION_LABEL_MIN, Math.min(sorted.length, GRAPH_DEFAULT_RELATION_LABEL_MAX)));
        return new Set(rows.slice(0, desired).map((relation) => relation.id));
    }

    private relationInlineLabel(relation: KnowledgeGraphRelation): string {
        let type = this.truncate(this.relationTypeLabel(relation) || "관계", 12);
        let evidence = this.relationEvidenceShortLabel(relation);
        return `${type} · ${evidence}`;
    }

    public relationStatusMarker(relation: KnowledgeGraphRelation | null): string {
        if (!relation || this.isRelationMetadataRecommendation(relation)) return "";
        if (this.isRelationPendingEvidence(relation)) return "대기";
        return "";
    }

    public relationStatusMarkerTitle(relation: KnowledgeGraphRelation | null): string {
        if (!relation) return "";
        return `${this.relationTypeLabel(relation)} · ${this.relationEvidenceStatusLabel(relation)}`;
    }

    private relationEvidenceShortLabel(relation: KnowledgeGraphRelation | null): string {
        if (!relation) return "상태";
        if (this.isRelationPendingEvidence(relation)) return "근거 대기";
        if (this.isRelationMetadataRecommendation(relation)) return "자료정보";
        if (this.relationEvidenceStatusLabel(relation) === GRAPH_BODY_EVIDENCE_COMPLETE_STATUS) return "본문근거";
        return this.relationStatusLabel(relation) || "상태";
    }

    public async openTopicGraph(tag: SearchTagResultCard, event?: Event) {
        this.stopEvent(event);
        if (!tag || !this.canAccessKnowledgeGraph()) return;
        let collectionId = this.collectionIdForTag(tag.name);
        if (collectionId) {
            await this.openCollectionGraphById(collectionId, undefined, tag.name);
            return;
        }
        if (tag.representativeBook && this.canUseResultGraph(tag.representativeBook)) {
            await this.openResultGraph(tag.representativeBook);
            return;
        }
        await this.applyTopicTag(tag.name);
    }

    public relationHasSourcePage(relation: KnowledgeGraphRelation | null): boolean {
        if (!relation) return false;
        let chunkId = this.text(relation.chunkId);
        if (!(relation.page > 0)) return false;
        if (!chunkId || chunkId.startsWith("metadata:")) return false;
        if (!this.text(relation.sentence)) return false;
        return this.relationEvidenceStatusLabel(relation) === GRAPH_BODY_EVIDENCE_COMPLETE_STATUS;
    }

    private isRelationPendingEvidence(relation: KnowledgeGraphRelation | null): boolean {
        return this.relationEvidenceStatusLabel(relation) === GRAPH_BODY_EVIDENCE_PENDING_STATUS;
    }

    private isRelationMetadataRecommendation(relation: KnowledgeGraphRelation | null): boolean {
        if (!relation) return false;
        let status = this.relationStatusLabel(relation);
        let method = this.text(relation.extractionMethod);
        let chunkId = this.text(relation.chunkId);
        return status === GRAPH_METADATA_RECOMMENDATION_STATUS || method.includes("메타데이터") || chunkId.startsWith("metadata:");
    }

    private isRelationReviewed(relation: KnowledgeGraphRelation | null): boolean {
        if (!relation) return false;
        return ["검수완료", "검수 완료"].includes(this.text(relation.reviewStatus));
    }

    private graphRelationStateClassTokens(relation: KnowledgeGraphRelation | null): string[] {
        if (!relation) return [];
        let classes: string[] = [];
        if (this.isRelationMetadataRecommendation(relation)) classes.push("is-metadata-recommendation");
        if (this.isRelationPendingEvidence(relation)) classes.push("is-pending-evidence");
        if (this.relationEvidenceStatusLabel(relation) === GRAPH_BODY_EVIDENCE_COMPLETE_STATUS) classes.push("is-evidence-complete");
        if (this.relationEvidenceCount(relation) > 1) classes.push("is-evidence-strong");
        if (this.isRelationReviewed(relation)) classes.push("is-reviewed");
        else if (this.isRelationPendingReview(relation)) classes.push("is-pending-review");
        return classes;
    }

    public graphLinkStatusClass(relation: KnowledgeGraphRelation, scope: "book" | "collection" = "book"): string {
        let classes = ["graph-link-status"];
        classes = classes.concat(this.graphRelationStateClassTokens(relation));
        let isSelected = scope === "collection" ? this.isCollectionRelationSelected(relation) : this.isGraphRelationSelected(relation);
        let isDirect = scope === "collection" ? this.isCollectionRelationDirect(relation) : this.isGraphRelationDirect(relation);
        let isHovered = scope === "collection" ? this.isCollectionRelationHovered(relation) : this.isGraphRelationHovered(relation);
        let isDimmed = scope === "collection"
            ? this.isCollectionSelectionActive() && !isSelected && !isDirect
            : this.isGraphSelectionActive() && !isSelected && !isDirect;
        if (isSelected) classes.push("is-selected");
        else if (isDirect) classes.push("is-direct");
        if (isHovered) classes.push("is-hovered");
        if (isDimmed) classes.push("is-dimmed");
        return classes.join(" ");
    }

    private isRelationPendingReview(relation: KnowledgeGraphRelation | null): boolean {
        if (!relation) return false;
        let review = this.text(relation.reviewStatus);
        let note = this.text(relation.reviewNote);
        if (review === "검수완료" || review === "검수 완료") return false;
        if (["자동추출", "자동추천", "검수대기", "검수 필요", "검수 대기", "메타데이터 기반 추천"].includes(review)) return true;
        return note.includes("검수");
    }

    public graphNodeMaterialCount(node: KnowledgeGraphNode | null): number {
        if (!node) return 0;
        let relatedMaterialCount = Number(node.relatedMaterialCount || 0);
        if (relatedMaterialCount > 0) return relatedMaterialCount;
        if (node.materialIds?.length) return node.materialIds.length;
        if (node.materialId || node.type === "자료") return 1;
        let materialIds = new Set(this.graphAllRelationsForNode(node).map((relation) => relation.materialId).filter((value) => value));
        return materialIds.size;
    }

    public graphNodeConnectionCount(node: KnowledgeGraphNode | null): number {
        return this.graphAllRelationsForNode(node).length;
    }

    public graphNodeTopTargets(node: KnowledgeGraphNode | null): string {
        if (!node) return "연결 없음";
        let labels: string[] = [];
        this.graphAllRelationsForNode(node)
            .sort((a, b) => this.graphRelationScore(b) - this.graphRelationScore(a))
            .forEach((relation) => {
                let label = relation.source === node.id || relation.sourceLabel === node.label ? relation.targetLabel : relation.sourceLabel;
                label = this.text(label);
                if (label && label !== node.label && !labels.includes(label)) labels.push(label);
            });
        return labels.length ? labels.slice(0, 4).join(", ") : "연결 없음";
    }

    public graphNodeEvidenceStatus(node: KnowledgeGraphNode | null): string {
        if (!node) return "";
        if (this.text(node.evidenceStatus) === GRAPH_BODY_EVIDENCE_COMPLETE_STATUS) return GRAPH_BODY_EVIDENCE_COMPLETE_STATUS;
        if (Number(node.page || 0) > 0 && node.chunkId) return GRAPH_BODY_EVIDENCE_COMPLETE_STATUS;
        let relations = this.graphAllRelationsForNode(node);
        if (relations.some((relation) => this.relationEvidenceStatusLabel(relation) === GRAPH_BODY_EVIDENCE_COMPLETE_STATUS)) return GRAPH_BODY_EVIDENCE_COMPLETE_STATUS;
        if (node.evidenceCount > 0) return GRAPH_BODY_EVIDENCE_PENDING_STATUS;
        return GRAPH_BODY_EVIDENCE_PENDING_STATUS;
    }

    public graphNodeHumanReviewStatus(node: KnowledgeGraphNode | null, scope: string): string {
        if (!node) return "사람 확인 전";
        let relations = scope === "collection"
            ? this.collectionAllRelationsForNode(node)
            : this.graphAllRelationsForNode(node);
        if (relations.some((relation) => this.isRelationReviewed(relation))) return "사람 확인 완료 관계 포함";
        let status = this.normalizeGraphReviewStatus(node.reviewStatus || "검수 대기");
        return status === "자료 확인 완료" ? "사람 확인 완료" : "사람 확인 전";
    }

    public async openGraphRelationMaterial(relation: KnowledgeGraphRelation) {
        let book = this.findBookByMaterialId(relation?.materialId || "") || this.selectedBook;
        if (!book) return;
        await this.openBook(book);
    }

    public async openGraphNodeMaterial(node: KnowledgeGraphNode | null) {
        if (!node) return;
        let relation = this.graphAllRelationsForNode(node)[0];
        let book = this.findBookByMaterialId(node.materialId || relation?.materialId || "") || this.selectedBook;
        if (!book) return;
        await this.openBook(book);
    }

    public async openGraphRelationPage(relation: KnowledgeGraphRelation) {
        if (!this.relationHasSourcePage(relation)) return;
        this.syncMainUrl("replace");
        let targetBook = this.findBookByMaterialId(relation.materialId) || this.graphTargetBook() || this.selectedBook;
        if (!targetBook) return;
        let evidencePage = Number(relation.pdfPage || relation.page);
        if (!this.selectedBook || this.selectedBook.id !== targetBook.id) {
            await this.openBook(targetBook, undefined, true, { fileId: relation.fileId, page: evidencePage, anchor: "ebook-reader" });
        }
        if (!this.selectedBook) return;
        if (relation.fileId) {
            let index = this.selectedBook.pdfs.findIndex((pdf) => (pdf.fileId || pdf.textIndex?.fileId) === relation.fileId);
            if (index >= 0) this.activePdfIndex = index;
            this.selectedFileId = relation.fileId;
        } else if (Number.isFinite(relation.pdfIndex)) {
            this.activePdfIndex = Math.max(0, relation.pdfIndex);
        }
        this.activePdfPage = evidencePage;
        this.readerPageInput = String(this.activePdfPage);
        this.replaceDetailAnchor("ebook-reader");
        await this.scrollToDetailSection("ebook-reader");
        await this.renderActivePdfPage();
    }

    public async openGraphNodePage(node: KnowledgeGraphNode) {
        if (!node) return;
        let evidenceRelation = this.graphAllRelationsForNode(node).find((relation) => this.relationHasSourcePage(relation));
        if (evidenceRelation) {
            await this.openGraphRelationPage(evidenceRelation);
            return;
        }
        if (!node.page) return;
        await this.openGraphRelationPage({
            id: node.id,
            source: "",
            target: node.id,
            sourceLabel: "",
            targetLabel: node.label,
            type: "관련자료",
            materialId: node.materialId || "",
            fileId: node.fileId || "",
            page: node.page || 0,
            paragraph: 0,
            chunkId: node.chunkId || "",
            sentence: node.sentence || "",
            extractionMethod: "본문청크",
            confidence: 1,
            confidenceLabel: "",
            reviewStatus: node.reviewStatus,
            publicStatus: node.publicStatus,
            pdfFilename: node.pdfFilename || "",
            pdfUrl: node.pdfUrl || "",
            pdfIndex: node.pdfIndex || 0,
            relationStatus: node.page ? GRAPH_BODY_EVIDENCE_COMPLETE_STATUS : GRAPH_BODY_EVIDENCE_PENDING_STATUS,
            status: node.page ? GRAPH_BODY_EVIDENCE_COMPLETE_STATUS : GRAPH_BODY_EVIDENCE_PENDING_STATUS,
            evidenceStatus: node.page ? GRAPH_BODY_EVIDENCE_COMPLETE_STATUS : GRAPH_BODY_EVIDENCE_PENDING_STATUS,
            reviewNote: "검수 대기",
        });
    }

    public graphRelationsForNode(node: KnowledgeGraphNode | null): KnowledgeGraphRelation[] {
        return this.graphAllRelationsForNode(node).slice(0, 6);
    }

    public graphNodeHasRepresentativePage(node: KnowledgeGraphNode | null): boolean {
        if (!node) return false;
        if (Number(node.page || 0) > 0 && !this.text(node.chunkId).startsWith("metadata:")) return true;
        return this.graphAllRelationsForNode(node).some((relation) => this.relationHasSourcePage(relation));
    }

    public graphAllRelationsForNode(node: KnowledgeGraphNode | null): KnowledgeGraphRelation[] {
        if (!node || !this.knowledgeGraph) return [];
        return this.knowledgeGraph.relations
            .filter((relation) => relation.target === node.id
                || relation.source === node.id
                || relation.evidenceNodeId === node.id
                || relation.targetLabel === node.label
                || relation.sourceLabel === node.label)
            .sort((a, b) => this.graphRelationScore(b) - this.graphRelationScore(a));
    }

    public selectedCollection(): CollectionSummary | null {
        return this.collections.find((item) => item.id === this.selectedCollectionId) || this.collections[0] || null;
    }

    public async selectCollection(collection: CollectionSummary) {
        if (!collection || collection.id === this.selectedCollectionId) return;
        this.selectedCollectionId = collection.id;
        this.collectionNodeTypeFilter = "";
        this.collectionReviewStatusFilter = "";
        this.graphRelationStatusFilter = "전체";
        this.graphSearchQuery = "";
        this.collectionMinConfidence = 0;
        this.collectionShowEvidence = false;
        this.collectionGraphExpanded = false;
        this.collectionGraphZoom = 1;
        this.collectionRouteSelectedNodeId = "";
        this.collectionRouteSelectedRelationId = "";
        this.collectionAiQuestion = "";
        this.collectionAiAnswer = "";
        this.syncMainUrl("push");
        await this.loadCollectionGraph();
    }

    private buildClientCollectionGraph(collection: CollectionSummary): KnowledgeGraphData | null {
        let books = this.collectionPreviewBooks(collection, 24);
        if (!books.length) return null;

        let centralId = `collection:${collection.id}`;
        let topicCounts: { [name: string]: { count: number, axis: string } } = {};
        books.forEach((book) => {
            this.primaryTags(book).slice(0, 8).forEach((tag) => {
                if (!tag.name || this.isStateTagName(tag.name)) return;
                if (!topicCounts[tag.name]) topicCounts[tag.name] = { count: 0, axis: tag.axis || "주제" };
                topicCounts[tag.name].count += 1;
            });
        });
        let topics = Object.keys(topicCounts)
            .sort((a, b) => topicCounts[b].count - topicCounts[a].count || a.localeCompare(b, "ko"))
            .slice(0, 12);

        let nodes: KnowledgeGraphNode[] = [{
            id: centralId,
            type: "중심 주제",
            label: collection.title,
            detail: collection.description,
            evidenceCount: 0,
            connectionCount: books.length + topics.length,
            evidenceStatus: GRAPH_METADATA_RECOMMENDATION_STATUS,
            reviewStatus: collection.reviewStatus || "검수 대기",
            publicStatus: collection.publicStatus || "내부전용",
            materialIds: books.map((book) => book.id || book.hflibId).filter((id) => id),
            relatedTags: topics,
            sourceField: "주제 컬렉션",
            priorityRank: 1,
            importanceScore: 1,
            importanceBasis: "선택한 주제 컬렉션",
        }];

        topics.forEach((topic, index) => {
            nodes.push({
                id: `topic:${collection.id}:${index}:${topic}`,
                type: "주제",
                label: topic,
                detail: `${topicCounts[topic].axis} · 관련 자료 ${topicCounts[topic].count}건`,
                evidenceCount: 0,
                connectionCount: topicCounts[topic].count + 1,
                evidenceStatus: GRAPH_METADATA_RECOMMENDATION_STATUS,
                reviewStatus: "검수 대기",
                publicStatus: collection.publicStatus || "내부전용",
                materialIds: books
                    .filter((book) => this.primaryTags(book).some((tag) => tag.name === topic))
                    .map((book) => book.id || book.hflibId)
                    .filter((id) => id),
                relatedTags: [topic],
                sourceField: topicCounts[topic].axis,
                priorityRank: index + 2,
                importanceScore: Math.max(0.35, topicCounts[topic].count / Math.max(1, books.length)),
                importanceBasis: "자료 태그 빈도",
            });
        });

        books.forEach((book, index) => {
            nodes.push({
                id: `material:${book.id || book.hflibId}`,
                type: "자료",
                label: book.title,
                detail: `${this.publisherLabel(book)} · ${this.publishedYearLabel(book)}`,
                evidenceCount: 0,
                connectionCount: this.primaryTags(book).length + 1,
                evidenceStatus: GRAPH_METADATA_RECOMMENDATION_STATUS,
                reviewStatus: book.reviewStatus || "검수 대기",
                publicStatus: book.publicStatus || "내부전용",
                materialId: book.id || book.hflibId,
                relatedMaterialId: book.id || book.hflibId,
                relatedTags: this.primaryTags(book).map((tag) => tag.name).slice(0, 8),
                sourceField: "자료 태그·서지정보",
                priorityRank: index + 20,
                importanceScore: book.bodySearchAvailable ? 0.72 : 0.54,
                importanceBasis: book.bodySearchAvailable ? "본문 색인 자료" : "서지·태그 자료",
            });
        });

        let relations: KnowledgeGraphRelation[] = [];
        let addRelation = (source: string, target: string, sourceLabel: string, targetLabel: string, type: string, materialId: string, sentence: string, index: number) => {
            relations.push({
                id: `client:${collection.id}:${relations.length}:${index}`,
                source,
                target,
                sourceLabel,
                targetLabel,
                type,
                rawType: type,
                relationStatus: GRAPH_METADATA_RECOMMENDATION_STATUS,
                status: GRAPH_METADATA_RECOMMENDATION_STATUS,
                materialId,
                fileId: "",
                page: 0,
                paragraph: 0,
                chunkId: "",
                sentence,
                extractionMethod: "자료 태그·서지정보 기반",
                generationMethod: "클라이언트 즉시 산출",
                confidence: 0.62,
                confidenceLabel: "메타데이터 후보",
                evidenceCount: 0,
                reviewStatus: "검수 대기",
                publicStatus: collection.publicStatus || "내부전용",
                pdfFilename: "",
                pdfUrl: "",
                pdfIndex: 0,
                evidenceStatus: GRAPH_METADATA_RECOMMENDATION_STATUS,
                bodyEvidenceLinked: false,
                bodyEvidenceStatus: GRAPH_BODY_EVIDENCE_PENDING_STATUS,
                reviewNote: "서버 그래프 응답 전 즉시 표시한 메타데이터 기반 후보입니다.",
                sourceField: "자료 태그·서지정보",
                importanceScore: 0.56,
                importanceBasis: "컬렉션·태그 공통성",
                relationRule: {
                    sourceType: "주제",
                    targetType: "자료",
                    type,
                    basis: "자료 태그·서지정보 기반 후보",
                },
            });
        };

        books.forEach((book, index) => {
            let materialId = book.id || book.hflibId;
            let materialNodeId = `material:${materialId}`;
            addRelation(centralId, materialNodeId, collection.title, book.title, "관련자료", materialId, `${collection.title} 컬렉션의 관련 자료입니다.`, index);
            this.primaryTags(book).slice(0, 5).forEach((tag, tagIndex) => {
                let topicIndex = topics.indexOf(tag.name);
                if (topicIndex < 0) return;
                let topicNodeId = `topic:${collection.id}:${topicIndex}:${tag.name}`;
                addRelation(materialNodeId, topicNodeId, book.title, tag.name, "주제로다룬다", materialId, `${book.title}의 태그와 서지정보가 ${tag.name} 주제와 연결됩니다.`, index * 10 + tagIndex);
            });
        });

        topics.forEach((topic, index) => {
            let topicNodeId = `topic:${collection.id}:${index}:${topic}`;
            addRelation(centralId, topicNodeId, collection.title, topic, "포함한다", collection.id, `${collection.title} 컬렉션의 대표 주제입니다.`, index);
        });

        let connectionCounts: { [id: string]: number } = {};
        relations.forEach((relation) => {
            connectionCounts[relation.source] = (connectionCounts[relation.source] || 0) + 1;
            connectionCounts[relation.target] = (connectionCounts[relation.target] || 0) + 1;
        });
        nodes.forEach((node) => node.connectionCount = connectionCounts[node.id] || node.connectionCount || 0);

        return {
            collectionId: collection.id,
            materialId: collection.id,
            bookTitle: collection.title,
            graphType: GRAPH_METADATA_CANDIDATE_GRAPH_LABEL,
            generatedAt: new Date().toISOString(),
            extractionBasis: GRAPH_METADATA_CANDIDATE_GRAPH_LABEL,
            dataSources: [
                { source: "자료 목록·태그", role: "서버 그래프 응답 전 주제·자료 연결 후보를 즉시 표시", active: true },
                { source: "원문 본문", role: "서버 그래프 응답 후 근거 문장 연결 필요", active: false },
            ],
            nodeTypes: this.uniqueOptions(nodes.map((node) => node.type)),
            relationStates: [GRAPH_METADATA_RECOMMENDATION_STATUS],
            generationMethods: ["클라이언트 즉시 산출"],
            storageStatus: "클라이언트 즉시 산출",
            storagePath: "자료 목록·태그 기반",
            summary: {
                nodeCount: nodes.length,
                relationCount: relations.length,
                evidenceNodeCount: 0,
                autoExtractedCount: nodes.length,
                reviewedCount: 0,
                materialCount: books.length,
                displayMaterialCount: books.length,
                commonEntityCount: topics.length,
                bodyRelationCount: 0,
                bodyChunkCount: books.reduce((sum, book) => sum + (book.bodyChunkCount || 0), 0),
                metadataCandidateCount: relations.length,
                pendingEvidenceCount: relations.length,
                metadataOnly: true,
                qualityStatus: "metadata-fallback",
            },
            nodes,
            relations,
            evidenceNodes: [],
            materials: books.map((book) => ({
                id: book.id || book.hflibId,
                hflibId: book.hflibId,
                title: book.title,
                author: book.author,
                publisher: book.publisher,
                publishedDate: book.publishedDate,
                publishedYear: book.publishedYear,
                coverImage: book.coverImage,
                coverAvailable: book.coverAvailable,
                pdfCount: book.pdfCount,
                bodySearchAvailable: book.bodySearchAvailable,
                reviewStatus: book.reviewStatus,
                publicStatus: book.publicStatus,
                score: book.bodySearchAvailable ? 0.72 : 0.54,
                evidence: this.primaryTags(book).map((tag) => tag.name).slice(0, 5),
            })),
        };
    }

    public async loadCollectionGraph() {
        if (!this.canAccessKnowledgeGraph()) {
            this.collectionGraph = null;
            this.collectionGraphLoading = false;
            this.collectionGraphErrorMessage = this.accessDeniedMessage("graph");
            await this.service.render();
            return;
        }
        let collection = this.selectedCollection();
        if (!collection) return;
        if (this.collectionGraphLoading && this.collectionGraphRequestKey === collection.id) return;
        this.collectionGraphAbortController?.abort();
        let controller = new AbortController();
        this.collectionGraphAbortController = controller;
        this.collectionGraphRequestKey = collection.id;
        let token = ++this.collectionGraphToken;
        let fallbackGraph = this.buildClientCollectionGraph(collection);
        this.collectionGraph = fallbackGraph;
        this.collectionGraphLoading = true;
        this.collectionGraphErrorMessage = "";
        this.collectionGraphPartialMessage = "";
        this.collectionSelectedNode = null;
        this.collectionSelectedRelation = null;
        this.collectionHoveredNode = null;
        this.collectionHoveredRelation = null;
        if (fallbackGraph) this.collectionGraphZoom = this.recommendedCollectionGraphZoom();
        await this.service.render();

        try {
            let limit = collection.id === "dokdo" ? 220 : 180;
            let endpoint = `/wiz/api/page.main/collection_graph?collectionId=${encodeURIComponent(collection.id)}&limit=${limit}&materialLimit=24`;
            let raw = await fetch(endpoint, { signal: controller.signal, cache: "no-cache" });
            let response: any = await raw.json();
            if (token !== this.collectionGraphToken) return;
            if (!raw.ok || response.code != 200) {
                let responseStatus = Number(response.code || raw.status);
                if (responseStatus !== 401 && responseStatus !== 403 && fallbackGraph) {
                    this.collectionGraph = fallbackGraph;
                    this.collectionGraphPartialMessage = "일부 관계를 불러오지 못해 현재 자료 목록으로 만든 기본 관계만 표시합니다.";
                    this.restoreGraphSelectionFromRoute("collection");
                } else {
                    this.collectionGraphErrorMessage = this.graphLoadErrorMessage(responseStatus, response, "주제별");
                }
                return;
            }
            let payload = response?.data?.data || response?.data || {};
            this.collectionGraph = this.cleanKnowledgeGraph(payload);
            this.collectionSelectedNode = null;
            this.collectionSelectedRelation = null;
            this.collectionHoveredNode = null;
            this.collectionHoveredRelation = null;
            this.collectionGraphZoom = this.recommendedCollectionGraphZoom();
            this.restoreGraphSelectionFromRoute("collection");
        } catch (e) {
            if (token !== this.collectionGraphToken) return;
            if ((e as any)?.name === "AbortError") return;
            if (fallbackGraph) {
                this.collectionGraph = fallbackGraph;
                this.collectionGraphPartialMessage = "일부 관계를 불러오지 못해 현재 자료 목록으로 만든 기본 관계만 표시합니다.";
                this.restoreGraphSelectionFromRoute("collection");
            } else {
                this.collectionGraphErrorMessage = "주제별 관계도 요청에 실패했습니다. 잠시 후 다시 시도해 주세요.";
            }
        } finally {
            if (token === this.collectionGraphToken) {
                this.collectionGraphLoading = false;
                this.collectionGraphRequestKey = "";
                if (this.collectionGraphAbortController === controller) this.collectionGraphAbortController = null;
                await this.service.render();
            }
        }
    }

    public collectionCentralNode(): KnowledgeGraphNode | null {
        if (!this.collectionGraph) return null;
        let forcedTopicByCollection: any = {
            dokdo: "독도",
            balhae: "발해",
        };
        let forcedLabel = forcedTopicByCollection[this.currentCollectionId()];
        if (forcedLabel) {
            let forcedKey = this.graphLabelKey(forcedLabel);
            let forcedNode = this.collectionGraph.nodes.find((node) => node.id.startsWith("collection:") && this.graphLabelKey(node.label) === forcedKey)
                || this.collectionGraph.nodes.find((node) => this.graphLabelKey(node.label) === forcedKey && node.type === "주제")
                || this.collectionGraph.nodes.find((node) => this.graphLabelKey(node.label) === forcedKey);
            if (forcedNode) return forcedNode;
        }
        return this.collectionGraph.nodes.find((node) => node.id.startsWith("collection:"))
            || this.collectionGraph.nodes.find((node) => node.type === "주제")
            || this.collectionGraph.nodes[0]
            || null;
    }

    public collectionNodeTypeOptions(): string[] {
        return GRAPH_NODE_TYPE_FILTERS;
    }

    public collectionReviewStatusOptions(): string[] {
        if (!this.collectionGraph) return [];
        let values = this.collectionGraph.nodes.map((node) => node.reviewStatus)
            .concat(this.collectionGraph.relations.map((relation) => relation.reviewStatus));
        return this.uniqueOptions(values);
    }

    public collectionConfidenceLabel(): string {
        let value = Number(this.collectionMinConfidence || 0);
        if (value <= 0) return "전체";
        return `${Math.round(value * 100)}% 이상`;
    }

    public collectionGraphZoomLabel(): string {
        return `${Math.round(this.collectionGraphZoom * 100)}%`;
    }

    public async zoomCollectionGraph(delta: number) {
        this.collectionGraphZoom = this.clampGraphZoom(this.collectionGraphZoom + delta);
        this.syncMainUrl("replace");
        await this.service.render();
    }

    public async fitCollectionGraph() {
        this.collectionGraphZoom = this.recommendedCollectionGraphZoom();
        this.syncMainUrl("replace");
        await this.service.render();
    }

    private recommendedCollectionGraphZoom(): number {
        let nodeCount = this.collectionResourceNodes().length
            + this.collectionTagNodes().length
            + this.collectionEntityNodes().length
            + this.collectionOuterNodes().length;
        if (this.currentCollectionId() === "dokdo") {
            if (nodeCount > 28) return this.clampGraphZoom(1.06);
            if (nodeCount > 18) return this.clampGraphZoom(1.04);
            return this.clampGraphZoom(1.02);
        }
        if (nodeCount > 28) return this.clampGraphZoom(1.02);
        if (nodeCount > 22) return this.clampGraphZoom(1);
        if (nodeCount > 16) return this.clampGraphZoom(0.98);
        return this.clampGraphZoom(1);
    }

    public async resetCollectionGraphView() {
        this.collectionNodeTypeFilter = "";
        this.collectionReviewStatusFilter = "";
        this.graphRelationStatusFilter = "전체";
        this.graphSearchQuery = "";
        this.collectionMinConfidence = 0;
        this.collectionShowEvidence = false;
        this.collectionGraphExpanded = false;
        this.collectionGraphZoom = 1;
        this.collectionSelectedNode = null;
        this.collectionSelectedRelation = null;
        this.collectionHoveredNode = null;
        this.collectionHoveredRelation = null;
        this.collectionRouteSelectedNodeId = "";
        this.collectionRouteSelectedRelationId = "";
        this.collectionAiQuestion = "";
        this.collectionAiAnswer = "";
        this.syncMainUrl("replace");
        await this.service.render();
    }

    public onCollectionGraphFilterChange() {
        this.collectionSelectedNode = null;
        this.collectionSelectedRelation = null;
        this.collectionRouteSelectedNodeId = "";
        this.collectionRouteSelectedRelationId = "";
        this.collectionGraphExpanded = false;
        this.collectionGraphZoom = this.recommendedCollectionGraphZoom();
        this.collectionAiAnswer = "";
        this.syncMainUrl("replace");
    }

    public async clearCollectionGraphSelection(event?: Event) {
        if (event) event.stopPropagation();
        if (!this.collectionSelectedNode && !this.collectionSelectedRelation) return;
        this.collectionSelectedNode = null;
        this.collectionSelectedRelation = null;
        this.collectionRouteSelectedNodeId = "";
        this.collectionRouteSelectedRelationId = "";
        this.collectionAiAnswer = "";
        this.syncMainUrl("replace");
        await this.service.render();
    }

    public collectionFilteredRelationCount(): number {
        return this.filteredCollectionRelations().length;
    }

    public collectionDisplaySummary(): string {
        if (this.collectionGraphLoading && this.collectionGraph) return `기본 관계 ${this.collectionGraph.relations.length}건 · 전체 응답 갱신 중`;
        if (this.collectionGraphLoading) return "응답을 기다리는 중";
        if (!this.collectionGraph) return "응답 범위 미확인";
        let responseTotal = this.collectionGraph?.relations.length || 0;
        let total = this.collectionFilteredRelationCount();
        let visible = this.collectionDisplayRelations().length;
        let range = this.collectionGraph?.summary?.relationLimitReached
            ? `응답 범위 ${responseTotal}건(전체 아님)`
            : `응답 관계 ${responseTotal}건`;
        if (!total) return `${range} · 현재 표시 0건`;
        if (visible < total) return `${range} · 필터 ${total}건 중 ${visible}건 표시`;
        return `${range} · 현재 표시 ${visible}건`;
    }

    public collectionGraphEmptyTitle(): string {
        if (!this.collectionGraph?.relations.length) return "실제 관계 없음";
        if (!this.filteredCollectionRelations().length) return "필터 결과 없음";
        return "표시 항목 없음";
    }

    public collectionGraphEmptyDescription(): string {
        if (!this.collectionGraph?.relations.length) return "현재 응답에는 이 주제와 연결된 관계가 없습니다.";
        if (!this.filteredCollectionRelations().length) return "필터를 바꾸거나 초기화하면 전체 응답 범위를 다시 볼 수 있습니다.";
        return "현재 표시 범위에 포함된 항목이 없습니다. 더 보기를 선택해 확인하세요.";
    }

    public collectionHiddenNodeCount(): number {
        if (!this.isDefaultCollectionGraphLayout()) return 0;
        if (!this.collectionGraph) return 0;
        let total = this.collectionDisplayCandidateNodes().length;
        return Math.max(0, total - this.collectionNodeDisplayLimit(total));
    }

    public collectionCanToggleMore(): boolean {
        return this.collectionGraphExpanded || this.collectionHiddenNodeCount() > 0;
    }

    public collectionMoreButtonLabel(): string {
        if (this.collectionGraphExpanded) return "간략히";
        let count = this.collectionHiddenNodeCount();
        return count > 0 ? `더 보기 ${count}개` : "더 보기";
    }

    public async toggleCollectionGraphMore() {
        this.collectionGraphExpanded = !this.collectionGraphExpanded;
        this.collectionGraphZoom = this.recommendedCollectionGraphZoom();
        this.syncMainUrl("replace");
        await this.service.render();
    }

    public collectionDisplayNodes(): KnowledgeGraphNode[] {
        let rows = this.collectionDisplayCandidateNodes();
        let limit = this.collectionNodeDisplayLimit(rows.length);
        if (!this.collectionNodeTypeFilter && !this.collectionReviewStatusFilter && !this.graphSearchQuery && this.graphRelationStatusFilter === "전체" && this.currentCollectionId() === "dokdo") {
            let priorityRows = rows.filter((node) => node.type !== "자료"
                && node.type !== "관련 자료"
                && !this.isCollectionOuterNode(node)
                && !this.isCollectionCentralDuplicate(node)
                && this.collectionInnerRingPriorityIndex(node) >= 0)
                .sort((a, b) => this.collectionInnerRingPriorityIndex(a) - this.collectionInnerRingPriorityIndex(b)
                    || this.collectionInnerRingMatchStrength(a) - this.collectionInnerRingMatchStrength(b)
                    || this.collectionNodeScore(b) - this.collectionNodeScore(a)
                    || a.label.localeCompare(b.label, "ko"));
            return this.uniqueGraphNodesForDisplay(priorityRows.concat(rows), true).slice(0, limit);
        }
        return rows.slice(0, limit);
    }

    private collectionDisplayCandidateNodes(): KnowledgeGraphNode[] {
        if (!this.collectionGraph) return [];
        let query = this.text(this.graphSearchQuery).toLocaleLowerCase();
        let visibleRelationIds = new Set<string>();
        this.filteredCollectionRelations().forEach((relation) => {
            visibleRelationIds.add(relation.source);
            visibleRelationIds.add(relation.target);
            if (relation.evidenceNodeId) visibleRelationIds.add(relation.evidenceNodeId);
        });
        let relationStatusFiltered = this.graphRelationStatusFilter !== "전체";
        let rows = this.collectionGraph.nodes.filter((node) => {
            if (node.id.startsWith("collection:")) return true;
            if (!this.collectionEvidenceNodesVisible() && this.isEvidenceNodeType(node)) return false;
            if (this.collectionNodeTypeFilter
                && !this.matchesGraphNodeTypeFilter(node, this.collectionNodeTypeFilter)
                && !this.isContextMaterialNode(node, visibleRelationIds)) return false;
            if (this.collectionReviewStatusFilter && node.reviewStatus !== this.collectionReviewStatusFilter) return false;
            if (relationStatusFiltered && !visibleRelationIds.has(node.id)) return false;
            if (query && !`${node.label} ${node.type} ${node.detail || ""}`.toLocaleLowerCase().includes(query) && !visibleRelationIds.has(node.id)) return false;
            if (visibleRelationIds.size && !visibleRelationIds.has(node.id)) return false;
            return true;
        });
        rows.sort((a, b) => this.collectionNodeScore(b) - this.collectionNodeScore(a) || a.label.localeCompare(b.label, "ko"));
        return rows;
    }

    public collectionResourceNodes(): KnowledgeGraphNode[] {
        let rows = this.collectionDisplayCandidateNodes()
            .filter((node) => node.type === "관련 자료" || node.type === "자료");
        return this.uniqueGraphNodesForDisplay(rows, true).slice(0, 4);
    }

    public collectionTagNodes(): KnowledgeGraphNode[] {
        let rows = this.collectionDisplayCandidateNodes()
            .filter((node) => !node.id.startsWith("collection:")
                && node.type !== "관련 자료"
                && node.type !== "자료"
                && !this.isCollectionOuterNode(node)
                && !this.isCollectionCentralDuplicate(node));
        if (this.collectionNodeTypeFilter || this.collectionReviewStatusFilter || this.graphSearchQuery || this.graphRelationStatusFilter !== "전체") {
            return this.uniqueGraphNodesForDisplay(
                rows.filter((node) => node.type === "주제" && node.id.startsWith("tag:")),
            ).slice(0, 6);
        }

        let priorityRows = rows
            .filter((node) => this.collectionInnerRingPriorityIndex(node) >= 0)
            .sort((a, b) => this.collectionInnerRingPriorityIndex(a) - this.collectionInnerRingPriorityIndex(b)
                || this.collectionInnerRingMatchStrength(a) - this.collectionInnerRingMatchStrength(b)
                || this.collectionNodeScore(b) - this.collectionNodeScore(a)
                || a.label.localeCompare(b.label, "ko"));
        let fallbackRows = rows
            .filter((node) => node.type === "주제" && node.id.startsWith("tag:"))
            .sort((a, b) => this.collectionNodeScore(b) - this.collectionNodeScore(a) || a.label.localeCompare(b.label, "ko"));
        return this.uniqueGraphNodesForDisplay(priorityRows.concat(fallbackRows)).slice(0, 6);
    }

    public collectionEntityNodes(): KnowledgeGraphNode[] {
        let used = new Set<string>();
        let usedLabels = new Set<string>();
        this.collectionResourceNodes().concat(this.collectionTagNodes()).forEach((node) => {
            used.add(node.id);
            usedLabels.add(this.graphLabelKey(node.label));
        });
        let rows = this.collectionDisplayCandidateNodes()
            .filter((node) => !node.id.startsWith("collection:")
                && node.type !== "관련 자료"
                && node.type !== "자료"
                && !this.isCollectionOuterNode(node)
                && !used.has(node.id)
                && !usedLabels.has(this.graphLabelKey(node.label))
                && !this.isCollectionCentralDuplicate(node));
        if (this.collectionNodeTypeFilter || this.collectionReviewStatusFilter || this.graphSearchQuery || this.graphRelationStatusFilter !== "전체") return rows.slice(0, 16);
        let prioritized = this.uniqueGraphNodesForDisplay(rows)
            .sort((a, b) => this.collectionMiddleRingScore(b) - this.collectionMiddleRingScore(a)
                || this.collectionNodeScore(b) - this.collectionNodeScore(a)
                || a.label.localeCompare(b.label, "ko"));
        return this.balanceGraphNodes(prioritized, ["place", "event", "actor", "concept"], 2, 8);
    }

    public collectionOuterNodes(): KnowledgeGraphNode[] {
        if (!this.collectionShowEvidence && this.isDefaultCollectionGraphLayout()) return [];
        let rows = this.collectionDisplayCandidateNodes()
            .filter((node) => this.isCollectionOuterNode(node) && !this.isCollectionCentralDuplicate(node));
        return this.uniqueGraphNodesForDisplay(rows).slice(0, 3);
    }

    private isDefaultCollectionGraphLayout(): boolean {
        return !this.collectionNodeTypeFilter
            && !this.collectionReviewStatusFilter
            && !this.graphSearchQuery
            && this.graphRelationStatusFilter === "전체";
    }

    public isCollectionOuterNode(node: KnowledgeGraphNode): boolean {
        return this.isEvidenceNodeType(node) || node.id.startsWith("alias:");
    }

    private currentCollectionId(): string {
        return this.text(this.collectionGraph?.collectionId || this.selectedCollectionId || this.selectedCollection()?.id);
    }

    private graphLabelKey(value: string): string {
        return this.text(value).toLocaleLowerCase().replace(/[^0-9a-z가-힣]/g, "");
    }

    private isCollectionCentralDuplicate(node: KnowledgeGraphNode | null): boolean {
        if (!node) return false;
        let central = this.collectionCentralNode();
        if (!central || node.id === central.id) return false;
        return this.graphLabelKey(node.label) === this.graphLabelKey(central.label);
    }

    private uniqueGraphNodesForDisplay(nodes: KnowledgeGraphNode[], byLabel: boolean = true): KnowledgeGraphNode[] {
        let result: KnowledgeGraphNode[] = [];
        let seen = new Set<string>();
        nodes.forEach((node) => {
            let key = byLabel ? this.graphLabelKey(node.label) : node.id;
            if (!key) key = node.id;
            if (!key || seen.has(key)) return;
            seen.add(key);
            result.push(node);
        });
        return result;
    }

    private collectionPriorityKeyMatches(key: string, target: string): boolean {
        if (!key || !target) return false;
        if (key === target) return true;
        if (key.length >= 3 && target.length >= 3 && (key.includes(target) || target.includes(key))) return true;
        return false;
    }

    private collectionInnerRingPriorityIndex(node: KnowledgeGraphNode | null): number {
        if (!node || this.currentCollectionId() !== "dokdo") return -1;
        let key = this.graphLabelKey(node.label);
        let relatedKeys = (node.relatedTags || []).map((label) => this.graphLabelKey(label)).filter((label) => label);
        for (let i = 0; i < DOKDO_INNER_RING_LABELS.length; i++) {
            let target = this.graphLabelKey(DOKDO_INNER_RING_LABELS[i]);
            if (!target) continue;
            let labelMatches = this.collectionPriorityKeyMatches(key, target);
            let relatedMatches = relatedKeys.some((item) => this.collectionPriorityKeyMatches(item, target));
            if (labelMatches || relatedMatches) {
                return i;
            }
        }
        return -1;
    }

    private collectionInnerRingMatchStrength(node: KnowledgeGraphNode | null): number {
        if (!node || this.currentCollectionId() !== "dokdo") return 99;
        let key = this.graphLabelKey(node.label);
        let relatedKeys = (node.relatedTags || []).map((label) => this.graphLabelKey(label)).filter((label) => label);
        let best = 99;
        DOKDO_INNER_RING_LABELS.forEach((label) => {
            let target = this.graphLabelKey(label);
            if (!target) return;
            if (key && key === target) best = Math.min(best, 0);
            else if (key && key.length >= 3 && target.length >= 3 && target.includes(key)) best = Math.min(best, 1 + Math.max(0, target.length - key.length) * 0.04);
            else if (key && key.length >= 3 && target.length >= 3 && key.includes(target)) best = Math.min(best, 2 + Math.max(0, key.length - target.length) * 0.08);
            if (relatedKeys.some((item) => item === target)) best = Math.min(best, 1.5);
            else if (relatedKeys.some((item) => this.collectionPriorityKeyMatches(item, target))) best = Math.min(best, 2.5);
        });
        return best;
    }

    private collectionMiddleRingScore(node: KnowledgeGraphNode | null): number {
        if (!node) return 0;
        let type = this.normalizeGraphNodeType(this.text(node.nodeType || node.type));
        let score = this.collectionNodeScore(node);
        let priorityIndex = this.collectionInnerRingPriorityIndex(node);
        if (priorityIndex >= 0) score += Math.max(1.5, 12 - priorityIndex * 0.45);
        if (type === "문헌·법령") score += 4;
        if (type === "기관" || type === "인물") score += 3;
        if (type === "시대" || type === "사건") score += 2;
        if (type === "장소") score += 1.5;
        if (type === "개념") score += 1;
        return score;
    }

    public collectionDisplayRelations(): KnowledgeGraphRelation[] {
        if (!this.collectionGraph) return [];
        let visibleIds = new Set(this.collectionDisplayNodes().map((node) => node.id));
        let rows = this.filteredCollectionRelations().filter((relation) => {
            if (!visibleIds.has(relation.source) && !visibleIds.has(relation.target)) return false;
            return true;
        });
        rows.sort((a, b) => this.graphRelationScore(b) - this.graphRelationScore(a) || this.relationTypeLabel(a).localeCompare(this.relationTypeLabel(b), "ko"));
        return rows.slice(0, this.collectionRelationDisplayLimit(rows.length));
    }

    private filteredCollectionRelations(): KnowledgeGraphRelation[] {
        let graph = this.collectionGraph;
        if (!graph) return [];
        let query = this.text(this.graphSearchQuery).toLocaleLowerCase();
        let minConfidence = Number(this.collectionMinConfidence || 0);
        return graph.relations.filter((relation) => {
            if (relation.confidence < minConfidence) return false;
            if (this.collectionReviewStatusFilter && relation.reviewStatus !== this.collectionReviewStatusFilter) return false;
            if (!this.matchesGraphRelationStatusFilter(relation)) return false;
            if (this.collectionNodeTypeFilter && !this.collectionRelationMatchesNodeTypeFilter(relation)) return false;
            if (query && !this.graphRelationMatchesSearch(relation, query)) return false;
            return true;
        });
    }

    private collectionRelationMatchesNodeTypeFilter(relation: KnowledgeGraphRelation): boolean {
        if (!this.collectionNodeTypeFilter || !this.collectionGraph) return true;
        return this.graphNodesForRelation(relation, this.collectionGraph)
            .some((node) => this.matchesGraphNodeTypeFilter(node, this.collectionNodeTypeFilter));
    }

    private collectionEvidenceNodesVisible(): boolean {
        if (this.collectionShowEvidence || this.collectionNodeTypeFilter === "근거") return true;
        return false;
    }

    private collectionNodeScore(node: KnowledgeGraphNode): number {
        let relations = this.collectionAllRelationsForNode(node);
        let relationScore = relations.reduce((sum, relation) => sum + this.graphRelationScore(relation), 0);
        let importanceScore = this.graphNodeImportanceScore(node);
        let priorityBonus = Math.max(0, 9 - this.graphNodePriorityRank(node)) * 0.38;
        let sourceBonus = Math.min(6, Number(node.sourceCount || 0)) * 0.18;
        return importanceScore * 2.1
            + relationScore
            + priorityBonus
            + sourceBonus
            + (node.evidenceCount || 0) * 0.08
            + (node.relatedMaterialCount || 0) * 0.16;
    }

    private collectionNodeDisplayLimit(total: number): number {
        if (this.collectionGraphExpanded && this.isDefaultCollectionGraphLayout()) return Math.min(40, total);
        if (this.collectionNodeTypeFilter || this.collectionReviewStatusFilter || this.graphSearchQuery || this.graphRelationStatusFilter !== "전체") return Math.min(36, total);
        return Math.min(28, total);
    }

    private collectionRelationDisplayLimit(total: number): number {
        if (this.collectionNodeTypeFilter || this.collectionReviewStatusFilter || this.graphSearchQuery || this.graphRelationStatusFilter !== "전체") return Math.min(80, total);
        if (total > 160) return 56;
        if (total > 96) return 64;
        return 72;
    }

    private collectionNodesForRing(ring: CollectionGraphRing): KnowledgeGraphNode[] {
        if (ring === "resource") return this.collectionResourceNodes();
        if (ring === "tag") return this.collectionTagNodes();
        if (ring === "entity") return this.collectionEntityNodes();
        return this.collectionOuterNodes();
    }

    private collectionRingBounds(ring: CollectionGraphRing): { minX: number, maxX: number, minY: number, maxY: number } {
        if (ring === "tag") return { minX: 22, maxX: 78, minY: 16, maxY: 84 };
        if (ring === "entity") return { minX: 11, maxX: 89, minY: 6, maxY: 94 };
        if (ring === "resource") return { minX: 6, maxX: 94, minY: 5, maxY: 95 };
        return { minX: 5, maxX: 95, minY: 4, maxY: 96 };
    }

    private clampGraphPoint(point: GraphLayoutPoint, bounds: { minX: number, maxX: number, minY: number, maxY: number }): GraphLayoutPoint {
        return {
            x: Math.max(bounds.minX, Math.min(bounds.maxX, point.x)),
            y: Math.max(bounds.minY, Math.min(bounds.maxY, point.y)),
        };
    }

    private collectionRadialBasePosition(node: KnowledgeGraphNode, index: number, nodes: KnowledgeGraphNode[], ring: CollectionGraphRing): GraphLayoutPoint {
        let count = Math.max(1, nodes.length);
        let angle = -90;
        let radiusX = 22;
        let radiusY = 24;

        if (ring === "tag") {
            radiusX = 26 + Math.max(0, count - 6) * 0.55;
            radiusY = 28 + Math.max(0, count - 6) * 0.55;
            angle = -138 + (360 / count) * index;
        } else if (ring === "entity") {
            radiusX = 48 + Math.max(0, count - 8) * 0.38;
            radiusY = 47 + Math.max(0, count - 8) * 0.34;
            let group = this.graphSemanticGroup(node);
            let groupNodes = nodes.filter((item) => this.graphSemanticGroup(item) === group);
            let groupIndex = Math.max(0, groupNodes.findIndex((item) => item.id === node.id));
            let groupAngles: any = {
                place: -10,
                event: -22,
                actor: 186,
                concept: -164,
                topic: -96,
                support: 172,
                source: 180,
            };
            let centerAngle = groupAngles[group] ?? -90 + (360 / count) * index;
            let spread = Math.min(92, Math.max(0, groupNodes.length - 1) * 34);
            angle = groupNodes.length <= 1 ? centerAngle : centerAngle - spread / 2 + spread * groupIndex / (groupNodes.length - 1);
        } else if (ring === "resource") {
            radiusX = 45;
            radiusY = 48;
            angle = count <= 1 ? 90 : 36 + (108 * index / (count - 1));
        } else {
            radiusX = 47;
            radiusY = 46;
            angle = -68 + (360 / count) * index;
        }

        let radians = angle * Math.PI / 180;
        return {
            x: 50 + Math.cos(radians) * radiusX,
            y: 50 + Math.sin(radians) * radiusY,
        };
    }

    private resolveCollectionRingCollisions(items: Array<{ node: KnowledgeGraphNode, point: GraphLayoutPoint }>, ring: CollectionGraphRing): Array<{ node: KnowledgeGraphNode, point: GraphLayoutPoint }> {
        let bounds = this.collectionRingBounds(ring);
        let minDistance: any = {
            tag: 18.5,
            entity: 17.5,
            resource: 18,
            outer: 12,
        };
        let rows = items.map((item) => ({ node: item.node, point: this.clampGraphPoint({ x: item.point.x, y: item.point.y }, bounds) }));
        let minimum = minDistance[ring] || 11;
        for (let pass = 0; pass < 7; pass++) {
            for (let i = 0; i < rows.length; i++) {
                for (let j = i + 1; j < rows.length; j++) {
                    let a = rows[i].point;
                    let b = rows[j].point;
                    let weightedDx = (a.x - b.x) * 1.18;
                    let dy = a.y - b.y;
                    let distance = Math.sqrt(weightedDx * weightedDx + dy * dy);
                    if (distance >= minimum) continue;
                    let fallbackAngle = ((i + j + pass + 1) * 137.5) * Math.PI / 180;
                    let ux = distance > 0.001 ? weightedDx / distance : Math.cos(fallbackAngle);
                    let uy = distance > 0.001 ? dy / distance : Math.sin(fallbackAngle);
                    let push = (minimum - distance) / 2 + 0.35;
                    a.x += ux * push / 1.18;
                    b.x -= ux * push / 1.18;
                    a.y += uy * push;
                    b.y -= uy * push;
                    rows[i].point = this.clampGraphPoint(a, bounds);
                    rows[j].point = this.clampGraphPoint(b, bounds);
                }
            }
        }
        return rows;
    }

    private collectionRadialPositionMap(nodes: KnowledgeGraphNode[], ring: CollectionGraphRing): any {
        let rows = nodes.map((node, index) => ({
            node: node,
            point: this.collectionRadialBasePosition(node, index, nodes, ring),
        }));
        let adjusted = this.resolveCollectionRingCollisions(rows, ring);
        let result: any = {};
        adjusted.forEach((item) => result[item.node.id] = item.point);
        return result;
    }

    private collectionNodePositionForNode(node: KnowledgeGraphNode, index: number, count: number, ring: CollectionGraphRing): GraphLayoutPoint {
        if (this.collectionNodeTypeFilter || this.collectionReviewStatusFilter || this.graphSearchQuery || this.graphRelationStatusFilter !== "전체") {
            return this.zoomPosition(this.gridPosition(index, count, 36, 88, 13, 87, 4), this.collectionGraphZoom, 30, 92, 10, 90);
        }
        let ringNodes = this.collectionNodesForRing(ring);
        let positions = this.collectionRadialPositionMap(ringNodes, ring);
        let position = positions[node.id] || this.collectionRadialBasePosition(node, index, ringNodes.length ? ringNodes : [node], ring);
        let bounds = this.collectionRingBounds(ring);
        return this.zoomPosition(position, this.collectionGraphZoom, bounds.minX, bounds.maxX, bounds.minY, bounds.maxY);
    }

    public collectionCentralNodeStyle(): any {
        return {
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
        };
    }

    public collectionNodeStyle(node: KnowledgeGraphNode, index: number, count: number, ring: "resource" | "tag" | "entity" | "outer"): any {
        let position = this.collectionNodePositionForNode(node, index, count, ring);
        return {
            left: `${position.x}%`,
            top: `${position.y}%`,
            transform: "translate(-50%, -50%)",
        };
    }

    public collectionNodeClass(node: KnowledgeGraphNode): string {
        return this.graphNodeClassTokens(node).join(" ");
    }

    public collectionGraphLinkSegments(): GraphLinkSegment[] {
        if (!this.collectionGraph) return [];
        let central = this.collectionCentralNode();
        let resources = this.collectionResourceNodes();
        let tags = this.collectionTagNodes();
        let entities = this.collectionEntityNodes();
        let outers = this.collectionOuterNodes();
        let positions: any = {};
        let nodesById: any = {};
        if (central) positions[central.id] = { x: 50, y: 50 };
        if (central) nodesById[central.id] = central;
        resources.forEach((node, index) => {
            positions[node.id] = this.collectionNodePositionForNode(node, index, resources.length, "resource");
            nodesById[node.id] = node;
        });
        tags.forEach((node, index) => {
            positions[node.id] = this.collectionNodePositionForNode(node, index, tags.length, "tag");
            nodesById[node.id] = node;
        });
        entities.forEach((node, index) => {
            positions[node.id] = this.collectionNodePositionForNode(node, index, entities.length, "entity");
            nodesById[node.id] = node;
        });
        outers.forEach((node, index) => {
            positions[node.id] = this.collectionNodePositionForNode(node, index, outers.length, "outer");
            nodesById[node.id] = node;
        });

        let seen: any = {};
        let segments: GraphLinkSegment[] = [];
        for (let relation of this.collectionDisplayRelations()) {
            let source = positions[relation.source];
            let target = positions[relation.target];
            if (!source || !target) continue;
            let key = `${relation.source}:${relation.target}`;
            if (seen[key]) continue;
            seen[key] = true;
            let sourceNode = nodesById[relation.source] || null;
            let targetNode = nodesById[relation.target] || null;
            segments.push({
                id: relation.id,
                relation: relation,
                sourceNode: sourceNode,
                targetNode: targetNode,
                x1: source.x,
                y1: source.y,
                x2: target.x,
                y2: target.y,
                curveOffset: this.graphRelationCurveOffset(source, target, relation, segments.length),
            });
            if (segments.length >= 90) break;
        }
        return segments;
    }

    public collectionGraphLinkClass(relation: KnowledgeGraphRelation): string {
        let classes = ["graph-link"];
        classes = classes.concat(this.graphRelationStateClassTokens(relation));
        let isSelected = this.isCollectionRelationSelected(relation);
        let isDirect = this.isCollectionRelationDirect(relation);
        if (isSelected) classes.push("is-selected");
        else if (isDirect) classes.push("is-direct");
        if (this.isCollectionRelationHovered(relation)) classes.push("is-hovered");
        if (this.isCollectionSelectionActive() && !isSelected && !isDirect) classes.push("is-dimmed");
        return classes.join(" ");
    }

    public setCollectionHoveredRelation(relation: KnowledgeGraphRelation | null) {
        this.collectionHoveredRelation = relation;
    }

    public clearCollectionHoveredRelation(relation: KnowledgeGraphRelation | null) {
        if (!relation || this.isEquivalentGraphRelation(this.collectionHoveredRelation, relation)) {
            this.collectionHoveredRelation = null;
        }
    }

    public setCollectionHoveredNode(node: KnowledgeGraphNode | null) {
        this.collectionHoveredNode = node;
    }

    public clearCollectionHoveredNode(node: KnowledgeGraphNode | null) {
        if (!node || this.collectionHoveredNode?.id === node.id) {
            this.collectionHoveredNode = null;
        }
    }

    public async selectCollectionGraphNode(node: KnowledgeGraphNode, event?: Event) {
        if (event) event.stopPropagation();
        if (this.collectionSelectedNode?.id === node.id && !this.collectionSelectedRelation) {
            this.collectionSelectedNode = null;
            this.collectionSelectedRelation = null;
        } else {
            this.collectionSelectedNode = node;
            this.collectionSelectedRelation = null;
        }
        this.collectionRouteSelectedNodeId = this.collectionSelectedNode?.id || "";
        this.collectionRouteSelectedRelationId = "";
        this.collectionAiAnswer = "";
        this.syncMainUrl("replace");
        await this.service.render();
    }

    public async selectCollectionGraphRelation(relation: KnowledgeGraphRelation, event?: Event) {
        if (event) event.stopPropagation();
        if (this.collectionSelectedRelation?.id === relation.id) {
            this.collectionSelectedRelation = null;
            this.collectionSelectedNode = null;
            this.collectionRouteSelectedNodeId = "";
            this.collectionRouteSelectedRelationId = "";
            this.collectionAiAnswer = "";
            this.syncMainUrl("replace");
            await this.service.render();
            return;
        }
        this.collectionSelectedRelation = relation;
        this.collectionSelectedNode = this.collectionGraph?.nodes.find((node) => node.id === relation.target)
            || this.collectionGraph?.nodes.find((node) => node.id === relation.source)
            || null;
        this.collectionRouteSelectedRelationId = relation.id;
        this.collectionRouteSelectedNodeId = this.collectionSelectedNode?.id || "";
        this.collectionAiAnswer = "";
        this.syncMainUrl("replace");
        await this.service.render();
    }

    public isCollectionSelectionActive(): boolean {
        return !!(this.collectionSelectedRelation || this.collectionSelectedNode);
    }

    public isCollectionNodeDimmed(node: KnowledgeGraphNode): boolean {
        if (!node) return false;
        if (this.collectionSelectedRelation) {
            return !this.isRelationEndpointNode(node, this.collectionSelectedRelation);
        }
        if (this.collectionSelectedNode) return !this.isCollectionNodeFocused(node);
        return false;
    }

    public isCollectionNodeRelated(node: KnowledgeGraphNode): boolean {
        if (!node || !this.isCollectionSelectionActive() || this.isCollectionNodeDimmed(node)) return false;
        if (this.collectionSelectedRelation) return this.isRelationEndpointNode(node, this.collectionSelectedRelation);
        if (!this.collectionSelectedNode) return false;
        return node.id !== this.collectionSelectedNode.id && this.isCollectionNodeFocused(node);
    }

    private isCollectionNodeFocused(node: KnowledgeGraphNode): boolean {
        if (!node || !this.collectionSelectedNode) return false;
        if (node.id === this.collectionSelectedNode.id) return true;
        return this.collectionAllRelationsForNode(this.collectionSelectedNode).some((relation) => {
            return relation.source === node.id || relation.target === node.id || relation.evidenceNodeId === node.id;
        });
    }

    public isCollectionRelationFocused(relation: KnowledgeGraphRelation): boolean {
        if (!relation) return false;
        if (this.collectionSelectedRelation) return this.isEquivalentGraphRelation(relation, this.collectionSelectedRelation);
        if (!this.collectionSelectedNode) return false;
        return relation.source === this.collectionSelectedNode.id
            || relation.target === this.collectionSelectedNode.id
            || relation.evidenceNodeId === this.collectionSelectedNode.id
            || relation.sourceLabel === this.collectionSelectedNode.label
            || relation.targetLabel === this.collectionSelectedNode.label;
    }

    public isCollectionRelationRelated(relation: KnowledgeGraphRelation): boolean {
        return !!this.collectionSelectedNode && !this.collectionSelectedRelation && this.isCollectionRelationFocused(relation);
    }

    private isCollectionRelationSelected(relation: KnowledgeGraphRelation | null): boolean {
        return !!(relation && this.collectionSelectedRelation && this.isEquivalentGraphRelation(relation, this.collectionSelectedRelation));
    }

    private isCollectionRelationDirect(relation: KnowledgeGraphRelation | null): boolean {
        return !!(relation && !this.collectionSelectedRelation && this.collectionSelectedNode && this.isCollectionRelationFocused(relation));
    }

    private isCollectionRelationHovered(relation: KnowledgeGraphRelation | null): boolean {
        if (!relation) return false;
        if (this.collectionHoveredRelation && this.isEquivalentGraphRelation(relation, this.collectionHoveredRelation)) return true;
        return !!(this.collectionHoveredNode && this.isRelationEndpointNode(this.collectionHoveredNode, relation));
    }

    public collectionRelatedBooks(): BookItem[] {
        let materialIds: string[] = [];
        let materials = this.collectionGraph?.materials || [];
        if (materials.length) {
            materialIds = materials.map((item) => item.id);
        } else {
            materialIds = this.collectionResourceNodes().map((node) => node.materialId || node.id.replace(/^material:/, ""));
        }
        let result: BookItem[] = [];
        for (let id of materialIds) {
            let book = this.findBookByMaterialId(id);
            if (book && !result.find((item) => item.id === book.id)) result.push(book);
        }
        return result.slice(0, 16);
    }

    public findBookByMaterialId(materialId: string): BookItem | null {
        materialId = this.text(materialId);
        if (!materialId) return null;
        return this.books.find((book) => materialId === book.id || materialId === book.hflibId) || null;
    }

    public async openCollectionMaterial(book: BookItem | null, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!book) return;
        await this.openBook(book);
    }

    public async openCollectionRelationPage(relation: KnowledgeGraphRelation) {
        if (!this.relationHasSourcePage(relation)) return;
        this.syncMainUrl("replace");
        let book = this.findBookByMaterialId(relation.materialId);
        if (!book) return;
        let evidencePage = Number(relation.pdfPage || relation.page);
        await this.openBook(book, undefined, true, { fileId: relation.fileId, page: evidencePage, anchor: "ebook-reader" });
        if (!this.selectedBook) return;
        if (relation.fileId) {
            let index = this.selectedBook.pdfs.findIndex((pdf) => (pdf.fileId || pdf.textIndex?.fileId) === relation.fileId);
            if (index >= 0) this.activePdfIndex = index;
            this.selectedFileId = relation.fileId;
        } else if (Number.isFinite(relation.pdfIndex)) {
            this.activePdfIndex = Math.max(0, relation.pdfIndex);
        }
        if (relation.page > 0) {
            this.activePdfPage = evidencePage;
            this.readerPageInput = String(this.activePdfPage);
            this.replaceDetailAnchor("ebook-reader");
            await this.scrollToDetailSection("ebook-reader");
            await this.renderActivePdfPage();
        }
    }

    public async openCollectionNodePage(node: KnowledgeGraphNode) {
        if (!node) return;
        let book = this.findBookByMaterialId(node.materialId || "");
        if (!book && node.materialIds?.length) {
            book = this.findBookByMaterialId(node.materialIds[0]);
        }
        if (!book) return;
        let evidenceRelation = this.collectionAllRelationsForNode(node).find((relation) => this.relationHasSourcePage(relation));
        if (evidenceRelation) {
            await this.openCollectionRelationPage(evidenceRelation);
            return;
        }
        await this.openBook(book);
        if (node.page && this.selectedBook) {
            this.activePdfPage = node.page;
            this.readerPageInput = String(node.page);
            await this.scrollToDetailSection("ebook-reader");
            await this.renderActivePdfPage();
        }
    }

    public collectionRelationsForNode(node: KnowledgeGraphNode | null): KnowledgeGraphRelation[] {
        return this.collectionAllRelationsForNode(node)
            .filter((relation) => this.relationHasSourcePage(relation) && !!relation.sentence)
            .slice(0, 6);
    }

    public collectionAllRelationsForNode(node: KnowledgeGraphNode | null): KnowledgeGraphRelation[] {
        if (!node || !this.collectionGraph) return [];
        return this.collectionGraph.relations
            .filter((relation) => relation.target === node.id
                || relation.source === node.id
                || relation.evidenceNodeId === node.id
                || relation.targetLabel === node.label
                || relation.sourceLabel === node.label)
            .sort((a, b) => this.graphRelationScore(b) - this.graphRelationScore(a));
    }

    public collectionNodeMaterialCount(node: KnowledgeGraphNode | null): number {
        if (!node) return 0;
        let relatedMaterialCount = Number(node.relatedMaterialCount || 0);
        if (relatedMaterialCount > 0) return relatedMaterialCount;
        if (node.materialIds?.length) return node.materialIds.length;
        if (node.materialId || node.type === "자료") return 1;
        let materialIds = new Set(this.collectionAllRelationsForNode(node).map((relation) => relation.materialId).filter((value) => value));
        return materialIds.size;
    }

    public collectionNodeConnectionCount(node: KnowledgeGraphNode | null): number {
        return this.collectionAllRelationsForNode(node).length;
    }

    public collectionNodeTopTargets(node: KnowledgeGraphNode | null): string {
        if (!node) return "연결 없음";
        let labels: string[] = [];
        this.collectionAllRelationsForNode(node).forEach((relation) => {
            let label = relation.source === node.id || relation.sourceLabel === node.label ? relation.targetLabel : relation.sourceLabel;
            label = this.text(label);
            if (label && label !== node.label && !labels.includes(label)) labels.push(label);
        });
        return labels.length ? labels.slice(0, 4).join(", ") : "연결 없음";
    }

    public collectionNodeEvidenceStatus(node: KnowledgeGraphNode | null): string {
        if (!node) return "";
        if (this.text(node.evidenceStatus) === GRAPH_BODY_EVIDENCE_COMPLETE_STATUS) return GRAPH_BODY_EVIDENCE_COMPLETE_STATUS;
        if (Number(node.page || 0) > 0 && node.chunkId) return GRAPH_BODY_EVIDENCE_COMPLETE_STATUS;
        let relations = this.collectionAllRelationsForNode(node);
        if (relations.some((relation) => this.relationEvidenceStatusLabel(relation) === GRAPH_BODY_EVIDENCE_COMPLETE_STATUS)) return GRAPH_BODY_EVIDENCE_COMPLETE_STATUS;
        if (node.evidenceCount > 0) return GRAPH_BODY_EVIDENCE_PENDING_STATUS;
        return GRAPH_BODY_EVIDENCE_PENDING_STATUS;
    }

    public collectionNodeHasRepresentativePage(node: KnowledgeGraphNode | null): boolean {
        if (!node) return false;
        if (Number(node.page || 0) > 0 && !this.text(node.chunkId).startsWith("metadata:")) return true;
        return this.collectionAllRelationsForNode(node).some((relation) => this.relationHasSourcePage(relation));
    }

    public async openCollectionNodeMaterial(node: KnowledgeGraphNode | null) {
        if (!node) return;
        let book = this.findBookByMaterialId(node.materialId || "");
        if (!book && node.materialIds?.length) {
            book = this.findBookByMaterialId(node.materialIds[0]);
        }
        if (!book) {
            let relation = this.collectionAllRelationsForNode(node)[0];
            book = this.findBookByMaterialId(relation?.materialId || "");
        }
        if (book) await this.openCollectionMaterial(book);
    }

    public async showCollectionRelationEvidence(relation: KnowledgeGraphRelation) {
        if (!relation || !this.collectionGraph) return;
        this.collectionShowEvidence = true;
        let evidenceNode = this.collectionGraph.nodes.find((node) => node.id === relation.evidenceNodeId)
            || this.collectionGraph.nodes.find((node) => node.chunkId === relation.chunkId && node.type === "근거 후보");
        if (evidenceNode) {
            this.collectionSelectedNode = evidenceNode;
            this.collectionSelectedRelation = null;
        }
        await this.service.render();
    }

    public async askCollectionAi() {
        if (!this.canAccessResearchAi()) {
            this.collectionAiAnswer = this.accessDeniedMessage("ai");
            this.collectionAiLoading = false;
            await this.service.render();
            return;
        }
        let collection = this.selectedCollection();
        let question = this.text(this.collectionAiQuestion);
        if (!collection || !question) {
            this.collectionAiAnswer = "";
            this.collectionAiLoading = false;
            await this.service.render();
            return;
        }
        let node = this.collectionSelectedNode;
        let relation = this.collectionSelectedRelation;
        let nodeLabel = node?.label || relation?.targetLabel || collection.title;
        let nodeType = node?.type || relation?.type || "컬렉션";
        let materialId = node?.materialId || relation?.materialId || "";
        let requestKey = [
            this.text((this.service.auth.session || {}).id || (this.service.auth.session || {}).username),
            collection.id,
            materialId,
            nodeLabel,
            question,
        ].join("|");
        let requestToken = ++this.collectionAiRequestToken;
        this.collectionAiLoading = true;
        this.collectionAiAnswer = "선택한 모음 범위에서 질문과 관련된 원문 근거를 찾고 있습니다.";
        await this.service.render();
        try {
            let response: any = await wiz.call("collection_ai_answer", {
                collectionId: collection.id,
                question: question,
                nodeLabel: nodeLabel,
                nodeType: nodeType,
                materialId: materialId
            });
            let payload = response?.data?.data || response?.data || {};
            let currentKey = [
                this.text((this.service.auth.session || {}).id || (this.service.auth.session || {}).username),
                this.selectedCollection()?.id,
                this.collectionSelectedNode?.materialId || this.collectionSelectedRelation?.materialId || "",
                this.collectionSelectedNode?.label || this.collectionSelectedRelation?.targetLabel || this.selectedCollection()?.title,
                this.text(this.collectionAiQuestion),
            ].join("|");
            if (requestToken !== this.collectionAiRequestToken || requestKey !== currentKey) return;
            if (response?.code && response.code !== 200) {
                throw new Error(this.text(payload.message || response.message || "모음 질문 범위를 확인하지 못했습니다."));
            }
            if (this.text(payload.answer)) {
                this.collectionAiAnswer = this.text(payload.answer);
                this.collectionAiLoading = false;
                await this.service.render();
                return;
            }
        } catch (e) {
            if (requestToken !== this.collectionAiRequestToken) return;
            this.collectionAiLoading = false;
            this.collectionAiAnswer = `${this.text((e as any)?.message) || "모음에서 관련 근거를 찾지 못했습니다."} 범위를 자동으로 넓히지 않았습니다. 같은 범위에서 다시 시도할 수 있습니다.`;
            await this.service.render();
            return;
        }
        this.collectionAiLoading = false;
        this.collectionAiAnswer = `검색 범위: ${collection.title} 모음 / 선택 항목: ${nodeType} ${nodeLabel}. 현재 범위를 유지한 채 충분한 원문 근거 문장을 찾지 못했습니다. 더 넓은 범위는 사용자가 별도로 선택해야 합니다.`;
        await this.service.render();
    }

    private graphNodeExportPalette(node: KnowledgeGraphNode, centralTopic: boolean = false): { bg: string, border: string, text: string, accent: string } {
        let color = DESIGN_EXPORT_COLORS;
        let type = this.normalizeGraphNodeType(this.text(node.nodeType || node.type));
        if (centralTopic) {
            return { bg: color.centralTopicBg, border: color.centralTopicBg, text: color.centralTopicText, accent: color.accentStrong };
        }
        if (type === "자료") {
            return { bg: color.materialBg, border: color.materialBorder, text: color.materialText, accent: color.materialBorder };
        }
        if (type === "관련 자료") {
            return { bg: color.relatedMaterialBg, border: color.relatedMaterialBorder, text: color.relatedMaterialText, accent: color.relatedMaterialBorder };
        }
        if (type === "주제") {
            return { bg: color.topicBg, border: color.topicBorder, text: color.topicText, accent: color.topicBorder };
        }
        if (type === "장소") {
            return { bg: color.placeBg, border: color.placeBorder, text: color.placeText, accent: color.placeBorder };
        }
        if (type === "인물" || type === "기관") {
            return { bg: color.actorBg, border: color.actorBorder, text: color.actorText, accent: color.actorBorder };
        }
        if (type === "사건" || type === "시대") {
            return { bg: color.eventBg, border: color.eventBorder, text: color.eventText, accent: color.eventText };
        }
        if (type === "문헌·법령" || type === "개념") {
            return { bg: color.conceptBg, border: color.conceptBorder, text: color.conceptText, accent: color.conceptBorder };
        }
        if (type === "쟁점·반박") {
            return { bg: color.issueBg, border: color.issueBorder, text: color.issueText, accent: color.issueBorder };
        }
        return { bg: color.evidenceBg, border: color.evidenceBorder, text: color.evidenceText, accent: color.evidenceBorder };
    }

    public exportCollectionGraphImage() {
        if (!this.collectionGraph) return;
        let collection = this.selectedCollection();
        let width = 1280;
        let height = 860;
        let nodes: Array<{ node: KnowledgeGraphNode, x: number, y: number, palette: { bg: string, border: string, text: string, accent: string }, centralTopic?: boolean }> = [];
        let central = this.collectionCentralNode();
        let scalePoint = (point: GraphLayoutPoint) => ({ x: point.x * width / 100, y: point.y * height / 100 });
        if (central) {
            let position = scalePoint({ x: 50, y: 50 });
            nodes.push({ node: central, x: position.x, y: position.y, palette: this.graphNodeExportPalette(central, true), centralTopic: true });
        }
        let addGroup = (rows: KnowledgeGraphNode[], ring: "resource" | "tag" | "entity" | "outer") => {
            rows.forEach((node, index) => {
                let point = scalePoint(this.collectionNodePositionForNode(node, index, rows.length, ring));
                nodes.push({ node, x: point.x, y: point.y, palette: this.graphNodeExportPalette(node) });
            });
        };
        addGroup(this.collectionResourceNodes(), "resource");
        addGroup(this.collectionTagNodes(), "tag");
        addGroup(this.collectionEntityNodes(), "entity");
        addGroup(this.collectionOuterNodes(), "outer");
        let positions: any = {};
        nodes.forEach((item) => positions[item.node.id] = item);
        let lines = this.collectionDisplayRelations()
            .filter((relation) => positions[relation.source] && positions[relation.target])
            .slice(0, 120)
            .map((relation, index) => {
                let source = positions[relation.source];
                let target = positions[relation.target];
                return this.exportGraphRelationSvg(relation, source, target, index, "collection");
            }).join("");
        let nodeSvg = nodes.map((item) => this.exportGraphNodeSvg(item.node, item.x, item.y, item.palette, Boolean(item.centralTopic))).join("");
        let title = this.escapeHtml(collection?.title || this.collectionGraph.bookTitle || "컬렉션");
        let labels = `<text x="610" y="224" font-size="12" font-weight="700" fill="${DESIGN_EXPORT_COLORS.textMuted}">안쪽 링: 핵심 개념</text><text x="840" y="322" font-size="12" font-weight="700" fill="${DESIGN_EXPORT_COLORS.textMuted}">중간 링: 장소·사건·기관</text><text x="116" y="616" font-size="12" font-weight="700" fill="${DESIGN_EXPORT_COLORS.textMuted}">자료 링</text><text x="978" y="760" font-size="12" font-weight="700" fill="${DESIGN_EXPORT_COLORS.textMuted}">바깥 링: 근거·별칭</text>`;
        let rings = `<circle cx="640" cy="430" r="188" fill="none" stroke="${DESIGN_EXPORT_COLORS.border}" stroke-width="1" opacity="0.28"/><circle cx="640" cy="430" r="306" fill="none" stroke="${DESIGN_EXPORT_COLORS.border}" stroke-width="1" opacity="0.2"/><circle cx="640" cy="430" r="388" fill="none" stroke="${DESIGN_EXPORT_COLORS.border}" stroke-width="1" opacity="0.14"/>`;
        let svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}"><rect width="100%" height="100%" fill="${DESIGN_EXPORT_COLORS.background}"/><text x="40" y="54" font-size="30" font-weight="800" fill="${DESIGN_EXPORT_COLORS.text}">${title} 자료 관계도</text><text x="40" y="84" font-size="14" fill="${DESIGN_EXPORT_COLORS.textMuted}">관련 자료 ${this.collectionResourceNodes().length}건 · 주제 ${this.collectionTagNodes().length}건 · 관계 ${this.collectionDisplayRelations().length}건</text>${rings}${labels}${lines}${nodeSvg}</svg>`;
        let filename = `${this.text(collection?.title || "collection").replace(/[^0-9A-Za-z가-힣_-]+/g, "-")}-collection-graph.svg`;
        this.downloadBlob(filename, svg, "image/svg+xml;charset=utf-8");
    }

    public async runBodySearch(book: BookItem) {
        if (!this.canAccessBookOriginals(book)) {
            this.bodySearchResults = [];
            await this.service.render();
            return;
        }
        let query = this.text(this.bodySearchQuery);
        if (!query) {
            this.bodySearchResults = [];
            await this.service.render();
            return;
        }

        try {
            let response: any = await wiz.call("body_search", {
                q: query,
                bookId: book.id || book.hflibId,
                limit: 14
            });
            let payload = response?.data?.data || response?.data || {};
            let hits = this.cleanBodySearchHits(payload.results || []);
            if (hits.length > 0 || book.bodySearchAvailable) {
                this.bodySearchResults = hits;
                await this.service.render();
                return;
            }
        } catch (e) { }

        let queryLower = query.toLocaleLowerCase();
        let candidates: BodySearchHit[] = [
            {
                title: "제목",
                context: book.title,
                source: "서지정보",
                pageLabel: "자료ID " + book.hflibId,
                status: "수집 메타데이터",
            },
            {
                title: "저자·편찬기관",
                context: this.authorOrCompiler(book),
                source: "서지정보",
                pageLabel: "MARC/상세 메타데이터",
                status: "수집 메타데이터",
            },
            {
                title: "발행기관",
                context: this.publisherYearLabel(book),
                source: "서지정보",
                pageLabel: this.publishedYearLabel(book),
                status: "수집 메타데이터",
            },
            {
                title: "자료 설명",
                context: book.description,
                source: "서지정보",
                pageLabel: "소개 필드",
                status: "수집 메타데이터",
            },
            {
                title: "분류 정보",
                context: this.classificationLabel(book),
                source: "서지정보",
                pageLabel: book.kdc ? "KDC" : "자료유형",
                status: "수집 메타데이터",
            },
            ...book.tags.map((tag) => ({
                title: tag.name,
                context: `${this.axisDisplayName(tag.axis)} · ${this.aliasSummary(book, tag) || tag.evidence || "주제어"}`,
                source: "주제어",
                pageLabel: "메타데이터 근거",
                status: "주제어",
            })),
            ...book.pdfs.map((pdf, index) => ({
                title: pdf.filename,
                context: `${pdf.originalFilename || pdf.filename} · ${pdf.sizeLabel || "크기 정보 없음"}`,
                source: "원문 파일",
                pageLabel: `${index + 1}권`,
                status: "원문 파일 확인",
            })),
        ];

        this.bodySearchResults = candidates
            .filter((hit) => `${hit.title} ${hit.context} ${hit.source} ${hit.pageLabel}`.toLocaleLowerCase().includes(queryLower))
            .slice(0, 8);
        await this.service.render();
    }

    public cleanBodySearchHits(items: any[]): BodySearchHit[] {
        if (!Array.isArray(items)) return [];
        return items.map((item) => ({
            id: this.text(item.id || item.chunkId),
            chunkId: this.text(item.chunkId || item.id),
            bookId: this.text(item.bookId || item.hflibId),
            bookTitle: this.text(item.bookTitle || item.title),
            title: this.text(item.title || item.bookTitle || "본문 근거"),
            context: this.text(item.context || item.quote),
            source: this.text(item.source || "원문 본문"),
            pageLabel: this.text(item.pageLabel || `${item.page || ""}쪽`),
            status: this.text(item.status || "본문 정리"),
            page: Number(item.page || 0),
            paragraph: Number(item.paragraph || 0),
            fileId: this.text(item.fileId),
            pdfFilename: this.text(item.pdfFilename),
            pdfIndex: Number(item.pdfIndex || 0),
            pdfUrl: this.text(item.pdfUrl),
            quote: this.text(item.quote || item.context),
            qualityScore: Number(item.qualityScore || 0)
        })).filter((item) => item.context || item.title);
    }

    public cleanAiEvidenceItems(items: any[]): AiEvidenceItem[] {
        if (!Array.isArray(items)) return [];
        return items.map((item) => ({
            id: this.text(item.id || item.chunkId),
            chunkId: this.text(item.chunkId || item.id),
            bookId: this.text(item.bookId || item.hflibId),
            hflibId: this.text(item.hflibId),
            bookTitle: this.text(item.bookTitle || item.title),
            title: this.text(item.title || item.bookTitle || "본문 근거"),
            pdfFilename: this.text(item.pdfFilename),
            fileId: this.text(item.fileId),
            page: Number(item.page || 0),
            paragraph: Number(item.paragraph || 0),
            pageLabel: this.text(item.pageLabel || `${item.page || ""}쪽`),
            printedPage: this.text(item.printedPage),
            printedPageStatus: this.text(item.printedPageStatus || (item.printedPage ? "확인됨" : "미확인")),
            pageMappingStatus: this.text(item.pageMappingStatus || "PDF 쪽 기준"),
            evidenceParagraph: this.text(item.evidenceParagraph || item.quote || item.context),
            quote: this.text(item.quote || item.evidenceParagraph || item.context),
            context: this.text(item.context || item.evidenceParagraph || item.quote),
            source: this.text(item.source || "원문 본문"),
            status: this.text(item.status || "본문 정리"),
            qualityScore: Number(item.qualityScore || 0),
            qualityEligibility: item.qualityEligibility || {},
            pdfUrl: this.text(item.pdfUrl)
        })).filter((item) => item.evidenceParagraph || item.bookTitle);
    }

    public cleanAppliedAiScope(item: any): AppliedAiScope {
        item = item || {};
        return {
            type: this.text(item.type),
            label: this.text(item.label),
            identifier: this.text(item.identifier),
            materialIds: Array.isArray(item.materialIds) ? item.materialIds.map((value: any) => this.text(value)).filter((value: string) => value) : [],
            materialCount: Number(item.materialCount || 0),
            totalFileCount: Number(item.totalFileCount || 0),
            searchableFileCount: Number(item.searchableFileCount || 0),
            coverageLabel: this.text(item.coverageLabel),
            accessScope: this.text(item.accessScope),
            autoExpanded: Boolean(item.autoExpanded),
            contractVersion: this.text(item.contractVersion),
            qualityPolicyVersion: this.text(item.qualityPolicyVersion),
            qualitySignature: this.text(item.qualitySignature),
            requestContextId: this.text(item.requestContextId)
        };
    }

    public cleanAiCitationSources(items: any[]): AiCitationSource[] {
        if (!Array.isArray(items)) return [];
        return items.map((item) => ({
            materialId: this.text(item.materialId),
            fileId: this.text(item.fileId),
            chunkId: this.text(item.chunkId),
            bookTitle: this.text(item.bookTitle),
            pdfFilename: this.text(item.pdfFilename),
            page: Number(item.page || 0),
            printedPage: this.text(item.printedPage),
            paragraph: Number(item.paragraph || 0),
            qualityEligibility: item.qualityEligibility || {}
        })).filter((item) => item.materialId && item.chunkId);
    }

    public cleanAiMaterials(items: any[]): AiMaterialItem[] {
        if (!Array.isArray(items)) return [];
        return items.map((item) => ({
            id: this.text(item.id || item.hflibId),
            hflibId: this.text(item.hflibId),
            title: this.text(item.title),
            author: this.text(item.author),
            publisher: this.text(item.publisher),
            publishedDate: this.text(item.publishedDate),
            publishedYear: Number(item.publishedYear || 0) || undefined,
            pdfCount: Number(item.pdfCount || 0),
            bodyChunkCount: Number(item.bodyChunkCount || 0),
            citationCandidateCount: Number(item.citationCandidateCount || 0),
            reviewStatus: this.text(item.reviewStatus || "검수대기"),
            publicStatus: this.text(item.publicStatus || "내부전용"),
            evidenceCount: Number(item.evidenceCount || 0),
            reason: this.text(item.reason)
        })).filter((item) => item.id && item.title);
    }

    public cleanAiAnswerPayload(payload: any): AiAnswerPayload | null {
        if (!payload) return null;
        let answer = this.text(payload.answer);
        let evidence = this.cleanAiEvidenceItems(payload.coreEvidence || payload.evidence || []);
        let related = this.cleanAiMaterials(payload.relatedMaterials || []);
        let additional = this.cleanAiMaterials(payload.additionalMaterials || []);
        if (!answer && !evidence.length && !payload.shortConclusion) return null;
        return {
            question: this.text(payload.question || this.aiQuestion),
            searchScope: this.text(payload.searchScope),
            scopeType: this.text(payload.scopeType),
            appliedScope: this.cleanAppliedAiScope(payload.appliedScope),
            citationSources: this.cleanAiCitationSources(payload.citationSources || []),
            requestContextId: this.text(payload.requestContextId || payload.appliedScope?.requestContextId),
            shortConclusion: this.text(payload.shortConclusion),
            featureName: this.text(payload.featureName || "질문과 관련된 근거 찾기"),
            resultMode: this.text(payload.resultMode || "evidence_retrieval"),
            generationAvailable: Boolean(payload.generationAvailable),
            capabilityNotice: this.text(payload.capabilityNotice || "현재 범위의 검색 가능한 원문에서 질문과 관련된 근거 후보를 찾습니다."),
            coreEvidence: evidence,
            relatedMaterials: related,
            uncertainties: Array.isArray(payload.uncertainties) ? payload.uncertainties.map((item: any) => this.text(item)).filter((item: string) => item) : [],
            additionalMaterials: additional,
            additionalMaterialTitles: Array.isArray(payload.additionalMaterialTitles) ? payload.additionalMaterialTitles.map((item: any) => this.text(item)).filter((item: string) => item) : [],
            answer: answer,
            insufficient: Boolean(payload.insufficient),
            reviewStatus: this.text(payload.reviewStatus || "자동 검색 결과 · 사람 확인 필요"),
            publicStatus: this.text(payload.publicStatus || "내부전용"),
            model: this.text(payload.model || "local-evidence-retrieval")
        };
    }

    public cleanCitationCandidates(items: any[]): CitationCandidateItem[] {
        if (!Array.isArray(items)) return [];
        return items.map((item) => ({
            id: this.text(item.id || item.citationId),
            citationId: this.text(item.citationId || item.id),
            chunkId: this.text(item.chunkId),
            bookId: this.text(item.bookId),
            bookTitle: this.text(item.bookTitle),
            pdfFilename: this.text(item.pdfFilename),
            page: Number(item.page || 0),
            paragraph: Number(item.paragraph || 0),
            sentence: this.text(item.sentence),
            status: this.text(item.status || "인용후보")
        })).filter((item) => item.sentence);
    }

    public cleanBibliography(items: any[]): BibliographyItem[] {
        if (!Array.isArray(items)) return [];
        return items.map((item) => ({
            bookId: this.text(item.bookId),
            title: this.text(item.title),
            citation: this.text(item.citation),
            reviewStatus: this.text(item.reviewStatus || "검수대기"),
            publicStatus: this.text(item.publicStatus || "내부전용")
        })).filter((item) => item.citation);
    }

    public cleanReportAssistantPayload(payload: any): ReportAssistantPayload | null {
        if (!payload) return null;
        return {
            searchScope: this.text(payload.searchScope),
            scopeType: this.text(payload.scopeType),
            appliedScope: payload.appliedScope ? this.cleanAppliedAiScope(payload.appliedScope) : undefined,
            citationSources: this.cleanAiCitationSources(payload.citationSources || []),
            requestContextId: this.text(payload.requestContextId || payload.appliedScope?.requestContextId),
            warning: this.text(payload.warning || "자동 생성 보고서가 아니라 내부 검토용 보조 결과입니다."),
            evidenceParagraphs: this.cleanAiEvidenceItems(payload.evidenceParagraphs || []),
            materialBundle: this.cleanAiMaterials(payload.materialBundle || []),
            citationCandidates: this.cleanCitationCandidates(payload.citationCandidates || []),
            bibliography: this.cleanBibliography(payload.bibliography || []),
            outline: Array.isArray(payload.outline) ? payload.outline.map((item: any) => this.text(item)).filter((item: string) => item) : [],
            issueEvidence: Array.isArray(payload.issueEvidence)
                ? payload.issueEvidence.map((group: any) => ({
                    issue: this.text(group.issue || "쟁점"),
                    evidence: this.cleanAiEvidenceItems(group.evidence || [])
                })).filter((group: IssueEvidenceGroup) => group.issue && group.evidence.length)
                : [],
            graphExport: {
                status: this.text(payload.graphExport?.status || "그래프 이미지 내보내기 가능"),
                formats: Array.isArray(payload.graphExport?.formats) ? payload.graphExport.formats.map((item: any) => this.text(item)).filter((item: string) => item) : ["SVG"],
                basis: this.text(payload.graphExport?.basis || "근거 기반 자동추출 그래프")
            },
            reviewStatus: this.text(payload.reviewStatus || "자동 생성 초안"),
            publicStatus: this.text(payload.publicStatus || "내부전용"),
            insufficient: Boolean(payload.insufficient)
        };
    }

    public async openBodySearchHit(hit: BodySearchHit) {
        if (!this.selectedBook || !hit) return;
        if (hit.fileId) {
            let index = this.selectedBook.pdfs.findIndex((pdf) => (pdf.fileId || pdf.textIndex?.fileId) === hit.fileId);
            if (index >= 0) this.activePdfIndex = index;
        } else if (typeof hit.pdfIndex === "number" && Number.isFinite(hit.pdfIndex)) {
            this.activePdfIndex = Math.max(0, hit.pdfIndex);
        }
        if (hit.page && hit.page > 0) {
            this.activePdfPage = hit.page;
            this.readerPageInput = String(hit.page);
        }
        await this.scrollToDetailSection("ebook-reader");
        await this.renderActivePdfPage();
    }

    public async clearBodySearch() {
        this.bodySearchQuery = "";
        this.bodySearchResults = [];
        await this.service.render();
    }

    public async askAi(book: BookItem) {
        if (!this.canAccessResearchAi()) {
            this.aiAnswer = null;
            this.aiDraftAnswer = this.accessDeniedMessage("ai");
            this.aiRequestState = "error";
            await this.service.render();
            this.focusQuestionResult();
            return;
        }
        let question = this.text(this.aiQuestion);
        if (!question) {
            this.aiDraftAnswer = "";
            this.aiAnswer = null;
            this.aiRequestState = "idle";
            await this.service.render();
            return;
        }

        let validationMessage = this.aiScopeValidationMessage(book);
        if (validationMessage) {
            this.aiAnswer = null;
            this.aiDraftAnswer = validationMessage;
            this.aiRequestState = "error";
            await this.service.render();
            this.focusQuestionResult();
            return;
        }

        let selectedMaterialId = this.aiScopeType === "selected" ? this.aiScopeIdentifier(book) : "";
        let requestKey = this.aiScopeRequestKey(book);
        let requestToken = ++this.aiRequestToken;
        this.aiAnswer = null;
        this.aiRequestState = "loading";
        this.aiDraftAnswer = "선택한 범위의 검색 가능한 원문에서 질문과 관련된 근거를 찾고 있습니다.";
        await this.service.render();

        try {
            let response: any = await wiz.call("ai_answer", {
                question: question,
                bookId: selectedMaterialId,
                bookIds: selectedMaterialId,
                scope: this.aiScopeType,
                tagName: this.aiScopeTag,
                collectionId: this.aiScopeCollectionId
            });
            let payload = response?.data?.data || response?.data || {};
            if (requestToken !== this.aiRequestToken || requestKey !== this.aiScopeRequestKey(book)) return;
            if (response?.code && response.code !== 200) {
                throw new Error(this.text(payload.message || response.message || "질문 범위를 확인하지 못했습니다."));
            }
            let answer = this.cleanAiAnswerPayload(payload);
            if (answer) {
                this.aiAnswer = answer;
                this.aiDraftAnswer = answer.answer;
                this.aiRequestState = answer.insufficient ? "empty" : "success";
                await this.service.render();
                this.focusQuestionResult();
                return;
            }
            throw new Error("현재 범위의 근거 검색 결과를 확인하지 못했습니다.");
        } catch (e) {
            if (requestToken !== this.aiRequestToken || requestKey !== this.aiScopeRequestKey(book)) return;
            this.aiDraftAnswer = `${this.text((e as any)?.message) || "관련 근거를 찾지 못했습니다."} 범위를 자동으로 넓히지 않았습니다. 같은 범위에서 다시 시도할 수 있습니다.`;
            this.aiRequestState = "error";
        }
        this.aiAnswer = null;
        await this.service.render();
        this.focusQuestionResult();
    }

    public async runReportAssistant(book: BookItem) {
        if (!this.canAccessResearchAi()) {
            this.reportAssistant = null;
            this.reportErrorMessage = this.accessDeniedMessage("ai");
            await this.service.render();
            return;
        }
        let question = this.text(this.aiQuestion) || `${book.title} 보고서 보조`;
        let validationMessage = this.aiScopeValidationMessage(book);
        if (validationMessage) {
            this.reportAssistant = null;
            this.reportErrorMessage = validationMessage;
            await this.service.render();
            return;
        }
        let selectedMaterialId = this.aiScopeType === "selected" ? this.aiScopeIdentifier(book) : "";
        let requestKey = this.aiScopeRequestKey(book);
        let requestToken = ++this.reportRequestToken;
        this.reportLoading = true;
        this.reportErrorMessage = "";
        await this.service.render();

        try {
            let response: any = await wiz.call("report_assistant", {
                question: question,
                bookId: selectedMaterialId,
                bookIds: selectedMaterialId,
                scope: this.aiScopeType,
                tagName: this.aiScopeTag,
                collectionId: this.aiScopeCollectionId
            });
            let payload = response?.data?.data || response?.data || {};
            if (requestToken !== this.reportRequestToken || requestKey !== this.aiScopeRequestKey(book)) return;
            if (response?.code && response.code !== 200) {
                throw new Error(this.text(payload.message || response.message || "보고서 보조 범위를 확인하지 못했습니다."));
            }
            this.reportAssistant = this.cleanReportAssistantPayload(payload);
            this.reportLoading = false;
            await this.service.render();
            return;
        } catch (e) {
            if (requestToken !== this.reportRequestToken || requestKey !== this.aiScopeRequestKey(book)) return;
            this.reportLoading = false;
            this.reportErrorMessage = `${this.text((e as any)?.message) || "보고서 보조 자료를 생성하지 못했습니다."} 범위를 자동으로 넓히지 않았습니다.`;
            await this.service.render();
        }
    }

    public async saveAiEvidence(item: AiEvidenceItem) {
        let book = this.findBookByMaterialId(item.bookId || item.hflibId || "");
        let evidence: EvidenceItem = {
            id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
            bookId: item.bookId || item.hflibId || book?.id || "",
            bookTitle: item.bookTitle || book?.title || "본문 근거",
            page: Number(item.page || 0),
            scope: `질문 관련 근거 ${item.paragraph ? "문단 " + item.paragraph : ""}`.trim(),
            quote: this.truncate(item.evidenceParagraph || item.quote || item.context, 520),
            source: `${item.pdfFilename || "PDF 본문"} · ${item.chunkId || item.status}`,
            savedAt: new Date().toISOString()
        };
        if (!evidence.bookId || !evidence.quote) return;
        this.evidenceBox = [evidence].concat(this.evidenceBox).slice(0, 80);
        this.persistEvidenceBox();
        await this.service.render();
    }

    public async openAiEvidence(item: AiEvidenceItem) {
        let book = this.findBookByMaterialId(item.bookId || item.hflibId || "");
        if (!book) return;
        await this.openBook(book, undefined, true, {
            fileId: this.text(item.fileId),
            page: Number(item.page || 0),
            anchor: "ebook-reader",
        });
        if (!this.selectedBook) return;
        await this.scrollToDetailSection("ebook-reader");
        this.syncMainUrl("replace");
    }

    public async openAiMaterial(item: AiMaterialItem | BibliographyItem | CitationCandidateItem) {
        let id = this.text((item as any).id || (item as any).bookId || (item as any).hflibId);
        let book = this.findBookByMaterialId(id);
        if (!book) return;
        await this.openBook(book);
    }

    public exportBibliography() {
        if (!this.reportAssistant || !this.reportAssistant.bibliography.length) return;
        let lines = this.reportAssistant.bibliography.map((item, index) => `${index + 1}. ${item.citation}`);
        this.downloadTextFile("nah-bibliography.txt", lines.join("\n"));
    }

    public exportBookGraphImage(book: BookItem) {
        if (!this.knowledgeGraph) return;
        let width = 1180;
        let height = 760;
        let nodes: Array<{ node: KnowledgeGraphNode, x: number, y: number, palette: { bg: string, border: string, text: string, accent: string } }> = [];
        let central = this.graphCentralNode();
        let scalePoint = (point: GraphLayoutPoint) => ({ x: point.x * width / 100, y: point.y * height / 100 });
        if (central) {
            let position = scalePoint({ x: 50, y: 50 });
            nodes.push({ node: central, x: position.x, y: position.y, palette: this.graphNodeExportPalette(central) });
        }
        let surrounding = this.graphSurroundingNodes(book).slice(0, 18);
        surrounding.forEach((node) => {
            let point = scalePoint(this.graphNodePositionForNode(node, surrounding));
            nodes.push({
                node: node,
                x: point.x,
                y: point.y,
                palette: this.graphNodeExportPalette(node)
            });
        });
        let positions: any = {};
        nodes.forEach((item) => positions[item.node.id] = item);
        let lines = this.graphDisplayRelations(book)
            .filter((relation) => positions[relation.source] && positions[relation.target])
            .slice(0, 44)
            .map((relation, index) => {
                let source = positions[relation.source];
                let target = positions[relation.target];
                return this.exportGraphRelationSvg(relation, source, target, index, "book");
            }).join("");
        let nodeSvg = nodes.map((item) => this.exportGraphNodeSvg(item.node, item.x, item.y, item.palette)).join("");
        let title = this.escapeHtml(book.title);
        let legend = `<g opacity="0.72"><rect x="40" y="690" width="246" height="30" rx="6" fill="#FFFFFF" stroke="${DESIGN_EXPORT_COLORS.border}" stroke-width="1"/><text x="54" y="710" font-size="11" font-weight="700" fill="${DESIGN_EXPORT_COLORS.textMuted}">항목 유형은 이름·아이콘·색상으로 구분</text></g>`;
        let rings = `<circle cx="590" cy="380" r="188" fill="none" stroke="${DESIGN_EXPORT_COLORS.border}" stroke-width="1" opacity="0.28"/><circle cx="590" cy="380" r="282" fill="none" stroke="${DESIGN_EXPORT_COLORS.border}" stroke-width="1" opacity="0.2"/><circle cx="590" cy="380" r="342" fill="none" stroke="${DESIGN_EXPORT_COLORS.border}" stroke-width="1" opacity="0.14"/>`;
        let svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}"><rect width="100%" height="100%" fill="${DESIGN_EXPORT_COLORS.background}"/><text x="40" y="54" font-size="30" font-weight="800" fill="${DESIGN_EXPORT_COLORS.text}">${title}</text><text x="40" y="84" font-size="14" fill="${DESIGN_EXPORT_COLORS.textMuted}">관계 ${this.graphDisplayRelations(book).length}건 · 근거 기반 연결 · ${this.publicGraphText(this.knowledgeGraph.extractionBasis)}</text>${rings}${lines}${nodeSvg}${legend}</svg>`;
        let filename = `${this.text(book.title || "book").replace(/[^0-9A-Za-z가-힣_-]+/g, "-")}-knowledge-graph.svg`;
        this.downloadBlob(filename, svg, "image/svg+xml;charset=utf-8");
    }

    private downloadTextFile(filename: string, content: string) {
        this.downloadBlob(filename, content, "text/plain;charset=utf-8");
    }

    private downloadBlob(filename: string, content: string, type: string) {
        let blob = new Blob([content], { type: type });
        let url = URL.createObjectURL(blob);
        let anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = filename;
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        URL.revokeObjectURL(url);
    }

    public resetDetailTools() {
        let preserveGraphRouteState = this.activeTopTab === "graph";
        this.knowledgeGraphAbortController?.abort();
        this.knowledgeGraphToken++;
        this.aiRequestToken++;
        this.reportRequestToken++;
        this.bodySearchQuery = "";
        this.bodySearchResults = [];
        this.aiQuestion = "";
        this.aiDraftAnswer = "";
        this.aiAnswer = null;
        this.aiRequestState = "idle";
        this.reportAssistant = null;
        this.reportLoading = false;
        this.reportErrorMessage = "";
        this.readerSearchQuery = "";
        this.readerSearchResults = [];
        this.readerSearchMessage = "";
        this.readerAiQuestion = "";
        this.readerAiAnswer = "";
        this.readerAiLoading = false;
        this.readerAiAnswerContext = "";
        this.readerAiRequestToken++;
        this.currentPageMatchCount = 0;
        this.knowledgeGraph = null;
        this.graphLoading = false;
        this.graphErrorMessage = "";
        this.graphSelectedNode = null;
        this.graphSelectedRelation = null;
        this.graphHoveredNode = null;
        this.graphHoveredRelation = null;
        if (!preserveGraphRouteState) {
            this.graphNodeTypeFilter = "";
            this.graphRelationTypeFilter = "";
            this.graphRelationStatusFilter = "전체";
            this.graphSearchQuery = "";
            this.graphMinConfidence = 0;
            this.graphShowEvidence = false;
            this.graphExpanded = false;
            this.graphZoom = 1;
        }
    }

    public activePdf(book: BookItem): PdfAsset | null {
        if (!book.pdfs.length) return null;
        return book.pdfs[Math.min(this.activePdfIndex, book.pdfs.length - 1)] || book.pdfs[0];
    }

    public async selectPdf(index: number) {
        this.activePdfIndex = Math.max(0, index);
        this.selectedFileId = this.text(this.selectedBook?.pdfs?.[this.activePdfIndex]?.fileId);
        this.activePdfPage = 1;
        this.readerPageInput = "1";
        this.readerPageError = "";
        this.readerActionMessage = "";
        this.readerPagePreviews = [];
        this.readerPreviewCache = {};
        this.resetPdfReaderState();
        await this.service.render();
        this.syncMainUrl("replace");
        await this.prepareActiveReader();
    }

    private applySelectedFileId(book: BookItem | null) {
        if (!book || !this.selectedFileId) return;
        let index = (book.pdfs || []).findIndex((pdf) => this.text(pdf.fileId) === this.selectedFileId);
        if (index >= 0) this.activePdfIndex = index;
        else this.selectedFileId = "";
    }

    public async changePdfPage(delta: number) {
        this.activePdfPage = this.clampPage(this.activePdfPage + delta);
        this.readerPageInput = String(this.activePdfPage);
        this.readerPageError = "";
        this.readerActionMessage = "";
        await this.service.render();
        await this.renderActivePdfPage();
        this.syncMainUrl("replace");
    }

    public async goToReaderPage() {
        let page = Number(this.readerPageInput);
        let total = this.pdfTotalPages;
        if (!Number.isInteger(page) || page < 1 || (total > 0 && page > total)) {
            this.readerPageError = total > 0
                ? `PDF 페이지는 1부터 ${total}까지 입력해 주세요.`
                : "1 이상의 PDF 페이지를 입력해 주세요.";
            await this.service.render();
            return;
        }
        this.readerPageError = "";
        this.readerActionMessage = "";
        this.activePdfPage = this.clampPage(Math.round(page));
        this.readerPageInput = String(this.activePdfPage);
        await this.service.render();
        await this.renderActivePdfPage();
        this.syncMainUrl("replace");
    }

    public async validateReaderPageInput() {
        let page = Number(this.readerPageInput);
        let total = this.pdfTotalPages;
        this.readerPageError = (!Number.isInteger(page) || page < 1 || (total > 0 && page > total))
            ? (total > 0 ? `PDF 페이지는 1부터 ${total}까지 입력해 주세요.` : "1 이상의 PDF 페이지를 입력해 주세요.")
            : "";
        await this.service.render();
    }

    public async zoomReader(delta: number) {
        let next = Math.round((this.readerZoom + delta) * 100) / 100;
        this.readerZoomMode = "custom";
        this.readerZoom = Math.max(0.25, Math.min(4, next));
        this.readerActionMessage = "";
        await this.service.render();
        await this.renderActivePdfPage();
    }

    public async fitReaderWidth() {
        this.readerZoomMode = "fit-width";
        this.readerActionMessage = "폭에 맞춤을 적용했습니다.";
        await this.service.render();
        await this.renderActivePdfPage();
    }

    public readerZoomLabel(): string {
        let percent = `${Math.round(this.readerZoom * 100)}%`;
        return this.readerZoomMode === "fit-width" ? `폭 맞춤 ${percent}` : percent;
    }

    public readerPagePositionLabel(): string {
        let total = this.pdfTotalPages || "?";
        let label = `PDF ${this.activePdfPage}/${total}쪽`;
        if (this.currentPrintedPageNumber && this.currentPrintedPageNumber > 0) {
            label += ` · 인쇄 ${this.currentPrintedPageNumber}쪽`;
        }
        return label;
    }

    public readerNavigationLabel(book: BookItem): string {
        return book.toc.length > 0 ? "목차" : "페이지 이동";
    }

    public readerToc(book: BookItem): ReaderTocItem[] {
        if (book.toc.length > 0) {
            return book.toc.map((item) => ({
                label: item.label,
                page: item.page || "",
                source: item.source || "metadata.md",
                depth: item.depth || 1,
                targetPage: this.pageNumberFromText(item.page) || 1
            }));
        }

        let fallback: ReaderTocItem[] = [{
            label: "첫 페이지",
            page: "1",
            source: "PDF 페이지 기준",
            depth: 1,
            targetPage: 1
        }];
        if (this.pdfTotalPages > 1) {
            fallback.push({
                label: "중간 페이지",
                page: String(Math.max(1, Math.ceil(this.pdfTotalPages / 2))),
                source: "PDF 페이지 기준",
                depth: 1,
                targetPage: Math.max(1, Math.ceil(this.pdfTotalPages / 2))
            });
            fallback.push({
                label: "마지막 페이지",
                page: String(this.pdfTotalPages),
                source: "PDF 페이지 기준",
                depth: 1,
                targetPage: this.pdfTotalPages
            });
        }
        return fallback;
    }

    public async goToTocItem(item: ReaderTocItem) {
        this.activePdfPage = this.clampPage(item.targetPage || 1);
        this.readerPageInput = String(this.activePdfPage);
        this.readerPageError = "";
        this.readerActionMessage = "";
        await this.service.render();
        await this.renderActivePdfPage();
        this.syncMainUrl("replace");
    }

    public async runReaderSearch(book: BookItem) {
        if (!this.canAccessBookOriginals(book)) {
            this.readerSearchResults = [];
            this.readerSearchMessage = this.originalAccessDeniedLabel(book);
            await this.service.render();
            return;
        }
        let query = this.text(this.readerSearchQuery);
        if (!query) {
            this.readerSearchResults = [];
            this.readerSearchMessage = "";
            this.currentPageMatchCount = 0;
            await this.service.render();
            return;
        }

        await this.runServerReaderSearch(book, query);
    }

    private async runServerReaderSearch(book: BookItem, query: string): Promise<boolean> {
        let pdf = this.activePdf(book);
        let fileId = this.text(pdf?.fileId || pdf?.textIndex?.fileId);
        if (!fileId || !pdf?.textIndex || pdf.textIndex.searchablePageCount <= 0 || pdf.textIndex.chunkCount <= 0) {
            this.readerSearchResults = [];
            this.readerSearchMessage = pdf?.textIndex?.processingStatus === "처리완료"
                ? `이 파일은 검증된 검색 가능 본문이 없습니다. PDF ${pdf.textIndex.pageCount}쪽 · 추출 ${pdf.textIndex.extractedPageCount}쪽 · 검색 가능 ${pdf.textIndex.searchablePageCount}쪽 · ${pdf.textIndex.qualityStatus}.`
                : "이 파일은 본문 품질 검사가 실행되지 않아 검색을 지원하지 않습니다.";
            await this.service.render();
            return true;
        }

        let token = ++this.readerSearchToken;
        this.readerSearchRunning = true;
        this.readerSearchMessage = "원문 본문에서 검색하고 있습니다.";
        this.readerSearchResults = [];
        await this.service.render();

        try {
            let response: any = await wiz.call("pdf_text_search", {
                fileId: fileId,
                q: query,
                limit: 24
            });
            if (token !== this.readerSearchToken) return true;
            let payload = response?.data?.data || response?.data || {};
            let rows = Array.isArray(payload.results) ? payload.results : [];
            this.readerSearchResults = rows.map((item: any) => ({
                page: Number(item.page || 0),
                snippet: this.text(item.snippet),
                count: Number(item.count || 0),
                source: this.text(item.source || "원문 본문")
            })).filter((item: ReaderSearchHit) => item.page > 0);
            this.readerSearchRunning = false;
            this.readerSearchMessage = this.readerSearchResults.length
                ? `${this.readerSearchResults.length}개 페이지에서 검색어를 찾았습니다.`
                : "검색어와 일치하는 본문 문단이 없습니다.";
            this.currentPageMatchCount = this.countMatches(this.currentPageText, query);
            await this.service.render();
            return true;
        } catch (e) {
            this.readerSearchRunning = false;
            this.readerSearchResults = [];
            this.readerSearchMessage = "검증된 본문 검색 결과를 불러오지 못했습니다. 브라우저 임시 추출은 검색에 사용하지 않습니다.";
            await this.service.render();
            return true;
        }
    }

    public async clearReaderSearch() {
        this.readerSearchQuery = "";
        this.readerSearchResults = [];
        this.readerSearchMessage = "";
        this.currentPageMatchCount = 0;
        await this.service.render();
    }

    public async goToSearchHit(hit: ReaderSearchHit) {
        this.activePdfPage = this.clampPage(hit.page);
        this.readerPageInput = String(this.activePdfPage);
        this.readerPageError = "";
        this.readerActionMessage = "";
        await this.service.render();
        await this.renderActivePdfPage();
        this.syncMainUrl("replace");
    }

    public highlightedText(value: string): string {
        let escaped = this.escapeHtml(value);
        let query = this.text(this.readerSearchQuery);
        if (!query) return escaped;
        let pattern = new RegExp(`(${this.escapeRegExp(query)})`, "gi");
        return escaped.replace(pattern, "<mark>$1</mark>");
    }

    public async saveCurrentPageEvidence(book: BookItem) {
        let quote = this.currentPageSearchAvailable && this.currentPageText
            ? this.currentPageText
            : `${book.title} · 원문 PDF ${this.activePdfPage}쪽 북마크 (텍스트 근거 아님)`;
        this.saveEvidence(book, this.currentPageSearchAvailable ? "페이지 근거" : "페이지 북마크", quote, this.activePdfPage, this.currentPageSearchAvailable);
        await this.service.render();
    }

    public async saveParagraphEvidence(book: BookItem, paragraph: string, index: number) {
        if (!this.currentPageParagraphSaveAvailable) return;
        this.saveEvidence(book, `문단 ${index + 1}`, paragraph, this.activePdfPage, true);
        await this.service.render();
    }

    public async removeEvidence(item: EvidenceItem) {
        this.evidenceBox = this.evidenceBox.filter((entry) => entry.id !== item.id);
        this.persistEvidenceBox();
        await this.service.render();
    }

    public async clearEvidenceBox() {
        this.evidenceBox = [];
        this.persistEvidenceBox();
        await this.service.render();
    }

    public evidenceForBook(book: BookItem): EvidenceItem[] {
        return this.evidenceBox.filter((item) => item.bookId === book.id || item.bookId === book.hflibId);
    }

    public async askReaderAi(book: BookItem) {
        let requestKey = this.readerQuestionRequestKey(book);
        if (!this.canAccessResearchAi()) {
            this.readerAiAnswer = this.accessDeniedMessage("ai");
            this.readerAiAnswerContext = requestKey;
            this.readerAiLoading = false;
            await this.service.render();
            return;
        }
        let question = this.text(this.readerAiQuestion);
        if (!question) {
            this.readerAiAnswer = "";
            this.readerAiAnswerContext = "";
            this.readerAiLoading = false;
            await this.service.render();
            return;
        }

        let pdf = this.activePdf(book);
        let fileId = this.text(pdf?.fileId || pdf?.textIndex?.fileId);
        if (!fileId || !this.currentPageSearchAvailable) {
            this.readerAiAnswer = `현재 PDF ${this.activePdfPage}쪽은 ${this.currentPageQualityStatus} 상태로 질문 근거에 사용할 수 없습니다. 원문 열람과 페이지 북마크는 계속 사용할 수 있습니다.`;
            this.readerAiAnswerContext = requestKey;
            this.readerAiLoading = false;
            await this.service.render();
            return;
        }
        let requestToken = ++this.readerAiRequestToken;
        this.readerAiAnswer = "현재 페이지에서 질문과 관련된 근거를 찾고 있습니다.";
        this.readerAiAnswerContext = requestKey;
        this.readerAiLoading = true;
        await this.service.render();
        if (fileId) {
            try {
                let response: any = await wiz.call("ai_answer", {
                    question: question,
                    bookId: book.id || book.hflibId,
                    fileId: fileId,
                    page: this.activePdfPage
                });
                let payload = response?.data?.data || response?.data || {};
                if (requestToken !== this.readerAiRequestToken || requestKey !== this.readerQuestionRequestKey(book)) {
                    if (requestToken === this.readerAiRequestToken) {
                        this.readerAiLoading = false;
                        await this.service.render();
                    }
                    return;
                }
                if (this.text(payload.answer)) {
                    this.readerAiAnswer = this.text(payload.answer);
                    this.readerAiLoading = false;
                    await this.service.render();
                    return;
                }
            } catch (e) {
                if (requestToken !== this.readerAiRequestToken || requestKey !== this.readerQuestionRequestKey(book)) return;
                this.readerAiLoading = false;
                this.readerAiAnswer = "현재 페이지의 근거 검색에 실패했습니다. 같은 파일·쪽 범위에서 다시 시도할 수 있습니다.";
                await this.service.render();
                return;
            }
        }
        this.readerAiLoading = false;
        this.readerAiAnswer = "현재 파일·PDF 쪽 범위에서 질문과 직접 연결되는 검증된 본문 근거를 찾지 못했습니다.";
        await this.service.render();
    }

    public activePdfOriginalDownloadUrl(book: BookItem): string {
        let pdf = this.activePdf(book);
        return pdf ? this.text(pdf.downloadUrl) : "";
    }

    public showSourceFileLink(book: BookItem): boolean {
        let pdf = this.activePdf(book);
        if (!pdf) return false;
        let sourceUrl = this.text(pdf.downloadUrl);
        return Boolean(sourceUrl && sourceUrl !== this.text(pdf.url));
    }

    public async retryPdfRender() {
        this.clearLoadedPdfDocument();
        await this.service.render();
        await this.renderActivePdfPage();
    }

    public async prepareActiveReader() {
        if (!this.canAccessBookOriginals(this.selectedBook)) {
            this.resetPdfReaderState(false);
            return;
        }
        if (!this.selectedBook || !this.selectedBook.pdfAvailable) {
            this.resetPdfReaderState(false);
            return;
        }
        if (!this.selectedFileId) {
            let pdf = this.activePdf(this.selectedBook);
            this.selectedFileId = this.text(pdf?.fileId || pdf?.textIndex?.fileId);
        }
        await this.renderActivePdfPage();
        this.syncMainUrl("replace");
    }

    public async renderActivePdfPage() {
        let book = this.selectedBook;
        if (!this.canAccessBookOriginals(book)) return;
        if (!book || !book.pdfAvailable) return;

        let token = ++this.pdfRenderToken;
        this.cancelPdfPageRenderTask();
        this.pdfLoading = true;
        this.pdfRenderError = "";
        await this.service.render();

        try {
            let document = await this.ensurePdfDocument(book);
            if (!document || token !== this.pdfRenderToken) return;
            this.activePdfPage = this.clampPage(this.activePdfPage);
            this.readerPageInput = String(this.activePdfPage);

            let page = await document.getPage(this.activePdfPage);
            if (token !== this.pdfRenderToken) return;

            let canvas = this.pdfCanvas?.nativeElement;
            if (!canvas) {
                this.pdfRenderError = "원문 페이지를 렌더링할 캔버스를 준비하지 못했습니다.";
                return;
            }

            let scale = this.readerZoomMode === "fit-width"
                ? this.readerFitScale(page)
                : this.readerZoom;
            this.readerZoom = scale;
            let viewport = page.getViewport({ scale: scale });
            let ratio = window.devicePixelRatio || 1;
            let context = canvas.getContext("2d");
            if (!context) {
                this.pdfRenderError = "브라우저가 원문 페이지 표시를 지원하지 않습니다.";
                return;
            }

            canvas.width = Math.floor(viewport.width * ratio);
            canvas.height = Math.floor(viewport.height * ratio);
            canvas.style.width = `${Math.floor(viewport.width)}px`;
            canvas.style.height = `${Math.floor(viewport.height)}px`;
            context.setTransform(ratio, 0, 0, ratio, 0, 0);
            context.clearRect(0, 0, viewport.width, viewport.height);

            let renderTask = page.render({ canvasContext: context, viewport: viewport });
            this.pdfPageRenderTask = renderTask;
            try {
                await renderTask.promise;
            } finally {
                if (this.pdfPageRenderTask === renderTask) this.pdfPageRenderTask = null;
            }
            if (token !== this.pdfRenderToken) return;
            let serverPage = await this.loadServerPageText(this.activePdfPage);
            this.currentPageText = serverPage?.text || "";
            this.currentPageParagraphs = serverPage?.paragraphs || [];
            this.currentPageQualityStatus = serverPage?.qualityStatus || "미검증";
            this.currentPageQualityReason = serverPage?.qualityReason || "서버 품질 검증 산출물이 없어 브라우저 임시 추출을 표시하지 않습니다.";
            this.currentPageTextAvailable = Boolean(serverPage?.textAvailable);
            this.currentPageSearchAvailable = Boolean(serverPage?.searchAvailable);
            this.currentPageParagraphSaveAvailable = Boolean(serverPage?.paragraphSaveAvailable);
            this.currentPrintedPageNumber = serverPage?.printedPageNumber || null;
            this.currentPageMatchCount = this.currentPageSearchAvailable
                ? this.countMatches(this.currentPageText, this.readerSearchQuery)
                : 0;
            if (!this.currentPageTextAvailable && this.readerTextPanelOpen) {
                this.readerActionMessage = "현재 페이지는 텍스트 보기를 지원하지 않습니다. 원문과 페이지 저장은 계속 사용할 수 있습니다.";
            }
            if (this.readerPreviewOpen) this.loadReaderPagePreviews();
        } catch (error: any) {
            if (token !== this.pdfRenderToken || error?.name === "RenderingCancelledException") return;
            this.pdfRenderError = error && error.message
                ? error.message
                : "원문 페이지를 불러오지 못했습니다.";
        } finally {
            if (token === this.pdfRenderToken) {
                this.pdfLoading = false;
                await this.service.render();
            }
        }
    }

    private async loadServerPageText(pageNumber: number): Promise<{
        text: string;
        paragraphs: string[];
        qualityStatus: string;
        qualityReason: string;
        textAvailable: boolean;
        searchAvailable: boolean;
        paragraphSaveAvailable: boolean;
        printedPageNumber: number | null;
    } | null> {
        let book = this.selectedBook;
        if (!book) return null;
        let pdf = this.activePdf(book);
        let fileId = this.text(pdf?.fileId || pdf?.textIndex?.fileId);
        if (!fileId || !pdf?.textIndex) return null;

        let key = `${fileId}:${pageNumber}`;
        if (this.serverPageTextCache[key] !== undefined) return this.serverPageTextCache[key];

        try {
            let response: any = await wiz.call("pdf_page_text", {
                fileId: fileId,
                page: pageNumber
            });
            let payload = response?.data?.data || response?.data || {};
            if (!payload.page) {
                this.serverPageTextCache[key] = null;
                return null;
            }
            let text = this.text(payload.page.text);
            let paragraphs = Array.isArray(payload.paragraphs)
                ? payload.paragraphs.map((item: any) => this.text(item.text)).filter((item: string) => item)
                : [];
            let result = {
                text,
                paragraphs,
                qualityStatus: this.text(payload.page.qualityStatus || payload.quality?.state) || "미검증",
                qualityReason: this.text(payload.quality?.reason) || "품질 사유 없음",
                textAvailable: Boolean(payload.textAvailable),
                searchAvailable: Boolean(payload.searchAvailable),
                paragraphSaveAvailable: Boolean(payload.paragraphSaveAvailable),
                printedPageNumber: Number(payload.page?.pageMapping?.printedPageNumber || 0) || null
            };
            this.serverPageTextCache[key] = result;
            return result;
        } catch (e) {
            this.serverPageTextCache[key] = null;
            return null;
        }
    }

    private async ensurePdfDocument(book: BookItem) {
        let pdf = this.activePdf(book);
        if (!pdf) return null;
        if (this.pdfDocument && this.activePdfUrl === pdf.url) return this.pdfDocument;

        this.clearLoadedPdfDocument();
        this.activePdfUrl = pdf.url;

        let lib = await this.ensurePdfjs();
        let loadingTask = lib.getDocument({ url: pdf.url });
        this.pdfDocument = await loadingTask.promise;
        this.pdfTotalPages = Number(this.pdfDocument.numPages || 0);
        this.activePdfPage = this.clampPage(this.activePdfPage);
        this.readerPageInput = String(this.activePdfPage);
        return this.pdfDocument;
    }

    private readerFitScale(page: any): number {
        let baseViewport = page.getViewport({ scale: 1 });
        let viewportWidth = this.readerViewport?.nativeElement?.clientWidth || window.innerWidth;
        let horizontalPadding = window.innerWidth <= 760 ? 20 : 56;
        let availableWidth = Math.max(180, viewportWidth - horizontalPadding);
        return Math.max(0.25, Math.min(4, availableWidth / Math.max(1, baseViewport.width)));
    }

    private previewPageNumbers(): number[] {
        let total = this.pdfTotalPages || 0;
        if (!total) return [];
        return Array.from(new Set([
            Math.max(1, this.activePdfPage - 1),
            this.activePdfPage,
            Math.min(total, this.activePdfPage + 1),
        ])).sort((left, right) => left - right);
    }

    private async loadReaderPagePreviews() {
        if (!this.readerPreviewOpen || !this.pdfDocument) return;
        let token = ++this.readerPreviewToken;
        let pdf = this.activePdf(this.selectedBook as BookItem);
        let fileKey = this.text(pdf?.fileId || pdf?.url);
        let pages = this.previewPageNumbers();
        this.readerPagePreviews = pages.map((page) => {
            let imageUrl = this.readerPreviewCache[`${fileKey}:${page}`] || "";
            return { page, imageUrl, loading: !imageUrl, error: "" };
        });
        await this.service.render();

        for (let item of this.readerPagePreviews) {
            if (token !== this.readerPreviewToken || !this.readerPreviewOpen) return;
            if (item.imageUrl) continue;
            try {
                let page = await this.pdfDocument.getPage(item.page);
                let base = page.getViewport({ scale: 1 });
                let scale = Math.min(0.35, 132 / Math.max(1, base.width));
                let viewport = page.getViewport({ scale });
                let canvas = document.createElement("canvas");
                canvas.width = Math.max(1, Math.floor(viewport.width));
                canvas.height = Math.max(1, Math.floor(viewport.height));
                let context = canvas.getContext("2d");
                if (!context) throw new Error("미리보기 캔버스를 만들 수 없습니다.");
                await page.render({ canvasContext: context, viewport }).promise;
                item.imageUrl = canvas.toDataURL("image/jpeg", 0.72);
                item.loading = false;
                this.readerPreviewCache[`${fileKey}:${item.page}`] = item.imageUrl;
            } catch (error: any) {
                item.loading = false;
                item.error = "미리보기를 불러오지 못했습니다.";
            }
            await this.service.render();
        }
    }

    private async ensurePdfjs() {
        if (this.pdfjs) return this.pdfjs;
        let lib: any = pdfjsLib;
        lib.GlobalWorkerOptions.workerSrc = "/wiz/api/page.main/pdfworker";
        this.pdfjs = lib;
        return this.pdfjs;
    }

    private async extractPdfPageText(pageNumber: number, page?: any): Promise<string> {
        if (this.pageTextCache[pageNumber] !== undefined) return this.pageTextCache[pageNumber];
        if (!this.pdfDocument) return "";
        let targetPage = page || await this.pdfDocument.getPage(pageNumber);
        let content = await targetPage.getTextContent();
        let text = (content.items || [])
            .map((item: any) => this.text(item.str))
            .filter((item: string) => item)
            .join(" ")
            .replace(/\s+([,.;:!?])/g, "$1")
            .replace(/\s+/g, " ")
            .trim();
        this.pageTextCache[pageNumber] = text;
        return text;
    }

    private paragraphsFromText(value: string): string[] {
        value = this.text(value);
        if (!value) return [];
        let raw = value.split(/(?<=[.!?。])\s+/).filter((item) => this.text(item));
        if (raw.length <= 1) raw = value.match(/.{1,320}(\s|$)/g) || [value];

        let paragraphs: string[] = [];
        let buffer = "";
        raw.forEach((sentence) => {
            sentence = this.text(sentence);
            if (!sentence) return;
            if ((buffer + " " + sentence).trim().length > 420 && buffer) {
                paragraphs.push(buffer);
                buffer = sentence;
            } else {
                buffer = `${buffer} ${sentence}`.trim();
            }
        });
        if (buffer) paragraphs.push(buffer);
        return paragraphs.slice(0, 18);
    }

    private resetPdfReaderState(destroyDocument: boolean = true) {
        this.pdfRenderToken++;
        this.cancelPdfPageRenderTask();
        this.readerSearchToken++;
        if (destroyDocument && this.pdfDocument && this.pdfDocument.destroy) {
            try {
                this.pdfDocument.destroy();
            } catch (e) { }
        }
        this.pdfDocument = null;
        this.activePdfUrl = "";
        this.pdfTotalPages = 0;
        this.pdfLoading = false;
        this.pdfRenderError = "";
        this.currentPageText = "";
        this.currentPageParagraphs = [];
        this.currentPageQualityStatus = "미검증";
        this.currentPageQualityReason = "품질 검증 산출물이 없습니다.";
        this.currentPageTextAvailable = false;
        this.currentPageSearchAvailable = false;
        this.currentPageParagraphSaveAvailable = false;
        this.currentPrintedPageNumber = null;
        this.currentPageMatchCount = 0;
        this.readerSearchResults = [];
        this.readerSearchRunning = false;
        this.readerSearchMessage = "";
        this.readerPageError = "";
        this.readerActionMessage = "";
        this.readerPagePreviews = [];
        this.readerPreviewToken++;
        this.pageTextCache = {};
        this.serverPageTextCache = {};
    }

    private clearLoadedPdfDocument() {
        this.cancelPdfPageRenderTask();
        if (this.pdfDocument && this.pdfDocument.destroy) {
            try {
                this.pdfDocument.destroy();
            } catch (e) { }
        }
        this.pdfDocument = null;
        this.activePdfUrl = "";
        this.pdfTotalPages = 0;
        this.pdfRenderError = "";
        this.currentPageText = "";
        this.currentPageParagraphs = [];
        this.currentPageQualityStatus = "미검증";
        this.currentPageQualityReason = "품질 검증 산출물이 없습니다.";
        this.currentPageTextAvailable = false;
        this.currentPageSearchAvailable = false;
        this.currentPageParagraphSaveAvailable = false;
        this.currentPrintedPageNumber = null;
        this.currentPageMatchCount = 0;
        this.readerSearchResults = [];
        this.readerSearchRunning = false;
        this.readerSearchMessage = "";
        this.readerPagePreviews = [];
        this.readerPreviewToken++;
        this.pageTextCache = {};
        this.serverPageTextCache = {};
    }

    private cancelPdfPageRenderTask() {
        if (!this.pdfPageRenderTask?.cancel) {
            this.pdfPageRenderTask = null;
            return;
        }
        try {
            this.pdfPageRenderTask.cancel();
        } catch (e) { }
        this.pdfPageRenderTask = null;
    }

    private clampPage(page: number): number {
        let total = this.pdfTotalPages || 9999;
        if (!Number.isFinite(page) || page < 1) return 1;
        return Math.max(1, Math.min(total, page));
    }

    private pageNumberFromText(value: any): number {
        let match = this.text(value).match(/\d+/);
        return match ? Number(match[0]) : 0;
    }

    private countMatches(value: string, query: string): number {
        value = this.text(value).toLocaleLowerCase();
        query = this.text(query).toLocaleLowerCase();
        if (!value || !query) return 0;
        let index = 0;
        let count = 0;
        while ((index = value.indexOf(query, index)) !== -1) {
            count++;
            index += query.length;
        }
        return count;
    }

    private searchSnippet(value: string, queryLower: string): string {
        let text = this.text(value);
        let index = text.toLocaleLowerCase().indexOf(queryLower);
        if (index < 0) return this.truncate(text, 180);
        let start = Math.max(0, index - 70);
        let end = Math.min(text.length, index + queryLower.length + 100);
        let prefix = start > 0 ? "... " : "";
        let suffix = end < text.length ? " ..." : "";
        return `${prefix}${text.slice(start, end).trim()}${suffix}`;
    }

    private escapeHtml(value: string): string {
        return this.text(value)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");
    }

    private escapeRegExp(value: string): string {
        return this.text(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    public async toggleReaderTextPanel() {
        if (!this.readerTextPanelOpen && !this.currentPageTextAvailable) {
            this.readerActionMessage = "현재 페이지는 확인된 텍스트가 없어 텍스트 보기를 열 수 없습니다.";
            await this.service.render();
            return;
        }
        this.readerTextPanelOpen = !this.readerTextPanelOpen;
        this.readerActionMessage = "";
        await this.service.render();
        if (this.readerZoomMode === "fit-width") setTimeout(() => this.renderActivePdfPage(), 0);
    }

    public async toggleReaderNavPanel() {
        this.readerNavPanelOpen = !this.readerNavPanelOpen;
        this.readerActionMessage = "";
        await this.service.render();
        if (this.readerZoomMode === "fit-width") setTimeout(() => this.renderActivePdfPage(), 0);
    }

    public async toggleReaderSection(section: "toc" | "preview" | "saved") {
        if (section === "toc") this.readerTocOpen = !this.readerTocOpen;
        if (section === "preview") this.readerPreviewOpen = !this.readerPreviewOpen;
        if (section === "saved") this.readerSavedPagesOpen = !this.readerSavedPagesOpen;
        await this.service.render();
        if (section === "preview" && this.readerPreviewOpen) await this.loadReaderPagePreviews();
    }

    public async goToReaderPreview(page: number) {
        this.activePdfPage = this.clampPage(page);
        this.readerPageInput = String(this.activePdfPage);
        this.readerPageError = "";
        await this.service.render();
        await this.renderActivePdfPage();
        this.syncMainUrl("replace");
    }

    public canOpenSavedEvidence(book: BookItem, item: EvidenceItem): boolean {
        let materialId = this.text(item.materialId || item.bookId);
        let bookIds = [book.id, book.hflibId].map((value) => this.text(value));
        if (!materialId || !bookIds.includes(materialId) || !item.fileId || !item.pdfPageNumber) return false;
        return (book.pdfs || []).some((pdf) => this.text(pdf.fileId || pdf.textIndex?.fileId) === this.text(item.fileId));
    }

    public async openSavedEvidence(book: BookItem, item: EvidenceItem) {
        if (!this.canOpenSavedEvidence(book, item)) {
            this.readerActionMessage = "이 저장 항목에는 정확한 파일·PDF 페이지 정보가 없어 자동 이동하지 않습니다.";
            await this.service.render();
            return;
        }
        let index = book.pdfs.findIndex((pdf) => this.text(pdf.fileId || pdf.textIndex?.fileId) === this.text(item.fileId));
        if (index !== this.activePdfIndex) {
            this.activePdfIndex = index;
            this.selectedFileId = this.text(item.fileId);
            this.resetPdfReaderState();
            await this.service.render();
        }
        await this.ensurePdfDocument(book);
        this.activePdfPage = this.clampPage(Number(item.pdfPageNumber));
        this.readerPageInput = String(this.activePdfPage);
        this.readerPageError = "";
        this.readerActionMessage = `${item.source} PDF ${this.activePdfPage}쪽으로 이동했습니다.`;
        await this.service.render();
        await this.renderActivePdfPage();
        this.syncMainUrl("replace");
    }

    public async toggleReaderFullscreen() {
        let workspace = this.readerWorkspace?.nativeElement;
        if (!workspace) return;
        try {
            if (document.fullscreenElement === workspace) await document.exitFullscreen();
            else await workspace.requestFullscreen();
        } catch (e) {
            this.readerActionMessage = "이 브라우저에서는 전체 화면을 열 수 없습니다.";
            await this.service.render();
        }
    }

    public async copyCurrentPageText() {
        if (!this.currentPageTextAvailable || !this.currentPageText) return;
        let copied = await this.copyToClipboard(this.currentPageText);
        this.readerActionMessage = copied ? "현재 페이지 텍스트를 복사했습니다." : "텍스트를 복사하지 못했습니다.";
        await this.service.render();
    }

    public async copyReaderPageLink(book: BookItem) {
        if (!book || !this.activePdf(book)) return;
        this.selectedFileId = this.text(this.activePdf(book)?.fileId || this.activePdf(book)?.textIndex?.fileId);
        this.syncMainUrl("replace");
        let copied = await this.copyToClipboard(window.location.href);
        this.readerActionMessage = copied
            ? "자료ID·파일ID·PDF 페이지가 포함된 링크를 복사했습니다."
            : "현재 페이지 링크를 복사하지 못했습니다.";
        await this.service.render();
    }

    private async copyToClipboard(value: string): Promise<boolean> {
        try {
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(value);
                return true;
            }
            let textarea = document.createElement("textarea");
            textarea.value = value;
            textarea.setAttribute("readonly", "");
            textarea.style.position = "fixed";
            textarea.style.opacity = "0";
            document.body.appendChild(textarea);
            textarea.select();
            let copied = document.execCommand("copy");
            textarea.remove();
            return copied;
        } catch (e) {
            return false;
        }
    }

    private saveEvidence(book: BookItem, scope: string, quote: string, page: number, textEvidence: boolean = true) {
        let pdf = this.activePdf(book);
        let item: EvidenceItem = {
            id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
            bookId: book.id || book.hflibId,
            bookTitle: book.title,
            page: page,
            scope: scope,
            quote: this.truncate(quote, 520),
            source: pdf ? pdf.filename : (book.metadataPath || "metadata.md"),
            fileId: this.text(pdf?.fileId || pdf?.textIndex?.fileId),
            materialId: book.id || book.hflibId,
            pdfPageNumber: page,
            textEvidence,
            savedAt: new Date().toISOString()
        };
        this.evidenceBox = [item].concat(this.evidenceBox).slice(0, 80);
        this.persistEvidenceBox();
    }

    private loadEvidenceBox() {
        try {
            let rows = JSON.parse(localStorage.getItem(this.evidenceStorageKey) || "[]");
            this.evidenceBox = Array.isArray(rows) ? rows.slice(0, 80) : [];
        } catch (e) {
            this.evidenceBox = [];
        }
    }

    private persistEvidenceBox() {
        try {
            localStorage.setItem(this.evidenceStorageKey, JSON.stringify(this.evidenceBox));
        } catch (e) { }
    }

    public coverImageSrc(book: BookItem, mode: "list" | "detail" = "detail"): string {
        if (!book) return "";
        if (mode === "list") {
            return this.text(book.listCoverImage || book.coverThumbnailImage || book.coverImage);
        }
        return this.text(book.coverImage || book.listCoverImage || book.coverThumbnailImage);
    }

    public coverAlt(book: BookItem): string {
        return book.coverAvailable ? `${book.title} 실제 표지` : `${book.title} 기본 표지`;
    }

    public coverIntrinsicWidth(className: string = "cover-frame"): number {
        if (className === "modal-cover") return 312;
        if (className === "related-cover") return 96;
        if (className === "collection-material-cover" || className === "tag-result-cover") return 54;
        return 240;
    }

    public coverIntrinsicHeight(className: string = "cover-frame"): number {
        if (className === "modal-cover") return 432;
        if (className === "related-cover") return 133;
        if (className === "collection-material-cover" || className === "tag-result-cover") return 72;
        return 332;
    }

    public isPriorityListCover(index: number): boolean {
        let limit = this.activeTopTab === "search" ? SEARCH_PRIORITY_COVER_COUNT : LIST_PRIORITY_COVER_COUNT;
        return Number(index) >= 0 && Number(index) < limit;
    }

    public isCoverLoading(book: BookItem, list: boolean = false): boolean {
        let src = this.coverImageSrc(book, list ? "list" : "detail");
        return Boolean(book?.coverAvailable && src && !book.coverLoadedPaths?.[src]);
    }

    public async markCoverLoaded(book: BookItem, event?: Event) {
        if (!book) return;
        let image = event?.target as HTMLImageElement;
        let src = this.text(image?.currentSrc || image?.src || this.coverImageSrc(book));
        let rawSrc = this.text(image?.getAttribute("src"));
        let sources = [
            src,
            rawSrc,
            this.coverImageSrc(book, "list"),
            this.coverImageSrc(book, "detail")
        ].filter((value, index, rows) => value && rows.indexOf(value) === index);
        if (!sources.length) return;
        if (!book.coverLoadedPaths) book.coverLoadedPaths = {};
        sources.forEach((value) => book.coverLoadedPaths[value] = true);
        await this.service.render();
    }

    public async markCoverMissing(book: BookItem, event?: Event) {
        let image = event?.target as HTMLImageElement;
        let src = this.text(image?.currentSrc || image?.src || this.coverImageSrc(book));
        if (book) {
            if (!book.coverFailedPaths) book.coverFailedPaths = {};
            if (src) {
                book.coverFailedPaths[src] = (book.coverFailedPaths[src] || 0) + 1;
                this.coverFailureCounts[src] = (this.coverFailureCounts[src] || 0) + 1;
                if (this.coverFailureCounts[src] >= 2) {
                    console.warn("Repeated cover image failure", src);
                }
            }
            book.coverAvailable = false;
            book.coverImage = "";
            book.coverThumbnailImage = "";
            book.listCoverImage = "";
            book.coverStatus = "표지 로딩 실패 - 기본 표지 사용";
        }
        if (image) image.removeAttribute("src");
        await this.service.render();
    }

    public coverTypeLabel(book: BookItem): string {
        return this.materialNature(book) || "자료";
    }

    public coverTitlePreview(book: BookItem): string {
        return this.text(book?.title) || "제목 정보 없음";
    }

    public coverMetaLine(book: BookItem): string {
        let publisher = this.publisherLabel(book);
        let year = this.publishedYearLabel(book);
        if (this.isMissingBibliographicValue(publisher)) return year;
        if (this.isMissingBibliographicValue(year)) return publisher;
        return `${publisher} · ${year}`;
    }

    public trackBook(index: number, book: BookItem) {
        return book.id || index;
    }

    public trackCollection(index: number, collection: CollectionSummary) {
        return collection.id || index;
    }

    public trackSearchStatus(index: number, row: { label: string }) {
        return row?.label || index;
    }

    public trackSearchCollection(index: number, collection: SearchCollectionCard) {
        return collection.id || index;
    }

    public trackSearchGroup(index: number, group: SearchResultGroup) {
        return group.id || index;
    }

    public trackBodyEvidenceResult(index: number, row: SearchBodyEvidenceResult) {
        return row.id || index;
    }

    public trackSearchTagResult(index: number, card: SearchTagResultCard) {
        return card.id || index;
    }

    public trackGraphSearchResult(index: number, card: SearchGraphResultCard) {
        return card.id || index;
    }

    public trackPdf(index: number, pdf: PdfAsset) {
        return pdf.url || index;
    }

    public trackTag(index: number, tag: TagItem) {
        return `${tag.axis}|${tag.name}` || index;
    }

    public trackAlias(index: number, alias: TagAliasItem) {
        return `${alias.axis}|${alias.tagName}|${alias.alias}` || index;
    }

    public trackToc(index: number, item: TocItem) {
        return `${item.label}-${item.page || index}`;
    }

    public trackSearchHit(index: number, hit: BodySearchHit) {
        return `${hit.title}-${hit.source}-${index}`;
    }

    public trackSearchMatch(index: number, match: SearchMatchItem) {
        return `${match.type}|${match.field}|${match.value}|${match.page || 0}|${match.chunkId || index}`;
    }

    public trackGraphNode(index: number, node: KnowledgeGraphNode) {
        return node.id || index;
    }

    public trackGraphRelation(index: number, relation: KnowledgeGraphRelation) {
        return relation.id || index;
    }

    public trackGraphQualityCheck(index: number, check: GraphQualityCheckItem) {
        return check?.key || check?.label || index;
    }

    public trackGraphMaterialReference(index: number, material: GraphMaterialReference) {
        return material.id || index;
    }

    public trackGraphSegment(index: number, segment: GraphLinkSegment) {
        return segment.id || index;
    }

    public trackTopTab(index: number, tab: { id: string }) {
        return tab?.id || index;
    }

    public trackActiveFilterChip(index: number, chip: ActiveFilterChip) {
        return chip ? `${chip.key}:${chip.value}` : index;
    }

    public trackText(index: number, value: string) {
        return value || index;
    }

    public displayTerm(value: any): string {
        let text = value === null || value === undefined ? "" : `${value}`;
        const exact: any = {
            "내부열람": "내부 사용자만 열람",
            "검수 대기": "자료 확인 필요",
            "검수대기": "자료 확인 필요",
            "검수 완료": "자료 확인 완료",
            "검수완료": "자료 확인 완료",
            "OCR 필요": "이미지 속 글자 인식 필요"
        };
        if (exact[text]) return exact[text];
        return text
            .replace(/서지정보/g, "자료 기본정보")
            .replace(/메타데이터/g, "자료 정보")
            .replace(/지식그래프/g, "자료 관계도")
            .replace(/본문 ?청크/g, "본문 구간")
            .replace(/태그/g, "주제어")
            .replace(/검수/g, "자료 확인")
            .replace(/내부열람/g, "내부 사용자만 열람")
            .replace(/OCR/g, "이미지 속 글자 인식");
    }

    public text(value: any): string {
        if (value === null || value === undefined) return "";
        return String(value).replace(/\s+/g, " ").trim();
    }

    public truncate(value: string, limit: number): string {
        value = this.text(value);
        if (value.length <= limit) return value;
        return value.slice(0, limit).trim() + "...";
    }

    public normalizeIsbn(value: any): string {
        return this.text(value).replace(/[^0-9Xx]/g, "").toLocaleUpperCase();
    }

    public numberYear(value: any): number | undefined {
        let match = this.text(value).match(/(?:19|20)\d{2}/g);
        if (!match || !match.length) return undefined;
        return Number(match[match.length - 1]);
    }

    public yearOf(book: BookItem): string {
        let year = book.publishedYear || this.numberYear(book.publishedDate);
        return year ? String(year) : "";
    }

    public yearValue(book: BookItem, oldest: boolean = false): number {
        let year = Number(this.yearOf(book));
        if (year) return year;
        return oldest ? 9999 : 0;
    }

    public uniqueOptions(values: any[]): string[] {
        let seen: any = {};
        let result: string[] = [];
        values.forEach((value) => {
            value = this.text(value);
            if (!value || seen[value]) return;
            seen[value] = true;
            result.push(value);
        });
        return result.sort((a, b) => a.localeCompare(b, "ko"));
    }

    public normalizedAuthor(value: any): string {
        return this.text(value).replace(/\s+/g, "").toLocaleLowerCase();
    }

    public keywords(book: BookItem): string[] {
        let value = `${book.title} ${book.author} ${book.category} ${book.description} ${book.tags.map((tag) => tag.name).join(" ")}`.toLocaleLowerCase();
        let words = value
            .replace(/[^\p{L}\p{N}\s]/gu, " ")
            .split(/\s+/)
            .filter((word) => word.length >= 2);
        return Array.from(new Set(words)).slice(0, 40);
    }

    private syncSelectedBookFromUrl() {
        let params = new URLSearchParams(window.location.search || "");
        let pathMatch = (window.location.pathname || "").match(/^\/main\/([^/?#]+)\/?$/);
        let routeBook = pathMatch ? this.text(pathMatch[1]) : "";
        let bookId = routeBook || this.text(params.get("book"));
        if (!bookId) {
            this.selectedBook = null;
            this.relatedBooks = [];
            this.resetDetailTools();
            return;
        }
        try {
            bookId = decodeURIComponent(bookId);
        } catch (e) {
            bookId = "";
        }

        let book = this.books.find((item) => item.id === bookId || item.hflibId === bookId);
        if (!book) {
            this.selectedBook = null;
            this.relatedBooks = [];
            this.resetDetailTools();
            this.routeStateMessage = `자료ID ${bookId || "(잘못된 값)"}는 존재하지 않거나 현재 권한으로 열 수 없습니다. 자료검색 화면으로 돌아왔습니다.`;
            if (!this.restoringRouteState) this.syncMainUrl("replace");
            return;
        }

        let selectedId = this.selectedBook ? this.selectedBook.id : "";
        this.selectedBook = book;
        this.relatedBooks = this.findRelatedBooks(book);
        this.activePdfIndex = 0;
        this.activePdfPage = Math.max(1, this.requestedReaderPage || 1);
        this.readerPageInput = String(this.activePdfPage);
        if (selectedId !== book.id) {
            this.resetPdfReaderState();
            this.resetDetailTools();
            this.graphLoading = this.canUseBookKnowledgeGraph(book);
        }
    }

    private applyEntryRouteParams() {
        if (this.entryRouteApplied) return;
        this.entryRouteApplied = true;
        this.restoreMainStateFromUrl();
    }

    private emptyFilterState(): any {
        return {
            search: "", author: "", businessAxis: "", issueAxis: "", eraAxis: "", regionAxis: "",
            relationshipAxis: "", materialNature: "", creatorAxis: "", perspectiveAxis: "", workPurpose: "",
            reviewStateAxis: "", collectionId: "", year: "", pdfState: "", bodyExtractionStatus: "",
            tagReviewStatus: "", publicStatus: "", sort: "title"
        };
    }

    private restoreMainStateFromUrl() {
        let params = new URLSearchParams(window.location.search || "");
        this.selectedFileId = this.text(params.get("fileId"));
        let requestedReaderPage = Number(params.get("pdfPage") || 1);
        this.requestedReaderPage = Number.isInteger(requestedReaderPage) && requestedReaderPage > 0 ? requestedReaderPage : 1;
        let requestedTab = this.text(params.get("tab"));
        this.routeStateMessage = "";
        if (["admin", "materials"].includes(requestedTab)) {
            if (this.canAccessMaterials()) {
                window.location.replace("/admin/materials");
                return;
            }
            this.routeStateMessage = this.accessDeniedMessage("admin");
            requestedTab = "search";
        }

        this.filters = this.emptyFilterState();
        let search = this.text(params.get("q") || params.get("search") || params.get("query") || params.get("topic"));
        let collectionId = this.text(params.get("collection") || params.get("collectionId"));
        let pdfState = this.text(params.get("pdf") || params.get("pdfState") || params.get("original") || params.get("originals"));
        let sort = this.text(params.get("sort"));
        let graphScope = this.text(params.get("graph") || params.get("scope"));
        let graphBookId = this.text(params.get("bookId") || params.get("materialId"));
        let resultTab = this.text(params.get("result") || params.get("resultTab"));
        let routeView = this.normalizeMaterialViewMode(params.get("view") || params.get("viewMode"));
        let requestedPage = Math.max(1, Number(params.get("page") || 1));
        let requestedPageSize = Number(params.get("pageSize") || 50);
        this.materialListPage = Number.isFinite(requestedPage) ? requestedPage : 1;
        this.materialListPageSize = this.materialListPageSizeOptions.includes(requestedPageSize) ? requestedPageSize : 50;
        let filterParams: Array<[string, string]> = [
            ["author", "author"], ["businessAxis", "business"], ["issueAxis", "issue"],
            ["eraAxis", "era"], ["regionAxis", "region"], ["relationshipAxis", "relation"],
            ["materialNature", "nature"], ["creatorAxis", "creator"], ["perspectiveAxis", "perspective"],
            ["workPurpose", "purpose"], ["reviewStateAxis", "review"], ["year", "year"],
            ["bodyExtractionStatus", "body"], ["tagReviewStatus", "tagReview"], ["publicStatus", "public"],
        ];
        filterParams.forEach(([field, key]) => this.filters[field] = this.text(params.get(key)));

        if (search) {
            this.filters.search = search;
            requestedTab = requestedTab || "search";
        }

        if (collectionId && this.collections.some((collection) => collection.id === collectionId)) {
            this.selectedCollectionId = collectionId;
            this.aiScopeCollectionId = collectionId;
            if (!requestedTab || requestedTab === "search" || requestedTab === "books") {
                this.filters.collectionId = collectionId;
                requestedTab = requestedTab || "search";
            }
        } else if (collectionId) {
            this.routeStateMessage = `컬렉션 ${collectionId}를 찾을 수 없어 해당 조건을 제외했습니다.`;
        }

        if (pdfState) {
            let normalizedPdfState = pdfState.toLocaleLowerCase();
            if (["with-pdf", "pdf", "ebook", "original", "originals", "available", "true", "1"].includes(normalizedPdfState)) {
                this.filters.pdfState = "with-pdf";
                requestedTab = requestedTab || "search";
            } else if (["without-pdf", "none", "missing", "false", "0"].includes(normalizedPdfState)) {
                this.filters.pdfState = "without-pdf";
                requestedTab = requestedTab || "search";
            }
        }

        if (sort && ["title", "title-desc", "author", "publisher", "publisher-desc", "category", "material", "material-desc", "pdf", "body", "graph", "newest", "oldest"].includes(sort)) {
            this.filters.sort = sort;
        }

        if (resultTab && this.searchResultTabs.some((tab) => tab.id === resultTab)) {
            this.activeSearchResultTab = resultTab;
        } else {
            this.activeSearchResultTab = "all";
            if (resultTab) this.routeStateMessage = `지원하지 않는 검색 결과 유형(${resultTab}) 대신 전체 결과를 표시합니다.`;
        }

        if (routeView) {
            this.materialViewMode = routeView;
            this.persistMaterialViewMode(false);
        }

        if (graphBookId && this.findBookByMaterialId(graphBookId)) {
            this.graphTargetBookId = graphBookId;
        }

        if (graphScope && GRAPH_TYPE_OPTIONS.some((option) => option.value === graphScope)) {
            this.activeGraphScope = graphScope;
            requestedTab = "graph";
        }

        this.graphNodeTypeFilter = this.text(params.get("graphNodeType"));
        this.graphRelationStatusFilter = this.text(params.get("graphStatus")) || "전체";
        this.graphSearchQuery = this.text(params.get("graphQuery"));
        this.graphZoom = this.clampGraphZoom(Number(params.get("graphZoom") || 1));
        this.graphExpanded = params.get("graphMore") === "1";
        this.graphRouteSelectedNodeId = this.text(params.get("graphNode"));
        this.graphRouteSelectedRelationId = this.text(params.get("graphRelation"));
        this.collectionNodeTypeFilter = this.text(params.get("collectionNodeType"));
        this.collectionReviewStatusFilter = this.text(params.get("collectionReview"));
        this.collectionGraphZoom = this.clampGraphZoom(Number(params.get("collectionZoom") || 1));
        this.collectionGraphExpanded = params.get("collectionMore") === "1";
        this.collectionRouteSelectedNodeId = this.text(params.get("collectionNode"));
        this.collectionRouteSelectedRelationId = this.text(params.get("collectionRelation"));

        let aiScope = this.text(params.get("aiScope"));
        if (aiScope && this.aiScopeOptions.some((option) => option.value === aiScope)) this.aiScopeType = aiScope;
        this.aiTargetBookId = this.text(params.get("aiBook")) || this.aiTargetBookId;
        this.aiScopeTag = this.text(params.get("aiTag"));
        this.aiScopeCollectionId = this.text(params.get("aiCollection")) || this.aiScopeCollectionId;
        this.activeResultGroupId = this.text(params.get("group"));

        let tabExists = !!requestedTab && this.topTabs.some((tab) => tab.id === requestedTab);
        if (tabExists && this.canAccessTopTab(requestedTab)) {
            this.activeTopTab = requestedTab;
        } else if (tabExists) {
            this.activeTopTab = search ? "search" : "books";
            this.routeStateMessage = this.accessDeniedMessage(requestedTab);
        } else if (requestedTab) {
            this.activeTopTab = search ? "search" : "books";
            this.routeStateMessage = `지원하지 않는 화면(${requestedTab}) 대신 ${this.activeTopTab === "search" ? "자료검색" : "자료 목록"}을 표시합니다.`;
        } else {
            this.activeTopTab = search ? "search" : "books";
        }
    }

    private mainStateParams(): URLSearchParams {
        let params = new URLSearchParams();
        params.set("tab", this.activeTopTab);
        params.set("view", this.materialViewMode);
        if (this.materialListPage > 1) params.set("page", String(this.materialListPage));
        if (this.materialListPageSize !== 50) params.set("pageSize", String(this.materialListPageSize));
        if (this.activeSearchResultTab !== "all") params.set("result", this.activeSearchResultTab);
        let values: Array<[string, any]> = [
            ["q", this.filters.search], ["author", this.filters.author], ["business", this.filters.businessAxis],
            ["issue", this.filters.issueAxis], ["era", this.filters.eraAxis], ["region", this.filters.regionAxis],
            ["relation", this.filters.relationshipAxis], ["nature", this.filters.materialNature], ["creator", this.filters.creatorAxis],
            ["perspective", this.filters.perspectiveAxis], ["purpose", this.filters.workPurpose], ["review", this.filters.reviewStateAxis],
            ["year", this.filters.year], ["pdf", this.filters.pdfState], ["body", this.filters.bodyExtractionStatus],
            ["tagReview", this.filters.tagReviewStatus], ["public", this.filters.publicStatus],
        ];
        values.forEach(([key, value]) => {
            value = this.text(value);
            if (value) params.set(key, value);
        });
        if (this.filters.sort && this.filters.sort !== "title") params.set("sort", this.filters.sort);
        let collectionId = this.text(this.filters.collectionId)
            || (["collections", "graph"].includes(this.activeTopTab) ? this.text(this.selectedCollectionId) : "");
        if (collectionId) params.set("collection", collectionId);
        if (this.activeTopTab === "graph") {
            params.set("graph", this.activeGraphScope);
            if (this.graphTargetBookId) params.set("bookId", this.graphTargetBookId);
            if (this.graphNodeTypeFilter) params.set("graphNodeType", this.graphNodeTypeFilter);
            if (this.graphRelationStatusFilter !== "전체") params.set("graphStatus", this.graphRelationStatusFilter);
            if (this.graphSearchQuery) params.set("graphQuery", this.graphSearchQuery);
            if (this.graphZoom !== 1) params.set("graphZoom", this.graphZoom.toFixed(2));
            if (this.graphExpanded) params.set("graphMore", "1");
            if (this.graphRouteSelectedNodeId) params.set("graphNode", this.graphRouteSelectedNodeId);
            if (this.graphRouteSelectedRelationId) params.set("graphRelation", this.graphRouteSelectedRelationId);
            if (this.collectionNodeTypeFilter) params.set("collectionNodeType", this.collectionNodeTypeFilter);
            if (this.collectionReviewStatusFilter) params.set("collectionReview", this.collectionReviewStatusFilter);
            if (this.collectionGraphZoom !== 1) params.set("collectionZoom", this.collectionGraphZoom.toFixed(2));
            if (this.collectionGraphExpanded) params.set("collectionMore", "1");
            if (this.collectionRouteSelectedNodeId) params.set("collectionNode", this.collectionRouteSelectedNodeId);
            if (this.collectionRouteSelectedRelationId) params.set("collectionRelation", this.collectionRouteSelectedRelationId);
        }
        if (this.activeTopTab === "ai") {
            params.set("aiScope", this.aiScopeType);
            if (this.aiTargetBookId) params.set("aiBook", this.aiTargetBookId);
            if (this.aiScopeTag) params.set("aiTag", this.aiScopeTag);
            if (this.aiScopeCollectionId) params.set("aiCollection", this.aiScopeCollectionId);
        }
        if (this.activeResultGroupId) params.set("group", this.activeResultGroupId);
        if (this.selectedBook && this.selectedFileId) params.set("fileId", this.selectedFileId);
        if (this.selectedBook && this.selectedFileId && this.activePdfPage > 0) params.set("pdfPage", String(this.activePdfPage));
        return params;
    }

    private materialListScrollStorageKey(): string {
        let url = this.mainStateUrl("/main");
        let hash = 2166136261;
        for (let i = 0; i < url.length; i++) {
            hash ^= url.charCodeAt(i);
            hash = Math.imul(hash, 16777619);
        }
        return `nah-main-list-scroll-v1-${(hash >>> 0).toString(16)}`;
    }

    private captureMaterialListScroll() {
        this.materialListScrollY = Math.max(0, Math.round(window.scrollY || 0));
        try {
            window.sessionStorage.setItem(this.materialListScrollStorageKey(), String(this.materialListScrollY));
        } catch (e) { }
        let current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
        let state = { ...(window.history.state || {}), listScrollY: this.materialListScrollY };
        window.history.replaceState(state, "", current);
    }

    private restoreMaterialListScroll() {
        let historyScroll = window.history.state?.listScrollY;
        let scrollY = historyScroll === null || historyScroll === undefined
            ? Number.NaN
            : Number(historyScroll);
        if (!Number.isFinite(scrollY) || scrollY < 0) {
            try {
                let storedScroll = window.sessionStorage.getItem(this.materialListScrollStorageKey());
                scrollY = storedScroll === null ? Number.NaN : Number(storedScroll);
            } catch (e) {
                scrollY = Number.NaN;
            }
        }
        if (!Number.isFinite(scrollY) || scrollY < 0) scrollY = this.materialListScrollY;
        this.materialListScrollY = Math.max(0, Number(scrollY || 0));
        setTimeout(() => window.scrollTo({ top: this.materialListScrollY, behavior: "auto" }), 0);
    }

    private mainStateUrl(pathname: string = "/main"): string {
        let query = this.mainStateParams().toString();
        return `${pathname}${query ? `?${query}` : ""}`;
    }

    private syncMainUrl(mode: "push" | "replace" = "replace") {
        if (this.restoringRouteState) return;
        let pathname = "/main";
        if (this.selectedBook) pathname = `/main/${encodeURIComponent(this.selectedBook.id || this.selectedBook.hflibId)}`;
        let target = this.mainStateUrl(pathname);
        if (this.selectedBook) target += this.compatibleDetailHash();
        let current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
        if (target === current) return;
        let state = { tab: this.activeTopTab, selectedBookId: this.selectedBook?.id || "" };
        if (mode === "push") window.history.pushState(state, "", target);
        else window.history.replaceState(state, "", target);
    }

    private compatibleDetailHash(): string {
        let hash = window.location.hash || "";
        return ["#material-detail-top", "#ebook-reader", "#body-search", "#book-knowledge-graph", "#ai-workbench", "#related-materials"].includes(hash) ? hash : "";
    }

    private replaceDetailAnchor(anchorId: string) {
        if (!this.selectedBook) return;
        let pathname = `/main/${encodeURIComponent(this.selectedBook.id || this.selectedBook.hflibId)}`;
        let target = `${this.mainStateUrl(pathname)}#${anchorId}`;
        let state = { ...(window.history.state || {}), tab: this.activeTopTab, selectedBookId: this.selectedBook.id || "" };
        window.history.replaceState(state, "", target);
    }

    private restoreDetailAnchor() {
        let hash = this.compatibleDetailHash();
        if (!hash) return;
        setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "auto", block: "start" }), 0);
    }

    private pushDetailUrl(book: BookItem) {
        let url = this.detailUrl(book);
        if (window.location.pathname + window.location.search === url) return;
        window.history.pushState({
            bookId: book.id,
            listScrollY: this.materialListScrollY,
            listPage: this.materialListPage
        }, "", url);
    }

    private pushListUrl() {
        let url = this.mainStateUrl("/main");
        if (`${window.location.pathname}${window.location.search}` === url) return;
        window.history.pushState({
            materialViewMode: this.materialViewMode,
            listScrollY: this.materialListScrollY,
            listPage: this.materialListPage
        }, "", url);
    }
}

export default PageMainComponent;